var Lu = Object.defineProperty;
var Fu = (r, e, t) => e in r ? Lu(r, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : r[e] = t;
var K = (r, e, t) => Fu(r, typeof e != "symbol" ? e + "" : e, t);
const Tt = "srgb", tr = "srgb-linear", Ps = "linear", Qe = "srgb";
const Go = "300 es";
function sc(r) {
  for (let e = r.length - 1; e >= 0; --e)
    if (r[e] >= 65535) return !0;
  return !1;
}
function Fr(r) {
  return document.createElementNS("http://www.w3.org/1999/xhtml", r);
}
function Uu() {
  const r = Fr("canvas");
  return r.style.display = "block", r;
}
const ko = {};
function Ds(...r) {
  const e = "THREE." + r.shift();
  console.log(e, ...r);
}
function Ce(...r) {
  const e = "THREE." + r.shift();
  console.warn(e, ...r);
}
function Xe(...r) {
  const e = "THREE." + r.shift();
  console.error(e, ...r);
}
function Ur(...r) {
  const e = r.join(" ");
  e in ko || (ko[e] = !0, Ce(...r));
}
function Iu(r, e, t) {
  return new Promise(function(n, i) {
    function s() {
      switch (r.clientWaitSync(e, r.SYNC_FLUSH_COMMANDS_BIT, 0)) {
        case r.WAIT_FAILED:
          i();
          break;
        case r.TIMEOUT_EXPIRED:
          setTimeout(s, t);
          break;
        default:
          n();
      }
    }
    setTimeout(s, t);
  });
}
class lr {
  /**
   * Adds the given event listener to the given event type.
   *
   * @param {string} type - The type of event to listen to.
   * @param {Function} listener - The function that gets called when the event is fired.
   */
  addEventListener(e, t) {
    this._listeners === void 0 && (this._listeners = {});
    const n = this._listeners;
    n[e] === void 0 && (n[e] = []), n[e].indexOf(t) === -1 && n[e].push(t);
  }
  /**
   * Returns `true` if the given event listener has been added to the given event type.
   *
   * @param {string} type - The type of event.
   * @param {Function} listener - The listener to check.
   * @return {boolean} Whether the given event listener has been added to the given event type.
   */
  hasEventListener(e, t) {
    const n = this._listeners;
    return n === void 0 ? !1 : n[e] !== void 0 && n[e].indexOf(t) !== -1;
  }
  /**
   * Removes the given event listener from the given event type.
   *
   * @param {string} type - The type of event.
   * @param {Function} listener - The listener to remove.
   */
  removeEventListener(e, t) {
    const n = this._listeners;
    if (n === void 0) return;
    const i = n[e];
    if (i !== void 0) {
      const s = i.indexOf(t);
      s !== -1 && i.splice(s, 1);
    }
  }
  /**
   * Dispatches an event object.
   *
   * @param {Object} event - The event that gets fired.
   */
  dispatchEvent(e) {
    const t = this._listeners;
    if (t === void 0) return;
    const n = t[e.type];
    if (n !== void 0) {
      e.target = this;
      const i = n.slice(0);
      for (let s = 0, a = i.length; s < a; s++)
        i[s].call(this, e);
      e.target = null;
    }
  }
}
const Ut = ["00", "01", "02", "03", "04", "05", "06", "07", "08", "09", "0a", "0b", "0c", "0d", "0e", "0f", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "1a", "1b", "1c", "1d", "1e", "1f", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "2a", "2b", "2c", "2d", "2e", "2f", "30", "31", "32", "33", "34", "35", "36", "37", "38", "39", "3a", "3b", "3c", "3d", "3e", "3f", "40", "41", "42", "43", "44", "45", "46", "47", "48", "49", "4a", "4b", "4c", "4d", "4e", "4f", "50", "51", "52", "53", "54", "55", "56", "57", "58", "59", "5a", "5b", "5c", "5d", "5e", "5f", "60", "61", "62", "63", "64", "65", "66", "67", "68", "69", "6a", "6b", "6c", "6d", "6e", "6f", "70", "71", "72", "73", "74", "75", "76", "77", "78", "79", "7a", "7b", "7c", "7d", "7e", "7f", "80", "81", "82", "83", "84", "85", "86", "87", "88", "89", "8a", "8b", "8c", "8d", "8e", "8f", "90", "91", "92", "93", "94", "95", "96", "97", "98", "99", "9a", "9b", "9c", "9d", "9e", "9f", "a0", "a1", "a2", "a3", "a4", "a5", "a6", "a7", "a8", "a9", "aa", "ab", "ac", "ad", "ae", "af", "b0", "b1", "b2", "b3", "b4", "b5", "b6", "b7", "b8", "b9", "ba", "bb", "bc", "bd", "be", "bf", "c0", "c1", "c2", "c3", "c4", "c5", "c6", "c7", "c8", "c9", "ca", "cb", "cc", "cd", "ce", "cf", "d0", "d1", "d2", "d3", "d4", "d5", "d6", "d7", "d8", "d9", "da", "db", "dc", "dd", "de", "df", "e0", "e1", "e2", "e3", "e4", "e5", "e6", "e7", "e8", "e9", "ea", "eb", "ec", "ed", "ee", "ef", "f0", "f1", "f2", "f3", "f4", "f5", "f6", "f7", "f8", "f9", "fa", "fb", "fc", "fd", "fe", "ff"];
let Vo = 1234567;
const wr = Math.PI / 180, Ir = 180 / Math.PI;
function Gn() {
  const r = Math.random() * 4294967295 | 0, e = Math.random() * 4294967295 | 0, t = Math.random() * 4294967295 | 0, n = Math.random() * 4294967295 | 0;
  return (Ut[r & 255] + Ut[r >> 8 & 255] + Ut[r >> 16 & 255] + Ut[r >> 24 & 255] + "-" + Ut[e & 255] + Ut[e >> 8 & 255] + "-" + Ut[e >> 16 & 15 | 64] + Ut[e >> 24 & 255] + "-" + Ut[t & 63 | 128] + Ut[t >> 8 & 255] + "-" + Ut[t >> 16 & 255] + Ut[t >> 24 & 255] + Ut[n & 255] + Ut[n >> 8 & 255] + Ut[n >> 16 & 255] + Ut[n >> 24 & 255]).toLowerCase();
}
function ze(r, e, t) {
  return Math.max(e, Math.min(t, r));
}
function so(r, e) {
  return (r % e + e) % e;
}
function Nu(r, e, t, n, i) {
  return n + (r - e) * (i - n) / (t - e);
}
function Ou(r, e, t) {
  return r !== e ? (t - r) / (e - r) : 0;
}
function Rr(r, e, t) {
  return (1 - t) * r + t * e;
}
function Bu(r, e, t, n) {
  return Rr(r, e, 1 - Math.exp(-t * n));
}
function zu(r, e = 1) {
  return e - Math.abs(so(r, e * 2) - e);
}
function Gu(r, e, t) {
  return r <= e ? 0 : r >= t ? 1 : (r = (r - e) / (t - e), r * r * (3 - 2 * r));
}
function ku(r, e, t) {
  return r <= e ? 0 : r >= t ? 1 : (r = (r - e) / (t - e), r * r * r * (r * (r * 6 - 15) + 10));
}
function Vu(r, e) {
  return r + Math.floor(Math.random() * (e - r + 1));
}
function Hu(r, e) {
  return r + Math.random() * (e - r);
}
function Wu(r) {
  return r * (0.5 - Math.random());
}
function Xu(r) {
  r !== void 0 && (Vo = r);
  let e = Vo += 1831565813;
  return e = Math.imul(e ^ e >>> 15, e | 1), e ^= e + Math.imul(e ^ e >>> 7, e | 61), ((e ^ e >>> 14) >>> 0) / 4294967296;
}
function qu(r) {
  return r * wr;
}
function Yu(r) {
  return r * Ir;
}
function $u(r) {
  return (r & r - 1) === 0 && r !== 0;
}
function Ku(r) {
  return Math.pow(2, Math.ceil(Math.log(r) / Math.LN2));
}
function Zu(r) {
  return Math.pow(2, Math.floor(Math.log(r) / Math.LN2));
}
function ju(r, e, t, n, i) {
  const s = Math.cos, a = Math.sin, o = s(t / 2), c = a(t / 2), l = s((e + n) / 2), u = a((e + n) / 2), h = s((e - n) / 2), f = a((e - n) / 2), d = s((n - e) / 2), g = a((n - e) / 2);
  switch (i) {
    case "XYX":
      r.set(o * u, c * h, c * f, o * l);
      break;
    case "YZY":
      r.set(c * f, o * u, c * h, o * l);
      break;
    case "ZXZ":
      r.set(c * h, c * f, o * u, o * l);
      break;
    case "XZX":
      r.set(o * u, c * g, c * d, o * l);
      break;
    case "YXY":
      r.set(c * d, o * u, c * g, o * l);
      break;
    case "ZYZ":
      r.set(c * g, c * d, o * u, o * l);
      break;
    default:
      Ce("MathUtils: .setQuaternionFromProperEuler() encountered an unknown order: " + i);
  }
}
function yn(r, e) {
  switch (e.constructor) {
    case Float32Array:
      return r;
    case Uint32Array:
      return r / 4294967295;
    case Uint16Array:
      return r / 65535;
    case Uint8Array:
      return r / 255;
    case Int32Array:
      return Math.max(r / 2147483647, -1);
    case Int16Array:
      return Math.max(r / 32767, -1);
    case Int8Array:
      return Math.max(r / 127, -1);
    default:
      throw new Error("Invalid component type.");
  }
}
function et(r, e) {
  switch (e.constructor) {
    case Float32Array:
      return r;
    case Uint32Array:
      return Math.round(r * 4294967295);
    case Uint16Array:
      return Math.round(r * 65535);
    case Uint8Array:
      return Math.round(r * 255);
    case Int32Array:
      return Math.round(r * 2147483647);
    case Int16Array:
      return Math.round(r * 32767);
    case Int8Array:
      return Math.round(r * 127);
    default:
      throw new Error("Invalid component type.");
  }
}
const Ju = {
  DEG2RAD: wr,
  RAD2DEG: Ir,
  /**
   * Generate a [UUID](https://en.wikipedia.org/wiki/Universally_unique_identifier)
   * (universally unique identifier).
   *
   * @static
   * @method
   * @return {string} The UUID.
   */
  generateUUID: Gn,
  /**
   * Clamps the given value between min and max.
   *
   * @static
   * @method
   * @param {number} value - The value to clamp.
   * @param {number} min - The min value.
   * @param {number} max - The max value.
   * @return {number} The clamped value.
   */
  clamp: ze,
  /**
   * Computes the Euclidean modulo of the given parameters that
   * is `( ( n % m ) + m ) % m`.
   *
   * @static
   * @method
   * @param {number} n - The first parameter.
   * @param {number} m - The second parameter.
   * @return {number} The Euclidean modulo.
   */
  euclideanModulo: so,
  /**
   * Performs a linear mapping from range `<a1, a2>` to range `<b1, b2>`
   * for the given value.
   *
   * @static
   * @method
   * @param {number} x - The value to be mapped.
   * @param {number} a1 - Minimum value for range A.
   * @param {number} a2 - Maximum value for range A.
   * @param {number} b1 - Minimum value for range B.
   * @param {number} b2 - Maximum value for range B.
   * @return {number} The mapped value.
   */
  mapLinear: Nu,
  /**
   * Returns the percentage in the closed interval `[0, 1]` of the given value
   * between the start and end point.
   *
   * @static
   * @method
   * @param {number} x - The start point
   * @param {number} y - The end point.
   * @param {number} value - A value between start and end.
   * @return {number} The interpolation factor.
   */
  inverseLerp: Ou,
  /**
   * Returns a value linearly interpolated from two known points based on the given interval -
   * `t = 0` will return `x` and `t = 1` will return `y`.
   *
   * @static
   * @method
   * @param {number} x - The start point
   * @param {number} y - The end point.
   * @param {number} t - The interpolation factor in the closed interval `[0, 1]`.
   * @return {number} The interpolated value.
   */
  lerp: Rr,
  /**
   * Smoothly interpolate a number from `x` to `y` in  a spring-like manner using a delta
   * time to maintain frame rate independent movement. For details, see
   * [Frame rate independent damping using lerp](http://www.rorydriscoll.com/2016/03/07/frame-rate-independent-damping-using-lerp/).
   *
   * @static
   * @method
   * @param {number} x - The current point.
   * @param {number} y - The target point.
   * @param {number} lambda - A higher lambda value will make the movement more sudden,
   * and a lower value will make the movement more gradual.
   * @param {number} dt - Delta time in seconds.
   * @return {number} The interpolated value.
   */
  damp: Bu,
  /**
   * Returns a value that alternates between `0` and the given `length` parameter.
   *
   * @static
   * @method
   * @param {number} x - The value to pingpong.
   * @param {number} [length=1] - The positive value the function will pingpong to.
   * @return {number} The alternated value.
   */
  pingpong: zu,
  /**
   * Returns a value in the range `[0,1]` that represents the percentage that `x` has
   * moved between `min` and `max`, but smoothed or slowed down the closer `x` is to
   * the `min` and `max`.
   *
   * See [Smoothstep](http://en.wikipedia.org/wiki/Smoothstep) for more details.
   *
   * @static
   * @method
   * @param {number} x - The value to evaluate based on its position between min and max.
   * @param {number} min - The min value. Any x value below min will be `0`.
   * @param {number} max - The max value. Any x value above max will be `1`.
   * @return {number} The alternated value.
   */
  smoothstep: Gu,
  /**
   * A [variation on smoothstep](https://en.wikipedia.org/wiki/Smoothstep#Variations)
   * that has zero 1st and 2nd order derivatives at x=0 and x=1.
   *
   * @static
   * @method
   * @param {number} x - The value to evaluate based on its position between min and max.
   * @param {number} min - The min value. Any x value below min will be `0`.
   * @param {number} max - The max value. Any x value above max will be `1`.
   * @return {number} The alternated value.
   */
  smootherstep: ku,
  /**
   * Returns a random integer from `<low, high>` interval.
   *
   * @static
   * @method
   * @param {number} low - The lower value boundary.
   * @param {number} high - The upper value boundary
   * @return {number} A random integer.
   */
  randInt: Vu,
  /**
   * Returns a random float from `<low, high>` interval.
   *
   * @static
   * @method
   * @param {number} low - The lower value boundary.
   * @param {number} high - The upper value boundary
   * @return {number} A random float.
   */
  randFloat: Hu,
  /**
   * Returns a random integer from `<-range/2, range/2>` interval.
   *
   * @static
   * @method
   * @param {number} range - Defines the value range.
   * @return {number} A random float.
   */
  randFloatSpread: Wu,
  /**
   * Returns a deterministic pseudo-random float in the interval `[0, 1]`.
   *
   * @static
   * @method
   * @param {number} [s] - The integer seed.
   * @return {number} A random float.
   */
  seededRandom: Xu,
  /**
   * Converts degrees to radians.
   *
   * @static
   * @method
   * @param {number} degrees - A value in degrees.
   * @return {number} The converted value in radians.
   */
  degToRad: qu,
  /**
   * Converts radians to degrees.
   *
   * @static
   * @method
   * @param {number} radians - A value in radians.
   * @return {number} The converted value in degrees.
   */
  radToDeg: Yu,
  /**
   * Returns `true` if the given number is a power of two.
   *
   * @static
   * @method
   * @param {number} value - The value to check.
   * @return {boolean} Whether the given number is a power of two or not.
   */
  isPowerOfTwo: $u,
  /**
   * Returns the smallest power of two that is greater than or equal to the given number.
   *
   * @static
   * @method
   * @param {number} value - The value to find a POT for.
   * @return {number} The smallest power of two that is greater than or equal to the given number.
   */
  ceilPowerOfTwo: Ku,
  /**
   * Returns the largest power of two that is less than or equal to the given number.
   *
   * @static
   * @method
   * @param {number} value - The value to find a POT for.
   * @return {number} The largest power of two that is less than or equal to the given number.
   */
  floorPowerOfTwo: Zu,
  /**
   * Sets the given quaternion from the [Intrinsic Proper Euler Angles](https://en.wikipedia.org/wiki/Euler_angles)
   * defined by the given angles and order.
   *
   * Rotations are applied to the axes in the order specified by order:
   * rotation by angle `a` is applied first, then by angle `b`, then by angle `c`.
   *
   * @static
   * @method
   * @param {Quaternion} q - The quaternion to set.
   * @param {number} a - The rotation applied to the first axis, in radians.
   * @param {number} b - The rotation applied to the second axis, in radians.
   * @param {number} c - The rotation applied to the third axis, in radians.
   * @param {('XYX'|'XZX'|'YXY'|'YZY'|'ZXZ'|'ZYZ')} order - A string specifying the axes order.
   */
  setQuaternionFromProperEuler: ju,
  /**
   * Normalizes the given value according to the given typed array.
   *
   * @static
   * @method
   * @param {number} value - The float value in the range `[0,1]` to normalize.
   * @param {TypedArray} array - The typed array that defines the data type of the value.
   * @return {number} The normalize value.
   */
  normalize: et,
  /**
   * Denormalizes the given value according to the given typed array.
   *
   * @static
   * @method
   * @param {number} value - The value to denormalize.
   * @param {TypedArray} array - The typed array that defines the data type of the value.
   * @return {number} The denormalize (float) value in the range `[0,1]`.
   */
  denormalize: yn
};
class Ae {
  /**
   * Constructs a new 2D vector.
   *
   * @param {number} [x=0] - The x value of this vector.
   * @param {number} [y=0] - The y value of this vector.
   */
  constructor(e = 0, t = 0) {
    Ae.prototype.isVector2 = !0, this.x = e, this.y = t;
  }
  /**
   * Alias for {@link Vector2#x}.
   *
   * @type {number}
   */
  get width() {
    return this.x;
  }
  set width(e) {
    this.x = e;
  }
  /**
   * Alias for {@link Vector2#y}.
   *
   * @type {number}
   */
  get height() {
    return this.y;
  }
  set height(e) {
    this.y = e;
  }
  /**
   * Sets the vector components.
   *
   * @param {number} x - The value of the x component.
   * @param {number} y - The value of the y component.
   * @return {Vector2} A reference to this vector.
   */
  set(e, t) {
    return this.x = e, this.y = t, this;
  }
  /**
   * Sets the vector components to the same value.
   *
   * @param {number} scalar - The value to set for all vector components.
   * @return {Vector2} A reference to this vector.
   */
  setScalar(e) {
    return this.x = e, this.y = e, this;
  }
  /**
   * Sets the vector's x component to the given value
   *
   * @param {number} x - The value to set.
   * @return {Vector2} A reference to this vector.
   */
  setX(e) {
    return this.x = e, this;
  }
  /**
   * Sets the vector's y component to the given value
   *
   * @param {number} y - The value to set.
   * @return {Vector2} A reference to this vector.
   */
  setY(e) {
    return this.y = e, this;
  }
  /**
   * Allows to set a vector component with an index.
   *
   * @param {number} index - The component index. `0` equals to x, `1` equals to y.
   * @param {number} value - The value to set.
   * @return {Vector2} A reference to this vector.
   */
  setComponent(e, t) {
    switch (e) {
      case 0:
        this.x = t;
        break;
      case 1:
        this.y = t;
        break;
      default:
        throw new Error("index is out of range: " + e);
    }
    return this;
  }
  /**
   * Returns the value of the vector component which matches the given index.
   *
   * @param {number} index - The component index. `0` equals to x, `1` equals to y.
   * @return {number} A vector component value.
   */
  getComponent(e) {
    switch (e) {
      case 0:
        return this.x;
      case 1:
        return this.y;
      default:
        throw new Error("index is out of range: " + e);
    }
  }
  /**
   * Returns a new vector with copied values from this instance.
   *
   * @return {Vector2} A clone of this instance.
   */
  clone() {
    return new this.constructor(this.x, this.y);
  }
  /**
   * Copies the values of the given vector to this instance.
   *
   * @param {Vector2} v - The vector to copy.
   * @return {Vector2} A reference to this vector.
   */
  copy(e) {
    return this.x = e.x, this.y = e.y, this;
  }
  /**
   * Adds the given vector to this instance.
   *
   * @param {Vector2} v - The vector to add.
   * @return {Vector2} A reference to this vector.
   */
  add(e) {
    return this.x += e.x, this.y += e.y, this;
  }
  /**
   * Adds the given scalar value to all components of this instance.
   *
   * @param {number} s - The scalar to add.
   * @return {Vector2} A reference to this vector.
   */
  addScalar(e) {
    return this.x += e, this.y += e, this;
  }
  /**
   * Adds the given vectors and stores the result in this instance.
   *
   * @param {Vector2} a - The first vector.
   * @param {Vector2} b - The second vector.
   * @return {Vector2} A reference to this vector.
   */
  addVectors(e, t) {
    return this.x = e.x + t.x, this.y = e.y + t.y, this;
  }
  /**
   * Adds the given vector scaled by the given factor to this instance.
   *
   * @param {Vector2} v - The vector.
   * @param {number} s - The factor that scales `v`.
   * @return {Vector2} A reference to this vector.
   */
  addScaledVector(e, t) {
    return this.x += e.x * t, this.y += e.y * t, this;
  }
  /**
   * Subtracts the given vector from this instance.
   *
   * @param {Vector2} v - The vector to subtract.
   * @return {Vector2} A reference to this vector.
   */
  sub(e) {
    return this.x -= e.x, this.y -= e.y, this;
  }
  /**
   * Subtracts the given scalar value from all components of this instance.
   *
   * @param {number} s - The scalar to subtract.
   * @return {Vector2} A reference to this vector.
   */
  subScalar(e) {
    return this.x -= e, this.y -= e, this;
  }
  /**
   * Subtracts the given vectors and stores the result in this instance.
   *
   * @param {Vector2} a - The first vector.
   * @param {Vector2} b - The second vector.
   * @return {Vector2} A reference to this vector.
   */
  subVectors(e, t) {
    return this.x = e.x - t.x, this.y = e.y - t.y, this;
  }
  /**
   * Multiplies the given vector with this instance.
   *
   * @param {Vector2} v - The vector to multiply.
   * @return {Vector2} A reference to this vector.
   */
  multiply(e) {
    return this.x *= e.x, this.y *= e.y, this;
  }
  /**
   * Multiplies the given scalar value with all components of this instance.
   *
   * @param {number} scalar - The scalar to multiply.
   * @return {Vector2} A reference to this vector.
   */
  multiplyScalar(e) {
    return this.x *= e, this.y *= e, this;
  }
  /**
   * Divides this instance by the given vector.
   *
   * @param {Vector2} v - The vector to divide.
   * @return {Vector2} A reference to this vector.
   */
  divide(e) {
    return this.x /= e.x, this.y /= e.y, this;
  }
  /**
   * Divides this vector by the given scalar.
   *
   * @param {number} scalar - The scalar to divide.
   * @return {Vector2} A reference to this vector.
   */
  divideScalar(e) {
    return this.multiplyScalar(1 / e);
  }
  /**
   * Multiplies this vector (with an implicit 1 as the 3rd component) by
   * the given 3x3 matrix.
   *
   * @param {Matrix3} m - The matrix to apply.
   * @return {Vector2} A reference to this vector.
   */
  applyMatrix3(e) {
    const t = this.x, n = this.y, i = e.elements;
    return this.x = i[0] * t + i[3] * n + i[6], this.y = i[1] * t + i[4] * n + i[7], this;
  }
  /**
   * If this vector's x or y value is greater than the given vector's x or y
   * value, replace that value with the corresponding min value.
   *
   * @param {Vector2} v - The vector.
   * @return {Vector2} A reference to this vector.
   */
  min(e) {
    return this.x = Math.min(this.x, e.x), this.y = Math.min(this.y, e.y), this;
  }
  /**
   * If this vector's x or y value is less than the given vector's x or y
   * value, replace that value with the corresponding max value.
   *
   * @param {Vector2} v - The vector.
   * @return {Vector2} A reference to this vector.
   */
  max(e) {
    return this.x = Math.max(this.x, e.x), this.y = Math.max(this.y, e.y), this;
  }
  /**
   * If this vector's x or y value is greater than the max vector's x or y
   * value, it is replaced by the corresponding value.
   * If this vector's x or y value is less than the min vector's x or y value,
   * it is replaced by the corresponding value.
   *
   * @param {Vector2} min - The minimum x and y values.
   * @param {Vector2} max - The maximum x and y values in the desired range.
   * @return {Vector2} A reference to this vector.
   */
  clamp(e, t) {
    return this.x = ze(this.x, e.x, t.x), this.y = ze(this.y, e.y, t.y), this;
  }
  /**
   * If this vector's x or y values are greater than the max value, they are
   * replaced by the max value.
   * If this vector's x or y values are less than the min value, they are
   * replaced by the min value.
   *
   * @param {number} minVal - The minimum value the components will be clamped to.
   * @param {number} maxVal - The maximum value the components will be clamped to.
   * @return {Vector2} A reference to this vector.
   */
  clampScalar(e, t) {
    return this.x = ze(this.x, e, t), this.y = ze(this.y, e, t), this;
  }
  /**
   * If this vector's length is greater than the max value, it is replaced by
   * the max value.
   * If this vector's length is less than the min value, it is replaced by the
   * min value.
   *
   * @param {number} min - The minimum value the vector length will be clamped to.
   * @param {number} max - The maximum value the vector length will be clamped to.
   * @return {Vector2} A reference to this vector.
   */
  clampLength(e, t) {
    const n = this.length();
    return this.divideScalar(n || 1).multiplyScalar(ze(n, e, t));
  }
  /**
   * The components of this vector are rounded down to the nearest integer value.
   *
   * @return {Vector2} A reference to this vector.
   */
  floor() {
    return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this;
  }
  /**
   * The components of this vector are rounded up to the nearest integer value.
   *
   * @return {Vector2} A reference to this vector.
   */
  ceil() {
    return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this;
  }
  /**
   * The components of this vector are rounded to the nearest integer value
   *
   * @return {Vector2} A reference to this vector.
   */
  round() {
    return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
  }
  /**
   * The components of this vector are rounded towards zero (up if negative,
   * down if positive) to an integer value.
   *
   * @return {Vector2} A reference to this vector.
   */
  roundToZero() {
    return this.x = Math.trunc(this.x), this.y = Math.trunc(this.y), this;
  }
  /**
   * Inverts this vector - i.e. sets x = -x and y = -y.
   *
   * @return {Vector2} A reference to this vector.
   */
  negate() {
    return this.x = -this.x, this.y = -this.y, this;
  }
  /**
   * Calculates the dot product of the given vector with this instance.
   *
   * @param {Vector2} v - The vector to compute the dot product with.
   * @return {number} The result of the dot product.
   */
  dot(e) {
    return this.x * e.x + this.y * e.y;
  }
  /**
   * Calculates the cross product of the given vector with this instance.
   *
   * @param {Vector2} v - The vector to compute the cross product with.
   * @return {number} The result of the cross product.
   */
  cross(e) {
    return this.x * e.y - this.y * e.x;
  }
  /**
   * Computes the square of the Euclidean length (straight-line length) from
   * (0, 0) to (x, y). If you are comparing the lengths of vectors, you should
   * compare the length squared instead as it is slightly more efficient to calculate.
   *
   * @return {number} The square length of this vector.
   */
  lengthSq() {
    return this.x * this.x + this.y * this.y;
  }
  /**
   * Computes the  Euclidean length (straight-line length) from (0, 0) to (x, y).
   *
   * @return {number} The length of this vector.
   */
  length() {
    return Math.sqrt(this.x * this.x + this.y * this.y);
  }
  /**
   * Computes the Manhattan length of this vector.
   *
   * @return {number} The length of this vector.
   */
  manhattanLength() {
    return Math.abs(this.x) + Math.abs(this.y);
  }
  /**
   * Converts this vector to a unit vector - that is, sets it equal to a vector
   * with the same direction as this one, but with a vector length of `1`.
   *
   * @return {Vector2} A reference to this vector.
   */
  normalize() {
    return this.divideScalar(this.length() || 1);
  }
  /**
   * Computes the angle in radians of this vector with respect to the positive x-axis.
   *
   * @return {number} The angle in radians.
   */
  angle() {
    return Math.atan2(-this.y, -this.x) + Math.PI;
  }
  /**
   * Returns the angle between the given vector and this instance in radians.
   *
   * @param {Vector2} v - The vector to compute the angle with.
   * @return {number} The angle in radians.
   */
  angleTo(e) {
    const t = Math.sqrt(this.lengthSq() * e.lengthSq());
    if (t === 0) return Math.PI / 2;
    const n = this.dot(e) / t;
    return Math.acos(ze(n, -1, 1));
  }
  /**
   * Computes the distance from the given vector to this instance.
   *
   * @param {Vector2} v - The vector to compute the distance to.
   * @return {number} The distance.
   */
  distanceTo(e) {
    return Math.sqrt(this.distanceToSquared(e));
  }
  /**
   * Computes the squared distance from the given vector to this instance.
   * If you are just comparing the distance with another distance, you should compare
   * the distance squared instead as it is slightly more efficient to calculate.
   *
   * @param {Vector2} v - The vector to compute the squared distance to.
   * @return {number} The squared distance.
   */
  distanceToSquared(e) {
    const t = this.x - e.x, n = this.y - e.y;
    return t * t + n * n;
  }
  /**
   * Computes the Manhattan distance from the given vector to this instance.
   *
   * @param {Vector2} v - The vector to compute the Manhattan distance to.
   * @return {number} The Manhattan distance.
   */
  manhattanDistanceTo(e) {
    return Math.abs(this.x - e.x) + Math.abs(this.y - e.y);
  }
  /**
   * Sets this vector to a vector with the same direction as this one, but
   * with the specified length.
   *
   * @param {number} length - The new length of this vector.
   * @return {Vector2} A reference to this vector.
   */
  setLength(e) {
    return this.normalize().multiplyScalar(e);
  }
  /**
   * Linearly interpolates between the given vector and this instance, where
   * alpha is the percent distance along the line - alpha = 0 will be this
   * vector, and alpha = 1 will be the given one.
   *
   * @param {Vector2} v - The vector to interpolate towards.
   * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
   * @return {Vector2} A reference to this vector.
   */
  lerp(e, t) {
    return this.x += (e.x - this.x) * t, this.y += (e.y - this.y) * t, this;
  }
  /**
   * Linearly interpolates between the given vectors, where alpha is the percent
   * distance along the line - alpha = 0 will be first vector, and alpha = 1 will
   * be the second one. The result is stored in this instance.
   *
   * @param {Vector2} v1 - The first vector.
   * @param {Vector2} v2 - The second vector.
   * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
   * @return {Vector2} A reference to this vector.
   */
  lerpVectors(e, t, n) {
    return this.x = e.x + (t.x - e.x) * n, this.y = e.y + (t.y - e.y) * n, this;
  }
  /**
   * Returns `true` if this vector is equal with the given one.
   *
   * @param {Vector2} v - The vector to test for equality.
   * @return {boolean} Whether this vector is equal with the given one.
   */
  equals(e) {
    return e.x === this.x && e.y === this.y;
  }
  /**
   * Sets this vector's x value to be `array[ offset ]` and y
   * value to be `array[ offset + 1 ]`.
   *
   * @param {Array<number>} array - An array holding the vector component values.
   * @param {number} [offset=0] - The offset into the array.
   * @return {Vector2} A reference to this vector.
   */
  fromArray(e, t = 0) {
    return this.x = e[t], this.y = e[t + 1], this;
  }
  /**
   * Writes the components of this vector to the given array. If no array is provided,
   * the method returns a new instance.
   *
   * @param {Array<number>} [array=[]] - The target array holding the vector components.
   * @param {number} [offset=0] - Index of the first element in the array.
   * @return {Array<number>} The vector components.
   */
  toArray(e = [], t = 0) {
    return e[t] = this.x, e[t + 1] = this.y, e;
  }
  /**
   * Sets the components of this vector from the given buffer attribute.
   *
   * @param {BufferAttribute} attribute - The buffer attribute holding vector data.
   * @param {number} index - The index into the attribute.
   * @return {Vector2} A reference to this vector.
   */
  fromBufferAttribute(e, t) {
    return this.x = e.getX(t), this.y = e.getY(t), this;
  }
  /**
   * Rotates this vector around the given center by the given angle.
   *
   * @param {Vector2} center - The point around which to rotate.
   * @param {number} angle - The angle to rotate, in radians.
   * @return {Vector2} A reference to this vector.
   */
  rotateAround(e, t) {
    const n = Math.cos(t), i = Math.sin(t), s = this.x - e.x, a = this.y - e.y;
    return this.x = s * n - a * i + e.x, this.y = s * i + a * n + e.y, this;
  }
  /**
   * Sets each component of this vector to a pseudo-random value between `0` and
   * `1`, excluding `1`.
   *
   * @return {Vector2} A reference to this vector.
   */
  random() {
    return this.x = Math.random(), this.y = Math.random(), this;
  }
  *[Symbol.iterator]() {
    yield this.x, yield this.y;
  }
}
class Xr {
  /**
   * Constructs a new quaternion.
   *
   * @param {number} [x=0] - The x value of this quaternion.
   * @param {number} [y=0] - The y value of this quaternion.
   * @param {number} [z=0] - The z value of this quaternion.
   * @param {number} [w=1] - The w value of this quaternion.
   */
  constructor(e = 0, t = 0, n = 0, i = 1) {
    this.isQuaternion = !0, this._x = e, this._y = t, this._z = n, this._w = i;
  }
  /**
   * Interpolates between two quaternions via SLERP. This implementation assumes the
   * quaternion data are managed in flat arrays.
   *
   * @param {Array<number>} dst - The destination array.
   * @param {number} dstOffset - An offset into the destination array.
   * @param {Array<number>} src0 - The source array of the first quaternion.
   * @param {number} srcOffset0 - An offset into the first source array.
   * @param {Array<number>} src1 -  The source array of the second quaternion.
   * @param {number} srcOffset1 - An offset into the second source array.
   * @param {number} t - The interpolation factor in the range `[0,1]`.
   * @see {@link Quaternion#slerp}
   */
  static slerpFlat(e, t, n, i, s, a, o) {
    let c = n[i + 0], l = n[i + 1], u = n[i + 2], h = n[i + 3], f = s[a + 0], d = s[a + 1], g = s[a + 2], _ = s[a + 3];
    if (o <= 0) {
      e[t + 0] = c, e[t + 1] = l, e[t + 2] = u, e[t + 3] = h;
      return;
    }
    if (o >= 1) {
      e[t + 0] = f, e[t + 1] = d, e[t + 2] = g, e[t + 3] = _;
      return;
    }
    if (h !== _ || c !== f || l !== d || u !== g) {
      let m = c * f + l * d + u * g + h * _;
      m < 0 && (f = -f, d = -d, g = -g, _ = -_, m = -m);
      let p = 1 - o;
      if (m < 0.9995) {
        const S = Math.acos(m), b = Math.sin(S);
        p = Math.sin(p * S) / b, o = Math.sin(o * S) / b, c = c * p + f * o, l = l * p + d * o, u = u * p + g * o, h = h * p + _ * o;
      } else {
        c = c * p + f * o, l = l * p + d * o, u = u * p + g * o, h = h * p + _ * o;
        const S = 1 / Math.sqrt(c * c + l * l + u * u + h * h);
        c *= S, l *= S, u *= S, h *= S;
      }
    }
    e[t] = c, e[t + 1] = l, e[t + 2] = u, e[t + 3] = h;
  }
  /**
   * Multiplies two quaternions. This implementation assumes the quaternion data are managed
   * in flat arrays.
   *
   * @param {Array<number>} dst - The destination array.
   * @param {number} dstOffset - An offset into the destination array.
   * @param {Array<number>} src0 - The source array of the first quaternion.
   * @param {number} srcOffset0 - An offset into the first source array.
   * @param {Array<number>} src1 -  The source array of the second quaternion.
   * @param {number} srcOffset1 - An offset into the second source array.
   * @return {Array<number>} The destination array.
   * @see {@link Quaternion#multiplyQuaternions}.
   */
  static multiplyQuaternionsFlat(e, t, n, i, s, a) {
    const o = n[i], c = n[i + 1], l = n[i + 2], u = n[i + 3], h = s[a], f = s[a + 1], d = s[a + 2], g = s[a + 3];
    return e[t] = o * g + u * h + c * d - l * f, e[t + 1] = c * g + u * f + l * h - o * d, e[t + 2] = l * g + u * d + o * f - c * h, e[t + 3] = u * g - o * h - c * f - l * d, e;
  }
  /**
   * The x value of this quaternion.
   *
   * @type {number}
   * @default 0
   */
  get x() {
    return this._x;
  }
  set x(e) {
    this._x = e, this._onChangeCallback();
  }
  /**
   * The y value of this quaternion.
   *
   * @type {number}
   * @default 0
   */
  get y() {
    return this._y;
  }
  set y(e) {
    this._y = e, this._onChangeCallback();
  }
  /**
   * The z value of this quaternion.
   *
   * @type {number}
   * @default 0
   */
  get z() {
    return this._z;
  }
  set z(e) {
    this._z = e, this._onChangeCallback();
  }
  /**
   * The w value of this quaternion.
   *
   * @type {number}
   * @default 1
   */
  get w() {
    return this._w;
  }
  set w(e) {
    this._w = e, this._onChangeCallback();
  }
  /**
   * Sets the quaternion components.
   *
   * @param {number} x - The x value of this quaternion.
   * @param {number} y - The y value of this quaternion.
   * @param {number} z - The z value of this quaternion.
   * @param {number} w - The w value of this quaternion.
   * @return {Quaternion} A reference to this quaternion.
   */
  set(e, t, n, i) {
    return this._x = e, this._y = t, this._z = n, this._w = i, this._onChangeCallback(), this;
  }
  /**
   * Returns a new quaternion with copied values from this instance.
   *
   * @return {Quaternion} A clone of this instance.
   */
  clone() {
    return new this.constructor(this._x, this._y, this._z, this._w);
  }
  /**
   * Copies the values of the given quaternion to this instance.
   *
   * @param {Quaternion} quaternion - The quaternion to copy.
   * @return {Quaternion} A reference to this quaternion.
   */
  copy(e) {
    return this._x = e.x, this._y = e.y, this._z = e.z, this._w = e.w, this._onChangeCallback(), this;
  }
  /**
   * Sets this quaternion from the rotation specified by the given
   * Euler angles.
   *
   * @param {Euler} euler - The Euler angles.
   * @param {boolean} [update=true] - Whether the internal `onChange` callback should be executed or not.
   * @return {Quaternion} A reference to this quaternion.
   */
  setFromEuler(e, t = !0) {
    const n = e._x, i = e._y, s = e._z, a = e._order, o = Math.cos, c = Math.sin, l = o(n / 2), u = o(i / 2), h = o(s / 2), f = c(n / 2), d = c(i / 2), g = c(s / 2);
    switch (a) {
      case "XYZ":
        this._x = f * u * h + l * d * g, this._y = l * d * h - f * u * g, this._z = l * u * g + f * d * h, this._w = l * u * h - f * d * g;
        break;
      case "YXZ":
        this._x = f * u * h + l * d * g, this._y = l * d * h - f * u * g, this._z = l * u * g - f * d * h, this._w = l * u * h + f * d * g;
        break;
      case "ZXY":
        this._x = f * u * h - l * d * g, this._y = l * d * h + f * u * g, this._z = l * u * g + f * d * h, this._w = l * u * h - f * d * g;
        break;
      case "ZYX":
        this._x = f * u * h - l * d * g, this._y = l * d * h + f * u * g, this._z = l * u * g - f * d * h, this._w = l * u * h + f * d * g;
        break;
      case "YZX":
        this._x = f * u * h + l * d * g, this._y = l * d * h + f * u * g, this._z = l * u * g - f * d * h, this._w = l * u * h - f * d * g;
        break;
      case "XZY":
        this._x = f * u * h - l * d * g, this._y = l * d * h - f * u * g, this._z = l * u * g + f * d * h, this._w = l * u * h + f * d * g;
        break;
      default:
        Ce("Quaternion: .setFromEuler() encountered an unknown order: " + a);
    }
    return t === !0 && this._onChangeCallback(), this;
  }
  /**
   * Sets this quaternion from the given axis and angle.
   *
   * @param {Vector3} axis - The normalized axis.
   * @param {number} angle - The angle in radians.
   * @return {Quaternion} A reference to this quaternion.
   */
  setFromAxisAngle(e, t) {
    const n = t / 2, i = Math.sin(n);
    return this._x = e.x * i, this._y = e.y * i, this._z = e.z * i, this._w = Math.cos(n), this._onChangeCallback(), this;
  }
  /**
   * Sets this quaternion from the given rotation matrix.
   *
   * @param {Matrix4} m - A 4x4 matrix of which the upper 3x3 of matrix is a pure rotation matrix (i.e. unscaled).
   * @return {Quaternion} A reference to this quaternion.
   */
  setFromRotationMatrix(e) {
    const t = e.elements, n = t[0], i = t[4], s = t[8], a = t[1], o = t[5], c = t[9], l = t[2], u = t[6], h = t[10], f = n + o + h;
    if (f > 0) {
      const d = 0.5 / Math.sqrt(f + 1);
      this._w = 0.25 / d, this._x = (u - c) * d, this._y = (s - l) * d, this._z = (a - i) * d;
    } else if (n > o && n > h) {
      const d = 2 * Math.sqrt(1 + n - o - h);
      this._w = (u - c) / d, this._x = 0.25 * d, this._y = (i + a) / d, this._z = (s + l) / d;
    } else if (o > h) {
      const d = 2 * Math.sqrt(1 + o - n - h);
      this._w = (s - l) / d, this._x = (i + a) / d, this._y = 0.25 * d, this._z = (c + u) / d;
    } else {
      const d = 2 * Math.sqrt(1 + h - n - o);
      this._w = (a - i) / d, this._x = (s + l) / d, this._y = (c + u) / d, this._z = 0.25 * d;
    }
    return this._onChangeCallback(), this;
  }
  /**
   * Sets this quaternion to the rotation required to rotate the direction vector
   * `vFrom` to the direction vector `vTo`.
   *
   * @param {Vector3} vFrom - The first (normalized) direction vector.
   * @param {Vector3} vTo - The second (normalized) direction vector.
   * @return {Quaternion} A reference to this quaternion.
   */
  setFromUnitVectors(e, t) {
    let n = e.dot(t) + 1;
    return n < 1e-8 ? (n = 0, Math.abs(e.x) > Math.abs(e.z) ? (this._x = -e.y, this._y = e.x, this._z = 0, this._w = n) : (this._x = 0, this._y = -e.z, this._z = e.y, this._w = n)) : (this._x = e.y * t.z - e.z * t.y, this._y = e.z * t.x - e.x * t.z, this._z = e.x * t.y - e.y * t.x, this._w = n), this.normalize();
  }
  /**
   * Returns the angle between this quaternion and the given one in radians.
   *
   * @param {Quaternion} q - The quaternion to compute the angle with.
   * @return {number} The angle in radians.
   */
  angleTo(e) {
    return 2 * Math.acos(Math.abs(ze(this.dot(e), -1, 1)));
  }
  /**
   * Rotates this quaternion by a given angular step to the given quaternion.
   * The method ensures that the final quaternion will not overshoot `q`.
   *
   * @param {Quaternion} q - The target quaternion.
   * @param {number} step - The angular step in radians.
   * @return {Quaternion} A reference to this quaternion.
   */
  rotateTowards(e, t) {
    const n = this.angleTo(e);
    if (n === 0) return this;
    const i = Math.min(1, t / n);
    return this.slerp(e, i), this;
  }
  /**
   * Sets this quaternion to the identity quaternion; that is, to the
   * quaternion that represents "no rotation".
   *
   * @return {Quaternion} A reference to this quaternion.
   */
  identity() {
    return this.set(0, 0, 0, 1);
  }
  /**
   * Inverts this quaternion via {@link Quaternion#conjugate}. The
   * quaternion is assumed to have unit length.
   *
   * @return {Quaternion} A reference to this quaternion.
   */
  invert() {
    return this.conjugate();
  }
  /**
   * Returns the rotational conjugate of this quaternion. The conjugate of a
   * quaternion represents the same rotation in the opposite direction about
   * the rotational axis.
   *
   * @return {Quaternion} A reference to this quaternion.
   */
  conjugate() {
    return this._x *= -1, this._y *= -1, this._z *= -1, this._onChangeCallback(), this;
  }
  /**
   * Calculates the dot product of this quaternion and the given one.
   *
   * @param {Quaternion} v - The quaternion to compute the dot product with.
   * @return {number} The result of the dot product.
   */
  dot(e) {
    return this._x * e._x + this._y * e._y + this._z * e._z + this._w * e._w;
  }
  /**
   * Computes the squared Euclidean length (straight-line length) of this quaternion,
   * considered as a 4 dimensional vector. This can be useful if you are comparing the
   * lengths of two quaternions, as this is a slightly more efficient calculation than
   * {@link Quaternion#length}.
   *
   * @return {number} The squared Euclidean length.
   */
  lengthSq() {
    return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
  }
  /**
   * Computes the Euclidean length (straight-line length) of this quaternion,
   * considered as a 4 dimensional vector.
   *
   * @return {number} The Euclidean length.
   */
  length() {
    return Math.sqrt(this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w);
  }
  /**
   * Normalizes this quaternion - that is, calculated the quaternion that performs
   * the same rotation as this one, but has a length equal to `1`.
   *
   * @return {Quaternion} A reference to this quaternion.
   */
  normalize() {
    let e = this.length();
    return e === 0 ? (this._x = 0, this._y = 0, this._z = 0, this._w = 1) : (e = 1 / e, this._x = this._x * e, this._y = this._y * e, this._z = this._z * e, this._w = this._w * e), this._onChangeCallback(), this;
  }
  /**
   * Multiplies this quaternion by the given one.
   *
   * @param {Quaternion} q - The quaternion.
   * @return {Quaternion} A reference to this quaternion.
   */
  multiply(e) {
    return this.multiplyQuaternions(this, e);
  }
  /**
   * Pre-multiplies this quaternion by the given one.
   *
   * @param {Quaternion} q - The quaternion.
   * @return {Quaternion} A reference to this quaternion.
   */
  premultiply(e) {
    return this.multiplyQuaternions(e, this);
  }
  /**
   * Multiplies the given quaternions and stores the result in this instance.
   *
   * @param {Quaternion} a - The first quaternion.
   * @param {Quaternion} b - The second quaternion.
   * @return {Quaternion} A reference to this quaternion.
   */
  multiplyQuaternions(e, t) {
    const n = e._x, i = e._y, s = e._z, a = e._w, o = t._x, c = t._y, l = t._z, u = t._w;
    return this._x = n * u + a * o + i * l - s * c, this._y = i * u + a * c + s * o - n * l, this._z = s * u + a * l + n * c - i * o, this._w = a * u - n * o - i * c - s * l, this._onChangeCallback(), this;
  }
  /**
   * Performs a spherical linear interpolation between quaternions.
   *
   * @param {Quaternion} qb - The target quaternion.
   * @param {number} t - The interpolation factor in the closed interval `[0, 1]`.
   * @return {Quaternion} A reference to this quaternion.
   */
  slerp(e, t) {
    if (t <= 0) return this;
    if (t >= 1) return this.copy(e);
    let n = e._x, i = e._y, s = e._z, a = e._w, o = this.dot(e);
    o < 0 && (n = -n, i = -i, s = -s, a = -a, o = -o);
    let c = 1 - t;
    if (o < 0.9995) {
      const l = Math.acos(o), u = Math.sin(l);
      c = Math.sin(c * l) / u, t = Math.sin(t * l) / u, this._x = this._x * c + n * t, this._y = this._y * c + i * t, this._z = this._z * c + s * t, this._w = this._w * c + a * t, this._onChangeCallback();
    } else
      this._x = this._x * c + n * t, this._y = this._y * c + i * t, this._z = this._z * c + s * t, this._w = this._w * c + a * t, this.normalize();
    return this;
  }
  /**
   * Performs a spherical linear interpolation between the given quaternions
   * and stores the result in this quaternion.
   *
   * @param {Quaternion} qa - The source quaternion.
   * @param {Quaternion} qb - The target quaternion.
   * @param {number} t - The interpolation factor in the closed interval `[0, 1]`.
   * @return {Quaternion} A reference to this quaternion.
   */
  slerpQuaternions(e, t, n) {
    return this.copy(e).slerp(t, n);
  }
  /**
   * Sets this quaternion to a uniformly random, normalized quaternion.
   *
   * @return {Quaternion} A reference to this quaternion.
   */
  random() {
    const e = 2 * Math.PI * Math.random(), t = 2 * Math.PI * Math.random(), n = Math.random(), i = Math.sqrt(1 - n), s = Math.sqrt(n);
    return this.set(
      i * Math.sin(e),
      i * Math.cos(e),
      s * Math.sin(t),
      s * Math.cos(t)
    );
  }
  /**
   * Returns `true` if this quaternion is equal with the given one.
   *
   * @param {Quaternion} quaternion - The quaternion to test for equality.
   * @return {boolean} Whether this quaternion is equal with the given one.
   */
  equals(e) {
    return e._x === this._x && e._y === this._y && e._z === this._z && e._w === this._w;
  }
  /**
   * Sets this quaternion's components from the given array.
   *
   * @param {Array<number>} array - An array holding the quaternion component values.
   * @param {number} [offset=0] - The offset into the array.
   * @return {Quaternion} A reference to this quaternion.
   */
  fromArray(e, t = 0) {
    return this._x = e[t], this._y = e[t + 1], this._z = e[t + 2], this._w = e[t + 3], this._onChangeCallback(), this;
  }
  /**
   * Writes the components of this quaternion to the given array. If no array is provided,
   * the method returns a new instance.
   *
   * @param {Array<number>} [array=[]] - The target array holding the quaternion components.
   * @param {number} [offset=0] - Index of the first element in the array.
   * @return {Array<number>} The quaternion components.
   */
  toArray(e = [], t = 0) {
    return e[t] = this._x, e[t + 1] = this._y, e[t + 2] = this._z, e[t + 3] = this._w, e;
  }
  /**
   * Sets the components of this quaternion from the given buffer attribute.
   *
   * @param {BufferAttribute} attribute - The buffer attribute holding quaternion data.
   * @param {number} index - The index into the attribute.
   * @return {Quaternion} A reference to this quaternion.
   */
  fromBufferAttribute(e, t) {
    return this._x = e.getX(t), this._y = e.getY(t), this._z = e.getZ(t), this._w = e.getW(t), this._onChangeCallback(), this;
  }
  /**
   * This methods defines the serialization result of this class. Returns the
   * numerical elements of this quaternion in an array of format `[x, y, z, w]`.
   *
   * @return {Array<number>} The serialized quaternion.
   */
  toJSON() {
    return this.toArray();
  }
  _onChange(e) {
    return this._onChangeCallback = e, this;
  }
  _onChangeCallback() {
  }
  *[Symbol.iterator]() {
    yield this._x, yield this._y, yield this._z, yield this._w;
  }
}
class I {
  /**
   * Constructs a new 3D vector.
   *
   * @param {number} [x=0] - The x value of this vector.
   * @param {number} [y=0] - The y value of this vector.
   * @param {number} [z=0] - The z value of this vector.
   */
  constructor(e = 0, t = 0, n = 0) {
    I.prototype.isVector3 = !0, this.x = e, this.y = t, this.z = n;
  }
  /**
   * Sets the vector components.
   *
   * @param {number} x - The value of the x component.
   * @param {number} y - The value of the y component.
   * @param {number} z - The value of the z component.
   * @return {Vector3} A reference to this vector.
   */
  set(e, t, n) {
    return n === void 0 && (n = this.z), this.x = e, this.y = t, this.z = n, this;
  }
  /**
   * Sets the vector components to the same value.
   *
   * @param {number} scalar - The value to set for all vector components.
   * @return {Vector3} A reference to this vector.
   */
  setScalar(e) {
    return this.x = e, this.y = e, this.z = e, this;
  }
  /**
   * Sets the vector's x component to the given value
   *
   * @param {number} x - The value to set.
   * @return {Vector3} A reference to this vector.
   */
  setX(e) {
    return this.x = e, this;
  }
  /**
   * Sets the vector's y component to the given value
   *
   * @param {number} y - The value to set.
   * @return {Vector3} A reference to this vector.
   */
  setY(e) {
    return this.y = e, this;
  }
  /**
   * Sets the vector's z component to the given value
   *
   * @param {number} z - The value to set.
   * @return {Vector3} A reference to this vector.
   */
  setZ(e) {
    return this.z = e, this;
  }
  /**
   * Allows to set a vector component with an index.
   *
   * @param {number} index - The component index. `0` equals to x, `1` equals to y, `2` equals to z.
   * @param {number} value - The value to set.
   * @return {Vector3} A reference to this vector.
   */
  setComponent(e, t) {
    switch (e) {
      case 0:
        this.x = t;
        break;
      case 1:
        this.y = t;
        break;
      case 2:
        this.z = t;
        break;
      default:
        throw new Error("index is out of range: " + e);
    }
    return this;
  }
  /**
   * Returns the value of the vector component which matches the given index.
   *
   * @param {number} index - The component index. `0` equals to x, `1` equals to y, `2` equals to z.
   * @return {number} A vector component value.
   */
  getComponent(e) {
    switch (e) {
      case 0:
        return this.x;
      case 1:
        return this.y;
      case 2:
        return this.z;
      default:
        throw new Error("index is out of range: " + e);
    }
  }
  /**
   * Returns a new vector with copied values from this instance.
   *
   * @return {Vector3} A clone of this instance.
   */
  clone() {
    return new this.constructor(this.x, this.y, this.z);
  }
  /**
   * Copies the values of the given vector to this instance.
   *
   * @param {Vector3} v - The vector to copy.
   * @return {Vector3} A reference to this vector.
   */
  copy(e) {
    return this.x = e.x, this.y = e.y, this.z = e.z, this;
  }
  /**
   * Adds the given vector to this instance.
   *
   * @param {Vector3} v - The vector to add.
   * @return {Vector3} A reference to this vector.
   */
  add(e) {
    return this.x += e.x, this.y += e.y, this.z += e.z, this;
  }
  /**
   * Adds the given scalar value to all components of this instance.
   *
   * @param {number} s - The scalar to add.
   * @return {Vector3} A reference to this vector.
   */
  addScalar(e) {
    return this.x += e, this.y += e, this.z += e, this;
  }
  /**
   * Adds the given vectors and stores the result in this instance.
   *
   * @param {Vector3} a - The first vector.
   * @param {Vector3} b - The second vector.
   * @return {Vector3} A reference to this vector.
   */
  addVectors(e, t) {
    return this.x = e.x + t.x, this.y = e.y + t.y, this.z = e.z + t.z, this;
  }
  /**
   * Adds the given vector scaled by the given factor to this instance.
   *
   * @param {Vector3|Vector4} v - The vector.
   * @param {number} s - The factor that scales `v`.
   * @return {Vector3} A reference to this vector.
   */
  addScaledVector(e, t) {
    return this.x += e.x * t, this.y += e.y * t, this.z += e.z * t, this;
  }
  /**
   * Subtracts the given vector from this instance.
   *
   * @param {Vector3} v - The vector to subtract.
   * @return {Vector3} A reference to this vector.
   */
  sub(e) {
    return this.x -= e.x, this.y -= e.y, this.z -= e.z, this;
  }
  /**
   * Subtracts the given scalar value from all components of this instance.
   *
   * @param {number} s - The scalar to subtract.
   * @return {Vector3} A reference to this vector.
   */
  subScalar(e) {
    return this.x -= e, this.y -= e, this.z -= e, this;
  }
  /**
   * Subtracts the given vectors and stores the result in this instance.
   *
   * @param {Vector3} a - The first vector.
   * @param {Vector3} b - The second vector.
   * @return {Vector3} A reference to this vector.
   */
  subVectors(e, t) {
    return this.x = e.x - t.x, this.y = e.y - t.y, this.z = e.z - t.z, this;
  }
  /**
   * Multiplies the given vector with this instance.
   *
   * @param {Vector3} v - The vector to multiply.
   * @return {Vector3} A reference to this vector.
   */
  multiply(e) {
    return this.x *= e.x, this.y *= e.y, this.z *= e.z, this;
  }
  /**
   * Multiplies the given scalar value with all components of this instance.
   *
   * @param {number} scalar - The scalar to multiply.
   * @return {Vector3} A reference to this vector.
   */
  multiplyScalar(e) {
    return this.x *= e, this.y *= e, this.z *= e, this;
  }
  /**
   * Multiplies the given vectors and stores the result in this instance.
   *
   * @param {Vector3} a - The first vector.
   * @param {Vector3} b - The second vector.
   * @return {Vector3} A reference to this vector.
   */
  multiplyVectors(e, t) {
    return this.x = e.x * t.x, this.y = e.y * t.y, this.z = e.z * t.z, this;
  }
  /**
   * Applies the given Euler rotation to this vector.
   *
   * @param {Euler} euler - The Euler angles.
   * @return {Vector3} A reference to this vector.
   */
  applyEuler(e) {
    return this.applyQuaternion(Ho.setFromEuler(e));
  }
  /**
   * Applies a rotation specified by an axis and an angle to this vector.
   *
   * @param {Vector3} axis - A normalized vector representing the rotation axis.
   * @param {number} angle - The angle in radians.
   * @return {Vector3} A reference to this vector.
   */
  applyAxisAngle(e, t) {
    return this.applyQuaternion(Ho.setFromAxisAngle(e, t));
  }
  /**
   * Multiplies this vector with the given 3x3 matrix.
   *
   * @param {Matrix3} m - The 3x3 matrix.
   * @return {Vector3} A reference to this vector.
   */
  applyMatrix3(e) {
    const t = this.x, n = this.y, i = this.z, s = e.elements;
    return this.x = s[0] * t + s[3] * n + s[6] * i, this.y = s[1] * t + s[4] * n + s[7] * i, this.z = s[2] * t + s[5] * n + s[8] * i, this;
  }
  /**
   * Multiplies this vector by the given normal matrix and normalizes
   * the result.
   *
   * @param {Matrix3} m - The normal matrix.
   * @return {Vector3} A reference to this vector.
   */
  applyNormalMatrix(e) {
    return this.applyMatrix3(e).normalize();
  }
  /**
   * Multiplies this vector (with an implicit 1 in the 4th dimension) by m, and
   * divides by perspective.
   *
   * @param {Matrix4} m - The matrix to apply.
   * @return {Vector3} A reference to this vector.
   */
  applyMatrix4(e) {
    const t = this.x, n = this.y, i = this.z, s = e.elements, a = 1 / (s[3] * t + s[7] * n + s[11] * i + s[15]);
    return this.x = (s[0] * t + s[4] * n + s[8] * i + s[12]) * a, this.y = (s[1] * t + s[5] * n + s[9] * i + s[13]) * a, this.z = (s[2] * t + s[6] * n + s[10] * i + s[14]) * a, this;
  }
  /**
   * Applies the given Quaternion to this vector.
   *
   * @param {Quaternion} q - The Quaternion.
   * @return {Vector3} A reference to this vector.
   */
  applyQuaternion(e) {
    const t = this.x, n = this.y, i = this.z, s = e.x, a = e.y, o = e.z, c = e.w, l = 2 * (a * i - o * n), u = 2 * (o * t - s * i), h = 2 * (s * n - a * t);
    return this.x = t + c * l + a * h - o * u, this.y = n + c * u + o * l - s * h, this.z = i + c * h + s * u - a * l, this;
  }
  /**
   * Projects this vector from world space into the camera's normalized
   * device coordinate (NDC) space.
   *
   * @param {Camera} camera - The camera.
   * @return {Vector3} A reference to this vector.
   */
  project(e) {
    return this.applyMatrix4(e.matrixWorldInverse).applyMatrix4(e.projectionMatrix);
  }
  /**
   * Unprojects this vector from the camera's normalized device coordinate (NDC)
   * space into world space.
   *
   * @param {Camera} camera - The camera.
   * @return {Vector3} A reference to this vector.
   */
  unproject(e) {
    return this.applyMatrix4(e.projectionMatrixInverse).applyMatrix4(e.matrixWorld);
  }
  /**
   * Transforms the direction of this vector by a matrix (the upper left 3 x 3
   * subset of the given 4x4 matrix and then normalizes the result.
   *
   * @param {Matrix4} m - The matrix.
   * @return {Vector3} A reference to this vector.
   */
  transformDirection(e) {
    const t = this.x, n = this.y, i = this.z, s = e.elements;
    return this.x = s[0] * t + s[4] * n + s[8] * i, this.y = s[1] * t + s[5] * n + s[9] * i, this.z = s[2] * t + s[6] * n + s[10] * i, this.normalize();
  }
  /**
   * Divides this instance by the given vector.
   *
   * @param {Vector3} v - The vector to divide.
   * @return {Vector3} A reference to this vector.
   */
  divide(e) {
    return this.x /= e.x, this.y /= e.y, this.z /= e.z, this;
  }
  /**
   * Divides this vector by the given scalar.
   *
   * @param {number} scalar - The scalar to divide.
   * @return {Vector3} A reference to this vector.
   */
  divideScalar(e) {
    return this.multiplyScalar(1 / e);
  }
  /**
   * If this vector's x, y or z value is greater than the given vector's x, y or z
   * value, replace that value with the corresponding min value.
   *
   * @param {Vector3} v - The vector.
   * @return {Vector3} A reference to this vector.
   */
  min(e) {
    return this.x = Math.min(this.x, e.x), this.y = Math.min(this.y, e.y), this.z = Math.min(this.z, e.z), this;
  }
  /**
   * If this vector's x, y or z value is less than the given vector's x, y or z
   * value, replace that value with the corresponding max value.
   *
   * @param {Vector3} v - The vector.
   * @return {Vector3} A reference to this vector.
   */
  max(e) {
    return this.x = Math.max(this.x, e.x), this.y = Math.max(this.y, e.y), this.z = Math.max(this.z, e.z), this;
  }
  /**
   * If this vector's x, y or z value is greater than the max vector's x, y or z
   * value, it is replaced by the corresponding value.
   * If this vector's x, y or z value is less than the min vector's x, y or z value,
   * it is replaced by the corresponding value.
   *
   * @param {Vector3} min - The minimum x, y and z values.
   * @param {Vector3} max - The maximum x, y and z values in the desired range.
   * @return {Vector3} A reference to this vector.
   */
  clamp(e, t) {
    return this.x = ze(this.x, e.x, t.x), this.y = ze(this.y, e.y, t.y), this.z = ze(this.z, e.z, t.z), this;
  }
  /**
   * If this vector's x, y or z values are greater than the max value, they are
   * replaced by the max value.
   * If this vector's x, y or z values are less than the min value, they are
   * replaced by the min value.
   *
   * @param {number} minVal - The minimum value the components will be clamped to.
   * @param {number} maxVal - The maximum value the components will be clamped to.
   * @return {Vector3} A reference to this vector.
   */
  clampScalar(e, t) {
    return this.x = ze(this.x, e, t), this.y = ze(this.y, e, t), this.z = ze(this.z, e, t), this;
  }
  /**
   * If this vector's length is greater than the max value, it is replaced by
   * the max value.
   * If this vector's length is less than the min value, it is replaced by the
   * min value.
   *
   * @param {number} min - The minimum value the vector length will be clamped to.
   * @param {number} max - The maximum value the vector length will be clamped to.
   * @return {Vector3} A reference to this vector.
   */
  clampLength(e, t) {
    const n = this.length();
    return this.divideScalar(n || 1).multiplyScalar(ze(n, e, t));
  }
  /**
   * The components of this vector are rounded down to the nearest integer value.
   *
   * @return {Vector3} A reference to this vector.
   */
  floor() {
    return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this.z = Math.floor(this.z), this;
  }
  /**
   * The components of this vector are rounded up to the nearest integer value.
   *
   * @return {Vector3} A reference to this vector.
   */
  ceil() {
    return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this.z = Math.ceil(this.z), this;
  }
  /**
   * The components of this vector are rounded to the nearest integer value
   *
   * @return {Vector3} A reference to this vector.
   */
  round() {
    return this.x = Math.round(this.x), this.y = Math.round(this.y), this.z = Math.round(this.z), this;
  }
  /**
   * The components of this vector are rounded towards zero (up if negative,
   * down if positive) to an integer value.
   *
   * @return {Vector3} A reference to this vector.
   */
  roundToZero() {
    return this.x = Math.trunc(this.x), this.y = Math.trunc(this.y), this.z = Math.trunc(this.z), this;
  }
  /**
   * Inverts this vector - i.e. sets x = -x, y = -y and z = -z.
   *
   * @return {Vector3} A reference to this vector.
   */
  negate() {
    return this.x = -this.x, this.y = -this.y, this.z = -this.z, this;
  }
  /**
   * Calculates the dot product of the given vector with this instance.
   *
   * @param {Vector3} v - The vector to compute the dot product with.
   * @return {number} The result of the dot product.
   */
  dot(e) {
    return this.x * e.x + this.y * e.y + this.z * e.z;
  }
  /**
   * Computes the square of the Euclidean length (straight-line length) from
   * (0, 0, 0) to (x, y, z). If you are comparing the lengths of vectors, you should
   * compare the length squared instead as it is slightly more efficient to calculate.
   *
   * @return {number} The square length of this vector.
   */
  lengthSq() {
    return this.x * this.x + this.y * this.y + this.z * this.z;
  }
  /**
   * Computes the  Euclidean length (straight-line length) from (0, 0, 0) to (x, y, z).
   *
   * @return {number} The length of this vector.
   */
  length() {
    return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
  }
  /**
   * Computes the Manhattan length of this vector.
   *
   * @return {number} The length of this vector.
   */
  manhattanLength() {
    return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z);
  }
  /**
   * Converts this vector to a unit vector - that is, sets it equal to a vector
   * with the same direction as this one, but with a vector length of `1`.
   *
   * @return {Vector3} A reference to this vector.
   */
  normalize() {
    return this.divideScalar(this.length() || 1);
  }
  /**
   * Sets this vector to a vector with the same direction as this one, but
   * with the specified length.
   *
   * @param {number} length - The new length of this vector.
   * @return {Vector3} A reference to this vector.
   */
  setLength(e) {
    return this.normalize().multiplyScalar(e);
  }
  /**
   * Linearly interpolates between the given vector and this instance, where
   * alpha is the percent distance along the line - alpha = 0 will be this
   * vector, and alpha = 1 will be the given one.
   *
   * @param {Vector3} v - The vector to interpolate towards.
   * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
   * @return {Vector3} A reference to this vector.
   */
  lerp(e, t) {
    return this.x += (e.x - this.x) * t, this.y += (e.y - this.y) * t, this.z += (e.z - this.z) * t, this;
  }
  /**
   * Linearly interpolates between the given vectors, where alpha is the percent
   * distance along the line - alpha = 0 will be first vector, and alpha = 1 will
   * be the second one. The result is stored in this instance.
   *
   * @param {Vector3} v1 - The first vector.
   * @param {Vector3} v2 - The second vector.
   * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
   * @return {Vector3} A reference to this vector.
   */
  lerpVectors(e, t, n) {
    return this.x = e.x + (t.x - e.x) * n, this.y = e.y + (t.y - e.y) * n, this.z = e.z + (t.z - e.z) * n, this;
  }
  /**
   * Calculates the cross product of the given vector with this instance.
   *
   * @param {Vector3} v - The vector to compute the cross product with.
   * @return {Vector3} The result of the cross product.
   */
  cross(e) {
    return this.crossVectors(this, e);
  }
  /**
   * Calculates the cross product of the given vectors and stores the result
   * in this instance.
   *
   * @param {Vector3} a - The first vector.
   * @param {Vector3} b - The second vector.
   * @return {Vector3} A reference to this vector.
   */
  crossVectors(e, t) {
    const n = e.x, i = e.y, s = e.z, a = t.x, o = t.y, c = t.z;
    return this.x = i * c - s * o, this.y = s * a - n * c, this.z = n * o - i * a, this;
  }
  /**
   * Projects this vector onto the given one.
   *
   * @param {Vector3} v - The vector to project to.
   * @return {Vector3} A reference to this vector.
   */
  projectOnVector(e) {
    const t = e.lengthSq();
    if (t === 0) return this.set(0, 0, 0);
    const n = e.dot(this) / t;
    return this.copy(e).multiplyScalar(n);
  }
  /**
   * Projects this vector onto a plane by subtracting this
   * vector projected onto the plane's normal from this vector.
   *
   * @param {Vector3} planeNormal - The plane normal.
   * @return {Vector3} A reference to this vector.
   */
  projectOnPlane(e) {
    return na.copy(this).projectOnVector(e), this.sub(na);
  }
  /**
   * Reflects this vector off a plane orthogonal to the given normal vector.
   *
   * @param {Vector3} normal - The (normalized) normal vector.
   * @return {Vector3} A reference to this vector.
   */
  reflect(e) {
    return this.sub(na.copy(e).multiplyScalar(2 * this.dot(e)));
  }
  /**
   * Returns the angle between the given vector and this instance in radians.
   *
   * @param {Vector3} v - The vector to compute the angle with.
   * @return {number} The angle in radians.
   */
  angleTo(e) {
    const t = Math.sqrt(this.lengthSq() * e.lengthSq());
    if (t === 0) return Math.PI / 2;
    const n = this.dot(e) / t;
    return Math.acos(ze(n, -1, 1));
  }
  /**
   * Computes the distance from the given vector to this instance.
   *
   * @param {Vector3} v - The vector to compute the distance to.
   * @return {number} The distance.
   */
  distanceTo(e) {
    return Math.sqrt(this.distanceToSquared(e));
  }
  /**
   * Computes the squared distance from the given vector to this instance.
   * If you are just comparing the distance with another distance, you should compare
   * the distance squared instead as it is slightly more efficient to calculate.
   *
   * @param {Vector3} v - The vector to compute the squared distance to.
   * @return {number} The squared distance.
   */
  distanceToSquared(e) {
    const t = this.x - e.x, n = this.y - e.y, i = this.z - e.z;
    return t * t + n * n + i * i;
  }
  /**
   * Computes the Manhattan distance from the given vector to this instance.
   *
   * @param {Vector3} v - The vector to compute the Manhattan distance to.
   * @return {number} The Manhattan distance.
   */
  manhattanDistanceTo(e) {
    return Math.abs(this.x - e.x) + Math.abs(this.y - e.y) + Math.abs(this.z - e.z);
  }
  /**
   * Sets the vector components from the given spherical coordinates.
   *
   * @param {Spherical} s - The spherical coordinates.
   * @return {Vector3} A reference to this vector.
   */
  setFromSpherical(e) {
    return this.setFromSphericalCoords(e.radius, e.phi, e.theta);
  }
  /**
   * Sets the vector components from the given spherical coordinates.
   *
   * @param {number} radius - The radius.
   * @param {number} phi - The phi angle in radians.
   * @param {number} theta - The theta angle in radians.
   * @return {Vector3} A reference to this vector.
   */
  setFromSphericalCoords(e, t, n) {
    const i = Math.sin(t) * e;
    return this.x = i * Math.sin(n), this.y = Math.cos(t) * e, this.z = i * Math.cos(n), this;
  }
  /**
   * Sets the vector components from the given cylindrical coordinates.
   *
   * @param {Cylindrical} c - The cylindrical coordinates.
   * @return {Vector3} A reference to this vector.
   */
  setFromCylindrical(e) {
    return this.setFromCylindricalCoords(e.radius, e.theta, e.y);
  }
  /**
   * Sets the vector components from the given cylindrical coordinates.
   *
   * @param {number} radius - The radius.
   * @param {number} theta - The theta angle in radians.
   * @param {number} y - The y value.
   * @return {Vector3} A reference to this vector.
   */
  setFromCylindricalCoords(e, t, n) {
    return this.x = e * Math.sin(t), this.y = n, this.z = e * Math.cos(t), this;
  }
  /**
   * Sets the vector components to the position elements of the
   * given transformation matrix.
   *
   * @param {Matrix4} m - The 4x4 matrix.
   * @return {Vector3} A reference to this vector.
   */
  setFromMatrixPosition(e) {
    const t = e.elements;
    return this.x = t[12], this.y = t[13], this.z = t[14], this;
  }
  /**
   * Sets the vector components to the scale elements of the
   * given transformation matrix.
   *
   * @param {Matrix4} m - The 4x4 matrix.
   * @return {Vector3} A reference to this vector.
   */
  setFromMatrixScale(e) {
    const t = this.setFromMatrixColumn(e, 0).length(), n = this.setFromMatrixColumn(e, 1).length(), i = this.setFromMatrixColumn(e, 2).length();
    return this.x = t, this.y = n, this.z = i, this;
  }
  /**
   * Sets the vector components from the specified matrix column.
   *
   * @param {Matrix4} m - The 4x4 matrix.
   * @param {number} index - The column index.
   * @return {Vector3} A reference to this vector.
   */
  setFromMatrixColumn(e, t) {
    return this.fromArray(e.elements, t * 4);
  }
  /**
   * Sets the vector components from the specified matrix column.
   *
   * @param {Matrix3} m - The 3x3 matrix.
   * @param {number} index - The column index.
   * @return {Vector3} A reference to this vector.
   */
  setFromMatrix3Column(e, t) {
    return this.fromArray(e.elements, t * 3);
  }
  /**
   * Sets the vector components from the given Euler angles.
   *
   * @param {Euler} e - The Euler angles to set.
   * @return {Vector3} A reference to this vector.
   */
  setFromEuler(e) {
    return this.x = e._x, this.y = e._y, this.z = e._z, this;
  }
  /**
   * Sets the vector components from the RGB components of the
   * given color.
   *
   * @param {Color} c - The color to set.
   * @return {Vector3} A reference to this vector.
   */
  setFromColor(e) {
    return this.x = e.r, this.y = e.g, this.z = e.b, this;
  }
  /**
   * Returns `true` if this vector is equal with the given one.
   *
   * @param {Vector3} v - The vector to test for equality.
   * @return {boolean} Whether this vector is equal with the given one.
   */
  equals(e) {
    return e.x === this.x && e.y === this.y && e.z === this.z;
  }
  /**
   * Sets this vector's x value to be `array[ offset ]`, y value to be `array[ offset + 1 ]`
   * and z value to be `array[ offset + 2 ]`.
   *
   * @param {Array<number>} array - An array holding the vector component values.
   * @param {number} [offset=0] - The offset into the array.
   * @return {Vector3} A reference to this vector.
   */
  fromArray(e, t = 0) {
    return this.x = e[t], this.y = e[t + 1], this.z = e[t + 2], this;
  }
  /**
   * Writes the components of this vector to the given array. If no array is provided,
   * the method returns a new instance.
   *
   * @param {Array<number>} [array=[]] - The target array holding the vector components.
   * @param {number} [offset=0] - Index of the first element in the array.
   * @return {Array<number>} The vector components.
   */
  toArray(e = [], t = 0) {
    return e[t] = this.x, e[t + 1] = this.y, e[t + 2] = this.z, e;
  }
  /**
   * Sets the components of this vector from the given buffer attribute.
   *
   * @param {BufferAttribute} attribute - The buffer attribute holding vector data.
   * @param {number} index - The index into the attribute.
   * @return {Vector3} A reference to this vector.
   */
  fromBufferAttribute(e, t) {
    return this.x = e.getX(t), this.y = e.getY(t), this.z = e.getZ(t), this;
  }
  /**
   * Sets each component of this vector to a pseudo-random value between `0` and
   * `1`, excluding `1`.
   *
   * @return {Vector3} A reference to this vector.
   */
  random() {
    return this.x = Math.random(), this.y = Math.random(), this.z = Math.random(), this;
  }
  /**
   * Sets this vector to a uniformly random point on a unit sphere.
   *
   * @return {Vector3} A reference to this vector.
   */
  randomDirection() {
    const e = Math.random() * Math.PI * 2, t = Math.random() * 2 - 1, n = Math.sqrt(1 - t * t);
    return this.x = n * Math.cos(e), this.y = t, this.z = n * Math.sin(e), this;
  }
  *[Symbol.iterator]() {
    yield this.x, yield this.y, yield this.z;
  }
}
const na = /* @__PURE__ */ new I(), Ho = /* @__PURE__ */ new Xr();
class Ue {
  /**
   * Constructs a new 3x3 matrix. The arguments are supposed to be
   * in row-major order. If no arguments are provided, the constructor
   * initializes the matrix as an identity matrix.
   *
   * @param {number} [n11] - 1-1 matrix element.
   * @param {number} [n12] - 1-2 matrix element.
   * @param {number} [n13] - 1-3 matrix element.
   * @param {number} [n21] - 2-1 matrix element.
   * @param {number} [n22] - 2-2 matrix element.
   * @param {number} [n23] - 2-3 matrix element.
   * @param {number} [n31] - 3-1 matrix element.
   * @param {number} [n32] - 3-2 matrix element.
   * @param {number} [n33] - 3-3 matrix element.
   */
  constructor(e, t, n, i, s, a, o, c, l) {
    Ue.prototype.isMatrix3 = !0, this.elements = [
      1,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      1
    ], e !== void 0 && this.set(e, t, n, i, s, a, o, c, l);
  }
  /**
   * Sets the elements of the matrix.The arguments are supposed to be
   * in row-major order.
   *
   * @param {number} [n11] - 1-1 matrix element.
   * @param {number} [n12] - 1-2 matrix element.
   * @param {number} [n13] - 1-3 matrix element.
   * @param {number} [n21] - 2-1 matrix element.
   * @param {number} [n22] - 2-2 matrix element.
   * @param {number} [n23] - 2-3 matrix element.
   * @param {number} [n31] - 3-1 matrix element.
   * @param {number} [n32] - 3-2 matrix element.
   * @param {number} [n33] - 3-3 matrix element.
   * @return {Matrix3} A reference to this matrix.
   */
  set(e, t, n, i, s, a, o, c, l) {
    const u = this.elements;
    return u[0] = e, u[1] = i, u[2] = o, u[3] = t, u[4] = s, u[5] = c, u[6] = n, u[7] = a, u[8] = l, this;
  }
  /**
   * Sets this matrix to the 3x3 identity matrix.
   *
   * @return {Matrix3} A reference to this matrix.
   */
  identity() {
    return this.set(
      1,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      1
    ), this;
  }
  /**
   * Copies the values of the given matrix to this instance.
   *
   * @param {Matrix3} m - The matrix to copy.
   * @return {Matrix3} A reference to this matrix.
   */
  copy(e) {
    const t = this.elements, n = e.elements;
    return t[0] = n[0], t[1] = n[1], t[2] = n[2], t[3] = n[3], t[4] = n[4], t[5] = n[5], t[6] = n[6], t[7] = n[7], t[8] = n[8], this;
  }
  /**
   * Extracts the basis of this matrix into the three axis vectors provided.
   *
   * @param {Vector3} xAxis - The basis's x axis.
   * @param {Vector3} yAxis - The basis's y axis.
   * @param {Vector3} zAxis - The basis's z axis.
   * @return {Matrix3} A reference to this matrix.
   */
  extractBasis(e, t, n) {
    return e.setFromMatrix3Column(this, 0), t.setFromMatrix3Column(this, 1), n.setFromMatrix3Column(this, 2), this;
  }
  /**
   * Set this matrix to the upper 3x3 matrix of the given 4x4 matrix.
   *
   * @param {Matrix4} m - The 4x4 matrix.
   * @return {Matrix3} A reference to this matrix.
   */
  setFromMatrix4(e) {
    const t = e.elements;
    return this.set(
      t[0],
      t[4],
      t[8],
      t[1],
      t[5],
      t[9],
      t[2],
      t[6],
      t[10]
    ), this;
  }
  /**
   * Post-multiplies this matrix by the given 3x3 matrix.
   *
   * @param {Matrix3} m - The matrix to multiply with.
   * @return {Matrix3} A reference to this matrix.
   */
  multiply(e) {
    return this.multiplyMatrices(this, e);
  }
  /**
   * Pre-multiplies this matrix by the given 3x3 matrix.
   *
   * @param {Matrix3} m - The matrix to multiply with.
   * @return {Matrix3} A reference to this matrix.
   */
  premultiply(e) {
    return this.multiplyMatrices(e, this);
  }
  /**
   * Multiples the given 3x3 matrices and stores the result
   * in this matrix.
   *
   * @param {Matrix3} a - The first matrix.
   * @param {Matrix3} b - The second matrix.
   * @return {Matrix3} A reference to this matrix.
   */
  multiplyMatrices(e, t) {
    const n = e.elements, i = t.elements, s = this.elements, a = n[0], o = n[3], c = n[6], l = n[1], u = n[4], h = n[7], f = n[2], d = n[5], g = n[8], _ = i[0], m = i[3], p = i[6], S = i[1], b = i[4], T = i[7], y = i[2], R = i[5], A = i[8];
    return s[0] = a * _ + o * S + c * y, s[3] = a * m + o * b + c * R, s[6] = a * p + o * T + c * A, s[1] = l * _ + u * S + h * y, s[4] = l * m + u * b + h * R, s[7] = l * p + u * T + h * A, s[2] = f * _ + d * S + g * y, s[5] = f * m + d * b + g * R, s[8] = f * p + d * T + g * A, this;
  }
  /**
   * Multiplies every component of the matrix by the given scalar.
   *
   * @param {number} s - The scalar.
   * @return {Matrix3} A reference to this matrix.
   */
  multiplyScalar(e) {
    const t = this.elements;
    return t[0] *= e, t[3] *= e, t[6] *= e, t[1] *= e, t[4] *= e, t[7] *= e, t[2] *= e, t[5] *= e, t[8] *= e, this;
  }
  /**
   * Computes and returns the determinant of this matrix.
   *
   * @return {number} The determinant.
   */
  determinant() {
    const e = this.elements, t = e[0], n = e[1], i = e[2], s = e[3], a = e[4], o = e[5], c = e[6], l = e[7], u = e[8];
    return t * a * u - t * o * l - n * s * u + n * o * c + i * s * l - i * a * c;
  }
  /**
   * Inverts this matrix, using the [analytic method](https://en.wikipedia.org/wiki/Invertible_matrix#Analytic_solution).
   * You can not invert with a determinant of zero. If you attempt this, the method produces
   * a zero matrix instead.
   *
   * @return {Matrix3} A reference to this matrix.
   */
  invert() {
    const e = this.elements, t = e[0], n = e[1], i = e[2], s = e[3], a = e[4], o = e[5], c = e[6], l = e[7], u = e[8], h = u * a - o * l, f = o * c - u * s, d = l * s - a * c, g = t * h + n * f + i * d;
    if (g === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0);
    const _ = 1 / g;
    return e[0] = h * _, e[1] = (i * l - u * n) * _, e[2] = (o * n - i * a) * _, e[3] = f * _, e[4] = (u * t - i * c) * _, e[5] = (i * s - o * t) * _, e[6] = d * _, e[7] = (n * c - l * t) * _, e[8] = (a * t - n * s) * _, this;
  }
  /**
   * Transposes this matrix in place.
   *
   * @return {Matrix3} A reference to this matrix.
   */
  transpose() {
    let e;
    const t = this.elements;
    return e = t[1], t[1] = t[3], t[3] = e, e = t[2], t[2] = t[6], t[6] = e, e = t[5], t[5] = t[7], t[7] = e, this;
  }
  /**
   * Computes the normal matrix which is the inverse transpose of the upper
   * left 3x3 portion of the given 4x4 matrix.
   *
   * @param {Matrix4} matrix4 - The 4x4 matrix.
   * @return {Matrix3} A reference to this matrix.
   */
  getNormalMatrix(e) {
    return this.setFromMatrix4(e).invert().transpose();
  }
  /**
   * Transposes this matrix into the supplied array, and returns itself unchanged.
   *
   * @param {Array<number>} r - An array to store the transposed matrix elements.
   * @return {Matrix3} A reference to this matrix.
   */
  transposeIntoArray(e) {
    const t = this.elements;
    return e[0] = t[0], e[1] = t[3], e[2] = t[6], e[3] = t[1], e[4] = t[4], e[5] = t[7], e[6] = t[2], e[7] = t[5], e[8] = t[8], this;
  }
  /**
   * Sets the UV transform matrix from offset, repeat, rotation, and center.
   *
   * @param {number} tx - Offset x.
   * @param {number} ty - Offset y.
   * @param {number} sx - Repeat x.
   * @param {number} sy - Repeat y.
   * @param {number} rotation - Rotation, in radians. Positive values rotate counterclockwise.
   * @param {number} cx - Center x of rotation.
   * @param {number} cy - Center y of rotation
   * @return {Matrix3} A reference to this matrix.
   */
  setUvTransform(e, t, n, i, s, a, o) {
    const c = Math.cos(s), l = Math.sin(s);
    return this.set(
      n * c,
      n * l,
      -n * (c * a + l * o) + a + e,
      -i * l,
      i * c,
      -i * (-l * a + c * o) + o + t,
      0,
      0,
      1
    ), this;
  }
  /**
   * Scales this matrix with the given scalar values.
   *
   * @param {number} sx - The amount to scale in the X axis.
   * @param {number} sy - The amount to scale in the Y axis.
   * @return {Matrix3} A reference to this matrix.
   */
  scale(e, t) {
    return this.premultiply(ia.makeScale(e, t)), this;
  }
  /**
   * Rotates this matrix by the given angle.
   *
   * @param {number} theta - The rotation in radians.
   * @return {Matrix3} A reference to this matrix.
   */
  rotate(e) {
    return this.premultiply(ia.makeRotation(-e)), this;
  }
  /**
   * Translates this matrix by the given scalar values.
   *
   * @param {number} tx - The amount to translate in the X axis.
   * @param {number} ty - The amount to translate in the Y axis.
   * @return {Matrix3} A reference to this matrix.
   */
  translate(e, t) {
    return this.premultiply(ia.makeTranslation(e, t)), this;
  }
  // for 2D Transforms
  /**
   * Sets this matrix as a 2D translation transform.
   *
   * @param {number|Vector2} x - The amount to translate in the X axis or alternatively a translation vector.
   * @param {number} y - The amount to translate in the Y axis.
   * @return {Matrix3} A reference to this matrix.
   */
  makeTranslation(e, t) {
    return e.isVector2 ? this.set(
      1,
      0,
      e.x,
      0,
      1,
      e.y,
      0,
      0,
      1
    ) : this.set(
      1,
      0,
      e,
      0,
      1,
      t,
      0,
      0,
      1
    ), this;
  }
  /**
   * Sets this matrix as a 2D rotational transformation.
   *
   * @param {number} theta - The rotation in radians.
   * @return {Matrix3} A reference to this matrix.
   */
  makeRotation(e) {
    const t = Math.cos(e), n = Math.sin(e);
    return this.set(
      t,
      -n,
      0,
      n,
      t,
      0,
      0,
      0,
      1
    ), this;
  }
  /**
   * Sets this matrix as a 2D scale transform.
   *
   * @param {number} x - The amount to scale in the X axis.
   * @param {number} y - The amount to scale in the Y axis.
   * @return {Matrix3} A reference to this matrix.
   */
  makeScale(e, t) {
    return this.set(
      e,
      0,
      0,
      0,
      t,
      0,
      0,
      0,
      1
    ), this;
  }
  /**
   * Returns `true` if this matrix is equal with the given one.
   *
   * @param {Matrix3} matrix - The matrix to test for equality.
   * @return {boolean} Whether this matrix is equal with the given one.
   */
  equals(e) {
    const t = this.elements, n = e.elements;
    for (let i = 0; i < 9; i++)
      if (t[i] !== n[i]) return !1;
    return !0;
  }
  /**
   * Sets the elements of the matrix from the given array.
   *
   * @param {Array<number>} array - The matrix elements in column-major order.
   * @param {number} [offset=0] - Index of the first element in the array.
   * @return {Matrix3} A reference to this matrix.
   */
  fromArray(e, t = 0) {
    for (let n = 0; n < 9; n++)
      this.elements[n] = e[n + t];
    return this;
  }
  /**
   * Writes the elements of this matrix to the given array. If no array is provided,
   * the method returns a new instance.
   *
   * @param {Array<number>} [array=[]] - The target array holding the matrix elements in column-major order.
   * @param {number} [offset=0] - Index of the first element in the array.
   * @return {Array<number>} The matrix elements in column-major order.
   */
  toArray(e = [], t = 0) {
    const n = this.elements;
    return e[t] = n[0], e[t + 1] = n[1], e[t + 2] = n[2], e[t + 3] = n[3], e[t + 4] = n[4], e[t + 5] = n[5], e[t + 6] = n[6], e[t + 7] = n[7], e[t + 8] = n[8], e;
  }
  /**
   * Returns a matrix with copied values from this instance.
   *
   * @return {Matrix3} A clone of this instance.
   */
  clone() {
    return new this.constructor().fromArray(this.elements);
  }
}
const ia = /* @__PURE__ */ new Ue(), Wo = /* @__PURE__ */ new Ue().set(
  0.4123908,
  0.3575843,
  0.1804808,
  0.212639,
  0.7151687,
  0.0721923,
  0.0193308,
  0.1191948,
  0.9505322
), Xo = /* @__PURE__ */ new Ue().set(
  3.2409699,
  -1.5373832,
  -0.4986108,
  -0.9692436,
  1.8759675,
  0.0415551,
  0.0556301,
  -0.203977,
  1.0569715
);
function Qu() {
  const r = {
    enabled: !0,
    workingColorSpace: tr,
    /**
     * Implementations of supported color spaces.
     *
     * Required:
     *	- primaries: chromaticity coordinates [ rx ry gx gy bx by ]
     *	- whitePoint: reference white [ x y ]
     *	- transfer: transfer function (pre-defined)
     *	- toXYZ: Matrix3 RGB to XYZ transform
     *	- fromXYZ: Matrix3 XYZ to RGB transform
     *	- luminanceCoefficients: RGB luminance coefficients
     *
     * Optional:
     *  - outputColorSpaceConfig: { drawingBufferColorSpace: ColorSpace, toneMappingMode: 'extended' | 'standard' }
     *  - workingColorSpaceConfig: { unpackColorSpace: ColorSpace }
     *
     * Reference:
     * - https://www.russellcottrell.com/photo/matrixCalculator.htm
     */
    spaces: {},
    convert: function(i, s, a) {
      return this.enabled === !1 || s === a || !s || !a || (this.spaces[s].transfer === Qe && (i.r = kn(i.r), i.g = kn(i.g), i.b = kn(i.b)), this.spaces[s].primaries !== this.spaces[a].primaries && (i.applyMatrix3(this.spaces[s].toXYZ), i.applyMatrix3(this.spaces[a].fromXYZ)), this.spaces[a].transfer === Qe && (i.r = ji(i.r), i.g = ji(i.g), i.b = ji(i.b))), i;
    },
    workingToColorSpace: function(i, s) {
      return this.convert(i, this.workingColorSpace, s);
    },
    colorSpaceToWorking: function(i, s) {
      return this.convert(i, s, this.workingColorSpace);
    },
    getPrimaries: function(i) {
      return this.spaces[i].primaries;
    },
    getTransfer: function(i) {
      return i === "" ? Ps : this.spaces[i].transfer;
    },
    getToneMappingMode: function(i) {
      return this.spaces[i].outputColorSpaceConfig.toneMappingMode || "standard";
    },
    getLuminanceCoefficients: function(i, s = this.workingColorSpace) {
      return i.fromArray(this.spaces[s].luminanceCoefficients);
    },
    define: function(i) {
      Object.assign(this.spaces, i);
    },
    // Internal APIs
    _getMatrix: function(i, s, a) {
      return i.copy(this.spaces[s].toXYZ).multiply(this.spaces[a].fromXYZ);
    },
    _getDrawingBufferColorSpace: function(i) {
      return this.spaces[i].outputColorSpaceConfig.drawingBufferColorSpace;
    },
    _getUnpackColorSpace: function(i = this.workingColorSpace) {
      return this.spaces[i].workingColorSpaceConfig.unpackColorSpace;
    },
    // Deprecated
    fromWorkingColorSpace: function(i, s) {
      return Ur("ColorManagement: .fromWorkingColorSpace() has been renamed to .workingToColorSpace()."), r.workingToColorSpace(i, s);
    },
    toWorkingColorSpace: function(i, s) {
      return Ur("ColorManagement: .toWorkingColorSpace() has been renamed to .colorSpaceToWorking()."), r.colorSpaceToWorking(i, s);
    }
  }, e = [0.64, 0.33, 0.3, 0.6, 0.15, 0.06], t = [0.2126, 0.7152, 0.0722], n = [0.3127, 0.329];
  return r.define({
    [tr]: {
      primaries: e,
      whitePoint: n,
      transfer: Ps,
      toXYZ: Wo,
      fromXYZ: Xo,
      luminanceCoefficients: t,
      workingColorSpaceConfig: { unpackColorSpace: Tt },
      outputColorSpaceConfig: { drawingBufferColorSpace: Tt }
    },
    [Tt]: {
      primaries: e,
      whitePoint: n,
      transfer: Qe,
      toXYZ: Wo,
      fromXYZ: Xo,
      luminanceCoefficients: t,
      outputColorSpaceConfig: { drawingBufferColorSpace: Tt }
    }
  }), r;
}
const qe = /* @__PURE__ */ Qu();
function kn(r) {
  return r < 0.04045 ? r * 0.0773993808 : Math.pow(r * 0.9478672986 + 0.0521327014, 2.4);
}
function ji(r) {
  return r < 31308e-7 ? r * 12.92 : 1.055 * Math.pow(r, 0.41666) - 0.055;
}
let Ci;
class eh {
  /**
   * Returns a data URI containing a representation of the given image.
   *
   * @param {(HTMLImageElement|HTMLCanvasElement)} image - The image object.
   * @param {string} [type='image/png'] - Indicates the image format.
   * @return {string} The data URI.
   */
  static getDataURL(e, t = "image/png") {
    if (/^data:/i.test(e.src) || typeof HTMLCanvasElement > "u")
      return e.src;
    let n;
    if (e instanceof HTMLCanvasElement)
      n = e;
    else {
      Ci === void 0 && (Ci = Fr("canvas")), Ci.width = e.width, Ci.height = e.height;
      const i = Ci.getContext("2d");
      e instanceof ImageData ? i.putImageData(e, 0, 0) : i.drawImage(e, 0, 0, e.width, e.height), n = Ci;
    }
    return n.toDataURL(t);
  }
  /**
   * Converts the given sRGB image data to linear color space.
   *
   * @param {(HTMLImageElement|HTMLCanvasElement|ImageBitmap|Object)} image - The image object.
   * @return {HTMLCanvasElement|Object} The converted image.
   */
  static sRGBToLinear(e) {
    if (typeof HTMLImageElement < "u" && e instanceof HTMLImageElement || typeof HTMLCanvasElement < "u" && e instanceof HTMLCanvasElement || typeof ImageBitmap < "u" && e instanceof ImageBitmap) {
      const t = Fr("canvas");
      t.width = e.width, t.height = e.height;
      const n = t.getContext("2d");
      n.drawImage(e, 0, 0, e.width, e.height);
      const i = n.getImageData(0, 0, e.width, e.height), s = i.data;
      for (let a = 0; a < s.length; a++)
        s[a] = kn(s[a] / 255) * 255;
      return n.putImageData(i, 0, 0), t;
    } else if (e.data) {
      const t = e.data.slice(0);
      for (let n = 0; n < t.length; n++)
        t instanceof Uint8Array || t instanceof Uint8ClampedArray ? t[n] = Math.floor(kn(t[n] / 255) * 255) : t[n] = kn(t[n]);
      return {
        data: t,
        width: e.width,
        height: e.height
      };
    } else
      return Ce("ImageUtils.sRGBToLinear(): Unsupported image type. No color space conversion applied."), e;
  }
}
let th = 0;
class ao {
  /**
   * Constructs a new video texture.
   *
   * @param {any} [data=null] - The data definition of a texture.
   */
  constructor(e = null) {
    this.isSource = !0, Object.defineProperty(this, "id", { value: th++ }), this.uuid = Gn(), this.data = e, this.dataReady = !0, this.version = 0;
  }
  /**
   * Returns the dimensions of the source into the given target vector.
   *
   * @param {(Vector2|Vector3)} target - The target object the result is written into.
   * @return {(Vector2|Vector3)} The dimensions of the source.
   */
  getSize(e) {
    const t = this.data;
    return typeof HTMLVideoElement < "u" && t instanceof HTMLVideoElement ? e.set(t.videoWidth, t.videoHeight, 0) : typeof VideoFrame < "u" && t instanceof VideoFrame ? e.set(t.displayHeight, t.displayWidth, 0) : t !== null ? e.set(t.width, t.height, t.depth || 0) : e.set(0, 0, 0), e;
  }
  /**
   * When the property is set to `true`, the engine allocates the memory
   * for the texture (if necessary) and triggers the actual texture upload
   * to the GPU next time the source is used.
   *
   * @type {boolean}
   * @default false
   * @param {boolean} value
   */
  set needsUpdate(e) {
    e === !0 && this.version++;
  }
  /**
   * Serializes the source into JSON.
   *
   * @param {?(Object|string)} meta - An optional value holding meta information about the serialization.
   * @return {Object} A JSON object representing the serialized source.
   * @see {@link ObjectLoader#parse}
   */
  toJSON(e) {
    const t = e === void 0 || typeof e == "string";
    if (!t && e.images[this.uuid] !== void 0)
      return e.images[this.uuid];
    const n = {
      uuid: this.uuid,
      url: ""
    }, i = this.data;
    if (i !== null) {
      let s;
      if (Array.isArray(i)) {
        s = [];
        for (let a = 0, o = i.length; a < o; a++)
          i[a].isDataTexture ? s.push(ra(i[a].image)) : s.push(ra(i[a]));
      } else
        s = ra(i);
      n.url = s;
    }
    return t || (e.images[this.uuid] = n), n;
  }
}
function ra(r) {
  return typeof HTMLImageElement < "u" && r instanceof HTMLImageElement || typeof HTMLCanvasElement < "u" && r instanceof HTMLCanvasElement || typeof ImageBitmap < "u" && r instanceof ImageBitmap ? eh.getDataURL(r) : r.data ? {
    data: Array.from(r.data),
    width: r.width,
    height: r.height,
    type: r.data.constructor.name
  } : (Ce("Texture: Unable to serialize Texture."), {});
}
let nh = 0;
const sa = /* @__PURE__ */ new I();
class bt extends lr {
  /**
   * Constructs a new texture.
   *
   * @param {?Object} [image=Texture.DEFAULT_IMAGE] - The image holding the texture data.
   * @param {number} [mapping=Texture.DEFAULT_MAPPING] - The texture mapping.
   * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
   * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
   * @param {number} [magFilter=LinearFilter] - The mag filter value.
   * @param {number} [minFilter=LinearMipmapLinearFilter] - The min filter value.
   * @param {number} [format=RGBAFormat] - The texture format.
   * @param {number} [type=UnsignedByteType] - The texture type.
   * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
   * @param {string} [colorSpace=NoColorSpace] - The color space.
   */
  constructor(e = bt.DEFAULT_IMAGE, t = bt.DEFAULT_MAPPING, n = 1001, i = 1001, s = 1006, a = 1008, o = 1023, c = 1009, l = bt.DEFAULT_ANISOTROPY, u = "") {
    super(), this.isTexture = !0, Object.defineProperty(this, "id", { value: nh++ }), this.uuid = Gn(), this.name = "", this.source = new ao(e), this.mipmaps = [], this.mapping = t, this.channel = 0, this.wrapS = n, this.wrapT = i, this.magFilter = s, this.minFilter = a, this.anisotropy = l, this.format = o, this.internalFormat = null, this.type = c, this.offset = new Ae(0, 0), this.repeat = new Ae(1, 1), this.center = new Ae(0, 0), this.rotation = 0, this.matrixAutoUpdate = !0, this.matrix = new Ue(), this.generateMipmaps = !0, this.premultiplyAlpha = !1, this.flipY = !0, this.unpackAlignment = 4, this.colorSpace = u, this.userData = {}, this.updateRanges = [], this.version = 0, this.onUpdate = null, this.renderTarget = null, this.isRenderTargetTexture = !1, this.isArrayTexture = !!(e && e.depth && e.depth > 1), this.pmremVersion = 0;
  }
  /**
   * The width of the texture in pixels.
   */
  get width() {
    return this.source.getSize(sa).x;
  }
  /**
   * The height of the texture in pixels.
   */
  get height() {
    return this.source.getSize(sa).y;
  }
  /**
   * The depth of the texture in pixels.
   */
  get depth() {
    return this.source.getSize(sa).z;
  }
  /**
   * The image object holding the texture data.
   *
   * @type {?Object}
   */
  get image() {
    return this.source.data;
  }
  set image(e = null) {
    this.source.data = e;
  }
  /**
   * Updates the texture transformation matrix from the from the properties {@link Texture#offset},
   * {@link Texture#repeat}, {@link Texture#rotation}, and {@link Texture#center}.
   */
  updateMatrix() {
    this.matrix.setUvTransform(this.offset.x, this.offset.y, this.repeat.x, this.repeat.y, this.rotation, this.center.x, this.center.y);
  }
  /**
   * Adds a range of data in the data texture to be updated on the GPU.
   *
   * @param {number} start - Position at which to start update.
   * @param {number} count - The number of components to update.
   */
  addUpdateRange(e, t) {
    this.updateRanges.push({ start: e, count: t });
  }
  /**
   * Clears the update ranges.
   */
  clearUpdateRanges() {
    this.updateRanges.length = 0;
  }
  /**
   * Returns a new texture with copied values from this instance.
   *
   * @return {Texture} A clone of this instance.
   */
  clone() {
    return new this.constructor().copy(this);
  }
  /**
   * Copies the values of the given texture to this instance.
   *
   * @param {Texture} source - The texture to copy.
   * @return {Texture} A reference to this instance.
   */
  copy(e) {
    return this.name = e.name, this.source = e.source, this.mipmaps = e.mipmaps.slice(0), this.mapping = e.mapping, this.channel = e.channel, this.wrapS = e.wrapS, this.wrapT = e.wrapT, this.magFilter = e.magFilter, this.minFilter = e.minFilter, this.anisotropy = e.anisotropy, this.format = e.format, this.internalFormat = e.internalFormat, this.type = e.type, this.offset.copy(e.offset), this.repeat.copy(e.repeat), this.center.copy(e.center), this.rotation = e.rotation, this.matrixAutoUpdate = e.matrixAutoUpdate, this.matrix.copy(e.matrix), this.generateMipmaps = e.generateMipmaps, this.premultiplyAlpha = e.premultiplyAlpha, this.flipY = e.flipY, this.unpackAlignment = e.unpackAlignment, this.colorSpace = e.colorSpace, this.renderTarget = e.renderTarget, this.isRenderTargetTexture = e.isRenderTargetTexture, this.isArrayTexture = e.isArrayTexture, this.userData = JSON.parse(JSON.stringify(e.userData)), this.needsUpdate = !0, this;
  }
  /**
   * Sets this texture's properties based on `values`.
   * @param {Object} values - A container with texture parameters.
   */
  setValues(e) {
    for (const t in e) {
      const n = e[t];
      if (n === void 0) {
        Ce(`Texture.setValues(): parameter '${t}' has value of undefined.`);
        continue;
      }
      const i = this[t];
      if (i === void 0) {
        Ce(`Texture.setValues(): property '${t}' does not exist.`);
        continue;
      }
      i && n && i.isVector2 && n.isVector2 || i && n && i.isVector3 && n.isVector3 || i && n && i.isMatrix3 && n.isMatrix3 ? i.copy(n) : this[t] = n;
    }
  }
  /**
   * Serializes the texture into JSON.
   *
   * @param {?(Object|string)} meta - An optional value holding meta information about the serialization.
   * @return {Object} A JSON object representing the serialized texture.
   * @see {@link ObjectLoader#parse}
   */
  toJSON(e) {
    const t = e === void 0 || typeof e == "string";
    if (!t && e.textures[this.uuid] !== void 0)
      return e.textures[this.uuid];
    const n = {
      metadata: {
        version: 4.7,
        type: "Texture",
        generator: "Texture.toJSON"
      },
      uuid: this.uuid,
      name: this.name,
      image: this.source.toJSON(e).uuid,
      mapping: this.mapping,
      channel: this.channel,
      repeat: [this.repeat.x, this.repeat.y],
      offset: [this.offset.x, this.offset.y],
      center: [this.center.x, this.center.y],
      rotation: this.rotation,
      wrap: [this.wrapS, this.wrapT],
      format: this.format,
      internalFormat: this.internalFormat,
      type: this.type,
      colorSpace: this.colorSpace,
      minFilter: this.minFilter,
      magFilter: this.magFilter,
      anisotropy: this.anisotropy,
      flipY: this.flipY,
      generateMipmaps: this.generateMipmaps,
      premultiplyAlpha: this.premultiplyAlpha,
      unpackAlignment: this.unpackAlignment
    };
    return Object.keys(this.userData).length > 0 && (n.userData = this.userData), t || (e.textures[this.uuid] = n), n;
  }
  /**
   * Frees the GPU-related resources allocated by this instance. Call this
   * method whenever this instance is no longer used in your app.
   *
   * @fires Texture#dispose
   */
  dispose() {
    this.dispatchEvent({ type: "dispose" });
  }
  /**
   * Transforms the given uv vector with the textures uv transformation matrix.
   *
   * @param {Vector2} uv - The uv vector.
   * @return {Vector2} The transformed uv vector.
   */
  transformUv(e) {
    if (this.mapping !== 300) return e;
    if (e.applyMatrix3(this.matrix), e.x < 0 || e.x > 1)
      switch (this.wrapS) {
        case 1e3:
          e.x = e.x - Math.floor(e.x);
          break;
        case 1001:
          e.x = e.x < 0 ? 0 : 1;
          break;
        case 1002:
          Math.abs(Math.floor(e.x) % 2) === 1 ? e.x = Math.ceil(e.x) - e.x : e.x = e.x - Math.floor(e.x);
          break;
      }
    if (e.y < 0 || e.y > 1)
      switch (this.wrapT) {
        case 1e3:
          e.y = e.y - Math.floor(e.y);
          break;
        case 1001:
          e.y = e.y < 0 ? 0 : 1;
          break;
        case 1002:
          Math.abs(Math.floor(e.y) % 2) === 1 ? e.y = Math.ceil(e.y) - e.y : e.y = e.y - Math.floor(e.y);
          break;
      }
    return this.flipY && (e.y = 1 - e.y), e;
  }
  /**
   * Setting this property to `true` indicates the engine the texture
   * must be updated in the next render. This triggers a texture upload
   * to the GPU and ensures correct texture parameter configuration.
   *
   * @type {boolean}
   * @default false
   * @param {boolean} value
   */
  set needsUpdate(e) {
    e === !0 && (this.version++, this.source.needsUpdate = !0);
  }
  /**
   * Setting this property to `true` indicates the engine the PMREM
   * must be regenerated.
   *
   * @type {boolean}
   * @default false
   * @param {boolean} value
   */
  set needsPMREMUpdate(e) {
    e === !0 && this.pmremVersion++;
  }
}
bt.DEFAULT_IMAGE = null;
bt.DEFAULT_MAPPING = 300;
bt.DEFAULT_ANISOTROPY = 1;
class xt {
  /**
   * Constructs a new 4D vector.
   *
   * @param {number} [x=0] - The x value of this vector.
   * @param {number} [y=0] - The y value of this vector.
   * @param {number} [z=0] - The z value of this vector.
   * @param {number} [w=1] - The w value of this vector.
   */
  constructor(e = 0, t = 0, n = 0, i = 1) {
    xt.prototype.isVector4 = !0, this.x = e, this.y = t, this.z = n, this.w = i;
  }
  /**
   * Alias for {@link Vector4#z}.
   *
   * @type {number}
   */
  get width() {
    return this.z;
  }
  set width(e) {
    this.z = e;
  }
  /**
   * Alias for {@link Vector4#w}.
   *
   * @type {number}
   */
  get height() {
    return this.w;
  }
  set height(e) {
    this.w = e;
  }
  /**
   * Sets the vector components.
   *
   * @param {number} x - The value of the x component.
   * @param {number} y - The value of the y component.
   * @param {number} z - The value of the z component.
   * @param {number} w - The value of the w component.
   * @return {Vector4} A reference to this vector.
   */
  set(e, t, n, i) {
    return this.x = e, this.y = t, this.z = n, this.w = i, this;
  }
  /**
   * Sets the vector components to the same value.
   *
   * @param {number} scalar - The value to set for all vector components.
   * @return {Vector4} A reference to this vector.
   */
  setScalar(e) {
    return this.x = e, this.y = e, this.z = e, this.w = e, this;
  }
  /**
   * Sets the vector's x component to the given value
   *
   * @param {number} x - The value to set.
   * @return {Vector4} A reference to this vector.
   */
  setX(e) {
    return this.x = e, this;
  }
  /**
   * Sets the vector's y component to the given value
   *
   * @param {number} y - The value to set.
   * @return {Vector4} A reference to this vector.
   */
  setY(e) {
    return this.y = e, this;
  }
  /**
   * Sets the vector's z component to the given value
   *
   * @param {number} z - The value to set.
   * @return {Vector4} A reference to this vector.
   */
  setZ(e) {
    return this.z = e, this;
  }
  /**
   * Sets the vector's w component to the given value
   *
   * @param {number} w - The value to set.
   * @return {Vector4} A reference to this vector.
   */
  setW(e) {
    return this.w = e, this;
  }
  /**
   * Allows to set a vector component with an index.
   *
   * @param {number} index - The component index. `0` equals to x, `1` equals to y,
   * `2` equals to z, `3` equals to w.
   * @param {number} value - The value to set.
   * @return {Vector4} A reference to this vector.
   */
  setComponent(e, t) {
    switch (e) {
      case 0:
        this.x = t;
        break;
      case 1:
        this.y = t;
        break;
      case 2:
        this.z = t;
        break;
      case 3:
        this.w = t;
        break;
      default:
        throw new Error("index is out of range: " + e);
    }
    return this;
  }
  /**
   * Returns the value of the vector component which matches the given index.
   *
   * @param {number} index - The component index. `0` equals to x, `1` equals to y,
   * `2` equals to z, `3` equals to w.
   * @return {number} A vector component value.
   */
  getComponent(e) {
    switch (e) {
      case 0:
        return this.x;
      case 1:
        return this.y;
      case 2:
        return this.z;
      case 3:
        return this.w;
      default:
        throw new Error("index is out of range: " + e);
    }
  }
  /**
   * Returns a new vector with copied values from this instance.
   *
   * @return {Vector4} A clone of this instance.
   */
  clone() {
    return new this.constructor(this.x, this.y, this.z, this.w);
  }
  /**
   * Copies the values of the given vector to this instance.
   *
   * @param {Vector3|Vector4} v - The vector to copy.
   * @return {Vector4} A reference to this vector.
   */
  copy(e) {
    return this.x = e.x, this.y = e.y, this.z = e.z, this.w = e.w !== void 0 ? e.w : 1, this;
  }
  /**
   * Adds the given vector to this instance.
   *
   * @param {Vector4} v - The vector to add.
   * @return {Vector4} A reference to this vector.
   */
  add(e) {
    return this.x += e.x, this.y += e.y, this.z += e.z, this.w += e.w, this;
  }
  /**
   * Adds the given scalar value to all components of this instance.
   *
   * @param {number} s - The scalar to add.
   * @return {Vector4} A reference to this vector.
   */
  addScalar(e) {
    return this.x += e, this.y += e, this.z += e, this.w += e, this;
  }
  /**
   * Adds the given vectors and stores the result in this instance.
   *
   * @param {Vector4} a - The first vector.
   * @param {Vector4} b - The second vector.
   * @return {Vector4} A reference to this vector.
   */
  addVectors(e, t) {
    return this.x = e.x + t.x, this.y = e.y + t.y, this.z = e.z + t.z, this.w = e.w + t.w, this;
  }
  /**
   * Adds the given vector scaled by the given factor to this instance.
   *
   * @param {Vector4} v - The vector.
   * @param {number} s - The factor that scales `v`.
   * @return {Vector4} A reference to this vector.
   */
  addScaledVector(e, t) {
    return this.x += e.x * t, this.y += e.y * t, this.z += e.z * t, this.w += e.w * t, this;
  }
  /**
   * Subtracts the given vector from this instance.
   *
   * @param {Vector4} v - The vector to subtract.
   * @return {Vector4} A reference to this vector.
   */
  sub(e) {
    return this.x -= e.x, this.y -= e.y, this.z -= e.z, this.w -= e.w, this;
  }
  /**
   * Subtracts the given scalar value from all components of this instance.
   *
   * @param {number} s - The scalar to subtract.
   * @return {Vector4} A reference to this vector.
   */
  subScalar(e) {
    return this.x -= e, this.y -= e, this.z -= e, this.w -= e, this;
  }
  /**
   * Subtracts the given vectors and stores the result in this instance.
   *
   * @param {Vector4} a - The first vector.
   * @param {Vector4} b - The second vector.
   * @return {Vector4} A reference to this vector.
   */
  subVectors(e, t) {
    return this.x = e.x - t.x, this.y = e.y - t.y, this.z = e.z - t.z, this.w = e.w - t.w, this;
  }
  /**
   * Multiplies the given vector with this instance.
   *
   * @param {Vector4} v - The vector to multiply.
   * @return {Vector4} A reference to this vector.
   */
  multiply(e) {
    return this.x *= e.x, this.y *= e.y, this.z *= e.z, this.w *= e.w, this;
  }
  /**
   * Multiplies the given scalar value with all components of this instance.
   *
   * @param {number} scalar - The scalar to multiply.
   * @return {Vector4} A reference to this vector.
   */
  multiplyScalar(e) {
    return this.x *= e, this.y *= e, this.z *= e, this.w *= e, this;
  }
  /**
   * Multiplies this vector with the given 4x4 matrix.
   *
   * @param {Matrix4} m - The 4x4 matrix.
   * @return {Vector4} A reference to this vector.
   */
  applyMatrix4(e) {
    const t = this.x, n = this.y, i = this.z, s = this.w, a = e.elements;
    return this.x = a[0] * t + a[4] * n + a[8] * i + a[12] * s, this.y = a[1] * t + a[5] * n + a[9] * i + a[13] * s, this.z = a[2] * t + a[6] * n + a[10] * i + a[14] * s, this.w = a[3] * t + a[7] * n + a[11] * i + a[15] * s, this;
  }
  /**
   * Divides this instance by the given vector.
   *
   * @param {Vector4} v - The vector to divide.
   * @return {Vector4} A reference to this vector.
   */
  divide(e) {
    return this.x /= e.x, this.y /= e.y, this.z /= e.z, this.w /= e.w, this;
  }
  /**
   * Divides this vector by the given scalar.
   *
   * @param {number} scalar - The scalar to divide.
   * @return {Vector4} A reference to this vector.
   */
  divideScalar(e) {
    return this.multiplyScalar(1 / e);
  }
  /**
   * Sets the x, y and z components of this
   * vector to the quaternion's axis and w to the angle.
   *
   * @param {Quaternion} q - The Quaternion to set.
   * @return {Vector4} A reference to this vector.
   */
  setAxisAngleFromQuaternion(e) {
    this.w = 2 * Math.acos(e.w);
    const t = Math.sqrt(1 - e.w * e.w);
    return t < 1e-4 ? (this.x = 1, this.y = 0, this.z = 0) : (this.x = e.x / t, this.y = e.y / t, this.z = e.z / t), this;
  }
  /**
   * Sets the x, y and z components of this
   * vector to the axis of rotation and w to the angle.
   *
   * @param {Matrix4} m - A 4x4 matrix of which the upper left 3x3 matrix is a pure rotation matrix.
   * @return {Vector4} A reference to this vector.
   */
  setAxisAngleFromRotationMatrix(e) {
    let t, n, i, s;
    const c = e.elements, l = c[0], u = c[4], h = c[8], f = c[1], d = c[5], g = c[9], _ = c[2], m = c[6], p = c[10];
    if (Math.abs(u - f) < 0.01 && Math.abs(h - _) < 0.01 && Math.abs(g - m) < 0.01) {
      if (Math.abs(u + f) < 0.1 && Math.abs(h + _) < 0.1 && Math.abs(g + m) < 0.1 && Math.abs(l + d + p - 3) < 0.1)
        return this.set(1, 0, 0, 0), this;
      t = Math.PI;
      const b = (l + 1) / 2, T = (d + 1) / 2, y = (p + 1) / 2, R = (u + f) / 4, A = (h + _) / 4, C = (g + m) / 4;
      return b > T && b > y ? b < 0.01 ? (n = 0, i = 0.707106781, s = 0.707106781) : (n = Math.sqrt(b), i = R / n, s = A / n) : T > y ? T < 0.01 ? (n = 0.707106781, i = 0, s = 0.707106781) : (i = Math.sqrt(T), n = R / i, s = C / i) : y < 0.01 ? (n = 0.707106781, i = 0.707106781, s = 0) : (s = Math.sqrt(y), n = A / s, i = C / s), this.set(n, i, s, t), this;
    }
    let S = Math.sqrt((m - g) * (m - g) + (h - _) * (h - _) + (f - u) * (f - u));
    return Math.abs(S) < 1e-3 && (S = 1), this.x = (m - g) / S, this.y = (h - _) / S, this.z = (f - u) / S, this.w = Math.acos((l + d + p - 1) / 2), this;
  }
  /**
   * Sets the vector components to the position elements of the
   * given transformation matrix.
   *
   * @param {Matrix4} m - The 4x4 matrix.
   * @return {Vector4} A reference to this vector.
   */
  setFromMatrixPosition(e) {
    const t = e.elements;
    return this.x = t[12], this.y = t[13], this.z = t[14], this.w = t[15], this;
  }
  /**
   * If this vector's x, y, z or w value is greater than the given vector's x, y, z or w
   * value, replace that value with the corresponding min value.
   *
   * @param {Vector4} v - The vector.
   * @return {Vector4} A reference to this vector.
   */
  min(e) {
    return this.x = Math.min(this.x, e.x), this.y = Math.min(this.y, e.y), this.z = Math.min(this.z, e.z), this.w = Math.min(this.w, e.w), this;
  }
  /**
   * If this vector's x, y, z or w value is less than the given vector's x, y, z or w
   * value, replace that value with the corresponding max value.
   *
   * @param {Vector4} v - The vector.
   * @return {Vector4} A reference to this vector.
   */
  max(e) {
    return this.x = Math.max(this.x, e.x), this.y = Math.max(this.y, e.y), this.z = Math.max(this.z, e.z), this.w = Math.max(this.w, e.w), this;
  }
  /**
   * If this vector's x, y, z or w value is greater than the max vector's x, y, z or w
   * value, it is replaced by the corresponding value.
   * If this vector's x, y, z or w value is less than the min vector's x, y, z or w value,
   * it is replaced by the corresponding value.
   *
   * @param {Vector4} min - The minimum x, y and z values.
   * @param {Vector4} max - The maximum x, y and z values in the desired range.
   * @return {Vector4} A reference to this vector.
   */
  clamp(e, t) {
    return this.x = ze(this.x, e.x, t.x), this.y = ze(this.y, e.y, t.y), this.z = ze(this.z, e.z, t.z), this.w = ze(this.w, e.w, t.w), this;
  }
  /**
   * If this vector's x, y, z or w values are greater than the max value, they are
   * replaced by the max value.
   * If this vector's x, y, z or w values are less than the min value, they are
   * replaced by the min value.
   *
   * @param {number} minVal - The minimum value the components will be clamped to.
   * @param {number} maxVal - The maximum value the components will be clamped to.
   * @return {Vector4} A reference to this vector.
   */
  clampScalar(e, t) {
    return this.x = ze(this.x, e, t), this.y = ze(this.y, e, t), this.z = ze(this.z, e, t), this.w = ze(this.w, e, t), this;
  }
  /**
   * If this vector's length is greater than the max value, it is replaced by
   * the max value.
   * If this vector's length is less than the min value, it is replaced by the
   * min value.
   *
   * @param {number} min - The minimum value the vector length will be clamped to.
   * @param {number} max - The maximum value the vector length will be clamped to.
   * @return {Vector4} A reference to this vector.
   */
  clampLength(e, t) {
    const n = this.length();
    return this.divideScalar(n || 1).multiplyScalar(ze(n, e, t));
  }
  /**
   * The components of this vector are rounded down to the nearest integer value.
   *
   * @return {Vector4} A reference to this vector.
   */
  floor() {
    return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this.z = Math.floor(this.z), this.w = Math.floor(this.w), this;
  }
  /**
   * The components of this vector are rounded up to the nearest integer value.
   *
   * @return {Vector4} A reference to this vector.
   */
  ceil() {
    return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this.z = Math.ceil(this.z), this.w = Math.ceil(this.w), this;
  }
  /**
   * The components of this vector are rounded to the nearest integer value
   *
   * @return {Vector4} A reference to this vector.
   */
  round() {
    return this.x = Math.round(this.x), this.y = Math.round(this.y), this.z = Math.round(this.z), this.w = Math.round(this.w), this;
  }
  /**
   * The components of this vector are rounded towards zero (up if negative,
   * down if positive) to an integer value.
   *
   * @return {Vector4} A reference to this vector.
   */
  roundToZero() {
    return this.x = Math.trunc(this.x), this.y = Math.trunc(this.y), this.z = Math.trunc(this.z), this.w = Math.trunc(this.w), this;
  }
  /**
   * Inverts this vector - i.e. sets x = -x, y = -y, z = -z, w = -w.
   *
   * @return {Vector4} A reference to this vector.
   */
  negate() {
    return this.x = -this.x, this.y = -this.y, this.z = -this.z, this.w = -this.w, this;
  }
  /**
   * Calculates the dot product of the given vector with this instance.
   *
   * @param {Vector4} v - The vector to compute the dot product with.
   * @return {number} The result of the dot product.
   */
  dot(e) {
    return this.x * e.x + this.y * e.y + this.z * e.z + this.w * e.w;
  }
  /**
   * Computes the square of the Euclidean length (straight-line length) from
   * (0, 0, 0, 0) to (x, y, z, w). If you are comparing the lengths of vectors, you should
   * compare the length squared instead as it is slightly more efficient to calculate.
   *
   * @return {number} The square length of this vector.
   */
  lengthSq() {
    return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
  }
  /**
   * Computes the  Euclidean length (straight-line length) from (0, 0, 0, 0) to (x, y, z, w).
   *
   * @return {number} The length of this vector.
   */
  length() {
    return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
  }
  /**
   * Computes the Manhattan length of this vector.
   *
   * @return {number} The length of this vector.
   */
  manhattanLength() {
    return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z) + Math.abs(this.w);
  }
  /**
   * Converts this vector to a unit vector - that is, sets it equal to a vector
   * with the same direction as this one, but with a vector length of `1`.
   *
   * @return {Vector4} A reference to this vector.
   */
  normalize() {
    return this.divideScalar(this.length() || 1);
  }
  /**
   * Sets this vector to a vector with the same direction as this one, but
   * with the specified length.
   *
   * @param {number} length - The new length of this vector.
   * @return {Vector4} A reference to this vector.
   */
  setLength(e) {
    return this.normalize().multiplyScalar(e);
  }
  /**
   * Linearly interpolates between the given vector and this instance, where
   * alpha is the percent distance along the line - alpha = 0 will be this
   * vector, and alpha = 1 will be the given one.
   *
   * @param {Vector4} v - The vector to interpolate towards.
   * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
   * @return {Vector4} A reference to this vector.
   */
  lerp(e, t) {
    return this.x += (e.x - this.x) * t, this.y += (e.y - this.y) * t, this.z += (e.z - this.z) * t, this.w += (e.w - this.w) * t, this;
  }
  /**
   * Linearly interpolates between the given vectors, where alpha is the percent
   * distance along the line - alpha = 0 will be first vector, and alpha = 1 will
   * be the second one. The result is stored in this instance.
   *
   * @param {Vector4} v1 - The first vector.
   * @param {Vector4} v2 - The second vector.
   * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
   * @return {Vector4} A reference to this vector.
   */
  lerpVectors(e, t, n) {
    return this.x = e.x + (t.x - e.x) * n, this.y = e.y + (t.y - e.y) * n, this.z = e.z + (t.z - e.z) * n, this.w = e.w + (t.w - e.w) * n, this;
  }
  /**
   * Returns `true` if this vector is equal with the given one.
   *
   * @param {Vector4} v - The vector to test for equality.
   * @return {boolean} Whether this vector is equal with the given one.
   */
  equals(e) {
    return e.x === this.x && e.y === this.y && e.z === this.z && e.w === this.w;
  }
  /**
   * Sets this vector's x value to be `array[ offset ]`, y value to be `array[ offset + 1 ]`,
   * z value to be `array[ offset + 2 ]`, w value to be `array[ offset + 3 ]`.
   *
   * @param {Array<number>} array - An array holding the vector component values.
   * @param {number} [offset=0] - The offset into the array.
   * @return {Vector4} A reference to this vector.
   */
  fromArray(e, t = 0) {
    return this.x = e[t], this.y = e[t + 1], this.z = e[t + 2], this.w = e[t + 3], this;
  }
  /**
   * Writes the components of this vector to the given array. If no array is provided,
   * the method returns a new instance.
   *
   * @param {Array<number>} [array=[]] - The target array holding the vector components.
   * @param {number} [offset=0] - Index of the first element in the array.
   * @return {Array<number>} The vector components.
   */
  toArray(e = [], t = 0) {
    return e[t] = this.x, e[t + 1] = this.y, e[t + 2] = this.z, e[t + 3] = this.w, e;
  }
  /**
   * Sets the components of this vector from the given buffer attribute.
   *
   * @param {BufferAttribute} attribute - The buffer attribute holding vector data.
   * @param {number} index - The index into the attribute.
   * @return {Vector4} A reference to this vector.
   */
  fromBufferAttribute(e, t) {
    return this.x = e.getX(t), this.y = e.getY(t), this.z = e.getZ(t), this.w = e.getW(t), this;
  }
  /**
   * Sets each component of this vector to a pseudo-random value between `0` and
   * `1`, excluding `1`.
   *
   * @return {Vector4} A reference to this vector.
   */
  random() {
    return this.x = Math.random(), this.y = Math.random(), this.z = Math.random(), this.w = Math.random(), this;
  }
  *[Symbol.iterator]() {
    yield this.x, yield this.y, yield this.z, yield this.w;
  }
}
class ih extends lr {
  /**
   * Render target options.
   *
   * @typedef {Object} RenderTarget~Options
   * @property {boolean} [generateMipmaps=false] - Whether to generate mipmaps or not.
   * @property {number} [magFilter=LinearFilter] - The mag filter.
   * @property {number} [minFilter=LinearFilter] - The min filter.
   * @property {number} [format=RGBAFormat] - The texture format.
   * @property {number} [type=UnsignedByteType] - The texture type.
   * @property {?string} [internalFormat=null] - The texture's internal format.
   * @property {number} [wrapS=ClampToEdgeWrapping] - The texture's uv wrapping mode.
   * @property {number} [wrapT=ClampToEdgeWrapping] - The texture's uv wrapping mode.
   * @property {number} [anisotropy=1] - The texture's anisotropy value.
   * @property {string} [colorSpace=NoColorSpace] - The texture's color space.
   * @property {boolean} [depthBuffer=true] - Whether to allocate a depth buffer or not.
   * @property {boolean} [stencilBuffer=false] - Whether to allocate a stencil buffer or not.
   * @property {boolean} [resolveDepthBuffer=true] - Whether to resolve the depth buffer or not.
   * @property {boolean} [resolveStencilBuffer=true] - Whether  to resolve the stencil buffer or not.
   * @property {?Texture} [depthTexture=null] - Reference to a depth texture.
   * @property {number} [samples=0] - The MSAA samples count.
   * @property {number} [count=1] - Defines the number of color attachments . Must be at least `1`.
   * @property {number} [depth=1] - The texture depth.
   * @property {boolean} [multiview=false] - Whether this target is used for multiview rendering.
   */
  /**
   * Constructs a new render target.
   *
   * @param {number} [width=1] - The width of the render target.
   * @param {number} [height=1] - The height of the render target.
   * @param {RenderTarget~Options} [options] - The configuration object.
   */
  constructor(e = 1, t = 1, n = {}) {
    super(), n = Object.assign({
      generateMipmaps: !1,
      internalFormat: null,
      minFilter: 1006,
      depthBuffer: !0,
      stencilBuffer: !1,
      resolveDepthBuffer: !0,
      resolveStencilBuffer: !0,
      depthTexture: null,
      samples: 0,
      count: 1,
      depth: 1,
      multiview: !1
    }, n), this.isRenderTarget = !0, this.width = e, this.height = t, this.depth = n.depth, this.scissor = new xt(0, 0, e, t), this.scissorTest = !1, this.viewport = new xt(0, 0, e, t);
    const i = { width: e, height: t, depth: n.depth }, s = new bt(i);
    this.textures = [];
    const a = n.count;
    for (let o = 0; o < a; o++)
      this.textures[o] = s.clone(), this.textures[o].isRenderTargetTexture = !0, this.textures[o].renderTarget = this;
    this._setTextureOptions(n), this.depthBuffer = n.depthBuffer, this.stencilBuffer = n.stencilBuffer, this.resolveDepthBuffer = n.resolveDepthBuffer, this.resolveStencilBuffer = n.resolveStencilBuffer, this._depthTexture = null, this.depthTexture = n.depthTexture, this.samples = n.samples, this.multiview = n.multiview;
  }
  _setTextureOptions(e = {}) {
    const t = {
      minFilter: 1006,
      generateMipmaps: !1,
      flipY: !1,
      internalFormat: null
    };
    e.mapping !== void 0 && (t.mapping = e.mapping), e.wrapS !== void 0 && (t.wrapS = e.wrapS), e.wrapT !== void 0 && (t.wrapT = e.wrapT), e.wrapR !== void 0 && (t.wrapR = e.wrapR), e.magFilter !== void 0 && (t.magFilter = e.magFilter), e.minFilter !== void 0 && (t.minFilter = e.minFilter), e.format !== void 0 && (t.format = e.format), e.type !== void 0 && (t.type = e.type), e.anisotropy !== void 0 && (t.anisotropy = e.anisotropy), e.colorSpace !== void 0 && (t.colorSpace = e.colorSpace), e.flipY !== void 0 && (t.flipY = e.flipY), e.generateMipmaps !== void 0 && (t.generateMipmaps = e.generateMipmaps), e.internalFormat !== void 0 && (t.internalFormat = e.internalFormat);
    for (let n = 0; n < this.textures.length; n++)
      this.textures[n].setValues(t);
  }
  /**
   * The texture representing the default color attachment.
   *
   * @type {Texture}
   */
  get texture() {
    return this.textures[0];
  }
  set texture(e) {
    this.textures[0] = e;
  }
  set depthTexture(e) {
    this._depthTexture !== null && (this._depthTexture.renderTarget = null), e !== null && (e.renderTarget = this), this._depthTexture = e;
  }
  /**
   * Instead of saving the depth in a renderbuffer, a texture
   * can be used instead which is useful for further processing
   * e.g. in context of post-processing.
   *
   * @type {?DepthTexture}
   * @default null
   */
  get depthTexture() {
    return this._depthTexture;
  }
  /**
   * Sets the size of this render target.
   *
   * @param {number} width - The width.
   * @param {number} height - The height.
   * @param {number} [depth=1] - The depth.
   */
  setSize(e, t, n = 1) {
    if (this.width !== e || this.height !== t || this.depth !== n) {
      this.width = e, this.height = t, this.depth = n;
      for (let i = 0, s = this.textures.length; i < s; i++)
        this.textures[i].image.width = e, this.textures[i].image.height = t, this.textures[i].image.depth = n, this.textures[i].isData3DTexture !== !0 && (this.textures[i].isArrayTexture = this.textures[i].image.depth > 1);
      this.dispose();
    }
    this.viewport.set(0, 0, e, t), this.scissor.set(0, 0, e, t);
  }
  /**
   * Returns a new render target with copied values from this instance.
   *
   * @return {RenderTarget} A clone of this instance.
   */
  clone() {
    return new this.constructor().copy(this);
  }
  /**
   * Copies the settings of the given render target. This is a structural copy so
   * no resources are shared between render targets after the copy. That includes
   * all MRT textures and the depth texture.
   *
   * @param {RenderTarget} source - The render target to copy.
   * @return {RenderTarget} A reference to this instance.
   */
  copy(e) {
    this.width = e.width, this.height = e.height, this.depth = e.depth, this.scissor.copy(e.scissor), this.scissorTest = e.scissorTest, this.viewport.copy(e.viewport), this.textures.length = 0;
    for (let t = 0, n = e.textures.length; t < n; t++) {
      this.textures[t] = e.textures[t].clone(), this.textures[t].isRenderTargetTexture = !0, this.textures[t].renderTarget = this;
      const i = Object.assign({}, e.textures[t].image);
      this.textures[t].source = new ao(i);
    }
    return this.depthBuffer = e.depthBuffer, this.stencilBuffer = e.stencilBuffer, this.resolveDepthBuffer = e.resolveDepthBuffer, this.resolveStencilBuffer = e.resolveStencilBuffer, e.depthTexture !== null && (this.depthTexture = e.depthTexture.clone()), this.samples = e.samples, this;
  }
  /**
   * Frees the GPU-related resources allocated by this instance. Call this
   * method whenever this instance is no longer used in your app.
   *
   * @fires RenderTarget#dispose
   */
  dispose() {
    this.dispatchEvent({ type: "dispose" });
  }
}
class Cn extends ih {
  /**
   * Constructs a new 3D render target.
   *
   * @param {number} [width=1] - The width of the render target.
   * @param {number} [height=1] - The height of the render target.
   * @param {RenderTarget~Options} [options] - The configuration object.
   */
  constructor(e = 1, t = 1, n = {}) {
    super(e, t, n), this.isWebGLRenderTarget = !0;
  }
}
class ac extends bt {
  /**
   * Constructs a new data array texture.
   *
   * @param {?TypedArray} [data=null] - The buffer data.
   * @param {number} [width=1] - The width of the texture.
   * @param {number} [height=1] - The height of the texture.
   * @param {number} [depth=1] - The depth of the texture.
   */
  constructor(e = null, t = 1, n = 1, i = 1) {
    super(null), this.isDataArrayTexture = !0, this.image = { data: e, width: t, height: n, depth: i }, this.magFilter = 1003, this.minFilter = 1003, this.wrapR = 1001, this.generateMipmaps = !1, this.flipY = !1, this.unpackAlignment = 1, this.layerUpdates = /* @__PURE__ */ new Set();
  }
  /**
   * Describes that a specific layer of the texture needs to be updated.
   * Normally when {@link Texture#needsUpdate} is set to `true`, the
   * entire data texture array is sent to the GPU. Marking specific
   * layers will only transmit subsets of all mipmaps associated with a
   * specific depth in the array which is often much more performant.
   *
   * @param {number} layerIndex - The layer index that should be updated.
   */
  addLayerUpdate(e) {
    this.layerUpdates.add(e);
  }
  /**
   * Resets the layer updates registry.
   */
  clearLayerUpdates() {
    this.layerUpdates.clear();
  }
}
class rh extends bt {
  /**
   * Constructs a new data array texture.
   *
   * @param {?TypedArray} [data=null] - The buffer data.
   * @param {number} [width=1] - The width of the texture.
   * @param {number} [height=1] - The height of the texture.
   * @param {number} [depth=1] - The depth of the texture.
   */
  constructor(e = null, t = 1, n = 1, i = 1) {
    super(null), this.isData3DTexture = !0, this.image = { data: e, width: t, height: n, depth: i }, this.magFilter = 1003, this.minFilter = 1003, this.wrapR = 1001, this.generateMipmaps = !1, this.flipY = !1, this.unpackAlignment = 1;
  }
}
class qr {
  /**
   * Constructs a new bounding box.
   *
   * @param {Vector3} [min=(Infinity,Infinity,Infinity)] - A vector representing the lower boundary of the box.
   * @param {Vector3} [max=(-Infinity,-Infinity,-Infinity)] - A vector representing the upper boundary of the box.
   */
  constructor(e = new I(1 / 0, 1 / 0, 1 / 0), t = new I(-1 / 0, -1 / 0, -1 / 0)) {
    this.isBox3 = !0, this.min = e, this.max = t;
  }
  /**
   * Sets the lower and upper boundaries of this box.
   * Please note that this method only copies the values from the given objects.
   *
   * @param {Vector3} min - The lower boundary of the box.
   * @param {Vector3} max - The upper boundary of the box.
   * @return {Box3} A reference to this bounding box.
   */
  set(e, t) {
    return this.min.copy(e), this.max.copy(t), this;
  }
  /**
   * Sets the upper and lower bounds of this box so it encloses the position data
   * in the given array.
   *
   * @param {Array<number>} array - An array holding 3D position data.
   * @return {Box3} A reference to this bounding box.
   */
  setFromArray(e) {
    this.makeEmpty();
    for (let t = 0, n = e.length; t < n; t += 3)
      this.expandByPoint(xn.fromArray(e, t));
    return this;
  }
  /**
   * Sets the upper and lower bounds of this box so it encloses the position data
   * in the given buffer attribute.
   *
   * @param {BufferAttribute} attribute - A buffer attribute holding 3D position data.
   * @return {Box3} A reference to this bounding box.
   */
  setFromBufferAttribute(e) {
    this.makeEmpty();
    for (let t = 0, n = e.count; t < n; t++)
      this.expandByPoint(xn.fromBufferAttribute(e, t));
    return this;
  }
  /**
   * Sets the upper and lower bounds of this box so it encloses the position data
   * in the given array.
   *
   * @param {Array<Vector3>} points - An array holding 3D position data as instances of {@link Vector3}.
   * @return {Box3} A reference to this bounding box.
   */
  setFromPoints(e) {
    this.makeEmpty();
    for (let t = 0, n = e.length; t < n; t++)
      this.expandByPoint(e[t]);
    return this;
  }
  /**
   * Centers this box on the given center vector and sets this box's width, height and
   * depth to the given size values.
   *
   * @param {Vector3} center - The center of the box.
   * @param {Vector3} size - The x, y and z dimensions of the box.
   * @return {Box3} A reference to this bounding box.
   */
  setFromCenterAndSize(e, t) {
    const n = xn.copy(t).multiplyScalar(0.5);
    return this.min.copy(e).sub(n), this.max.copy(e).add(n), this;
  }
  /**
   * Computes the world-axis-aligned bounding box for the given 3D object
   * (including its children), accounting for the object's, and children's,
   * world transforms. The function may result in a larger box than strictly necessary.
   *
   * @param {Object3D} object - The 3D object to compute the bounding box for.
   * @param {boolean} [precise=false] - If set to `true`, the method computes the smallest
   * world-axis-aligned bounding box at the expense of more computation.
   * @return {Box3} A reference to this bounding box.
   */
  setFromObject(e, t = !1) {
    return this.makeEmpty(), this.expandByObject(e, t);
  }
  /**
   * Returns a new box with copied values from this instance.
   *
   * @return {Box3} A clone of this instance.
   */
  clone() {
    return new this.constructor().copy(this);
  }
  /**
   * Copies the values of the given box to this instance.
   *
   * @param {Box3} box - The box to copy.
   * @return {Box3} A reference to this bounding box.
   */
  copy(e) {
    return this.min.copy(e.min), this.max.copy(e.max), this;
  }
  /**
   * Makes this box empty which means in encloses a zero space in 3D.
   *
   * @return {Box3} A reference to this bounding box.
   */
  makeEmpty() {
    return this.min.x = this.min.y = this.min.z = 1 / 0, this.max.x = this.max.y = this.max.z = -1 / 0, this;
  }
  /**
   * Returns true if this box includes zero points within its bounds.
   * Note that a box with equal lower and upper bounds still includes one
   * point, the one both bounds share.
   *
   * @return {boolean} Whether this box is empty or not.
   */
  isEmpty() {
    return this.max.x < this.min.x || this.max.y < this.min.y || this.max.z < this.min.z;
  }
  /**
   * Returns the center point of this box.
   *
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} The center point.
   */
  getCenter(e) {
    return this.isEmpty() ? e.set(0, 0, 0) : e.addVectors(this.min, this.max).multiplyScalar(0.5);
  }
  /**
   * Returns the dimensions of this box.
   *
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} The size.
   */
  getSize(e) {
    return this.isEmpty() ? e.set(0, 0, 0) : e.subVectors(this.max, this.min);
  }
  /**
   * Expands the boundaries of this box to include the given point.
   *
   * @param {Vector3} point - The point that should be included by the bounding box.
   * @return {Box3} A reference to this bounding box.
   */
  expandByPoint(e) {
    return this.min.min(e), this.max.max(e), this;
  }
  /**
   * Expands this box equilaterally by the given vector. The width of this
   * box will be expanded by the x component of the vector in both
   * directions. The height of this box will be expanded by the y component of
   * the vector in both directions. The depth of this box will be
   * expanded by the z component of the vector in both directions.
   *
   * @param {Vector3} vector - The vector that should expand the bounding box.
   * @return {Box3} A reference to this bounding box.
   */
  expandByVector(e) {
    return this.min.sub(e), this.max.add(e), this;
  }
  /**
   * Expands each dimension of the box by the given scalar. If negative, the
   * dimensions of the box will be contracted.
   *
   * @param {number} scalar - The scalar value that should expand the bounding box.
   * @return {Box3} A reference to this bounding box.
   */
  expandByScalar(e) {
    return this.min.addScalar(-e), this.max.addScalar(e), this;
  }
  /**
   * Expands the boundaries of this box to include the given 3D object and
   * its children, accounting for the object's, and children's, world
   * transforms. The function may result in a larger box than strictly
   * necessary (unless the precise parameter is set to true).
   *
   * @param {Object3D} object - The 3D object that should expand the bounding box.
   * @param {boolean} precise - If set to `true`, the method expands the bounding box
   * as little as necessary at the expense of more computation.
   * @return {Box3} A reference to this bounding box.
   */
  expandByObject(e, t = !1) {
    e.updateWorldMatrix(!1, !1);
    const n = e.geometry;
    if (n !== void 0) {
      const s = n.getAttribute("position");
      if (t === !0 && s !== void 0 && e.isInstancedMesh !== !0)
        for (let a = 0, o = s.count; a < o; a++)
          e.isMesh === !0 ? e.getVertexPosition(a, xn) : xn.fromBufferAttribute(s, a), xn.applyMatrix4(e.matrixWorld), this.expandByPoint(xn);
      else
        e.boundingBox !== void 0 ? (e.boundingBox === null && e.computeBoundingBox(), Jr.copy(e.boundingBox)) : (n.boundingBox === null && n.computeBoundingBox(), Jr.copy(n.boundingBox)), Jr.applyMatrix4(e.matrixWorld), this.union(Jr);
    }
    const i = e.children;
    for (let s = 0, a = i.length; s < a; s++)
      this.expandByObject(i[s], t);
    return this;
  }
  /**
   * Returns `true` if the given point lies within or on the boundaries of this box.
   *
   * @param {Vector3} point - The point to test.
   * @return {boolean} Whether the bounding box contains the given point or not.
   */
  containsPoint(e) {
    return e.x >= this.min.x && e.x <= this.max.x && e.y >= this.min.y && e.y <= this.max.y && e.z >= this.min.z && e.z <= this.max.z;
  }
  /**
   * Returns `true` if this bounding box includes the entirety of the given bounding box.
   * If this box and the given one are identical, this function also returns `true`.
   *
   * @param {Box3} box - The bounding box to test.
   * @return {boolean} Whether the bounding box contains the given bounding box or not.
   */
  containsBox(e) {
    return this.min.x <= e.min.x && e.max.x <= this.max.x && this.min.y <= e.min.y && e.max.y <= this.max.y && this.min.z <= e.min.z && e.max.z <= this.max.z;
  }
  /**
   * Returns a point as a proportion of this box's width, height and depth.
   *
   * @param {Vector3} point - A point in 3D space.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} A point as a proportion of this box's width, height and depth.
   */
  getParameter(e, t) {
    return t.set(
      (e.x - this.min.x) / (this.max.x - this.min.x),
      (e.y - this.min.y) / (this.max.y - this.min.y),
      (e.z - this.min.z) / (this.max.z - this.min.z)
    );
  }
  /**
   * Returns `true` if the given bounding box intersects with this bounding box.
   *
   * @param {Box3} box - The bounding box to test.
   * @return {boolean} Whether the given bounding box intersects with this bounding box.
   */
  intersectsBox(e) {
    return e.max.x >= this.min.x && e.min.x <= this.max.x && e.max.y >= this.min.y && e.min.y <= this.max.y && e.max.z >= this.min.z && e.min.z <= this.max.z;
  }
  /**
   * Returns `true` if the given bounding sphere intersects with this bounding box.
   *
   * @param {Sphere} sphere - The bounding sphere to test.
   * @return {boolean} Whether the given bounding sphere intersects with this bounding box.
   */
  intersectsSphere(e) {
    return this.clampPoint(e.center, xn), xn.distanceToSquared(e.center) <= e.radius * e.radius;
  }
  /**
   * Returns `true` if the given plane intersects with this bounding box.
   *
   * @param {Plane} plane - The plane to test.
   * @return {boolean} Whether the given plane intersects with this bounding box.
   */
  intersectsPlane(e) {
    let t, n;
    return e.normal.x > 0 ? (t = e.normal.x * this.min.x, n = e.normal.x * this.max.x) : (t = e.normal.x * this.max.x, n = e.normal.x * this.min.x), e.normal.y > 0 ? (t += e.normal.y * this.min.y, n += e.normal.y * this.max.y) : (t += e.normal.y * this.max.y, n += e.normal.y * this.min.y), e.normal.z > 0 ? (t += e.normal.z * this.min.z, n += e.normal.z * this.max.z) : (t += e.normal.z * this.max.z, n += e.normal.z * this.min.z), t <= -e.constant && n >= -e.constant;
  }
  /**
   * Returns `true` if the given triangle intersects with this bounding box.
   *
   * @param {Triangle} triangle - The triangle to test.
   * @return {boolean} Whether the given triangle intersects with this bounding box.
   */
  intersectsTriangle(e) {
    if (this.isEmpty())
      return !1;
    this.getCenter(hr), Qr.subVectors(this.max, hr), Pi.subVectors(e.a, hr), Di.subVectors(e.b, hr), Li.subVectors(e.c, hr), Xn.subVectors(Di, Pi), qn.subVectors(Li, Di), ui.subVectors(Pi, Li);
    let t = [
      0,
      -Xn.z,
      Xn.y,
      0,
      -qn.z,
      qn.y,
      0,
      -ui.z,
      ui.y,
      Xn.z,
      0,
      -Xn.x,
      qn.z,
      0,
      -qn.x,
      ui.z,
      0,
      -ui.x,
      -Xn.y,
      Xn.x,
      0,
      -qn.y,
      qn.x,
      0,
      -ui.y,
      ui.x,
      0
    ];
    return !aa(t, Pi, Di, Li, Qr) || (t = [1, 0, 0, 0, 1, 0, 0, 0, 1], !aa(t, Pi, Di, Li, Qr)) ? !1 : (es.crossVectors(Xn, qn), t = [es.x, es.y, es.z], aa(t, Pi, Di, Li, Qr));
  }
  /**
   * Clamps the given point within the bounds of this box.
   *
   * @param {Vector3} point - The point to clamp.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} The clamped point.
   */
  clampPoint(e, t) {
    return t.copy(e).clamp(this.min, this.max);
  }
  /**
   * Returns the euclidean distance from any edge of this box to the specified point. If
   * the given point lies inside of this box, the distance will be `0`.
   *
   * @param {Vector3} point - The point to compute the distance to.
   * @return {number} The euclidean distance.
   */
  distanceToPoint(e) {
    return this.clampPoint(e, xn).distanceTo(e);
  }
  /**
   * Returns a bounding sphere that encloses this bounding box.
   *
   * @param {Sphere} target - The target sphere that is used to store the method's result.
   * @return {Sphere} The bounding sphere that encloses this bounding box.
   */
  getBoundingSphere(e) {
    return this.isEmpty() ? e.makeEmpty() : (this.getCenter(e.center), e.radius = this.getSize(xn).length() * 0.5), e;
  }
  /**
   * Computes the intersection of this bounding box and the given one, setting the upper
   * bound of this box to the lesser of the two boxes' upper bounds and the
   * lower bound of this box to the greater of the two boxes' lower bounds. If
   * there's no overlap, makes this box empty.
   *
   * @param {Box3} box - The bounding box to intersect with.
   * @return {Box3} A reference to this bounding box.
   */
  intersect(e) {
    return this.min.max(e.min), this.max.min(e.max), this.isEmpty() && this.makeEmpty(), this;
  }
  /**
   * Computes the union of this box and another and the given one, setting the upper
   * bound of this box to the greater of the two boxes' upper bounds and the
   * lower bound of this box to the lesser of the two boxes' lower bounds.
   *
   * @param {Box3} box - The bounding box that will be unioned with this instance.
   * @return {Box3} A reference to this bounding box.
   */
  union(e) {
    return this.min.min(e.min), this.max.max(e.max), this;
  }
  /**
   * Transforms this bounding box by the given 4x4 transformation matrix.
   *
   * @param {Matrix4} matrix - The transformation matrix.
   * @return {Box3} A reference to this bounding box.
   */
  applyMatrix4(e) {
    return this.isEmpty() ? this : (Fn[0].set(this.min.x, this.min.y, this.min.z).applyMatrix4(e), Fn[1].set(this.min.x, this.min.y, this.max.z).applyMatrix4(e), Fn[2].set(this.min.x, this.max.y, this.min.z).applyMatrix4(e), Fn[3].set(this.min.x, this.max.y, this.max.z).applyMatrix4(e), Fn[4].set(this.max.x, this.min.y, this.min.z).applyMatrix4(e), Fn[5].set(this.max.x, this.min.y, this.max.z).applyMatrix4(e), Fn[6].set(this.max.x, this.max.y, this.min.z).applyMatrix4(e), Fn[7].set(this.max.x, this.max.y, this.max.z).applyMatrix4(e), this.setFromPoints(Fn), this);
  }
  /**
   * Adds the given offset to both the upper and lower bounds of this bounding box,
   * effectively moving it in 3D space.
   *
   * @param {Vector3} offset - The offset that should be used to translate the bounding box.
   * @return {Box3} A reference to this bounding box.
   */
  translate(e) {
    return this.min.add(e), this.max.add(e), this;
  }
  /**
   * Returns `true` if this bounding box is equal with the given one.
   *
   * @param {Box3} box - The box to test for equality.
   * @return {boolean} Whether this bounding box is equal with the given one.
   */
  equals(e) {
    return e.min.equals(this.min) && e.max.equals(this.max);
  }
  /**
   * Returns a serialized structure of the bounding box.
   *
   * @return {Object} Serialized structure with fields representing the object state.
   */
  toJSON() {
    return {
      min: this.min.toArray(),
      max: this.max.toArray()
    };
  }
  /**
   * Returns a serialized structure of the bounding box.
   *
   * @param {Object} json - The serialized json to set the box from.
   * @return {Box3} A reference to this bounding box.
   */
  fromJSON(e) {
    return this.min.fromArray(e.min), this.max.fromArray(e.max), this;
  }
}
const Fn = [
  /* @__PURE__ */ new I(),
  /* @__PURE__ */ new I(),
  /* @__PURE__ */ new I(),
  /* @__PURE__ */ new I(),
  /* @__PURE__ */ new I(),
  /* @__PURE__ */ new I(),
  /* @__PURE__ */ new I(),
  /* @__PURE__ */ new I()
], xn = /* @__PURE__ */ new I(), Jr = /* @__PURE__ */ new qr(), Pi = /* @__PURE__ */ new I(), Di = /* @__PURE__ */ new I(), Li = /* @__PURE__ */ new I(), Xn = /* @__PURE__ */ new I(), qn = /* @__PURE__ */ new I(), ui = /* @__PURE__ */ new I(), hr = /* @__PURE__ */ new I(), Qr = /* @__PURE__ */ new I(), es = /* @__PURE__ */ new I(), hi = /* @__PURE__ */ new I();
function aa(r, e, t, n, i) {
  for (let s = 0, a = r.length - 3; s <= a; s += 3) {
    hi.fromArray(r, s);
    const o = i.x * Math.abs(hi.x) + i.y * Math.abs(hi.y) + i.z * Math.abs(hi.z), c = e.dot(hi), l = t.dot(hi), u = n.dot(hi);
    if (Math.max(-Math.max(c, l, u), Math.min(c, l, u)) > o)
      return !1;
  }
  return !0;
}
const sh = /* @__PURE__ */ new qr(), fr = /* @__PURE__ */ new I(), oa = /* @__PURE__ */ new I();
class Yr {
  /**
   * Constructs a new sphere.
   *
   * @param {Vector3} [center=(0,0,0)] - The center of the sphere
   * @param {number} [radius=-1] - The radius of the sphere.
   */
  constructor(e = new I(), t = -1) {
    this.isSphere = !0, this.center = e, this.radius = t;
  }
  /**
   * Sets the sphere's components by copying the given values.
   *
   * @param {Vector3} center - The center.
   * @param {number} radius - The radius.
   * @return {Sphere} A reference to this sphere.
   */
  set(e, t) {
    return this.center.copy(e), this.radius = t, this;
  }
  /**
   * Computes the minimum bounding sphere for list of points.
   * If the optional center point is given, it is used as the sphere's
   * center. Otherwise, the center of the axis-aligned bounding box
   * encompassing the points is calculated.
   *
   * @param {Array<Vector3>} points - A list of points in 3D space.
   * @param {Vector3} [optionalCenter] - The center of the sphere.
   * @return {Sphere} A reference to this sphere.
   */
  setFromPoints(e, t) {
    const n = this.center;
    t !== void 0 ? n.copy(t) : sh.setFromPoints(e).getCenter(n);
    let i = 0;
    for (let s = 0, a = e.length; s < a; s++)
      i = Math.max(i, n.distanceToSquared(e[s]));
    return this.radius = Math.sqrt(i), this;
  }
  /**
   * Copies the values of the given sphere to this instance.
   *
   * @param {Sphere} sphere - The sphere to copy.
   * @return {Sphere} A reference to this sphere.
   */
  copy(e) {
    return this.center.copy(e.center), this.radius = e.radius, this;
  }
  /**
   * Returns `true` if the sphere is empty (the radius set to a negative number).
   *
   * Spheres with a radius of `0` contain only their center point and are not
   * considered to be empty.
   *
   * @return {boolean} Whether this sphere is empty or not.
   */
  isEmpty() {
    return this.radius < 0;
  }
  /**
   * Makes this sphere empty which means in encloses a zero space in 3D.
   *
   * @return {Sphere} A reference to this sphere.
   */
  makeEmpty() {
    return this.center.set(0, 0, 0), this.radius = -1, this;
  }
  /**
   * Returns `true` if this sphere contains the given point inclusive of
   * the surface of the sphere.
   *
   * @param {Vector3} point - The point to check.
   * @return {boolean} Whether this sphere contains the given point or not.
   */
  containsPoint(e) {
    return e.distanceToSquared(this.center) <= this.radius * this.radius;
  }
  /**
   * Returns the closest distance from the boundary of the sphere to the
   * given point. If the sphere contains the point, the distance will
   * be negative.
   *
   * @param {Vector3} point - The point to compute the distance to.
   * @return {number} The distance to the point.
   */
  distanceToPoint(e) {
    return e.distanceTo(this.center) - this.radius;
  }
  /**
   * Returns `true` if this sphere intersects with the given one.
   *
   * @param {Sphere} sphere - The sphere to test.
   * @return {boolean} Whether this sphere intersects with the given one or not.
   */
  intersectsSphere(e) {
    const t = this.radius + e.radius;
    return e.center.distanceToSquared(this.center) <= t * t;
  }
  /**
   * Returns `true` if this sphere intersects with the given box.
   *
   * @param {Box3} box - The box to test.
   * @return {boolean} Whether this sphere intersects with the given box or not.
   */
  intersectsBox(e) {
    return e.intersectsSphere(this);
  }
  /**
   * Returns `true` if this sphere intersects with the given plane.
   *
   * @param {Plane} plane - The plane to test.
   * @return {boolean} Whether this sphere intersects with the given plane or not.
   */
  intersectsPlane(e) {
    return Math.abs(e.distanceToPoint(this.center)) <= this.radius;
  }
  /**
   * Clamps a point within the sphere. If the point is outside the sphere, it
   * will clamp it to the closest point on the edge of the sphere. Points
   * already inside the sphere will not be affected.
   *
   * @param {Vector3} point - The plane to clamp.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} The clamped point.
   */
  clampPoint(e, t) {
    const n = this.center.distanceToSquared(e);
    return t.copy(e), n > this.radius * this.radius && (t.sub(this.center).normalize(), t.multiplyScalar(this.radius).add(this.center)), t;
  }
  /**
   * Returns a bounding box that encloses this sphere.
   *
   * @param {Box3} target - The target box that is used to store the method's result.
   * @return {Box3} The bounding box that encloses this sphere.
   */
  getBoundingBox(e) {
    return this.isEmpty() ? (e.makeEmpty(), e) : (e.set(this.center, this.center), e.expandByScalar(this.radius), e);
  }
  /**
   * Transforms this sphere with the given 4x4 transformation matrix.
   *
   * @param {Matrix4} matrix - The transformation matrix.
   * @return {Sphere} A reference to this sphere.
   */
  applyMatrix4(e) {
    return this.center.applyMatrix4(e), this.radius = this.radius * e.getMaxScaleOnAxis(), this;
  }
  /**
   * Translates the sphere's center by the given offset.
   *
   * @param {Vector3} offset - The offset.
   * @return {Sphere} A reference to this sphere.
   */
  translate(e) {
    return this.center.add(e), this;
  }
  /**
   * Expands the boundaries of this sphere to include the given point.
   *
   * @param {Vector3} point - The point to include.
   * @return {Sphere} A reference to this sphere.
   */
  expandByPoint(e) {
    if (this.isEmpty())
      return this.center.copy(e), this.radius = 0, this;
    fr.subVectors(e, this.center);
    const t = fr.lengthSq();
    if (t > this.radius * this.radius) {
      const n = Math.sqrt(t), i = (n - this.radius) * 0.5;
      this.center.addScaledVector(fr, i / n), this.radius += i;
    }
    return this;
  }
  /**
   * Expands this sphere to enclose both the original sphere and the given sphere.
   *
   * @param {Sphere} sphere - The sphere to include.
   * @return {Sphere} A reference to this sphere.
   */
  union(e) {
    return e.isEmpty() ? this : this.isEmpty() ? (this.copy(e), this) : (this.center.equals(e.center) === !0 ? this.radius = Math.max(this.radius, e.radius) : (oa.subVectors(e.center, this.center).setLength(e.radius), this.expandByPoint(fr.copy(e.center).add(oa)), this.expandByPoint(fr.copy(e.center).sub(oa))), this);
  }
  /**
   * Returns `true` if this sphere is equal with the given one.
   *
   * @param {Sphere} sphere - The sphere to test for equality.
   * @return {boolean} Whether this bounding sphere is equal with the given one.
   */
  equals(e) {
    return e.center.equals(this.center) && e.radius === this.radius;
  }
  /**
   * Returns a new sphere with copied values from this instance.
   *
   * @return {Sphere} A clone of this instance.
   */
  clone() {
    return new this.constructor().copy(this);
  }
  /**
   * Returns a serialized structure of the bounding sphere.
   *
   * @return {Object} Serialized structure with fields representing the object state.
   */
  toJSON() {
    return {
      radius: this.radius,
      center: this.center.toArray()
    };
  }
  /**
   * Returns a serialized structure of the bounding sphere.
   *
   * @param {Object} json - The serialized json to set the sphere from.
   * @return {Sphere} A reference to this bounding sphere.
   */
  fromJSON(e) {
    return this.radius = e.radius, this.center.fromArray(e.center), this;
  }
}
const Un = /* @__PURE__ */ new I(), la = /* @__PURE__ */ new I(), ts = /* @__PURE__ */ new I(), Yn = /* @__PURE__ */ new I(), ca = /* @__PURE__ */ new I(), ns = /* @__PURE__ */ new I(), ua = /* @__PURE__ */ new I();
class oo {
  /**
   * Constructs a new ray.
   *
   * @param {Vector3} [origin=(0,0,0)] - The origin of the ray.
   * @param {Vector3} [direction=(0,0,-1)] - The (normalized) direction of the ray.
   */
  constructor(e = new I(), t = new I(0, 0, -1)) {
    this.origin = e, this.direction = t;
  }
  /**
   * Sets the ray's components by copying the given values.
   *
   * @param {Vector3} origin - The origin.
   * @param {Vector3} direction - The direction.
   * @return {Ray} A reference to this ray.
   */
  set(e, t) {
    return this.origin.copy(e), this.direction.copy(t), this;
  }
  /**
   * Copies the values of the given ray to this instance.
   *
   * @param {Ray} ray - The ray to copy.
   * @return {Ray} A reference to this ray.
   */
  copy(e) {
    return this.origin.copy(e.origin), this.direction.copy(e.direction), this;
  }
  /**
   * Returns a vector that is located at a given distance along this ray.
   *
   * @param {number} t - The distance along the ray to retrieve a position for.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} A position on the ray.
   */
  at(e, t) {
    return t.copy(this.origin).addScaledVector(this.direction, e);
  }
  /**
   * Adjusts the direction of the ray to point at the given vector in world space.
   *
   * @param {Vector3} v - The target position.
   * @return {Ray} A reference to this ray.
   */
  lookAt(e) {
    return this.direction.copy(e).sub(this.origin).normalize(), this;
  }
  /**
   * Shift the origin of this ray along its direction by the given distance.
   *
   * @param {number} t - The distance along the ray to interpolate.
   * @return {Ray} A reference to this ray.
   */
  recast(e) {
    return this.origin.copy(this.at(e, Un)), this;
  }
  /**
   * Returns the point along this ray that is closest to the given point.
   *
   * @param {Vector3} point - A point in 3D space to get the closet location on the ray for.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} The closest point on this ray.
   */
  closestPointToPoint(e, t) {
    t.subVectors(e, this.origin);
    const n = t.dot(this.direction);
    return n < 0 ? t.copy(this.origin) : t.copy(this.origin).addScaledVector(this.direction, n);
  }
  /**
   * Returns the distance of the closest approach between this ray and the given point.
   *
   * @param {Vector3} point - A point in 3D space to compute the distance to.
   * @return {number} The distance.
   */
  distanceToPoint(e) {
    return Math.sqrt(this.distanceSqToPoint(e));
  }
  /**
   * Returns the squared distance of the closest approach between this ray and the given point.
   *
   * @param {Vector3} point - A point in 3D space to compute the distance to.
   * @return {number} The squared distance.
   */
  distanceSqToPoint(e) {
    const t = Un.subVectors(e, this.origin).dot(this.direction);
    return t < 0 ? this.origin.distanceToSquared(e) : (Un.copy(this.origin).addScaledVector(this.direction, t), Un.distanceToSquared(e));
  }
  /**
   * Returns the squared distance between this ray and the given line segment.
   *
   * @param {Vector3} v0 - The start point of the line segment.
   * @param {Vector3} v1 - The end point of the line segment.
   * @param {Vector3} [optionalPointOnRay] - When provided, it receives the point on this ray that is closest to the segment.
   * @param {Vector3} [optionalPointOnSegment] - When provided, it receives the point on the line segment that is closest to this ray.
   * @return {number} The squared distance.
   */
  distanceSqToSegment(e, t, n, i) {
    la.copy(e).add(t).multiplyScalar(0.5), ts.copy(t).sub(e).normalize(), Yn.copy(this.origin).sub(la);
    const s = e.distanceTo(t) * 0.5, a = -this.direction.dot(ts), o = Yn.dot(this.direction), c = -Yn.dot(ts), l = Yn.lengthSq(), u = Math.abs(1 - a * a);
    let h, f, d, g;
    if (u > 0)
      if (h = a * c - o, f = a * o - c, g = s * u, h >= 0)
        if (f >= -g)
          if (f <= g) {
            const _ = 1 / u;
            h *= _, f *= _, d = h * (h + a * f + 2 * o) + f * (a * h + f + 2 * c) + l;
          } else
            f = s, h = Math.max(0, -(a * f + o)), d = -h * h + f * (f + 2 * c) + l;
        else
          f = -s, h = Math.max(0, -(a * f + o)), d = -h * h + f * (f + 2 * c) + l;
      else
        f <= -g ? (h = Math.max(0, -(-a * s + o)), f = h > 0 ? -s : Math.min(Math.max(-s, -c), s), d = -h * h + f * (f + 2 * c) + l) : f <= g ? (h = 0, f = Math.min(Math.max(-s, -c), s), d = f * (f + 2 * c) + l) : (h = Math.max(0, -(a * s + o)), f = h > 0 ? s : Math.min(Math.max(-s, -c), s), d = -h * h + f * (f + 2 * c) + l);
    else
      f = a > 0 ? -s : s, h = Math.max(0, -(a * f + o)), d = -h * h + f * (f + 2 * c) + l;
    return n && n.copy(this.origin).addScaledVector(this.direction, h), i && i.copy(la).addScaledVector(ts, f), d;
  }
  /**
   * Intersects this ray with the given sphere, returning the intersection
   * point or `null` if there is no intersection.
   *
   * @param {Sphere} sphere - The sphere to intersect.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {?Vector3} The intersection point.
   */
  intersectSphere(e, t) {
    Un.subVectors(e.center, this.origin);
    const n = Un.dot(this.direction), i = Un.dot(Un) - n * n, s = e.radius * e.radius;
    if (i > s) return null;
    const a = Math.sqrt(s - i), o = n - a, c = n + a;
    return c < 0 ? null : o < 0 ? this.at(c, t) : this.at(o, t);
  }
  /**
   * Returns `true` if this ray intersects with the given sphere.
   *
   * @param {Sphere} sphere - The sphere to intersect.
   * @return {boolean} Whether this ray intersects with the given sphere or not.
   */
  intersectsSphere(e) {
    return e.radius < 0 ? !1 : this.distanceSqToPoint(e.center) <= e.radius * e.radius;
  }
  /**
   * Computes the distance from the ray's origin to the given plane. Returns `null` if the ray
   * does not intersect with the plane.
   *
   * @param {Plane} plane - The plane to compute the distance to.
   * @return {?number} Whether this ray intersects with the given sphere or not.
   */
  distanceToPlane(e) {
    const t = e.normal.dot(this.direction);
    if (t === 0)
      return e.distanceToPoint(this.origin) === 0 ? 0 : null;
    const n = -(this.origin.dot(e.normal) + e.constant) / t;
    return n >= 0 ? n : null;
  }
  /**
   * Intersects this ray with the given plane, returning the intersection
   * point or `null` if there is no intersection.
   *
   * @param {Plane} plane - The plane to intersect.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {?Vector3} The intersection point.
   */
  intersectPlane(e, t) {
    const n = this.distanceToPlane(e);
    return n === null ? null : this.at(n, t);
  }
  /**
   * Returns `true` if this ray intersects with the given plane.
   *
   * @param {Plane} plane - The plane to intersect.
   * @return {boolean} Whether this ray intersects with the given plane or not.
   */
  intersectsPlane(e) {
    const t = e.distanceToPoint(this.origin);
    return t === 0 || e.normal.dot(this.direction) * t < 0;
  }
  /**
   * Intersects this ray with the given bounding box, returning the intersection
   * point or `null` if there is no intersection.
   *
   * @param {Box3} box - The box to intersect.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {?Vector3} The intersection point.
   */
  intersectBox(e, t) {
    let n, i, s, a, o, c;
    const l = 1 / this.direction.x, u = 1 / this.direction.y, h = 1 / this.direction.z, f = this.origin;
    return l >= 0 ? (n = (e.min.x - f.x) * l, i = (e.max.x - f.x) * l) : (n = (e.max.x - f.x) * l, i = (e.min.x - f.x) * l), u >= 0 ? (s = (e.min.y - f.y) * u, a = (e.max.y - f.y) * u) : (s = (e.max.y - f.y) * u, a = (e.min.y - f.y) * u), n > a || s > i || ((s > n || isNaN(n)) && (n = s), (a < i || isNaN(i)) && (i = a), h >= 0 ? (o = (e.min.z - f.z) * h, c = (e.max.z - f.z) * h) : (o = (e.max.z - f.z) * h, c = (e.min.z - f.z) * h), n > c || o > i) || ((o > n || n !== n) && (n = o), (c < i || i !== i) && (i = c), i < 0) ? null : this.at(n >= 0 ? n : i, t);
  }
  /**
   * Returns `true` if this ray intersects with the given box.
   *
   * @param {Box3} box - The box to intersect.
   * @return {boolean} Whether this ray intersects with the given box or not.
   */
  intersectsBox(e) {
    return this.intersectBox(e, Un) !== null;
  }
  /**
   * Intersects this ray with the given triangle, returning the intersection
   * point or `null` if there is no intersection.
   *
   * @param {Vector3} a - The first vertex of the triangle.
   * @param {Vector3} b - The second vertex of the triangle.
   * @param {Vector3} c - The third vertex of the triangle.
   * @param {boolean} backfaceCulling - Whether to use backface culling or not.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {?Vector3} The intersection point.
   */
  intersectTriangle(e, t, n, i, s) {
    ca.subVectors(t, e), ns.subVectors(n, e), ua.crossVectors(ca, ns);
    let a = this.direction.dot(ua), o;
    if (a > 0) {
      if (i) return null;
      o = 1;
    } else if (a < 0)
      o = -1, a = -a;
    else
      return null;
    Yn.subVectors(this.origin, e);
    const c = o * this.direction.dot(ns.crossVectors(Yn, ns));
    if (c < 0)
      return null;
    const l = o * this.direction.dot(ca.cross(Yn));
    if (l < 0 || c + l > a)
      return null;
    const u = -o * Yn.dot(ua);
    return u < 0 ? null : this.at(u / a, s);
  }
  /**
   * Transforms this ray with the given 4x4 transformation matrix.
   *
   * @param {Matrix4} matrix4 - The transformation matrix.
   * @return {Ray} A reference to this ray.
   */
  applyMatrix4(e) {
    return this.origin.applyMatrix4(e), this.direction.transformDirection(e), this;
  }
  /**
   * Returns `true` if this ray is equal with the given one.
   *
   * @param {Ray} ray - The ray to test for equality.
   * @return {boolean} Whether this ray is equal with the given one.
   */
  equals(e) {
    return e.origin.equals(this.origin) && e.direction.equals(this.direction);
  }
  /**
   * Returns a new ray with copied values from this instance.
   *
   * @return {Ray} A clone of this instance.
   */
  clone() {
    return new this.constructor().copy(this);
  }
}
class ht {
  /**
   * Constructs a new 4x4 matrix. The arguments are supposed to be
   * in row-major order. If no arguments are provided, the constructor
   * initializes the matrix as an identity matrix.
   *
   * @param {number} [n11] - 1-1 matrix element.
   * @param {number} [n12] - 1-2 matrix element.
   * @param {number} [n13] - 1-3 matrix element.
   * @param {number} [n14] - 1-4 matrix element.
   * @param {number} [n21] - 2-1 matrix element.
   * @param {number} [n22] - 2-2 matrix element.
   * @param {number} [n23] - 2-3 matrix element.
   * @param {number} [n24] - 2-4 matrix element.
   * @param {number} [n31] - 3-1 matrix element.
   * @param {number} [n32] - 3-2 matrix element.
   * @param {number} [n33] - 3-3 matrix element.
   * @param {number} [n34] - 3-4 matrix element.
   * @param {number} [n41] - 4-1 matrix element.
   * @param {number} [n42] - 4-2 matrix element.
   * @param {number} [n43] - 4-3 matrix element.
   * @param {number} [n44] - 4-4 matrix element.
   */
  constructor(e, t, n, i, s, a, o, c, l, u, h, f, d, g, _, m) {
    ht.prototype.isMatrix4 = !0, this.elements = [
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    ], e !== void 0 && this.set(e, t, n, i, s, a, o, c, l, u, h, f, d, g, _, m);
  }
  /**
   * Sets the elements of the matrix.The arguments are supposed to be
   * in row-major order.
   *
   * @param {number} [n11] - 1-1 matrix element.
   * @param {number} [n12] - 1-2 matrix element.
   * @param {number} [n13] - 1-3 matrix element.
   * @param {number} [n14] - 1-4 matrix element.
   * @param {number} [n21] - 2-1 matrix element.
   * @param {number} [n22] - 2-2 matrix element.
   * @param {number} [n23] - 2-3 matrix element.
   * @param {number} [n24] - 2-4 matrix element.
   * @param {number} [n31] - 3-1 matrix element.
   * @param {number} [n32] - 3-2 matrix element.
   * @param {number} [n33] - 3-3 matrix element.
   * @param {number} [n34] - 3-4 matrix element.
   * @param {number} [n41] - 4-1 matrix element.
   * @param {number} [n42] - 4-2 matrix element.
   * @param {number} [n43] - 4-3 matrix element.
   * @param {number} [n44] - 4-4 matrix element.
   * @return {Matrix4} A reference to this matrix.
   */
  set(e, t, n, i, s, a, o, c, l, u, h, f, d, g, _, m) {
    const p = this.elements;
    return p[0] = e, p[4] = t, p[8] = n, p[12] = i, p[1] = s, p[5] = a, p[9] = o, p[13] = c, p[2] = l, p[6] = u, p[10] = h, p[14] = f, p[3] = d, p[7] = g, p[11] = _, p[15] = m, this;
  }
  /**
   * Sets this matrix to the 4x4 identity matrix.
   *
   * @return {Matrix4} A reference to this matrix.
   */
  identity() {
    return this.set(
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  /**
   * Returns a matrix with copied values from this instance.
   *
   * @return {Matrix4} A clone of this instance.
   */
  clone() {
    return new ht().fromArray(this.elements);
  }
  /**
   * Copies the values of the given matrix to this instance.
   *
   * @param {Matrix4} m - The matrix to copy.
   * @return {Matrix4} A reference to this matrix.
   */
  copy(e) {
    const t = this.elements, n = e.elements;
    return t[0] = n[0], t[1] = n[1], t[2] = n[2], t[3] = n[3], t[4] = n[4], t[5] = n[5], t[6] = n[6], t[7] = n[7], t[8] = n[8], t[9] = n[9], t[10] = n[10], t[11] = n[11], t[12] = n[12], t[13] = n[13], t[14] = n[14], t[15] = n[15], this;
  }
  /**
   * Copies the translation component of the given matrix
   * into this matrix's translation component.
   *
   * @param {Matrix4} m - The matrix to copy the translation component.
   * @return {Matrix4} A reference to this matrix.
   */
  copyPosition(e) {
    const t = this.elements, n = e.elements;
    return t[12] = n[12], t[13] = n[13], t[14] = n[14], this;
  }
  /**
   * Set the upper 3x3 elements of this matrix to the values of given 3x3 matrix.
   *
   * @param {Matrix3} m - The 3x3 matrix.
   * @return {Matrix4} A reference to this matrix.
   */
  setFromMatrix3(e) {
    const t = e.elements;
    return this.set(
      t[0],
      t[3],
      t[6],
      0,
      t[1],
      t[4],
      t[7],
      0,
      t[2],
      t[5],
      t[8],
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  /**
   * Extracts the basis of this matrix into the three axis vectors provided.
   *
   * @param {Vector3} xAxis - The basis's x axis.
   * @param {Vector3} yAxis - The basis's y axis.
   * @param {Vector3} zAxis - The basis's z axis.
   * @return {Matrix4} A reference to this matrix.
   */
  extractBasis(e, t, n) {
    return this.determinant() === 0 ? (e.set(1, 0, 0), t.set(0, 1, 0), n.set(0, 0, 1), this) : (e.setFromMatrixColumn(this, 0), t.setFromMatrixColumn(this, 1), n.setFromMatrixColumn(this, 2), this);
  }
  /**
   * Sets the given basis vectors to this matrix.
   *
   * @param {Vector3} xAxis - The basis's x axis.
   * @param {Vector3} yAxis - The basis's y axis.
   * @param {Vector3} zAxis - The basis's z axis.
   * @return {Matrix4} A reference to this matrix.
   */
  makeBasis(e, t, n) {
    return this.set(
      e.x,
      t.x,
      n.x,
      0,
      e.y,
      t.y,
      n.y,
      0,
      e.z,
      t.z,
      n.z,
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  /**
   * Extracts the rotation component of the given matrix
   * into this matrix's rotation component.
   *
   * Note: This method does not support reflection matrices.
   *
   * @param {Matrix4} m - The matrix.
   * @return {Matrix4} A reference to this matrix.
   */
  extractRotation(e) {
    if (e.determinant() === 0)
      return this.identity();
    const t = this.elements, n = e.elements, i = 1 / Fi.setFromMatrixColumn(e, 0).length(), s = 1 / Fi.setFromMatrixColumn(e, 1).length(), a = 1 / Fi.setFromMatrixColumn(e, 2).length();
    return t[0] = n[0] * i, t[1] = n[1] * i, t[2] = n[2] * i, t[3] = 0, t[4] = n[4] * s, t[5] = n[5] * s, t[6] = n[6] * s, t[7] = 0, t[8] = n[8] * a, t[9] = n[9] * a, t[10] = n[10] * a, t[11] = 0, t[12] = 0, t[13] = 0, t[14] = 0, t[15] = 1, this;
  }
  /**
   * Sets the rotation component (the upper left 3x3 matrix) of this matrix to
   * the rotation specified by the given Euler angles. The rest of
   * the matrix is set to the identity. Depending on the {@link Euler#order},
   * there are six possible outcomes. See [this page](https://en.wikipedia.org/wiki/Euler_angles#Rotation_matrix)
   * for a complete list.
   *
   * @param {Euler} euler - The Euler angles.
   * @return {Matrix4} A reference to this matrix.
   */
  makeRotationFromEuler(e) {
    const t = this.elements, n = e.x, i = e.y, s = e.z, a = Math.cos(n), o = Math.sin(n), c = Math.cos(i), l = Math.sin(i), u = Math.cos(s), h = Math.sin(s);
    if (e.order === "XYZ") {
      const f = a * u, d = a * h, g = o * u, _ = o * h;
      t[0] = c * u, t[4] = -c * h, t[8] = l, t[1] = d + g * l, t[5] = f - _ * l, t[9] = -o * c, t[2] = _ - f * l, t[6] = g + d * l, t[10] = a * c;
    } else if (e.order === "YXZ") {
      const f = c * u, d = c * h, g = l * u, _ = l * h;
      t[0] = f + _ * o, t[4] = g * o - d, t[8] = a * l, t[1] = a * h, t[5] = a * u, t[9] = -o, t[2] = d * o - g, t[6] = _ + f * o, t[10] = a * c;
    } else if (e.order === "ZXY") {
      const f = c * u, d = c * h, g = l * u, _ = l * h;
      t[0] = f - _ * o, t[4] = -a * h, t[8] = g + d * o, t[1] = d + g * o, t[5] = a * u, t[9] = _ - f * o, t[2] = -a * l, t[6] = o, t[10] = a * c;
    } else if (e.order === "ZYX") {
      const f = a * u, d = a * h, g = o * u, _ = o * h;
      t[0] = c * u, t[4] = g * l - d, t[8] = f * l + _, t[1] = c * h, t[5] = _ * l + f, t[9] = d * l - g, t[2] = -l, t[6] = o * c, t[10] = a * c;
    } else if (e.order === "YZX") {
      const f = a * c, d = a * l, g = o * c, _ = o * l;
      t[0] = c * u, t[4] = _ - f * h, t[8] = g * h + d, t[1] = h, t[5] = a * u, t[9] = -o * u, t[2] = -l * u, t[6] = d * h + g, t[10] = f - _ * h;
    } else if (e.order === "XZY") {
      const f = a * c, d = a * l, g = o * c, _ = o * l;
      t[0] = c * u, t[4] = -h, t[8] = l * u, t[1] = f * h + _, t[5] = a * u, t[9] = d * h - g, t[2] = g * h - d, t[6] = o * u, t[10] = _ * h + f;
    }
    return t[3] = 0, t[7] = 0, t[11] = 0, t[12] = 0, t[13] = 0, t[14] = 0, t[15] = 1, this;
  }
  /**
   * Sets the rotation component of this matrix to the rotation specified by
   * the given Quaternion as outlined [here](https://en.wikipedia.org/wiki/Rotation_matrix#Quaternion)
   * The rest of the matrix is set to the identity.
   *
   * @param {Quaternion} q - The Quaternion.
   * @return {Matrix4} A reference to this matrix.
   */
  makeRotationFromQuaternion(e) {
    return this.compose(ah, e, oh);
  }
  /**
   * Sets the rotation component of the transformation matrix, looking from `eye` towards
   * `target`, and oriented by the up-direction.
   *
   * @param {Vector3} eye - The eye vector.
   * @param {Vector3} target - The target vector.
   * @param {Vector3} up - The up vector.
   * @return {Matrix4} A reference to this matrix.
   */
  lookAt(e, t, n) {
    const i = this.elements;
    return nn.subVectors(e, t), nn.lengthSq() === 0 && (nn.z = 1), nn.normalize(), $n.crossVectors(n, nn), $n.lengthSq() === 0 && (Math.abs(n.z) === 1 ? nn.x += 1e-4 : nn.z += 1e-4, nn.normalize(), $n.crossVectors(n, nn)), $n.normalize(), is.crossVectors(nn, $n), i[0] = $n.x, i[4] = is.x, i[8] = nn.x, i[1] = $n.y, i[5] = is.y, i[9] = nn.y, i[2] = $n.z, i[6] = is.z, i[10] = nn.z, this;
  }
  /**
   * Post-multiplies this matrix by the given 4x4 matrix.
   *
   * @param {Matrix4} m - The matrix to multiply with.
   * @return {Matrix4} A reference to this matrix.
   */
  multiply(e) {
    return this.multiplyMatrices(this, e);
  }
  /**
   * Pre-multiplies this matrix by the given 4x4 matrix.
   *
   * @param {Matrix4} m - The matrix to multiply with.
   * @return {Matrix4} A reference to this matrix.
   */
  premultiply(e) {
    return this.multiplyMatrices(e, this);
  }
  /**
   * Multiples the given 4x4 matrices and stores the result
   * in this matrix.
   *
   * @param {Matrix4} a - The first matrix.
   * @param {Matrix4} b - The second matrix.
   * @return {Matrix4} A reference to this matrix.
   */
  multiplyMatrices(e, t) {
    const n = e.elements, i = t.elements, s = this.elements, a = n[0], o = n[4], c = n[8], l = n[12], u = n[1], h = n[5], f = n[9], d = n[13], g = n[2], _ = n[6], m = n[10], p = n[14], S = n[3], b = n[7], T = n[11], y = n[15], R = i[0], A = i[4], C = i[8], x = i[12], E = i[1], P = i[5], z = i[9], N = i[13], W = i[2], H = i[6], k = i[10], O = i[14], Y = i[3], ae = i[7], ne = i[11], ue = i[15];
    return s[0] = a * R + o * E + c * W + l * Y, s[4] = a * A + o * P + c * H + l * ae, s[8] = a * C + o * z + c * k + l * ne, s[12] = a * x + o * N + c * O + l * ue, s[1] = u * R + h * E + f * W + d * Y, s[5] = u * A + h * P + f * H + d * ae, s[9] = u * C + h * z + f * k + d * ne, s[13] = u * x + h * N + f * O + d * ue, s[2] = g * R + _ * E + m * W + p * Y, s[6] = g * A + _ * P + m * H + p * ae, s[10] = g * C + _ * z + m * k + p * ne, s[14] = g * x + _ * N + m * O + p * ue, s[3] = S * R + b * E + T * W + y * Y, s[7] = S * A + b * P + T * H + y * ae, s[11] = S * C + b * z + T * k + y * ne, s[15] = S * x + b * N + T * O + y * ue, this;
  }
  /**
   * Multiplies every component of the matrix by the given scalar.
   *
   * @param {number} s - The scalar.
   * @return {Matrix4} A reference to this matrix.
   */
  multiplyScalar(e) {
    const t = this.elements;
    return t[0] *= e, t[4] *= e, t[8] *= e, t[12] *= e, t[1] *= e, t[5] *= e, t[9] *= e, t[13] *= e, t[2] *= e, t[6] *= e, t[10] *= e, t[14] *= e, t[3] *= e, t[7] *= e, t[11] *= e, t[15] *= e, this;
  }
  /**
   * Computes and returns the determinant of this matrix.
   *
   * Based on the method outlined [here](http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.html).
   *
   * @return {number} The determinant.
   */
  determinant() {
    const e = this.elements, t = e[0], n = e[4], i = e[8], s = e[12], a = e[1], o = e[5], c = e[9], l = e[13], u = e[2], h = e[6], f = e[10], d = e[14], g = e[3], _ = e[7], m = e[11], p = e[15], S = c * d - l * f, b = o * d - l * h, T = o * f - c * h, y = a * d - l * u, R = a * f - c * u, A = a * h - o * u;
    return t * (_ * S - m * b + p * T) - n * (g * S - m * y + p * R) + i * (g * b - _ * y + p * A) - s * (g * T - _ * R + m * A);
  }
  /**
   * Transposes this matrix in place.
   *
   * @return {Matrix4} A reference to this matrix.
   */
  transpose() {
    const e = this.elements;
    let t;
    return t = e[1], e[1] = e[4], e[4] = t, t = e[2], e[2] = e[8], e[8] = t, t = e[6], e[6] = e[9], e[9] = t, t = e[3], e[3] = e[12], e[12] = t, t = e[7], e[7] = e[13], e[13] = t, t = e[11], e[11] = e[14], e[14] = t, this;
  }
  /**
   * Sets the position component for this matrix from the given vector,
   * without affecting the rest of the matrix.
   *
   * @param {number|Vector3} x - The x component of the vector or alternatively the vector object.
   * @param {number} y - The y component of the vector.
   * @param {number} z - The z component of the vector.
   * @return {Matrix4} A reference to this matrix.
   */
  setPosition(e, t, n) {
    const i = this.elements;
    return e.isVector3 ? (i[12] = e.x, i[13] = e.y, i[14] = e.z) : (i[12] = e, i[13] = t, i[14] = n), this;
  }
  /**
   * Inverts this matrix, using the [analytic method](https://en.wikipedia.org/wiki/Invertible_matrix#Analytic_solution).
   * You can not invert with a determinant of zero. If you attempt this, the method produces
   * a zero matrix instead.
   *
   * @return {Matrix4} A reference to this matrix.
   */
  invert() {
    const e = this.elements, t = e[0], n = e[1], i = e[2], s = e[3], a = e[4], o = e[5], c = e[6], l = e[7], u = e[8], h = e[9], f = e[10], d = e[11], g = e[12], _ = e[13], m = e[14], p = e[15], S = h * m * l - _ * f * l + _ * c * d - o * m * d - h * c * p + o * f * p, b = g * f * l - u * m * l - g * c * d + a * m * d + u * c * p - a * f * p, T = u * _ * l - g * h * l + g * o * d - a * _ * d - u * o * p + a * h * p, y = g * h * c - u * _ * c - g * o * f + a * _ * f + u * o * m - a * h * m, R = t * S + n * b + i * T + s * y;
    if (R === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
    const A = 1 / R;
    return e[0] = S * A, e[1] = (_ * f * s - h * m * s - _ * i * d + n * m * d + h * i * p - n * f * p) * A, e[2] = (o * m * s - _ * c * s + _ * i * l - n * m * l - o * i * p + n * c * p) * A, e[3] = (h * c * s - o * f * s - h * i * l + n * f * l + o * i * d - n * c * d) * A, e[4] = b * A, e[5] = (u * m * s - g * f * s + g * i * d - t * m * d - u * i * p + t * f * p) * A, e[6] = (g * c * s - a * m * s - g * i * l + t * m * l + a * i * p - t * c * p) * A, e[7] = (a * f * s - u * c * s + u * i * l - t * f * l - a * i * d + t * c * d) * A, e[8] = T * A, e[9] = (g * h * s - u * _ * s - g * n * d + t * _ * d + u * n * p - t * h * p) * A, e[10] = (a * _ * s - g * o * s + g * n * l - t * _ * l - a * n * p + t * o * p) * A, e[11] = (u * o * s - a * h * s - u * n * l + t * h * l + a * n * d - t * o * d) * A, e[12] = y * A, e[13] = (u * _ * i - g * h * i + g * n * f - t * _ * f - u * n * m + t * h * m) * A, e[14] = (g * o * i - a * _ * i - g * n * c + t * _ * c + a * n * m - t * o * m) * A, e[15] = (a * h * i - u * o * i + u * n * c - t * h * c - a * n * f + t * o * f) * A, this;
  }
  /**
   * Multiplies the columns of this matrix by the given vector.
   *
   * @param {Vector3} v - The scale vector.
   * @return {Matrix4} A reference to this matrix.
   */
  scale(e) {
    const t = this.elements, n = e.x, i = e.y, s = e.z;
    return t[0] *= n, t[4] *= i, t[8] *= s, t[1] *= n, t[5] *= i, t[9] *= s, t[2] *= n, t[6] *= i, t[10] *= s, t[3] *= n, t[7] *= i, t[11] *= s, this;
  }
  /**
   * Gets the maximum scale value of the three axes.
   *
   * @return {number} The maximum scale.
   */
  getMaxScaleOnAxis() {
    const e = this.elements, t = e[0] * e[0] + e[1] * e[1] + e[2] * e[2], n = e[4] * e[4] + e[5] * e[5] + e[6] * e[6], i = e[8] * e[8] + e[9] * e[9] + e[10] * e[10];
    return Math.sqrt(Math.max(t, n, i));
  }
  /**
   * Sets this matrix as a translation transform from the given vector.
   *
   * @param {number|Vector3} x - The amount to translate in the X axis or alternatively a translation vector.
   * @param {number} y - The amount to translate in the Y axis.
   * @param {number} z - The amount to translate in the z axis.
   * @return {Matrix4} A reference to this matrix.
   */
  makeTranslation(e, t, n) {
    return e.isVector3 ? this.set(
      1,
      0,
      0,
      e.x,
      0,
      1,
      0,
      e.y,
      0,
      0,
      1,
      e.z,
      0,
      0,
      0,
      1
    ) : this.set(
      1,
      0,
      0,
      e,
      0,
      1,
      0,
      t,
      0,
      0,
      1,
      n,
      0,
      0,
      0,
      1
    ), this;
  }
  /**
   * Sets this matrix as a rotational transformation around the X axis by
   * the given angle.
   *
   * @param {number} theta - The rotation in radians.
   * @return {Matrix4} A reference to this matrix.
   */
  makeRotationX(e) {
    const t = Math.cos(e), n = Math.sin(e);
    return this.set(
      1,
      0,
      0,
      0,
      0,
      t,
      -n,
      0,
      0,
      n,
      t,
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  /**
   * Sets this matrix as a rotational transformation around the Y axis by
   * the given angle.
   *
   * @param {number} theta - The rotation in radians.
   * @return {Matrix4} A reference to this matrix.
   */
  makeRotationY(e) {
    const t = Math.cos(e), n = Math.sin(e);
    return this.set(
      t,
      0,
      n,
      0,
      0,
      1,
      0,
      0,
      -n,
      0,
      t,
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  /**
   * Sets this matrix as a rotational transformation around the Z axis by
   * the given angle.
   *
   * @param {number} theta - The rotation in radians.
   * @return {Matrix4} A reference to this matrix.
   */
  makeRotationZ(e) {
    const t = Math.cos(e), n = Math.sin(e);
    return this.set(
      t,
      -n,
      0,
      0,
      n,
      t,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  /**
   * Sets this matrix as a rotational transformation around the given axis by
   * the given angle.
   *
   * This is a somewhat controversial but mathematically sound alternative to
   * rotating via Quaternions. See the discussion [here](https://www.gamedev.net/articles/programming/math-and-physics/do-we-really-need-quaternions-r1199).
   *
   * @param {Vector3} axis - The normalized rotation axis.
   * @param {number} angle - The rotation in radians.
   * @return {Matrix4} A reference to this matrix.
   */
  makeRotationAxis(e, t) {
    const n = Math.cos(t), i = Math.sin(t), s = 1 - n, a = e.x, o = e.y, c = e.z, l = s * a, u = s * o;
    return this.set(
      l * a + n,
      l * o - i * c,
      l * c + i * o,
      0,
      l * o + i * c,
      u * o + n,
      u * c - i * a,
      0,
      l * c - i * o,
      u * c + i * a,
      s * c * c + n,
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  /**
   * Sets this matrix as a scale transformation.
   *
   * @param {number} x - The amount to scale in the X axis.
   * @param {number} y - The amount to scale in the Y axis.
   * @param {number} z - The amount to scale in the Z axis.
   * @return {Matrix4} A reference to this matrix.
   */
  makeScale(e, t, n) {
    return this.set(
      e,
      0,
      0,
      0,
      0,
      t,
      0,
      0,
      0,
      0,
      n,
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  /**
   * Sets this matrix as a shear transformation.
   *
   * @param {number} xy - The amount to shear X by Y.
   * @param {number} xz - The amount to shear X by Z.
   * @param {number} yx - The amount to shear Y by X.
   * @param {number} yz - The amount to shear Y by Z.
   * @param {number} zx - The amount to shear Z by X.
   * @param {number} zy - The amount to shear Z by Y.
   * @return {Matrix4} A reference to this matrix.
   */
  makeShear(e, t, n, i, s, a) {
    return this.set(
      1,
      n,
      s,
      0,
      e,
      1,
      a,
      0,
      t,
      i,
      1,
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  /**
   * Sets this matrix to the transformation composed of the given position,
   * rotation (Quaternion) and scale.
   *
   * @param {Vector3} position - The position vector.
   * @param {Quaternion} quaternion - The rotation as a Quaternion.
   * @param {Vector3} scale - The scale vector.
   * @return {Matrix4} A reference to this matrix.
   */
  compose(e, t, n) {
    const i = this.elements, s = t._x, a = t._y, o = t._z, c = t._w, l = s + s, u = a + a, h = o + o, f = s * l, d = s * u, g = s * h, _ = a * u, m = a * h, p = o * h, S = c * l, b = c * u, T = c * h, y = n.x, R = n.y, A = n.z;
    return i[0] = (1 - (_ + p)) * y, i[1] = (d + T) * y, i[2] = (g - b) * y, i[3] = 0, i[4] = (d - T) * R, i[5] = (1 - (f + p)) * R, i[6] = (m + S) * R, i[7] = 0, i[8] = (g + b) * A, i[9] = (m - S) * A, i[10] = (1 - (f + _)) * A, i[11] = 0, i[12] = e.x, i[13] = e.y, i[14] = e.z, i[15] = 1, this;
  }
  /**
   * Decomposes this matrix into its position, rotation and scale components
   * and provides the result in the given objects.
   *
   * Note: Not all matrices are decomposable in this way. For example, if an
   * object has a non-uniformly scaled parent, then the object's world matrix
   * may not be decomposable, and this method may not be appropriate.
   *
   * @param {Vector3} position - The position vector.
   * @param {Quaternion} quaternion - The rotation as a Quaternion.
   * @param {Vector3} scale - The scale vector.
   * @return {Matrix4} A reference to this matrix.
   */
  decompose(e, t, n) {
    const i = this.elements;
    if (e.x = i[12], e.y = i[13], e.z = i[14], this.determinant() === 0)
      return n.set(1, 1, 1), t.identity(), this;
    let s = Fi.set(i[0], i[1], i[2]).length();
    const a = Fi.set(i[4], i[5], i[6]).length(), o = Fi.set(i[8], i[9], i[10]).length();
    this.determinant() < 0 && (s = -s), Sn.copy(this);
    const l = 1 / s, u = 1 / a, h = 1 / o;
    return Sn.elements[0] *= l, Sn.elements[1] *= l, Sn.elements[2] *= l, Sn.elements[4] *= u, Sn.elements[5] *= u, Sn.elements[6] *= u, Sn.elements[8] *= h, Sn.elements[9] *= h, Sn.elements[10] *= h, t.setFromRotationMatrix(Sn), n.x = s, n.y = a, n.z = o, this;
  }
  /**
  	 * Creates a perspective projection matrix. This is used internally by
  	 * {@link PerspectiveCamera#updateProjectionMatrix}.
  
  	 * @param {number} left - Left boundary of the viewing frustum at the near plane.
  	 * @param {number} right - Right boundary of the viewing frustum at the near plane.
  	 * @param {number} top - Top boundary of the viewing frustum at the near plane.
  	 * @param {number} bottom - Bottom boundary of the viewing frustum at the near plane.
  	 * @param {number} near - The distance from the camera to the near plane.
  	 * @param {number} far - The distance from the camera to the far plane.
  	 * @param {(WebGLCoordinateSystem|WebGPUCoordinateSystem)} [coordinateSystem=WebGLCoordinateSystem] - The coordinate system.
  	 * @param {boolean} [reversedDepth=false] - Whether to use a reversed depth.
  	 * @return {Matrix4} A reference to this matrix.
  	 */
  makePerspective(e, t, n, i, s, a, o = 2e3, c = !1) {
    const l = this.elements, u = 2 * s / (t - e), h = 2 * s / (n - i), f = (t + e) / (t - e), d = (n + i) / (n - i);
    let g, _;
    if (c)
      g = s / (a - s), _ = a * s / (a - s);
    else if (o === 2e3)
      g = -(a + s) / (a - s), _ = -2 * a * s / (a - s);
    else if (o === 2001)
      g = -a / (a - s), _ = -a * s / (a - s);
    else
      throw new Error("THREE.Matrix4.makePerspective(): Invalid coordinate system: " + o);
    return l[0] = u, l[4] = 0, l[8] = f, l[12] = 0, l[1] = 0, l[5] = h, l[9] = d, l[13] = 0, l[2] = 0, l[6] = 0, l[10] = g, l[14] = _, l[3] = 0, l[7] = 0, l[11] = -1, l[15] = 0, this;
  }
  /**
  	 * Creates a orthographic projection matrix. This is used internally by
  	 * {@link OrthographicCamera#updateProjectionMatrix}.
  
  	 * @param {number} left - Left boundary of the viewing frustum at the near plane.
  	 * @param {number} right - Right boundary of the viewing frustum at the near plane.
  	 * @param {number} top - Top boundary of the viewing frustum at the near plane.
  	 * @param {number} bottom - Bottom boundary of the viewing frustum at the near plane.
  	 * @param {number} near - The distance from the camera to the near plane.
  	 * @param {number} far - The distance from the camera to the far plane.
  	 * @param {(WebGLCoordinateSystem|WebGPUCoordinateSystem)} [coordinateSystem=WebGLCoordinateSystem] - The coordinate system.
  	 * @param {boolean} [reversedDepth=false] - Whether to use a reversed depth.
  	 * @return {Matrix4} A reference to this matrix.
  	 */
  makeOrthographic(e, t, n, i, s, a, o = 2e3, c = !1) {
    const l = this.elements, u = 2 / (t - e), h = 2 / (n - i), f = -(t + e) / (t - e), d = -(n + i) / (n - i);
    let g, _;
    if (c)
      g = 1 / (a - s), _ = a / (a - s);
    else if (o === 2e3)
      g = -2 / (a - s), _ = -(a + s) / (a - s);
    else if (o === 2001)
      g = -1 / (a - s), _ = -s / (a - s);
    else
      throw new Error("THREE.Matrix4.makeOrthographic(): Invalid coordinate system: " + o);
    return l[0] = u, l[4] = 0, l[8] = 0, l[12] = f, l[1] = 0, l[5] = h, l[9] = 0, l[13] = d, l[2] = 0, l[6] = 0, l[10] = g, l[14] = _, l[3] = 0, l[7] = 0, l[11] = 0, l[15] = 1, this;
  }
  /**
   * Returns `true` if this matrix is equal with the given one.
   *
   * @param {Matrix4} matrix - The matrix to test for equality.
   * @return {boolean} Whether this matrix is equal with the given one.
   */
  equals(e) {
    const t = this.elements, n = e.elements;
    for (let i = 0; i < 16; i++)
      if (t[i] !== n[i]) return !1;
    return !0;
  }
  /**
   * Sets the elements of the matrix from the given array.
   *
   * @param {Array<number>} array - The matrix elements in column-major order.
   * @param {number} [offset=0] - Index of the first element in the array.
   * @return {Matrix4} A reference to this matrix.
   */
  fromArray(e, t = 0) {
    for (let n = 0; n < 16; n++)
      this.elements[n] = e[n + t];
    return this;
  }
  /**
   * Writes the elements of this matrix to the given array. If no array is provided,
   * the method returns a new instance.
   *
   * @param {Array<number>} [array=[]] - The target array holding the matrix elements in column-major order.
   * @param {number} [offset=0] - Index of the first element in the array.
   * @return {Array<number>} The matrix elements in column-major order.
   */
  toArray(e = [], t = 0) {
    const n = this.elements;
    return e[t] = n[0], e[t + 1] = n[1], e[t + 2] = n[2], e[t + 3] = n[3], e[t + 4] = n[4], e[t + 5] = n[5], e[t + 6] = n[6], e[t + 7] = n[7], e[t + 8] = n[8], e[t + 9] = n[9], e[t + 10] = n[10], e[t + 11] = n[11], e[t + 12] = n[12], e[t + 13] = n[13], e[t + 14] = n[14], e[t + 15] = n[15], e;
  }
}
const Fi = /* @__PURE__ */ new I(), Sn = /* @__PURE__ */ new ht(), ah = /* @__PURE__ */ new I(0, 0, 0), oh = /* @__PURE__ */ new I(1, 1, 1), $n = /* @__PURE__ */ new I(), is = /* @__PURE__ */ new I(), nn = /* @__PURE__ */ new I(), qo = /* @__PURE__ */ new ht(), Yo = /* @__PURE__ */ new Xr();
class Vn {
  /**
   * Constructs a new euler instance.
   *
   * @param {number} [x=0] - The angle of the x axis in radians.
   * @param {number} [y=0] - The angle of the y axis in radians.
   * @param {number} [z=0] - The angle of the z axis in radians.
   * @param {string} [order=Euler.DEFAULT_ORDER] - A string representing the order that the rotations are applied.
   */
  constructor(e = 0, t = 0, n = 0, i = Vn.DEFAULT_ORDER) {
    this.isEuler = !0, this._x = e, this._y = t, this._z = n, this._order = i;
  }
  /**
   * The angle of the x axis in radians.
   *
   * @type {number}
   * @default 0
   */
  get x() {
    return this._x;
  }
  set x(e) {
    this._x = e, this._onChangeCallback();
  }
  /**
   * The angle of the y axis in radians.
   *
   * @type {number}
   * @default 0
   */
  get y() {
    return this._y;
  }
  set y(e) {
    this._y = e, this._onChangeCallback();
  }
  /**
   * The angle of the z axis in radians.
   *
   * @type {number}
   * @default 0
   */
  get z() {
    return this._z;
  }
  set z(e) {
    this._z = e, this._onChangeCallback();
  }
  /**
   * A string representing the order that the rotations are applied.
   *
   * @type {string}
   * @default 'XYZ'
   */
  get order() {
    return this._order;
  }
  set order(e) {
    this._order = e, this._onChangeCallback();
  }
  /**
   * Sets the Euler components.
   *
   * @param {number} x - The angle of the x axis in radians.
   * @param {number} y - The angle of the y axis in radians.
   * @param {number} z - The angle of the z axis in radians.
   * @param {string} [order] - A string representing the order that the rotations are applied.
   * @return {Euler} A reference to this Euler instance.
   */
  set(e, t, n, i = this._order) {
    return this._x = e, this._y = t, this._z = n, this._order = i, this._onChangeCallback(), this;
  }
  /**
   * Returns a new Euler instance with copied values from this instance.
   *
   * @return {Euler} A clone of this instance.
   */
  clone() {
    return new this.constructor(this._x, this._y, this._z, this._order);
  }
  /**
   * Copies the values of the given Euler instance to this instance.
   *
   * @param {Euler} euler - The Euler instance to copy.
   * @return {Euler} A reference to this Euler instance.
   */
  copy(e) {
    return this._x = e._x, this._y = e._y, this._z = e._z, this._order = e._order, this._onChangeCallback(), this;
  }
  /**
   * Sets the angles of this Euler instance from a pure rotation matrix.
   *
   * @param {Matrix4} m - A 4x4 matrix of which the upper 3x3 of matrix is a pure rotation matrix (i.e. unscaled).
   * @param {string} [order] - A string representing the order that the rotations are applied.
   * @param {boolean} [update=true] - Whether the internal `onChange` callback should be executed or not.
   * @return {Euler} A reference to this Euler instance.
   */
  setFromRotationMatrix(e, t = this._order, n = !0) {
    const i = e.elements, s = i[0], a = i[4], o = i[8], c = i[1], l = i[5], u = i[9], h = i[2], f = i[6], d = i[10];
    switch (t) {
      case "XYZ":
        this._y = Math.asin(ze(o, -1, 1)), Math.abs(o) < 0.9999999 ? (this._x = Math.atan2(-u, d), this._z = Math.atan2(-a, s)) : (this._x = Math.atan2(f, l), this._z = 0);
        break;
      case "YXZ":
        this._x = Math.asin(-ze(u, -1, 1)), Math.abs(u) < 0.9999999 ? (this._y = Math.atan2(o, d), this._z = Math.atan2(c, l)) : (this._y = Math.atan2(-h, s), this._z = 0);
        break;
      case "ZXY":
        this._x = Math.asin(ze(f, -1, 1)), Math.abs(f) < 0.9999999 ? (this._y = Math.atan2(-h, d), this._z = Math.atan2(-a, l)) : (this._y = 0, this._z = Math.atan2(c, s));
        break;
      case "ZYX":
        this._y = Math.asin(-ze(h, -1, 1)), Math.abs(h) < 0.9999999 ? (this._x = Math.atan2(f, d), this._z = Math.atan2(c, s)) : (this._x = 0, this._z = Math.atan2(-a, l));
        break;
      case "YZX":
        this._z = Math.asin(ze(c, -1, 1)), Math.abs(c) < 0.9999999 ? (this._x = Math.atan2(-u, l), this._y = Math.atan2(-h, s)) : (this._x = 0, this._y = Math.atan2(o, d));
        break;
      case "XZY":
        this._z = Math.asin(-ze(a, -1, 1)), Math.abs(a) < 0.9999999 ? (this._x = Math.atan2(f, l), this._y = Math.atan2(o, s)) : (this._x = Math.atan2(-u, d), this._y = 0);
        break;
      default:
        Ce("Euler: .setFromRotationMatrix() encountered an unknown order: " + t);
    }
    return this._order = t, n === !0 && this._onChangeCallback(), this;
  }
  /**
   * Sets the angles of this Euler instance from a normalized quaternion.
   *
   * @param {Quaternion} q - A normalized Quaternion.
   * @param {string} [order] - A string representing the order that the rotations are applied.
   * @param {boolean} [update=true] - Whether the internal `onChange` callback should be executed or not.
   * @return {Euler} A reference to this Euler instance.
   */
  setFromQuaternion(e, t, n) {
    return qo.makeRotationFromQuaternion(e), this.setFromRotationMatrix(qo, t, n);
  }
  /**
   * Sets the angles of this Euler instance from the given vector.
   *
   * @param {Vector3} v - The vector.
   * @param {string} [order] - A string representing the order that the rotations are applied.
   * @return {Euler} A reference to this Euler instance.
   */
  setFromVector3(e, t = this._order) {
    return this.set(e.x, e.y, e.z, t);
  }
  /**
   * Resets the euler angle with a new order by creating a quaternion from this
   * euler angle and then setting this euler angle with the quaternion and the
   * new order.
   *
   * Warning: This discards revolution information.
   *
   * @param {string} [newOrder] - A string representing the new order that the rotations are applied.
   * @return {Euler} A reference to this Euler instance.
   */
  reorder(e) {
    return Yo.setFromEuler(this), this.setFromQuaternion(Yo, e);
  }
  /**
   * Returns `true` if this Euler instance is equal with the given one.
   *
   * @param {Euler} euler - The Euler instance to test for equality.
   * @return {boolean} Whether this Euler instance is equal with the given one.
   */
  equals(e) {
    return e._x === this._x && e._y === this._y && e._z === this._z && e._order === this._order;
  }
  /**
   * Sets this Euler instance's components to values from the given array. The first three
   * entries of the array are assign to the x,y and z components. An optional fourth entry
   * defines the Euler order.
   *
   * @param {Array<number,number,number,?string>} array - An array holding the Euler component values.
   * @return {Euler} A reference to this Euler instance.
   */
  fromArray(e) {
    return this._x = e[0], this._y = e[1], this._z = e[2], e[3] !== void 0 && (this._order = e[3]), this._onChangeCallback(), this;
  }
  /**
   * Writes the components of this Euler instance to the given array. If no array is provided,
   * the method returns a new instance.
   *
   * @param {Array<number,number,number,string>} [array=[]] - The target array holding the Euler components.
   * @param {number} [offset=0] - Index of the first element in the array.
   * @return {Array<number,number,number,string>} The Euler components.
   */
  toArray(e = [], t = 0) {
    return e[t] = this._x, e[t + 1] = this._y, e[t + 2] = this._z, e[t + 3] = this._order, e;
  }
  _onChange(e) {
    return this._onChangeCallback = e, this;
  }
  _onChangeCallback() {
  }
  *[Symbol.iterator]() {
    yield this._x, yield this._y, yield this._z, yield this._order;
  }
}
Vn.DEFAULT_ORDER = "XYZ";
class oc {
  /**
   * Constructs a new layers instance, with membership
   * initially set to layer `0`.
   */
  constructor() {
    this.mask = 1;
  }
  /**
   * Sets membership to the given layer, and remove membership all other layers.
   *
   * @param {number} layer - The layer to set.
   */
  set(e) {
    this.mask = (1 << e | 0) >>> 0;
  }
  /**
   * Adds membership of the given layer.
   *
   * @param {number} layer - The layer to enable.
   */
  enable(e) {
    this.mask |= 1 << e | 0;
  }
  /**
   * Adds membership to all layers.
   */
  enableAll() {
    this.mask = -1;
  }
  /**
   * Toggles the membership of the given layer.
   *
   * @param {number} layer - The layer to toggle.
   */
  toggle(e) {
    this.mask ^= 1 << e | 0;
  }
  /**
   * Removes membership of the given layer.
   *
   * @param {number} layer - The layer to enable.
   */
  disable(e) {
    this.mask &= ~(1 << e | 0);
  }
  /**
   * Removes the membership from all layers.
   */
  disableAll() {
    this.mask = 0;
  }
  /**
   * Returns `true` if this and the given layers object have at least one
   * layer in common.
   *
   * @param {Layers} layers - The layers to test.
   * @return {boolean } Whether this and the given layers object have at least one layer in common or not.
   */
  test(e) {
    return (this.mask & e.mask) !== 0;
  }
  /**
   * Returns `true` if the given layer is enabled.
   *
   * @param {number} layer - The layer to test.
   * @return {boolean } Whether the given layer is enabled or not.
   */
  isEnabled(e) {
    return (this.mask & (1 << e | 0)) !== 0;
  }
}
let lh = 0;
const $o = /* @__PURE__ */ new I(), Ui = /* @__PURE__ */ new Xr(), In = /* @__PURE__ */ new ht(), rs = /* @__PURE__ */ new I(), dr = /* @__PURE__ */ new I(), ch = /* @__PURE__ */ new I(), uh = /* @__PURE__ */ new Xr(), Ko = /* @__PURE__ */ new I(1, 0, 0), Zo = /* @__PURE__ */ new I(0, 1, 0), jo = /* @__PURE__ */ new I(0, 0, 1), Jo = { type: "added" }, hh = { type: "removed" }, Ii = { type: "childadded", child: null }, ha = { type: "childremoved", child: null };
class Bt extends lr {
  /**
   * Constructs a new 3D object.
   */
  constructor() {
    super(), this.isObject3D = !0, Object.defineProperty(this, "id", { value: lh++ }), this.uuid = Gn(), this.name = "", this.type = "Object3D", this.parent = null, this.children = [], this.up = Bt.DEFAULT_UP.clone();
    const e = new I(), t = new Vn(), n = new Xr(), i = new I(1, 1, 1);
    function s() {
      n.setFromEuler(t, !1);
    }
    function a() {
      t.setFromQuaternion(n, void 0, !1);
    }
    t._onChange(s), n._onChange(a), Object.defineProperties(this, {
      /**
       * Represents the object's local position.
       *
       * @name Object3D#position
       * @type {Vector3}
       * @default (0,0,0)
       */
      position: {
        configurable: !0,
        enumerable: !0,
        value: e
      },
      /**
       * Represents the object's local rotation as Euler angles, in radians.
       *
       * @name Object3D#rotation
       * @type {Euler}
       * @default (0,0,0)
       */
      rotation: {
        configurable: !0,
        enumerable: !0,
        value: t
      },
      /**
       * Represents the object's local rotation as Quaternions.
       *
       * @name Object3D#quaternion
       * @type {Quaternion}
       */
      quaternion: {
        configurable: !0,
        enumerable: !0,
        value: n
      },
      /**
       * Represents the object's local scale.
       *
       * @name Object3D#scale
       * @type {Vector3}
       * @default (1,1,1)
       */
      scale: {
        configurable: !0,
        enumerable: !0,
        value: i
      },
      /**
       * Represents the object's model-view matrix.
       *
       * @name Object3D#modelViewMatrix
       * @type {Matrix4}
       */
      modelViewMatrix: {
        value: new ht()
      },
      /**
       * Represents the object's normal matrix.
       *
       * @name Object3D#normalMatrix
       * @type {Matrix3}
       */
      normalMatrix: {
        value: new Ue()
      }
    }), this.matrix = new ht(), this.matrixWorld = new ht(), this.matrixAutoUpdate = Bt.DEFAULT_MATRIX_AUTO_UPDATE, this.matrixWorldAutoUpdate = Bt.DEFAULT_MATRIX_WORLD_AUTO_UPDATE, this.matrixWorldNeedsUpdate = !1, this.layers = new oc(), this.visible = !0, this.castShadow = !1, this.receiveShadow = !1, this.frustumCulled = !0, this.renderOrder = 0, this.animations = [], this.customDepthMaterial = void 0, this.customDistanceMaterial = void 0, this.userData = {};
  }
  /**
   * A callback that is executed immediately before a 3D object is rendered to a shadow map.
   *
   * @param {Renderer|WebGLRenderer} renderer - The renderer.
   * @param {Object3D} object - The 3D object.
   * @param {Camera} camera - The camera that is used to render the scene.
   * @param {Camera} shadowCamera - The shadow camera.
   * @param {BufferGeometry} geometry - The 3D object's geometry.
   * @param {Material} depthMaterial - The depth material.
   * @param {Object} group - The geometry group data.
   */
  onBeforeShadow() {
  }
  /**
   * A callback that is executed immediately after a 3D object is rendered to a shadow map.
   *
   * @param {Renderer|WebGLRenderer} renderer - The renderer.
   * @param {Object3D} object - The 3D object.
   * @param {Camera} camera - The camera that is used to render the scene.
   * @param {Camera} shadowCamera - The shadow camera.
   * @param {BufferGeometry} geometry - The 3D object's geometry.
   * @param {Material} depthMaterial - The depth material.
   * @param {Object} group - The geometry group data.
   */
  onAfterShadow() {
  }
  /**
   * A callback that is executed immediately before a 3D object is rendered.
   *
   * @param {Renderer|WebGLRenderer} renderer - The renderer.
   * @param {Object3D} object - The 3D object.
   * @param {Camera} camera - The camera that is used to render the scene.
   * @param {BufferGeometry} geometry - The 3D object's geometry.
   * @param {Material} material - The 3D object's material.
   * @param {Object} group - The geometry group data.
   */
  onBeforeRender() {
  }
  /**
   * A callback that is executed immediately after a 3D object is rendered.
   *
   * @param {Renderer|WebGLRenderer} renderer - The renderer.
   * @param {Object3D} object - The 3D object.
   * @param {Camera} camera - The camera that is used to render the scene.
   * @param {BufferGeometry} geometry - The 3D object's geometry.
   * @param {Material} material - The 3D object's material.
   * @param {Object} group - The geometry group data.
   */
  onAfterRender() {
  }
  /**
   * Applies the given transformation matrix to the object and updates the object's position,
   * rotation and scale.
   *
   * @param {Matrix4} matrix - The transformation matrix.
   */
  applyMatrix4(e) {
    this.matrixAutoUpdate && this.updateMatrix(), this.matrix.premultiply(e), this.matrix.decompose(this.position, this.quaternion, this.scale);
  }
  /**
   * Applies a rotation represented by given the quaternion to the 3D object.
   *
   * @param {Quaternion} q - The quaternion.
   * @return {Object3D} A reference to this instance.
   */
  applyQuaternion(e) {
    return this.quaternion.premultiply(e), this;
  }
  /**
   * Sets the given rotation represented as an axis/angle couple to the 3D object.
   *
   * @param {Vector3} axis - The (normalized) axis vector.
   * @param {number} angle - The angle in radians.
   */
  setRotationFromAxisAngle(e, t) {
    this.quaternion.setFromAxisAngle(e, t);
  }
  /**
   * Sets the given rotation represented as Euler angles to the 3D object.
   *
   * @param {Euler} euler - The Euler angles.
   */
  setRotationFromEuler(e) {
    this.quaternion.setFromEuler(e, !0);
  }
  /**
   * Sets the given rotation represented as rotation matrix to the 3D object.
   *
   * @param {Matrix4} m - Although a 4x4 matrix is expected, the upper 3x3 portion must be
   * a pure rotation matrix (i.e, unscaled).
   */
  setRotationFromMatrix(e) {
    this.quaternion.setFromRotationMatrix(e);
  }
  /**
   * Sets the given rotation represented as a Quaternion to the 3D object.
   *
   * @param {Quaternion} q - The Quaternion
   */
  setRotationFromQuaternion(e) {
    this.quaternion.copy(e);
  }
  /**
   * Rotates the 3D object along an axis in local space.
   *
   * @param {Vector3} axis - The (normalized) axis vector.
   * @param {number} angle - The angle in radians.
   * @return {Object3D} A reference to this instance.
   */
  rotateOnAxis(e, t) {
    return Ui.setFromAxisAngle(e, t), this.quaternion.multiply(Ui), this;
  }
  /**
   * Rotates the 3D object along an axis in world space.
   *
   * @param {Vector3} axis - The (normalized) axis vector.
   * @param {number} angle - The angle in radians.
   * @return {Object3D} A reference to this instance.
   */
  rotateOnWorldAxis(e, t) {
    return Ui.setFromAxisAngle(e, t), this.quaternion.premultiply(Ui), this;
  }
  /**
   * Rotates the 3D object around its X axis in local space.
   *
   * @param {number} angle - The angle in radians.
   * @return {Object3D} A reference to this instance.
   */
  rotateX(e) {
    return this.rotateOnAxis(Ko, e);
  }
  /**
   * Rotates the 3D object around its Y axis in local space.
   *
   * @param {number} angle - The angle in radians.
   * @return {Object3D} A reference to this instance.
   */
  rotateY(e) {
    return this.rotateOnAxis(Zo, e);
  }
  /**
   * Rotates the 3D object around its Z axis in local space.
   *
   * @param {number} angle - The angle in radians.
   * @return {Object3D} A reference to this instance.
   */
  rotateZ(e) {
    return this.rotateOnAxis(jo, e);
  }
  /**
   * Translate the 3D object by a distance along the given axis in local space.
   *
   * @param {Vector3} axis - The (normalized) axis vector.
   * @param {number} distance - The distance in world units.
   * @return {Object3D} A reference to this instance.
   */
  translateOnAxis(e, t) {
    return $o.copy(e).applyQuaternion(this.quaternion), this.position.add($o.multiplyScalar(t)), this;
  }
  /**
   * Translate the 3D object by a distance along its X-axis in local space.
   *
   * @param {number} distance - The distance in world units.
   * @return {Object3D} A reference to this instance.
   */
  translateX(e) {
    return this.translateOnAxis(Ko, e);
  }
  /**
   * Translate the 3D object by a distance along its Y-axis in local space.
   *
   * @param {number} distance - The distance in world units.
   * @return {Object3D} A reference to this instance.
   */
  translateY(e) {
    return this.translateOnAxis(Zo, e);
  }
  /**
   * Translate the 3D object by a distance along its Z-axis in local space.
   *
   * @param {number} distance - The distance in world units.
   * @return {Object3D} A reference to this instance.
   */
  translateZ(e) {
    return this.translateOnAxis(jo, e);
  }
  /**
   * Converts the given vector from this 3D object's local space to world space.
   *
   * @param {Vector3} vector - The vector to convert.
   * @return {Vector3} The converted vector.
   */
  localToWorld(e) {
    return this.updateWorldMatrix(!0, !1), e.applyMatrix4(this.matrixWorld);
  }
  /**
   * Converts the given vector from this 3D object's word space to local space.
   *
   * @param {Vector3} vector - The vector to convert.
   * @return {Vector3} The converted vector.
   */
  worldToLocal(e) {
    return this.updateWorldMatrix(!0, !1), e.applyMatrix4(In.copy(this.matrixWorld).invert());
  }
  /**
   * Rotates the object to face a point in world space.
   *
   * This method does not support objects having non-uniformly-scaled parent(s).
   *
   * @param {number|Vector3} x - The x coordinate in world space. Alternatively, a vector representing a position in world space
   * @param {number} [y] - The y coordinate in world space.
   * @param {number} [z] - The z coordinate in world space.
   */
  lookAt(e, t, n) {
    e.isVector3 ? rs.copy(e) : rs.set(e, t, n);
    const i = this.parent;
    this.updateWorldMatrix(!0, !1), dr.setFromMatrixPosition(this.matrixWorld), this.isCamera || this.isLight ? In.lookAt(dr, rs, this.up) : In.lookAt(rs, dr, this.up), this.quaternion.setFromRotationMatrix(In), i && (In.extractRotation(i.matrixWorld), Ui.setFromRotationMatrix(In), this.quaternion.premultiply(Ui.invert()));
  }
  /**
   * Adds the given 3D object as a child to this 3D object. An arbitrary number of
   * objects may be added. Any current parent on an object passed in here will be
   * removed, since an object can have at most one parent.
   *
   * @fires Object3D#added
   * @fires Object3D#childadded
   * @param {Object3D} object - The 3D object to add.
   * @return {Object3D} A reference to this instance.
   */
  add(e) {
    if (arguments.length > 1) {
      for (let t = 0; t < arguments.length; t++)
        this.add(arguments[t]);
      return this;
    }
    return e === this ? (Xe("Object3D.add: object can't be added as a child of itself.", e), this) : (e && e.isObject3D ? (e.removeFromParent(), e.parent = this, this.children.push(e), e.dispatchEvent(Jo), Ii.child = e, this.dispatchEvent(Ii), Ii.child = null) : Xe("Object3D.add: object not an instance of THREE.Object3D.", e), this);
  }
  /**
   * Removes the given 3D object as child from this 3D object.
   * An arbitrary number of objects may be removed.
   *
   * @fires Object3D#removed
   * @fires Object3D#childremoved
   * @param {Object3D} object - The 3D object to remove.
   * @return {Object3D} A reference to this instance.
   */
  remove(e) {
    if (arguments.length > 1) {
      for (let n = 0; n < arguments.length; n++)
        this.remove(arguments[n]);
      return this;
    }
    const t = this.children.indexOf(e);
    return t !== -1 && (e.parent = null, this.children.splice(t, 1), e.dispatchEvent(hh), ha.child = e, this.dispatchEvent(ha), ha.child = null), this;
  }
  /**
   * Removes this 3D object from its current parent.
   *
   * @fires Object3D#removed
   * @fires Object3D#childremoved
   * @return {Object3D} A reference to this instance.
   */
  removeFromParent() {
    const e = this.parent;
    return e !== null && e.remove(this), this;
  }
  /**
   * Removes all child objects.
   *
   * @fires Object3D#removed
   * @fires Object3D#childremoved
   * @return {Object3D} A reference to this instance.
   */
  clear() {
    return this.remove(...this.children);
  }
  /**
   * Adds the given 3D object as a child of this 3D object, while maintaining the object's world
   * transform. This method does not support scene graphs having non-uniformly-scaled nodes(s).
   *
   * @fires Object3D#added
   * @fires Object3D#childadded
   * @param {Object3D} object - The 3D object to attach.
   * @return {Object3D} A reference to this instance.
   */
  attach(e) {
    return this.updateWorldMatrix(!0, !1), In.copy(this.matrixWorld).invert(), e.parent !== null && (e.parent.updateWorldMatrix(!0, !1), In.multiply(e.parent.matrixWorld)), e.applyMatrix4(In), e.removeFromParent(), e.parent = this, this.children.push(e), e.updateWorldMatrix(!1, !0), e.dispatchEvent(Jo), Ii.child = e, this.dispatchEvent(Ii), Ii.child = null, this;
  }
  /**
   * Searches through the 3D object and its children, starting with the 3D object
   * itself, and returns the first with a matching ID.
   *
   * @param {number} id - The id.
   * @return {Object3D|undefined} The found 3D object. Returns `undefined` if no 3D object has been found.
   */
  getObjectById(e) {
    return this.getObjectByProperty("id", e);
  }
  /**
   * Searches through the 3D object and its children, starting with the 3D object
   * itself, and returns the first with a matching name.
   *
   * @param {string} name - The name.
   * @return {Object3D|undefined} The found 3D object. Returns `undefined` if no 3D object has been found.
   */
  getObjectByName(e) {
    return this.getObjectByProperty("name", e);
  }
  /**
   * Searches through the 3D object and its children, starting with the 3D object
   * itself, and returns the first with a matching property value.
   *
   * @param {string} name - The name of the property.
   * @param {any} value - The value.
   * @return {Object3D|undefined} The found 3D object. Returns `undefined` if no 3D object has been found.
   */
  getObjectByProperty(e, t) {
    if (this[e] === t) return this;
    for (let n = 0, i = this.children.length; n < i; n++) {
      const a = this.children[n].getObjectByProperty(e, t);
      if (a !== void 0)
        return a;
    }
  }
  /**
   * Searches through the 3D object and its children, starting with the 3D object
   * itself, and returns all 3D objects with a matching property value.
   *
   * @param {string} name - The name of the property.
   * @param {any} value - The value.
   * @param {Array<Object3D>} result - The method stores the result in this array.
   * @return {Array<Object3D>} The found 3D objects.
   */
  getObjectsByProperty(e, t, n = []) {
    this[e] === t && n.push(this);
    const i = this.children;
    for (let s = 0, a = i.length; s < a; s++)
      i[s].getObjectsByProperty(e, t, n);
    return n;
  }
  /**
   * Returns a vector representing the position of the 3D object in world space.
   *
   * @param {Vector3} target - The target vector the result is stored to.
   * @return {Vector3} The 3D object's position in world space.
   */
  getWorldPosition(e) {
    return this.updateWorldMatrix(!0, !1), e.setFromMatrixPosition(this.matrixWorld);
  }
  /**
   * Returns a Quaternion representing the position of the 3D object in world space.
   *
   * @param {Quaternion} target - The target Quaternion the result is stored to.
   * @return {Quaternion} The 3D object's rotation in world space.
   */
  getWorldQuaternion(e) {
    return this.updateWorldMatrix(!0, !1), this.matrixWorld.decompose(dr, e, ch), e;
  }
  /**
   * Returns a vector representing the scale of the 3D object in world space.
   *
   * @param {Vector3} target - The target vector the result is stored to.
   * @return {Vector3} The 3D object's scale in world space.
   */
  getWorldScale(e) {
    return this.updateWorldMatrix(!0, !1), this.matrixWorld.decompose(dr, uh, e), e;
  }
  /**
   * Returns a vector representing the ("look") direction of the 3D object in world space.
   *
   * @param {Vector3} target - The target vector the result is stored to.
   * @return {Vector3} The 3D object's direction in world space.
   */
  getWorldDirection(e) {
    this.updateWorldMatrix(!0, !1);
    const t = this.matrixWorld.elements;
    return e.set(t[8], t[9], t[10]).normalize();
  }
  /**
   * Abstract method to get intersections between a casted ray and this
   * 3D object. Renderable 3D objects such as {@link Mesh}, {@link Line} or {@link Points}
   * implement this method in order to use raycasting.
   *
   * @abstract
   * @param {Raycaster} raycaster - The raycaster.
   * @param {Array<Object>} intersects - An array holding the result of the method.
   */
  raycast() {
  }
  /**
   * Executes the callback on this 3D object and all descendants.
   *
   * Note: Modifying the scene graph inside the callback is discouraged.
   *
   * @param {Function} callback - A callback function that allows to process the current 3D object.
   */
  traverse(e) {
    e(this);
    const t = this.children;
    for (let n = 0, i = t.length; n < i; n++)
      t[n].traverse(e);
  }
  /**
   * Like {@link Object3D#traverse}, but the callback will only be executed for visible 3D objects.
   * Descendants of invisible 3D objects are not traversed.
   *
   * Note: Modifying the scene graph inside the callback is discouraged.
   *
   * @param {Function} callback - A callback function that allows to process the current 3D object.
   */
  traverseVisible(e) {
    if (this.visible === !1) return;
    e(this);
    const t = this.children;
    for (let n = 0, i = t.length; n < i; n++)
      t[n].traverseVisible(e);
  }
  /**
   * Like {@link Object3D#traverse}, but the callback will only be executed for all ancestors.
   *
   * Note: Modifying the scene graph inside the callback is discouraged.
   *
   * @param {Function} callback - A callback function that allows to process the current 3D object.
   */
  traverseAncestors(e) {
    const t = this.parent;
    t !== null && (e(t), t.traverseAncestors(e));
  }
  /**
   * Updates the transformation matrix in local space by computing it from the current
   * position, rotation and scale values.
   */
  updateMatrix() {
    this.matrix.compose(this.position, this.quaternion, this.scale), this.matrixWorldNeedsUpdate = !0;
  }
  /**
   * Updates the transformation matrix in world space of this 3D objects and its descendants.
   *
   * To ensure correct results, this method also recomputes the 3D object's transformation matrix in
   * local space. The computation of the local and world matrix can be controlled with the
   * {@link Object3D#matrixAutoUpdate} and {@link Object3D#matrixWorldAutoUpdate} flags which are both
   * `true` by default.  Set these flags to `false` if you need more control over the update matrix process.
   *
   * @param {boolean} [force=false] - When set to `true`, a recomputation of world matrices is forced even
   * when {@link Object3D#matrixWorldAutoUpdate} is set to `false`.
   */
  updateMatrixWorld(e) {
    this.matrixAutoUpdate && this.updateMatrix(), (this.matrixWorldNeedsUpdate || e) && (this.matrixWorldAutoUpdate === !0 && (this.parent === null ? this.matrixWorld.copy(this.matrix) : this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix)), this.matrixWorldNeedsUpdate = !1, e = !0);
    const t = this.children;
    for (let n = 0, i = t.length; n < i; n++)
      t[n].updateMatrixWorld(e);
  }
  /**
   * An alternative version of {@link Object3D#updateMatrixWorld} with more control over the
   * update of ancestor and descendant nodes.
   *
   * @param {boolean} [updateParents=false] Whether ancestor nodes should be updated or not.
   * @param {boolean} [updateChildren=false] Whether descendant nodes should be updated or not.
   */
  updateWorldMatrix(e, t) {
    const n = this.parent;
    if (e === !0 && n !== null && n.updateWorldMatrix(!0, !1), this.matrixAutoUpdate && this.updateMatrix(), this.matrixWorldAutoUpdate === !0 && (this.parent === null ? this.matrixWorld.copy(this.matrix) : this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix)), t === !0) {
      const i = this.children;
      for (let s = 0, a = i.length; s < a; s++)
        i[s].updateWorldMatrix(!1, !0);
    }
  }
  /**
   * Serializes the 3D object into JSON.
   *
   * @param {?(Object|string)} meta - An optional value holding meta information about the serialization.
   * @return {Object} A JSON object representing the serialized 3D object.
   * @see {@link ObjectLoader#parse}
   */
  toJSON(e) {
    const t = e === void 0 || typeof e == "string", n = {};
    t && (e = {
      geometries: {},
      materials: {},
      textures: {},
      images: {},
      shapes: {},
      skeletons: {},
      animations: {},
      nodes: {}
    }, n.metadata = {
      version: 4.7,
      type: "Object",
      generator: "Object3D.toJSON"
    });
    const i = {};
    i.uuid = this.uuid, i.type = this.type, this.name !== "" && (i.name = this.name), this.castShadow === !0 && (i.castShadow = !0), this.receiveShadow === !0 && (i.receiveShadow = !0), this.visible === !1 && (i.visible = !1), this.frustumCulled === !1 && (i.frustumCulled = !1), this.renderOrder !== 0 && (i.renderOrder = this.renderOrder), Object.keys(this.userData).length > 0 && (i.userData = this.userData), i.layers = this.layers.mask, i.matrix = this.matrix.toArray(), i.up = this.up.toArray(), this.matrixAutoUpdate === !1 && (i.matrixAutoUpdate = !1), this.isInstancedMesh && (i.type = "InstancedMesh", i.count = this.count, i.instanceMatrix = this.instanceMatrix.toJSON(), this.instanceColor !== null && (i.instanceColor = this.instanceColor.toJSON())), this.isBatchedMesh && (i.type = "BatchedMesh", i.perObjectFrustumCulled = this.perObjectFrustumCulled, i.sortObjects = this.sortObjects, i.drawRanges = this._drawRanges, i.reservedRanges = this._reservedRanges, i.geometryInfo = this._geometryInfo.map((o) => ({
      ...o,
      boundingBox: o.boundingBox ? o.boundingBox.toJSON() : void 0,
      boundingSphere: o.boundingSphere ? o.boundingSphere.toJSON() : void 0
    })), i.instanceInfo = this._instanceInfo.map((o) => ({ ...o })), i.availableInstanceIds = this._availableInstanceIds.slice(), i.availableGeometryIds = this._availableGeometryIds.slice(), i.nextIndexStart = this._nextIndexStart, i.nextVertexStart = this._nextVertexStart, i.geometryCount = this._geometryCount, i.maxInstanceCount = this._maxInstanceCount, i.maxVertexCount = this._maxVertexCount, i.maxIndexCount = this._maxIndexCount, i.geometryInitialized = this._geometryInitialized, i.matricesTexture = this._matricesTexture.toJSON(e), i.indirectTexture = this._indirectTexture.toJSON(e), this._colorsTexture !== null && (i.colorsTexture = this._colorsTexture.toJSON(e)), this.boundingSphere !== null && (i.boundingSphere = this.boundingSphere.toJSON()), this.boundingBox !== null && (i.boundingBox = this.boundingBox.toJSON()));
    function s(o, c) {
      return o[c.uuid] === void 0 && (o[c.uuid] = c.toJSON(e)), c.uuid;
    }
    if (this.isScene)
      this.background && (this.background.isColor ? i.background = this.background.toJSON() : this.background.isTexture && (i.background = this.background.toJSON(e).uuid)), this.environment && this.environment.isTexture && this.environment.isRenderTargetTexture !== !0 && (i.environment = this.environment.toJSON(e).uuid);
    else if (this.isMesh || this.isLine || this.isPoints) {
      i.geometry = s(e.geometries, this.geometry);
      const o = this.geometry.parameters;
      if (o !== void 0 && o.shapes !== void 0) {
        const c = o.shapes;
        if (Array.isArray(c))
          for (let l = 0, u = c.length; l < u; l++) {
            const h = c[l];
            s(e.shapes, h);
          }
        else
          s(e.shapes, c);
      }
    }
    if (this.isSkinnedMesh && (i.bindMode = this.bindMode, i.bindMatrix = this.bindMatrix.toArray(), this.skeleton !== void 0 && (s(e.skeletons, this.skeleton), i.skeleton = this.skeleton.uuid)), this.material !== void 0)
      if (Array.isArray(this.material)) {
        const o = [];
        for (let c = 0, l = this.material.length; c < l; c++)
          o.push(s(e.materials, this.material[c]));
        i.material = o;
      } else
        i.material = s(e.materials, this.material);
    if (this.children.length > 0) {
      i.children = [];
      for (let o = 0; o < this.children.length; o++)
        i.children.push(this.children[o].toJSON(e).object);
    }
    if (this.animations.length > 0) {
      i.animations = [];
      for (let o = 0; o < this.animations.length; o++) {
        const c = this.animations[o];
        i.animations.push(s(e.animations, c));
      }
    }
    if (t) {
      const o = a(e.geometries), c = a(e.materials), l = a(e.textures), u = a(e.images), h = a(e.shapes), f = a(e.skeletons), d = a(e.animations), g = a(e.nodes);
      o.length > 0 && (n.geometries = o), c.length > 0 && (n.materials = c), l.length > 0 && (n.textures = l), u.length > 0 && (n.images = u), h.length > 0 && (n.shapes = h), f.length > 0 && (n.skeletons = f), d.length > 0 && (n.animations = d), g.length > 0 && (n.nodes = g);
    }
    return n.object = i, n;
    function a(o) {
      const c = [];
      for (const l in o) {
        const u = o[l];
        delete u.metadata, c.push(u);
      }
      return c;
    }
  }
  /**
   * Returns a new 3D object with copied values from this instance.
   *
   * @param {boolean} [recursive=true] - When set to `true`, descendants of the 3D object are also cloned.
   * @return {Object3D} A clone of this instance.
   */
  clone(e) {
    return new this.constructor().copy(this, e);
  }
  /**
   * Copies the values of the given 3D object to this instance.
   *
   * @param {Object3D} source - The 3D object to copy.
   * @param {boolean} [recursive=true] - When set to `true`, descendants of the 3D object are cloned.
   * @return {Object3D} A reference to this instance.
   */
  copy(e, t = !0) {
    if (this.name = e.name, this.up.copy(e.up), this.position.copy(e.position), this.rotation.order = e.rotation.order, this.quaternion.copy(e.quaternion), this.scale.copy(e.scale), this.matrix.copy(e.matrix), this.matrixWorld.copy(e.matrixWorld), this.matrixAutoUpdate = e.matrixAutoUpdate, this.matrixWorldAutoUpdate = e.matrixWorldAutoUpdate, this.matrixWorldNeedsUpdate = e.matrixWorldNeedsUpdate, this.layers.mask = e.layers.mask, this.visible = e.visible, this.castShadow = e.castShadow, this.receiveShadow = e.receiveShadow, this.frustumCulled = e.frustumCulled, this.renderOrder = e.renderOrder, this.animations = e.animations.slice(), this.userData = JSON.parse(JSON.stringify(e.userData)), t === !0)
      for (let n = 0; n < e.children.length; n++) {
        const i = e.children[n];
        this.add(i.clone());
      }
    return this;
  }
}
Bt.DEFAULT_UP = /* @__PURE__ */ new I(0, 1, 0);
Bt.DEFAULT_MATRIX_AUTO_UPDATE = !0;
Bt.DEFAULT_MATRIX_WORLD_AUTO_UPDATE = !0;
const Mn = /* @__PURE__ */ new I(), Nn = /* @__PURE__ */ new I(), fa = /* @__PURE__ */ new I(), On = /* @__PURE__ */ new I(), Ni = /* @__PURE__ */ new I(), Oi = /* @__PURE__ */ new I(), Qo = /* @__PURE__ */ new I(), da = /* @__PURE__ */ new I(), pa = /* @__PURE__ */ new I(), ma = /* @__PURE__ */ new I(), _a = /* @__PURE__ */ new xt(), ga = /* @__PURE__ */ new xt(), va = /* @__PURE__ */ new xt();
class mn {
  /**
   * Constructs a new triangle.
   *
   * @param {Vector3} [a=(0,0,0)] - The first corner of the triangle.
   * @param {Vector3} [b=(0,0,0)] - The second corner of the triangle.
   * @param {Vector3} [c=(0,0,0)] - The third corner of the triangle.
   */
  constructor(e = new I(), t = new I(), n = new I()) {
    this.a = e, this.b = t, this.c = n;
  }
  /**
   * Computes the normal vector of a triangle.
   *
   * @param {Vector3} a - The first corner of the triangle.
   * @param {Vector3} b - The second corner of the triangle.
   * @param {Vector3} c - The third corner of the triangle.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} The triangle's normal.
   */
  static getNormal(e, t, n, i) {
    i.subVectors(n, t), Mn.subVectors(e, t), i.cross(Mn);
    const s = i.lengthSq();
    return s > 0 ? i.multiplyScalar(1 / Math.sqrt(s)) : i.set(0, 0, 0);
  }
  /**
   * Computes a barycentric coordinates from the given vector.
   * Returns `null` if the triangle is degenerate.
   *
   * @param {Vector3} point - A point in 3D space.
   * @param {Vector3} a - The first corner of the triangle.
   * @param {Vector3} b - The second corner of the triangle.
   * @param {Vector3} c - The third corner of the triangle.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {?Vector3} The barycentric coordinates for the given point
   */
  static getBarycoord(e, t, n, i, s) {
    Mn.subVectors(i, t), Nn.subVectors(n, t), fa.subVectors(e, t);
    const a = Mn.dot(Mn), o = Mn.dot(Nn), c = Mn.dot(fa), l = Nn.dot(Nn), u = Nn.dot(fa), h = a * l - o * o;
    if (h === 0)
      return s.set(0, 0, 0), null;
    const f = 1 / h, d = (l * c - o * u) * f, g = (a * u - o * c) * f;
    return s.set(1 - d - g, g, d);
  }
  /**
   * Returns `true` if the given point, when projected onto the plane of the
   * triangle, lies within the triangle.
   *
   * @param {Vector3} point - The point in 3D space to test.
   * @param {Vector3} a - The first corner of the triangle.
   * @param {Vector3} b - The second corner of the triangle.
   * @param {Vector3} c - The third corner of the triangle.
   * @return {boolean} Whether the given point, when projected onto the plane of the
   * triangle, lies within the triangle or not.
   */
  static containsPoint(e, t, n, i) {
    return this.getBarycoord(e, t, n, i, On) === null ? !1 : On.x >= 0 && On.y >= 0 && On.x + On.y <= 1;
  }
  /**
   * Computes the value barycentrically interpolated for the given point on the
   * triangle. Returns `null` if the triangle is degenerate.
   *
   * @param {Vector3} point - Position of interpolated point.
   * @param {Vector3} p1 - The first corner of the triangle.
   * @param {Vector3} p2 - The second corner of the triangle.
   * @param {Vector3} p3 - The third corner of the triangle.
   * @param {Vector3} v1 - Value to interpolate of first vertex.
   * @param {Vector3} v2 - Value to interpolate of second vertex.
   * @param {Vector3} v3 - Value to interpolate of third vertex.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {?Vector3} The interpolated value.
   */
  static getInterpolation(e, t, n, i, s, a, o, c) {
    return this.getBarycoord(e, t, n, i, On) === null ? (c.x = 0, c.y = 0, "z" in c && (c.z = 0), "w" in c && (c.w = 0), null) : (c.setScalar(0), c.addScaledVector(s, On.x), c.addScaledVector(a, On.y), c.addScaledVector(o, On.z), c);
  }
  /**
   * Computes the value barycentrically interpolated for the given attribute and indices.
   *
   * @param {BufferAttribute} attr - The attribute to interpolate.
   * @param {number} i1 - Index of first vertex.
   * @param {number} i2 - Index of second vertex.
   * @param {number} i3 - Index of third vertex.
   * @param {Vector3} barycoord - The barycoordinate value to use to interpolate.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} The interpolated attribute value.
   */
  static getInterpolatedAttribute(e, t, n, i, s, a) {
    return _a.setScalar(0), ga.setScalar(0), va.setScalar(0), _a.fromBufferAttribute(e, t), ga.fromBufferAttribute(e, n), va.fromBufferAttribute(e, i), a.setScalar(0), a.addScaledVector(_a, s.x), a.addScaledVector(ga, s.y), a.addScaledVector(va, s.z), a;
  }
  /**
   * Returns `true` if the triangle is oriented towards the given direction.
   *
   * @param {Vector3} a - The first corner of the triangle.
   * @param {Vector3} b - The second corner of the triangle.
   * @param {Vector3} c - The third corner of the triangle.
   * @param {Vector3} direction - The (normalized) direction vector.
   * @return {boolean} Whether the triangle is oriented towards the given direction or not.
   */
  static isFrontFacing(e, t, n, i) {
    return Mn.subVectors(n, t), Nn.subVectors(e, t), Mn.cross(Nn).dot(i) < 0;
  }
  /**
   * Sets the triangle's vertices by copying the given values.
   *
   * @param {Vector3} a - The first corner of the triangle.
   * @param {Vector3} b - The second corner of the triangle.
   * @param {Vector3} c - The third corner of the triangle.
   * @return {Triangle} A reference to this triangle.
   */
  set(e, t, n) {
    return this.a.copy(e), this.b.copy(t), this.c.copy(n), this;
  }
  /**
   * Sets the triangle's vertices by copying the given array values.
   *
   * @param {Array<Vector3>} points - An array with 3D points.
   * @param {number} i0 - The array index representing the first corner of the triangle.
   * @param {number} i1 - The array index representing the second corner of the triangle.
   * @param {number} i2 - The array index representing the third corner of the triangle.
   * @return {Triangle} A reference to this triangle.
   */
  setFromPointsAndIndices(e, t, n, i) {
    return this.a.copy(e[t]), this.b.copy(e[n]), this.c.copy(e[i]), this;
  }
  /**
   * Sets the triangle's vertices by copying the given attribute values.
   *
   * @param {BufferAttribute} attribute - A buffer attribute with 3D points data.
   * @param {number} i0 - The attribute index representing the first corner of the triangle.
   * @param {number} i1 - The attribute index representing the second corner of the triangle.
   * @param {number} i2 - The attribute index representing the third corner of the triangle.
   * @return {Triangle} A reference to this triangle.
   */
  setFromAttributeAndIndices(e, t, n, i) {
    return this.a.fromBufferAttribute(e, t), this.b.fromBufferAttribute(e, n), this.c.fromBufferAttribute(e, i), this;
  }
  /**
   * Returns a new triangle with copied values from this instance.
   *
   * @return {Triangle} A clone of this instance.
   */
  clone() {
    return new this.constructor().copy(this);
  }
  /**
   * Copies the values of the given triangle to this instance.
   *
   * @param {Triangle} triangle - The triangle to copy.
   * @return {Triangle} A reference to this triangle.
   */
  copy(e) {
    return this.a.copy(e.a), this.b.copy(e.b), this.c.copy(e.c), this;
  }
  /**
   * Computes the area of the triangle.
   *
   * @return {number} The triangle's area.
   */
  getArea() {
    return Mn.subVectors(this.c, this.b), Nn.subVectors(this.a, this.b), Mn.cross(Nn).length() * 0.5;
  }
  /**
   * Computes the midpoint of the triangle.
   *
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} The triangle's midpoint.
   */
  getMidpoint(e) {
    return e.addVectors(this.a, this.b).add(this.c).multiplyScalar(1 / 3);
  }
  /**
   * Computes the normal of the triangle.
   *
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} The triangle's normal.
   */
  getNormal(e) {
    return mn.getNormal(this.a, this.b, this.c, e);
  }
  /**
   * Computes a plane the triangle lies within.
   *
   * @param {Plane} target - The target vector that is used to store the method's result.
   * @return {Plane} The plane the triangle lies within.
   */
  getPlane(e) {
    return e.setFromCoplanarPoints(this.a, this.b, this.c);
  }
  /**
   * Computes a barycentric coordinates from the given vector.
   * Returns `null` if the triangle is degenerate.
   *
   * @param {Vector3} point - A point in 3D space.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {?Vector3} The barycentric coordinates for the given point
   */
  getBarycoord(e, t) {
    return mn.getBarycoord(e, this.a, this.b, this.c, t);
  }
  /**
   * Computes the value barycentrically interpolated for the given point on the
   * triangle. Returns `null` if the triangle is degenerate.
   *
   * @param {Vector3} point - Position of interpolated point.
   * @param {Vector3} v1 - Value to interpolate of first vertex.
   * @param {Vector3} v2 - Value to interpolate of second vertex.
   * @param {Vector3} v3 - Value to interpolate of third vertex.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {?Vector3} The interpolated value.
   */
  getInterpolation(e, t, n, i, s) {
    return mn.getInterpolation(e, this.a, this.b, this.c, t, n, i, s);
  }
  /**
   * Returns `true` if the given point, when projected onto the plane of the
   * triangle, lies within the triangle.
   *
   * @param {Vector3} point - The point in 3D space to test.
   * @return {boolean} Whether the given point, when projected onto the plane of the
   * triangle, lies within the triangle or not.
   */
  containsPoint(e) {
    return mn.containsPoint(e, this.a, this.b, this.c);
  }
  /**
   * Returns `true` if the triangle is oriented towards the given direction.
   *
   * @param {Vector3} direction - The (normalized) direction vector.
   * @return {boolean} Whether the triangle is oriented towards the given direction or not.
   */
  isFrontFacing(e) {
    return mn.isFrontFacing(this.a, this.b, this.c, e);
  }
  /**
   * Returns `true` if this triangle intersects with the given box.
   *
   * @param {Box3} box - The box to intersect.
   * @return {boolean} Whether this triangle intersects with the given box or not.
   */
  intersectsBox(e) {
    return e.intersectsTriangle(this);
  }
  /**
   * Returns the closest point on the triangle to the given point.
   *
   * @param {Vector3} p - The point to compute the closest point for.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} The closest point on the triangle.
   */
  closestPointToPoint(e, t) {
    const n = this.a, i = this.b, s = this.c;
    let a, o;
    Ni.subVectors(i, n), Oi.subVectors(s, n), da.subVectors(e, n);
    const c = Ni.dot(da), l = Oi.dot(da);
    if (c <= 0 && l <= 0)
      return t.copy(n);
    pa.subVectors(e, i);
    const u = Ni.dot(pa), h = Oi.dot(pa);
    if (u >= 0 && h <= u)
      return t.copy(i);
    const f = c * h - u * l;
    if (f <= 0 && c >= 0 && u <= 0)
      return a = c / (c - u), t.copy(n).addScaledVector(Ni, a);
    ma.subVectors(e, s);
    const d = Ni.dot(ma), g = Oi.dot(ma);
    if (g >= 0 && d <= g)
      return t.copy(s);
    const _ = d * l - c * g;
    if (_ <= 0 && l >= 0 && g <= 0)
      return o = l / (l - g), t.copy(n).addScaledVector(Oi, o);
    const m = u * g - d * h;
    if (m <= 0 && h - u >= 0 && d - g >= 0)
      return Qo.subVectors(s, i), o = (h - u) / (h - u + (d - g)), t.copy(i).addScaledVector(Qo, o);
    const p = 1 / (m + _ + f);
    return a = _ * p, o = f * p, t.copy(n).addScaledVector(Ni, a).addScaledVector(Oi, o);
  }
  /**
   * Returns `true` if this triangle is equal with the given one.
   *
   * @param {Triangle} triangle - The triangle to test for equality.
   * @return {boolean} Whether this triangle is equal with the given one.
   */
  equals(e) {
    return e.a.equals(this.a) && e.b.equals(this.b) && e.c.equals(this.c);
  }
}
const lc = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
}, Kn = { h: 0, s: 0, l: 0 }, ss = { h: 0, s: 0, l: 0 };
function xa(r, e, t) {
  return t < 0 && (t += 1), t > 1 && (t -= 1), t < 1 / 6 ? r + (e - r) * 6 * t : t < 1 / 2 ? e : t < 2 / 3 ? r + (e - r) * 6 * (2 / 3 - t) : r;
}
class Ge {
  /**
   * Constructs a new color.
   *
   * Note that standard method of specifying color in three.js is with a hexadecimal triplet,
   * and that method is used throughout the rest of the documentation.
   *
   * @param {(number|string|Color)} [r] - The red component of the color. If `g` and `b` are
   * not provided, it can be hexadecimal triplet, a CSS-style string or another `Color` instance.
   * @param {number} [g] - The green component.
   * @param {number} [b] - The blue component.
   */
  constructor(e, t, n) {
    return this.isColor = !0, this.r = 1, this.g = 1, this.b = 1, this.set(e, t, n);
  }
  /**
   * Sets the colors's components from the given values.
   *
   * @param {(number|string|Color)} [r] - The red component of the color. If `g` and `b` are
   * not provided, it can be hexadecimal triplet, a CSS-style string or another `Color` instance.
   * @param {number} [g] - The green component.
   * @param {number} [b] - The blue component.
   * @return {Color} A reference to this color.
   */
  set(e, t, n) {
    if (t === void 0 && n === void 0) {
      const i = e;
      i && i.isColor ? this.copy(i) : typeof i == "number" ? this.setHex(i) : typeof i == "string" && this.setStyle(i);
    } else
      this.setRGB(e, t, n);
    return this;
  }
  /**
   * Sets the colors's components to the given scalar value.
   *
   * @param {number} scalar - The scalar value.
   * @return {Color} A reference to this color.
   */
  setScalar(e) {
    return this.r = e, this.g = e, this.b = e, this;
  }
  /**
   * Sets this color from a hexadecimal value.
   *
   * @param {number} hex - The hexadecimal value.
   * @param {string} [colorSpace=SRGBColorSpace] - The color space.
   * @return {Color} A reference to this color.
   */
  setHex(e, t = Tt) {
    return e = Math.floor(e), this.r = (e >> 16 & 255) / 255, this.g = (e >> 8 & 255) / 255, this.b = (e & 255) / 255, qe.colorSpaceToWorking(this, t), this;
  }
  /**
   * Sets this color from RGB values.
   *
   * @param {number} r - Red channel value between `0.0` and `1.0`.
   * @param {number} g - Green channel value between `0.0` and `1.0`.
   * @param {number} b - Blue channel value between `0.0` and `1.0`.
   * @param {string} [colorSpace=ColorManagement.workingColorSpace] - The color space.
   * @return {Color} A reference to this color.
   */
  setRGB(e, t, n, i = qe.workingColorSpace) {
    return this.r = e, this.g = t, this.b = n, qe.colorSpaceToWorking(this, i), this;
  }
  /**
   * Sets this color from RGB values.
   *
   * @param {number} h - Hue value between `0.0` and `1.0`.
   * @param {number} s - Saturation value between `0.0` and `1.0`.
   * @param {number} l - Lightness value between `0.0` and `1.0`.
   * @param {string} [colorSpace=ColorManagement.workingColorSpace] - The color space.
   * @return {Color} A reference to this color.
   */
  setHSL(e, t, n, i = qe.workingColorSpace) {
    if (e = so(e, 1), t = ze(t, 0, 1), n = ze(n, 0, 1), t === 0)
      this.r = this.g = this.b = n;
    else {
      const s = n <= 0.5 ? n * (1 + t) : n + t - n * t, a = 2 * n - s;
      this.r = xa(a, s, e + 1 / 3), this.g = xa(a, s, e), this.b = xa(a, s, e - 1 / 3);
    }
    return qe.colorSpaceToWorking(this, i), this;
  }
  /**
   * Sets this color from a CSS-style string. For example, `rgb(250, 0,0)`,
   * `rgb(100%, 0%, 0%)`, `hsl(0, 100%, 50%)`, `#ff0000`, `#f00`, or `red` ( or
   * any [X11 color name](https://en.wikipedia.org/wiki/X11_color_names#Color_name_chart) -
   * all 140 color names are supported).
   *
   * @param {string} style - Color as a CSS-style string.
   * @param {string} [colorSpace=SRGBColorSpace] - The color space.
   * @return {Color} A reference to this color.
   */
  setStyle(e, t = Tt) {
    function n(s) {
      s !== void 0 && parseFloat(s) < 1 && Ce("Color: Alpha component of " + e + " will be ignored.");
    }
    let i;
    if (i = /^(\w+)\(([^\)]*)\)/.exec(e)) {
      let s;
      const a = i[1], o = i[2];
      switch (a) {
        case "rgb":
        case "rgba":
          if (s = /^\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(o))
            return n(s[4]), this.setRGB(
              Math.min(255, parseInt(s[1], 10)) / 255,
              Math.min(255, parseInt(s[2], 10)) / 255,
              Math.min(255, parseInt(s[3], 10)) / 255,
              t
            );
          if (s = /^\s*(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(o))
            return n(s[4]), this.setRGB(
              Math.min(100, parseInt(s[1], 10)) / 100,
              Math.min(100, parseInt(s[2], 10)) / 100,
              Math.min(100, parseInt(s[3], 10)) / 100,
              t
            );
          break;
        case "hsl":
        case "hsla":
          if (s = /^\s*(\d*\.?\d+)\s*,\s*(\d*\.?\d+)\%\s*,\s*(\d*\.?\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(o))
            return n(s[4]), this.setHSL(
              parseFloat(s[1]) / 360,
              parseFloat(s[2]) / 100,
              parseFloat(s[3]) / 100,
              t
            );
          break;
        default:
          Ce("Color: Unknown color model " + e);
      }
    } else if (i = /^\#([A-Fa-f\d]+)$/.exec(e)) {
      const s = i[1], a = s.length;
      if (a === 3)
        return this.setRGB(
          parseInt(s.charAt(0), 16) / 15,
          parseInt(s.charAt(1), 16) / 15,
          parseInt(s.charAt(2), 16) / 15,
          t
        );
      if (a === 6)
        return this.setHex(parseInt(s, 16), t);
      Ce("Color: Invalid hex color " + e);
    } else if (e && e.length > 0)
      return this.setColorName(e, t);
    return this;
  }
  /**
   * Sets this color from a color name. Faster than {@link Color#setStyle} if
   * you don't need the other CSS-style formats.
   *
   * For convenience, the list of names is exposed in `Color.NAMES` as a hash.
   * ```js
   * Color.NAMES.aliceblue // returns 0xF0F8FF
   * ```
   *
   * @param {string} style - The color name.
   * @param {string} [colorSpace=SRGBColorSpace] - The color space.
   * @return {Color} A reference to this color.
   */
  setColorName(e, t = Tt) {
    const n = lc[e.toLowerCase()];
    return n !== void 0 ? this.setHex(n, t) : Ce("Color: Unknown color " + e), this;
  }
  /**
   * Returns a new color with copied values from this instance.
   *
   * @return {Color} A clone of this instance.
   */
  clone() {
    return new this.constructor(this.r, this.g, this.b);
  }
  /**
   * Copies the values of the given color to this instance.
   *
   * @param {Color} color - The color to copy.
   * @return {Color} A reference to this color.
   */
  copy(e) {
    return this.r = e.r, this.g = e.g, this.b = e.b, this;
  }
  /**
   * Copies the given color into this color, and then converts this color from
   * `SRGBColorSpace` to `LinearSRGBColorSpace`.
   *
   * @param {Color} color - The color to copy/convert.
   * @return {Color} A reference to this color.
   */
  copySRGBToLinear(e) {
    return this.r = kn(e.r), this.g = kn(e.g), this.b = kn(e.b), this;
  }
  /**
   * Copies the given color into this color, and then converts this color from
   * `LinearSRGBColorSpace` to `SRGBColorSpace`.
   *
   * @param {Color} color - The color to copy/convert.
   * @return {Color} A reference to this color.
   */
  copyLinearToSRGB(e) {
    return this.r = ji(e.r), this.g = ji(e.g), this.b = ji(e.b), this;
  }
  /**
   * Converts this color from `SRGBColorSpace` to `LinearSRGBColorSpace`.
   *
   * @return {Color} A reference to this color.
   */
  convertSRGBToLinear() {
    return this.copySRGBToLinear(this), this;
  }
  /**
   * Converts this color from `LinearSRGBColorSpace` to `SRGBColorSpace`.
   *
   * @return {Color} A reference to this color.
   */
  convertLinearToSRGB() {
    return this.copyLinearToSRGB(this), this;
  }
  /**
   * Returns the hexadecimal value of this color.
   *
   * @param {string} [colorSpace=SRGBColorSpace] - The color space.
   * @return {number} The hexadecimal value.
   */
  getHex(e = Tt) {
    return qe.workingToColorSpace(It.copy(this), e), Math.round(ze(It.r * 255, 0, 255)) * 65536 + Math.round(ze(It.g * 255, 0, 255)) * 256 + Math.round(ze(It.b * 255, 0, 255));
  }
  /**
   * Returns the hexadecimal value of this color as a string (for example, 'FFFFFF').
   *
   * @param {string} [colorSpace=SRGBColorSpace] - The color space.
   * @return {string} The hexadecimal value as a string.
   */
  getHexString(e = Tt) {
    return ("000000" + this.getHex(e).toString(16)).slice(-6);
  }
  /**
   * Converts the colors RGB values into the HSL format and stores them into the
   * given target object.
   *
   * @param {{h:number,s:number,l:number}} target - The target object that is used to store the method's result.
   * @param {string} [colorSpace=ColorManagement.workingColorSpace] - The color space.
   * @return {{h:number,s:number,l:number}} The HSL representation of this color.
   */
  getHSL(e, t = qe.workingColorSpace) {
    qe.workingToColorSpace(It.copy(this), t);
    const n = It.r, i = It.g, s = It.b, a = Math.max(n, i, s), o = Math.min(n, i, s);
    let c, l;
    const u = (o + a) / 2;
    if (o === a)
      c = 0, l = 0;
    else {
      const h = a - o;
      switch (l = u <= 0.5 ? h / (a + o) : h / (2 - a - o), a) {
        case n:
          c = (i - s) / h + (i < s ? 6 : 0);
          break;
        case i:
          c = (s - n) / h + 2;
          break;
        case s:
          c = (n - i) / h + 4;
          break;
      }
      c /= 6;
    }
    return e.h = c, e.s = l, e.l = u, e;
  }
  /**
   * Returns the RGB values of this color and stores them into the given target object.
   *
   * @param {Color} target - The target color that is used to store the method's result.
   * @param {string} [colorSpace=ColorManagement.workingColorSpace] - The color space.
   * @return {Color} The RGB representation of this color.
   */
  getRGB(e, t = qe.workingColorSpace) {
    return qe.workingToColorSpace(It.copy(this), t), e.r = It.r, e.g = It.g, e.b = It.b, e;
  }
  /**
   * Returns the value of this color as a CSS style string. Example: `rgb(255,0,0)`.
   *
   * @param {string} [colorSpace=SRGBColorSpace] - The color space.
   * @return {string} The CSS representation of this color.
   */
  getStyle(e = Tt) {
    qe.workingToColorSpace(It.copy(this), e);
    const t = It.r, n = It.g, i = It.b;
    return e !== Tt ? `color(${e} ${t.toFixed(3)} ${n.toFixed(3)} ${i.toFixed(3)})` : `rgb(${Math.round(t * 255)},${Math.round(n * 255)},${Math.round(i * 255)})`;
  }
  /**
   * Adds the given HSL values to this color's values.
   * Internally, this converts the color's RGB values to HSL, adds HSL
   * and then converts the color back to RGB.
   *
   * @param {number} h - Hue value between `0.0` and `1.0`.
   * @param {number} s - Saturation value between `0.0` and `1.0`.
   * @param {number} l - Lightness value between `0.0` and `1.0`.
   * @return {Color} A reference to this color.
   */
  offsetHSL(e, t, n) {
    return this.getHSL(Kn), this.setHSL(Kn.h + e, Kn.s + t, Kn.l + n);
  }
  /**
   * Adds the RGB values of the given color to the RGB values of this color.
   *
   * @param {Color} color - The color to add.
   * @return {Color} A reference to this color.
   */
  add(e) {
    return this.r += e.r, this.g += e.g, this.b += e.b, this;
  }
  /**
   * Adds the RGB values of the given colors and stores the result in this instance.
   *
   * @param {Color} color1 - The first color.
   * @param {Color} color2 - The second color.
   * @return {Color} A reference to this color.
   */
  addColors(e, t) {
    return this.r = e.r + t.r, this.g = e.g + t.g, this.b = e.b + t.b, this;
  }
  /**
   * Adds the given scalar value to the RGB values of this color.
   *
   * @param {number} s - The scalar to add.
   * @return {Color} A reference to this color.
   */
  addScalar(e) {
    return this.r += e, this.g += e, this.b += e, this;
  }
  /**
   * Subtracts the RGB values of the given color from the RGB values of this color.
   *
   * @param {Color} color - The color to subtract.
   * @return {Color} A reference to this color.
   */
  sub(e) {
    return this.r = Math.max(0, this.r - e.r), this.g = Math.max(0, this.g - e.g), this.b = Math.max(0, this.b - e.b), this;
  }
  /**
   * Multiplies the RGB values of the given color with the RGB values of this color.
   *
   * @param {Color} color - The color to multiply.
   * @return {Color} A reference to this color.
   */
  multiply(e) {
    return this.r *= e.r, this.g *= e.g, this.b *= e.b, this;
  }
  /**
   * Multiplies the given scalar value with the RGB values of this color.
   *
   * @param {number} s - The scalar to multiply.
   * @return {Color} A reference to this color.
   */
  multiplyScalar(e) {
    return this.r *= e, this.g *= e, this.b *= e, this;
  }
  /**
   * Linearly interpolates this color's RGB values toward the RGB values of the
   * given color. The alpha argument can be thought of as the ratio between
   * the two colors, where `0.0` is this color and `1.0` is the first argument.
   *
   * @param {Color} color - The color to converge on.
   * @param {number} alpha - The interpolation factor in the closed interval `[0,1]`.
   * @return {Color} A reference to this color.
   */
  lerp(e, t) {
    return this.r += (e.r - this.r) * t, this.g += (e.g - this.g) * t, this.b += (e.b - this.b) * t, this;
  }
  /**
   * Linearly interpolates between the given colors and stores the result in this instance.
   * The alpha argument can be thought of as the ratio between the two colors, where `0.0`
   * is the first and `1.0` is the second color.
   *
   * @param {Color} color1 - The first color.
   * @param {Color} color2 - The second color.
   * @param {number} alpha - The interpolation factor in the closed interval `[0,1]`.
   * @return {Color} A reference to this color.
   */
  lerpColors(e, t, n) {
    return this.r = e.r + (t.r - e.r) * n, this.g = e.g + (t.g - e.g) * n, this.b = e.b + (t.b - e.b) * n, this;
  }
  /**
   * Linearly interpolates this color's HSL values toward the HSL values of the
   * given color. It differs from {@link Color#lerp} by not interpolating straight
   * from one color to the other, but instead going through all the hues in between
   * those two colors. The alpha argument can be thought of as the ratio between
   * the two colors, where 0.0 is this color and 1.0 is the first argument.
   *
   * @param {Color} color - The color to converge on.
   * @param {number} alpha - The interpolation factor in the closed interval `[0,1]`.
   * @return {Color} A reference to this color.
   */
  lerpHSL(e, t) {
    this.getHSL(Kn), e.getHSL(ss);
    const n = Rr(Kn.h, ss.h, t), i = Rr(Kn.s, ss.s, t), s = Rr(Kn.l, ss.l, t);
    return this.setHSL(n, i, s), this;
  }
  /**
   * Sets the color's RGB components from the given 3D vector.
   *
   * @param {Vector3} v - The vector to set.
   * @return {Color} A reference to this color.
   */
  setFromVector3(e) {
    return this.r = e.x, this.g = e.y, this.b = e.z, this;
  }
  /**
   * Transforms this color with the given 3x3 matrix.
   *
   * @param {Matrix3} m - The matrix.
   * @return {Color} A reference to this color.
   */
  applyMatrix3(e) {
    const t = this.r, n = this.g, i = this.b, s = e.elements;
    return this.r = s[0] * t + s[3] * n + s[6] * i, this.g = s[1] * t + s[4] * n + s[7] * i, this.b = s[2] * t + s[5] * n + s[8] * i, this;
  }
  /**
   * Returns `true` if this color is equal with the given one.
   *
   * @param {Color} c - The color to test for equality.
   * @return {boolean} Whether this bounding color is equal with the given one.
   */
  equals(e) {
    return e.r === this.r && e.g === this.g && e.b === this.b;
  }
  /**
   * Sets this color's RGB components from the given array.
   *
   * @param {Array<number>} array - An array holding the RGB values.
   * @param {number} [offset=0] - The offset into the array.
   * @return {Color} A reference to this color.
   */
  fromArray(e, t = 0) {
    return this.r = e[t], this.g = e[t + 1], this.b = e[t + 2], this;
  }
  /**
   * Writes the RGB components of this color to the given array. If no array is provided,
   * the method returns a new instance.
   *
   * @param {Array<number>} [array=[]] - The target array holding the color components.
   * @param {number} [offset=0] - Index of the first element in the array.
   * @return {Array<number>} The color components.
   */
  toArray(e = [], t = 0) {
    return e[t] = this.r, e[t + 1] = this.g, e[t + 2] = this.b, e;
  }
  /**
   * Sets the components of this color from the given buffer attribute.
   *
   * @param {BufferAttribute} attribute - The buffer attribute holding color data.
   * @param {number} index - The index into the attribute.
   * @return {Color} A reference to this color.
   */
  fromBufferAttribute(e, t) {
    return this.r = e.getX(t), this.g = e.getY(t), this.b = e.getZ(t), this;
  }
  /**
   * This methods defines the serialization result of this class. Returns the color
   * as a hexadecimal value.
   *
   * @return {number} The hexadecimal value.
   */
  toJSON() {
    return this.getHex();
  }
  *[Symbol.iterator]() {
    yield this.r, yield this.g, yield this.b;
  }
}
const It = /* @__PURE__ */ new Ge();
Ge.NAMES = lc;
let fh = 0;
class Ai extends lr {
  /**
   * Constructs a new material.
   */
  constructor() {
    super(), this.isMaterial = !0, Object.defineProperty(this, "id", { value: fh++ }), this.uuid = Gn(), this.name = "", this.type = "Material", this.blending = 1, this.side = 0, this.vertexColors = !1, this.opacity = 1, this.transparent = !1, this.alphaHash = !1, this.blendSrc = 204, this.blendDst = 205, this.blendEquation = 100, this.blendSrcAlpha = null, this.blendDstAlpha = null, this.blendEquationAlpha = null, this.blendColor = new Ge(0, 0, 0), this.blendAlpha = 0, this.depthFunc = 3, this.depthTest = !0, this.depthWrite = !0, this.stencilWriteMask = 255, this.stencilFunc = 519, this.stencilRef = 0, this.stencilFuncMask = 255, this.stencilFail = 7680, this.stencilZFail = 7680, this.stencilZPass = 7680, this.stencilWrite = !1, this.clippingPlanes = null, this.clipIntersection = !1, this.clipShadows = !1, this.shadowSide = null, this.colorWrite = !0, this.precision = null, this.polygonOffset = !1, this.polygonOffsetFactor = 0, this.polygonOffsetUnits = 0, this.dithering = !1, this.alphaToCoverage = !1, this.premultipliedAlpha = !1, this.forceSinglePass = !1, this.allowOverride = !0, this.visible = !0, this.toneMapped = !0, this.userData = {}, this.version = 0, this._alphaTest = 0;
  }
  /**
   * Sets the alpha value to be used when running an alpha test. The material
   * will not be rendered if the opacity is lower than this value.
   *
   * @type {number}
   * @readonly
   * @default 0
   */
  get alphaTest() {
    return this._alphaTest;
  }
  set alphaTest(e) {
    this._alphaTest > 0 != e > 0 && this.version++, this._alphaTest = e;
  }
  /**
   * An optional callback that is executed immediately before the material is used to render a 3D object.
   *
   * This method can only be used when rendering with {@link WebGLRenderer}.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {Scene} scene - The scene.
   * @param {Camera} camera - The camera that is used to render the scene.
   * @param {BufferGeometry} geometry - The 3D object's geometry.
   * @param {Object3D} object - The 3D object.
   * @param {Object} group - The geometry group data.
   */
  onBeforeRender() {
  }
  /**
   * An optional callback that is executed immediately before the shader
   * program is compiled. This function is called with the shader source code
   * as a parameter. Useful for the modification of built-in materials.
   *
   * This method can only be used when rendering with {@link WebGLRenderer}. The
   * recommended approach when customizing materials is to use `WebGPURenderer` with the new
   * Node Material system and [TSL](https://github.com/mrdoob/three.js/wiki/Three.js-Shading-Language).
   *
   * @param {{vertexShader:string,fragmentShader:string,uniforms:Object}} shaderobject - The object holds the uniforms and the vertex and fragment shader source.
   * @param {WebGLRenderer} renderer - A reference to the renderer.
   */
  onBeforeCompile() {
  }
  /**
   * In case {@link Material#onBeforeCompile} is used, this callback can be used to identify
   * values of settings used in `onBeforeCompile()`, so three.js can reuse a cached
   * shader or recompile the shader for this material as needed.
   *
   * This method can only be used when rendering with {@link WebGLRenderer}.
   *
   * @return {string} The custom program cache key.
   */
  customProgramCacheKey() {
    return this.onBeforeCompile.toString();
  }
  /**
   * This method can be used to set default values from parameter objects.
   * It is a generic implementation so it can be used with different types
   * of materials.
   *
   * @param {Object} [values] - The material values to set.
   */
  setValues(e) {
    if (e !== void 0)
      for (const t in e) {
        const n = e[t];
        if (n === void 0) {
          Ce(`Material: parameter '${t}' has value of undefined.`);
          continue;
        }
        const i = this[t];
        if (i === void 0) {
          Ce(`Material: '${t}' is not a property of THREE.${this.type}.`);
          continue;
        }
        i && i.isColor ? i.set(n) : i && i.isVector3 && n && n.isVector3 ? i.copy(n) : this[t] = n;
      }
  }
  /**
   * Serializes the material into JSON.
   *
   * @param {?(Object|string)} meta - An optional value holding meta information about the serialization.
   * @return {Object} A JSON object representing the serialized material.
   * @see {@link ObjectLoader#parse}
   */
  toJSON(e) {
    const t = e === void 0 || typeof e == "string";
    t && (e = {
      textures: {},
      images: {}
    });
    const n = {
      metadata: {
        version: 4.7,
        type: "Material",
        generator: "Material.toJSON"
      }
    };
    n.uuid = this.uuid, n.type = this.type, this.name !== "" && (n.name = this.name), this.color && this.color.isColor && (n.color = this.color.getHex()), this.roughness !== void 0 && (n.roughness = this.roughness), this.metalness !== void 0 && (n.metalness = this.metalness), this.sheen !== void 0 && (n.sheen = this.sheen), this.sheenColor && this.sheenColor.isColor && (n.sheenColor = this.sheenColor.getHex()), this.sheenRoughness !== void 0 && (n.sheenRoughness = this.sheenRoughness), this.emissive && this.emissive.isColor && (n.emissive = this.emissive.getHex()), this.emissiveIntensity !== void 0 && this.emissiveIntensity !== 1 && (n.emissiveIntensity = this.emissiveIntensity), this.specular && this.specular.isColor && (n.specular = this.specular.getHex()), this.specularIntensity !== void 0 && (n.specularIntensity = this.specularIntensity), this.specularColor && this.specularColor.isColor && (n.specularColor = this.specularColor.getHex()), this.shininess !== void 0 && (n.shininess = this.shininess), this.clearcoat !== void 0 && (n.clearcoat = this.clearcoat), this.clearcoatRoughness !== void 0 && (n.clearcoatRoughness = this.clearcoatRoughness), this.clearcoatMap && this.clearcoatMap.isTexture && (n.clearcoatMap = this.clearcoatMap.toJSON(e).uuid), this.clearcoatRoughnessMap && this.clearcoatRoughnessMap.isTexture && (n.clearcoatRoughnessMap = this.clearcoatRoughnessMap.toJSON(e).uuid), this.clearcoatNormalMap && this.clearcoatNormalMap.isTexture && (n.clearcoatNormalMap = this.clearcoatNormalMap.toJSON(e).uuid, n.clearcoatNormalScale = this.clearcoatNormalScale.toArray()), this.sheenColorMap && this.sheenColorMap.isTexture && (n.sheenColorMap = this.sheenColorMap.toJSON(e).uuid), this.sheenRoughnessMap && this.sheenRoughnessMap.isTexture && (n.sheenRoughnessMap = this.sheenRoughnessMap.toJSON(e).uuid), this.dispersion !== void 0 && (n.dispersion = this.dispersion), this.iridescence !== void 0 && (n.iridescence = this.iridescence), this.iridescenceIOR !== void 0 && (n.iridescenceIOR = this.iridescenceIOR), this.iridescenceThicknessRange !== void 0 && (n.iridescenceThicknessRange = this.iridescenceThicknessRange), this.iridescenceMap && this.iridescenceMap.isTexture && (n.iridescenceMap = this.iridescenceMap.toJSON(e).uuid), this.iridescenceThicknessMap && this.iridescenceThicknessMap.isTexture && (n.iridescenceThicknessMap = this.iridescenceThicknessMap.toJSON(e).uuid), this.anisotropy !== void 0 && (n.anisotropy = this.anisotropy), this.anisotropyRotation !== void 0 && (n.anisotropyRotation = this.anisotropyRotation), this.anisotropyMap && this.anisotropyMap.isTexture && (n.anisotropyMap = this.anisotropyMap.toJSON(e).uuid), this.map && this.map.isTexture && (n.map = this.map.toJSON(e).uuid), this.matcap && this.matcap.isTexture && (n.matcap = this.matcap.toJSON(e).uuid), this.alphaMap && this.alphaMap.isTexture && (n.alphaMap = this.alphaMap.toJSON(e).uuid), this.lightMap && this.lightMap.isTexture && (n.lightMap = this.lightMap.toJSON(e).uuid, n.lightMapIntensity = this.lightMapIntensity), this.aoMap && this.aoMap.isTexture && (n.aoMap = this.aoMap.toJSON(e).uuid, n.aoMapIntensity = this.aoMapIntensity), this.bumpMap && this.bumpMap.isTexture && (n.bumpMap = this.bumpMap.toJSON(e).uuid, n.bumpScale = this.bumpScale), this.normalMap && this.normalMap.isTexture && (n.normalMap = this.normalMap.toJSON(e).uuid, n.normalMapType = this.normalMapType, n.normalScale = this.normalScale.toArray()), this.displacementMap && this.displacementMap.isTexture && (n.displacementMap = this.displacementMap.toJSON(e).uuid, n.displacementScale = this.displacementScale, n.displacementBias = this.displacementBias), this.roughnessMap && this.roughnessMap.isTexture && (n.roughnessMap = this.roughnessMap.toJSON(e).uuid), this.metalnessMap && this.metalnessMap.isTexture && (n.metalnessMap = this.metalnessMap.toJSON(e).uuid), this.emissiveMap && this.emissiveMap.isTexture && (n.emissiveMap = this.emissiveMap.toJSON(e).uuid), this.specularMap && this.specularMap.isTexture && (n.specularMap = this.specularMap.toJSON(e).uuid), this.specularIntensityMap && this.specularIntensityMap.isTexture && (n.specularIntensityMap = this.specularIntensityMap.toJSON(e).uuid), this.specularColorMap && this.specularColorMap.isTexture && (n.specularColorMap = this.specularColorMap.toJSON(e).uuid), this.envMap && this.envMap.isTexture && (n.envMap = this.envMap.toJSON(e).uuid, this.combine !== void 0 && (n.combine = this.combine)), this.envMapRotation !== void 0 && (n.envMapRotation = this.envMapRotation.toArray()), this.envMapIntensity !== void 0 && (n.envMapIntensity = this.envMapIntensity), this.reflectivity !== void 0 && (n.reflectivity = this.reflectivity), this.refractionRatio !== void 0 && (n.refractionRatio = this.refractionRatio), this.gradientMap && this.gradientMap.isTexture && (n.gradientMap = this.gradientMap.toJSON(e).uuid), this.transmission !== void 0 && (n.transmission = this.transmission), this.transmissionMap && this.transmissionMap.isTexture && (n.transmissionMap = this.transmissionMap.toJSON(e).uuid), this.thickness !== void 0 && (n.thickness = this.thickness), this.thicknessMap && this.thicknessMap.isTexture && (n.thicknessMap = this.thicknessMap.toJSON(e).uuid), this.attenuationDistance !== void 0 && this.attenuationDistance !== 1 / 0 && (n.attenuationDistance = this.attenuationDistance), this.attenuationColor !== void 0 && (n.attenuationColor = this.attenuationColor.getHex()), this.size !== void 0 && (n.size = this.size), this.shadowSide !== null && (n.shadowSide = this.shadowSide), this.sizeAttenuation !== void 0 && (n.sizeAttenuation = this.sizeAttenuation), this.blending !== 1 && (n.blending = this.blending), this.side !== 0 && (n.side = this.side), this.vertexColors === !0 && (n.vertexColors = !0), this.opacity < 1 && (n.opacity = this.opacity), this.transparent === !0 && (n.transparent = !0), this.blendSrc !== 204 && (n.blendSrc = this.blendSrc), this.blendDst !== 205 && (n.blendDst = this.blendDst), this.blendEquation !== 100 && (n.blendEquation = this.blendEquation), this.blendSrcAlpha !== null && (n.blendSrcAlpha = this.blendSrcAlpha), this.blendDstAlpha !== null && (n.blendDstAlpha = this.blendDstAlpha), this.blendEquationAlpha !== null && (n.blendEquationAlpha = this.blendEquationAlpha), this.blendColor && this.blendColor.isColor && (n.blendColor = this.blendColor.getHex()), this.blendAlpha !== 0 && (n.blendAlpha = this.blendAlpha), this.depthFunc !== 3 && (n.depthFunc = this.depthFunc), this.depthTest === !1 && (n.depthTest = this.depthTest), this.depthWrite === !1 && (n.depthWrite = this.depthWrite), this.colorWrite === !1 && (n.colorWrite = this.colorWrite), this.stencilWriteMask !== 255 && (n.stencilWriteMask = this.stencilWriteMask), this.stencilFunc !== 519 && (n.stencilFunc = this.stencilFunc), this.stencilRef !== 0 && (n.stencilRef = this.stencilRef), this.stencilFuncMask !== 255 && (n.stencilFuncMask = this.stencilFuncMask), this.stencilFail !== 7680 && (n.stencilFail = this.stencilFail), this.stencilZFail !== 7680 && (n.stencilZFail = this.stencilZFail), this.stencilZPass !== 7680 && (n.stencilZPass = this.stencilZPass), this.stencilWrite === !0 && (n.stencilWrite = this.stencilWrite), this.rotation !== void 0 && this.rotation !== 0 && (n.rotation = this.rotation), this.polygonOffset === !0 && (n.polygonOffset = !0), this.polygonOffsetFactor !== 0 && (n.polygonOffsetFactor = this.polygonOffsetFactor), this.polygonOffsetUnits !== 0 && (n.polygonOffsetUnits = this.polygonOffsetUnits), this.linewidth !== void 0 && this.linewidth !== 1 && (n.linewidth = this.linewidth), this.dashSize !== void 0 && (n.dashSize = this.dashSize), this.gapSize !== void 0 && (n.gapSize = this.gapSize), this.scale !== void 0 && (n.scale = this.scale), this.dithering === !0 && (n.dithering = !0), this.alphaTest > 0 && (n.alphaTest = this.alphaTest), this.alphaHash === !0 && (n.alphaHash = !0), this.alphaToCoverage === !0 && (n.alphaToCoverage = !0), this.premultipliedAlpha === !0 && (n.premultipliedAlpha = !0), this.forceSinglePass === !0 && (n.forceSinglePass = !0), this.allowOverride === !1 && (n.allowOverride = !1), this.wireframe === !0 && (n.wireframe = !0), this.wireframeLinewidth > 1 && (n.wireframeLinewidth = this.wireframeLinewidth), this.wireframeLinecap !== "round" && (n.wireframeLinecap = this.wireframeLinecap), this.wireframeLinejoin !== "round" && (n.wireframeLinejoin = this.wireframeLinejoin), this.flatShading === !0 && (n.flatShading = !0), this.visible === !1 && (n.visible = !1), this.toneMapped === !1 && (n.toneMapped = !1), this.fog === !1 && (n.fog = !1), Object.keys(this.userData).length > 0 && (n.userData = this.userData);
    function i(s) {
      const a = [];
      for (const o in s) {
        const c = s[o];
        delete c.metadata, a.push(c);
      }
      return a;
    }
    if (t) {
      const s = i(e.textures), a = i(e.images);
      s.length > 0 && (n.textures = s), a.length > 0 && (n.images = a);
    }
    return n;
  }
  /**
   * Returns a new material with copied values from this instance.
   *
   * @return {Material} A clone of this instance.
   */
  clone() {
    return new this.constructor().copy(this);
  }
  /**
   * Copies the values of the given material to this instance.
   *
   * @param {Material} source - The material to copy.
   * @return {Material} A reference to this instance.
   */
  copy(e) {
    this.name = e.name, this.blending = e.blending, this.side = e.side, this.vertexColors = e.vertexColors, this.opacity = e.opacity, this.transparent = e.transparent, this.blendSrc = e.blendSrc, this.blendDst = e.blendDst, this.blendEquation = e.blendEquation, this.blendSrcAlpha = e.blendSrcAlpha, this.blendDstAlpha = e.blendDstAlpha, this.blendEquationAlpha = e.blendEquationAlpha, this.blendColor.copy(e.blendColor), this.blendAlpha = e.blendAlpha, this.depthFunc = e.depthFunc, this.depthTest = e.depthTest, this.depthWrite = e.depthWrite, this.stencilWriteMask = e.stencilWriteMask, this.stencilFunc = e.stencilFunc, this.stencilRef = e.stencilRef, this.stencilFuncMask = e.stencilFuncMask, this.stencilFail = e.stencilFail, this.stencilZFail = e.stencilZFail, this.stencilZPass = e.stencilZPass, this.stencilWrite = e.stencilWrite;
    const t = e.clippingPlanes;
    let n = null;
    if (t !== null) {
      const i = t.length;
      n = new Array(i);
      for (let s = 0; s !== i; ++s)
        n[s] = t[s].clone();
    }
    return this.clippingPlanes = n, this.clipIntersection = e.clipIntersection, this.clipShadows = e.clipShadows, this.shadowSide = e.shadowSide, this.colorWrite = e.colorWrite, this.precision = e.precision, this.polygonOffset = e.polygonOffset, this.polygonOffsetFactor = e.polygonOffsetFactor, this.polygonOffsetUnits = e.polygonOffsetUnits, this.dithering = e.dithering, this.alphaTest = e.alphaTest, this.alphaHash = e.alphaHash, this.alphaToCoverage = e.alphaToCoverage, this.premultipliedAlpha = e.premultipliedAlpha, this.forceSinglePass = e.forceSinglePass, this.allowOverride = e.allowOverride, this.visible = e.visible, this.toneMapped = e.toneMapped, this.userData = JSON.parse(JSON.stringify(e.userData)), this;
  }
  /**
   * Frees the GPU-related resources allocated by this instance. Call this
   * method whenever this instance is no longer used in your app.
   *
   * @fires Material#dispose
   */
  dispose() {
    this.dispatchEvent({ type: "dispose" });
  }
  /**
   * Setting this property to `true` indicates the engine the material
   * needs to be recompiled.
   *
   * @type {boolean}
   * @default false
   * @param {boolean} value
   */
  set needsUpdate(e) {
    e === !0 && this.version++;
  }
}
class Cr extends Ai {
  /**
   * Constructs a new mesh basic material.
   *
   * @param {Object} [parameters] - An object with one or more properties
   * defining the material's appearance. Any property of the material
   * (including any property from inherited materials) can be passed
   * in here. Color values can be passed any type of value accepted
   * by {@link Color#set}.
   */
  constructor(e) {
    super(), this.isMeshBasicMaterial = !0, this.type = "MeshBasicMaterial", this.color = new Ge(16777215), this.map = null, this.lightMap = null, this.lightMapIntensity = 1, this.aoMap = null, this.aoMapIntensity = 1, this.specularMap = null, this.alphaMap = null, this.envMap = null, this.envMapRotation = new Vn(), this.combine = 0, this.reflectivity = 1, this.refractionRatio = 0.98, this.wireframe = !1, this.wireframeLinewidth = 1, this.wireframeLinecap = "round", this.wireframeLinejoin = "round", this.fog = !0, this.setValues(e);
  }
  copy(e) {
    return super.copy(e), this.color.copy(e.color), this.map = e.map, this.lightMap = e.lightMap, this.lightMapIntensity = e.lightMapIntensity, this.aoMap = e.aoMap, this.aoMapIntensity = e.aoMapIntensity, this.specularMap = e.specularMap, this.alphaMap = e.alphaMap, this.envMap = e.envMap, this.envMapRotation.copy(e.envMapRotation), this.combine = e.combine, this.reflectivity = e.reflectivity, this.refractionRatio = e.refractionRatio, this.wireframe = e.wireframe, this.wireframeLinewidth = e.wireframeLinewidth, this.wireframeLinecap = e.wireframeLinecap, this.wireframeLinejoin = e.wireframeLinejoin, this.fog = e.fog, this;
  }
}
const yt = /* @__PURE__ */ new I(), as = /* @__PURE__ */ new Ae();
let dh = 0;
class Nt {
  /**
   * Constructs a new buffer attribute.
   *
   * @param {TypedArray} array - The array holding the attribute data.
   * @param {number} itemSize - The item size.
   * @param {boolean} [normalized=false] - Whether the data are normalized or not.
   */
  constructor(e, t, n = !1) {
    if (Array.isArray(e))
      throw new TypeError("THREE.BufferAttribute: array should be a Typed Array.");
    this.isBufferAttribute = !0, Object.defineProperty(this, "id", { value: dh++ }), this.name = "", this.array = e, this.itemSize = t, this.count = e !== void 0 ? e.length / t : 0, this.normalized = n, this.usage = 35044, this.updateRanges = [], this.gpuType = 1015, this.version = 0;
  }
  /**
   * A callback function that is executed after the renderer has transferred the attribute
   * array data to the GPU.
   */
  onUploadCallback() {
  }
  /**
   * Flag to indicate that this attribute has changed and should be re-sent to
   * the GPU. Set this to `true` when you modify the value of the array.
   *
   * @type {number}
   * @default false
   * @param {boolean} value
   */
  set needsUpdate(e) {
    e === !0 && this.version++;
  }
  /**
   * Sets the usage of this buffer attribute.
   *
   * @param {(StaticDrawUsage|DynamicDrawUsage|StreamDrawUsage|StaticReadUsage|DynamicReadUsage|StreamReadUsage|StaticCopyUsage|DynamicCopyUsage|StreamCopyUsage)} value - The usage to set.
   * @return {BufferAttribute} A reference to this buffer attribute.
   */
  setUsage(e) {
    return this.usage = e, this;
  }
  /**
   * Adds a range of data in the data array to be updated on the GPU.
   *
   * @param {number} start - Position at which to start update.
   * @param {number} count - The number of components to update.
   */
  addUpdateRange(e, t) {
    this.updateRanges.push({ start: e, count: t });
  }
  /**
   * Clears the update ranges.
   */
  clearUpdateRanges() {
    this.updateRanges.length = 0;
  }
  /**
   * Copies the values of the given buffer attribute to this instance.
   *
   * @param {BufferAttribute} source - The buffer attribute to copy.
   * @return {BufferAttribute} A reference to this instance.
   */
  copy(e) {
    return this.name = e.name, this.array = new e.array.constructor(e.array), this.itemSize = e.itemSize, this.count = e.count, this.normalized = e.normalized, this.usage = e.usage, this.gpuType = e.gpuType, this;
  }
  /**
   * Copies a vector from the given buffer attribute to this one. The start
   * and destination position in the attribute buffers are represented by the
   * given indices.
   *
   * @param {number} index1 - The destination index into this buffer attribute.
   * @param {BufferAttribute} attribute - The buffer attribute to copy from.
   * @param {number} index2 - The source index into the given buffer attribute.
   * @return {BufferAttribute} A reference to this instance.
   */
  copyAt(e, t, n) {
    e *= this.itemSize, n *= t.itemSize;
    for (let i = 0, s = this.itemSize; i < s; i++)
      this.array[e + i] = t.array[n + i];
    return this;
  }
  /**
   * Copies the given array data into this buffer attribute.
   *
   * @param {(TypedArray|Array)} array - The array to copy.
   * @return {BufferAttribute} A reference to this instance.
   */
  copyArray(e) {
    return this.array.set(e), this;
  }
  /**
   * Applies the given 3x3 matrix to the given attribute. Works with
   * item size `2` and `3`.
   *
   * @param {Matrix3} m - The matrix to apply.
   * @return {BufferAttribute} A reference to this instance.
   */
  applyMatrix3(e) {
    if (this.itemSize === 2)
      for (let t = 0, n = this.count; t < n; t++)
        as.fromBufferAttribute(this, t), as.applyMatrix3(e), this.setXY(t, as.x, as.y);
    else if (this.itemSize === 3)
      for (let t = 0, n = this.count; t < n; t++)
        yt.fromBufferAttribute(this, t), yt.applyMatrix3(e), this.setXYZ(t, yt.x, yt.y, yt.z);
    return this;
  }
  /**
   * Applies the given 4x4 matrix to the given attribute. Only works with
   * item size `3`.
   *
   * @param {Matrix4} m - The matrix to apply.
   * @return {BufferAttribute} A reference to this instance.
   */
  applyMatrix4(e) {
    for (let t = 0, n = this.count; t < n; t++)
      yt.fromBufferAttribute(this, t), yt.applyMatrix4(e), this.setXYZ(t, yt.x, yt.y, yt.z);
    return this;
  }
  /**
   * Applies the given 3x3 normal matrix to the given attribute. Only works with
   * item size `3`.
   *
   * @param {Matrix3} m - The normal matrix to apply.
   * @return {BufferAttribute} A reference to this instance.
   */
  applyNormalMatrix(e) {
    for (let t = 0, n = this.count; t < n; t++)
      yt.fromBufferAttribute(this, t), yt.applyNormalMatrix(e), this.setXYZ(t, yt.x, yt.y, yt.z);
    return this;
  }
  /**
   * Applies the given 4x4 matrix to the given attribute. Only works with
   * item size `3` and with direction vectors.
   *
   * @param {Matrix4} m - The matrix to apply.
   * @return {BufferAttribute} A reference to this instance.
   */
  transformDirection(e) {
    for (let t = 0, n = this.count; t < n; t++)
      yt.fromBufferAttribute(this, t), yt.transformDirection(e), this.setXYZ(t, yt.x, yt.y, yt.z);
    return this;
  }
  /**
   * Sets the given array data in the buffer attribute.
   *
   * @param {(TypedArray|Array)} value - The array data to set.
   * @param {number} [offset=0] - The offset in this buffer attribute's array.
   * @return {BufferAttribute} A reference to this instance.
   */
  set(e, t = 0) {
    return this.array.set(e, t), this;
  }
  /**
   * Returns the given component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} component - The component index.
   * @return {number} The returned value.
   */
  getComponent(e, t) {
    let n = this.array[e * this.itemSize + t];
    return this.normalized && (n = yn(n, this.array)), n;
  }
  /**
   * Sets the given value to the given component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} component - The component index.
   * @param {number} value - The value to set.
   * @return {BufferAttribute} A reference to this instance.
   */
  setComponent(e, t, n) {
    return this.normalized && (n = et(n, this.array)), this.array[e * this.itemSize + t] = n, this;
  }
  /**
   * Returns the x component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @return {number} The x component.
   */
  getX(e) {
    let t = this.array[e * this.itemSize];
    return this.normalized && (t = yn(t, this.array)), t;
  }
  /**
   * Sets the x component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} x - The value to set.
   * @return {BufferAttribute} A reference to this instance.
   */
  setX(e, t) {
    return this.normalized && (t = et(t, this.array)), this.array[e * this.itemSize] = t, this;
  }
  /**
   * Returns the y component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @return {number} The y component.
   */
  getY(e) {
    let t = this.array[e * this.itemSize + 1];
    return this.normalized && (t = yn(t, this.array)), t;
  }
  /**
   * Sets the y component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} y - The value to set.
   * @return {BufferAttribute} A reference to this instance.
   */
  setY(e, t) {
    return this.normalized && (t = et(t, this.array)), this.array[e * this.itemSize + 1] = t, this;
  }
  /**
   * Returns the z component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @return {number} The z component.
   */
  getZ(e) {
    let t = this.array[e * this.itemSize + 2];
    return this.normalized && (t = yn(t, this.array)), t;
  }
  /**
   * Sets the z component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} z - The value to set.
   * @return {BufferAttribute} A reference to this instance.
   */
  setZ(e, t) {
    return this.normalized && (t = et(t, this.array)), this.array[e * this.itemSize + 2] = t, this;
  }
  /**
   * Returns the w component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @return {number} The w component.
   */
  getW(e) {
    let t = this.array[e * this.itemSize + 3];
    return this.normalized && (t = yn(t, this.array)), t;
  }
  /**
   * Sets the w component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} w - The value to set.
   * @return {BufferAttribute} A reference to this instance.
   */
  setW(e, t) {
    return this.normalized && (t = et(t, this.array)), this.array[e * this.itemSize + 3] = t, this;
  }
  /**
   * Sets the x and y component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} x - The value for the x component to set.
   * @param {number} y - The value for the y component to set.
   * @return {BufferAttribute} A reference to this instance.
   */
  setXY(e, t, n) {
    return e *= this.itemSize, this.normalized && (t = et(t, this.array), n = et(n, this.array)), this.array[e + 0] = t, this.array[e + 1] = n, this;
  }
  /**
   * Sets the x, y and z component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} x - The value for the x component to set.
   * @param {number} y - The value for the y component to set.
   * @param {number} z - The value for the z component to set.
   * @return {BufferAttribute} A reference to this instance.
   */
  setXYZ(e, t, n, i) {
    return e *= this.itemSize, this.normalized && (t = et(t, this.array), n = et(n, this.array), i = et(i, this.array)), this.array[e + 0] = t, this.array[e + 1] = n, this.array[e + 2] = i, this;
  }
  /**
   * Sets the x, y, z and w component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} x - The value for the x component to set.
   * @param {number} y - The value for the y component to set.
   * @param {number} z - The value for the z component to set.
   * @param {number} w - The value for the w component to set.
   * @return {BufferAttribute} A reference to this instance.
   */
  setXYZW(e, t, n, i, s) {
    return e *= this.itemSize, this.normalized && (t = et(t, this.array), n = et(n, this.array), i = et(i, this.array), s = et(s, this.array)), this.array[e + 0] = t, this.array[e + 1] = n, this.array[e + 2] = i, this.array[e + 3] = s, this;
  }
  /**
   * Sets the given callback function that is executed after the Renderer has transferred
   * the attribute array data to the GPU. Can be used to perform clean-up operations after
   * the upload when attribute data are not needed anymore on the CPU side.
   *
   * @param {Function} callback - The `onUpload()` callback.
   * @return {BufferAttribute} A reference to this instance.
   */
  onUpload(e) {
    return this.onUploadCallback = e, this;
  }
  /**
   * Returns a new buffer attribute with copied values from this instance.
   *
   * @return {BufferAttribute} A clone of this instance.
   */
  clone() {
    return new this.constructor(this.array, this.itemSize).copy(this);
  }
  /**
   * Serializes the buffer attribute into JSON.
   *
   * @return {Object} A JSON object representing the serialized buffer attribute.
   */
  toJSON() {
    const e = {
      itemSize: this.itemSize,
      type: this.array.constructor.name,
      array: Array.from(this.array),
      normalized: this.normalized
    };
    return this.name !== "" && (e.name = this.name), this.usage !== 35044 && (e.usage = this.usage), e;
  }
}
class cc extends Nt {
  /**
   * Constructs a new buffer attribute.
   *
   * @param {(Array<number>|Uint16Array)} array - The array holding the attribute data.
   * @param {number} itemSize - The item size.
   * @param {boolean} [normalized=false] - Whether the data are normalized or not.
   */
  constructor(e, t, n) {
    super(new Uint16Array(e), t, n);
  }
}
class uc extends Nt {
  /**
   * Constructs a new buffer attribute.
   *
   * @param {(Array<number>|Uint32Array)} array - The array holding the attribute data.
   * @param {number} itemSize - The item size.
   * @param {boolean} [normalized=false] - Whether the data are normalized or not.
   */
  constructor(e, t, n) {
    super(new Uint32Array(e), t, n);
  }
}
class Pn extends Nt {
  /**
   * Constructs a new buffer attribute.
   *
   * @param {(Array<number>|Float32Array)} array - The array holding the attribute data.
   * @param {number} itemSize - The item size.
   * @param {boolean} [normalized=false] - Whether the data are normalized or not.
   */
  constructor(e, t, n) {
    super(new Float32Array(e), t, n);
  }
}
let ph = 0;
const dn = /* @__PURE__ */ new ht(), Sa = /* @__PURE__ */ new Bt(), Bi = /* @__PURE__ */ new I(), rn = /* @__PURE__ */ new qr(), pr = /* @__PURE__ */ new qr(), Ct = /* @__PURE__ */ new I();
class Qt extends lr {
  /**
   * Constructs a new geometry.
   */
  constructor() {
    super(), this.isBufferGeometry = !0, Object.defineProperty(this, "id", { value: ph++ }), this.uuid = Gn(), this.name = "", this.type = "BufferGeometry", this.index = null, this.indirect = null, this.indirectOffset = 0, this.attributes = {}, this.morphAttributes = {}, this.morphTargetsRelative = !1, this.groups = [], this.boundingBox = null, this.boundingSphere = null, this.drawRange = { start: 0, count: 1 / 0 }, this.userData = {};
  }
  /**
   * Returns the index of this geometry.
   *
   * @return {?BufferAttribute} The index. Returns `null` if no index is defined.
   */
  getIndex() {
    return this.index;
  }
  /**
   * Sets the given index to this geometry.
   *
   * @param {Array<number>|BufferAttribute} index - The index to set.
   * @return {BufferGeometry} A reference to this instance.
   */
  setIndex(e) {
    return Array.isArray(e) ? this.index = new (sc(e) ? uc : cc)(e, 1) : this.index = e, this;
  }
  /**
   * Sets the given indirect attribute to this geometry.
   *
   * @param {BufferAttribute} indirect - The attribute holding indirect draw calls.
   * @param {number|Array<number>} [indirectOffset=0] - The offset, in bytes, into the indirect drawing buffer where the value data begins. If an array is provided, multiple indirect draw calls will be made for each offset.
   * @return {BufferGeometry} A reference to this instance.
   */
  setIndirect(e, t = 0) {
    return this.indirect = e, this.indirectOffset = t, this;
  }
  /**
   * Returns the indirect attribute of this geometry.
   *
   * @return {?BufferAttribute} The indirect attribute. Returns `null` if no indirect attribute is defined.
   */
  getIndirect() {
    return this.indirect;
  }
  /**
   * Returns the buffer attribute for the given name.
   *
   * @param {string} name - The attribute name.
   * @return {BufferAttribute|InterleavedBufferAttribute|undefined} The buffer attribute.
   * Returns `undefined` if not attribute has been found.
   */
  getAttribute(e) {
    return this.attributes[e];
  }
  /**
   * Sets the given attribute for the given name.
   *
   * @param {string} name - The attribute name.
   * @param {BufferAttribute|InterleavedBufferAttribute} attribute - The attribute to set.
   * @return {BufferGeometry} A reference to this instance.
   */
  setAttribute(e, t) {
    return this.attributes[e] = t, this;
  }
  /**
   * Deletes the attribute for the given name.
   *
   * @param {string} name - The attribute name to delete.
   * @return {BufferGeometry} A reference to this instance.
   */
  deleteAttribute(e) {
    return delete this.attributes[e], this;
  }
  /**
   * Returns `true` if this geometry has an attribute for the given name.
   *
   * @param {string} name - The attribute name.
   * @return {boolean} Whether this geometry has an attribute for the given name or not.
   */
  hasAttribute(e) {
    return this.attributes[e] !== void 0;
  }
  /**
   * Adds a group to this geometry.
   *
   * @param {number} start - The first element in this draw call. That is the first
   * vertex for non-indexed geometry, otherwise the first triangle index.
   * @param {number} count - Specifies how many vertices (or indices) are part of this group.
   * @param {number} [materialIndex=0] - The material array index to use.
   */
  addGroup(e, t, n = 0) {
    this.groups.push({
      start: e,
      count: t,
      materialIndex: n
    });
  }
  /**
   * Clears all groups.
   */
  clearGroups() {
    this.groups = [];
  }
  /**
   * Sets the draw range for this geometry.
   *
   * @param {number} start - The first vertex for non-indexed geometry, otherwise the first triangle index.
   * @param {number} count - For non-indexed BufferGeometry, `count` is the number of vertices to render.
   * For indexed BufferGeometry, `count` is the number of indices to render.
   */
  setDrawRange(e, t) {
    this.drawRange.start = e, this.drawRange.count = t;
  }
  /**
   * Applies the given 4x4 transformation matrix to the geometry.
   *
   * @param {Matrix4} matrix - The matrix to apply.
   * @return {BufferGeometry} A reference to this instance.
   */
  applyMatrix4(e) {
    const t = this.attributes.position;
    t !== void 0 && (t.applyMatrix4(e), t.needsUpdate = !0);
    const n = this.attributes.normal;
    if (n !== void 0) {
      const s = new Ue().getNormalMatrix(e);
      n.applyNormalMatrix(s), n.needsUpdate = !0;
    }
    const i = this.attributes.tangent;
    return i !== void 0 && (i.transformDirection(e), i.needsUpdate = !0), this.boundingBox !== null && this.computeBoundingBox(), this.boundingSphere !== null && this.computeBoundingSphere(), this;
  }
  /**
   * Applies the rotation represented by the Quaternion to the geometry.
   *
   * @param {Quaternion} q - The Quaternion to apply.
   * @return {BufferGeometry} A reference to this instance.
   */
  applyQuaternion(e) {
    return dn.makeRotationFromQuaternion(e), this.applyMatrix4(dn), this;
  }
  /**
   * Rotates the geometry about the X axis. This is typically done as a one time
   * operation, and not during a loop. Use {@link Object3D#rotation} for typical
   * real-time mesh rotation.
   *
   * @param {number} angle - The angle in radians.
   * @return {BufferGeometry} A reference to this instance.
   */
  rotateX(e) {
    return dn.makeRotationX(e), this.applyMatrix4(dn), this;
  }
  /**
   * Rotates the geometry about the Y axis. This is typically done as a one time
   * operation, and not during a loop. Use {@link Object3D#rotation} for typical
   * real-time mesh rotation.
   *
   * @param {number} angle - The angle in radians.
   * @return {BufferGeometry} A reference to this instance.
   */
  rotateY(e) {
    return dn.makeRotationY(e), this.applyMatrix4(dn), this;
  }
  /**
   * Rotates the geometry about the Z axis. This is typically done as a one time
   * operation, and not during a loop. Use {@link Object3D#rotation} for typical
   * real-time mesh rotation.
   *
   * @param {number} angle - The angle in radians.
   * @return {BufferGeometry} A reference to this instance.
   */
  rotateZ(e) {
    return dn.makeRotationZ(e), this.applyMatrix4(dn), this;
  }
  /**
   * Translates the geometry. This is typically done as a one time
   * operation, and not during a loop. Use {@link Object3D#position} for typical
   * real-time mesh rotation.
   *
   * @param {number} x - The x offset.
   * @param {number} y - The y offset.
   * @param {number} z - The z offset.
   * @return {BufferGeometry} A reference to this instance.
   */
  translate(e, t, n) {
    return dn.makeTranslation(e, t, n), this.applyMatrix4(dn), this;
  }
  /**
   * Scales the geometry. This is typically done as a one time
   * operation, and not during a loop. Use {@link Object3D#scale} for typical
   * real-time mesh rotation.
   *
   * @param {number} x - The x scale.
   * @param {number} y - The y scale.
   * @param {number} z - The z scale.
   * @return {BufferGeometry} A reference to this instance.
   */
  scale(e, t, n) {
    return dn.makeScale(e, t, n), this.applyMatrix4(dn), this;
  }
  /**
   * Rotates the geometry to face a point in 3D space. This is typically done as a one time
   * operation, and not during a loop. Use {@link Object3D#lookAt} for typical
   * real-time mesh rotation.
   *
   * @param {Vector3} vector - The target point.
   * @return {BufferGeometry} A reference to this instance.
   */
  lookAt(e) {
    return Sa.lookAt(e), Sa.updateMatrix(), this.applyMatrix4(Sa.matrix), this;
  }
  /**
   * Center the geometry based on its bounding box.
   *
   * @return {BufferGeometry} A reference to this instance.
   */
  center() {
    return this.computeBoundingBox(), this.boundingBox.getCenter(Bi).negate(), this.translate(Bi.x, Bi.y, Bi.z), this;
  }
  /**
   * Defines a geometry by creating a `position` attribute based on the given array of points. The array
   * can hold 2D or 3D vectors. When using two-dimensional data, the `z` coordinate for all vertices is
   * set to `0`.
   *
   * If the method is used with an existing `position` attribute, the vertex data are overwritten with the
   * data from the array. The length of the array must match the vertex count.
   *
   * @param {Array<Vector2>|Array<Vector3>} points - The points.
   * @return {BufferGeometry} A reference to this instance.
   */
  setFromPoints(e) {
    const t = this.getAttribute("position");
    if (t === void 0) {
      const n = [];
      for (let i = 0, s = e.length; i < s; i++) {
        const a = e[i];
        n.push(a.x, a.y, a.z || 0);
      }
      this.setAttribute("position", new Pn(n, 3));
    } else {
      const n = Math.min(e.length, t.count);
      for (let i = 0; i < n; i++) {
        const s = e[i];
        t.setXYZ(i, s.x, s.y, s.z || 0);
      }
      e.length > t.count && Ce("BufferGeometry: Buffer size too small for points data. Use .dispose() and create a new geometry."), t.needsUpdate = !0;
    }
    return this;
  }
  /**
   * Computes the bounding box of the geometry, and updates the `boundingBox` member.
   * The bounding box is not computed by the engine; it must be computed by your app.
   * You may need to recompute the bounding box if the geometry vertices are modified.
   */
  computeBoundingBox() {
    this.boundingBox === null && (this.boundingBox = new qr());
    const e = this.attributes.position, t = this.morphAttributes.position;
    if (e && e.isGLBufferAttribute) {
      Xe("BufferGeometry.computeBoundingBox(): GLBufferAttribute requires a manual bounding box.", this), this.boundingBox.set(
        new I(-1 / 0, -1 / 0, -1 / 0),
        new I(1 / 0, 1 / 0, 1 / 0)
      );
      return;
    }
    if (e !== void 0) {
      if (this.boundingBox.setFromBufferAttribute(e), t)
        for (let n = 0, i = t.length; n < i; n++) {
          const s = t[n];
          rn.setFromBufferAttribute(s), this.morphTargetsRelative ? (Ct.addVectors(this.boundingBox.min, rn.min), this.boundingBox.expandByPoint(Ct), Ct.addVectors(this.boundingBox.max, rn.max), this.boundingBox.expandByPoint(Ct)) : (this.boundingBox.expandByPoint(rn.min), this.boundingBox.expandByPoint(rn.max));
        }
    } else
      this.boundingBox.makeEmpty();
    (isNaN(this.boundingBox.min.x) || isNaN(this.boundingBox.min.y) || isNaN(this.boundingBox.min.z)) && Xe('BufferGeometry.computeBoundingBox(): Computed min/max have NaN values. The "position" attribute is likely to have NaN values.', this);
  }
  /**
   * Computes the bounding sphere of the geometry, and updates the `boundingSphere` member.
   * The engine automatically computes the bounding sphere when it is needed, e.g., for ray casting or view frustum culling.
   * You may need to recompute the bounding sphere if the geometry vertices are modified.
   */
  computeBoundingSphere() {
    this.boundingSphere === null && (this.boundingSphere = new Yr());
    const e = this.attributes.position, t = this.morphAttributes.position;
    if (e && e.isGLBufferAttribute) {
      Xe("BufferGeometry.computeBoundingSphere(): GLBufferAttribute requires a manual bounding sphere.", this), this.boundingSphere.set(new I(), 1 / 0);
      return;
    }
    if (e) {
      const n = this.boundingSphere.center;
      if (rn.setFromBufferAttribute(e), t)
        for (let s = 0, a = t.length; s < a; s++) {
          const o = t[s];
          pr.setFromBufferAttribute(o), this.morphTargetsRelative ? (Ct.addVectors(rn.min, pr.min), rn.expandByPoint(Ct), Ct.addVectors(rn.max, pr.max), rn.expandByPoint(Ct)) : (rn.expandByPoint(pr.min), rn.expandByPoint(pr.max));
        }
      rn.getCenter(n);
      let i = 0;
      for (let s = 0, a = e.count; s < a; s++)
        Ct.fromBufferAttribute(e, s), i = Math.max(i, n.distanceToSquared(Ct));
      if (t)
        for (let s = 0, a = t.length; s < a; s++) {
          const o = t[s], c = this.morphTargetsRelative;
          for (let l = 0, u = o.count; l < u; l++)
            Ct.fromBufferAttribute(o, l), c && (Bi.fromBufferAttribute(e, l), Ct.add(Bi)), i = Math.max(i, n.distanceToSquared(Ct));
        }
      this.boundingSphere.radius = Math.sqrt(i), isNaN(this.boundingSphere.radius) && Xe('BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.', this);
    }
  }
  /**
   * Calculates and adds a tangent attribute to this geometry.
   *
   * The computation is only supported for indexed geometries and if position, normal, and uv attributes
   * are defined. When using a tangent space normal map, prefer the MikkTSpace algorithm provided by
   * {@link BufferGeometryUtils#computeMikkTSpaceTangents} instead.
   */
  computeTangents() {
    const e = this.index, t = this.attributes;
    if (e === null || t.position === void 0 || t.normal === void 0 || t.uv === void 0) {
      Xe("BufferGeometry: .computeTangents() failed. Missing required attributes (index, position, normal or uv)");
      return;
    }
    const n = t.position, i = t.normal, s = t.uv;
    this.hasAttribute("tangent") === !1 && this.setAttribute("tangent", new Nt(new Float32Array(4 * n.count), 4));
    const a = this.getAttribute("tangent"), o = [], c = [];
    for (let C = 0; C < n.count; C++)
      o[C] = new I(), c[C] = new I();
    const l = new I(), u = new I(), h = new I(), f = new Ae(), d = new Ae(), g = new Ae(), _ = new I(), m = new I();
    function p(C, x, E) {
      l.fromBufferAttribute(n, C), u.fromBufferAttribute(n, x), h.fromBufferAttribute(n, E), f.fromBufferAttribute(s, C), d.fromBufferAttribute(s, x), g.fromBufferAttribute(s, E), u.sub(l), h.sub(l), d.sub(f), g.sub(f);
      const P = 1 / (d.x * g.y - g.x * d.y);
      isFinite(P) && (_.copy(u).multiplyScalar(g.y).addScaledVector(h, -d.y).multiplyScalar(P), m.copy(h).multiplyScalar(d.x).addScaledVector(u, -g.x).multiplyScalar(P), o[C].add(_), o[x].add(_), o[E].add(_), c[C].add(m), c[x].add(m), c[E].add(m));
    }
    let S = this.groups;
    S.length === 0 && (S = [{
      start: 0,
      count: e.count
    }]);
    for (let C = 0, x = S.length; C < x; ++C) {
      const E = S[C], P = E.start, z = E.count;
      for (let N = P, W = P + z; N < W; N += 3)
        p(
          e.getX(N + 0),
          e.getX(N + 1),
          e.getX(N + 2)
        );
    }
    const b = new I(), T = new I(), y = new I(), R = new I();
    function A(C) {
      y.fromBufferAttribute(i, C), R.copy(y);
      const x = o[C];
      b.copy(x), b.sub(y.multiplyScalar(y.dot(x))).normalize(), T.crossVectors(R, x);
      const P = T.dot(c[C]) < 0 ? -1 : 1;
      a.setXYZW(C, b.x, b.y, b.z, P);
    }
    for (let C = 0, x = S.length; C < x; ++C) {
      const E = S[C], P = E.start, z = E.count;
      for (let N = P, W = P + z; N < W; N += 3)
        A(e.getX(N + 0)), A(e.getX(N + 1)), A(e.getX(N + 2));
    }
  }
  /**
   * Computes vertex normals for the given vertex data. For indexed geometries, the method sets
   * each vertex normal to be the average of the face normals of the faces that share that vertex.
   * For non-indexed geometries, vertices are not shared, and the method sets each vertex normal
   * to be the same as the face normal.
   */
  computeVertexNormals() {
    const e = this.index, t = this.getAttribute("position");
    if (t !== void 0) {
      let n = this.getAttribute("normal");
      if (n === void 0)
        n = new Nt(new Float32Array(t.count * 3), 3), this.setAttribute("normal", n);
      else
        for (let f = 0, d = n.count; f < d; f++)
          n.setXYZ(f, 0, 0, 0);
      const i = new I(), s = new I(), a = new I(), o = new I(), c = new I(), l = new I(), u = new I(), h = new I();
      if (e)
        for (let f = 0, d = e.count; f < d; f += 3) {
          const g = e.getX(f + 0), _ = e.getX(f + 1), m = e.getX(f + 2);
          i.fromBufferAttribute(t, g), s.fromBufferAttribute(t, _), a.fromBufferAttribute(t, m), u.subVectors(a, s), h.subVectors(i, s), u.cross(h), o.fromBufferAttribute(n, g), c.fromBufferAttribute(n, _), l.fromBufferAttribute(n, m), o.add(u), c.add(u), l.add(u), n.setXYZ(g, o.x, o.y, o.z), n.setXYZ(_, c.x, c.y, c.z), n.setXYZ(m, l.x, l.y, l.z);
        }
      else
        for (let f = 0, d = t.count; f < d; f += 3)
          i.fromBufferAttribute(t, f + 0), s.fromBufferAttribute(t, f + 1), a.fromBufferAttribute(t, f + 2), u.subVectors(a, s), h.subVectors(i, s), u.cross(h), n.setXYZ(f + 0, u.x, u.y, u.z), n.setXYZ(f + 1, u.x, u.y, u.z), n.setXYZ(f + 2, u.x, u.y, u.z);
      this.normalizeNormals(), n.needsUpdate = !0;
    }
  }
  /**
   * Ensures every normal vector in a geometry will have a magnitude of `1`. This will
   * correct lighting on the geometry surfaces.
   */
  normalizeNormals() {
    const e = this.attributes.normal;
    for (let t = 0, n = e.count; t < n; t++)
      Ct.fromBufferAttribute(e, t), Ct.normalize(), e.setXYZ(t, Ct.x, Ct.y, Ct.z);
  }
  /**
   * Return a new non-index version of this indexed geometry. If the geometry
   * is already non-indexed, the method is a NOOP.
   *
   * @return {BufferGeometry} The non-indexed version of this indexed geometry.
   */
  toNonIndexed() {
    function e(o, c) {
      const l = o.array, u = o.itemSize, h = o.normalized, f = new l.constructor(c.length * u);
      let d = 0, g = 0;
      for (let _ = 0, m = c.length; _ < m; _++) {
        o.isInterleavedBufferAttribute ? d = c[_] * o.data.stride + o.offset : d = c[_] * u;
        for (let p = 0; p < u; p++)
          f[g++] = l[d++];
      }
      return new Nt(f, u, h);
    }
    if (this.index === null)
      return Ce("BufferGeometry.toNonIndexed(): BufferGeometry is already non-indexed."), this;
    const t = new Qt(), n = this.index.array, i = this.attributes;
    for (const o in i) {
      const c = i[o], l = e(c, n);
      t.setAttribute(o, l);
    }
    const s = this.morphAttributes;
    for (const o in s) {
      const c = [], l = s[o];
      for (let u = 0, h = l.length; u < h; u++) {
        const f = l[u], d = e(f, n);
        c.push(d);
      }
      t.morphAttributes[o] = c;
    }
    t.morphTargetsRelative = this.morphTargetsRelative;
    const a = this.groups;
    for (let o = 0, c = a.length; o < c; o++) {
      const l = a[o];
      t.addGroup(l.start, l.count, l.materialIndex);
    }
    return t;
  }
  /**
   * Serializes the geometry into JSON.
   *
   * @return {Object} A JSON object representing the serialized geometry.
   */
  toJSON() {
    const e = {
      metadata: {
        version: 4.7,
        type: "BufferGeometry",
        generator: "BufferGeometry.toJSON"
      }
    };
    if (e.uuid = this.uuid, e.type = this.type, this.name !== "" && (e.name = this.name), Object.keys(this.userData).length > 0 && (e.userData = this.userData), this.parameters !== void 0) {
      const c = this.parameters;
      for (const l in c)
        c[l] !== void 0 && (e[l] = c[l]);
      return e;
    }
    e.data = { attributes: {} };
    const t = this.index;
    t !== null && (e.data.index = {
      type: t.array.constructor.name,
      array: Array.prototype.slice.call(t.array)
    });
    const n = this.attributes;
    for (const c in n) {
      const l = n[c];
      e.data.attributes[c] = l.toJSON(e.data);
    }
    const i = {};
    let s = !1;
    for (const c in this.morphAttributes) {
      const l = this.morphAttributes[c], u = [];
      for (let h = 0, f = l.length; h < f; h++) {
        const d = l[h];
        u.push(d.toJSON(e.data));
      }
      u.length > 0 && (i[c] = u, s = !0);
    }
    s && (e.data.morphAttributes = i, e.data.morphTargetsRelative = this.morphTargetsRelative);
    const a = this.groups;
    a.length > 0 && (e.data.groups = JSON.parse(JSON.stringify(a)));
    const o = this.boundingSphere;
    return o !== null && (e.data.boundingSphere = o.toJSON()), e;
  }
  /**
   * Returns a new geometry with copied values from this instance.
   *
   * @return {BufferGeometry} A clone of this instance.
   */
  clone() {
    return new this.constructor().copy(this);
  }
  /**
   * Copies the values of the given geometry to this instance.
   *
   * @param {BufferGeometry} source - The geometry to copy.
   * @return {BufferGeometry} A reference to this instance.
   */
  copy(e) {
    this.index = null, this.attributes = {}, this.morphAttributes = {}, this.groups = [], this.boundingBox = null, this.boundingSphere = null;
    const t = {};
    this.name = e.name;
    const n = e.index;
    n !== null && this.setIndex(n.clone());
    const i = e.attributes;
    for (const l in i) {
      const u = i[l];
      this.setAttribute(l, u.clone(t));
    }
    const s = e.morphAttributes;
    for (const l in s) {
      const u = [], h = s[l];
      for (let f = 0, d = h.length; f < d; f++)
        u.push(h[f].clone(t));
      this.morphAttributes[l] = u;
    }
    this.morphTargetsRelative = e.morphTargetsRelative;
    const a = e.groups;
    for (let l = 0, u = a.length; l < u; l++) {
      const h = a[l];
      this.addGroup(h.start, h.count, h.materialIndex);
    }
    const o = e.boundingBox;
    o !== null && (this.boundingBox = o.clone());
    const c = e.boundingSphere;
    return c !== null && (this.boundingSphere = c.clone()), this.drawRange.start = e.drawRange.start, this.drawRange.count = e.drawRange.count, this.userData = e.userData, this;
  }
  /**
   * Frees the GPU-related resources allocated by this instance. Call this
   * method whenever this instance is no longer used in your app.
   *
   * @fires BufferGeometry#dispose
   */
  dispose() {
    this.dispatchEvent({ type: "dispose" });
  }
}
const el = /* @__PURE__ */ new ht(), fi = /* @__PURE__ */ new oo(), os = /* @__PURE__ */ new Yr(), tl = /* @__PURE__ */ new I(), ls = /* @__PURE__ */ new I(), cs = /* @__PURE__ */ new I(), us = /* @__PURE__ */ new I(), Ma = /* @__PURE__ */ new I(), hs = /* @__PURE__ */ new I(), nl = /* @__PURE__ */ new I(), fs = /* @__PURE__ */ new I();
class Lt extends Bt {
  /**
   * Constructs a new mesh.
   *
   * @param {BufferGeometry} [geometry] - The mesh geometry.
   * @param {Material|Array<Material>} [material] - The mesh material.
   */
  constructor(e = new Qt(), t = new Cr()) {
    super(), this.isMesh = !0, this.type = "Mesh", this.geometry = e, this.material = t, this.morphTargetDictionary = void 0, this.morphTargetInfluences = void 0, this.count = 1, this.updateMorphTargets();
  }
  copy(e, t) {
    return super.copy(e, t), e.morphTargetInfluences !== void 0 && (this.morphTargetInfluences = e.morphTargetInfluences.slice()), e.morphTargetDictionary !== void 0 && (this.morphTargetDictionary = Object.assign({}, e.morphTargetDictionary)), this.material = Array.isArray(e.material) ? e.material.slice() : e.material, this.geometry = e.geometry, this;
  }
  /**
   * Sets the values of {@link Mesh#morphTargetDictionary} and {@link Mesh#morphTargetInfluences}
   * to make sure existing morph targets can influence this 3D object.
   */
  updateMorphTargets() {
    const t = this.geometry.morphAttributes, n = Object.keys(t);
    if (n.length > 0) {
      const i = t[n[0]];
      if (i !== void 0) {
        this.morphTargetInfluences = [], this.morphTargetDictionary = {};
        for (let s = 0, a = i.length; s < a; s++) {
          const o = i[s].name || String(s);
          this.morphTargetInfluences.push(0), this.morphTargetDictionary[o] = s;
        }
      }
    }
  }
  /**
   * Returns the local-space position of the vertex at the given index, taking into
   * account the current animation state of both morph targets and skinning.
   *
   * @param {number} index - The vertex index.
   * @param {Vector3} target - The target object that is used to store the method's result.
   * @return {Vector3} The vertex position in local space.
   */
  getVertexPosition(e, t) {
    const n = this.geometry, i = n.attributes.position, s = n.morphAttributes.position, a = n.morphTargetsRelative;
    t.fromBufferAttribute(i, e);
    const o = this.morphTargetInfluences;
    if (s && o) {
      hs.set(0, 0, 0);
      for (let c = 0, l = s.length; c < l; c++) {
        const u = o[c], h = s[c];
        u !== 0 && (Ma.fromBufferAttribute(h, e), a ? hs.addScaledVector(Ma, u) : hs.addScaledVector(Ma.sub(t), u));
      }
      t.add(hs);
    }
    return t;
  }
  /**
   * Computes intersection points between a casted ray and this line.
   *
   * @param {Raycaster} raycaster - The raycaster.
   * @param {Array<Object>} intersects - The target array that holds the intersection points.
   */
  raycast(e, t) {
    const n = this.geometry, i = this.material, s = this.matrixWorld;
    i !== void 0 && (n.boundingSphere === null && n.computeBoundingSphere(), os.copy(n.boundingSphere), os.applyMatrix4(s), fi.copy(e.ray).recast(e.near), !(os.containsPoint(fi.origin) === !1 && (fi.intersectSphere(os, tl) === null || fi.origin.distanceToSquared(tl) > (e.far - e.near) ** 2)) && (el.copy(s).invert(), fi.copy(e.ray).applyMatrix4(el), !(n.boundingBox !== null && fi.intersectsBox(n.boundingBox) === !1) && this._computeIntersections(e, t, fi)));
  }
  _computeIntersections(e, t, n) {
    let i;
    const s = this.geometry, a = this.material, o = s.index, c = s.attributes.position, l = s.attributes.uv, u = s.attributes.uv1, h = s.attributes.normal, f = s.groups, d = s.drawRange;
    if (o !== null)
      if (Array.isArray(a))
        for (let g = 0, _ = f.length; g < _; g++) {
          const m = f[g], p = a[m.materialIndex], S = Math.max(m.start, d.start), b = Math.min(o.count, Math.min(m.start + m.count, d.start + d.count));
          for (let T = S, y = b; T < y; T += 3) {
            const R = o.getX(T), A = o.getX(T + 1), C = o.getX(T + 2);
            i = ds(this, p, e, n, l, u, h, R, A, C), i && (i.faceIndex = Math.floor(T / 3), i.face.materialIndex = m.materialIndex, t.push(i));
          }
        }
      else {
        const g = Math.max(0, d.start), _ = Math.min(o.count, d.start + d.count);
        for (let m = g, p = _; m < p; m += 3) {
          const S = o.getX(m), b = o.getX(m + 1), T = o.getX(m + 2);
          i = ds(this, a, e, n, l, u, h, S, b, T), i && (i.faceIndex = Math.floor(m / 3), t.push(i));
        }
      }
    else if (c !== void 0)
      if (Array.isArray(a))
        for (let g = 0, _ = f.length; g < _; g++) {
          const m = f[g], p = a[m.materialIndex], S = Math.max(m.start, d.start), b = Math.min(c.count, Math.min(m.start + m.count, d.start + d.count));
          for (let T = S, y = b; T < y; T += 3) {
            const R = T, A = T + 1, C = T + 2;
            i = ds(this, p, e, n, l, u, h, R, A, C), i && (i.faceIndex = Math.floor(T / 3), i.face.materialIndex = m.materialIndex, t.push(i));
          }
        }
      else {
        const g = Math.max(0, d.start), _ = Math.min(c.count, d.start + d.count);
        for (let m = g, p = _; m < p; m += 3) {
          const S = m, b = m + 1, T = m + 2;
          i = ds(this, a, e, n, l, u, h, S, b, T), i && (i.faceIndex = Math.floor(m / 3), t.push(i));
        }
      }
  }
}
function mh(r, e, t, n, i, s, a, o) {
  let c;
  if (e.side === 1 ? c = n.intersectTriangle(a, s, i, !0, o) : c = n.intersectTriangle(i, s, a, e.side === 0, o), c === null) return null;
  fs.copy(o), fs.applyMatrix4(r.matrixWorld);
  const l = t.ray.origin.distanceTo(fs);
  return l < t.near || l > t.far ? null : {
    distance: l,
    point: fs.clone(),
    object: r
  };
}
function ds(r, e, t, n, i, s, a, o, c, l) {
  r.getVertexPosition(o, ls), r.getVertexPosition(c, cs), r.getVertexPosition(l, us);
  const u = mh(r, e, t, n, ls, cs, us, nl);
  if (u) {
    const h = new I();
    mn.getBarycoord(nl, ls, cs, us, h), i && (u.uv = mn.getInterpolatedAttribute(i, o, c, l, h, new Ae())), s && (u.uv1 = mn.getInterpolatedAttribute(s, o, c, l, h, new Ae())), a && (u.normal = mn.getInterpolatedAttribute(a, o, c, l, h, new I()), u.normal.dot(n.direction) > 0 && u.normal.multiplyScalar(-1));
    const f = {
      a: o,
      b: c,
      c: l,
      normal: new I(),
      materialIndex: 0
    };
    mn.getNormal(ls, cs, us, f.normal), u.face = f, u.barycoord = h;
  }
  return u;
}
class $r extends Qt {
  /**
   * Constructs a new box geometry.
   *
   * @param {number} [width=1] - The width. That is, the length of the edges parallel to the X axis.
   * @param {number} [height=1] - The height. That is, the length of the edges parallel to the Y axis.
   * @param {number} [depth=1] - The depth. That is, the length of the edges parallel to the Z axis.
   * @param {number} [widthSegments=1] - Number of segmented rectangular faces along the width of the sides.
   * @param {number} [heightSegments=1] - Number of segmented rectangular faces along the height of the sides.
   * @param {number} [depthSegments=1] - Number of segmented rectangular faces along the depth of the sides.
   */
  constructor(e = 1, t = 1, n = 1, i = 1, s = 1, a = 1) {
    super(), this.type = "BoxGeometry", this.parameters = {
      width: e,
      height: t,
      depth: n,
      widthSegments: i,
      heightSegments: s,
      depthSegments: a
    };
    const o = this;
    i = Math.floor(i), s = Math.floor(s), a = Math.floor(a);
    const c = [], l = [], u = [], h = [];
    let f = 0, d = 0;
    g("z", "y", "x", -1, -1, n, t, e, a, s, 0), g("z", "y", "x", 1, -1, n, t, -e, a, s, 1), g("x", "z", "y", 1, 1, e, n, t, i, a, 2), g("x", "z", "y", 1, -1, e, n, -t, i, a, 3), g("x", "y", "z", 1, -1, e, t, n, i, s, 4), g("x", "y", "z", -1, -1, e, t, -n, i, s, 5), this.setIndex(c), this.setAttribute("position", new Pn(l, 3)), this.setAttribute("normal", new Pn(u, 3)), this.setAttribute("uv", new Pn(h, 2));
    function g(_, m, p, S, b, T, y, R, A, C, x) {
      const E = T / A, P = y / C, z = T / 2, N = y / 2, W = R / 2, H = A + 1, k = C + 1;
      let O = 0, Y = 0;
      const ae = new I();
      for (let ne = 0; ne < k; ne++) {
        const ue = ne * P - N;
        for (let Pe = 0; Pe < H; Pe++) {
          const Le = Pe * E - z;
          ae[_] = Le * S, ae[m] = ue * b, ae[p] = W, l.push(ae.x, ae.y, ae.z), ae[_] = 0, ae[m] = 0, ae[p] = R > 0 ? 1 : -1, u.push(ae.x, ae.y, ae.z), h.push(Pe / A), h.push(1 - ne / C), O += 1;
        }
      }
      for (let ne = 0; ne < C; ne++)
        for (let ue = 0; ue < A; ue++) {
          const Pe = f + ue + H * ne, Le = f + ue + H * (ne + 1), Ve = f + (ue + 1) + H * (ne + 1), He = f + (ue + 1) + H * ne;
          c.push(Pe, Le, He), c.push(Le, Ve, He), Y += 6;
        }
      o.addGroup(d, Y, x), d += Y, f += O;
    }
  }
  copy(e) {
    return super.copy(e), this.parameters = Object.assign({}, e.parameters), this;
  }
  /**
   * Factory method for creating an instance of this class from the given
   * JSON object.
   *
   * @param {Object} data - A JSON object representing the serialized geometry.
   * @return {BoxGeometry} A new instance.
   */
  static fromJSON(e) {
    return new $r(e.width, e.height, e.depth, e.widthSegments, e.heightSegments, e.depthSegments);
  }
}
function nr(r) {
  const e = {};
  for (const t in r) {
    e[t] = {};
    for (const n in r[t]) {
      const i = r[t][n];
      i && (i.isColor || i.isMatrix3 || i.isMatrix4 || i.isVector2 || i.isVector3 || i.isVector4 || i.isTexture || i.isQuaternion) ? i.isRenderTargetTexture ? (Ce("UniformsUtils: Textures of render targets cannot be cloned via cloneUniforms() or mergeUniforms()."), e[t][n] = null) : e[t][n] = i.clone() : Array.isArray(i) ? e[t][n] = i.slice() : e[t][n] = i;
    }
  }
  return e;
}
function Vt(r) {
  const e = {};
  for (let t = 0; t < r.length; t++) {
    const n = nr(r[t]);
    for (const i in n)
      e[i] = n[i];
  }
  return e;
}
function _h(r) {
  const e = [];
  for (let t = 0; t < r.length; t++)
    e.push(r[t].clone());
  return e;
}
function hc(r) {
  const e = r.getRenderTarget();
  return e === null ? r.outputColorSpace : e.isXRRenderTarget === !0 ? e.texture.colorSpace : qe.workingColorSpace;
}
const gh = { clone: nr, merge: Vt };
var vh = `void main() {
	gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
}`, xh = `void main() {
	gl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );
}`;
class Ht extends Ai {
  /**
   * Constructs a new shader material.
   *
   * @param {Object} [parameters] - An object with one or more properties
   * defining the material's appearance. Any property of the material
   * (including any property from inherited materials) can be passed
   * in here. Color values can be passed any type of value accepted
   * by {@link Color#set}.
   */
  constructor(e) {
    super(), this.isShaderMaterial = !0, this.type = "ShaderMaterial", this.defines = {}, this.uniforms = {}, this.uniformsGroups = [], this.vertexShader = vh, this.fragmentShader = xh, this.linewidth = 1, this.wireframe = !1, this.wireframeLinewidth = 1, this.fog = !1, this.lights = !1, this.clipping = !1, this.forceSinglePass = !0, this.extensions = {
      clipCullDistance: !1,
      // set to use vertex shader clipping
      multiDraw: !1
      // set to use vertex shader multi_draw / enable gl_DrawID
    }, this.defaultAttributeValues = {
      color: [1, 1, 1],
      uv: [0, 0],
      uv1: [0, 0]
    }, this.index0AttributeName = void 0, this.uniformsNeedUpdate = !1, this.glslVersion = null, e !== void 0 && this.setValues(e);
  }
  copy(e) {
    return super.copy(e), this.fragmentShader = e.fragmentShader, this.vertexShader = e.vertexShader, this.uniforms = nr(e.uniforms), this.uniformsGroups = _h(e.uniformsGroups), this.defines = Object.assign({}, e.defines), this.wireframe = e.wireframe, this.wireframeLinewidth = e.wireframeLinewidth, this.fog = e.fog, this.lights = e.lights, this.clipping = e.clipping, this.extensions = Object.assign({}, e.extensions), this.glslVersion = e.glslVersion, this.defaultAttributeValues = Object.assign({}, e.defaultAttributeValues), this.index0AttributeName = e.index0AttributeName, this.uniformsNeedUpdate = e.uniformsNeedUpdate, this;
  }
  toJSON(e) {
    const t = super.toJSON(e);
    t.glslVersion = this.glslVersion, t.uniforms = {};
    for (const i in this.uniforms) {
      const a = this.uniforms[i].value;
      a && a.isTexture ? t.uniforms[i] = {
        type: "t",
        value: a.toJSON(e).uuid
      } : a && a.isColor ? t.uniforms[i] = {
        type: "c",
        value: a.getHex()
      } : a && a.isVector2 ? t.uniforms[i] = {
        type: "v2",
        value: a.toArray()
      } : a && a.isVector3 ? t.uniforms[i] = {
        type: "v3",
        value: a.toArray()
      } : a && a.isVector4 ? t.uniforms[i] = {
        type: "v4",
        value: a.toArray()
      } : a && a.isMatrix3 ? t.uniforms[i] = {
        type: "m3",
        value: a.toArray()
      } : a && a.isMatrix4 ? t.uniforms[i] = {
        type: "m4",
        value: a.toArray()
      } : t.uniforms[i] = {
        value: a
      };
    }
    Object.keys(this.defines).length > 0 && (t.defines = this.defines), t.vertexShader = this.vertexShader, t.fragmentShader = this.fragmentShader, t.lights = this.lights, t.clipping = this.clipping;
    const n = {};
    for (const i in this.extensions)
      this.extensions[i] === !0 && (n[i] = !0);
    return Object.keys(n).length > 0 && (t.extensions = n), t;
  }
}
class lo extends Bt {
  /**
   * Constructs a new camera.
   */
  constructor() {
    super(), this.isCamera = !0, this.type = "Camera", this.matrixWorldInverse = new ht(), this.projectionMatrix = new ht(), this.projectionMatrixInverse = new ht(), this.coordinateSystem = 2e3, this._reversedDepth = !1;
  }
  /**
   * The flag that indicates whether the camera uses a reversed depth buffer.
   *
   * @type {boolean}
   * @default false
   */
  get reversedDepth() {
    return this._reversedDepth;
  }
  copy(e, t) {
    return super.copy(e, t), this.matrixWorldInverse.copy(e.matrixWorldInverse), this.projectionMatrix.copy(e.projectionMatrix), this.projectionMatrixInverse.copy(e.projectionMatrixInverse), this.coordinateSystem = e.coordinateSystem, this;
  }
  /**
   * Returns a vector representing the ("look") direction of the 3D object in world space.
   *
   * This method is overwritten since cameras have a different forward vector compared to other
   * 3D objects. A camera looks down its local, negative z-axis by default.
   *
   * @param {Vector3} target - The target vector the result is stored to.
   * @return {Vector3} The 3D object's direction in world space.
   */
  getWorldDirection(e) {
    return super.getWorldDirection(e).negate();
  }
  updateMatrixWorld(e) {
    super.updateMatrixWorld(e), this.matrixWorldInverse.copy(this.matrixWorld).invert();
  }
  updateWorldMatrix(e, t) {
    super.updateWorldMatrix(e, t), this.matrixWorldInverse.copy(this.matrixWorld).invert();
  }
  clone() {
    return new this.constructor().copy(this);
  }
}
const Zn = /* @__PURE__ */ new I(), il = /* @__PURE__ */ new Ae(), rl = /* @__PURE__ */ new Ae();
class qt extends lo {
  /**
   * Constructs a new perspective camera.
   *
   * @param {number} [fov=50] - The vertical field of view.
   * @param {number} [aspect=1] - The aspect ratio.
   * @param {number} [near=0.1] - The camera's near plane.
   * @param {number} [far=2000] - The camera's far plane.
   */
  constructor(e = 50, t = 1, n = 0.1, i = 2e3) {
    super(), this.isPerspectiveCamera = !0, this.type = "PerspectiveCamera", this.fov = e, this.zoom = 1, this.near = n, this.far = i, this.focus = 10, this.aspect = t, this.view = null, this.filmGauge = 35, this.filmOffset = 0, this.updateProjectionMatrix();
  }
  copy(e, t) {
    return super.copy(e, t), this.fov = e.fov, this.zoom = e.zoom, this.near = e.near, this.far = e.far, this.focus = e.focus, this.aspect = e.aspect, this.view = e.view === null ? null : Object.assign({}, e.view), this.filmGauge = e.filmGauge, this.filmOffset = e.filmOffset, this;
  }
  /**
   * Sets the FOV by focal length in respect to the current {@link PerspectiveCamera#filmGauge}.
   *
   * The default film gauge is 35, so that the focal length can be specified for
   * a 35mm (full frame) camera.
   *
   * @param {number} focalLength - Values for focal length and film gauge must have the same unit.
   */
  setFocalLength(e) {
    const t = 0.5 * this.getFilmHeight() / e;
    this.fov = Ir * 2 * Math.atan(t), this.updateProjectionMatrix();
  }
  /**
   * Returns the focal length from the current {@link PerspectiveCamera#fov} and
   * {@link PerspectiveCamera#filmGauge}.
   *
   * @return {number} The computed focal length.
   */
  getFocalLength() {
    const e = Math.tan(wr * 0.5 * this.fov);
    return 0.5 * this.getFilmHeight() / e;
  }
  /**
   * Returns the current vertical field of view angle in degrees considering {@link PerspectiveCamera#zoom}.
   *
   * @return {number} The effective FOV.
   */
  getEffectiveFOV() {
    return Ir * 2 * Math.atan(
      Math.tan(wr * 0.5 * this.fov) / this.zoom
    );
  }
  /**
   * Returns the width of the image on the film. If {@link PerspectiveCamera#aspect} is greater than or
   * equal to one (landscape format), the result equals {@link PerspectiveCamera#filmGauge}.
   *
   * @return {number} The film width.
   */
  getFilmWidth() {
    return this.filmGauge * Math.min(this.aspect, 1);
  }
  /**
   * Returns the height of the image on the film. If {@link PerspectiveCamera#aspect} is greater than or
   * equal to one (landscape format), the result equals {@link PerspectiveCamera#filmGauge}.
   *
   * @return {number} The film width.
   */
  getFilmHeight() {
    return this.filmGauge / Math.max(this.aspect, 1);
  }
  /**
   * Computes the 2D bounds of the camera's viewable rectangle at a given distance along the viewing direction.
   * Sets `minTarget` and `maxTarget` to the coordinates of the lower-left and upper-right corners of the view rectangle.
   *
   * @param {number} distance - The viewing distance.
   * @param {Vector2} minTarget - The lower-left corner of the view rectangle is written into this vector.
   * @param {Vector2} maxTarget - The upper-right corner of the view rectangle is written into this vector.
   */
  getViewBounds(e, t, n) {
    Zn.set(-1, -1, 0.5).applyMatrix4(this.projectionMatrixInverse), t.set(Zn.x, Zn.y).multiplyScalar(-e / Zn.z), Zn.set(1, 1, 0.5).applyMatrix4(this.projectionMatrixInverse), n.set(Zn.x, Zn.y).multiplyScalar(-e / Zn.z);
  }
  /**
   * Computes the width and height of the camera's viewable rectangle at a given distance along the viewing direction.
   *
   * @param {number} distance - The viewing distance.
   * @param {Vector2} target - The target vector that is used to store result where x is width and y is height.
   * @returns {Vector2} The view size.
   */
  getViewSize(e, t) {
    return this.getViewBounds(e, il, rl), t.subVectors(rl, il);
  }
  /**
   * Sets an offset in a larger frustum. This is useful for multi-window or
   * multi-monitor/multi-machine setups.
   *
   * For example, if you have 3x2 monitors and each monitor is 1920x1080 and
   * the monitors are in grid like this
   *```
   *   +---+---+---+
   *   | A | B | C |
   *   +---+---+---+
   *   | D | E | F |
   *   +---+---+---+
   *```
   * then for each monitor you would call it like this:
   *```js
   * const w = 1920;
   * const h = 1080;
   * const fullWidth = w * 3;
   * const fullHeight = h * 2;
   *
   * // --A--
   * camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 0, w, h );
   * // --B--
   * camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 0, w, h );
   * // --C--
   * camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 0, w, h );
   * // --D--
   * camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 1, w, h );
   * // --E--
   * camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 1, w, h );
   * // --F--
   * camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 1, w, h );
   * ```
   *
   * Note there is no reason monitors have to be the same size or in a grid.
   *
   * @param {number} fullWidth - The full width of multiview setup.
   * @param {number} fullHeight - The full height of multiview setup.
   * @param {number} x - The horizontal offset of the subcamera.
   * @param {number} y - The vertical offset of the subcamera.
   * @param {number} width - The width of subcamera.
   * @param {number} height - The height of subcamera.
   */
  setViewOffset(e, t, n, i, s, a) {
    this.aspect = e / t, this.view === null && (this.view = {
      enabled: !0,
      fullWidth: 1,
      fullHeight: 1,
      offsetX: 0,
      offsetY: 0,
      width: 1,
      height: 1
    }), this.view.enabled = !0, this.view.fullWidth = e, this.view.fullHeight = t, this.view.offsetX = n, this.view.offsetY = i, this.view.width = s, this.view.height = a, this.updateProjectionMatrix();
  }
  /**
   * Removes the view offset from the projection matrix.
   */
  clearViewOffset() {
    this.view !== null && (this.view.enabled = !1), this.updateProjectionMatrix();
  }
  /**
   * Updates the camera's projection matrix. Must be called after any change of
   * camera properties.
   */
  updateProjectionMatrix() {
    const e = this.near;
    let t = e * Math.tan(wr * 0.5 * this.fov) / this.zoom, n = 2 * t, i = this.aspect * n, s = -0.5 * i;
    const a = this.view;
    if (this.view !== null && this.view.enabled) {
      const c = a.fullWidth, l = a.fullHeight;
      s += a.offsetX * i / c, t -= a.offsetY * n / l, i *= a.width / c, n *= a.height / l;
    }
    const o = this.filmOffset;
    o !== 0 && (s += e * o / this.getFilmWidth()), this.projectionMatrix.makePerspective(s, s + i, t, t - n, e, this.far, this.coordinateSystem, this.reversedDepth), this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
  }
  toJSON(e) {
    const t = super.toJSON(e);
    return t.object.fov = this.fov, t.object.zoom = this.zoom, t.object.near = this.near, t.object.far = this.far, t.object.focus = this.focus, t.object.aspect = this.aspect, this.view !== null && (t.object.view = Object.assign({}, this.view)), t.object.filmGauge = this.filmGauge, t.object.filmOffset = this.filmOffset, t;
  }
}
const zi = -90, Gi = 1;
class Sh extends Bt {
  /**
   * Constructs a new cube camera.
   *
   * @param {number} near - The camera's near plane.
   * @param {number} far - The camera's far plane.
   * @param {WebGLCubeRenderTarget} renderTarget - The cube render target.
   */
  constructor(e, t, n) {
    super(), this.type = "CubeCamera", this.renderTarget = n, this.coordinateSystem = null, this.activeMipmapLevel = 0;
    const i = new qt(zi, Gi, e, t);
    i.layers = this.layers, this.add(i);
    const s = new qt(zi, Gi, e, t);
    s.layers = this.layers, this.add(s);
    const a = new qt(zi, Gi, e, t);
    a.layers = this.layers, this.add(a);
    const o = new qt(zi, Gi, e, t);
    o.layers = this.layers, this.add(o);
    const c = new qt(zi, Gi, e, t);
    c.layers = this.layers, this.add(c);
    const l = new qt(zi, Gi, e, t);
    l.layers = this.layers, this.add(l);
  }
  /**
   * Must be called when the coordinate system of the cube camera is changed.
   */
  updateCoordinateSystem() {
    const e = this.coordinateSystem, t = this.children.concat(), [n, i, s, a, o, c] = t;
    for (const l of t) this.remove(l);
    if (e === 2e3)
      n.up.set(0, 1, 0), n.lookAt(1, 0, 0), i.up.set(0, 1, 0), i.lookAt(-1, 0, 0), s.up.set(0, 0, -1), s.lookAt(0, 1, 0), a.up.set(0, 0, 1), a.lookAt(0, -1, 0), o.up.set(0, 1, 0), o.lookAt(0, 0, 1), c.up.set(0, 1, 0), c.lookAt(0, 0, -1);
    else if (e === 2001)
      n.up.set(0, -1, 0), n.lookAt(-1, 0, 0), i.up.set(0, -1, 0), i.lookAt(1, 0, 0), s.up.set(0, 0, 1), s.lookAt(0, 1, 0), a.up.set(0, 0, -1), a.lookAt(0, -1, 0), o.up.set(0, -1, 0), o.lookAt(0, 0, 1), c.up.set(0, -1, 0), c.lookAt(0, 0, -1);
    else
      throw new Error("THREE.CubeCamera.updateCoordinateSystem(): Invalid coordinate system: " + e);
    for (const l of t)
      this.add(l), l.updateMatrixWorld();
  }
  /**
   * Calling this method will render the given scene with the given renderer
   * into the cube render target of the camera.
   *
   * @param {(Renderer|WebGLRenderer)} renderer - The renderer.
   * @param {Scene} scene - The scene to render.
   */
  update(e, t) {
    this.parent === null && this.updateMatrixWorld();
    const { renderTarget: n, activeMipmapLevel: i } = this;
    this.coordinateSystem !== e.coordinateSystem && (this.coordinateSystem = e.coordinateSystem, this.updateCoordinateSystem());
    const [s, a, o, c, l, u] = this.children, h = e.getRenderTarget(), f = e.getActiveCubeFace(), d = e.getActiveMipmapLevel(), g = e.xr.enabled;
    e.xr.enabled = !1;
    const _ = n.texture.generateMipmaps;
    n.texture.generateMipmaps = !1, e.setRenderTarget(n, 0, i), e.render(t, s), e.setRenderTarget(n, 1, i), e.render(t, a), e.setRenderTarget(n, 2, i), e.render(t, o), e.setRenderTarget(n, 3, i), e.render(t, c), e.setRenderTarget(n, 4, i), e.render(t, l), n.texture.generateMipmaps = _, e.setRenderTarget(n, 5, i), e.render(t, u), e.setRenderTarget(h, f, d), e.xr.enabled = g, n.texture.needsPMREMUpdate = !0;
  }
}
class fc extends bt {
  /**
   * Constructs a new cube texture.
   *
   * @param {Array<Image>} [images=[]] - An array holding a image for each side of a cube.
   * @param {number} [mapping=CubeReflectionMapping] - The texture mapping.
   * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
   * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
   * @param {number} [magFilter=LinearFilter] - The mag filter value.
   * @param {number} [minFilter=LinearMipmapLinearFilter] - The min filter value.
   * @param {number} [format=RGBAFormat] - The texture format.
   * @param {number} [type=UnsignedByteType] - The texture type.
   * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
   * @param {string} [colorSpace=NoColorSpace] - The color space value.
   */
  constructor(e = [], t = 301, n, i, s, a, o, c, l, u) {
    super(e, t, n, i, s, a, o, c, l, u), this.isCubeTexture = !0, this.flipY = !1;
  }
  /**
   * Alias for {@link CubeTexture#image}.
   *
   * @type {Array<Image>}
   */
  get images() {
    return this.image;
  }
  set images(e) {
    this.image = e;
  }
}
class dc extends Cn {
  /**
   * Constructs a new cube render target.
   *
   * @param {number} [size=1] - The size of the render target.
   * @param {RenderTarget~Options} [options] - The configuration object.
   */
  constructor(e = 1, t = {}) {
    super(e, e, t), this.isWebGLCubeRenderTarget = !0;
    const n = { width: e, height: e, depth: 1 }, i = [n, n, n, n, n, n];
    this.texture = new fc(i), this._setTextureOptions(t), this.texture.isRenderTargetTexture = !0;
  }
  /**
   * Converts the given equirectangular texture to a cube map.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {Texture} texture - The equirectangular texture.
   * @return {WebGLCubeRenderTarget} A reference to this cube render target.
   */
  fromEquirectangularTexture(e, t) {
    this.texture.type = t.type, this.texture.colorSpace = t.colorSpace, this.texture.generateMipmaps = t.generateMipmaps, this.texture.minFilter = t.minFilter, this.texture.magFilter = t.magFilter;
    const n = {
      uniforms: {
        tEquirect: { value: null }
      },
      vertexShader: (
        /* glsl */
        `

				varying vec3 vWorldDirection;

				vec3 transformDirection( in vec3 dir, in mat4 matrix ) {

					return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );

				}

				void main() {

					vWorldDirection = transformDirection( position, modelMatrix );

					#include <begin_vertex>
					#include <project_vertex>

				}
			`
      ),
      fragmentShader: (
        /* glsl */
        `

				uniform sampler2D tEquirect;

				varying vec3 vWorldDirection;

				#include <common>

				void main() {

					vec3 direction = normalize( vWorldDirection );

					vec2 sampleUV = equirectUv( direction );

					gl_FragColor = texture2D( tEquirect, sampleUV );

				}
			`
      )
    }, i = new $r(5, 5, 5), s = new Ht({
      name: "CubemapFromEquirect",
      uniforms: nr(n.uniforms),
      vertexShader: n.vertexShader,
      fragmentShader: n.fragmentShader,
      side: 1,
      blending: 0
    });
    s.uniforms.tEquirect.value = t;
    const a = new Lt(i, s), o = t.minFilter;
    return t.minFilter === 1008 && (t.minFilter = 1006), new Sh(1, 10, this).update(e, a), t.minFilter = o, a.geometry.dispose(), a.material.dispose(), this;
  }
  /**
   * Clears this cube render target.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {boolean} [color=true] - Whether the color buffer should be cleared or not.
   * @param {boolean} [depth=true] - Whether the depth buffer should be cleared or not.
   * @param {boolean} [stencil=true] - Whether the stencil buffer should be cleared or not.
   */
  clear(e, t = !0, n = !0, i = !0) {
    const s = e.getRenderTarget();
    for (let a = 0; a < 6; a++)
      e.setRenderTarget(this, a), e.clear(t, n, i);
    e.setRenderTarget(s);
  }
}
class jn extends Bt {
  constructor() {
    super(), this.isGroup = !0, this.type = "Group";
  }
}
const Mh = { type: "move" };
class ya {
  /**
   * Constructs a new XR controller.
   */
  constructor() {
    this._targetRay = null, this._grip = null, this._hand = null;
  }
  /**
   * Returns a group representing the hand space of the XR controller.
   *
   * @return {Group} A group representing the hand space of the XR controller.
   */
  getHandSpace() {
    return this._hand === null && (this._hand = new jn(), this._hand.matrixAutoUpdate = !1, this._hand.visible = !1, this._hand.joints = {}, this._hand.inputState = { pinching: !1 }), this._hand;
  }
  /**
   * Returns a group representing the target ray space of the XR controller.
   *
   * @return {Group} A group representing the target ray space of the XR controller.
   */
  getTargetRaySpace() {
    return this._targetRay === null && (this._targetRay = new jn(), this._targetRay.matrixAutoUpdate = !1, this._targetRay.visible = !1, this._targetRay.hasLinearVelocity = !1, this._targetRay.linearVelocity = new I(), this._targetRay.hasAngularVelocity = !1, this._targetRay.angularVelocity = new I()), this._targetRay;
  }
  /**
   * Returns a group representing the grip space of the XR controller.
   *
   * @return {Group} A group representing the grip space of the XR controller.
   */
  getGripSpace() {
    return this._grip === null && (this._grip = new jn(), this._grip.matrixAutoUpdate = !1, this._grip.visible = !1, this._grip.hasLinearVelocity = !1, this._grip.linearVelocity = new I(), this._grip.hasAngularVelocity = !1, this._grip.angularVelocity = new I()), this._grip;
  }
  /**
   * Dispatches the given event to the groups representing
   * the different coordinate spaces of the XR controller.
   *
   * @param {Object} event - The event to dispatch.
   * @return {WebXRController} A reference to this instance.
   */
  dispatchEvent(e) {
    return this._targetRay !== null && this._targetRay.dispatchEvent(e), this._grip !== null && this._grip.dispatchEvent(e), this._hand !== null && this._hand.dispatchEvent(e), this;
  }
  /**
   * Connects the controller with the given XR input source.
   *
   * @param {XRInputSource} inputSource - The input source.
   * @return {WebXRController} A reference to this instance.
   */
  connect(e) {
    if (e && e.hand) {
      const t = this._hand;
      if (t)
        for (const n of e.hand.values())
          this._getHandJoint(t, n);
    }
    return this.dispatchEvent({ type: "connected", data: e }), this;
  }
  /**
   * Disconnects the controller from the given XR input source.
   *
   * @param {XRInputSource} inputSource - The input source.
   * @return {WebXRController} A reference to this instance.
   */
  disconnect(e) {
    return this.dispatchEvent({ type: "disconnected", data: e }), this._targetRay !== null && (this._targetRay.visible = !1), this._grip !== null && (this._grip.visible = !1), this._hand !== null && (this._hand.visible = !1), this;
  }
  /**
   * Updates the controller with the given input source, XR frame and reference space.
   * This updates the transformations of the groups that represent the different
   * coordinate systems of the controller.
   *
   * @param {XRInputSource} inputSource - The input source.
   * @param {XRFrame} frame - The XR frame.
   * @param {XRReferenceSpace} referenceSpace - The reference space.
   * @return {WebXRController} A reference to this instance.
   */
  update(e, t, n) {
    let i = null, s = null, a = null;
    const o = this._targetRay, c = this._grip, l = this._hand;
    if (e && t.session.visibilityState !== "visible-blurred") {
      if (l && e.hand) {
        a = !0;
        for (const _ of e.hand.values()) {
          const m = t.getJointPose(_, n), p = this._getHandJoint(l, _);
          m !== null && (p.matrix.fromArray(m.transform.matrix), p.matrix.decompose(p.position, p.rotation, p.scale), p.matrixWorldNeedsUpdate = !0, p.jointRadius = m.radius), p.visible = m !== null;
        }
        const u = l.joints["index-finger-tip"], h = l.joints["thumb-tip"], f = u.position.distanceTo(h.position), d = 0.02, g = 5e-3;
        l.inputState.pinching && f > d + g ? (l.inputState.pinching = !1, this.dispatchEvent({
          type: "pinchend",
          handedness: e.handedness,
          target: this
        })) : !l.inputState.pinching && f <= d - g && (l.inputState.pinching = !0, this.dispatchEvent({
          type: "pinchstart",
          handedness: e.handedness,
          target: this
        }));
      } else
        c !== null && e.gripSpace && (s = t.getPose(e.gripSpace, n), s !== null && (c.matrix.fromArray(s.transform.matrix), c.matrix.decompose(c.position, c.rotation, c.scale), c.matrixWorldNeedsUpdate = !0, s.linearVelocity ? (c.hasLinearVelocity = !0, c.linearVelocity.copy(s.linearVelocity)) : c.hasLinearVelocity = !1, s.angularVelocity ? (c.hasAngularVelocity = !0, c.angularVelocity.copy(s.angularVelocity)) : c.hasAngularVelocity = !1));
      o !== null && (i = t.getPose(e.targetRaySpace, n), i === null && s !== null && (i = s), i !== null && (o.matrix.fromArray(i.transform.matrix), o.matrix.decompose(o.position, o.rotation, o.scale), o.matrixWorldNeedsUpdate = !0, i.linearVelocity ? (o.hasLinearVelocity = !0, o.linearVelocity.copy(i.linearVelocity)) : o.hasLinearVelocity = !1, i.angularVelocity ? (o.hasAngularVelocity = !0, o.angularVelocity.copy(i.angularVelocity)) : o.hasAngularVelocity = !1, this.dispatchEvent(Mh)));
    }
    return o !== null && (o.visible = i !== null), c !== null && (c.visible = s !== null), l !== null && (l.visible = a !== null), this;
  }
  /**
   * Returns a group representing the hand joint for the given input joint.
   *
   * @private
   * @param {Group} hand - The group representing the hand space.
   * @param {XRJointSpace} inputjoint - The hand joint data.
   * @return {Group} A group representing the hand joint for the given input joint.
   */
  _getHandJoint(e, t) {
    if (e.joints[t.jointName] === void 0) {
      const n = new jn();
      n.matrixAutoUpdate = !1, n.visible = !1, e.joints[t.jointName] = n, e.add(n);
    }
    return e.joints[t.jointName];
  }
}
class co {
  /**
   * Constructs a new fog.
   *
   * @param {number|Color} color - The fog's color.
   * @param {number} [density=0.00025] - Defines how fast the fog will grow dense.
   */
  constructor(e, t = 25e-5) {
    this.isFogExp2 = !0, this.name = "", this.color = new Ge(e), this.density = t;
  }
  /**
   * Returns a new fog with copied values from this instance.
   *
   * @return {FogExp2} A clone of this instance.
   */
  clone() {
    return new co(this.color, this.density);
  }
  /**
   * Serializes the fog into JSON.
   *
   * @param {?(Object|string)} meta - An optional value holding meta information about the serialization.
   * @return {Object} A JSON object representing the serialized fog
   */
  toJSON() {
    return {
      type: "FogExp2",
      name: this.name,
      color: this.color.getHex(),
      density: this.density
    };
  }
}
class Vs extends Bt {
  /**
   * Constructs a new scene.
   */
  constructor() {
    super(), this.isScene = !0, this.type = "Scene", this.background = null, this.environment = null, this.fog = null, this.backgroundBlurriness = 0, this.backgroundIntensity = 1, this.backgroundRotation = new Vn(), this.environmentIntensity = 1, this.environmentRotation = new Vn(), this.overrideMaterial = null, typeof __THREE_DEVTOOLS__ < "u" && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", { detail: this }));
  }
  copy(e, t) {
    return super.copy(e, t), e.background !== null && (this.background = e.background.clone()), e.environment !== null && (this.environment = e.environment.clone()), e.fog !== null && (this.fog = e.fog.clone()), this.backgroundBlurriness = e.backgroundBlurriness, this.backgroundIntensity = e.backgroundIntensity, this.backgroundRotation.copy(e.backgroundRotation), this.environmentIntensity = e.environmentIntensity, this.environmentRotation.copy(e.environmentRotation), e.overrideMaterial !== null && (this.overrideMaterial = e.overrideMaterial.clone()), this.matrixAutoUpdate = e.matrixAutoUpdate, this;
  }
  toJSON(e) {
    const t = super.toJSON(e);
    return this.fog !== null && (t.object.fog = this.fog.toJSON()), this.backgroundBlurriness > 0 && (t.object.backgroundBlurriness = this.backgroundBlurriness), this.backgroundIntensity !== 1 && (t.object.backgroundIntensity = this.backgroundIntensity), t.object.backgroundRotation = this.backgroundRotation.toArray(), this.environmentIntensity !== 1 && (t.object.environmentIntensity = this.environmentIntensity), t.object.environmentRotation = this.environmentRotation.toArray(), t;
  }
}
class yh {
  /**
   * Constructs a new interleaved buffer.
   *
   * @param {TypedArray} array - A typed array with a shared buffer storing attribute data.
   * @param {number} stride - The number of typed-array elements per vertex.
   */
  constructor(e, t) {
    this.isInterleavedBuffer = !0, this.array = e, this.stride = t, this.count = e !== void 0 ? e.length / t : 0, this.usage = 35044, this.updateRanges = [], this.version = 0, this.uuid = Gn();
  }
  /**
   * A callback function that is executed after the renderer has transferred the attribute array
   * data to the GPU.
   */
  onUploadCallback() {
  }
  /**
   * Flag to indicate that this attribute has changed and should be re-sent to
   * the GPU. Set this to `true` when you modify the value of the array.
   *
   * @type {number}
   * @default false
   * @param {boolean} value
   */
  set needsUpdate(e) {
    e === !0 && this.version++;
  }
  /**
   * Sets the usage of this interleaved buffer.
   *
   * @param {(StaticDrawUsage|DynamicDrawUsage|StreamDrawUsage|StaticReadUsage|DynamicReadUsage|StreamReadUsage|StaticCopyUsage|DynamicCopyUsage|StreamCopyUsage)} value - The usage to set.
   * @return {InterleavedBuffer} A reference to this interleaved buffer.
   */
  setUsage(e) {
    return this.usage = e, this;
  }
  /**
   * Adds a range of data in the data array to be updated on the GPU.
   *
   * @param {number} start - Position at which to start update.
   * @param {number} count - The number of components to update.
   */
  addUpdateRange(e, t) {
    this.updateRanges.push({ start: e, count: t });
  }
  /**
   * Clears the update ranges.
   */
  clearUpdateRanges() {
    this.updateRanges.length = 0;
  }
  /**
   * Copies the values of the given interleaved buffer to this instance.
   *
   * @param {InterleavedBuffer} source - The interleaved buffer to copy.
   * @return {InterleavedBuffer} A reference to this instance.
   */
  copy(e) {
    return this.array = new e.array.constructor(e.array), this.count = e.count, this.stride = e.stride, this.usage = e.usage, this;
  }
  /**
   * Copies a vector from the given interleaved buffer to this one. The start
   * and destination position in the attribute buffers are represented by the
   * given indices.
   *
   * @param {number} index1 - The destination index into this interleaved buffer.
   * @param {InterleavedBuffer} interleavedBuffer - The interleaved buffer to copy from.
   * @param {number} index2 - The source index into the given interleaved buffer.
   * @return {InterleavedBuffer} A reference to this instance.
   */
  copyAt(e, t, n) {
    e *= this.stride, n *= t.stride;
    for (let i = 0, s = this.stride; i < s; i++)
      this.array[e + i] = t.array[n + i];
    return this;
  }
  /**
   * Sets the given array data in the interleaved buffer.
   *
   * @param {(TypedArray|Array)} value - The array data to set.
   * @param {number} [offset=0] - The offset in this interleaved buffer's array.
   * @return {InterleavedBuffer} A reference to this instance.
   */
  set(e, t = 0) {
    return this.array.set(e, t), this;
  }
  /**
   * Returns a new interleaved buffer with copied values from this instance.
   *
   * @param {Object} [data] - An object with shared array buffers that allows to retain shared structures.
   * @return {InterleavedBuffer} A clone of this instance.
   */
  clone(e) {
    e.arrayBuffers === void 0 && (e.arrayBuffers = {}), this.array.buffer._uuid === void 0 && (this.array.buffer._uuid = Gn()), e.arrayBuffers[this.array.buffer._uuid] === void 0 && (e.arrayBuffers[this.array.buffer._uuid] = this.array.slice(0).buffer);
    const t = new this.array.constructor(e.arrayBuffers[this.array.buffer._uuid]), n = new this.constructor(t, this.stride);
    return n.setUsage(this.usage), n;
  }
  /**
   * Sets the given callback function that is executed after the Renderer has transferred
   * the array data to the GPU. Can be used to perform clean-up operations after
   * the upload when data are not needed anymore on the CPU side.
   *
   * @param {Function} callback - The `onUpload()` callback.
   * @return {InterleavedBuffer} A reference to this instance.
   */
  onUpload(e) {
    return this.onUploadCallback = e, this;
  }
  /**
   * Serializes the interleaved buffer into JSON.
   *
   * @param {Object} [data] - An optional value holding meta information about the serialization.
   * @return {Object} A JSON object representing the serialized interleaved buffer.
   */
  toJSON(e) {
    return e.arrayBuffers === void 0 && (e.arrayBuffers = {}), this.array.buffer._uuid === void 0 && (this.array.buffer._uuid = Gn()), e.arrayBuffers[this.array.buffer._uuid] === void 0 && (e.arrayBuffers[this.array.buffer._uuid] = Array.from(new Uint32Array(this.array.buffer))), {
      uuid: this.uuid,
      buffer: this.array.buffer._uuid,
      type: this.array.constructor.name,
      stride: this.stride
    };
  }
}
const kt = /* @__PURE__ */ new I();
class Ls {
  /**
   * Constructs a new interleaved buffer attribute.
   *
   * @param {InterleavedBuffer} interleavedBuffer - The buffer holding the interleaved data.
   * @param {number} itemSize - The item size.
   * @param {number} offset - The attribute offset into the buffer.
   * @param {boolean} [normalized=false] - Whether the data are normalized or not.
   */
  constructor(e, t, n, i = !1) {
    this.isInterleavedBufferAttribute = !0, this.name = "", this.data = e, this.itemSize = t, this.offset = n, this.normalized = i;
  }
  /**
   * The item count of this buffer attribute.
   *
   * @type {number}
   * @readonly
   */
  get count() {
    return this.data.count;
  }
  /**
   * The array holding the interleaved buffer attribute data.
   *
   * @type {TypedArray}
   */
  get array() {
    return this.data.array;
  }
  /**
   * Flag to indicate that this attribute has changed and should be re-sent to
   * the GPU. Set this to `true` when you modify the value of the array.
   *
   * @type {number}
   * @default false
   * @param {boolean} value
   */
  set needsUpdate(e) {
    this.data.needsUpdate = e;
  }
  /**
   * Applies the given 4x4 matrix to the given attribute. Only works with
   * item size `3`.
   *
   * @param {Matrix4} m - The matrix to apply.
   * @return {InterleavedBufferAttribute} A reference to this instance.
   */
  applyMatrix4(e) {
    for (let t = 0, n = this.data.count; t < n; t++)
      kt.fromBufferAttribute(this, t), kt.applyMatrix4(e), this.setXYZ(t, kt.x, kt.y, kt.z);
    return this;
  }
  /**
   * Applies the given 3x3 normal matrix to the given attribute. Only works with
   * item size `3`.
   *
   * @param {Matrix3} m - The normal matrix to apply.
   * @return {InterleavedBufferAttribute} A reference to this instance.
   */
  applyNormalMatrix(e) {
    for (let t = 0, n = this.count; t < n; t++)
      kt.fromBufferAttribute(this, t), kt.applyNormalMatrix(e), this.setXYZ(t, kt.x, kt.y, kt.z);
    return this;
  }
  /**
   * Applies the given 4x4 matrix to the given attribute. Only works with
   * item size `3` and with direction vectors.
   *
   * @param {Matrix4} m - The matrix to apply.
   * @return {InterleavedBufferAttribute} A reference to this instance.
   */
  transformDirection(e) {
    for (let t = 0, n = this.count; t < n; t++)
      kt.fromBufferAttribute(this, t), kt.transformDirection(e), this.setXYZ(t, kt.x, kt.y, kt.z);
    return this;
  }
  /**
   * Returns the given component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} component - The component index.
   * @return {number} The returned value.
   */
  getComponent(e, t) {
    let n = this.array[e * this.data.stride + this.offset + t];
    return this.normalized && (n = yn(n, this.array)), n;
  }
  /**
   * Sets the given value to the given component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} component - The component index.
   * @param {number} value - The value to set.
   * @return {InterleavedBufferAttribute} A reference to this instance.
   */
  setComponent(e, t, n) {
    return this.normalized && (n = et(n, this.array)), this.data.array[e * this.data.stride + this.offset + t] = n, this;
  }
  /**
   * Sets the x component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} x - The value to set.
   * @return {InterleavedBufferAttribute} A reference to this instance.
   */
  setX(e, t) {
    return this.normalized && (t = et(t, this.array)), this.data.array[e * this.data.stride + this.offset] = t, this;
  }
  /**
   * Sets the y component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} y - The value to set.
   * @return {InterleavedBufferAttribute} A reference to this instance.
   */
  setY(e, t) {
    return this.normalized && (t = et(t, this.array)), this.data.array[e * this.data.stride + this.offset + 1] = t, this;
  }
  /**
   * Sets the z component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} z - The value to set.
   * @return {InterleavedBufferAttribute} A reference to this instance.
   */
  setZ(e, t) {
    return this.normalized && (t = et(t, this.array)), this.data.array[e * this.data.stride + this.offset + 2] = t, this;
  }
  /**
   * Sets the w component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} w - The value to set.
   * @return {InterleavedBufferAttribute} A reference to this instance.
   */
  setW(e, t) {
    return this.normalized && (t = et(t, this.array)), this.data.array[e * this.data.stride + this.offset + 3] = t, this;
  }
  /**
   * Returns the x component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @return {number} The x component.
   */
  getX(e) {
    let t = this.data.array[e * this.data.stride + this.offset];
    return this.normalized && (t = yn(t, this.array)), t;
  }
  /**
   * Returns the y component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @return {number} The y component.
   */
  getY(e) {
    let t = this.data.array[e * this.data.stride + this.offset + 1];
    return this.normalized && (t = yn(t, this.array)), t;
  }
  /**
   * Returns the z component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @return {number} The z component.
   */
  getZ(e) {
    let t = this.data.array[e * this.data.stride + this.offset + 2];
    return this.normalized && (t = yn(t, this.array)), t;
  }
  /**
   * Returns the w component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @return {number} The w component.
   */
  getW(e) {
    let t = this.data.array[e * this.data.stride + this.offset + 3];
    return this.normalized && (t = yn(t, this.array)), t;
  }
  /**
   * Sets the x and y component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} x - The value for the x component to set.
   * @param {number} y - The value for the y component to set.
   * @return {InterleavedBufferAttribute} A reference to this instance.
   */
  setXY(e, t, n) {
    return e = e * this.data.stride + this.offset, this.normalized && (t = et(t, this.array), n = et(n, this.array)), this.data.array[e + 0] = t, this.data.array[e + 1] = n, this;
  }
  /**
   * Sets the x, y and z component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} x - The value for the x component to set.
   * @param {number} y - The value for the y component to set.
   * @param {number} z - The value for the z component to set.
   * @return {InterleavedBufferAttribute} A reference to this instance.
   */
  setXYZ(e, t, n, i) {
    return e = e * this.data.stride + this.offset, this.normalized && (t = et(t, this.array), n = et(n, this.array), i = et(i, this.array)), this.data.array[e + 0] = t, this.data.array[e + 1] = n, this.data.array[e + 2] = i, this;
  }
  /**
   * Sets the x, y, z and w component of the vector at the given index.
   *
   * @param {number} index - The index into the buffer attribute.
   * @param {number} x - The value for the x component to set.
   * @param {number} y - The value for the y component to set.
   * @param {number} z - The value for the z component to set.
   * @param {number} w - The value for the w component to set.
   * @return {InterleavedBufferAttribute} A reference to this instance.
   */
  setXYZW(e, t, n, i, s) {
    return e = e * this.data.stride + this.offset, this.normalized && (t = et(t, this.array), n = et(n, this.array), i = et(i, this.array), s = et(s, this.array)), this.data.array[e + 0] = t, this.data.array[e + 1] = n, this.data.array[e + 2] = i, this.data.array[e + 3] = s, this;
  }
  /**
   * Returns a new buffer attribute with copied values from this instance.
   *
   * If no parameter is provided, cloning an interleaved buffer attribute will de-interleave buffer data.
   *
   * @param {Object} [data] - An object with interleaved buffers that allows to retain the interleaved property.
   * @return {BufferAttribute|InterleavedBufferAttribute} A clone of this instance.
   */
  clone(e) {
    if (e === void 0) {
      Ds("InterleavedBufferAttribute.clone(): Cloning an interleaved buffer attribute will de-interleave buffer data.");
      const t = [];
      for (let n = 0; n < this.count; n++) {
        const i = n * this.data.stride + this.offset;
        for (let s = 0; s < this.itemSize; s++)
          t.push(this.data.array[i + s]);
      }
      return new Nt(new this.array.constructor(t), this.itemSize, this.normalized);
    } else
      return e.interleavedBuffers === void 0 && (e.interleavedBuffers = {}), e.interleavedBuffers[this.data.uuid] === void 0 && (e.interleavedBuffers[this.data.uuid] = this.data.clone(e)), new Ls(e.interleavedBuffers[this.data.uuid], this.itemSize, this.offset, this.normalized);
  }
  /**
   * Serializes the buffer attribute into JSON.
   *
   * If no parameter is provided, cloning an interleaved buffer attribute will de-interleave buffer data.
   *
   * @param {Object} [data] - An optional value holding meta information about the serialization.
   * @return {Object} A JSON object representing the serialized buffer attribute.
   */
  toJSON(e) {
    if (e === void 0) {
      Ds("InterleavedBufferAttribute.toJSON(): Serializing an interleaved buffer attribute will de-interleave buffer data.");
      const t = [];
      for (let n = 0; n < this.count; n++) {
        const i = n * this.data.stride + this.offset;
        for (let s = 0; s < this.itemSize; s++)
          t.push(this.data.array[i + s]);
      }
      return {
        itemSize: this.itemSize,
        type: this.array.constructor.name,
        array: t,
        normalized: this.normalized
      };
    } else
      return e.interleavedBuffers === void 0 && (e.interleavedBuffers = {}), e.interleavedBuffers[this.data.uuid] === void 0 && (e.interleavedBuffers[this.data.uuid] = this.data.toJSON(e)), {
        isInterleavedBufferAttribute: !0,
        itemSize: this.itemSize,
        data: this.data.uuid,
        offset: this.offset,
        normalized: this.normalized
      };
  }
}
class ka extends Ai {
  /**
   * Constructs a new sprite material.
   *
   * @param {Object} [parameters] - An object with one or more properties
   * defining the material's appearance. Any property of the material
   * (including any property from inherited materials) can be passed
   * in here. Color values can be passed any type of value accepted
   * by {@link Color#set}.
   */
  constructor(e) {
    super(), this.isSpriteMaterial = !0, this.type = "SpriteMaterial", this.color = new Ge(16777215), this.map = null, this.alphaMap = null, this.rotation = 0, this.sizeAttenuation = !0, this.transparent = !0, this.fog = !0, this.setValues(e);
  }
  copy(e) {
    return super.copy(e), this.color.copy(e.color), this.map = e.map, this.alphaMap = e.alphaMap, this.rotation = e.rotation, this.sizeAttenuation = e.sizeAttenuation, this.fog = e.fog, this;
  }
}
let ki;
const mr = /* @__PURE__ */ new I(), Vi = /* @__PURE__ */ new I(), Hi = /* @__PURE__ */ new I(), Wi = /* @__PURE__ */ new Ae(), _r = /* @__PURE__ */ new Ae(), pc = /* @__PURE__ */ new ht(), ps = /* @__PURE__ */ new I(), gr = /* @__PURE__ */ new I(), ms = /* @__PURE__ */ new I(), sl = /* @__PURE__ */ new Ae(), Ea = /* @__PURE__ */ new Ae(), al = /* @__PURE__ */ new Ae();
class ol extends Bt {
  /**
   * Constructs a new sprite.
   *
   * @param {(SpriteMaterial|SpriteNodeMaterial)} [material] - The sprite material.
   */
  constructor(e = new ka()) {
    if (super(), this.isSprite = !0, this.type = "Sprite", ki === void 0) {
      ki = new Qt();
      const t = new Float32Array([
        -0.5,
        -0.5,
        0,
        0,
        0,
        0.5,
        -0.5,
        0,
        1,
        0,
        0.5,
        0.5,
        0,
        1,
        1,
        -0.5,
        0.5,
        0,
        0,
        1
      ]), n = new yh(t, 5);
      ki.setIndex([0, 1, 2, 0, 2, 3]), ki.setAttribute("position", new Ls(n, 3, 0, !1)), ki.setAttribute("uv", new Ls(n, 2, 3, !1));
    }
    this.geometry = ki, this.material = e, this.center = new Ae(0.5, 0.5), this.count = 1;
  }
  /**
   * Computes intersection points between a casted ray and this sprite.
   *
   * @param {Raycaster} raycaster - The raycaster.
   * @param {Array<Object>} intersects - The target array that holds the intersection points.
   */
  raycast(e, t) {
    e.camera === null && Xe('Sprite: "Raycaster.camera" needs to be set in order to raycast against sprites.'), Vi.setFromMatrixScale(this.matrixWorld), pc.copy(e.camera.matrixWorld), this.modelViewMatrix.multiplyMatrices(e.camera.matrixWorldInverse, this.matrixWorld), Hi.setFromMatrixPosition(this.modelViewMatrix), e.camera.isPerspectiveCamera && this.material.sizeAttenuation === !1 && Vi.multiplyScalar(-Hi.z);
    const n = this.material.rotation;
    let i, s;
    n !== 0 && (s = Math.cos(n), i = Math.sin(n));
    const a = this.center;
    _s(ps.set(-0.5, -0.5, 0), Hi, a, Vi, i, s), _s(gr.set(0.5, -0.5, 0), Hi, a, Vi, i, s), _s(ms.set(0.5, 0.5, 0), Hi, a, Vi, i, s), sl.set(0, 0), Ea.set(1, 0), al.set(1, 1);
    let o = e.ray.intersectTriangle(ps, gr, ms, !1, mr);
    if (o === null && (_s(gr.set(-0.5, 0.5, 0), Hi, a, Vi, i, s), Ea.set(0, 1), o = e.ray.intersectTriangle(ps, ms, gr, !1, mr), o === null))
      return;
    const c = e.ray.origin.distanceTo(mr);
    c < e.near || c > e.far || t.push({
      distance: c,
      point: mr.clone(),
      uv: mn.getInterpolation(mr, ps, gr, ms, sl, Ea, al, new Ae()),
      face: null,
      object: this
    });
  }
  copy(e, t) {
    return super.copy(e, t), e.center !== void 0 && this.center.copy(e.center), this.material = e.material, this;
  }
}
function _s(r, e, t, n, i, s) {
  Wi.subVectors(r, t).addScalar(0.5).multiply(n), i !== void 0 ? (_r.x = s * Wi.x - i * Wi.y, _r.y = i * Wi.x + s * Wi.y) : _r.copy(Wi), r.copy(e), r.x += _r.x, r.y += _r.y, r.applyMatrix4(pc);
}
class mc extends bt {
  /**
   * Constructs a new data texture.
   *
   * @param {?TypedArray} [data=null] - The buffer data.
   * @param {number} [width=1] - The width of the texture.
   * @param {number} [height=1] - The height of the texture.
   * @param {number} [format=RGBAFormat] - The texture format.
   * @param {number} [type=UnsignedByteType] - The texture type.
   * @param {number} [mapping=Texture.DEFAULT_MAPPING] - The texture mapping.
   * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
   * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
   * @param {number} [magFilter=NearestFilter] - The mag filter value.
   * @param {number} [minFilter=NearestFilter] - The min filter value.
   * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
   * @param {string} [colorSpace=NoColorSpace] - The color space.
   */
  constructor(e = null, t = 1, n = 1, i, s, a, o, c, l = 1003, u = 1003, h, f) {
    super(null, a, o, c, l, u, i, s, h, f), this.isDataTexture = !0, this.image = { data: e, width: t, height: n }, this.generateMipmaps = !1, this.flipY = !1, this.unpackAlignment = 1;
  }
}
const Ta = /* @__PURE__ */ new I(), Eh = /* @__PURE__ */ new I(), Th = /* @__PURE__ */ new Ue();
class vi {
  /**
   * Constructs a new plane.
   *
   * @param {Vector3} [normal=(1,0,0)] - A unit length vector defining the normal of the plane.
   * @param {number} [constant=0] - The signed distance from the origin to the plane.
   */
  constructor(e = new I(1, 0, 0), t = 0) {
    this.isPlane = !0, this.normal = e, this.constant = t;
  }
  /**
   * Sets the plane components by copying the given values.
   *
   * @param {Vector3} normal - The normal.
   * @param {number} constant - The constant.
   * @return {Plane} A reference to this plane.
   */
  set(e, t) {
    return this.normal.copy(e), this.constant = t, this;
  }
  /**
   * Sets the plane components by defining `x`, `y`, `z` as the
   * plane normal and `w` as the constant.
   *
   * @param {number} x - The value for the normal's x component.
   * @param {number} y - The value for the normal's y component.
   * @param {number} z - The value for the normal's z component.
   * @param {number} w - The constant value.
   * @return {Plane} A reference to this plane.
   */
  setComponents(e, t, n, i) {
    return this.normal.set(e, t, n), this.constant = i, this;
  }
  /**
   * Sets the plane from the given normal and coplanar point (that is a point
   * that lies onto the plane).
   *
   * @param {Vector3} normal - The normal.
   * @param {Vector3} point - A coplanar point.
   * @return {Plane} A reference to this plane.
   */
  setFromNormalAndCoplanarPoint(e, t) {
    return this.normal.copy(e), this.constant = -t.dot(this.normal), this;
  }
  /**
   * Sets the plane from three coplanar points. The winding order is
   * assumed to be counter-clockwise, and determines the direction of
   * the plane normal.
   *
   * @param {Vector3} a - The first coplanar point.
   * @param {Vector3} b - The second coplanar point.
   * @param {Vector3} c - The third coplanar point.
   * @return {Plane} A reference to this plane.
   */
  setFromCoplanarPoints(e, t, n) {
    const i = Ta.subVectors(n, t).cross(Eh.subVectors(e, t)).normalize();
    return this.setFromNormalAndCoplanarPoint(i, e), this;
  }
  /**
   * Copies the values of the given plane to this instance.
   *
   * @param {Plane} plane - The plane to copy.
   * @return {Plane} A reference to this plane.
   */
  copy(e) {
    return this.normal.copy(e.normal), this.constant = e.constant, this;
  }
  /**
   * Normalizes the plane normal and adjusts the constant accordingly.
   *
   * @return {Plane} A reference to this plane.
   */
  normalize() {
    const e = 1 / this.normal.length();
    return this.normal.multiplyScalar(e), this.constant *= e, this;
  }
  /**
   * Negates both the plane normal and the constant.
   *
   * @return {Plane} A reference to this plane.
   */
  negate() {
    return this.constant *= -1, this.normal.negate(), this;
  }
  /**
   * Returns the signed distance from the given point to this plane.
   *
   * @param {Vector3} point - The point to compute the distance for.
   * @return {number} The signed distance.
   */
  distanceToPoint(e) {
    return this.normal.dot(e) + this.constant;
  }
  /**
   * Returns the signed distance from the given sphere to this plane.
   *
   * @param {Sphere} sphere - The sphere to compute the distance for.
   * @return {number} The signed distance.
   */
  distanceToSphere(e) {
    return this.distanceToPoint(e.center) - e.radius;
  }
  /**
   * Projects a the given point onto the plane.
   *
   * @param {Vector3} point - The point to project.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} The projected point on the plane.
   */
  projectPoint(e, t) {
    return t.copy(e).addScaledVector(this.normal, -this.distanceToPoint(e));
  }
  /**
   * Returns the intersection point of the passed line and the plane. Returns
   * `null` if the line does not intersect. Returns the line's starting point if
   * the line is coplanar with the plane.
   *
   * @param {Line3} line - The line to compute the intersection for.
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {?Vector3} The intersection point.
   */
  intersectLine(e, t) {
    const n = e.delta(Ta), i = this.normal.dot(n);
    if (i === 0)
      return this.distanceToPoint(e.start) === 0 ? t.copy(e.start) : null;
    const s = -(e.start.dot(this.normal) + this.constant) / i;
    return s < 0 || s > 1 ? null : t.copy(e.start).addScaledVector(n, s);
  }
  /**
   * Returns `true` if the given line segment intersects with (passes through) the plane.
   *
   * @param {Line3} line - The line to test.
   * @return {boolean} Whether the given line segment intersects with the plane or not.
   */
  intersectsLine(e) {
    const t = this.distanceToPoint(e.start), n = this.distanceToPoint(e.end);
    return t < 0 && n > 0 || n < 0 && t > 0;
  }
  /**
   * Returns `true` if the given bounding box intersects with the plane.
   *
   * @param {Box3} box - The bounding box to test.
   * @return {boolean} Whether the given bounding box intersects with the plane or not.
   */
  intersectsBox(e) {
    return e.intersectsPlane(this);
  }
  /**
   * Returns `true` if the given bounding sphere intersects with the plane.
   *
   * @param {Sphere} sphere - The bounding sphere to test.
   * @return {boolean} Whether the given bounding sphere intersects with the plane or not.
   */
  intersectsSphere(e) {
    return e.intersectsPlane(this);
  }
  /**
   * Returns a coplanar vector to the plane, by calculating the
   * projection of the normal at the origin onto the plane.
   *
   * @param {Vector3} target - The target vector that is used to store the method's result.
   * @return {Vector3} The coplanar point.
   */
  coplanarPoint(e) {
    return e.copy(this.normal).multiplyScalar(-this.constant);
  }
  /**
   * Apply a 4x4 matrix to the plane. The matrix must be an affine, homogeneous transform.
   *
   * The optional normal matrix can be pre-computed like so:
   * ```js
   * const optionalNormalMatrix = new THREE.Matrix3().getNormalMatrix( matrix );
   * ```
   *
   * @param {Matrix4} matrix - The transformation matrix.
   * @param {Matrix4} [optionalNormalMatrix] - A pre-computed normal matrix.
   * @return {Plane} A reference to this plane.
   */
  applyMatrix4(e, t) {
    const n = t || Th.getNormalMatrix(e), i = this.coplanarPoint(Ta).applyMatrix4(e), s = this.normal.applyMatrix3(n).normalize();
    return this.constant = -i.dot(s), this;
  }
  /**
   * Translates the plane by the distance defined by the given offset vector.
   * Note that this only affects the plane constant and will not affect the normal vector.
   *
   * @param {Vector3} offset - The offset vector.
   * @return {Plane} A reference to this plane.
   */
  translate(e) {
    return this.constant -= e.dot(this.normal), this;
  }
  /**
   * Returns `true` if this plane is equal with the given one.
   *
   * @param {Plane} plane - The plane to test for equality.
   * @return {boolean} Whether this plane is equal with the given one.
   */
  equals(e) {
    return e.normal.equals(this.normal) && e.constant === this.constant;
  }
  /**
   * Returns a new plane with copied values from this instance.
   *
   * @return {Plane} A clone of this instance.
   */
  clone() {
    return new this.constructor().copy(this);
  }
}
const di = /* @__PURE__ */ new Yr(), bh = /* @__PURE__ */ new Ae(0.5, 0.5), gs = /* @__PURE__ */ new I();
class _c {
  /**
   * Constructs a new frustum.
   *
   * @param {Plane} [p0] - The first plane that encloses the frustum.
   * @param {Plane} [p1] - The second plane that encloses the frustum.
   * @param {Plane} [p2] - The third plane that encloses the frustum.
   * @param {Plane} [p3] - The fourth plane that encloses the frustum.
   * @param {Plane} [p4] - The fifth plane that encloses the frustum.
   * @param {Plane} [p5] - The sixth plane that encloses the frustum.
   */
  constructor(e = new vi(), t = new vi(), n = new vi(), i = new vi(), s = new vi(), a = new vi()) {
    this.planes = [e, t, n, i, s, a];
  }
  /**
   * Sets the frustum planes by copying the given planes.
   *
   * @param {Plane} [p0] - The first plane that encloses the frustum.
   * @param {Plane} [p1] - The second plane that encloses the frustum.
   * @param {Plane} [p2] - The third plane that encloses the frustum.
   * @param {Plane} [p3] - The fourth plane that encloses the frustum.
   * @param {Plane} [p4] - The fifth plane that encloses the frustum.
   * @param {Plane} [p5] - The sixth plane that encloses the frustum.
   * @return {Frustum} A reference to this frustum.
   */
  set(e, t, n, i, s, a) {
    const o = this.planes;
    return o[0].copy(e), o[1].copy(t), o[2].copy(n), o[3].copy(i), o[4].copy(s), o[5].copy(a), this;
  }
  /**
   * Copies the values of the given frustum to this instance.
   *
   * @param {Frustum} frustum - The frustum to copy.
   * @return {Frustum} A reference to this frustum.
   */
  copy(e) {
    const t = this.planes;
    for (let n = 0; n < 6; n++)
      t[n].copy(e.planes[n]);
    return this;
  }
  /**
   * Sets the frustum planes from the given projection matrix.
   *
   * @param {Matrix4} m - The projection matrix.
   * @param {(WebGLCoordinateSystem|WebGPUCoordinateSystem)} coordinateSystem - The coordinate system.
   * @param {boolean} [reversedDepth=false] - Whether to use a reversed depth.
   * @return {Frustum} A reference to this frustum.
   */
  setFromProjectionMatrix(e, t = 2e3, n = !1) {
    const i = this.planes, s = e.elements, a = s[0], o = s[1], c = s[2], l = s[3], u = s[4], h = s[5], f = s[6], d = s[7], g = s[8], _ = s[9], m = s[10], p = s[11], S = s[12], b = s[13], T = s[14], y = s[15];
    if (i[0].setComponents(l - a, d - u, p - g, y - S).normalize(), i[1].setComponents(l + a, d + u, p + g, y + S).normalize(), i[2].setComponents(l + o, d + h, p + _, y + b).normalize(), i[3].setComponents(l - o, d - h, p - _, y - b).normalize(), n)
      i[4].setComponents(c, f, m, T).normalize(), i[5].setComponents(l - c, d - f, p - m, y - T).normalize();
    else if (i[4].setComponents(l - c, d - f, p - m, y - T).normalize(), t === 2e3)
      i[5].setComponents(l + c, d + f, p + m, y + T).normalize();
    else if (t === 2001)
      i[5].setComponents(c, f, m, T).normalize();
    else
      throw new Error("THREE.Frustum.setFromProjectionMatrix(): Invalid coordinate system: " + t);
    return this;
  }
  /**
   * Returns `true` if the 3D object's bounding sphere is intersecting this frustum.
   *
   * Note that the 3D object must have a geometry so that the bounding sphere can be calculated.
   *
   * @param {Object3D} object - The 3D object to test.
   * @return {boolean} Whether the 3D object's bounding sphere is intersecting this frustum or not.
   */
  intersectsObject(e) {
    if (e.boundingSphere !== void 0)
      e.boundingSphere === null && e.computeBoundingSphere(), di.copy(e.boundingSphere).applyMatrix4(e.matrixWorld);
    else {
      const t = e.geometry;
      t.boundingSphere === null && t.computeBoundingSphere(), di.copy(t.boundingSphere).applyMatrix4(e.matrixWorld);
    }
    return this.intersectsSphere(di);
  }
  /**
   * Returns `true` if the given sprite is intersecting this frustum.
   *
   * @param {Sprite} sprite - The sprite to test.
   * @return {boolean} Whether the sprite is intersecting this frustum or not.
   */
  intersectsSprite(e) {
    di.center.set(0, 0, 0);
    const t = bh.distanceTo(e.center);
    return di.radius = 0.7071067811865476 + t, di.applyMatrix4(e.matrixWorld), this.intersectsSphere(di);
  }
  /**
   * Returns `true` if the given bounding sphere is intersecting this frustum.
   *
   * @param {Sphere} sphere - The bounding sphere to test.
   * @return {boolean} Whether the bounding sphere is intersecting this frustum or not.
   */
  intersectsSphere(e) {
    const t = this.planes, n = e.center, i = -e.radius;
    for (let s = 0; s < 6; s++)
      if (t[s].distanceToPoint(n) < i)
        return !1;
    return !0;
  }
  /**
   * Returns `true` if the given bounding box is intersecting this frustum.
   *
   * @param {Box3} box - The bounding box to test.
   * @return {boolean} Whether the bounding box is intersecting this frustum or not.
   */
  intersectsBox(e) {
    const t = this.planes;
    for (let n = 0; n < 6; n++) {
      const i = t[n];
      if (gs.x = i.normal.x > 0 ? e.max.x : e.min.x, gs.y = i.normal.y > 0 ? e.max.y : e.min.y, gs.z = i.normal.z > 0 ? e.max.z : e.min.z, i.distanceToPoint(gs) < 0)
        return !1;
    }
    return !0;
  }
  /**
   * Returns `true` if the given point lies within the frustum.
   *
   * @param {Vector3} point - The point to test.
   * @return {boolean} Whether the point lies within this frustum or not.
   */
  containsPoint(e) {
    const t = this.planes;
    for (let n = 0; n < 6; n++)
      if (t[n].distanceToPoint(e) < 0)
        return !1;
    return !0;
  }
  /**
   * Returns a new frustum with copied values from this instance.
   *
   * @return {Frustum} A clone of this instance.
   */
  clone() {
    return new this.constructor().copy(this);
  }
}
class gc extends Ai {
  /**
   * Constructs a new line basic material.
   *
   * @param {Object} [parameters] - An object with one or more properties
   * defining the material's appearance. Any property of the material
   * (including any property from inherited materials) can be passed
   * in here. Color values can be passed any type of value accepted
   * by {@link Color#set}.
   */
  constructor(e) {
    super(), this.isLineBasicMaterial = !0, this.type = "LineBasicMaterial", this.color = new Ge(16777215), this.map = null, this.linewidth = 1, this.linecap = "round", this.linejoin = "round", this.fog = !0, this.setValues(e);
  }
  copy(e) {
    return super.copy(e), this.color.copy(e.color), this.map = e.map, this.linewidth = e.linewidth, this.linecap = e.linecap, this.linejoin = e.linejoin, this.fog = e.fog, this;
  }
}
const Fs = /* @__PURE__ */ new I(), Us = /* @__PURE__ */ new I(), ll = /* @__PURE__ */ new ht(), vr = /* @__PURE__ */ new oo(), vs = /* @__PURE__ */ new Yr(), ba = /* @__PURE__ */ new I(), cl = /* @__PURE__ */ new I();
class Ah extends Bt {
  /**
   * Constructs a new line.
   *
   * @param {BufferGeometry} [geometry] - The line geometry.
   * @param {Material|Array<Material>} [material] - The line material.
   */
  constructor(e = new Qt(), t = new gc()) {
    super(), this.isLine = !0, this.type = "Line", this.geometry = e, this.material = t, this.morphTargetDictionary = void 0, this.morphTargetInfluences = void 0, this.updateMorphTargets();
  }
  copy(e, t) {
    return super.copy(e, t), this.material = Array.isArray(e.material) ? e.material.slice() : e.material, this.geometry = e.geometry, this;
  }
  /**
   * Computes an array of distance values which are necessary for rendering dashed lines.
   * For each vertex in the geometry, the method calculates the cumulative length from the
   * current point to the very beginning of the line.
   *
   * @return {Line} A reference to this line.
   */
  computeLineDistances() {
    const e = this.geometry;
    if (e.index === null) {
      const t = e.attributes.position, n = [0];
      for (let i = 1, s = t.count; i < s; i++)
        Fs.fromBufferAttribute(t, i - 1), Us.fromBufferAttribute(t, i), n[i] = n[i - 1], n[i] += Fs.distanceTo(Us);
      e.setAttribute("lineDistance", new Pn(n, 1));
    } else
      Ce("Line.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.");
    return this;
  }
  /**
   * Computes intersection points between a casted ray and this line.
   *
   * @param {Raycaster} raycaster - The raycaster.
   * @param {Array<Object>} intersects - The target array that holds the intersection points.
   */
  raycast(e, t) {
    const n = this.geometry, i = this.matrixWorld, s = e.params.Line.threshold, a = n.drawRange;
    if (n.boundingSphere === null && n.computeBoundingSphere(), vs.copy(n.boundingSphere), vs.applyMatrix4(i), vs.radius += s, e.ray.intersectsSphere(vs) === !1) return;
    ll.copy(i).invert(), vr.copy(e.ray).applyMatrix4(ll);
    const o = s / ((this.scale.x + this.scale.y + this.scale.z) / 3), c = o * o, l = this.isLineSegments ? 2 : 1, u = n.index, f = n.attributes.position;
    if (u !== null) {
      const d = Math.max(0, a.start), g = Math.min(u.count, a.start + a.count);
      for (let _ = d, m = g - 1; _ < m; _ += l) {
        const p = u.getX(_), S = u.getX(_ + 1), b = xs(this, e, vr, c, p, S, _);
        b && t.push(b);
      }
      if (this.isLineLoop) {
        const _ = u.getX(g - 1), m = u.getX(d), p = xs(this, e, vr, c, _, m, g - 1);
        p && t.push(p);
      }
    } else {
      const d = Math.max(0, a.start), g = Math.min(f.count, a.start + a.count);
      for (let _ = d, m = g - 1; _ < m; _ += l) {
        const p = xs(this, e, vr, c, _, _ + 1, _);
        p && t.push(p);
      }
      if (this.isLineLoop) {
        const _ = xs(this, e, vr, c, g - 1, d, g - 1);
        _ && t.push(_);
      }
    }
  }
  /**
   * Sets the values of {@link Line#morphTargetDictionary} and {@link Line#morphTargetInfluences}
   * to make sure existing morph targets can influence this 3D object.
   */
  updateMorphTargets() {
    const t = this.geometry.morphAttributes, n = Object.keys(t);
    if (n.length > 0) {
      const i = t[n[0]];
      if (i !== void 0) {
        this.morphTargetInfluences = [], this.morphTargetDictionary = {};
        for (let s = 0, a = i.length; s < a; s++) {
          const o = i[s].name || String(s);
          this.morphTargetInfluences.push(0), this.morphTargetDictionary[o] = s;
        }
      }
    }
  }
}
function xs(r, e, t, n, i, s, a) {
  const o = r.geometry.attributes.position;
  if (Fs.fromBufferAttribute(o, i), Us.fromBufferAttribute(o, s), t.distanceSqToSegment(Fs, Us, ba, cl) > n) return;
  ba.applyMatrix4(r.matrixWorld);
  const l = e.ray.origin.distanceTo(ba);
  if (!(l < e.near || l > e.far))
    return {
      distance: l,
      // What do we want? intersection point on the ray or on the segment??
      // point: raycaster.ray.at( distance ),
      point: cl.clone().applyMatrix4(r.matrixWorld),
      index: a,
      face: null,
      faceIndex: null,
      barycoord: null,
      object: r
    };
}
class wh extends Ah {
  /**
   * Constructs a new line loop.
   *
   * @param {BufferGeometry} [geometry] - The line geometry.
   * @param {Material|Array<Material>} [material] - The line material.
   */
  constructor(e, t) {
    super(e, t), this.isLineLoop = !0, this.type = "LineLoop";
  }
}
class Rh extends Ai {
  /**
   * Constructs a new points material.
   *
   * @param {Object} [parameters] - An object with one or more properties
   * defining the material's appearance. Any property of the material
   * (including any property from inherited materials) can be passed
   * in here. Color values can be passed any type of value accepted
   * by {@link Color#set}.
   */
  constructor(e) {
    super(), this.isPointsMaterial = !0, this.type = "PointsMaterial", this.color = new Ge(16777215), this.map = null, this.alphaMap = null, this.size = 1, this.sizeAttenuation = !0, this.fog = !0, this.setValues(e);
  }
  copy(e) {
    return super.copy(e), this.color.copy(e.color), this.map = e.map, this.alphaMap = e.alphaMap, this.size = e.size, this.sizeAttenuation = e.sizeAttenuation, this.fog = e.fog, this;
  }
}
const ul = /* @__PURE__ */ new ht(), Va = /* @__PURE__ */ new oo(), Ss = /* @__PURE__ */ new Yr(), Ms = /* @__PURE__ */ new I();
class Ch extends Bt {
  /**
   * Constructs a new point cloud.
   *
   * @param {BufferGeometry} [geometry] - The points geometry.
   * @param {Material|Array<Material>} [material] - The points material.
   */
  constructor(e = new Qt(), t = new Rh()) {
    super(), this.isPoints = !0, this.type = "Points", this.geometry = e, this.material = t, this.morphTargetDictionary = void 0, this.morphTargetInfluences = void 0, this.updateMorphTargets();
  }
  copy(e, t) {
    return super.copy(e, t), this.material = Array.isArray(e.material) ? e.material.slice() : e.material, this.geometry = e.geometry, this;
  }
  /**
   * Computes intersection points between a casted ray and this point cloud.
   *
   * @param {Raycaster} raycaster - The raycaster.
   * @param {Array<Object>} intersects - The target array that holds the intersection points.
   */
  raycast(e, t) {
    const n = this.geometry, i = this.matrixWorld, s = e.params.Points.threshold, a = n.drawRange;
    if (n.boundingSphere === null && n.computeBoundingSphere(), Ss.copy(n.boundingSphere), Ss.applyMatrix4(i), Ss.radius += s, e.ray.intersectsSphere(Ss) === !1) return;
    ul.copy(i).invert(), Va.copy(e.ray).applyMatrix4(ul);
    const o = s / ((this.scale.x + this.scale.y + this.scale.z) / 3), c = o * o, l = n.index, h = n.attributes.position;
    if (l !== null) {
      const f = Math.max(0, a.start), d = Math.min(l.count, a.start + a.count);
      for (let g = f, _ = d; g < _; g++) {
        const m = l.getX(g);
        Ms.fromBufferAttribute(h, m), hl(Ms, m, c, i, e, t, this);
      }
    } else {
      const f = Math.max(0, a.start), d = Math.min(h.count, a.start + a.count);
      for (let g = f, _ = d; g < _; g++)
        Ms.fromBufferAttribute(h, g), hl(Ms, g, c, i, e, t, this);
    }
  }
  /**
   * Sets the values of {@link Points#morphTargetDictionary} and {@link Points#morphTargetInfluences}
   * to make sure existing morph targets can influence this 3D object.
   */
  updateMorphTargets() {
    const t = this.geometry.morphAttributes, n = Object.keys(t);
    if (n.length > 0) {
      const i = t[n[0]];
      if (i !== void 0) {
        this.morphTargetInfluences = [], this.morphTargetDictionary = {};
        for (let s = 0, a = i.length; s < a; s++) {
          const o = i[s].name || String(s);
          this.morphTargetInfluences.push(0), this.morphTargetDictionary[o] = s;
        }
      }
    }
  }
}
function hl(r, e, t, n, i, s, a) {
  const o = Va.distanceSqToPoint(r);
  if (o < t) {
    const c = new I();
    Va.closestPointToPoint(r, c), c.applyMatrix4(n);
    const l = i.ray.origin.distanceTo(c);
    if (l < i.near || l > i.far) return;
    s.push({
      distance: l,
      distanceToRay: Math.sqrt(o),
      point: c,
      index: e,
      face: null,
      faceIndex: null,
      barycoord: null,
      object: a
    });
  }
}
class vc extends bt {
  /**
   * Constructs a new texture.
   *
   * @param {HTMLCanvasElement} [canvas] - The HTML canvas element.
   * @param {number} [mapping=Texture.DEFAULT_MAPPING] - The texture mapping.
   * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
   * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
   * @param {number} [magFilter=LinearFilter] - The mag filter value.
   * @param {number} [minFilter=LinearMipmapLinearFilter] - The min filter value.
   * @param {number} [format=RGBAFormat] - The texture format.
   * @param {number} [type=UnsignedByteType] - The texture type.
   * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
   */
  constructor(e, t, n, i, s, a, o, c, l) {
    super(e, t, n, i, s, a, o, c, l), this.isCanvasTexture = !0, this.needsUpdate = !0;
  }
}
class Nr extends bt {
  /**
   * Constructs a new depth texture.
   *
   * @param {number} width - The width of the texture.
   * @param {number} height - The height of the texture.
   * @param {number} [type=UnsignedIntType] - The texture type.
   * @param {number} [mapping=Texture.DEFAULT_MAPPING] - The texture mapping.
   * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
   * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
   * @param {number} [magFilter=LinearFilter] - The mag filter value.
   * @param {number} [minFilter=LinearFilter] - The min filter value.
   * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
   * @param {number} [format=DepthFormat] - The texture format.
   * @param {number} [depth=1] - The depth of the texture.
   */
  constructor(e, t, n = 1014, i, s, a, o = 1003, c = 1003, l, u = 1026, h = 1) {
    if (u !== 1026 && u !== 1027)
      throw new Error("DepthTexture format must be either THREE.DepthFormat or THREE.DepthStencilFormat");
    const f = { width: e, height: t, depth: h };
    super(f, i, s, a, o, c, u, n, l), this.isDepthTexture = !0, this.flipY = !1, this.generateMipmaps = !1, this.compareFunction = null;
  }
  copy(e) {
    return super.copy(e), this.source = new ao(Object.assign({}, e.image)), this.compareFunction = e.compareFunction, this;
  }
  toJSON(e) {
    const t = super.toJSON(e);
    return this.compareFunction !== null && (t.compareFunction = this.compareFunction), t;
  }
}
class Ph extends Nr {
  /**
   * Constructs a new cube depth texture.
   *
   * @param {number} size - The size (width and height) of each cube face.
   * @param {number} [type=UnsignedIntType] - The texture type.
   * @param {number} [mapping=CubeReflectionMapping] - The texture mapping.
   * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
   * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
   * @param {number} [magFilter=NearestFilter] - The mag filter value.
   * @param {number} [minFilter=NearestFilter] - The min filter value.
   * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
   * @param {number} [format=DepthFormat] - The texture format.
   */
  constructor(e, t = 1014, n = 301, i, s, a = 1003, o = 1003, c, l = 1026) {
    const u = { width: e, height: e, depth: 1 }, h = [u, u, u, u, u, u];
    super(e, e, t, n, i, s, a, o, c, l), this.image = h, this.isCubeDepthTexture = !0, this.isCubeTexture = !0;
  }
  /**
   * Alias for {@link CubeDepthTexture#image}.
   *
   * @type {Array<Image>}
   */
  get images() {
    return this.image;
  }
  set images(e) {
    this.image = e;
  }
}
class xc extends bt {
  /**
   * Creates a new raw texture.
   *
   * @param {?(WebGLTexture|GPUTexture)} [sourceTexture=null] - The external texture.
   */
  constructor(e = null) {
    super(), this.sourceTexture = e, this.isExternalTexture = !0;
  }
  copy(e) {
    return super.copy(e), this.sourceTexture = e.sourceTexture, this;
  }
}
class Dh {
  /**
   * Constructs a new curve.
   */
  constructor() {
    this.type = "Curve", this.arcLengthDivisions = 200, this.needsUpdate = !1, this.cacheArcLengths = null;
  }
  /**
   * This method returns a vector in 2D or 3D space (depending on the curve definition)
   * for the given interpolation factor.
   *
   * @abstract
   * @param {number} t - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
   * @param {(Vector2|Vector3)} [optionalTarget] - The optional target vector the result is written to.
   * @return {(Vector2|Vector3)} The position on the curve. It can be a 2D or 3D vector depending on the curve definition.
   */
  getPoint() {
    Ce("Curve: .getPoint() not implemented.");
  }
  /**
   * This method returns a vector in 2D or 3D space (depending on the curve definition)
   * for the given interpolation factor. Unlike {@link Curve#getPoint}, this method honors the length
   * of the curve which equidistant samples.
   *
   * @param {number} u - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
   * @param {(Vector2|Vector3)} [optionalTarget] - The optional target vector the result is written to.
   * @return {(Vector2|Vector3)} The position on the curve. It can be a 2D or 3D vector depending on the curve definition.
   */
  getPointAt(e, t) {
    const n = this.getUtoTmapping(e);
    return this.getPoint(n, t);
  }
  /**
   * This method samples the curve via {@link Curve#getPoint} and returns an array of points representing
   * the curve shape.
   *
   * @param {number} [divisions=5] - The number of divisions.
   * @return {Array<(Vector2|Vector3)>} An array holding the sampled curve values. The number of points is `divisions + 1`.
   */
  getPoints(e = 5) {
    const t = [];
    for (let n = 0; n <= e; n++)
      t.push(this.getPoint(n / e));
    return t;
  }
  // Get sequence of points using getPointAt( u )
  /**
   * This method samples the curve via {@link Curve#getPointAt} and returns an array of points representing
   * the curve shape. Unlike {@link Curve#getPoints}, this method returns equi-spaced points across the entire
   * curve.
   *
   * @param {number} [divisions=5] - The number of divisions.
   * @return {Array<(Vector2|Vector3)>} An array holding the sampled curve values. The number of points is `divisions + 1`.
   */
  getSpacedPoints(e = 5) {
    const t = [];
    for (let n = 0; n <= e; n++)
      t.push(this.getPointAt(n / e));
    return t;
  }
  /**
   * Returns the total arc length of the curve.
   *
   * @return {number} The length of the curve.
   */
  getLength() {
    const e = this.getLengths();
    return e[e.length - 1];
  }
  /**
   * Returns an array of cumulative segment lengths of the curve.
   *
   * @param {number} [divisions=this.arcLengthDivisions] - The number of divisions.
   * @return {Array<number>} An array holding the cumulative segment lengths.
   */
  getLengths(e = this.arcLengthDivisions) {
    if (this.cacheArcLengths && this.cacheArcLengths.length === e + 1 && !this.needsUpdate)
      return this.cacheArcLengths;
    this.needsUpdate = !1;
    const t = [];
    let n, i = this.getPoint(0), s = 0;
    t.push(0);
    for (let a = 1; a <= e; a++)
      n = this.getPoint(a / e), s += n.distanceTo(i), t.push(s), i = n;
    return this.cacheArcLengths = t, t;
  }
  /**
   * Update the cumulative segment distance cache. The method must be called
   * every time curve parameters are changed. If an updated curve is part of a
   * composed curve like {@link CurvePath}, this method must be called on the
   * composed curve, too.
   */
  updateArcLengths() {
    this.needsUpdate = !0, this.getLengths();
  }
  /**
   * Given an interpolation factor in the range `[0,1]`, this method returns an updated
   * interpolation factor in the same range that can be ued to sample equidistant points
   * from a curve.
   *
   * @param {number} u - The interpolation factor.
   * @param {?number} distance - An optional distance on the curve.
   * @return {number} The updated interpolation factor.
   */
  getUtoTmapping(e, t = null) {
    const n = this.getLengths();
    let i = 0;
    const s = n.length;
    let a;
    t ? a = t : a = e * n[s - 1];
    let o = 0, c = s - 1, l;
    for (; o <= c; )
      if (i = Math.floor(o + (c - o) / 2), l = n[i] - a, l < 0)
        o = i + 1;
      else if (l > 0)
        c = i - 1;
      else {
        c = i;
        break;
      }
    if (i = c, n[i] === a)
      return i / (s - 1);
    const u = n[i], f = n[i + 1] - u, d = (a - u) / f;
    return (i + d) / (s - 1);
  }
  /**
   * Returns a unit vector tangent for the given interpolation factor.
   * If the derived curve does not implement its tangent derivation,
   * two points a small delta apart will be used to find its gradient
   * which seems to give a reasonable approximation.
   *
   * @param {number} t - The interpolation factor.
   * @param {(Vector2|Vector3)} [optionalTarget] - The optional target vector the result is written to.
   * @return {(Vector2|Vector3)} The tangent vector.
   */
  getTangent(e, t) {
    let i = e - 1e-4, s = e + 1e-4;
    i < 0 && (i = 0), s > 1 && (s = 1);
    const a = this.getPoint(i), o = this.getPoint(s), c = t || (a.isVector2 ? new Ae() : new I());
    return c.copy(o).sub(a).normalize(), c;
  }
  /**
   * Same as {@link Curve#getTangent} but with equidistant samples.
   *
   * @param {number} u - The interpolation factor.
   * @param {(Vector2|Vector3)} [optionalTarget] - The optional target vector the result is written to.
   * @return {(Vector2|Vector3)} The tangent vector.
   * @see {@link Curve#getPointAt}
   */
  getTangentAt(e, t) {
    const n = this.getUtoTmapping(e);
    return this.getTangent(n, t);
  }
  /**
   * Generates the Frenet Frames. Requires a curve definition in 3D space. Used
   * in geometries like {@link TubeGeometry} or {@link ExtrudeGeometry}.
   *
   * @param {number} segments - The number of segments.
   * @param {boolean} [closed=false] - Whether the curve is closed or not.
   * @return {{tangents: Array<Vector3>, normals: Array<Vector3>, binormals: Array<Vector3>}} The Frenet Frames.
   */
  computeFrenetFrames(e, t = !1) {
    const n = new I(), i = [], s = [], a = [], o = new I(), c = new ht();
    for (let d = 0; d <= e; d++) {
      const g = d / e;
      i[d] = this.getTangentAt(g, new I());
    }
    s[0] = new I(), a[0] = new I();
    let l = Number.MAX_VALUE;
    const u = Math.abs(i[0].x), h = Math.abs(i[0].y), f = Math.abs(i[0].z);
    u <= l && (l = u, n.set(1, 0, 0)), h <= l && (l = h, n.set(0, 1, 0)), f <= l && n.set(0, 0, 1), o.crossVectors(i[0], n).normalize(), s[0].crossVectors(i[0], o), a[0].crossVectors(i[0], s[0]);
    for (let d = 1; d <= e; d++) {
      if (s[d] = s[d - 1].clone(), a[d] = a[d - 1].clone(), o.crossVectors(i[d - 1], i[d]), o.length() > Number.EPSILON) {
        o.normalize();
        const g = Math.acos(ze(i[d - 1].dot(i[d]), -1, 1));
        s[d].applyMatrix4(c.makeRotationAxis(o, g));
      }
      a[d].crossVectors(i[d], s[d]);
    }
    if (t === !0) {
      let d = Math.acos(ze(s[0].dot(s[e]), -1, 1));
      d /= e, i[0].dot(o.crossVectors(s[0], s[e])) > 0 && (d = -d);
      for (let g = 1; g <= e; g++)
        s[g].applyMatrix4(c.makeRotationAxis(i[g], d * g)), a[g].crossVectors(i[g], s[g]);
    }
    return {
      tangents: i,
      normals: s,
      binormals: a
    };
  }
  /**
   * Returns a new curve with copied values from this instance.
   *
   * @return {Curve} A clone of this instance.
   */
  clone() {
    return new this.constructor().copy(this);
  }
  /**
   * Copies the values of the given curve to this instance.
   *
   * @param {Curve} source - The curve to copy.
   * @return {Curve} A reference to this curve.
   */
  copy(e) {
    return this.arcLengthDivisions = e.arcLengthDivisions, this;
  }
  /**
   * Serializes the curve into JSON.
   *
   * @return {Object} A JSON object representing the serialized curve.
   * @see {@link ObjectLoader#parse}
   */
  toJSON() {
    const e = {
      metadata: {
        version: 4.7,
        type: "Curve",
        generator: "Curve.toJSON"
      }
    };
    return e.arcLengthDivisions = this.arcLengthDivisions, e.type = this.type, e;
  }
  /**
   * Deserializes the curve from the given JSON.
   *
   * @param {Object} json - The JSON holding the serialized curve.
   * @return {Curve} A reference to this curve.
   */
  fromJSON(e) {
    return this.arcLengthDivisions = e.arcLengthDivisions, this;
  }
}
class Lh extends Dh {
  /**
   * Constructs a new ellipse curve.
   *
   * @param {number} [aX=0] - The X center of the ellipse.
   * @param {number} [aY=0] - The Y center of the ellipse.
   * @param {number} [xRadius=1] - The radius of the ellipse in the x direction.
   * @param {number} [yRadius=1] - The radius of the ellipse in the y direction.
   * @param {number} [aStartAngle=0] - The start angle of the curve in radians starting from the positive X axis.
   * @param {number} [aEndAngle=Math.PI*2] - The end angle of the curve in radians starting from the positive X axis.
   * @param {boolean} [aClockwise=false] - Whether the ellipse is drawn clockwise or not.
   * @param {number} [aRotation=0] - The rotation angle of the ellipse in radians, counterclockwise from the positive X axis.
   */
  constructor(e = 0, t = 0, n = 1, i = 1, s = 0, a = Math.PI * 2, o = !1, c = 0) {
    super(), this.isEllipseCurve = !0, this.type = "EllipseCurve", this.aX = e, this.aY = t, this.xRadius = n, this.yRadius = i, this.aStartAngle = s, this.aEndAngle = a, this.aClockwise = o, this.aRotation = c;
  }
  /**
   * Returns a point on the curve.
   *
   * @param {number} t - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
   * @param {Vector2} [optionalTarget] - The optional target vector the result is written to.
   * @return {Vector2} The position on the curve.
   */
  getPoint(e, t = new Ae()) {
    const n = t, i = Math.PI * 2;
    let s = this.aEndAngle - this.aStartAngle;
    const a = Math.abs(s) < Number.EPSILON;
    for (; s < 0; ) s += i;
    for (; s > i; ) s -= i;
    s < Number.EPSILON && (a ? s = 0 : s = i), this.aClockwise === !0 && !a && (s === i ? s = -i : s = s - i);
    const o = this.aStartAngle + e * s;
    let c = this.aX + this.xRadius * Math.cos(o), l = this.aY + this.yRadius * Math.sin(o);
    if (this.aRotation !== 0) {
      const u = Math.cos(this.aRotation), h = Math.sin(this.aRotation), f = c - this.aX, d = l - this.aY;
      c = f * u - d * h + this.aX, l = f * h + d * u + this.aY;
    }
    return n.set(c, l);
  }
  copy(e) {
    return super.copy(e), this.aX = e.aX, this.aY = e.aY, this.xRadius = e.xRadius, this.yRadius = e.yRadius, this.aStartAngle = e.aStartAngle, this.aEndAngle = e.aEndAngle, this.aClockwise = e.aClockwise, this.aRotation = e.aRotation, this;
  }
  toJSON() {
    const e = super.toJSON();
    return e.aX = this.aX, e.aY = this.aY, e.xRadius = this.xRadius, e.yRadius = this.yRadius, e.aStartAngle = this.aStartAngle, e.aEndAngle = this.aEndAngle, e.aClockwise = this.aClockwise, e.aRotation = this.aRotation, e;
  }
  fromJSON(e) {
    return super.fromJSON(e), this.aX = e.aX, this.aY = e.aY, this.xRadius = e.xRadius, this.yRadius = e.yRadius, this.aStartAngle = e.aStartAngle, this.aEndAngle = e.aEndAngle, this.aClockwise = e.aClockwise, this.aRotation = e.aRotation, this;
  }
}
class _n extends Qt {
  /**
   * Constructs a new plane geometry.
   *
   * @param {number} [width=1] - The width along the X axis.
   * @param {number} [height=1] - The height along the Y axis
   * @param {number} [widthSegments=1] - The number of segments along the X axis.
   * @param {number} [heightSegments=1] - The number of segments along the Y axis.
   */
  constructor(e = 1, t = 1, n = 1, i = 1) {
    super(), this.type = "PlaneGeometry", this.parameters = {
      width: e,
      height: t,
      widthSegments: n,
      heightSegments: i
    };
    const s = e / 2, a = t / 2, o = Math.floor(n), c = Math.floor(i), l = o + 1, u = c + 1, h = e / o, f = t / c, d = [], g = [], _ = [], m = [];
    for (let p = 0; p < u; p++) {
      const S = p * f - a;
      for (let b = 0; b < l; b++) {
        const T = b * h - s;
        g.push(T, -S, 0), _.push(0, 0, 1), m.push(b / o), m.push(1 - p / c);
      }
    }
    for (let p = 0; p < c; p++)
      for (let S = 0; S < o; S++) {
        const b = S + l * p, T = S + l * (p + 1), y = S + 1 + l * (p + 1), R = S + 1 + l * p;
        d.push(b, T, R), d.push(T, y, R);
      }
    this.setIndex(d), this.setAttribute("position", new Pn(g, 3)), this.setAttribute("normal", new Pn(_, 3)), this.setAttribute("uv", new Pn(m, 2));
  }
  copy(e) {
    return super.copy(e), this.parameters = Object.assign({}, e.parameters), this;
  }
  /**
   * Factory method for creating an instance of this class from the given
   * JSON object.
   *
   * @param {Object} data - A JSON object representing the serialized geometry.
   * @return {PlaneGeometry} A new instance.
   */
  static fromJSON(e) {
    return new _n(e.width, e.height, e.widthSegments, e.heightSegments);
  }
}
class Fh extends Ht {
  /**
   * Constructs a new raw shader material.
   *
   * @param {Object} [parameters] - An object with one or more properties
   * defining the material's appearance. Any property of the material
   * (including any property from inherited materials) can be passed
   * in here. Color values can be passed any type of value accepted
   * by {@link Color#set}.
   */
  constructor(e) {
    super(e), this.isRawShaderMaterial = !0, this.type = "RawShaderMaterial";
  }
}
class Uh extends Ai {
  /**
   * Constructs a new mesh depth material.
   *
   * @param {Object} [parameters] - An object with one or more properties
   * defining the material's appearance. Any property of the material
   * (including any property from inherited materials) can be passed
   * in here. Color values can be passed any type of value accepted
   * by {@link Color#set}.
   */
  constructor(e) {
    super(), this.isMeshDepthMaterial = !0, this.type = "MeshDepthMaterial", this.depthPacking = 3200, this.map = null, this.alphaMap = null, this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.wireframe = !1, this.wireframeLinewidth = 1, this.setValues(e);
  }
  copy(e) {
    return super.copy(e), this.depthPacking = e.depthPacking, this.map = e.map, this.alphaMap = e.alphaMap, this.displacementMap = e.displacementMap, this.displacementScale = e.displacementScale, this.displacementBias = e.displacementBias, this.wireframe = e.wireframe, this.wireframeLinewidth = e.wireframeLinewidth, this;
  }
}
class Ih extends Ai {
  /**
   * Constructs a new mesh distance material.
   *
   * @param {Object} [parameters] - An object with one or more properties
   * defining the material's appearance. Any property of the material
   * (including any property from inherited materials) can be passed
   * in here. Color values can be passed any type of value accepted
   * by {@link Color#set}.
   */
  constructor(e) {
    super(), this.isMeshDistanceMaterial = !0, this.type = "MeshDistanceMaterial", this.map = null, this.alphaMap = null, this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.setValues(e);
  }
  copy(e) {
    return super.copy(e), this.map = e.map, this.alphaMap = e.alphaMap, this.displacementMap = e.displacementMap, this.displacementScale = e.displacementScale, this.displacementBias = e.displacementBias, this;
  }
}
const Aa = {
  /**
   * Whether caching is enabled or not.
   *
   * @static
   * @type {boolean}
   * @default false
   */
  enabled: !1,
  /**
   * A dictionary that holds cached files.
   *
   * @static
   * @type {Object<string,Object>}
   */
  files: {},
  /**
   * Adds a cache entry with a key to reference the file. If this key already
   * holds a file, it is overwritten.
   *
   * @static
   * @param {string} key - The key to reference the cached file.
   * @param {Object} file -  The file to be cached.
   */
  add: function(r, e) {
    this.enabled !== !1 && (this.files[r] = e);
  },
  /**
   * Gets the cached value for the given key.
   *
   * @static
   * @param {string} key - The key to reference the cached file.
   * @return {Object|undefined} The cached file. If the key does not exist `undefined` is returned.
   */
  get: function(r) {
    if (this.enabled !== !1)
      return this.files[r];
  },
  /**
   * Removes the cached file associated with the given key.
   *
   * @static
   * @param {string} key - The key to reference the cached file.
   */
  remove: function(r) {
    delete this.files[r];
  },
  /**
   * Remove all values from the cache.
   *
   * @static
   */
  clear: function() {
    this.files = {};
  }
};
class Nh {
  /**
   * Constructs a new loading manager.
   *
   * @param {Function} [onLoad] - Executes when all items have been loaded.
   * @param {Function} [onProgress] - Executes when single items have been loaded.
   * @param {Function} [onError] - Executes when an error occurs.
   */
  constructor(e, t, n) {
    const i = this;
    let s = !1, a = 0, o = 0, c;
    const l = [];
    this.onStart = void 0, this.onLoad = e, this.onProgress = t, this.onError = n, this._abortController = null, this.itemStart = function(u) {
      o++, s === !1 && i.onStart !== void 0 && i.onStart(u, a, o), s = !0;
    }, this.itemEnd = function(u) {
      a++, i.onProgress !== void 0 && i.onProgress(u, a, o), a === o && (s = !1, i.onLoad !== void 0 && i.onLoad());
    }, this.itemError = function(u) {
      i.onError !== void 0 && i.onError(u);
    }, this.resolveURL = function(u) {
      return c ? c(u) : u;
    }, this.setURLModifier = function(u) {
      return c = u, this;
    }, this.addHandler = function(u, h) {
      return l.push(u, h), this;
    }, this.removeHandler = function(u) {
      const h = l.indexOf(u);
      return h !== -1 && l.splice(h, 2), this;
    }, this.getHandler = function(u) {
      for (let h = 0, f = l.length; h < f; h += 2) {
        const d = l[h], g = l[h + 1];
        if (d.global && (d.lastIndex = 0), d.test(u))
          return g;
      }
      return null;
    }, this.abort = function() {
      return this.abortController.abort(), this._abortController = null, this;
    };
  }
  // TODO: Revert this back to a single member variable once this issue has been fixed
  // https://github.com/cloudflare/workerd/issues/3657
  /**
   * Used for aborting ongoing requests in loaders using this manager.
   *
   * @type {AbortController}
   */
  get abortController() {
    return this._abortController || (this._abortController = new AbortController()), this._abortController;
  }
}
const Oh = /* @__PURE__ */ new Nh();
class uo {
  /**
   * Constructs a new loader.
   *
   * @param {LoadingManager} [manager] - The loading manager.
   */
  constructor(e) {
    this.manager = e !== void 0 ? e : Oh, this.crossOrigin = "anonymous", this.withCredentials = !1, this.path = "", this.resourcePath = "", this.requestHeader = {};
  }
  /**
   * This method needs to be implemented by all concrete loaders. It holds the
   * logic for loading assets from the backend.
   *
   * @abstract
   * @param {string} url - The path/URL of the file to be loaded.
   * @param {Function} onLoad - Executed when the loading process has been finished.
   * @param {onProgressCallback} [onProgress] - Executed while the loading is in progress.
   * @param {onErrorCallback} [onError] - Executed when errors occur.
   */
  load() {
  }
  /**
   * A async version of {@link Loader#load}.
   *
   * @param {string} url - The path/URL of the file to be loaded.
   * @param {onProgressCallback} [onProgress] - Executed while the loading is in progress.
   * @return {Promise} A Promise that resolves when the asset has been loaded.
   */
  loadAsync(e, t) {
    const n = this;
    return new Promise(function(i, s) {
      n.load(e, i, t, s);
    });
  }
  /**
   * This method needs to be implemented by all concrete loaders. It holds the
   * logic for parsing the asset into three.js entities.
   *
   * @abstract
   * @param {any} data - The data to parse.
   */
  parse() {
  }
  /**
   * Sets the `crossOrigin` String to implement CORS for loading the URL
   * from a different domain that allows CORS.
   *
   * @param {string} crossOrigin - The `crossOrigin` value.
   * @return {Loader} A reference to this instance.
   */
  setCrossOrigin(e) {
    return this.crossOrigin = e, this;
  }
  /**
   * Whether the XMLHttpRequest uses credentials such as cookies, authorization
   * headers or TLS client certificates, see [XMLHttpRequest.withCredentials](https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/withCredentials).
   *
   * Note: This setting has no effect if you are loading files locally or from the same domain.
   *
   * @param {boolean} value - The `withCredentials` value.
   * @return {Loader} A reference to this instance.
   */
  setWithCredentials(e) {
    return this.withCredentials = e, this;
  }
  /**
   * Sets the base path for the asset.
   *
   * @param {string} path - The base path.
   * @return {Loader} A reference to this instance.
   */
  setPath(e) {
    return this.path = e, this;
  }
  /**
   * Sets the base path for dependent resources like textures.
   *
   * @param {string} resourcePath - The resource path.
   * @return {Loader} A reference to this instance.
   */
  setResourcePath(e) {
    return this.resourcePath = e, this;
  }
  /**
   * Sets the given request header.
   *
   * @param {Object} requestHeader - A [request header](https://developer.mozilla.org/en-US/docs/Glossary/Request_header)
   * for configuring the HTTP request.
   * @return {Loader} A reference to this instance.
   */
  setRequestHeader(e) {
    return this.requestHeader = e, this;
  }
  /**
   * This method can be implemented in loaders for aborting ongoing requests.
   *
   * @abstract
   * @return {Loader} A reference to this instance.
   */
  abort() {
    return this;
  }
}
uo.DEFAULT_MATERIAL_NAME = "__DEFAULT";
const Xi = /* @__PURE__ */ new WeakMap();
class Bh extends uo {
  /**
   * Constructs a new image loader.
   *
   * @param {LoadingManager} [manager] - The loading manager.
   */
  constructor(e) {
    super(e);
  }
  /**
   * Starts loading from the given URL and passes the loaded image
   * to the `onLoad()` callback. The method also returns a new `Image` object which can
   * directly be used for texture creation. If you do it this way, the texture
   * may pop up in your scene once the respective loading process is finished.
   *
   * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
   * @param {function(Image)} onLoad - Executed when the loading process has been finished.
   * @param {onProgressCallback} onProgress - Unsupported in this loader.
   * @param {onErrorCallback} onError - Executed when errors occur.
   * @return {Image} The image.
   */
  load(e, t, n, i) {
    this.path !== void 0 && (e = this.path + e), e = this.manager.resolveURL(e);
    const s = this, a = Aa.get(`image:${e}`);
    if (a !== void 0) {
      if (a.complete === !0)
        s.manager.itemStart(e), setTimeout(function() {
          t && t(a), s.manager.itemEnd(e);
        }, 0);
      else {
        let h = Xi.get(a);
        h === void 0 && (h = [], Xi.set(a, h)), h.push({ onLoad: t, onError: i });
      }
      return a;
    }
    const o = Fr("img");
    function c() {
      u(), t && t(this);
      const h = Xi.get(this) || [];
      for (let f = 0; f < h.length; f++) {
        const d = h[f];
        d.onLoad && d.onLoad(this);
      }
      Xi.delete(this), s.manager.itemEnd(e);
    }
    function l(h) {
      u(), i && i(h), Aa.remove(`image:${e}`);
      const f = Xi.get(this) || [];
      for (let d = 0; d < f.length; d++) {
        const g = f[d];
        g.onError && g.onError(h);
      }
      Xi.delete(this), s.manager.itemError(e), s.manager.itemEnd(e);
    }
    function u() {
      o.removeEventListener("load", c, !1), o.removeEventListener("error", l, !1);
    }
    return o.addEventListener("load", c, !1), o.addEventListener("error", l, !1), e.slice(0, 5) !== "data:" && this.crossOrigin !== void 0 && (o.crossOrigin = this.crossOrigin), Aa.add(`image:${e}`, o), s.manager.itemStart(e), o.src = e, o;
  }
}
class Sc extends uo {
  /**
   * Constructs a new texture loader.
   *
   * @param {LoadingManager} [manager] - The loading manager.
   */
  constructor(e) {
    super(e);
  }
  /**
   * Starts loading from the given URL and pass the fully loaded texture
   * to the `onLoad()` callback. The method also returns a new texture object which can
   * directly be used for material creation. If you do it this way, the texture
   * may pop up in your scene once the respective loading process is finished.
   *
   * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
   * @param {function(Texture)} onLoad - Executed when the loading process has been finished.
   * @param {onProgressCallback} onProgress - Unsupported in this loader.
   * @param {onErrorCallback} onError - Executed when errors occur.
   * @return {Texture} The texture.
   */
  load(e, t, n, i) {
    const s = new bt(), a = new Bh(this.manager);
    return a.setCrossOrigin(this.crossOrigin), a.setPath(this.path), a.load(e, function(o) {
      s.image = o, s.needsUpdate = !0, t !== void 0 && t(s);
    }, n, i), s;
  }
}
class Mc extends lo {
  /**
   * Constructs a new orthographic camera.
   *
   * @param {number} [left=-1] - The left plane of the camera's frustum.
   * @param {number} [right=1] - The right plane of the camera's frustum.
   * @param {number} [top=1] - The top plane of the camera's frustum.
   * @param {number} [bottom=-1] - The bottom plane of the camera's frustum.
   * @param {number} [near=0.1] - The camera's near plane.
   * @param {number} [far=2000] - The camera's far plane.
   */
  constructor(e = -1, t = 1, n = 1, i = -1, s = 0.1, a = 2e3) {
    super(), this.isOrthographicCamera = !0, this.type = "OrthographicCamera", this.zoom = 1, this.view = null, this.left = e, this.right = t, this.top = n, this.bottom = i, this.near = s, this.far = a, this.updateProjectionMatrix();
  }
  copy(e, t) {
    return super.copy(e, t), this.left = e.left, this.right = e.right, this.top = e.top, this.bottom = e.bottom, this.near = e.near, this.far = e.far, this.zoom = e.zoom, this.view = e.view === null ? null : Object.assign({}, e.view), this;
  }
  /**
   * Sets an offset in a larger frustum. This is useful for multi-window or
   * multi-monitor/multi-machine setups.
   *
   * @param {number} fullWidth - The full width of multiview setup.
   * @param {number} fullHeight - The full height of multiview setup.
   * @param {number} x - The horizontal offset of the subcamera.
   * @param {number} y - The vertical offset of the subcamera.
   * @param {number} width - The width of subcamera.
   * @param {number} height - The height of subcamera.
   * @see {@link PerspectiveCamera#setViewOffset}
   */
  setViewOffset(e, t, n, i, s, a) {
    this.view === null && (this.view = {
      enabled: !0,
      fullWidth: 1,
      fullHeight: 1,
      offsetX: 0,
      offsetY: 0,
      width: 1,
      height: 1
    }), this.view.enabled = !0, this.view.fullWidth = e, this.view.fullHeight = t, this.view.offsetX = n, this.view.offsetY = i, this.view.width = s, this.view.height = a, this.updateProjectionMatrix();
  }
  /**
   * Removes the view offset from the projection matrix.
   */
  clearViewOffset() {
    this.view !== null && (this.view.enabled = !1), this.updateProjectionMatrix();
  }
  /**
   * Updates the camera's projection matrix. Must be called after any change of
   * camera properties.
   */
  updateProjectionMatrix() {
    const e = (this.right - this.left) / (2 * this.zoom), t = (this.top - this.bottom) / (2 * this.zoom), n = (this.right + this.left) / 2, i = (this.top + this.bottom) / 2;
    let s = n - e, a = n + e, o = i + t, c = i - t;
    if (this.view !== null && this.view.enabled) {
      const l = (this.right - this.left) / this.view.fullWidth / this.zoom, u = (this.top - this.bottom) / this.view.fullHeight / this.zoom;
      s += l * this.view.offsetX, a = s + l * this.view.width, o -= u * this.view.offsetY, c = o - u * this.view.height;
    }
    this.projectionMatrix.makeOrthographic(s, a, o, c, this.near, this.far, this.coordinateSystem, this.reversedDepth), this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
  }
  toJSON(e) {
    const t = super.toJSON(e);
    return t.object.zoom = this.zoom, t.object.left = this.left, t.object.right = this.right, t.object.top = this.top, t.object.bottom = this.bottom, t.object.near = this.near, t.object.far = this.far, this.view !== null && (t.object.view = Object.assign({}, this.view)), t;
  }
}
class zh extends qt {
  /**
   * Constructs a new array camera.
   *
   * @param {Array<PerspectiveCamera>} [array=[]] - An array of perspective sub cameras.
   */
  constructor(e = []) {
    super(), this.isArrayCamera = !0, this.isMultiViewCamera = !1, this.cameras = e;
  }
}
class Hs {
  /**
   * Constructs a new clock.
   *
   * @param {boolean} [autoStart=true] - Whether to automatically start the clock when
   * `getDelta()` is called for the first time.
   */
  constructor(e = !0) {
    this.autoStart = e, this.startTime = 0, this.oldTime = 0, this.elapsedTime = 0, this.running = !1;
  }
  /**
   * Starts the clock. When `autoStart` is set to `true`, the method is automatically
   * called by the class.
   */
  start() {
    this.startTime = performance.now(), this.oldTime = this.startTime, this.elapsedTime = 0, this.running = !0;
  }
  /**
   * Stops the clock.
   */
  stop() {
    this.getElapsedTime(), this.running = !1, this.autoStart = !1;
  }
  /**
   * Returns the elapsed time in seconds.
   *
   * @return {number} The elapsed time.
   */
  getElapsedTime() {
    return this.getDelta(), this.elapsedTime;
  }
  /**
   * Returns the delta time in seconds.
   *
   * @return {number} The delta time.
   */
  getDelta() {
    let e = 0;
    if (this.autoStart && !this.running)
      return this.start(), 0;
    if (this.running) {
      const t = performance.now();
      e = (t - this.oldTime) / 1e3, this.oldTime = t, this.elapsedTime += e;
    }
    return e;
  }
}
function fl(r, e, t, n) {
  const i = Gh(n);
  switch (t) {
    // https://registry.khronos.org/OpenGL-Refpages/es3.0/html/glTexImage2D.xhtml
    case 1021:
      return r * e;
    case 1028:
      return r * e / i.components * i.byteLength;
    case 1029:
      return r * e / i.components * i.byteLength;
    case 1030:
      return r * e * 2 / i.components * i.byteLength;
    case 1031:
      return r * e * 2 / i.components * i.byteLength;
    case 1022:
      return r * e * 3 / i.components * i.byteLength;
    case 1023:
      return r * e * 4 / i.components * i.byteLength;
    case 1033:
      return r * e * 4 / i.components * i.byteLength;
    // https://registry.khronos.org/webgl/extensions/WEBGL_compressed_texture_s3tc_srgb/
    case 33776:
    case 33777:
      return Math.floor((r + 3) / 4) * Math.floor((e + 3) / 4) * 8;
    case 33778:
    case 33779:
      return Math.floor((r + 3) / 4) * Math.floor((e + 3) / 4) * 16;
    // https://registry.khronos.org/webgl/extensions/WEBGL_compressed_texture_pvrtc/
    case 35841:
    case 35843:
      return Math.max(r, 16) * Math.max(e, 8) / 4;
    case 35840:
    case 35842:
      return Math.max(r, 8) * Math.max(e, 8) / 2;
    // https://registry.khronos.org/webgl/extensions/WEBGL_compressed_texture_etc/
    case 36196:
    case 37492:
    case 37488:
    case 37489:
      return Math.floor((r + 3) / 4) * Math.floor((e + 3) / 4) * 8;
    case 37496:
    case 37490:
    case 37491:
      return Math.floor((r + 3) / 4) * Math.floor((e + 3) / 4) * 16;
    // https://registry.khronos.org/webgl/extensions/WEBGL_compressed_texture_astc/
    case 37808:
      return Math.floor((r + 3) / 4) * Math.floor((e + 3) / 4) * 16;
    case 37809:
      return Math.floor((r + 4) / 5) * Math.floor((e + 3) / 4) * 16;
    case 37810:
      return Math.floor((r + 4) / 5) * Math.floor((e + 4) / 5) * 16;
    case 37811:
      return Math.floor((r + 5) / 6) * Math.floor((e + 4) / 5) * 16;
    case 37812:
      return Math.floor((r + 5) / 6) * Math.floor((e + 5) / 6) * 16;
    case 37813:
      return Math.floor((r + 7) / 8) * Math.floor((e + 4) / 5) * 16;
    case 37814:
      return Math.floor((r + 7) / 8) * Math.floor((e + 5) / 6) * 16;
    case 37815:
      return Math.floor((r + 7) / 8) * Math.floor((e + 7) / 8) * 16;
    case 37816:
      return Math.floor((r + 9) / 10) * Math.floor((e + 4) / 5) * 16;
    case 37817:
      return Math.floor((r + 9) / 10) * Math.floor((e + 5) / 6) * 16;
    case 37818:
      return Math.floor((r + 9) / 10) * Math.floor((e + 7) / 8) * 16;
    case 37819:
      return Math.floor((r + 9) / 10) * Math.floor((e + 9) / 10) * 16;
    case 37820:
      return Math.floor((r + 11) / 12) * Math.floor((e + 9) / 10) * 16;
    case 37821:
      return Math.floor((r + 11) / 12) * Math.floor((e + 11) / 12) * 16;
    // https://registry.khronos.org/webgl/extensions/EXT_texture_compression_bptc/
    case 36492:
    case 36494:
    case 36495:
      return Math.ceil(r / 4) * Math.ceil(e / 4) * 16;
    // https://registry.khronos.org/webgl/extensions/EXT_texture_compression_rgtc/
    case 36283:
    case 36284:
      return Math.ceil(r / 4) * Math.ceil(e / 4) * 8;
    case 36285:
    case 36286:
      return Math.ceil(r / 4) * Math.ceil(e / 4) * 16;
  }
  throw new Error(
    `Unable to determine texture byte length for ${t} format.`
  );
}
function Gh(r) {
  switch (r) {
    case 1009:
    case 1010:
      return { byteLength: 1, components: 1 };
    case 1012:
    case 1011:
    case 1016:
      return { byteLength: 2, components: 1 };
    case 1017:
    case 1018:
      return { byteLength: 2, components: 4 };
    case 1014:
    case 1013:
    case 1015:
      return { byteLength: 4, components: 1 };
    case 35902:
    case 35899:
      return { byteLength: 4, components: 3 };
  }
  throw new Error(`Unknown texture type ${r}.`);
}
typeof __THREE_DEVTOOLS__ < "u" && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("register", { detail: {
  revision: "182"
} }));
typeof window < "u" && (window.__THREE__ ? Ce("WARNING: Multiple instances of Three.js being imported.") : window.__THREE__ = "182");
function yc() {
  let r = null, e = !1, t = null, n = null;
  function i(s, a) {
    t(s, a), n = r.requestAnimationFrame(i);
  }
  return {
    start: function() {
      e !== !0 && t !== null && (n = r.requestAnimationFrame(i), e = !0);
    },
    stop: function() {
      r.cancelAnimationFrame(n), e = !1;
    },
    setAnimationLoop: function(s) {
      t = s;
    },
    setContext: function(s) {
      r = s;
    }
  };
}
function kh(r) {
  const e = /* @__PURE__ */ new WeakMap();
  function t(o, c) {
    const l = o.array, u = o.usage, h = l.byteLength, f = r.createBuffer();
    r.bindBuffer(c, f), r.bufferData(c, l, u), o.onUploadCallback();
    let d;
    if (l instanceof Float32Array)
      d = r.FLOAT;
    else if (typeof Float16Array < "u" && l instanceof Float16Array)
      d = r.HALF_FLOAT;
    else if (l instanceof Uint16Array)
      o.isFloat16BufferAttribute ? d = r.HALF_FLOAT : d = r.UNSIGNED_SHORT;
    else if (l instanceof Int16Array)
      d = r.SHORT;
    else if (l instanceof Uint32Array)
      d = r.UNSIGNED_INT;
    else if (l instanceof Int32Array)
      d = r.INT;
    else if (l instanceof Int8Array)
      d = r.BYTE;
    else if (l instanceof Uint8Array)
      d = r.UNSIGNED_BYTE;
    else if (l instanceof Uint8ClampedArray)
      d = r.UNSIGNED_BYTE;
    else
      throw new Error("THREE.WebGLAttributes: Unsupported buffer data format: " + l);
    return {
      buffer: f,
      type: d,
      bytesPerElement: l.BYTES_PER_ELEMENT,
      version: o.version,
      size: h
    };
  }
  function n(o, c, l) {
    const u = c.array, h = c.updateRanges;
    if (r.bindBuffer(l, o), h.length === 0)
      r.bufferSubData(l, 0, u);
    else {
      h.sort((d, g) => d.start - g.start);
      let f = 0;
      for (let d = 1; d < h.length; d++) {
        const g = h[f], _ = h[d];
        _.start <= g.start + g.count + 1 ? g.count = Math.max(
          g.count,
          _.start + _.count - g.start
        ) : (++f, h[f] = _);
      }
      h.length = f + 1;
      for (let d = 0, g = h.length; d < g; d++) {
        const _ = h[d];
        r.bufferSubData(
          l,
          _.start * u.BYTES_PER_ELEMENT,
          u,
          _.start,
          _.count
        );
      }
      c.clearUpdateRanges();
    }
    c.onUploadCallback();
  }
  function i(o) {
    return o.isInterleavedBufferAttribute && (o = o.data), e.get(o);
  }
  function s(o) {
    o.isInterleavedBufferAttribute && (o = o.data);
    const c = e.get(o);
    c && (r.deleteBuffer(c.buffer), e.delete(o));
  }
  function a(o, c) {
    if (o.isInterleavedBufferAttribute && (o = o.data), o.isGLBufferAttribute) {
      const u = e.get(o);
      (!u || u.version < o.version) && e.set(o, {
        buffer: o.buffer,
        type: o.type,
        bytesPerElement: o.elementSize,
        version: o.version
      });
      return;
    }
    const l = e.get(o);
    if (l === void 0)
      e.set(o, t(o, c));
    else if (l.version < o.version) {
      if (l.size !== o.array.byteLength)
        throw new Error("THREE.WebGLAttributes: The size of the buffer attribute's array buffer does not match the original size. Resizing buffer attributes is not supported.");
      n(l.buffer, o, c), l.version = o.version;
    }
  }
  return {
    get: i,
    remove: s,
    update: a
  };
}
var Vh = `#ifdef USE_ALPHAHASH
	if ( diffuseColor.a < getAlphaHashThreshold( vPosition ) ) discard;
#endif`, Hh = `#ifdef USE_ALPHAHASH
	const float ALPHA_HASH_SCALE = 0.05;
	float hash2D( vec2 value ) {
		return fract( 1.0e4 * sin( 17.0 * value.x + 0.1 * value.y ) * ( 0.1 + abs( sin( 13.0 * value.y + value.x ) ) ) );
	}
	float hash3D( vec3 value ) {
		return hash2D( vec2( hash2D( value.xy ), value.z ) );
	}
	float getAlphaHashThreshold( vec3 position ) {
		float maxDeriv = max(
			length( dFdx( position.xyz ) ),
			length( dFdy( position.xyz ) )
		);
		float pixScale = 1.0 / ( ALPHA_HASH_SCALE * maxDeriv );
		vec2 pixScales = vec2(
			exp2( floor( log2( pixScale ) ) ),
			exp2( ceil( log2( pixScale ) ) )
		);
		vec2 alpha = vec2(
			hash3D( floor( pixScales.x * position.xyz ) ),
			hash3D( floor( pixScales.y * position.xyz ) )
		);
		float lerpFactor = fract( log2( pixScale ) );
		float x = ( 1.0 - lerpFactor ) * alpha.x + lerpFactor * alpha.y;
		float a = min( lerpFactor, 1.0 - lerpFactor );
		vec3 cases = vec3(
			x * x / ( 2.0 * a * ( 1.0 - a ) ),
			( x - 0.5 * a ) / ( 1.0 - a ),
			1.0 - ( ( 1.0 - x ) * ( 1.0 - x ) / ( 2.0 * a * ( 1.0 - a ) ) )
		);
		float threshold = ( x < ( 1.0 - a ) )
			? ( ( x < a ) ? cases.x : cases.y )
			: cases.z;
		return clamp( threshold , 1.0e-6, 1.0 );
	}
#endif`, Wh = `#ifdef USE_ALPHAMAP
	diffuseColor.a *= texture2D( alphaMap, vAlphaMapUv ).g;
#endif`, Xh = `#ifdef USE_ALPHAMAP
	uniform sampler2D alphaMap;
#endif`, qh = `#ifdef USE_ALPHATEST
	#ifdef ALPHA_TO_COVERAGE
	diffuseColor.a = smoothstep( alphaTest, alphaTest + fwidth( diffuseColor.a ), diffuseColor.a );
	if ( diffuseColor.a == 0.0 ) discard;
	#else
	if ( diffuseColor.a < alphaTest ) discard;
	#endif
#endif`, Yh = `#ifdef USE_ALPHATEST
	uniform float alphaTest;
#endif`, $h = `#ifdef USE_AOMAP
	float ambientOcclusion = ( texture2D( aoMap, vAoMapUv ).r - 1.0 ) * aoMapIntensity + 1.0;
	reflectedLight.indirectDiffuse *= ambientOcclusion;
	#if defined( USE_CLEARCOAT ) 
		clearcoatSpecularIndirect *= ambientOcclusion;
	#endif
	#if defined( USE_SHEEN ) 
		sheenSpecularIndirect *= ambientOcclusion;
	#endif
	#if defined( USE_ENVMAP ) && defined( STANDARD )
		float dotNV = saturate( dot( geometryNormal, geometryViewDir ) );
		reflectedLight.indirectSpecular *= computeSpecularOcclusion( dotNV, ambientOcclusion, material.roughness );
	#endif
#endif`, Kh = `#ifdef USE_AOMAP
	uniform sampler2D aoMap;
	uniform float aoMapIntensity;
#endif`, Zh = `#ifdef USE_BATCHING
	#if ! defined( GL_ANGLE_multi_draw )
	#define gl_DrawID _gl_DrawID
	uniform int _gl_DrawID;
	#endif
	uniform highp sampler2D batchingTexture;
	uniform highp usampler2D batchingIdTexture;
	mat4 getBatchingMatrix( const in float i ) {
		int size = textureSize( batchingTexture, 0 ).x;
		int j = int( i ) * 4;
		int x = j % size;
		int y = j / size;
		vec4 v1 = texelFetch( batchingTexture, ivec2( x, y ), 0 );
		vec4 v2 = texelFetch( batchingTexture, ivec2( x + 1, y ), 0 );
		vec4 v3 = texelFetch( batchingTexture, ivec2( x + 2, y ), 0 );
		vec4 v4 = texelFetch( batchingTexture, ivec2( x + 3, y ), 0 );
		return mat4( v1, v2, v3, v4 );
	}
	float getIndirectIndex( const in int i ) {
		int size = textureSize( batchingIdTexture, 0 ).x;
		int x = i % size;
		int y = i / size;
		return float( texelFetch( batchingIdTexture, ivec2( x, y ), 0 ).r );
	}
#endif
#ifdef USE_BATCHING_COLOR
	uniform sampler2D batchingColorTexture;
	vec3 getBatchingColor( const in float i ) {
		int size = textureSize( batchingColorTexture, 0 ).x;
		int j = int( i );
		int x = j % size;
		int y = j / size;
		return texelFetch( batchingColorTexture, ivec2( x, y ), 0 ).rgb;
	}
#endif`, jh = `#ifdef USE_BATCHING
	mat4 batchingMatrix = getBatchingMatrix( getIndirectIndex( gl_DrawID ) );
#endif`, Jh = `vec3 transformed = vec3( position );
#ifdef USE_ALPHAHASH
	vPosition = vec3( position );
#endif`, Qh = `vec3 objectNormal = vec3( normal );
#ifdef USE_TANGENT
	vec3 objectTangent = vec3( tangent.xyz );
#endif`, ef = `float G_BlinnPhong_Implicit( ) {
	return 0.25;
}
float D_BlinnPhong( const in float shininess, const in float dotNH ) {
	return RECIPROCAL_PI * ( shininess * 0.5 + 1.0 ) * pow( dotNH, shininess );
}
vec3 BRDF_BlinnPhong( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 specularColor, const in float shininess ) {
	vec3 halfDir = normalize( lightDir + viewDir );
	float dotNH = saturate( dot( normal, halfDir ) );
	float dotVH = saturate( dot( viewDir, halfDir ) );
	vec3 F = F_Schlick( specularColor, 1.0, dotVH );
	float G = G_BlinnPhong_Implicit( );
	float D = D_BlinnPhong( shininess, dotNH );
	return F * ( G * D );
} // validated`, tf = `#ifdef USE_IRIDESCENCE
	const mat3 XYZ_TO_REC709 = mat3(
		 3.2404542, -0.9692660,  0.0556434,
		-1.5371385,  1.8760108, -0.2040259,
		-0.4985314,  0.0415560,  1.0572252
	);
	vec3 Fresnel0ToIor( vec3 fresnel0 ) {
		vec3 sqrtF0 = sqrt( fresnel0 );
		return ( vec3( 1.0 ) + sqrtF0 ) / ( vec3( 1.0 ) - sqrtF0 );
	}
	vec3 IorToFresnel0( vec3 transmittedIor, float incidentIor ) {
		return pow2( ( transmittedIor - vec3( incidentIor ) ) / ( transmittedIor + vec3( incidentIor ) ) );
	}
	float IorToFresnel0( float transmittedIor, float incidentIor ) {
		return pow2( ( transmittedIor - incidentIor ) / ( transmittedIor + incidentIor ));
	}
	vec3 evalSensitivity( float OPD, vec3 shift ) {
		float phase = 2.0 * PI * OPD * 1.0e-9;
		vec3 val = vec3( 5.4856e-13, 4.4201e-13, 5.2481e-13 );
		vec3 pos = vec3( 1.6810e+06, 1.7953e+06, 2.2084e+06 );
		vec3 var = vec3( 4.3278e+09, 9.3046e+09, 6.6121e+09 );
		vec3 xyz = val * sqrt( 2.0 * PI * var ) * cos( pos * phase + shift ) * exp( - pow2( phase ) * var );
		xyz.x += 9.7470e-14 * sqrt( 2.0 * PI * 4.5282e+09 ) * cos( 2.2399e+06 * phase + shift[ 0 ] ) * exp( - 4.5282e+09 * pow2( phase ) );
		xyz /= 1.0685e-7;
		vec3 rgb = XYZ_TO_REC709 * xyz;
		return rgb;
	}
	vec3 evalIridescence( float outsideIOR, float eta2, float cosTheta1, float thinFilmThickness, vec3 baseF0 ) {
		vec3 I;
		float iridescenceIOR = mix( outsideIOR, eta2, smoothstep( 0.0, 0.03, thinFilmThickness ) );
		float sinTheta2Sq = pow2( outsideIOR / iridescenceIOR ) * ( 1.0 - pow2( cosTheta1 ) );
		float cosTheta2Sq = 1.0 - sinTheta2Sq;
		if ( cosTheta2Sq < 0.0 ) {
			return vec3( 1.0 );
		}
		float cosTheta2 = sqrt( cosTheta2Sq );
		float R0 = IorToFresnel0( iridescenceIOR, outsideIOR );
		float R12 = F_Schlick( R0, 1.0, cosTheta1 );
		float T121 = 1.0 - R12;
		float phi12 = 0.0;
		if ( iridescenceIOR < outsideIOR ) phi12 = PI;
		float phi21 = PI - phi12;
		vec3 baseIOR = Fresnel0ToIor( clamp( baseF0, 0.0, 0.9999 ) );		vec3 R1 = IorToFresnel0( baseIOR, iridescenceIOR );
		vec3 R23 = F_Schlick( R1, 1.0, cosTheta2 );
		vec3 phi23 = vec3( 0.0 );
		if ( baseIOR[ 0 ] < iridescenceIOR ) phi23[ 0 ] = PI;
		if ( baseIOR[ 1 ] < iridescenceIOR ) phi23[ 1 ] = PI;
		if ( baseIOR[ 2 ] < iridescenceIOR ) phi23[ 2 ] = PI;
		float OPD = 2.0 * iridescenceIOR * thinFilmThickness * cosTheta2;
		vec3 phi = vec3( phi21 ) + phi23;
		vec3 R123 = clamp( R12 * R23, 1e-5, 0.9999 );
		vec3 r123 = sqrt( R123 );
		vec3 Rs = pow2( T121 ) * R23 / ( vec3( 1.0 ) - R123 );
		vec3 C0 = R12 + Rs;
		I = C0;
		vec3 Cm = Rs - T121;
		for ( int m = 1; m <= 2; ++ m ) {
			Cm *= r123;
			vec3 Sm = 2.0 * evalSensitivity( float( m ) * OPD, float( m ) * phi );
			I += Cm * Sm;
		}
		return max( I, vec3( 0.0 ) );
	}
#endif`, nf = `#ifdef USE_BUMPMAP
	uniform sampler2D bumpMap;
	uniform float bumpScale;
	vec2 dHdxy_fwd() {
		vec2 dSTdx = dFdx( vBumpMapUv );
		vec2 dSTdy = dFdy( vBumpMapUv );
		float Hll = bumpScale * texture2D( bumpMap, vBumpMapUv ).x;
		float dBx = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdx ).x - Hll;
		float dBy = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdy ).x - Hll;
		return vec2( dBx, dBy );
	}
	vec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy, float faceDirection ) {
		vec3 vSigmaX = normalize( dFdx( surf_pos.xyz ) );
		vec3 vSigmaY = normalize( dFdy( surf_pos.xyz ) );
		vec3 vN = surf_norm;
		vec3 R1 = cross( vSigmaY, vN );
		vec3 R2 = cross( vN, vSigmaX );
		float fDet = dot( vSigmaX, R1 ) * faceDirection;
		vec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );
		return normalize( abs( fDet ) * surf_norm - vGrad );
	}
#endif`, rf = `#if NUM_CLIPPING_PLANES > 0
	vec4 plane;
	#ifdef ALPHA_TO_COVERAGE
		float distanceToPlane, distanceGradient;
		float clipOpacity = 1.0;
		#pragma unroll_loop_start
		for ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {
			plane = clippingPlanes[ i ];
			distanceToPlane = - dot( vClipPosition, plane.xyz ) + plane.w;
			distanceGradient = fwidth( distanceToPlane ) / 2.0;
			clipOpacity *= smoothstep( - distanceGradient, distanceGradient, distanceToPlane );
			if ( clipOpacity == 0.0 ) discard;
		}
		#pragma unroll_loop_end
		#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES
			float unionClipOpacity = 1.0;
			#pragma unroll_loop_start
			for ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {
				plane = clippingPlanes[ i ];
				distanceToPlane = - dot( vClipPosition, plane.xyz ) + plane.w;
				distanceGradient = fwidth( distanceToPlane ) / 2.0;
				unionClipOpacity *= 1.0 - smoothstep( - distanceGradient, distanceGradient, distanceToPlane );
			}
			#pragma unroll_loop_end
			clipOpacity *= 1.0 - unionClipOpacity;
		#endif
		diffuseColor.a *= clipOpacity;
		if ( diffuseColor.a == 0.0 ) discard;
	#else
		#pragma unroll_loop_start
		for ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {
			plane = clippingPlanes[ i ];
			if ( dot( vClipPosition, plane.xyz ) > plane.w ) discard;
		}
		#pragma unroll_loop_end
		#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES
			bool clipped = true;
			#pragma unroll_loop_start
			for ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {
				plane = clippingPlanes[ i ];
				clipped = ( dot( vClipPosition, plane.xyz ) > plane.w ) && clipped;
			}
			#pragma unroll_loop_end
			if ( clipped ) discard;
		#endif
	#endif
#endif`, sf = `#if NUM_CLIPPING_PLANES > 0
	varying vec3 vClipPosition;
	uniform vec4 clippingPlanes[ NUM_CLIPPING_PLANES ];
#endif`, af = `#if NUM_CLIPPING_PLANES > 0
	varying vec3 vClipPosition;
#endif`, of = `#if NUM_CLIPPING_PLANES > 0
	vClipPosition = - mvPosition.xyz;
#endif`, lf = `#if defined( USE_COLOR_ALPHA )
	diffuseColor *= vColor;
#elif defined( USE_COLOR )
	diffuseColor.rgb *= vColor;
#endif`, cf = `#if defined( USE_COLOR_ALPHA )
	varying vec4 vColor;
#elif defined( USE_COLOR )
	varying vec3 vColor;
#endif`, uf = `#if defined( USE_COLOR_ALPHA )
	varying vec4 vColor;
#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR ) || defined( USE_BATCHING_COLOR )
	varying vec3 vColor;
#endif`, hf = `#if defined( USE_COLOR_ALPHA )
	vColor = vec4( 1.0 );
#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR ) || defined( USE_BATCHING_COLOR )
	vColor = vec3( 1.0 );
#endif
#ifdef USE_COLOR
	vColor *= color;
#endif
#ifdef USE_INSTANCING_COLOR
	vColor.xyz *= instanceColor.xyz;
#endif
#ifdef USE_BATCHING_COLOR
	vec3 batchingColor = getBatchingColor( getIndirectIndex( gl_DrawID ) );
	vColor.xyz *= batchingColor.xyz;
#endif`, ff = `#define PI 3.141592653589793
#define PI2 6.283185307179586
#define PI_HALF 1.5707963267948966
#define RECIPROCAL_PI 0.3183098861837907
#define RECIPROCAL_PI2 0.15915494309189535
#define EPSILON 1e-6
#ifndef saturate
#define saturate( a ) clamp( a, 0.0, 1.0 )
#endif
#define whiteComplement( a ) ( 1.0 - saturate( a ) )
float pow2( const in float x ) { return x*x; }
vec3 pow2( const in vec3 x ) { return x*x; }
float pow3( const in float x ) { return x*x*x; }
float pow4( const in float x ) { float x2 = x*x; return x2*x2; }
float max3( const in vec3 v ) { return max( max( v.x, v.y ), v.z ); }
float average( const in vec3 v ) { return dot( v, vec3( 0.3333333 ) ); }
highp float rand( const in vec2 uv ) {
	const highp float a = 12.9898, b = 78.233, c = 43758.5453;
	highp float dt = dot( uv.xy, vec2( a,b ) ), sn = mod( dt, PI );
	return fract( sin( sn ) * c );
}
#ifdef HIGH_PRECISION
	float precisionSafeLength( vec3 v ) { return length( v ); }
#else
	float precisionSafeLength( vec3 v ) {
		float maxComponent = max3( abs( v ) );
		return length( v / maxComponent ) * maxComponent;
	}
#endif
struct IncidentLight {
	vec3 color;
	vec3 direction;
	bool visible;
};
struct ReflectedLight {
	vec3 directDiffuse;
	vec3 directSpecular;
	vec3 indirectDiffuse;
	vec3 indirectSpecular;
};
#ifdef USE_ALPHAHASH
	varying vec3 vPosition;
#endif
vec3 transformDirection( in vec3 dir, in mat4 matrix ) {
	return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );
}
vec3 inverseTransformDirection( in vec3 dir, in mat4 matrix ) {
	return normalize( ( vec4( dir, 0.0 ) * matrix ).xyz );
}
bool isPerspectiveMatrix( mat4 m ) {
	return m[ 2 ][ 3 ] == - 1.0;
}
vec2 equirectUv( in vec3 dir ) {
	float u = atan( dir.z, dir.x ) * RECIPROCAL_PI2 + 0.5;
	float v = asin( clamp( dir.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;
	return vec2( u, v );
}
vec3 BRDF_Lambert( const in vec3 diffuseColor ) {
	return RECIPROCAL_PI * diffuseColor;
}
vec3 F_Schlick( const in vec3 f0, const in float f90, const in float dotVH ) {
	float fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );
	return f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );
}
float F_Schlick( const in float f0, const in float f90, const in float dotVH ) {
	float fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );
	return f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );
} // validated`, df = `#ifdef ENVMAP_TYPE_CUBE_UV
	#define cubeUV_minMipLevel 4.0
	#define cubeUV_minTileSize 16.0
	float getFace( vec3 direction ) {
		vec3 absDirection = abs( direction );
		float face = - 1.0;
		if ( absDirection.x > absDirection.z ) {
			if ( absDirection.x > absDirection.y )
				face = direction.x > 0.0 ? 0.0 : 3.0;
			else
				face = direction.y > 0.0 ? 1.0 : 4.0;
		} else {
			if ( absDirection.z > absDirection.y )
				face = direction.z > 0.0 ? 2.0 : 5.0;
			else
				face = direction.y > 0.0 ? 1.0 : 4.0;
		}
		return face;
	}
	vec2 getUV( vec3 direction, float face ) {
		vec2 uv;
		if ( face == 0.0 ) {
			uv = vec2( direction.z, direction.y ) / abs( direction.x );
		} else if ( face == 1.0 ) {
			uv = vec2( - direction.x, - direction.z ) / abs( direction.y );
		} else if ( face == 2.0 ) {
			uv = vec2( - direction.x, direction.y ) / abs( direction.z );
		} else if ( face == 3.0 ) {
			uv = vec2( - direction.z, direction.y ) / abs( direction.x );
		} else if ( face == 4.0 ) {
			uv = vec2( - direction.x, direction.z ) / abs( direction.y );
		} else {
			uv = vec2( direction.x, direction.y ) / abs( direction.z );
		}
		return 0.5 * ( uv + 1.0 );
	}
	vec3 bilinearCubeUV( sampler2D envMap, vec3 direction, float mipInt ) {
		float face = getFace( direction );
		float filterInt = max( cubeUV_minMipLevel - mipInt, 0.0 );
		mipInt = max( mipInt, cubeUV_minMipLevel );
		float faceSize = exp2( mipInt );
		highp vec2 uv = getUV( direction, face ) * ( faceSize - 2.0 ) + 1.0;
		if ( face > 2.0 ) {
			uv.y += faceSize;
			face -= 3.0;
		}
		uv.x += face * faceSize;
		uv.x += filterInt * 3.0 * cubeUV_minTileSize;
		uv.y += 4.0 * ( exp2( CUBEUV_MAX_MIP ) - faceSize );
		uv.x *= CUBEUV_TEXEL_WIDTH;
		uv.y *= CUBEUV_TEXEL_HEIGHT;
		#ifdef texture2DGradEXT
			return texture2DGradEXT( envMap, uv, vec2( 0.0 ), vec2( 0.0 ) ).rgb;
		#else
			return texture2D( envMap, uv ).rgb;
		#endif
	}
	#define cubeUV_r0 1.0
	#define cubeUV_m0 - 2.0
	#define cubeUV_r1 0.8
	#define cubeUV_m1 - 1.0
	#define cubeUV_r4 0.4
	#define cubeUV_m4 2.0
	#define cubeUV_r5 0.305
	#define cubeUV_m5 3.0
	#define cubeUV_r6 0.21
	#define cubeUV_m6 4.0
	float roughnessToMip( float roughness ) {
		float mip = 0.0;
		if ( roughness >= cubeUV_r1 ) {
			mip = ( cubeUV_r0 - roughness ) * ( cubeUV_m1 - cubeUV_m0 ) / ( cubeUV_r0 - cubeUV_r1 ) + cubeUV_m0;
		} else if ( roughness >= cubeUV_r4 ) {
			mip = ( cubeUV_r1 - roughness ) * ( cubeUV_m4 - cubeUV_m1 ) / ( cubeUV_r1 - cubeUV_r4 ) + cubeUV_m1;
		} else if ( roughness >= cubeUV_r5 ) {
			mip = ( cubeUV_r4 - roughness ) * ( cubeUV_m5 - cubeUV_m4 ) / ( cubeUV_r4 - cubeUV_r5 ) + cubeUV_m4;
		} else if ( roughness >= cubeUV_r6 ) {
			mip = ( cubeUV_r5 - roughness ) * ( cubeUV_m6 - cubeUV_m5 ) / ( cubeUV_r5 - cubeUV_r6 ) + cubeUV_m5;
		} else {
			mip = - 2.0 * log2( 1.16 * roughness );		}
		return mip;
	}
	vec4 textureCubeUV( sampler2D envMap, vec3 sampleDir, float roughness ) {
		float mip = clamp( roughnessToMip( roughness ), cubeUV_m0, CUBEUV_MAX_MIP );
		float mipF = fract( mip );
		float mipInt = floor( mip );
		vec3 color0 = bilinearCubeUV( envMap, sampleDir, mipInt );
		if ( mipF == 0.0 ) {
			return vec4( color0, 1.0 );
		} else {
			vec3 color1 = bilinearCubeUV( envMap, sampleDir, mipInt + 1.0 );
			return vec4( mix( color0, color1, mipF ), 1.0 );
		}
	}
#endif`, pf = `vec3 transformedNormal = objectNormal;
#ifdef USE_TANGENT
	vec3 transformedTangent = objectTangent;
#endif
#ifdef USE_BATCHING
	mat3 bm = mat3( batchingMatrix );
	transformedNormal /= vec3( dot( bm[ 0 ], bm[ 0 ] ), dot( bm[ 1 ], bm[ 1 ] ), dot( bm[ 2 ], bm[ 2 ] ) );
	transformedNormal = bm * transformedNormal;
	#ifdef USE_TANGENT
		transformedTangent = bm * transformedTangent;
	#endif
#endif
#ifdef USE_INSTANCING
	mat3 im = mat3( instanceMatrix );
	transformedNormal /= vec3( dot( im[ 0 ], im[ 0 ] ), dot( im[ 1 ], im[ 1 ] ), dot( im[ 2 ], im[ 2 ] ) );
	transformedNormal = im * transformedNormal;
	#ifdef USE_TANGENT
		transformedTangent = im * transformedTangent;
	#endif
#endif
transformedNormal = normalMatrix * transformedNormal;
#ifdef FLIP_SIDED
	transformedNormal = - transformedNormal;
#endif
#ifdef USE_TANGENT
	transformedTangent = ( modelViewMatrix * vec4( transformedTangent, 0.0 ) ).xyz;
	#ifdef FLIP_SIDED
		transformedTangent = - transformedTangent;
	#endif
#endif`, mf = `#ifdef USE_DISPLACEMENTMAP
	uniform sampler2D displacementMap;
	uniform float displacementScale;
	uniform float displacementBias;
#endif`, _f = `#ifdef USE_DISPLACEMENTMAP
	transformed += normalize( objectNormal ) * ( texture2D( displacementMap, vDisplacementMapUv ).x * displacementScale + displacementBias );
#endif`, gf = `#ifdef USE_EMISSIVEMAP
	vec4 emissiveColor = texture2D( emissiveMap, vEmissiveMapUv );
	#ifdef DECODE_VIDEO_TEXTURE_EMISSIVE
		emissiveColor = sRGBTransferEOTF( emissiveColor );
	#endif
	totalEmissiveRadiance *= emissiveColor.rgb;
#endif`, vf = `#ifdef USE_EMISSIVEMAP
	uniform sampler2D emissiveMap;
#endif`, xf = "gl_FragColor = linearToOutputTexel( gl_FragColor );", Sf = `vec4 LinearTransferOETF( in vec4 value ) {
	return value;
}
vec4 sRGBTransferEOTF( in vec4 value ) {
	return vec4( mix( pow( value.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), value.rgb * 0.0773993808, vec3( lessThanEqual( value.rgb, vec3( 0.04045 ) ) ) ), value.a );
}
vec4 sRGBTransferOETF( in vec4 value ) {
	return vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.a );
}`, Mf = `#ifdef USE_ENVMAP
	#ifdef ENV_WORLDPOS
		vec3 cameraToFrag;
		if ( isOrthographic ) {
			cameraToFrag = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );
		} else {
			cameraToFrag = normalize( vWorldPosition - cameraPosition );
		}
		vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );
		#ifdef ENVMAP_MODE_REFLECTION
			vec3 reflectVec = reflect( cameraToFrag, worldNormal );
		#else
			vec3 reflectVec = refract( cameraToFrag, worldNormal, refractionRatio );
		#endif
	#else
		vec3 reflectVec = vReflect;
	#endif
	#ifdef ENVMAP_TYPE_CUBE
		vec4 envColor = textureCube( envMap, envMapRotation * vec3( flipEnvMap * reflectVec.x, reflectVec.yz ) );
	#else
		vec4 envColor = vec4( 0.0 );
	#endif
	#ifdef ENVMAP_BLENDING_MULTIPLY
		outgoingLight = mix( outgoingLight, outgoingLight * envColor.xyz, specularStrength * reflectivity );
	#elif defined( ENVMAP_BLENDING_MIX )
		outgoingLight = mix( outgoingLight, envColor.xyz, specularStrength * reflectivity );
	#elif defined( ENVMAP_BLENDING_ADD )
		outgoingLight += envColor.xyz * specularStrength * reflectivity;
	#endif
#endif`, yf = `#ifdef USE_ENVMAP
	uniform float envMapIntensity;
	uniform float flipEnvMap;
	uniform mat3 envMapRotation;
	#ifdef ENVMAP_TYPE_CUBE
		uniform samplerCube envMap;
	#else
		uniform sampler2D envMap;
	#endif
#endif`, Ef = `#ifdef USE_ENVMAP
	uniform float reflectivity;
	#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )
		#define ENV_WORLDPOS
	#endif
	#ifdef ENV_WORLDPOS
		varying vec3 vWorldPosition;
		uniform float refractionRatio;
	#else
		varying vec3 vReflect;
	#endif
#endif`, Tf = `#ifdef USE_ENVMAP
	#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )
		#define ENV_WORLDPOS
	#endif
	#ifdef ENV_WORLDPOS
		
		varying vec3 vWorldPosition;
	#else
		varying vec3 vReflect;
		uniform float refractionRatio;
	#endif
#endif`, bf = `#ifdef USE_ENVMAP
	#ifdef ENV_WORLDPOS
		vWorldPosition = worldPosition.xyz;
	#else
		vec3 cameraToVertex;
		if ( isOrthographic ) {
			cameraToVertex = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );
		} else {
			cameraToVertex = normalize( worldPosition.xyz - cameraPosition );
		}
		vec3 worldNormal = inverseTransformDirection( transformedNormal, viewMatrix );
		#ifdef ENVMAP_MODE_REFLECTION
			vReflect = reflect( cameraToVertex, worldNormal );
		#else
			vReflect = refract( cameraToVertex, worldNormal, refractionRatio );
		#endif
	#endif
#endif`, Af = `#ifdef USE_FOG
	vFogDepth = - mvPosition.z;
#endif`, wf = `#ifdef USE_FOG
	varying float vFogDepth;
#endif`, Rf = `#ifdef USE_FOG
	#ifdef FOG_EXP2
		float fogFactor = 1.0 - exp( - fogDensity * fogDensity * vFogDepth * vFogDepth );
	#else
		float fogFactor = smoothstep( fogNear, fogFar, vFogDepth );
	#endif
	gl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );
#endif`, Cf = `#ifdef USE_FOG
	uniform vec3 fogColor;
	varying float vFogDepth;
	#ifdef FOG_EXP2
		uniform float fogDensity;
	#else
		uniform float fogNear;
		uniform float fogFar;
	#endif
#endif`, Pf = `#ifdef USE_GRADIENTMAP
	uniform sampler2D gradientMap;
#endif
vec3 getGradientIrradiance( vec3 normal, vec3 lightDirection ) {
	float dotNL = dot( normal, lightDirection );
	vec2 coord = vec2( dotNL * 0.5 + 0.5, 0.0 );
	#ifdef USE_GRADIENTMAP
		return vec3( texture2D( gradientMap, coord ).r );
	#else
		vec2 fw = fwidth( coord ) * 0.5;
		return mix( vec3( 0.7 ), vec3( 1.0 ), smoothstep( 0.7 - fw.x, 0.7 + fw.x, coord.x ) );
	#endif
}`, Df = `#ifdef USE_LIGHTMAP
	uniform sampler2D lightMap;
	uniform float lightMapIntensity;
#endif`, Lf = `LambertMaterial material;
material.diffuseColor = diffuseColor.rgb;
material.specularStrength = specularStrength;`, Ff = `varying vec3 vViewPosition;
struct LambertMaterial {
	vec3 diffuseColor;
	float specularStrength;
};
void RE_Direct_Lambert( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {
	float dotNL = saturate( dot( geometryNormal, directLight.direction ) );
	vec3 irradiance = dotNL * directLight.color;
	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
void RE_IndirectDiffuse_Lambert( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {
	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
#define RE_Direct				RE_Direct_Lambert
#define RE_IndirectDiffuse		RE_IndirectDiffuse_Lambert`, Uf = `uniform bool receiveShadow;
uniform vec3 ambientLightColor;
#if defined( USE_LIGHT_PROBES )
	uniform vec3 lightProbe[ 9 ];
#endif
vec3 shGetIrradianceAt( in vec3 normal, in vec3 shCoefficients[ 9 ] ) {
	float x = normal.x, y = normal.y, z = normal.z;
	vec3 result = shCoefficients[ 0 ] * 0.886227;
	result += shCoefficients[ 1 ] * 2.0 * 0.511664 * y;
	result += shCoefficients[ 2 ] * 2.0 * 0.511664 * z;
	result += shCoefficients[ 3 ] * 2.0 * 0.511664 * x;
	result += shCoefficients[ 4 ] * 2.0 * 0.429043 * x * y;
	result += shCoefficients[ 5 ] * 2.0 * 0.429043 * y * z;
	result += shCoefficients[ 6 ] * ( 0.743125 * z * z - 0.247708 );
	result += shCoefficients[ 7 ] * 2.0 * 0.429043 * x * z;
	result += shCoefficients[ 8 ] * 0.429043 * ( x * x - y * y );
	return result;
}
vec3 getLightProbeIrradiance( const in vec3 lightProbe[ 9 ], const in vec3 normal ) {
	vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );
	vec3 irradiance = shGetIrradianceAt( worldNormal, lightProbe );
	return irradiance;
}
vec3 getAmbientLightIrradiance( const in vec3 ambientLightColor ) {
	vec3 irradiance = ambientLightColor;
	return irradiance;
}
float getDistanceAttenuation( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {
	float distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), 0.01 );
	if ( cutoffDistance > 0.0 ) {
		distanceFalloff *= pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );
	}
	return distanceFalloff;
}
float getSpotAttenuation( const in float coneCosine, const in float penumbraCosine, const in float angleCosine ) {
	return smoothstep( coneCosine, penumbraCosine, angleCosine );
}
#if NUM_DIR_LIGHTS > 0
	struct DirectionalLight {
		vec3 direction;
		vec3 color;
	};
	uniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];
	void getDirectionalLightInfo( const in DirectionalLight directionalLight, out IncidentLight light ) {
		light.color = directionalLight.color;
		light.direction = directionalLight.direction;
		light.visible = true;
	}
#endif
#if NUM_POINT_LIGHTS > 0
	struct PointLight {
		vec3 position;
		vec3 color;
		float distance;
		float decay;
	};
	uniform PointLight pointLights[ NUM_POINT_LIGHTS ];
	void getPointLightInfo( const in PointLight pointLight, const in vec3 geometryPosition, out IncidentLight light ) {
		vec3 lVector = pointLight.position - geometryPosition;
		light.direction = normalize( lVector );
		float lightDistance = length( lVector );
		light.color = pointLight.color;
		light.color *= getDistanceAttenuation( lightDistance, pointLight.distance, pointLight.decay );
		light.visible = ( light.color != vec3( 0.0 ) );
	}
#endif
#if NUM_SPOT_LIGHTS > 0
	struct SpotLight {
		vec3 position;
		vec3 direction;
		vec3 color;
		float distance;
		float decay;
		float coneCos;
		float penumbraCos;
	};
	uniform SpotLight spotLights[ NUM_SPOT_LIGHTS ];
	void getSpotLightInfo( const in SpotLight spotLight, const in vec3 geometryPosition, out IncidentLight light ) {
		vec3 lVector = spotLight.position - geometryPosition;
		light.direction = normalize( lVector );
		float angleCos = dot( light.direction, spotLight.direction );
		float spotAttenuation = getSpotAttenuation( spotLight.coneCos, spotLight.penumbraCos, angleCos );
		if ( spotAttenuation > 0.0 ) {
			float lightDistance = length( lVector );
			light.color = spotLight.color * spotAttenuation;
			light.color *= getDistanceAttenuation( lightDistance, spotLight.distance, spotLight.decay );
			light.visible = ( light.color != vec3( 0.0 ) );
		} else {
			light.color = vec3( 0.0 );
			light.visible = false;
		}
	}
#endif
#if NUM_RECT_AREA_LIGHTS > 0
	struct RectAreaLight {
		vec3 color;
		vec3 position;
		vec3 halfWidth;
		vec3 halfHeight;
	};
	uniform sampler2D ltc_1;	uniform sampler2D ltc_2;
	uniform RectAreaLight rectAreaLights[ NUM_RECT_AREA_LIGHTS ];
#endif
#if NUM_HEMI_LIGHTS > 0
	struct HemisphereLight {
		vec3 direction;
		vec3 skyColor;
		vec3 groundColor;
	};
	uniform HemisphereLight hemisphereLights[ NUM_HEMI_LIGHTS ];
	vec3 getHemisphereLightIrradiance( const in HemisphereLight hemiLight, const in vec3 normal ) {
		float dotNL = dot( normal, hemiLight.direction );
		float hemiDiffuseWeight = 0.5 * dotNL + 0.5;
		vec3 irradiance = mix( hemiLight.groundColor, hemiLight.skyColor, hemiDiffuseWeight );
		return irradiance;
	}
#endif`, If = `#ifdef USE_ENVMAP
	vec3 getIBLIrradiance( const in vec3 normal ) {
		#ifdef ENVMAP_TYPE_CUBE_UV
			vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );
			vec4 envMapColor = textureCubeUV( envMap, envMapRotation * worldNormal, 1.0 );
			return PI * envMapColor.rgb * envMapIntensity;
		#else
			return vec3( 0.0 );
		#endif
	}
	vec3 getIBLRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness ) {
		#ifdef ENVMAP_TYPE_CUBE_UV
			vec3 reflectVec = reflect( - viewDir, normal );
			reflectVec = normalize( mix( reflectVec, normal, pow4( roughness ) ) );
			reflectVec = inverseTransformDirection( reflectVec, viewMatrix );
			vec4 envMapColor = textureCubeUV( envMap, envMapRotation * reflectVec, roughness );
			return envMapColor.rgb * envMapIntensity;
		#else
			return vec3( 0.0 );
		#endif
	}
	#ifdef USE_ANISOTROPY
		vec3 getIBLAnisotropyRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness, const in vec3 bitangent, const in float anisotropy ) {
			#ifdef ENVMAP_TYPE_CUBE_UV
				vec3 bentNormal = cross( bitangent, viewDir );
				bentNormal = normalize( cross( bentNormal, bitangent ) );
				bentNormal = normalize( mix( bentNormal, normal, pow2( pow2( 1.0 - anisotropy * ( 1.0 - roughness ) ) ) ) );
				return getIBLRadiance( viewDir, bentNormal, roughness );
			#else
				return vec3( 0.0 );
			#endif
		}
	#endif
#endif`, Nf = `ToonMaterial material;
material.diffuseColor = diffuseColor.rgb;`, Of = `varying vec3 vViewPosition;
struct ToonMaterial {
	vec3 diffuseColor;
};
void RE_Direct_Toon( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {
	vec3 irradiance = getGradientIrradiance( geometryNormal, directLight.direction ) * directLight.color;
	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
void RE_IndirectDiffuse_Toon( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {
	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
#define RE_Direct				RE_Direct_Toon
#define RE_IndirectDiffuse		RE_IndirectDiffuse_Toon`, Bf = `BlinnPhongMaterial material;
material.diffuseColor = diffuseColor.rgb;
material.specularColor = specular;
material.specularShininess = shininess;
material.specularStrength = specularStrength;`, zf = `varying vec3 vViewPosition;
struct BlinnPhongMaterial {
	vec3 diffuseColor;
	vec3 specularColor;
	float specularShininess;
	float specularStrength;
};
void RE_Direct_BlinnPhong( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {
	float dotNL = saturate( dot( geometryNormal, directLight.direction ) );
	vec3 irradiance = dotNL * directLight.color;
	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
	reflectedLight.directSpecular += irradiance * BRDF_BlinnPhong( directLight.direction, geometryViewDir, geometryNormal, material.specularColor, material.specularShininess ) * material.specularStrength;
}
void RE_IndirectDiffuse_BlinnPhong( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {
	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
#define RE_Direct				RE_Direct_BlinnPhong
#define RE_IndirectDiffuse		RE_IndirectDiffuse_BlinnPhong`, Gf = `PhysicalMaterial material;
material.diffuseColor = diffuseColor.rgb;
material.diffuseContribution = diffuseColor.rgb * ( 1.0 - metalnessFactor );
material.metalness = metalnessFactor;
vec3 dxy = max( abs( dFdx( nonPerturbedNormal ) ), abs( dFdy( nonPerturbedNormal ) ) );
float geometryRoughness = max( max( dxy.x, dxy.y ), dxy.z );
material.roughness = max( roughnessFactor, 0.0525 );material.roughness += geometryRoughness;
material.roughness = min( material.roughness, 1.0 );
#ifdef IOR
	material.ior = ior;
	#ifdef USE_SPECULAR
		float specularIntensityFactor = specularIntensity;
		vec3 specularColorFactor = specularColor;
		#ifdef USE_SPECULAR_COLORMAP
			specularColorFactor *= texture2D( specularColorMap, vSpecularColorMapUv ).rgb;
		#endif
		#ifdef USE_SPECULAR_INTENSITYMAP
			specularIntensityFactor *= texture2D( specularIntensityMap, vSpecularIntensityMapUv ).a;
		#endif
		material.specularF90 = mix( specularIntensityFactor, 1.0, metalnessFactor );
	#else
		float specularIntensityFactor = 1.0;
		vec3 specularColorFactor = vec3( 1.0 );
		material.specularF90 = 1.0;
	#endif
	material.specularColor = min( pow2( ( material.ior - 1.0 ) / ( material.ior + 1.0 ) ) * specularColorFactor, vec3( 1.0 ) ) * specularIntensityFactor;
	material.specularColorBlended = mix( material.specularColor, diffuseColor.rgb, metalnessFactor );
#else
	material.specularColor = vec3( 0.04 );
	material.specularColorBlended = mix( material.specularColor, diffuseColor.rgb, metalnessFactor );
	material.specularF90 = 1.0;
#endif
#ifdef USE_CLEARCOAT
	material.clearcoat = clearcoat;
	material.clearcoatRoughness = clearcoatRoughness;
	material.clearcoatF0 = vec3( 0.04 );
	material.clearcoatF90 = 1.0;
	#ifdef USE_CLEARCOATMAP
		material.clearcoat *= texture2D( clearcoatMap, vClearcoatMapUv ).x;
	#endif
	#ifdef USE_CLEARCOAT_ROUGHNESSMAP
		material.clearcoatRoughness *= texture2D( clearcoatRoughnessMap, vClearcoatRoughnessMapUv ).y;
	#endif
	material.clearcoat = saturate( material.clearcoat );	material.clearcoatRoughness = max( material.clearcoatRoughness, 0.0525 );
	material.clearcoatRoughness += geometryRoughness;
	material.clearcoatRoughness = min( material.clearcoatRoughness, 1.0 );
#endif
#ifdef USE_DISPERSION
	material.dispersion = dispersion;
#endif
#ifdef USE_IRIDESCENCE
	material.iridescence = iridescence;
	material.iridescenceIOR = iridescenceIOR;
	#ifdef USE_IRIDESCENCEMAP
		material.iridescence *= texture2D( iridescenceMap, vIridescenceMapUv ).r;
	#endif
	#ifdef USE_IRIDESCENCE_THICKNESSMAP
		material.iridescenceThickness = (iridescenceThicknessMaximum - iridescenceThicknessMinimum) * texture2D( iridescenceThicknessMap, vIridescenceThicknessMapUv ).g + iridescenceThicknessMinimum;
	#else
		material.iridescenceThickness = iridescenceThicknessMaximum;
	#endif
#endif
#ifdef USE_SHEEN
	material.sheenColor = sheenColor;
	#ifdef USE_SHEEN_COLORMAP
		material.sheenColor *= texture2D( sheenColorMap, vSheenColorMapUv ).rgb;
	#endif
	material.sheenRoughness = clamp( sheenRoughness, 0.0001, 1.0 );
	#ifdef USE_SHEEN_ROUGHNESSMAP
		material.sheenRoughness *= texture2D( sheenRoughnessMap, vSheenRoughnessMapUv ).a;
	#endif
#endif
#ifdef USE_ANISOTROPY
	#ifdef USE_ANISOTROPYMAP
		mat2 anisotropyMat = mat2( anisotropyVector.x, anisotropyVector.y, - anisotropyVector.y, anisotropyVector.x );
		vec3 anisotropyPolar = texture2D( anisotropyMap, vAnisotropyMapUv ).rgb;
		vec2 anisotropyV = anisotropyMat * normalize( 2.0 * anisotropyPolar.rg - vec2( 1.0 ) ) * anisotropyPolar.b;
	#else
		vec2 anisotropyV = anisotropyVector;
	#endif
	material.anisotropy = length( anisotropyV );
	if( material.anisotropy == 0.0 ) {
		anisotropyV = vec2( 1.0, 0.0 );
	} else {
		anisotropyV /= material.anisotropy;
		material.anisotropy = saturate( material.anisotropy );
	}
	material.alphaT = mix( pow2( material.roughness ), 1.0, pow2( material.anisotropy ) );
	material.anisotropyT = tbn[ 0 ] * anisotropyV.x + tbn[ 1 ] * anisotropyV.y;
	material.anisotropyB = tbn[ 1 ] * anisotropyV.x - tbn[ 0 ] * anisotropyV.y;
#endif`, kf = `uniform sampler2D dfgLUT;
struct PhysicalMaterial {
	vec3 diffuseColor;
	vec3 diffuseContribution;
	vec3 specularColor;
	vec3 specularColorBlended;
	float roughness;
	float metalness;
	float specularF90;
	float dispersion;
	#ifdef USE_CLEARCOAT
		float clearcoat;
		float clearcoatRoughness;
		vec3 clearcoatF0;
		float clearcoatF90;
	#endif
	#ifdef USE_IRIDESCENCE
		float iridescence;
		float iridescenceIOR;
		float iridescenceThickness;
		vec3 iridescenceFresnel;
		vec3 iridescenceF0;
		vec3 iridescenceFresnelDielectric;
		vec3 iridescenceFresnelMetallic;
	#endif
	#ifdef USE_SHEEN
		vec3 sheenColor;
		float sheenRoughness;
	#endif
	#ifdef IOR
		float ior;
	#endif
	#ifdef USE_TRANSMISSION
		float transmission;
		float transmissionAlpha;
		float thickness;
		float attenuationDistance;
		vec3 attenuationColor;
	#endif
	#ifdef USE_ANISOTROPY
		float anisotropy;
		float alphaT;
		vec3 anisotropyT;
		vec3 anisotropyB;
	#endif
};
vec3 clearcoatSpecularDirect = vec3( 0.0 );
vec3 clearcoatSpecularIndirect = vec3( 0.0 );
vec3 sheenSpecularDirect = vec3( 0.0 );
vec3 sheenSpecularIndirect = vec3(0.0 );
vec3 Schlick_to_F0( const in vec3 f, const in float f90, const in float dotVH ) {
    float x = clamp( 1.0 - dotVH, 0.0, 1.0 );
    float x2 = x * x;
    float x5 = clamp( x * x2 * x2, 0.0, 0.9999 );
    return ( f - vec3( f90 ) * x5 ) / ( 1.0 - x5 );
}
float V_GGX_SmithCorrelated( const in float alpha, const in float dotNL, const in float dotNV ) {
	float a2 = pow2( alpha );
	float gv = dotNL * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );
	float gl = dotNV * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );
	return 0.5 / max( gv + gl, EPSILON );
}
float D_GGX( const in float alpha, const in float dotNH ) {
	float a2 = pow2( alpha );
	float denom = pow2( dotNH ) * ( a2 - 1.0 ) + 1.0;
	return RECIPROCAL_PI * a2 / pow2( denom );
}
#ifdef USE_ANISOTROPY
	float V_GGX_SmithCorrelated_Anisotropic( const in float alphaT, const in float alphaB, const in float dotTV, const in float dotBV, const in float dotTL, const in float dotBL, const in float dotNV, const in float dotNL ) {
		float gv = dotNL * length( vec3( alphaT * dotTV, alphaB * dotBV, dotNV ) );
		float gl = dotNV * length( vec3( alphaT * dotTL, alphaB * dotBL, dotNL ) );
		float v = 0.5 / ( gv + gl );
		return v;
	}
	float D_GGX_Anisotropic( const in float alphaT, const in float alphaB, const in float dotNH, const in float dotTH, const in float dotBH ) {
		float a2 = alphaT * alphaB;
		highp vec3 v = vec3( alphaB * dotTH, alphaT * dotBH, a2 * dotNH );
		highp float v2 = dot( v, v );
		float w2 = a2 / v2;
		return RECIPROCAL_PI * a2 * pow2 ( w2 );
	}
#endif
#ifdef USE_CLEARCOAT
	vec3 BRDF_GGX_Clearcoat( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material) {
		vec3 f0 = material.clearcoatF0;
		float f90 = material.clearcoatF90;
		float roughness = material.clearcoatRoughness;
		float alpha = pow2( roughness );
		vec3 halfDir = normalize( lightDir + viewDir );
		float dotNL = saturate( dot( normal, lightDir ) );
		float dotNV = saturate( dot( normal, viewDir ) );
		float dotNH = saturate( dot( normal, halfDir ) );
		float dotVH = saturate( dot( viewDir, halfDir ) );
		vec3 F = F_Schlick( f0, f90, dotVH );
		float V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );
		float D = D_GGX( alpha, dotNH );
		return F * ( V * D );
	}
#endif
vec3 BRDF_GGX( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material ) {
	vec3 f0 = material.specularColorBlended;
	float f90 = material.specularF90;
	float roughness = material.roughness;
	float alpha = pow2( roughness );
	vec3 halfDir = normalize( lightDir + viewDir );
	float dotNL = saturate( dot( normal, lightDir ) );
	float dotNV = saturate( dot( normal, viewDir ) );
	float dotNH = saturate( dot( normal, halfDir ) );
	float dotVH = saturate( dot( viewDir, halfDir ) );
	vec3 F = F_Schlick( f0, f90, dotVH );
	#ifdef USE_IRIDESCENCE
		F = mix( F, material.iridescenceFresnel, material.iridescence );
	#endif
	#ifdef USE_ANISOTROPY
		float dotTL = dot( material.anisotropyT, lightDir );
		float dotTV = dot( material.anisotropyT, viewDir );
		float dotTH = dot( material.anisotropyT, halfDir );
		float dotBL = dot( material.anisotropyB, lightDir );
		float dotBV = dot( material.anisotropyB, viewDir );
		float dotBH = dot( material.anisotropyB, halfDir );
		float V = V_GGX_SmithCorrelated_Anisotropic( material.alphaT, alpha, dotTV, dotBV, dotTL, dotBL, dotNV, dotNL );
		float D = D_GGX_Anisotropic( material.alphaT, alpha, dotNH, dotTH, dotBH );
	#else
		float V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );
		float D = D_GGX( alpha, dotNH );
	#endif
	return F * ( V * D );
}
vec2 LTC_Uv( const in vec3 N, const in vec3 V, const in float roughness ) {
	const float LUT_SIZE = 64.0;
	const float LUT_SCALE = ( LUT_SIZE - 1.0 ) / LUT_SIZE;
	const float LUT_BIAS = 0.5 / LUT_SIZE;
	float dotNV = saturate( dot( N, V ) );
	vec2 uv = vec2( roughness, sqrt( 1.0 - dotNV ) );
	uv = uv * LUT_SCALE + LUT_BIAS;
	return uv;
}
float LTC_ClippedSphereFormFactor( const in vec3 f ) {
	float l = length( f );
	return max( ( l * l + f.z ) / ( l + 1.0 ), 0.0 );
}
vec3 LTC_EdgeVectorFormFactor( const in vec3 v1, const in vec3 v2 ) {
	float x = dot( v1, v2 );
	float y = abs( x );
	float a = 0.8543985 + ( 0.4965155 + 0.0145206 * y ) * y;
	float b = 3.4175940 + ( 4.1616724 + y ) * y;
	float v = a / b;
	float theta_sintheta = ( x > 0.0 ) ? v : 0.5 * inversesqrt( max( 1.0 - x * x, 1e-7 ) ) - v;
	return cross( v1, v2 ) * theta_sintheta;
}
vec3 LTC_Evaluate( const in vec3 N, const in vec3 V, const in vec3 P, const in mat3 mInv, const in vec3 rectCoords[ 4 ] ) {
	vec3 v1 = rectCoords[ 1 ] - rectCoords[ 0 ];
	vec3 v2 = rectCoords[ 3 ] - rectCoords[ 0 ];
	vec3 lightNormal = cross( v1, v2 );
	if( dot( lightNormal, P - rectCoords[ 0 ] ) < 0.0 ) return vec3( 0.0 );
	vec3 T1, T2;
	T1 = normalize( V - N * dot( V, N ) );
	T2 = - cross( N, T1 );
	mat3 mat = mInv * transpose( mat3( T1, T2, N ) );
	vec3 coords[ 4 ];
	coords[ 0 ] = mat * ( rectCoords[ 0 ] - P );
	coords[ 1 ] = mat * ( rectCoords[ 1 ] - P );
	coords[ 2 ] = mat * ( rectCoords[ 2 ] - P );
	coords[ 3 ] = mat * ( rectCoords[ 3 ] - P );
	coords[ 0 ] = normalize( coords[ 0 ] );
	coords[ 1 ] = normalize( coords[ 1 ] );
	coords[ 2 ] = normalize( coords[ 2 ] );
	coords[ 3 ] = normalize( coords[ 3 ] );
	vec3 vectorFormFactor = vec3( 0.0 );
	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 0 ], coords[ 1 ] );
	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 1 ], coords[ 2 ] );
	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 2 ], coords[ 3 ] );
	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 3 ], coords[ 0 ] );
	float result = LTC_ClippedSphereFormFactor( vectorFormFactor );
	return vec3( result );
}
#if defined( USE_SHEEN )
float D_Charlie( float roughness, float dotNH ) {
	float alpha = pow2( roughness );
	float invAlpha = 1.0 / alpha;
	float cos2h = dotNH * dotNH;
	float sin2h = max( 1.0 - cos2h, 0.0078125 );
	return ( 2.0 + invAlpha ) * pow( sin2h, invAlpha * 0.5 ) / ( 2.0 * PI );
}
float V_Neubelt( float dotNV, float dotNL ) {
	return saturate( 1.0 / ( 4.0 * ( dotNL + dotNV - dotNL * dotNV ) ) );
}
vec3 BRDF_Sheen( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, vec3 sheenColor, const in float sheenRoughness ) {
	vec3 halfDir = normalize( lightDir + viewDir );
	float dotNL = saturate( dot( normal, lightDir ) );
	float dotNV = saturate( dot( normal, viewDir ) );
	float dotNH = saturate( dot( normal, halfDir ) );
	float D = D_Charlie( sheenRoughness, dotNH );
	float V = V_Neubelt( dotNV, dotNL );
	return sheenColor * ( D * V );
}
#endif
float IBLSheenBRDF( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {
	float dotNV = saturate( dot( normal, viewDir ) );
	float r2 = roughness * roughness;
	float rInv = 1.0 / ( roughness + 0.1 );
	float a = -1.9362 + 1.0678 * roughness + 0.4573 * r2 - 0.8469 * rInv;
	float b = -0.6014 + 0.5538 * roughness - 0.4670 * r2 - 0.1255 * rInv;
	float DG = exp( a * dotNV + b );
	return saturate( DG );
}
vec3 EnvironmentBRDF( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness ) {
	float dotNV = saturate( dot( normal, viewDir ) );
	vec2 fab = texture2D( dfgLUT, vec2( roughness, dotNV ) ).rg;
	return specularColor * fab.x + specularF90 * fab.y;
}
#ifdef USE_IRIDESCENCE
void computeMultiscatteringIridescence( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float iridescence, const in vec3 iridescenceF0, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {
#else
void computeMultiscattering( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {
#endif
	float dotNV = saturate( dot( normal, viewDir ) );
	vec2 fab = texture2D( dfgLUT, vec2( roughness, dotNV ) ).rg;
	#ifdef USE_IRIDESCENCE
		vec3 Fr = mix( specularColor, iridescenceF0, iridescence );
	#else
		vec3 Fr = specularColor;
	#endif
	vec3 FssEss = Fr * fab.x + specularF90 * fab.y;
	float Ess = fab.x + fab.y;
	float Ems = 1.0 - Ess;
	vec3 Favg = Fr + ( 1.0 - Fr ) * 0.047619;	vec3 Fms = FssEss * Favg / ( 1.0 - Ems * Favg );
	singleScatter += FssEss;
	multiScatter += Fms * Ems;
}
vec3 BRDF_GGX_Multiscatter( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material ) {
	vec3 singleScatter = BRDF_GGX( lightDir, viewDir, normal, material );
	float dotNL = saturate( dot( normal, lightDir ) );
	float dotNV = saturate( dot( normal, viewDir ) );
	vec2 dfgV = texture2D( dfgLUT, vec2( material.roughness, dotNV ) ).rg;
	vec2 dfgL = texture2D( dfgLUT, vec2( material.roughness, dotNL ) ).rg;
	vec3 FssEss_V = material.specularColorBlended * dfgV.x + material.specularF90 * dfgV.y;
	vec3 FssEss_L = material.specularColorBlended * dfgL.x + material.specularF90 * dfgL.y;
	float Ess_V = dfgV.x + dfgV.y;
	float Ess_L = dfgL.x + dfgL.y;
	float Ems_V = 1.0 - Ess_V;
	float Ems_L = 1.0 - Ess_L;
	vec3 Favg = material.specularColorBlended + ( 1.0 - material.specularColorBlended ) * 0.047619;
	vec3 Fms = FssEss_V * FssEss_L * Favg / ( 1.0 - Ems_V * Ems_L * Favg + EPSILON );
	float compensationFactor = Ems_V * Ems_L;
	vec3 multiScatter = Fms * compensationFactor;
	return singleScatter + multiScatter;
}
#if NUM_RECT_AREA_LIGHTS > 0
	void RE_Direct_RectArea_Physical( const in RectAreaLight rectAreaLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {
		vec3 normal = geometryNormal;
		vec3 viewDir = geometryViewDir;
		vec3 position = geometryPosition;
		vec3 lightPos = rectAreaLight.position;
		vec3 halfWidth = rectAreaLight.halfWidth;
		vec3 halfHeight = rectAreaLight.halfHeight;
		vec3 lightColor = rectAreaLight.color;
		float roughness = material.roughness;
		vec3 rectCoords[ 4 ];
		rectCoords[ 0 ] = lightPos + halfWidth - halfHeight;		rectCoords[ 1 ] = lightPos - halfWidth - halfHeight;
		rectCoords[ 2 ] = lightPos - halfWidth + halfHeight;
		rectCoords[ 3 ] = lightPos + halfWidth + halfHeight;
		vec2 uv = LTC_Uv( normal, viewDir, roughness );
		vec4 t1 = texture2D( ltc_1, uv );
		vec4 t2 = texture2D( ltc_2, uv );
		mat3 mInv = mat3(
			vec3( t1.x, 0, t1.y ),
			vec3(    0, 1,    0 ),
			vec3( t1.z, 0, t1.w )
		);
		vec3 fresnel = ( material.specularColorBlended * t2.x + ( vec3( 1.0 ) - material.specularColorBlended ) * t2.y );
		reflectedLight.directSpecular += lightColor * fresnel * LTC_Evaluate( normal, viewDir, position, mInv, rectCoords );
		reflectedLight.directDiffuse += lightColor * material.diffuseContribution * LTC_Evaluate( normal, viewDir, position, mat3( 1.0 ), rectCoords );
	}
#endif
void RE_Direct_Physical( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {
	float dotNL = saturate( dot( geometryNormal, directLight.direction ) );
	vec3 irradiance = dotNL * directLight.color;
	#ifdef USE_CLEARCOAT
		float dotNLcc = saturate( dot( geometryClearcoatNormal, directLight.direction ) );
		vec3 ccIrradiance = dotNLcc * directLight.color;
		clearcoatSpecularDirect += ccIrradiance * BRDF_GGX_Clearcoat( directLight.direction, geometryViewDir, geometryClearcoatNormal, material );
	#endif
	#ifdef USE_SHEEN
 
 		sheenSpecularDirect += irradiance * BRDF_Sheen( directLight.direction, geometryViewDir, geometryNormal, material.sheenColor, material.sheenRoughness );
 
 		float sheenAlbedoV = IBLSheenBRDF( geometryNormal, geometryViewDir, material.sheenRoughness );
 		float sheenAlbedoL = IBLSheenBRDF( geometryNormal, directLight.direction, material.sheenRoughness );
 
 		float sheenEnergyComp = 1.0 - max3( material.sheenColor ) * max( sheenAlbedoV, sheenAlbedoL );
 
 		irradiance *= sheenEnergyComp;
 
 	#endif
	reflectedLight.directSpecular += irradiance * BRDF_GGX_Multiscatter( directLight.direction, geometryViewDir, geometryNormal, material );
	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseContribution );
}
void RE_IndirectDiffuse_Physical( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {
	vec3 diffuse = irradiance * BRDF_Lambert( material.diffuseContribution );
	#ifdef USE_SHEEN
		float sheenAlbedo = IBLSheenBRDF( geometryNormal, geometryViewDir, material.sheenRoughness );
		float sheenEnergyComp = 1.0 - max3( material.sheenColor ) * sheenAlbedo;
		diffuse *= sheenEnergyComp;
	#endif
	reflectedLight.indirectDiffuse += diffuse;
}
void RE_IndirectSpecular_Physical( const in vec3 radiance, const in vec3 irradiance, const in vec3 clearcoatRadiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight) {
	#ifdef USE_CLEARCOAT
		clearcoatSpecularIndirect += clearcoatRadiance * EnvironmentBRDF( geometryClearcoatNormal, geometryViewDir, material.clearcoatF0, material.clearcoatF90, material.clearcoatRoughness );
	#endif
	#ifdef USE_SHEEN
		sheenSpecularIndirect += irradiance * material.sheenColor * IBLSheenBRDF( geometryNormal, geometryViewDir, material.sheenRoughness ) * RECIPROCAL_PI;
 	#endif
	vec3 singleScatteringDielectric = vec3( 0.0 );
	vec3 multiScatteringDielectric = vec3( 0.0 );
	vec3 singleScatteringMetallic = vec3( 0.0 );
	vec3 multiScatteringMetallic = vec3( 0.0 );
	#ifdef USE_IRIDESCENCE
		computeMultiscatteringIridescence( geometryNormal, geometryViewDir, material.specularColor, material.specularF90, material.iridescence, material.iridescenceFresnelDielectric, material.roughness, singleScatteringDielectric, multiScatteringDielectric );
		computeMultiscatteringIridescence( geometryNormal, geometryViewDir, material.diffuseColor, material.specularF90, material.iridescence, material.iridescenceFresnelMetallic, material.roughness, singleScatteringMetallic, multiScatteringMetallic );
	#else
		computeMultiscattering( geometryNormal, geometryViewDir, material.specularColor, material.specularF90, material.roughness, singleScatteringDielectric, multiScatteringDielectric );
		computeMultiscattering( geometryNormal, geometryViewDir, material.diffuseColor, material.specularF90, material.roughness, singleScatteringMetallic, multiScatteringMetallic );
	#endif
	vec3 singleScattering = mix( singleScatteringDielectric, singleScatteringMetallic, material.metalness );
	vec3 multiScattering = mix( multiScatteringDielectric, multiScatteringMetallic, material.metalness );
	vec3 totalScatteringDielectric = singleScatteringDielectric + multiScatteringDielectric;
	vec3 diffuse = material.diffuseContribution * ( 1.0 - totalScatteringDielectric );
	vec3 cosineWeightedIrradiance = irradiance * RECIPROCAL_PI;
	vec3 indirectSpecular = radiance * singleScattering;
	indirectSpecular += multiScattering * cosineWeightedIrradiance;
	vec3 indirectDiffuse = diffuse * cosineWeightedIrradiance;
	#ifdef USE_SHEEN
		float sheenAlbedo = IBLSheenBRDF( geometryNormal, geometryViewDir, material.sheenRoughness );
		float sheenEnergyComp = 1.0 - max3( material.sheenColor ) * sheenAlbedo;
		indirectSpecular *= sheenEnergyComp;
		indirectDiffuse *= sheenEnergyComp;
	#endif
	reflectedLight.indirectSpecular += indirectSpecular;
	reflectedLight.indirectDiffuse += indirectDiffuse;
}
#define RE_Direct				RE_Direct_Physical
#define RE_Direct_RectArea		RE_Direct_RectArea_Physical
#define RE_IndirectDiffuse		RE_IndirectDiffuse_Physical
#define RE_IndirectSpecular		RE_IndirectSpecular_Physical
float computeSpecularOcclusion( const in float dotNV, const in float ambientOcclusion, const in float roughness ) {
	return saturate( pow( dotNV + ambientOcclusion, exp2( - 16.0 * roughness - 1.0 ) ) - 1.0 + ambientOcclusion );
}`, Vf = `
vec3 geometryPosition = - vViewPosition;
vec3 geometryNormal = normal;
vec3 geometryViewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( vViewPosition );
vec3 geometryClearcoatNormal = vec3( 0.0 );
#ifdef USE_CLEARCOAT
	geometryClearcoatNormal = clearcoatNormal;
#endif
#ifdef USE_IRIDESCENCE
	float dotNVi = saturate( dot( normal, geometryViewDir ) );
	if ( material.iridescenceThickness == 0.0 ) {
		material.iridescence = 0.0;
	} else {
		material.iridescence = saturate( material.iridescence );
	}
	if ( material.iridescence > 0.0 ) {
		material.iridescenceFresnelDielectric = evalIridescence( 1.0, material.iridescenceIOR, dotNVi, material.iridescenceThickness, material.specularColor );
		material.iridescenceFresnelMetallic = evalIridescence( 1.0, material.iridescenceIOR, dotNVi, material.iridescenceThickness, material.diffuseColor );
		material.iridescenceFresnel = mix( material.iridescenceFresnelDielectric, material.iridescenceFresnelMetallic, material.metalness );
		material.iridescenceF0 = Schlick_to_F0( material.iridescenceFresnel, 1.0, dotNVi );
	}
#endif
IncidentLight directLight;
#if ( NUM_POINT_LIGHTS > 0 ) && defined( RE_Direct )
	PointLight pointLight;
	#if defined( USE_SHADOWMAP ) && NUM_POINT_LIGHT_SHADOWS > 0
	PointLightShadow pointLightShadow;
	#endif
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {
		pointLight = pointLights[ i ];
		getPointLightInfo( pointLight, geometryPosition, directLight );
		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_POINT_LIGHT_SHADOWS ) && ( defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_BASIC ) )
		pointLightShadow = pointLightShadows[ i ];
		directLight.color *= ( directLight.visible && receiveShadow ) ? getPointShadow( pointShadowMap[ i ], pointLightShadow.shadowMapSize, pointLightShadow.shadowIntensity, pointLightShadow.shadowBias, pointLightShadow.shadowRadius, vPointShadowCoord[ i ], pointLightShadow.shadowCameraNear, pointLightShadow.shadowCameraFar ) : 1.0;
		#endif
		RE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );
	}
	#pragma unroll_loop_end
#endif
#if ( NUM_SPOT_LIGHTS > 0 ) && defined( RE_Direct )
	SpotLight spotLight;
	vec4 spotColor;
	vec3 spotLightCoord;
	bool inSpotLightMap;
	#if defined( USE_SHADOWMAP ) && NUM_SPOT_LIGHT_SHADOWS > 0
	SpotLightShadow spotLightShadow;
	#endif
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {
		spotLight = spotLights[ i ];
		getSpotLightInfo( spotLight, geometryPosition, directLight );
		#if ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )
		#define SPOT_LIGHT_MAP_INDEX UNROLLED_LOOP_INDEX
		#elif ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )
		#define SPOT_LIGHT_MAP_INDEX NUM_SPOT_LIGHT_MAPS
		#else
		#define SPOT_LIGHT_MAP_INDEX ( UNROLLED_LOOP_INDEX - NUM_SPOT_LIGHT_SHADOWS + NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )
		#endif
		#if ( SPOT_LIGHT_MAP_INDEX < NUM_SPOT_LIGHT_MAPS )
			spotLightCoord = vSpotLightCoord[ i ].xyz / vSpotLightCoord[ i ].w;
			inSpotLightMap = all( lessThan( abs( spotLightCoord * 2. - 1. ), vec3( 1.0 ) ) );
			spotColor = texture2D( spotLightMap[ SPOT_LIGHT_MAP_INDEX ], spotLightCoord.xy );
			directLight.color = inSpotLightMap ? directLight.color * spotColor.rgb : directLight.color;
		#endif
		#undef SPOT_LIGHT_MAP_INDEX
		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )
		spotLightShadow = spotLightShadows[ i ];
		directLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( spotShadowMap[ i ], spotLightShadow.shadowMapSize, spotLightShadow.shadowIntensity, spotLightShadow.shadowBias, spotLightShadow.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;
		#endif
		RE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );
	}
	#pragma unroll_loop_end
#endif
#if ( NUM_DIR_LIGHTS > 0 ) && defined( RE_Direct )
	DirectionalLight directionalLight;
	#if defined( USE_SHADOWMAP ) && NUM_DIR_LIGHT_SHADOWS > 0
	DirectionalLightShadow directionalLightShadow;
	#endif
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {
		directionalLight = directionalLights[ i ];
		getDirectionalLightInfo( directionalLight, directLight );
		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_DIR_LIGHT_SHADOWS )
		directionalLightShadow = directionalLightShadows[ i ];
		directLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( directionalShadowMap[ i ], directionalLightShadow.shadowMapSize, directionalLightShadow.shadowIntensity, directionalLightShadow.shadowBias, directionalLightShadow.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;
		#endif
		RE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );
	}
	#pragma unroll_loop_end
#endif
#if ( NUM_RECT_AREA_LIGHTS > 0 ) && defined( RE_Direct_RectArea )
	RectAreaLight rectAreaLight;
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {
		rectAreaLight = rectAreaLights[ i ];
		RE_Direct_RectArea( rectAreaLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );
	}
	#pragma unroll_loop_end
#endif
#if defined( RE_IndirectDiffuse )
	vec3 iblIrradiance = vec3( 0.0 );
	vec3 irradiance = getAmbientLightIrradiance( ambientLightColor );
	#if defined( USE_LIGHT_PROBES )
		irradiance += getLightProbeIrradiance( lightProbe, geometryNormal );
	#endif
	#if ( NUM_HEMI_LIGHTS > 0 )
		#pragma unroll_loop_start
		for ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {
			irradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometryNormal );
		}
		#pragma unroll_loop_end
	#endif
#endif
#if defined( RE_IndirectSpecular )
	vec3 radiance = vec3( 0.0 );
	vec3 clearcoatRadiance = vec3( 0.0 );
#endif`, Hf = `#if defined( RE_IndirectDiffuse )
	#ifdef USE_LIGHTMAP
		vec4 lightMapTexel = texture2D( lightMap, vLightMapUv );
		vec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;
		irradiance += lightMapIrradiance;
	#endif
	#if defined( USE_ENVMAP ) && defined( STANDARD ) && defined( ENVMAP_TYPE_CUBE_UV )
		iblIrradiance += getIBLIrradiance( geometryNormal );
	#endif
#endif
#if defined( USE_ENVMAP ) && defined( RE_IndirectSpecular )
	#ifdef USE_ANISOTROPY
		radiance += getIBLAnisotropyRadiance( geometryViewDir, geometryNormal, material.roughness, material.anisotropyB, material.anisotropy );
	#else
		radiance += getIBLRadiance( geometryViewDir, geometryNormal, material.roughness );
	#endif
	#ifdef USE_CLEARCOAT
		clearcoatRadiance += getIBLRadiance( geometryViewDir, geometryClearcoatNormal, material.clearcoatRoughness );
	#endif
#endif`, Wf = `#if defined( RE_IndirectDiffuse )
	RE_IndirectDiffuse( irradiance, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );
#endif
#if defined( RE_IndirectSpecular )
	RE_IndirectSpecular( radiance, iblIrradiance, clearcoatRadiance, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );
#endif`, Xf = `#if defined( USE_LOGARITHMIC_DEPTH_BUFFER )
	gl_FragDepth = vIsPerspective == 0.0 ? gl_FragCoord.z : log2( vFragDepth ) * logDepthBufFC * 0.5;
#endif`, qf = `#if defined( USE_LOGARITHMIC_DEPTH_BUFFER )
	uniform float logDepthBufFC;
	varying float vFragDepth;
	varying float vIsPerspective;
#endif`, Yf = `#ifdef USE_LOGARITHMIC_DEPTH_BUFFER
	varying float vFragDepth;
	varying float vIsPerspective;
#endif`, $f = `#ifdef USE_LOGARITHMIC_DEPTH_BUFFER
	vFragDepth = 1.0 + gl_Position.w;
	vIsPerspective = float( isPerspectiveMatrix( projectionMatrix ) );
#endif`, Kf = `#ifdef USE_MAP
	vec4 sampledDiffuseColor = texture2D( map, vMapUv );
	#ifdef DECODE_VIDEO_TEXTURE
		sampledDiffuseColor = sRGBTransferEOTF( sampledDiffuseColor );
	#endif
	diffuseColor *= sampledDiffuseColor;
#endif`, Zf = `#ifdef USE_MAP
	uniform sampler2D map;
#endif`, jf = `#if defined( USE_MAP ) || defined( USE_ALPHAMAP )
	#if defined( USE_POINTS_UV )
		vec2 uv = vUv;
	#else
		vec2 uv = ( uvTransform * vec3( gl_PointCoord.x, 1.0 - gl_PointCoord.y, 1 ) ).xy;
	#endif
#endif
#ifdef USE_MAP
	diffuseColor *= texture2D( map, uv );
#endif
#ifdef USE_ALPHAMAP
	diffuseColor.a *= texture2D( alphaMap, uv ).g;
#endif`, Jf = `#if defined( USE_POINTS_UV )
	varying vec2 vUv;
#else
	#if defined( USE_MAP ) || defined( USE_ALPHAMAP )
		uniform mat3 uvTransform;
	#endif
#endif
#ifdef USE_MAP
	uniform sampler2D map;
#endif
#ifdef USE_ALPHAMAP
	uniform sampler2D alphaMap;
#endif`, Qf = `float metalnessFactor = metalness;
#ifdef USE_METALNESSMAP
	vec4 texelMetalness = texture2D( metalnessMap, vMetalnessMapUv );
	metalnessFactor *= texelMetalness.b;
#endif`, ed = `#ifdef USE_METALNESSMAP
	uniform sampler2D metalnessMap;
#endif`, td = `#ifdef USE_INSTANCING_MORPH
	float morphTargetInfluences[ MORPHTARGETS_COUNT ];
	float morphTargetBaseInfluence = texelFetch( morphTexture, ivec2( 0, gl_InstanceID ), 0 ).r;
	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {
		morphTargetInfluences[i] =  texelFetch( morphTexture, ivec2( i + 1, gl_InstanceID ), 0 ).r;
	}
#endif`, nd = `#if defined( USE_MORPHCOLORS )
	vColor *= morphTargetBaseInfluence;
	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {
		#if defined( USE_COLOR_ALPHA )
			if ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ) * morphTargetInfluences[ i ];
		#elif defined( USE_COLOR )
			if ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ).rgb * morphTargetInfluences[ i ];
		#endif
	}
#endif`, id = `#ifdef USE_MORPHNORMALS
	objectNormal *= morphTargetBaseInfluence;
	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {
		if ( morphTargetInfluences[ i ] != 0.0 ) objectNormal += getMorph( gl_VertexID, i, 1 ).xyz * morphTargetInfluences[ i ];
	}
#endif`, rd = `#ifdef USE_MORPHTARGETS
	#ifndef USE_INSTANCING_MORPH
		uniform float morphTargetBaseInfluence;
		uniform float morphTargetInfluences[ MORPHTARGETS_COUNT ];
	#endif
	uniform sampler2DArray morphTargetsTexture;
	uniform ivec2 morphTargetsTextureSize;
	vec4 getMorph( const in int vertexIndex, const in int morphTargetIndex, const in int offset ) {
		int texelIndex = vertexIndex * MORPHTARGETS_TEXTURE_STRIDE + offset;
		int y = texelIndex / morphTargetsTextureSize.x;
		int x = texelIndex - y * morphTargetsTextureSize.x;
		ivec3 morphUV = ivec3( x, y, morphTargetIndex );
		return texelFetch( morphTargetsTexture, morphUV, 0 );
	}
#endif`, sd = `#ifdef USE_MORPHTARGETS
	transformed *= morphTargetBaseInfluence;
	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {
		if ( morphTargetInfluences[ i ] != 0.0 ) transformed += getMorph( gl_VertexID, i, 0 ).xyz * morphTargetInfluences[ i ];
	}
#endif`, ad = `float faceDirection = gl_FrontFacing ? 1.0 : - 1.0;
#ifdef FLAT_SHADED
	vec3 fdx = dFdx( vViewPosition );
	vec3 fdy = dFdy( vViewPosition );
	vec3 normal = normalize( cross( fdx, fdy ) );
#else
	vec3 normal = normalize( vNormal );
	#ifdef DOUBLE_SIDED
		normal *= faceDirection;
	#endif
#endif
#if defined( USE_NORMALMAP_TANGENTSPACE ) || defined( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY )
	#ifdef USE_TANGENT
		mat3 tbn = mat3( normalize( vTangent ), normalize( vBitangent ), normal );
	#else
		mat3 tbn = getTangentFrame( - vViewPosition, normal,
		#if defined( USE_NORMALMAP )
			vNormalMapUv
		#elif defined( USE_CLEARCOAT_NORMALMAP )
			vClearcoatNormalMapUv
		#else
			vUv
		#endif
		);
	#endif
	#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )
		tbn[0] *= faceDirection;
		tbn[1] *= faceDirection;
	#endif
#endif
#ifdef USE_CLEARCOAT_NORMALMAP
	#ifdef USE_TANGENT
		mat3 tbn2 = mat3( normalize( vTangent ), normalize( vBitangent ), normal );
	#else
		mat3 tbn2 = getTangentFrame( - vViewPosition, normal, vClearcoatNormalMapUv );
	#endif
	#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )
		tbn2[0] *= faceDirection;
		tbn2[1] *= faceDirection;
	#endif
#endif
vec3 nonPerturbedNormal = normal;`, od = `#ifdef USE_NORMALMAP_OBJECTSPACE
	normal = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;
	#ifdef FLIP_SIDED
		normal = - normal;
	#endif
	#ifdef DOUBLE_SIDED
		normal = normal * faceDirection;
	#endif
	normal = normalize( normalMatrix * normal );
#elif defined( USE_NORMALMAP_TANGENTSPACE )
	vec3 mapN = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;
	mapN.xy *= normalScale;
	normal = normalize( tbn * mapN );
#elif defined( USE_BUMPMAP )
	normal = perturbNormalArb( - vViewPosition, normal, dHdxy_fwd(), faceDirection );
#endif`, ld = `#ifndef FLAT_SHADED
	varying vec3 vNormal;
	#ifdef USE_TANGENT
		varying vec3 vTangent;
		varying vec3 vBitangent;
	#endif
#endif`, cd = `#ifndef FLAT_SHADED
	varying vec3 vNormal;
	#ifdef USE_TANGENT
		varying vec3 vTangent;
		varying vec3 vBitangent;
	#endif
#endif`, ud = `#ifndef FLAT_SHADED
	vNormal = normalize( transformedNormal );
	#ifdef USE_TANGENT
		vTangent = normalize( transformedTangent );
		vBitangent = normalize( cross( vNormal, vTangent ) * tangent.w );
	#endif
#endif`, hd = `#ifdef USE_NORMALMAP
	uniform sampler2D normalMap;
	uniform vec2 normalScale;
#endif
#ifdef USE_NORMALMAP_OBJECTSPACE
	uniform mat3 normalMatrix;
#endif
#if ! defined ( USE_TANGENT ) && ( defined ( USE_NORMALMAP_TANGENTSPACE ) || defined ( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY ) )
	mat3 getTangentFrame( vec3 eye_pos, vec3 surf_norm, vec2 uv ) {
		vec3 q0 = dFdx( eye_pos.xyz );
		vec3 q1 = dFdy( eye_pos.xyz );
		vec2 st0 = dFdx( uv.st );
		vec2 st1 = dFdy( uv.st );
		vec3 N = surf_norm;
		vec3 q1perp = cross( q1, N );
		vec3 q0perp = cross( N, q0 );
		vec3 T = q1perp * st0.x + q0perp * st1.x;
		vec3 B = q1perp * st0.y + q0perp * st1.y;
		float det = max( dot( T, T ), dot( B, B ) );
		float scale = ( det == 0.0 ) ? 0.0 : inversesqrt( det );
		return mat3( T * scale, B * scale, N );
	}
#endif`, fd = `#ifdef USE_CLEARCOAT
	vec3 clearcoatNormal = nonPerturbedNormal;
#endif`, dd = `#ifdef USE_CLEARCOAT_NORMALMAP
	vec3 clearcoatMapN = texture2D( clearcoatNormalMap, vClearcoatNormalMapUv ).xyz * 2.0 - 1.0;
	clearcoatMapN.xy *= clearcoatNormalScale;
	clearcoatNormal = normalize( tbn2 * clearcoatMapN );
#endif`, pd = `#ifdef USE_CLEARCOATMAP
	uniform sampler2D clearcoatMap;
#endif
#ifdef USE_CLEARCOAT_NORMALMAP
	uniform sampler2D clearcoatNormalMap;
	uniform vec2 clearcoatNormalScale;
#endif
#ifdef USE_CLEARCOAT_ROUGHNESSMAP
	uniform sampler2D clearcoatRoughnessMap;
#endif`, md = `#ifdef USE_IRIDESCENCEMAP
	uniform sampler2D iridescenceMap;
#endif
#ifdef USE_IRIDESCENCE_THICKNESSMAP
	uniform sampler2D iridescenceThicknessMap;
#endif`, _d = `#ifdef OPAQUE
diffuseColor.a = 1.0;
#endif
#ifdef USE_TRANSMISSION
diffuseColor.a *= material.transmissionAlpha;
#endif
gl_FragColor = vec4( outgoingLight, diffuseColor.a );`, gd = `vec3 packNormalToRGB( const in vec3 normal ) {
	return normalize( normal ) * 0.5 + 0.5;
}
vec3 unpackRGBToNormal( const in vec3 rgb ) {
	return 2.0 * rgb.xyz - 1.0;
}
const float PackUpscale = 256. / 255.;const float UnpackDownscale = 255. / 256.;const float ShiftRight8 = 1. / 256.;
const float Inv255 = 1. / 255.;
const vec4 PackFactors = vec4( 1.0, 256.0, 256.0 * 256.0, 256.0 * 256.0 * 256.0 );
const vec2 UnpackFactors2 = vec2( UnpackDownscale, 1.0 / PackFactors.g );
const vec3 UnpackFactors3 = vec3( UnpackDownscale / PackFactors.rg, 1.0 / PackFactors.b );
const vec4 UnpackFactors4 = vec4( UnpackDownscale / PackFactors.rgb, 1.0 / PackFactors.a );
vec4 packDepthToRGBA( const in float v ) {
	if( v <= 0.0 )
		return vec4( 0., 0., 0., 0. );
	if( v >= 1.0 )
		return vec4( 1., 1., 1., 1. );
	float vuf;
	float af = modf( v * PackFactors.a, vuf );
	float bf = modf( vuf * ShiftRight8, vuf );
	float gf = modf( vuf * ShiftRight8, vuf );
	return vec4( vuf * Inv255, gf * PackUpscale, bf * PackUpscale, af );
}
vec3 packDepthToRGB( const in float v ) {
	if( v <= 0.0 )
		return vec3( 0., 0., 0. );
	if( v >= 1.0 )
		return vec3( 1., 1., 1. );
	float vuf;
	float bf = modf( v * PackFactors.b, vuf );
	float gf = modf( vuf * ShiftRight8, vuf );
	return vec3( vuf * Inv255, gf * PackUpscale, bf );
}
vec2 packDepthToRG( const in float v ) {
	if( v <= 0.0 )
		return vec2( 0., 0. );
	if( v >= 1.0 )
		return vec2( 1., 1. );
	float vuf;
	float gf = modf( v * 256., vuf );
	return vec2( vuf * Inv255, gf );
}
float unpackRGBAToDepth( const in vec4 v ) {
	return dot( v, UnpackFactors4 );
}
float unpackRGBToDepth( const in vec3 v ) {
	return dot( v, UnpackFactors3 );
}
float unpackRGToDepth( const in vec2 v ) {
	return v.r * UnpackFactors2.r + v.g * UnpackFactors2.g;
}
vec4 pack2HalfToRGBA( const in vec2 v ) {
	vec4 r = vec4( v.x, fract( v.x * 255.0 ), v.y, fract( v.y * 255.0 ) );
	return vec4( r.x - r.y / 255.0, r.y, r.z - r.w / 255.0, r.w );
}
vec2 unpackRGBATo2Half( const in vec4 v ) {
	return vec2( v.x + ( v.y / 255.0 ), v.z + ( v.w / 255.0 ) );
}
float viewZToOrthographicDepth( const in float viewZ, const in float near, const in float far ) {
	return ( viewZ + near ) / ( near - far );
}
float orthographicDepthToViewZ( const in float depth, const in float near, const in float far ) {
	return depth * ( near - far ) - near;
}
float viewZToPerspectiveDepth( const in float viewZ, const in float near, const in float far ) {
	return ( ( near + viewZ ) * far ) / ( ( far - near ) * viewZ );
}
float perspectiveDepthToViewZ( const in float depth, const in float near, const in float far ) {
	return ( near * far ) / ( ( far - near ) * depth - far );
}`, vd = `#ifdef PREMULTIPLIED_ALPHA
	gl_FragColor.rgb *= gl_FragColor.a;
#endif`, xd = `vec4 mvPosition = vec4( transformed, 1.0 );
#ifdef USE_BATCHING
	mvPosition = batchingMatrix * mvPosition;
#endif
#ifdef USE_INSTANCING
	mvPosition = instanceMatrix * mvPosition;
#endif
mvPosition = modelViewMatrix * mvPosition;
gl_Position = projectionMatrix * mvPosition;`, Sd = `#ifdef DITHERING
	gl_FragColor.rgb = dithering( gl_FragColor.rgb );
#endif`, Md = `#ifdef DITHERING
	vec3 dithering( vec3 color ) {
		float grid_position = rand( gl_FragCoord.xy );
		vec3 dither_shift_RGB = vec3( 0.25 / 255.0, -0.25 / 255.0, 0.25 / 255.0 );
		dither_shift_RGB = mix( 2.0 * dither_shift_RGB, -2.0 * dither_shift_RGB, grid_position );
		return color + dither_shift_RGB;
	}
#endif`, yd = `float roughnessFactor = roughness;
#ifdef USE_ROUGHNESSMAP
	vec4 texelRoughness = texture2D( roughnessMap, vRoughnessMapUv );
	roughnessFactor *= texelRoughness.g;
#endif`, Ed = `#ifdef USE_ROUGHNESSMAP
	uniform sampler2D roughnessMap;
#endif`, Td = `#if NUM_SPOT_LIGHT_COORDS > 0
	varying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];
#endif
#if NUM_SPOT_LIGHT_MAPS > 0
	uniform sampler2D spotLightMap[ NUM_SPOT_LIGHT_MAPS ];
#endif
#ifdef USE_SHADOWMAP
	#if NUM_DIR_LIGHT_SHADOWS > 0
		#if defined( SHADOWMAP_TYPE_PCF )
			uniform sampler2DShadow directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];
		#else
			uniform sampler2D directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];
		#endif
		varying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];
		struct DirectionalLightShadow {
			float shadowIntensity;
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
		};
		uniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];
	#endif
	#if NUM_SPOT_LIGHT_SHADOWS > 0
		#if defined( SHADOWMAP_TYPE_PCF )
			uniform sampler2DShadow spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];
		#else
			uniform sampler2D spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];
		#endif
		struct SpotLightShadow {
			float shadowIntensity;
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
		};
		uniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];
	#endif
	#if NUM_POINT_LIGHT_SHADOWS > 0
		#if defined( SHADOWMAP_TYPE_PCF )
			uniform samplerCubeShadow pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];
		#elif defined( SHADOWMAP_TYPE_BASIC )
			uniform samplerCube pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];
		#endif
		varying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];
		struct PointLightShadow {
			float shadowIntensity;
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
			float shadowCameraNear;
			float shadowCameraFar;
		};
		uniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];
	#endif
	#if defined( SHADOWMAP_TYPE_PCF )
		float interleavedGradientNoise( vec2 position ) {
			return fract( 52.9829189 * fract( dot( position, vec2( 0.06711056, 0.00583715 ) ) ) );
		}
		vec2 vogelDiskSample( int sampleIndex, int samplesCount, float phi ) {
			const float goldenAngle = 2.399963229728653;
			float r = sqrt( ( float( sampleIndex ) + 0.5 ) / float( samplesCount ) );
			float theta = float( sampleIndex ) * goldenAngle + phi;
			return vec2( cos( theta ), sin( theta ) ) * r;
		}
	#endif
	#if defined( SHADOWMAP_TYPE_PCF )
		float getShadow( sampler2DShadow shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord ) {
			float shadow = 1.0;
			shadowCoord.xyz /= shadowCoord.w;
			shadowCoord.z += shadowBias;
			bool inFrustum = shadowCoord.x >= 0.0 && shadowCoord.x <= 1.0 && shadowCoord.y >= 0.0 && shadowCoord.y <= 1.0;
			bool frustumTest = inFrustum && shadowCoord.z <= 1.0;
			if ( frustumTest ) {
				vec2 texelSize = vec2( 1.0 ) / shadowMapSize;
				float radius = shadowRadius * texelSize.x;
				float phi = interleavedGradientNoise( gl_FragCoord.xy ) * 6.28318530718;
				shadow = (
					texture( shadowMap, vec3( shadowCoord.xy + vogelDiskSample( 0, 5, phi ) * radius, shadowCoord.z ) ) +
					texture( shadowMap, vec3( shadowCoord.xy + vogelDiskSample( 1, 5, phi ) * radius, shadowCoord.z ) ) +
					texture( shadowMap, vec3( shadowCoord.xy + vogelDiskSample( 2, 5, phi ) * radius, shadowCoord.z ) ) +
					texture( shadowMap, vec3( shadowCoord.xy + vogelDiskSample( 3, 5, phi ) * radius, shadowCoord.z ) ) +
					texture( shadowMap, vec3( shadowCoord.xy + vogelDiskSample( 4, 5, phi ) * radius, shadowCoord.z ) )
				) * 0.2;
			}
			return mix( 1.0, shadow, shadowIntensity );
		}
	#elif defined( SHADOWMAP_TYPE_VSM )
		float getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord ) {
			float shadow = 1.0;
			shadowCoord.xyz /= shadowCoord.w;
			shadowCoord.z += shadowBias;
			bool inFrustum = shadowCoord.x >= 0.0 && shadowCoord.x <= 1.0 && shadowCoord.y >= 0.0 && shadowCoord.y <= 1.0;
			bool frustumTest = inFrustum && shadowCoord.z <= 1.0;
			if ( frustumTest ) {
				vec2 distribution = texture2D( shadowMap, shadowCoord.xy ).rg;
				float mean = distribution.x;
				float variance = distribution.y * distribution.y;
				#ifdef USE_REVERSED_DEPTH_BUFFER
					float hard_shadow = step( mean, shadowCoord.z );
				#else
					float hard_shadow = step( shadowCoord.z, mean );
				#endif
				if ( hard_shadow == 1.0 ) {
					shadow = 1.0;
				} else {
					variance = max( variance, 0.0000001 );
					float d = shadowCoord.z - mean;
					float p_max = variance / ( variance + d * d );
					p_max = clamp( ( p_max - 0.3 ) / 0.65, 0.0, 1.0 );
					shadow = max( hard_shadow, p_max );
				}
			}
			return mix( 1.0, shadow, shadowIntensity );
		}
	#else
		float getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord ) {
			float shadow = 1.0;
			shadowCoord.xyz /= shadowCoord.w;
			shadowCoord.z += shadowBias;
			bool inFrustum = shadowCoord.x >= 0.0 && shadowCoord.x <= 1.0 && shadowCoord.y >= 0.0 && shadowCoord.y <= 1.0;
			bool frustumTest = inFrustum && shadowCoord.z <= 1.0;
			if ( frustumTest ) {
				float depth = texture2D( shadowMap, shadowCoord.xy ).r;
				#ifdef USE_REVERSED_DEPTH_BUFFER
					shadow = step( depth, shadowCoord.z );
				#else
					shadow = step( shadowCoord.z, depth );
				#endif
			}
			return mix( 1.0, shadow, shadowIntensity );
		}
	#endif
	#if NUM_POINT_LIGHT_SHADOWS > 0
	#if defined( SHADOWMAP_TYPE_PCF )
	float getPointShadow( samplerCubeShadow shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {
		float shadow = 1.0;
		vec3 lightToPosition = shadowCoord.xyz;
		vec3 bd3D = normalize( lightToPosition );
		vec3 absVec = abs( lightToPosition );
		float viewSpaceZ = max( max( absVec.x, absVec.y ), absVec.z );
		if ( viewSpaceZ - shadowCameraFar <= 0.0 && viewSpaceZ - shadowCameraNear >= 0.0 ) {
			float dp = ( shadowCameraFar * ( viewSpaceZ - shadowCameraNear ) ) / ( viewSpaceZ * ( shadowCameraFar - shadowCameraNear ) );
			dp += shadowBias;
			float texelSize = shadowRadius / shadowMapSize.x;
			vec3 absDir = abs( bd3D );
			vec3 tangent = absDir.x > absDir.z ? vec3( 0.0, 1.0, 0.0 ) : vec3( 1.0, 0.0, 0.0 );
			tangent = normalize( cross( bd3D, tangent ) );
			vec3 bitangent = cross( bd3D, tangent );
			float phi = interleavedGradientNoise( gl_FragCoord.xy ) * 6.28318530718;
			shadow = (
				texture( shadowMap, vec4( bd3D + ( tangent * vogelDiskSample( 0, 5, phi ).x + bitangent * vogelDiskSample( 0, 5, phi ).y ) * texelSize, dp ) ) +
				texture( shadowMap, vec4( bd3D + ( tangent * vogelDiskSample( 1, 5, phi ).x + bitangent * vogelDiskSample( 1, 5, phi ).y ) * texelSize, dp ) ) +
				texture( shadowMap, vec4( bd3D + ( tangent * vogelDiskSample( 2, 5, phi ).x + bitangent * vogelDiskSample( 2, 5, phi ).y ) * texelSize, dp ) ) +
				texture( shadowMap, vec4( bd3D + ( tangent * vogelDiskSample( 3, 5, phi ).x + bitangent * vogelDiskSample( 3, 5, phi ).y ) * texelSize, dp ) ) +
				texture( shadowMap, vec4( bd3D + ( tangent * vogelDiskSample( 4, 5, phi ).x + bitangent * vogelDiskSample( 4, 5, phi ).y ) * texelSize, dp ) )
			) * 0.2;
		}
		return mix( 1.0, shadow, shadowIntensity );
	}
	#elif defined( SHADOWMAP_TYPE_BASIC )
	float getPointShadow( samplerCube shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {
		float shadow = 1.0;
		vec3 lightToPosition = shadowCoord.xyz;
		vec3 bd3D = normalize( lightToPosition );
		vec3 absVec = abs( lightToPosition );
		float viewSpaceZ = max( max( absVec.x, absVec.y ), absVec.z );
		if ( viewSpaceZ - shadowCameraFar <= 0.0 && viewSpaceZ - shadowCameraNear >= 0.0 ) {
			float dp = ( shadowCameraFar * ( viewSpaceZ - shadowCameraNear ) ) / ( viewSpaceZ * ( shadowCameraFar - shadowCameraNear ) );
			dp += shadowBias;
			float depth = textureCube( shadowMap, bd3D ).r;
			#ifdef USE_REVERSED_DEPTH_BUFFER
				shadow = step( depth, dp );
			#else
				shadow = step( dp, depth );
			#endif
		}
		return mix( 1.0, shadow, shadowIntensity );
	}
	#endif
	#endif
#endif`, bd = `#if NUM_SPOT_LIGHT_COORDS > 0
	uniform mat4 spotLightMatrix[ NUM_SPOT_LIGHT_COORDS ];
	varying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];
#endif
#ifdef USE_SHADOWMAP
	#if NUM_DIR_LIGHT_SHADOWS > 0
		uniform mat4 directionalShadowMatrix[ NUM_DIR_LIGHT_SHADOWS ];
		varying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];
		struct DirectionalLightShadow {
			float shadowIntensity;
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
		};
		uniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];
	#endif
	#if NUM_SPOT_LIGHT_SHADOWS > 0
		struct SpotLightShadow {
			float shadowIntensity;
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
		};
		uniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];
	#endif
	#if NUM_POINT_LIGHT_SHADOWS > 0
		uniform mat4 pointShadowMatrix[ NUM_POINT_LIGHT_SHADOWS ];
		varying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];
		struct PointLightShadow {
			float shadowIntensity;
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
			float shadowCameraNear;
			float shadowCameraFar;
		};
		uniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];
	#endif
#endif`, Ad = `#if ( defined( USE_SHADOWMAP ) && ( NUM_DIR_LIGHT_SHADOWS > 0 || NUM_POINT_LIGHT_SHADOWS > 0 ) ) || ( NUM_SPOT_LIGHT_COORDS > 0 )
	vec3 shadowWorldNormal = inverseTransformDirection( transformedNormal, viewMatrix );
	vec4 shadowWorldPosition;
#endif
#if defined( USE_SHADOWMAP )
	#if NUM_DIR_LIGHT_SHADOWS > 0
		#pragma unroll_loop_start
		for ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {
			shadowWorldPosition = worldPosition + vec4( shadowWorldNormal * directionalLightShadows[ i ].shadowNormalBias, 0 );
			vDirectionalShadowCoord[ i ] = directionalShadowMatrix[ i ] * shadowWorldPosition;
		}
		#pragma unroll_loop_end
	#endif
	#if NUM_POINT_LIGHT_SHADOWS > 0
		#pragma unroll_loop_start
		for ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {
			shadowWorldPosition = worldPosition + vec4( shadowWorldNormal * pointLightShadows[ i ].shadowNormalBias, 0 );
			vPointShadowCoord[ i ] = pointShadowMatrix[ i ] * shadowWorldPosition;
		}
		#pragma unroll_loop_end
	#endif
#endif
#if NUM_SPOT_LIGHT_COORDS > 0
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_SPOT_LIGHT_COORDS; i ++ ) {
		shadowWorldPosition = worldPosition;
		#if ( defined( USE_SHADOWMAP ) && UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )
			shadowWorldPosition.xyz += shadowWorldNormal * spotLightShadows[ i ].shadowNormalBias;
		#endif
		vSpotLightCoord[ i ] = spotLightMatrix[ i ] * shadowWorldPosition;
	}
	#pragma unroll_loop_end
#endif`, wd = `float getShadowMask() {
	float shadow = 1.0;
	#ifdef USE_SHADOWMAP
	#if NUM_DIR_LIGHT_SHADOWS > 0
	DirectionalLightShadow directionalLight;
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {
		directionalLight = directionalLightShadows[ i ];
		shadow *= receiveShadow ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowIntensity, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;
	}
	#pragma unroll_loop_end
	#endif
	#if NUM_SPOT_LIGHT_SHADOWS > 0
	SpotLightShadow spotLight;
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {
		spotLight = spotLightShadows[ i ];
		shadow *= receiveShadow ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowIntensity, spotLight.shadowBias, spotLight.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;
	}
	#pragma unroll_loop_end
	#endif
	#if NUM_POINT_LIGHT_SHADOWS > 0 && ( defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_BASIC ) )
	PointLightShadow pointLight;
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {
		pointLight = pointLightShadows[ i ];
		shadow *= receiveShadow ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowIntensity, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ], pointLight.shadowCameraNear, pointLight.shadowCameraFar ) : 1.0;
	}
	#pragma unroll_loop_end
	#endif
	#endif
	return shadow;
}`, Rd = `#ifdef USE_SKINNING
	mat4 boneMatX = getBoneMatrix( skinIndex.x );
	mat4 boneMatY = getBoneMatrix( skinIndex.y );
	mat4 boneMatZ = getBoneMatrix( skinIndex.z );
	mat4 boneMatW = getBoneMatrix( skinIndex.w );
#endif`, Cd = `#ifdef USE_SKINNING
	uniform mat4 bindMatrix;
	uniform mat4 bindMatrixInverse;
	uniform highp sampler2D boneTexture;
	mat4 getBoneMatrix( const in float i ) {
		int size = textureSize( boneTexture, 0 ).x;
		int j = int( i ) * 4;
		int x = j % size;
		int y = j / size;
		vec4 v1 = texelFetch( boneTexture, ivec2( x, y ), 0 );
		vec4 v2 = texelFetch( boneTexture, ivec2( x + 1, y ), 0 );
		vec4 v3 = texelFetch( boneTexture, ivec2( x + 2, y ), 0 );
		vec4 v4 = texelFetch( boneTexture, ivec2( x + 3, y ), 0 );
		return mat4( v1, v2, v3, v4 );
	}
#endif`, Pd = `#ifdef USE_SKINNING
	vec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );
	vec4 skinned = vec4( 0.0 );
	skinned += boneMatX * skinVertex * skinWeight.x;
	skinned += boneMatY * skinVertex * skinWeight.y;
	skinned += boneMatZ * skinVertex * skinWeight.z;
	skinned += boneMatW * skinVertex * skinWeight.w;
	transformed = ( bindMatrixInverse * skinned ).xyz;
#endif`, Dd = `#ifdef USE_SKINNING
	mat4 skinMatrix = mat4( 0.0 );
	skinMatrix += skinWeight.x * boneMatX;
	skinMatrix += skinWeight.y * boneMatY;
	skinMatrix += skinWeight.z * boneMatZ;
	skinMatrix += skinWeight.w * boneMatW;
	skinMatrix = bindMatrixInverse * skinMatrix * bindMatrix;
	objectNormal = vec4( skinMatrix * vec4( objectNormal, 0.0 ) ).xyz;
	#ifdef USE_TANGENT
		objectTangent = vec4( skinMatrix * vec4( objectTangent, 0.0 ) ).xyz;
	#endif
#endif`, Ld = `float specularStrength;
#ifdef USE_SPECULARMAP
	vec4 texelSpecular = texture2D( specularMap, vSpecularMapUv );
	specularStrength = texelSpecular.r;
#else
	specularStrength = 1.0;
#endif`, Fd = `#ifdef USE_SPECULARMAP
	uniform sampler2D specularMap;
#endif`, Ud = `#if defined( TONE_MAPPING )
	gl_FragColor.rgb = toneMapping( gl_FragColor.rgb );
#endif`, Id = `#ifndef saturate
#define saturate( a ) clamp( a, 0.0, 1.0 )
#endif
uniform float toneMappingExposure;
vec3 LinearToneMapping( vec3 color ) {
	return saturate( toneMappingExposure * color );
}
vec3 ReinhardToneMapping( vec3 color ) {
	color *= toneMappingExposure;
	return saturate( color / ( vec3( 1.0 ) + color ) );
}
vec3 CineonToneMapping( vec3 color ) {
	color *= toneMappingExposure;
	color = max( vec3( 0.0 ), color - 0.004 );
	return pow( ( color * ( 6.2 * color + 0.5 ) ) / ( color * ( 6.2 * color + 1.7 ) + 0.06 ), vec3( 2.2 ) );
}
vec3 RRTAndODTFit( vec3 v ) {
	vec3 a = v * ( v + 0.0245786 ) - 0.000090537;
	vec3 b = v * ( 0.983729 * v + 0.4329510 ) + 0.238081;
	return a / b;
}
vec3 ACESFilmicToneMapping( vec3 color ) {
	const mat3 ACESInputMat = mat3(
		vec3( 0.59719, 0.07600, 0.02840 ),		vec3( 0.35458, 0.90834, 0.13383 ),
		vec3( 0.04823, 0.01566, 0.83777 )
	);
	const mat3 ACESOutputMat = mat3(
		vec3(  1.60475, -0.10208, -0.00327 ),		vec3( -0.53108,  1.10813, -0.07276 ),
		vec3( -0.07367, -0.00605,  1.07602 )
	);
	color *= toneMappingExposure / 0.6;
	color = ACESInputMat * color;
	color = RRTAndODTFit( color );
	color = ACESOutputMat * color;
	return saturate( color );
}
const mat3 LINEAR_REC2020_TO_LINEAR_SRGB = mat3(
	vec3( 1.6605, - 0.1246, - 0.0182 ),
	vec3( - 0.5876, 1.1329, - 0.1006 ),
	vec3( - 0.0728, - 0.0083, 1.1187 )
);
const mat3 LINEAR_SRGB_TO_LINEAR_REC2020 = mat3(
	vec3( 0.6274, 0.0691, 0.0164 ),
	vec3( 0.3293, 0.9195, 0.0880 ),
	vec3( 0.0433, 0.0113, 0.8956 )
);
vec3 agxDefaultContrastApprox( vec3 x ) {
	vec3 x2 = x * x;
	vec3 x4 = x2 * x2;
	return + 15.5 * x4 * x2
		- 40.14 * x4 * x
		+ 31.96 * x4
		- 6.868 * x2 * x
		+ 0.4298 * x2
		+ 0.1191 * x
		- 0.00232;
}
vec3 AgXToneMapping( vec3 color ) {
	const mat3 AgXInsetMatrix = mat3(
		vec3( 0.856627153315983, 0.137318972929847, 0.11189821299995 ),
		vec3( 0.0951212405381588, 0.761241990602591, 0.0767994186031903 ),
		vec3( 0.0482516061458583, 0.101439036467562, 0.811302368396859 )
	);
	const mat3 AgXOutsetMatrix = mat3(
		vec3( 1.1271005818144368, - 0.1413297634984383, - 0.14132976349843826 ),
		vec3( - 0.11060664309660323, 1.157823702216272, - 0.11060664309660294 ),
		vec3( - 0.016493938717834573, - 0.016493938717834257, 1.2519364065950405 )
	);
	const float AgxMinEv = - 12.47393;	const float AgxMaxEv = 4.026069;
	color *= toneMappingExposure;
	color = LINEAR_SRGB_TO_LINEAR_REC2020 * color;
	color = AgXInsetMatrix * color;
	color = max( color, 1e-10 );	color = log2( color );
	color = ( color - AgxMinEv ) / ( AgxMaxEv - AgxMinEv );
	color = clamp( color, 0.0, 1.0 );
	color = agxDefaultContrastApprox( color );
	color = AgXOutsetMatrix * color;
	color = pow( max( vec3( 0.0 ), color ), vec3( 2.2 ) );
	color = LINEAR_REC2020_TO_LINEAR_SRGB * color;
	color = clamp( color, 0.0, 1.0 );
	return color;
}
vec3 NeutralToneMapping( vec3 color ) {
	const float StartCompression = 0.8 - 0.04;
	const float Desaturation = 0.15;
	color *= toneMappingExposure;
	float x = min( color.r, min( color.g, color.b ) );
	float offset = x < 0.08 ? x - 6.25 * x * x : 0.04;
	color -= offset;
	float peak = max( color.r, max( color.g, color.b ) );
	if ( peak < StartCompression ) return color;
	float d = 1. - StartCompression;
	float newPeak = 1. - d * d / ( peak + d - StartCompression );
	color *= newPeak / peak;
	float g = 1. - 1. / ( Desaturation * ( peak - newPeak ) + 1. );
	return mix( color, vec3( newPeak ), g );
}
vec3 CustomToneMapping( vec3 color ) { return color; }`, Nd = `#ifdef USE_TRANSMISSION
	material.transmission = transmission;
	material.transmissionAlpha = 1.0;
	material.thickness = thickness;
	material.attenuationDistance = attenuationDistance;
	material.attenuationColor = attenuationColor;
	#ifdef USE_TRANSMISSIONMAP
		material.transmission *= texture2D( transmissionMap, vTransmissionMapUv ).r;
	#endif
	#ifdef USE_THICKNESSMAP
		material.thickness *= texture2D( thicknessMap, vThicknessMapUv ).g;
	#endif
	vec3 pos = vWorldPosition;
	vec3 v = normalize( cameraPosition - pos );
	vec3 n = inverseTransformDirection( normal, viewMatrix );
	vec4 transmitted = getIBLVolumeRefraction(
		n, v, material.roughness, material.diffuseContribution, material.specularColorBlended, material.specularF90,
		pos, modelMatrix, viewMatrix, projectionMatrix, material.dispersion, material.ior, material.thickness,
		material.attenuationColor, material.attenuationDistance );
	material.transmissionAlpha = mix( material.transmissionAlpha, transmitted.a, material.transmission );
	totalDiffuse = mix( totalDiffuse, transmitted.rgb, material.transmission );
#endif`, Od = `#ifdef USE_TRANSMISSION
	uniform float transmission;
	uniform float thickness;
	uniform float attenuationDistance;
	uniform vec3 attenuationColor;
	#ifdef USE_TRANSMISSIONMAP
		uniform sampler2D transmissionMap;
	#endif
	#ifdef USE_THICKNESSMAP
		uniform sampler2D thicknessMap;
	#endif
	uniform vec2 transmissionSamplerSize;
	uniform sampler2D transmissionSamplerMap;
	uniform mat4 modelMatrix;
	uniform mat4 projectionMatrix;
	varying vec3 vWorldPosition;
	float w0( float a ) {
		return ( 1.0 / 6.0 ) * ( a * ( a * ( - a + 3.0 ) - 3.0 ) + 1.0 );
	}
	float w1( float a ) {
		return ( 1.0 / 6.0 ) * ( a *  a * ( 3.0 * a - 6.0 ) + 4.0 );
	}
	float w2( float a ){
		return ( 1.0 / 6.0 ) * ( a * ( a * ( - 3.0 * a + 3.0 ) + 3.0 ) + 1.0 );
	}
	float w3( float a ) {
		return ( 1.0 / 6.0 ) * ( a * a * a );
	}
	float g0( float a ) {
		return w0( a ) + w1( a );
	}
	float g1( float a ) {
		return w2( a ) + w3( a );
	}
	float h0( float a ) {
		return - 1.0 + w1( a ) / ( w0( a ) + w1( a ) );
	}
	float h1( float a ) {
		return 1.0 + w3( a ) / ( w2( a ) + w3( a ) );
	}
	vec4 bicubic( sampler2D tex, vec2 uv, vec4 texelSize, float lod ) {
		uv = uv * texelSize.zw + 0.5;
		vec2 iuv = floor( uv );
		vec2 fuv = fract( uv );
		float g0x = g0( fuv.x );
		float g1x = g1( fuv.x );
		float h0x = h0( fuv.x );
		float h1x = h1( fuv.x );
		float h0y = h0( fuv.y );
		float h1y = h1( fuv.y );
		vec2 p0 = ( vec2( iuv.x + h0x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;
		vec2 p1 = ( vec2( iuv.x + h1x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;
		vec2 p2 = ( vec2( iuv.x + h0x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;
		vec2 p3 = ( vec2( iuv.x + h1x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;
		return g0( fuv.y ) * ( g0x * textureLod( tex, p0, lod ) + g1x * textureLod( tex, p1, lod ) ) +
			g1( fuv.y ) * ( g0x * textureLod( tex, p2, lod ) + g1x * textureLod( tex, p3, lod ) );
	}
	vec4 textureBicubic( sampler2D sampler, vec2 uv, float lod ) {
		vec2 fLodSize = vec2( textureSize( sampler, int( lod ) ) );
		vec2 cLodSize = vec2( textureSize( sampler, int( lod + 1.0 ) ) );
		vec2 fLodSizeInv = 1.0 / fLodSize;
		vec2 cLodSizeInv = 1.0 / cLodSize;
		vec4 fSample = bicubic( sampler, uv, vec4( fLodSizeInv, fLodSize ), floor( lod ) );
		vec4 cSample = bicubic( sampler, uv, vec4( cLodSizeInv, cLodSize ), ceil( lod ) );
		return mix( fSample, cSample, fract( lod ) );
	}
	vec3 getVolumeTransmissionRay( const in vec3 n, const in vec3 v, const in float thickness, const in float ior, const in mat4 modelMatrix ) {
		vec3 refractionVector = refract( - v, normalize( n ), 1.0 / ior );
		vec3 modelScale;
		modelScale.x = length( vec3( modelMatrix[ 0 ].xyz ) );
		modelScale.y = length( vec3( modelMatrix[ 1 ].xyz ) );
		modelScale.z = length( vec3( modelMatrix[ 2 ].xyz ) );
		return normalize( refractionVector ) * thickness * modelScale;
	}
	float applyIorToRoughness( const in float roughness, const in float ior ) {
		return roughness * clamp( ior * 2.0 - 2.0, 0.0, 1.0 );
	}
	vec4 getTransmissionSample( const in vec2 fragCoord, const in float roughness, const in float ior ) {
		float lod = log2( transmissionSamplerSize.x ) * applyIorToRoughness( roughness, ior );
		return textureBicubic( transmissionSamplerMap, fragCoord.xy, lod );
	}
	vec3 volumeAttenuation( const in float transmissionDistance, const in vec3 attenuationColor, const in float attenuationDistance ) {
		if ( isinf( attenuationDistance ) ) {
			return vec3( 1.0 );
		} else {
			vec3 attenuationCoefficient = -log( attenuationColor ) / attenuationDistance;
			vec3 transmittance = exp( - attenuationCoefficient * transmissionDistance );			return transmittance;
		}
	}
	vec4 getIBLVolumeRefraction( const in vec3 n, const in vec3 v, const in float roughness, const in vec3 diffuseColor,
		const in vec3 specularColor, const in float specularF90, const in vec3 position, const in mat4 modelMatrix,
		const in mat4 viewMatrix, const in mat4 projMatrix, const in float dispersion, const in float ior, const in float thickness,
		const in vec3 attenuationColor, const in float attenuationDistance ) {
		vec4 transmittedLight;
		vec3 transmittance;
		#ifdef USE_DISPERSION
			float halfSpread = ( ior - 1.0 ) * 0.025 * dispersion;
			vec3 iors = vec3( ior - halfSpread, ior, ior + halfSpread );
			for ( int i = 0; i < 3; i ++ ) {
				vec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, iors[ i ], modelMatrix );
				vec3 refractedRayExit = position + transmissionRay;
				vec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );
				vec2 refractionCoords = ndcPos.xy / ndcPos.w;
				refractionCoords += 1.0;
				refractionCoords /= 2.0;
				vec4 transmissionSample = getTransmissionSample( refractionCoords, roughness, iors[ i ] );
				transmittedLight[ i ] = transmissionSample[ i ];
				transmittedLight.a += transmissionSample.a;
				transmittance[ i ] = diffuseColor[ i ] * volumeAttenuation( length( transmissionRay ), attenuationColor, attenuationDistance )[ i ];
			}
			transmittedLight.a /= 3.0;
		#else
			vec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, ior, modelMatrix );
			vec3 refractedRayExit = position + transmissionRay;
			vec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );
			vec2 refractionCoords = ndcPos.xy / ndcPos.w;
			refractionCoords += 1.0;
			refractionCoords /= 2.0;
			transmittedLight = getTransmissionSample( refractionCoords, roughness, ior );
			transmittance = diffuseColor * volumeAttenuation( length( transmissionRay ), attenuationColor, attenuationDistance );
		#endif
		vec3 attenuatedColor = transmittance * transmittedLight.rgb;
		vec3 F = EnvironmentBRDF( n, v, specularColor, specularF90, roughness );
		float transmittanceFactor = ( transmittance.r + transmittance.g + transmittance.b ) / 3.0;
		return vec4( ( 1.0 - F ) * attenuatedColor, 1.0 - ( 1.0 - transmittedLight.a ) * transmittanceFactor );
	}
#endif`, Bd = `#if defined( USE_UV ) || defined( USE_ANISOTROPY )
	varying vec2 vUv;
#endif
#ifdef USE_MAP
	varying vec2 vMapUv;
#endif
#ifdef USE_ALPHAMAP
	varying vec2 vAlphaMapUv;
#endif
#ifdef USE_LIGHTMAP
	varying vec2 vLightMapUv;
#endif
#ifdef USE_AOMAP
	varying vec2 vAoMapUv;
#endif
#ifdef USE_BUMPMAP
	varying vec2 vBumpMapUv;
#endif
#ifdef USE_NORMALMAP
	varying vec2 vNormalMapUv;
#endif
#ifdef USE_EMISSIVEMAP
	varying vec2 vEmissiveMapUv;
#endif
#ifdef USE_METALNESSMAP
	varying vec2 vMetalnessMapUv;
#endif
#ifdef USE_ROUGHNESSMAP
	varying vec2 vRoughnessMapUv;
#endif
#ifdef USE_ANISOTROPYMAP
	varying vec2 vAnisotropyMapUv;
#endif
#ifdef USE_CLEARCOATMAP
	varying vec2 vClearcoatMapUv;
#endif
#ifdef USE_CLEARCOAT_NORMALMAP
	varying vec2 vClearcoatNormalMapUv;
#endif
#ifdef USE_CLEARCOAT_ROUGHNESSMAP
	varying vec2 vClearcoatRoughnessMapUv;
#endif
#ifdef USE_IRIDESCENCEMAP
	varying vec2 vIridescenceMapUv;
#endif
#ifdef USE_IRIDESCENCE_THICKNESSMAP
	varying vec2 vIridescenceThicknessMapUv;
#endif
#ifdef USE_SHEEN_COLORMAP
	varying vec2 vSheenColorMapUv;
#endif
#ifdef USE_SHEEN_ROUGHNESSMAP
	varying vec2 vSheenRoughnessMapUv;
#endif
#ifdef USE_SPECULARMAP
	varying vec2 vSpecularMapUv;
#endif
#ifdef USE_SPECULAR_COLORMAP
	varying vec2 vSpecularColorMapUv;
#endif
#ifdef USE_SPECULAR_INTENSITYMAP
	varying vec2 vSpecularIntensityMapUv;
#endif
#ifdef USE_TRANSMISSIONMAP
	uniform mat3 transmissionMapTransform;
	varying vec2 vTransmissionMapUv;
#endif
#ifdef USE_THICKNESSMAP
	uniform mat3 thicknessMapTransform;
	varying vec2 vThicknessMapUv;
#endif`, zd = `#if defined( USE_UV ) || defined( USE_ANISOTROPY )
	varying vec2 vUv;
#endif
#ifdef USE_MAP
	uniform mat3 mapTransform;
	varying vec2 vMapUv;
#endif
#ifdef USE_ALPHAMAP
	uniform mat3 alphaMapTransform;
	varying vec2 vAlphaMapUv;
#endif
#ifdef USE_LIGHTMAP
	uniform mat3 lightMapTransform;
	varying vec2 vLightMapUv;
#endif
#ifdef USE_AOMAP
	uniform mat3 aoMapTransform;
	varying vec2 vAoMapUv;
#endif
#ifdef USE_BUMPMAP
	uniform mat3 bumpMapTransform;
	varying vec2 vBumpMapUv;
#endif
#ifdef USE_NORMALMAP
	uniform mat3 normalMapTransform;
	varying vec2 vNormalMapUv;
#endif
#ifdef USE_DISPLACEMENTMAP
	uniform mat3 displacementMapTransform;
	varying vec2 vDisplacementMapUv;
#endif
#ifdef USE_EMISSIVEMAP
	uniform mat3 emissiveMapTransform;
	varying vec2 vEmissiveMapUv;
#endif
#ifdef USE_METALNESSMAP
	uniform mat3 metalnessMapTransform;
	varying vec2 vMetalnessMapUv;
#endif
#ifdef USE_ROUGHNESSMAP
	uniform mat3 roughnessMapTransform;
	varying vec2 vRoughnessMapUv;
#endif
#ifdef USE_ANISOTROPYMAP
	uniform mat3 anisotropyMapTransform;
	varying vec2 vAnisotropyMapUv;
#endif
#ifdef USE_CLEARCOATMAP
	uniform mat3 clearcoatMapTransform;
	varying vec2 vClearcoatMapUv;
#endif
#ifdef USE_CLEARCOAT_NORMALMAP
	uniform mat3 clearcoatNormalMapTransform;
	varying vec2 vClearcoatNormalMapUv;
#endif
#ifdef USE_CLEARCOAT_ROUGHNESSMAP
	uniform mat3 clearcoatRoughnessMapTransform;
	varying vec2 vClearcoatRoughnessMapUv;
#endif
#ifdef USE_SHEEN_COLORMAP
	uniform mat3 sheenColorMapTransform;
	varying vec2 vSheenColorMapUv;
#endif
#ifdef USE_SHEEN_ROUGHNESSMAP
	uniform mat3 sheenRoughnessMapTransform;
	varying vec2 vSheenRoughnessMapUv;
#endif
#ifdef USE_IRIDESCENCEMAP
	uniform mat3 iridescenceMapTransform;
	varying vec2 vIridescenceMapUv;
#endif
#ifdef USE_IRIDESCENCE_THICKNESSMAP
	uniform mat3 iridescenceThicknessMapTransform;
	varying vec2 vIridescenceThicknessMapUv;
#endif
#ifdef USE_SPECULARMAP
	uniform mat3 specularMapTransform;
	varying vec2 vSpecularMapUv;
#endif
#ifdef USE_SPECULAR_COLORMAP
	uniform mat3 specularColorMapTransform;
	varying vec2 vSpecularColorMapUv;
#endif
#ifdef USE_SPECULAR_INTENSITYMAP
	uniform mat3 specularIntensityMapTransform;
	varying vec2 vSpecularIntensityMapUv;
#endif
#ifdef USE_TRANSMISSIONMAP
	uniform mat3 transmissionMapTransform;
	varying vec2 vTransmissionMapUv;
#endif
#ifdef USE_THICKNESSMAP
	uniform mat3 thicknessMapTransform;
	varying vec2 vThicknessMapUv;
#endif`, Gd = `#if defined( USE_UV ) || defined( USE_ANISOTROPY )
	vUv = vec3( uv, 1 ).xy;
#endif
#ifdef USE_MAP
	vMapUv = ( mapTransform * vec3( MAP_UV, 1 ) ).xy;
#endif
#ifdef USE_ALPHAMAP
	vAlphaMapUv = ( alphaMapTransform * vec3( ALPHAMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_LIGHTMAP
	vLightMapUv = ( lightMapTransform * vec3( LIGHTMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_AOMAP
	vAoMapUv = ( aoMapTransform * vec3( AOMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_BUMPMAP
	vBumpMapUv = ( bumpMapTransform * vec3( BUMPMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_NORMALMAP
	vNormalMapUv = ( normalMapTransform * vec3( NORMALMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_DISPLACEMENTMAP
	vDisplacementMapUv = ( displacementMapTransform * vec3( DISPLACEMENTMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_EMISSIVEMAP
	vEmissiveMapUv = ( emissiveMapTransform * vec3( EMISSIVEMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_METALNESSMAP
	vMetalnessMapUv = ( metalnessMapTransform * vec3( METALNESSMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_ROUGHNESSMAP
	vRoughnessMapUv = ( roughnessMapTransform * vec3( ROUGHNESSMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_ANISOTROPYMAP
	vAnisotropyMapUv = ( anisotropyMapTransform * vec3( ANISOTROPYMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_CLEARCOATMAP
	vClearcoatMapUv = ( clearcoatMapTransform * vec3( CLEARCOATMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_CLEARCOAT_NORMALMAP
	vClearcoatNormalMapUv = ( clearcoatNormalMapTransform * vec3( CLEARCOAT_NORMALMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_CLEARCOAT_ROUGHNESSMAP
	vClearcoatRoughnessMapUv = ( clearcoatRoughnessMapTransform * vec3( CLEARCOAT_ROUGHNESSMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_IRIDESCENCEMAP
	vIridescenceMapUv = ( iridescenceMapTransform * vec3( IRIDESCENCEMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_IRIDESCENCE_THICKNESSMAP
	vIridescenceThicknessMapUv = ( iridescenceThicknessMapTransform * vec3( IRIDESCENCE_THICKNESSMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_SHEEN_COLORMAP
	vSheenColorMapUv = ( sheenColorMapTransform * vec3( SHEEN_COLORMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_SHEEN_ROUGHNESSMAP
	vSheenRoughnessMapUv = ( sheenRoughnessMapTransform * vec3( SHEEN_ROUGHNESSMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_SPECULARMAP
	vSpecularMapUv = ( specularMapTransform * vec3( SPECULARMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_SPECULAR_COLORMAP
	vSpecularColorMapUv = ( specularColorMapTransform * vec3( SPECULAR_COLORMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_SPECULAR_INTENSITYMAP
	vSpecularIntensityMapUv = ( specularIntensityMapTransform * vec3( SPECULAR_INTENSITYMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_TRANSMISSIONMAP
	vTransmissionMapUv = ( transmissionMapTransform * vec3( TRANSMISSIONMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_THICKNESSMAP
	vThicknessMapUv = ( thicknessMapTransform * vec3( THICKNESSMAP_UV, 1 ) ).xy;
#endif`, kd = `#if defined( USE_ENVMAP ) || defined( DISTANCE ) || defined ( USE_SHADOWMAP ) || defined ( USE_TRANSMISSION ) || NUM_SPOT_LIGHT_COORDS > 0
	vec4 worldPosition = vec4( transformed, 1.0 );
	#ifdef USE_BATCHING
		worldPosition = batchingMatrix * worldPosition;
	#endif
	#ifdef USE_INSTANCING
		worldPosition = instanceMatrix * worldPosition;
	#endif
	worldPosition = modelMatrix * worldPosition;
#endif`;
const Vd = `varying vec2 vUv;
uniform mat3 uvTransform;
void main() {
	vUv = ( uvTransform * vec3( uv, 1 ) ).xy;
	gl_Position = vec4( position.xy, 1.0, 1.0 );
}`, Hd = `uniform sampler2D t2D;
uniform float backgroundIntensity;
varying vec2 vUv;
void main() {
	vec4 texColor = texture2D( t2D, vUv );
	#ifdef DECODE_VIDEO_TEXTURE
		texColor = vec4( mix( pow( texColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), texColor.rgb * 0.0773993808, vec3( lessThanEqual( texColor.rgb, vec3( 0.04045 ) ) ) ), texColor.w );
	#endif
	texColor.rgb *= backgroundIntensity;
	gl_FragColor = texColor;
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
}`, Wd = `varying vec3 vWorldDirection;
#include <common>
void main() {
	vWorldDirection = transformDirection( position, modelMatrix );
	#include <begin_vertex>
	#include <project_vertex>
	gl_Position.z = gl_Position.w;
}`, Xd = `#ifdef ENVMAP_TYPE_CUBE
	uniform samplerCube envMap;
#elif defined( ENVMAP_TYPE_CUBE_UV )
	uniform sampler2D envMap;
#endif
uniform float flipEnvMap;
uniform float backgroundBlurriness;
uniform float backgroundIntensity;
uniform mat3 backgroundRotation;
varying vec3 vWorldDirection;
#include <cube_uv_reflection_fragment>
void main() {
	#ifdef ENVMAP_TYPE_CUBE
		vec4 texColor = textureCube( envMap, backgroundRotation * vec3( flipEnvMap * vWorldDirection.x, vWorldDirection.yz ) );
	#elif defined( ENVMAP_TYPE_CUBE_UV )
		vec4 texColor = textureCubeUV( envMap, backgroundRotation * vWorldDirection, backgroundBlurriness );
	#else
		vec4 texColor = vec4( 0.0, 0.0, 0.0, 1.0 );
	#endif
	texColor.rgb *= backgroundIntensity;
	gl_FragColor = texColor;
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
}`, qd = `varying vec3 vWorldDirection;
#include <common>
void main() {
	vWorldDirection = transformDirection( position, modelMatrix );
	#include <begin_vertex>
	#include <project_vertex>
	gl_Position.z = gl_Position.w;
}`, Yd = `uniform samplerCube tCube;
uniform float tFlip;
uniform float opacity;
varying vec3 vWorldDirection;
void main() {
	vec4 texColor = textureCube( tCube, vec3( tFlip * vWorldDirection.x, vWorldDirection.yz ) );
	gl_FragColor = texColor;
	gl_FragColor.a *= opacity;
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
}`, $d = `#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
varying vec2 vHighPrecisionZW;
void main() {
	#include <uv_vertex>
	#include <batching_vertex>
	#include <skinbase_vertex>
	#include <morphinstance_vertex>
	#ifdef USE_DISPLACEMENTMAP
		#include <beginnormal_vertex>
		#include <morphnormal_vertex>
		#include <skinnormal_vertex>
	#endif
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	vHighPrecisionZW = gl_Position.zw;
}`, Kd = `#if DEPTH_PACKING == 3200
	uniform float opacity;
#endif
#include <common>
#include <packing>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
varying vec2 vHighPrecisionZW;
void main() {
	vec4 diffuseColor = vec4( 1.0 );
	#include <clipping_planes_fragment>
	#if DEPTH_PACKING == 3200
		diffuseColor.a = opacity;
	#endif
	#include <map_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	#include <logdepthbuf_fragment>
	#ifdef USE_REVERSED_DEPTH_BUFFER
		float fragCoordZ = vHighPrecisionZW[ 0 ] / vHighPrecisionZW[ 1 ];
	#else
		float fragCoordZ = 0.5 * vHighPrecisionZW[ 0 ] / vHighPrecisionZW[ 1 ] + 0.5;
	#endif
	#if DEPTH_PACKING == 3200
		gl_FragColor = vec4( vec3( 1.0 - fragCoordZ ), opacity );
	#elif DEPTH_PACKING == 3201
		gl_FragColor = packDepthToRGBA( fragCoordZ );
	#elif DEPTH_PACKING == 3202
		gl_FragColor = vec4( packDepthToRGB( fragCoordZ ), 1.0 );
	#elif DEPTH_PACKING == 3203
		gl_FragColor = vec4( packDepthToRG( fragCoordZ ), 0.0, 1.0 );
	#endif
}`, Zd = `#define DISTANCE
varying vec3 vWorldPosition;
#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <batching_vertex>
	#include <skinbase_vertex>
	#include <morphinstance_vertex>
	#ifdef USE_DISPLACEMENTMAP
		#include <beginnormal_vertex>
		#include <morphnormal_vertex>
		#include <skinnormal_vertex>
	#endif
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <worldpos_vertex>
	#include <clipping_planes_vertex>
	vWorldPosition = worldPosition.xyz;
}`, jd = `#define DISTANCE
uniform vec3 referencePosition;
uniform float nearDistance;
uniform float farDistance;
varying vec3 vWorldPosition;
#include <common>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <clipping_planes_pars_fragment>
void main () {
	vec4 diffuseColor = vec4( 1.0 );
	#include <clipping_planes_fragment>
	#include <map_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	float dist = length( vWorldPosition - referencePosition );
	dist = ( dist - nearDistance ) / ( farDistance - nearDistance );
	dist = saturate( dist );
	gl_FragColor = vec4( dist, 0.0, 0.0, 1.0 );
}`, Jd = `varying vec3 vWorldDirection;
#include <common>
void main() {
	vWorldDirection = transformDirection( position, modelMatrix );
	#include <begin_vertex>
	#include <project_vertex>
}`, Qd = `uniform sampler2D tEquirect;
varying vec3 vWorldDirection;
#include <common>
void main() {
	vec3 direction = normalize( vWorldDirection );
	vec2 sampleUV = equirectUv( direction );
	gl_FragColor = texture2D( tEquirect, sampleUV );
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
}`, ep = `uniform float scale;
attribute float lineDistance;
varying float vLineDistance;
#include <common>
#include <uv_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <morphtarget_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	vLineDistance = scale * lineDistance;
	#include <uv_vertex>
	#include <color_vertex>
	#include <morphinstance_vertex>
	#include <morphcolor_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <fog_vertex>
}`, tp = `uniform vec3 diffuse;
uniform float opacity;
uniform float dashSize;
uniform float totalSize;
varying float vLineDistance;
#include <common>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <fog_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>
	if ( mod( vLineDistance, totalSize ) > dashSize ) {
		discard;
	}
	vec3 outgoingLight = vec3( 0.0 );
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	outgoingLight = diffuseColor.rgb;
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
}`, np = `#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <envmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <color_vertex>
	#include <morphinstance_vertex>
	#include <morphcolor_vertex>
	#include <batching_vertex>
	#if defined ( USE_ENVMAP ) || defined ( USE_SKINNING )
		#include <beginnormal_vertex>
		#include <morphnormal_vertex>
		#include <skinbase_vertex>
		#include <skinnormal_vertex>
		#include <defaultnormal_vertex>
	#endif
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <worldpos_vertex>
	#include <envmap_vertex>
	#include <fog_vertex>
}`, ip = `uniform vec3 diffuse;
uniform float opacity;
#ifndef FLAT_SHADED
	varying vec3 vNormal;
#endif
#include <common>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <envmap_common_pars_fragment>
#include <envmap_pars_fragment>
#include <fog_pars_fragment>
#include <specularmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	#include <specularmap_fragment>
	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
	#ifdef USE_LIGHTMAP
		vec4 lightMapTexel = texture2D( lightMap, vLightMapUv );
		reflectedLight.indirectDiffuse += lightMapTexel.rgb * lightMapIntensity * RECIPROCAL_PI;
	#else
		reflectedLight.indirectDiffuse += vec3( 1.0 );
	#endif
	#include <aomap_fragment>
	reflectedLight.indirectDiffuse *= diffuseColor.rgb;
	vec3 outgoingLight = reflectedLight.indirectDiffuse;
	#include <envmap_fragment>
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`, rp = `#define LAMBERT
varying vec3 vViewPosition;
#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <envmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <shadowmap_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <color_vertex>
	#include <morphinstance_vertex>
	#include <morphcolor_vertex>
	#include <batching_vertex>
	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	vViewPosition = - mvPosition.xyz;
	#include <worldpos_vertex>
	#include <envmap_vertex>
	#include <shadowmap_vertex>
	#include <fog_vertex>
}`, sp = `#define LAMBERT
uniform vec3 diffuse;
uniform vec3 emissive;
uniform float opacity;
#include <common>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <emissivemap_pars_fragment>
#include <envmap_common_pars_fragment>
#include <envmap_pars_fragment>
#include <fog_pars_fragment>
#include <bsdfs>
#include <lights_pars_begin>
#include <normal_pars_fragment>
#include <lights_lambert_pars_fragment>
#include <shadowmap_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <specularmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>
	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
	vec3 totalEmissiveRadiance = emissive;
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	#include <specularmap_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	#include <emissivemap_fragment>
	#include <lights_lambert_fragment>
	#include <lights_fragment_begin>
	#include <lights_fragment_maps>
	#include <lights_fragment_end>
	#include <aomap_fragment>
	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;
	#include <envmap_fragment>
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`, ap = `#define MATCAP
varying vec3 vViewPosition;
#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <color_pars_vertex>
#include <displacementmap_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <color_vertex>
	#include <morphinstance_vertex>
	#include <morphcolor_vertex>
	#include <batching_vertex>
	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <fog_vertex>
	vViewPosition = - mvPosition.xyz;
}`, op = `#define MATCAP
uniform vec3 diffuse;
uniform float opacity;
uniform sampler2D matcap;
varying vec3 vViewPosition;
#include <common>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <fog_pars_fragment>
#include <normal_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	vec3 viewDir = normalize( vViewPosition );
	vec3 x = normalize( vec3( viewDir.z, 0.0, - viewDir.x ) );
	vec3 y = cross( viewDir, x );
	vec2 uv = vec2( dot( x, normal ), dot( y, normal ) ) * 0.495 + 0.5;
	#ifdef USE_MATCAP
		vec4 matcapColor = texture2D( matcap, uv );
	#else
		vec4 matcapColor = vec4( vec3( mix( 0.2, 0.8, uv.y ) ), 1.0 );
	#endif
	vec3 outgoingLight = diffuseColor.rgb * matcapColor.rgb;
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`, lp = `#define NORMAL
#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )
	varying vec3 vViewPosition;
#endif
#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <batching_vertex>
	#include <beginnormal_vertex>
	#include <morphinstance_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )
	vViewPosition = - mvPosition.xyz;
#endif
}`, cp = `#define NORMAL
uniform float opacity;
#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )
	varying vec3 vViewPosition;
#endif
#include <uv_pars_fragment>
#include <normal_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( 0.0, 0.0, 0.0, opacity );
	#include <clipping_planes_fragment>
	#include <logdepthbuf_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	gl_FragColor = vec4( normalize( normal ) * 0.5 + 0.5, diffuseColor.a );
	#ifdef OPAQUE
		gl_FragColor.a = 1.0;
	#endif
}`, up = `#define PHONG
varying vec3 vViewPosition;
#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <envmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <shadowmap_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <color_vertex>
	#include <morphcolor_vertex>
	#include <batching_vertex>
	#include <beginnormal_vertex>
	#include <morphinstance_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	vViewPosition = - mvPosition.xyz;
	#include <worldpos_vertex>
	#include <envmap_vertex>
	#include <shadowmap_vertex>
	#include <fog_vertex>
}`, hp = `#define PHONG
uniform vec3 diffuse;
uniform vec3 emissive;
uniform vec3 specular;
uniform float shininess;
uniform float opacity;
#include <common>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <emissivemap_pars_fragment>
#include <envmap_common_pars_fragment>
#include <envmap_pars_fragment>
#include <fog_pars_fragment>
#include <bsdfs>
#include <lights_pars_begin>
#include <normal_pars_fragment>
#include <lights_phong_pars_fragment>
#include <shadowmap_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <specularmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>
	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
	vec3 totalEmissiveRadiance = emissive;
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	#include <specularmap_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	#include <emissivemap_fragment>
	#include <lights_phong_fragment>
	#include <lights_fragment_begin>
	#include <lights_fragment_maps>
	#include <lights_fragment_end>
	#include <aomap_fragment>
	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;
	#include <envmap_fragment>
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`, fp = `#define STANDARD
varying vec3 vViewPosition;
#ifdef USE_TRANSMISSION
	varying vec3 vWorldPosition;
#endif
#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <shadowmap_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <color_vertex>
	#include <morphinstance_vertex>
	#include <morphcolor_vertex>
	#include <batching_vertex>
	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	vViewPosition = - mvPosition.xyz;
	#include <worldpos_vertex>
	#include <shadowmap_vertex>
	#include <fog_vertex>
#ifdef USE_TRANSMISSION
	vWorldPosition = worldPosition.xyz;
#endif
}`, dp = `#define STANDARD
#ifdef PHYSICAL
	#define IOR
	#define USE_SPECULAR
#endif
uniform vec3 diffuse;
uniform vec3 emissive;
uniform float roughness;
uniform float metalness;
uniform float opacity;
#ifdef IOR
	uniform float ior;
#endif
#ifdef USE_SPECULAR
	uniform float specularIntensity;
	uniform vec3 specularColor;
	#ifdef USE_SPECULAR_COLORMAP
		uniform sampler2D specularColorMap;
	#endif
	#ifdef USE_SPECULAR_INTENSITYMAP
		uniform sampler2D specularIntensityMap;
	#endif
#endif
#ifdef USE_CLEARCOAT
	uniform float clearcoat;
	uniform float clearcoatRoughness;
#endif
#ifdef USE_DISPERSION
	uniform float dispersion;
#endif
#ifdef USE_IRIDESCENCE
	uniform float iridescence;
	uniform float iridescenceIOR;
	uniform float iridescenceThicknessMinimum;
	uniform float iridescenceThicknessMaximum;
#endif
#ifdef USE_SHEEN
	uniform vec3 sheenColor;
	uniform float sheenRoughness;
	#ifdef USE_SHEEN_COLORMAP
		uniform sampler2D sheenColorMap;
	#endif
	#ifdef USE_SHEEN_ROUGHNESSMAP
		uniform sampler2D sheenRoughnessMap;
	#endif
#endif
#ifdef USE_ANISOTROPY
	uniform vec2 anisotropyVector;
	#ifdef USE_ANISOTROPYMAP
		uniform sampler2D anisotropyMap;
	#endif
#endif
varying vec3 vViewPosition;
#include <common>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <emissivemap_pars_fragment>
#include <iridescence_fragment>
#include <cube_uv_reflection_fragment>
#include <envmap_common_pars_fragment>
#include <envmap_physical_pars_fragment>
#include <fog_pars_fragment>
#include <lights_pars_begin>
#include <normal_pars_fragment>
#include <lights_physical_pars_fragment>
#include <transmission_pars_fragment>
#include <shadowmap_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <clearcoat_pars_fragment>
#include <iridescence_pars_fragment>
#include <roughnessmap_pars_fragment>
#include <metalnessmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>
	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
	vec3 totalEmissiveRadiance = emissive;
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	#include <roughnessmap_fragment>
	#include <metalnessmap_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	#include <clearcoat_normal_fragment_begin>
	#include <clearcoat_normal_fragment_maps>
	#include <emissivemap_fragment>
	#include <lights_physical_fragment>
	#include <lights_fragment_begin>
	#include <lights_fragment_maps>
	#include <lights_fragment_end>
	#include <aomap_fragment>
	vec3 totalDiffuse = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse;
	vec3 totalSpecular = reflectedLight.directSpecular + reflectedLight.indirectSpecular;
	#include <transmission_fragment>
	vec3 outgoingLight = totalDiffuse + totalSpecular + totalEmissiveRadiance;
	#ifdef USE_SHEEN
 
		outgoingLight = outgoingLight + sheenSpecularDirect + sheenSpecularIndirect;
 
 	#endif
	#ifdef USE_CLEARCOAT
		float dotNVcc = saturate( dot( geometryClearcoatNormal, geometryViewDir ) );
		vec3 Fcc = F_Schlick( material.clearcoatF0, material.clearcoatF90, dotNVcc );
		outgoingLight = outgoingLight * ( 1.0 - material.clearcoat * Fcc ) + ( clearcoatSpecularDirect + clearcoatSpecularIndirect ) * material.clearcoat;
	#endif
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`, pp = `#define TOON
varying vec3 vViewPosition;
#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <shadowmap_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <color_vertex>
	#include <morphinstance_vertex>
	#include <morphcolor_vertex>
	#include <batching_vertex>
	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	vViewPosition = - mvPosition.xyz;
	#include <worldpos_vertex>
	#include <shadowmap_vertex>
	#include <fog_vertex>
}`, mp = `#define TOON
uniform vec3 diffuse;
uniform vec3 emissive;
uniform float opacity;
#include <common>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <emissivemap_pars_fragment>
#include <gradientmap_pars_fragment>
#include <fog_pars_fragment>
#include <bsdfs>
#include <lights_pars_begin>
#include <normal_pars_fragment>
#include <lights_toon_pars_fragment>
#include <shadowmap_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>
	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
	vec3 totalEmissiveRadiance = emissive;
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	#include <emissivemap_fragment>
	#include <lights_toon_fragment>
	#include <lights_fragment_begin>
	#include <lights_fragment_maps>
	#include <lights_fragment_end>
	#include <aomap_fragment>
	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`, _p = `uniform float size;
uniform float scale;
#include <common>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <morphtarget_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
#ifdef USE_POINTS_UV
	varying vec2 vUv;
	uniform mat3 uvTransform;
#endif
void main() {
	#ifdef USE_POINTS_UV
		vUv = ( uvTransform * vec3( uv, 1 ) ).xy;
	#endif
	#include <color_vertex>
	#include <morphinstance_vertex>
	#include <morphcolor_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <project_vertex>
	gl_PointSize = size;
	#ifdef USE_SIZEATTENUATION
		bool isPerspective = isPerspectiveMatrix( projectionMatrix );
		if ( isPerspective ) gl_PointSize *= ( scale / - mvPosition.z );
	#endif
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <worldpos_vertex>
	#include <fog_vertex>
}`, gp = `uniform vec3 diffuse;
uniform float opacity;
#include <common>
#include <color_pars_fragment>
#include <map_particle_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <fog_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>
	vec3 outgoingLight = vec3( 0.0 );
	#include <logdepthbuf_fragment>
	#include <map_particle_fragment>
	#include <color_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	outgoingLight = diffuseColor.rgb;
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
}`, vp = `#include <common>
#include <batching_pars_vertex>
#include <fog_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <shadowmap_pars_vertex>
void main() {
	#include <batching_vertex>
	#include <beginnormal_vertex>
	#include <morphinstance_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <worldpos_vertex>
	#include <shadowmap_vertex>
	#include <fog_vertex>
}`, xp = `uniform vec3 color;
uniform float opacity;
#include <common>
#include <fog_pars_fragment>
#include <bsdfs>
#include <lights_pars_begin>
#include <logdepthbuf_pars_fragment>
#include <shadowmap_pars_fragment>
#include <shadowmask_pars_fragment>
void main() {
	#include <logdepthbuf_fragment>
	gl_FragColor = vec4( color, opacity * ( 1.0 - getShadowMask() ) );
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
}`, Sp = `uniform float rotation;
uniform vec2 center;
#include <common>
#include <uv_pars_vertex>
#include <fog_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	vec4 mvPosition = modelViewMatrix[ 3 ];
	vec2 scale = vec2( length( modelMatrix[ 0 ].xyz ), length( modelMatrix[ 1 ].xyz ) );
	#ifndef USE_SIZEATTENUATION
		bool isPerspective = isPerspectiveMatrix( projectionMatrix );
		if ( isPerspective ) scale *= - mvPosition.z;
	#endif
	vec2 alignedPosition = ( position.xy - ( center - vec2( 0.5 ) ) ) * scale;
	vec2 rotatedPosition;
	rotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;
	rotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;
	mvPosition.xy += rotatedPosition;
	gl_Position = projectionMatrix * mvPosition;
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <fog_vertex>
}`, Mp = `uniform vec3 diffuse;
uniform float opacity;
#include <common>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <fog_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>
	vec3 outgoingLight = vec3( 0.0 );
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	outgoingLight = diffuseColor.rgb;
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
}`, Ie = {
  alphahash_fragment: Vh,
  alphahash_pars_fragment: Hh,
  alphamap_fragment: Wh,
  alphamap_pars_fragment: Xh,
  alphatest_fragment: qh,
  alphatest_pars_fragment: Yh,
  aomap_fragment: $h,
  aomap_pars_fragment: Kh,
  batching_pars_vertex: Zh,
  batching_vertex: jh,
  begin_vertex: Jh,
  beginnormal_vertex: Qh,
  bsdfs: ef,
  iridescence_fragment: tf,
  bumpmap_pars_fragment: nf,
  clipping_planes_fragment: rf,
  clipping_planes_pars_fragment: sf,
  clipping_planes_pars_vertex: af,
  clipping_planes_vertex: of,
  color_fragment: lf,
  color_pars_fragment: cf,
  color_pars_vertex: uf,
  color_vertex: hf,
  common: ff,
  cube_uv_reflection_fragment: df,
  defaultnormal_vertex: pf,
  displacementmap_pars_vertex: mf,
  displacementmap_vertex: _f,
  emissivemap_fragment: gf,
  emissivemap_pars_fragment: vf,
  colorspace_fragment: xf,
  colorspace_pars_fragment: Sf,
  envmap_fragment: Mf,
  envmap_common_pars_fragment: yf,
  envmap_pars_fragment: Ef,
  envmap_pars_vertex: Tf,
  envmap_physical_pars_fragment: If,
  envmap_vertex: bf,
  fog_vertex: Af,
  fog_pars_vertex: wf,
  fog_fragment: Rf,
  fog_pars_fragment: Cf,
  gradientmap_pars_fragment: Pf,
  lightmap_pars_fragment: Df,
  lights_lambert_fragment: Lf,
  lights_lambert_pars_fragment: Ff,
  lights_pars_begin: Uf,
  lights_toon_fragment: Nf,
  lights_toon_pars_fragment: Of,
  lights_phong_fragment: Bf,
  lights_phong_pars_fragment: zf,
  lights_physical_fragment: Gf,
  lights_physical_pars_fragment: kf,
  lights_fragment_begin: Vf,
  lights_fragment_maps: Hf,
  lights_fragment_end: Wf,
  logdepthbuf_fragment: Xf,
  logdepthbuf_pars_fragment: qf,
  logdepthbuf_pars_vertex: Yf,
  logdepthbuf_vertex: $f,
  map_fragment: Kf,
  map_pars_fragment: Zf,
  map_particle_fragment: jf,
  map_particle_pars_fragment: Jf,
  metalnessmap_fragment: Qf,
  metalnessmap_pars_fragment: ed,
  morphinstance_vertex: td,
  morphcolor_vertex: nd,
  morphnormal_vertex: id,
  morphtarget_pars_vertex: rd,
  morphtarget_vertex: sd,
  normal_fragment_begin: ad,
  normal_fragment_maps: od,
  normal_pars_fragment: ld,
  normal_pars_vertex: cd,
  normal_vertex: ud,
  normalmap_pars_fragment: hd,
  clearcoat_normal_fragment_begin: fd,
  clearcoat_normal_fragment_maps: dd,
  clearcoat_pars_fragment: pd,
  iridescence_pars_fragment: md,
  opaque_fragment: _d,
  packing: gd,
  premultiplied_alpha_fragment: vd,
  project_vertex: xd,
  dithering_fragment: Sd,
  dithering_pars_fragment: Md,
  roughnessmap_fragment: yd,
  roughnessmap_pars_fragment: Ed,
  shadowmap_pars_fragment: Td,
  shadowmap_pars_vertex: bd,
  shadowmap_vertex: Ad,
  shadowmask_pars_fragment: wd,
  skinbase_vertex: Rd,
  skinning_pars_vertex: Cd,
  skinning_vertex: Pd,
  skinnormal_vertex: Dd,
  specularmap_fragment: Ld,
  specularmap_pars_fragment: Fd,
  tonemapping_fragment: Ud,
  tonemapping_pars_fragment: Id,
  transmission_fragment: Nd,
  transmission_pars_fragment: Od,
  uv_pars_fragment: Bd,
  uv_pars_vertex: zd,
  uv_vertex: Gd,
  worldpos_vertex: kd,
  background_vert: Vd,
  background_frag: Hd,
  backgroundCube_vert: Wd,
  backgroundCube_frag: Xd,
  cube_vert: qd,
  cube_frag: Yd,
  depth_vert: $d,
  depth_frag: Kd,
  distance_vert: Zd,
  distance_frag: jd,
  equirect_vert: Jd,
  equirect_frag: Qd,
  linedashed_vert: ep,
  linedashed_frag: tp,
  meshbasic_vert: np,
  meshbasic_frag: ip,
  meshlambert_vert: rp,
  meshlambert_frag: sp,
  meshmatcap_vert: ap,
  meshmatcap_frag: op,
  meshnormal_vert: lp,
  meshnormal_frag: cp,
  meshphong_vert: up,
  meshphong_frag: hp,
  meshphysical_vert: fp,
  meshphysical_frag: dp,
  meshtoon_vert: pp,
  meshtoon_frag: mp,
  points_vert: _p,
  points_frag: gp,
  shadow_vert: vp,
  shadow_frag: xp,
  sprite_vert: Sp,
  sprite_frag: Mp
}, ce = {
  common: {
    diffuse: { value: /* @__PURE__ */ new Ge(16777215) },
    opacity: { value: 1 },
    map: { value: null },
    mapTransform: { value: /* @__PURE__ */ new Ue() },
    alphaMap: { value: null },
    alphaMapTransform: { value: /* @__PURE__ */ new Ue() },
    alphaTest: { value: 0 }
  },
  specularmap: {
    specularMap: { value: null },
    specularMapTransform: { value: /* @__PURE__ */ new Ue() }
  },
  envmap: {
    envMap: { value: null },
    envMapRotation: { value: /* @__PURE__ */ new Ue() },
    flipEnvMap: { value: -1 },
    reflectivity: { value: 1 },
    // basic, lambert, phong
    ior: { value: 1.5 },
    // physical
    refractionRatio: { value: 0.98 },
    // basic, lambert, phong
    dfgLUT: { value: null }
    // DFG LUT for physically-based rendering
  },
  aomap: {
    aoMap: { value: null },
    aoMapIntensity: { value: 1 },
    aoMapTransform: { value: /* @__PURE__ */ new Ue() }
  },
  lightmap: {
    lightMap: { value: null },
    lightMapIntensity: { value: 1 },
    lightMapTransform: { value: /* @__PURE__ */ new Ue() }
  },
  bumpmap: {
    bumpMap: { value: null },
    bumpMapTransform: { value: /* @__PURE__ */ new Ue() },
    bumpScale: { value: 1 }
  },
  normalmap: {
    normalMap: { value: null },
    normalMapTransform: { value: /* @__PURE__ */ new Ue() },
    normalScale: { value: /* @__PURE__ */ new Ae(1, 1) }
  },
  displacementmap: {
    displacementMap: { value: null },
    displacementMapTransform: { value: /* @__PURE__ */ new Ue() },
    displacementScale: { value: 1 },
    displacementBias: { value: 0 }
  },
  emissivemap: {
    emissiveMap: { value: null },
    emissiveMapTransform: { value: /* @__PURE__ */ new Ue() }
  },
  metalnessmap: {
    metalnessMap: { value: null },
    metalnessMapTransform: { value: /* @__PURE__ */ new Ue() }
  },
  roughnessmap: {
    roughnessMap: { value: null },
    roughnessMapTransform: { value: /* @__PURE__ */ new Ue() }
  },
  gradientmap: {
    gradientMap: { value: null }
  },
  fog: {
    fogDensity: { value: 25e-5 },
    fogNear: { value: 1 },
    fogFar: { value: 2e3 },
    fogColor: { value: /* @__PURE__ */ new Ge(16777215) }
  },
  lights: {
    ambientLightColor: { value: [] },
    lightProbe: { value: [] },
    directionalLights: { value: [], properties: {
      direction: {},
      color: {}
    } },
    directionalLightShadows: { value: [], properties: {
      shadowIntensity: 1,
      shadowBias: {},
      shadowNormalBias: {},
      shadowRadius: {},
      shadowMapSize: {}
    } },
    directionalShadowMap: { value: [] },
    directionalShadowMatrix: { value: [] },
    spotLights: { value: [], properties: {
      color: {},
      position: {},
      direction: {},
      distance: {},
      coneCos: {},
      penumbraCos: {},
      decay: {}
    } },
    spotLightShadows: { value: [], properties: {
      shadowIntensity: 1,
      shadowBias: {},
      shadowNormalBias: {},
      shadowRadius: {},
      shadowMapSize: {}
    } },
    spotLightMap: { value: [] },
    spotShadowMap: { value: [] },
    spotLightMatrix: { value: [] },
    pointLights: { value: [], properties: {
      color: {},
      position: {},
      decay: {},
      distance: {}
    } },
    pointLightShadows: { value: [], properties: {
      shadowIntensity: 1,
      shadowBias: {},
      shadowNormalBias: {},
      shadowRadius: {},
      shadowMapSize: {},
      shadowCameraNear: {},
      shadowCameraFar: {}
    } },
    pointShadowMap: { value: [] },
    pointShadowMatrix: { value: [] },
    hemisphereLights: { value: [], properties: {
      direction: {},
      skyColor: {},
      groundColor: {}
    } },
    // TODO (abelnation): RectAreaLight BRDF data needs to be moved from example to main src
    rectAreaLights: { value: [], properties: {
      color: {},
      position: {},
      width: {},
      height: {}
    } },
    ltc_1: { value: null },
    ltc_2: { value: null }
  },
  points: {
    diffuse: { value: /* @__PURE__ */ new Ge(16777215) },
    opacity: { value: 1 },
    size: { value: 1 },
    scale: { value: 1 },
    map: { value: null },
    alphaMap: { value: null },
    alphaMapTransform: { value: /* @__PURE__ */ new Ue() },
    alphaTest: { value: 0 },
    uvTransform: { value: /* @__PURE__ */ new Ue() }
  },
  sprite: {
    diffuse: { value: /* @__PURE__ */ new Ge(16777215) },
    opacity: { value: 1 },
    center: { value: /* @__PURE__ */ new Ae(0.5, 0.5) },
    rotation: { value: 0 },
    map: { value: null },
    mapTransform: { value: /* @__PURE__ */ new Ue() },
    alphaMap: { value: null },
    alphaMapTransform: { value: /* @__PURE__ */ new Ue() },
    alphaTest: { value: 0 }
  }
}, An = {
  basic: {
    uniforms: /* @__PURE__ */ Vt([
      ce.common,
      ce.specularmap,
      ce.envmap,
      ce.aomap,
      ce.lightmap,
      ce.fog
    ]),
    vertexShader: Ie.meshbasic_vert,
    fragmentShader: Ie.meshbasic_frag
  },
  lambert: {
    uniforms: /* @__PURE__ */ Vt([
      ce.common,
      ce.specularmap,
      ce.envmap,
      ce.aomap,
      ce.lightmap,
      ce.emissivemap,
      ce.bumpmap,
      ce.normalmap,
      ce.displacementmap,
      ce.fog,
      ce.lights,
      {
        emissive: { value: /* @__PURE__ */ new Ge(0) }
      }
    ]),
    vertexShader: Ie.meshlambert_vert,
    fragmentShader: Ie.meshlambert_frag
  },
  phong: {
    uniforms: /* @__PURE__ */ Vt([
      ce.common,
      ce.specularmap,
      ce.envmap,
      ce.aomap,
      ce.lightmap,
      ce.emissivemap,
      ce.bumpmap,
      ce.normalmap,
      ce.displacementmap,
      ce.fog,
      ce.lights,
      {
        emissive: { value: /* @__PURE__ */ new Ge(0) },
        specular: { value: /* @__PURE__ */ new Ge(1118481) },
        shininess: { value: 30 }
      }
    ]),
    vertexShader: Ie.meshphong_vert,
    fragmentShader: Ie.meshphong_frag
  },
  standard: {
    uniforms: /* @__PURE__ */ Vt([
      ce.common,
      ce.envmap,
      ce.aomap,
      ce.lightmap,
      ce.emissivemap,
      ce.bumpmap,
      ce.normalmap,
      ce.displacementmap,
      ce.roughnessmap,
      ce.metalnessmap,
      ce.fog,
      ce.lights,
      {
        emissive: { value: /* @__PURE__ */ new Ge(0) },
        roughness: { value: 1 },
        metalness: { value: 0 },
        envMapIntensity: { value: 1 }
      }
    ]),
    vertexShader: Ie.meshphysical_vert,
    fragmentShader: Ie.meshphysical_frag
  },
  toon: {
    uniforms: /* @__PURE__ */ Vt([
      ce.common,
      ce.aomap,
      ce.lightmap,
      ce.emissivemap,
      ce.bumpmap,
      ce.normalmap,
      ce.displacementmap,
      ce.gradientmap,
      ce.fog,
      ce.lights,
      {
        emissive: { value: /* @__PURE__ */ new Ge(0) }
      }
    ]),
    vertexShader: Ie.meshtoon_vert,
    fragmentShader: Ie.meshtoon_frag
  },
  matcap: {
    uniforms: /* @__PURE__ */ Vt([
      ce.common,
      ce.bumpmap,
      ce.normalmap,
      ce.displacementmap,
      ce.fog,
      {
        matcap: { value: null }
      }
    ]),
    vertexShader: Ie.meshmatcap_vert,
    fragmentShader: Ie.meshmatcap_frag
  },
  points: {
    uniforms: /* @__PURE__ */ Vt([
      ce.points,
      ce.fog
    ]),
    vertexShader: Ie.points_vert,
    fragmentShader: Ie.points_frag
  },
  dashed: {
    uniforms: /* @__PURE__ */ Vt([
      ce.common,
      ce.fog,
      {
        scale: { value: 1 },
        dashSize: { value: 1 },
        totalSize: { value: 2 }
      }
    ]),
    vertexShader: Ie.linedashed_vert,
    fragmentShader: Ie.linedashed_frag
  },
  depth: {
    uniforms: /* @__PURE__ */ Vt([
      ce.common,
      ce.displacementmap
    ]),
    vertexShader: Ie.depth_vert,
    fragmentShader: Ie.depth_frag
  },
  normal: {
    uniforms: /* @__PURE__ */ Vt([
      ce.common,
      ce.bumpmap,
      ce.normalmap,
      ce.displacementmap,
      {
        opacity: { value: 1 }
      }
    ]),
    vertexShader: Ie.meshnormal_vert,
    fragmentShader: Ie.meshnormal_frag
  },
  sprite: {
    uniforms: /* @__PURE__ */ Vt([
      ce.sprite,
      ce.fog
    ]),
    vertexShader: Ie.sprite_vert,
    fragmentShader: Ie.sprite_frag
  },
  background: {
    uniforms: {
      uvTransform: { value: /* @__PURE__ */ new Ue() },
      t2D: { value: null },
      backgroundIntensity: { value: 1 }
    },
    vertexShader: Ie.background_vert,
    fragmentShader: Ie.background_frag
  },
  backgroundCube: {
    uniforms: {
      envMap: { value: null },
      flipEnvMap: { value: -1 },
      backgroundBlurriness: { value: 0 },
      backgroundIntensity: { value: 1 },
      backgroundRotation: { value: /* @__PURE__ */ new Ue() }
    },
    vertexShader: Ie.backgroundCube_vert,
    fragmentShader: Ie.backgroundCube_frag
  },
  cube: {
    uniforms: {
      tCube: { value: null },
      tFlip: { value: -1 },
      opacity: { value: 1 }
    },
    vertexShader: Ie.cube_vert,
    fragmentShader: Ie.cube_frag
  },
  equirect: {
    uniforms: {
      tEquirect: { value: null }
    },
    vertexShader: Ie.equirect_vert,
    fragmentShader: Ie.equirect_frag
  },
  distance: {
    uniforms: /* @__PURE__ */ Vt([
      ce.common,
      ce.displacementmap,
      {
        referencePosition: { value: /* @__PURE__ */ new I() },
        nearDistance: { value: 1 },
        farDistance: { value: 1e3 }
      }
    ]),
    vertexShader: Ie.distance_vert,
    fragmentShader: Ie.distance_frag
  },
  shadow: {
    uniforms: /* @__PURE__ */ Vt([
      ce.lights,
      ce.fog,
      {
        color: { value: /* @__PURE__ */ new Ge(0) },
        opacity: { value: 1 }
      }
    ]),
    vertexShader: Ie.shadow_vert,
    fragmentShader: Ie.shadow_frag
  }
};
An.physical = {
  uniforms: /* @__PURE__ */ Vt([
    An.standard.uniforms,
    {
      clearcoat: { value: 0 },
      clearcoatMap: { value: null },
      clearcoatMapTransform: { value: /* @__PURE__ */ new Ue() },
      clearcoatNormalMap: { value: null },
      clearcoatNormalMapTransform: { value: /* @__PURE__ */ new Ue() },
      clearcoatNormalScale: { value: /* @__PURE__ */ new Ae(1, 1) },
      clearcoatRoughness: { value: 0 },
      clearcoatRoughnessMap: { value: null },
      clearcoatRoughnessMapTransform: { value: /* @__PURE__ */ new Ue() },
      dispersion: { value: 0 },
      iridescence: { value: 0 },
      iridescenceMap: { value: null },
      iridescenceMapTransform: { value: /* @__PURE__ */ new Ue() },
      iridescenceIOR: { value: 1.3 },
      iridescenceThicknessMinimum: { value: 100 },
      iridescenceThicknessMaximum: { value: 400 },
      iridescenceThicknessMap: { value: null },
      iridescenceThicknessMapTransform: { value: /* @__PURE__ */ new Ue() },
      sheen: { value: 0 },
      sheenColor: { value: /* @__PURE__ */ new Ge(0) },
      sheenColorMap: { value: null },
      sheenColorMapTransform: { value: /* @__PURE__ */ new Ue() },
      sheenRoughness: { value: 1 },
      sheenRoughnessMap: { value: null },
      sheenRoughnessMapTransform: { value: /* @__PURE__ */ new Ue() },
      transmission: { value: 0 },
      transmissionMap: { value: null },
      transmissionMapTransform: { value: /* @__PURE__ */ new Ue() },
      transmissionSamplerSize: { value: /* @__PURE__ */ new Ae() },
      transmissionSamplerMap: { value: null },
      thickness: { value: 0 },
      thicknessMap: { value: null },
      thicknessMapTransform: { value: /* @__PURE__ */ new Ue() },
      attenuationDistance: { value: 0 },
      attenuationColor: { value: /* @__PURE__ */ new Ge(0) },
      specularColor: { value: /* @__PURE__ */ new Ge(1, 1, 1) },
      specularColorMap: { value: null },
      specularColorMapTransform: { value: /* @__PURE__ */ new Ue() },
      specularIntensity: { value: 1 },
      specularIntensityMap: { value: null },
      specularIntensityMapTransform: { value: /* @__PURE__ */ new Ue() },
      anisotropyVector: { value: /* @__PURE__ */ new Ae() },
      anisotropyMap: { value: null },
      anisotropyMapTransform: { value: /* @__PURE__ */ new Ue() }
    }
  ]),
  vertexShader: Ie.meshphysical_vert,
  fragmentShader: Ie.meshphysical_frag
};
const ys = { r: 0, b: 0, g: 0 }, pi = /* @__PURE__ */ new Vn(), yp = /* @__PURE__ */ new ht();
function Ep(r, e, t, n, i, s, a) {
  const o = new Ge(0);
  let c = s === !0 ? 0 : 1, l, u, h = null, f = 0, d = null;
  function g(b) {
    let T = b.isScene === !0 ? b.background : null;
    return T && T.isTexture && (T = (b.backgroundBlurriness > 0 ? t : e).get(T)), T;
  }
  function _(b) {
    let T = !1;
    const y = g(b);
    y === null ? p(o, c) : y && y.isColor && (p(y, 1), T = !0);
    const R = r.xr.getEnvironmentBlendMode();
    R === "additive" ? n.buffers.color.setClear(0, 0, 0, 1, a) : R === "alpha-blend" && n.buffers.color.setClear(0, 0, 0, 0, a), (r.autoClear || T) && (n.buffers.depth.setTest(!0), n.buffers.depth.setMask(!0), n.buffers.color.setMask(!0), r.clear(r.autoClearColor, r.autoClearDepth, r.autoClearStencil));
  }
  function m(b, T) {
    const y = g(T);
    y && (y.isCubeTexture || y.mapping === 306) ? (u === void 0 && (u = new Lt(
      new $r(1, 1, 1),
      new Ht({
        name: "BackgroundCubeMaterial",
        uniforms: nr(An.backgroundCube.uniforms),
        vertexShader: An.backgroundCube.vertexShader,
        fragmentShader: An.backgroundCube.fragmentShader,
        side: 1,
        depthTest: !1,
        depthWrite: !1,
        fog: !1,
        allowOverride: !1
      })
    ), u.geometry.deleteAttribute("normal"), u.geometry.deleteAttribute("uv"), u.onBeforeRender = function(R, A, C) {
      this.matrixWorld.copyPosition(C.matrixWorld);
    }, Object.defineProperty(u.material, "envMap", {
      get: function() {
        return this.uniforms.envMap.value;
      }
    }), i.update(u)), pi.copy(T.backgroundRotation), pi.x *= -1, pi.y *= -1, pi.z *= -1, y.isCubeTexture && y.isRenderTargetTexture === !1 && (pi.y *= -1, pi.z *= -1), u.material.uniforms.envMap.value = y, u.material.uniforms.flipEnvMap.value = y.isCubeTexture && y.isRenderTargetTexture === !1 ? -1 : 1, u.material.uniforms.backgroundBlurriness.value = T.backgroundBlurriness, u.material.uniforms.backgroundIntensity.value = T.backgroundIntensity, u.material.uniforms.backgroundRotation.value.setFromMatrix4(yp.makeRotationFromEuler(pi)), u.material.toneMapped = qe.getTransfer(y.colorSpace) !== Qe, (h !== y || f !== y.version || d !== r.toneMapping) && (u.material.needsUpdate = !0, h = y, f = y.version, d = r.toneMapping), u.layers.enableAll(), b.unshift(u, u.geometry, u.material, 0, 0, null)) : y && y.isTexture && (l === void 0 && (l = new Lt(
      new _n(2, 2),
      new Ht({
        name: "BackgroundMaterial",
        uniforms: nr(An.background.uniforms),
        vertexShader: An.background.vertexShader,
        fragmentShader: An.background.fragmentShader,
        side: 0,
        depthTest: !1,
        depthWrite: !1,
        fog: !1,
        allowOverride: !1
      })
    ), l.geometry.deleteAttribute("normal"), Object.defineProperty(l.material, "map", {
      get: function() {
        return this.uniforms.t2D.value;
      }
    }), i.update(l)), l.material.uniforms.t2D.value = y, l.material.uniforms.backgroundIntensity.value = T.backgroundIntensity, l.material.toneMapped = qe.getTransfer(y.colorSpace) !== Qe, y.matrixAutoUpdate === !0 && y.updateMatrix(), l.material.uniforms.uvTransform.value.copy(y.matrix), (h !== y || f !== y.version || d !== r.toneMapping) && (l.material.needsUpdate = !0, h = y, f = y.version, d = r.toneMapping), l.layers.enableAll(), b.unshift(l, l.geometry, l.material, 0, 0, null));
  }
  function p(b, T) {
    b.getRGB(ys, hc(r)), n.buffers.color.setClear(ys.r, ys.g, ys.b, T, a);
  }
  function S() {
    u !== void 0 && (u.geometry.dispose(), u.material.dispose(), u = void 0), l !== void 0 && (l.geometry.dispose(), l.material.dispose(), l = void 0);
  }
  return {
    getClearColor: function() {
      return o;
    },
    setClearColor: function(b, T = 1) {
      o.set(b), c = T, p(o, c);
    },
    getClearAlpha: function() {
      return c;
    },
    setClearAlpha: function(b) {
      c = b, p(o, c);
    },
    render: _,
    addToRenderList: m,
    dispose: S
  };
}
function Tp(r, e) {
  const t = r.getParameter(r.MAX_VERTEX_ATTRIBS), n = {}, i = f(null);
  let s = i, a = !1;
  function o(E, P, z, N, W) {
    let H = !1;
    const k = h(N, z, P);
    s !== k && (s = k, l(s.object)), H = d(E, N, z, W), H && g(E, N, z, W), W !== null && e.update(W, r.ELEMENT_ARRAY_BUFFER), (H || a) && (a = !1, T(E, P, z, N), W !== null && r.bindBuffer(r.ELEMENT_ARRAY_BUFFER, e.get(W).buffer));
  }
  function c() {
    return r.createVertexArray();
  }
  function l(E) {
    return r.bindVertexArray(E);
  }
  function u(E) {
    return r.deleteVertexArray(E);
  }
  function h(E, P, z) {
    const N = z.wireframe === !0;
    let W = n[E.id];
    W === void 0 && (W = {}, n[E.id] = W);
    let H = W[P.id];
    H === void 0 && (H = {}, W[P.id] = H);
    let k = H[N];
    return k === void 0 && (k = f(c()), H[N] = k), k;
  }
  function f(E) {
    const P = [], z = [], N = [];
    for (let W = 0; W < t; W++)
      P[W] = 0, z[W] = 0, N[W] = 0;
    return {
      // for backward compatibility on non-VAO support browser
      geometry: null,
      program: null,
      wireframe: !1,
      newAttributes: P,
      enabledAttributes: z,
      attributeDivisors: N,
      object: E,
      attributes: {},
      index: null
    };
  }
  function d(E, P, z, N) {
    const W = s.attributes, H = P.attributes;
    let k = 0;
    const O = z.getAttributes();
    for (const Y in O)
      if (O[Y].location >= 0) {
        const ne = W[Y];
        let ue = H[Y];
        if (ue === void 0 && (Y === "instanceMatrix" && E.instanceMatrix && (ue = E.instanceMatrix), Y === "instanceColor" && E.instanceColor && (ue = E.instanceColor)), ne === void 0 || ne.attribute !== ue || ue && ne.data !== ue.data) return !0;
        k++;
      }
    return s.attributesNum !== k || s.index !== N;
  }
  function g(E, P, z, N) {
    const W = {}, H = P.attributes;
    let k = 0;
    const O = z.getAttributes();
    for (const Y in O)
      if (O[Y].location >= 0) {
        let ne = H[Y];
        ne === void 0 && (Y === "instanceMatrix" && E.instanceMatrix && (ne = E.instanceMatrix), Y === "instanceColor" && E.instanceColor && (ne = E.instanceColor));
        const ue = {};
        ue.attribute = ne, ne && ne.data && (ue.data = ne.data), W[Y] = ue, k++;
      }
    s.attributes = W, s.attributesNum = k, s.index = N;
  }
  function _() {
    const E = s.newAttributes;
    for (let P = 0, z = E.length; P < z; P++)
      E[P] = 0;
  }
  function m(E) {
    p(E, 0);
  }
  function p(E, P) {
    const z = s.newAttributes, N = s.enabledAttributes, W = s.attributeDivisors;
    z[E] = 1, N[E] === 0 && (r.enableVertexAttribArray(E), N[E] = 1), W[E] !== P && (r.vertexAttribDivisor(E, P), W[E] = P);
  }
  function S() {
    const E = s.newAttributes, P = s.enabledAttributes;
    for (let z = 0, N = P.length; z < N; z++)
      P[z] !== E[z] && (r.disableVertexAttribArray(z), P[z] = 0);
  }
  function b(E, P, z, N, W, H, k) {
    k === !0 ? r.vertexAttribIPointer(E, P, z, W, H) : r.vertexAttribPointer(E, P, z, N, W, H);
  }
  function T(E, P, z, N) {
    _();
    const W = N.attributes, H = z.getAttributes(), k = P.defaultAttributeValues;
    for (const O in H) {
      const Y = H[O];
      if (Y.location >= 0) {
        let ae = W[O];
        if (ae === void 0 && (O === "instanceMatrix" && E.instanceMatrix && (ae = E.instanceMatrix), O === "instanceColor" && E.instanceColor && (ae = E.instanceColor)), ae !== void 0) {
          const ne = ae.normalized, ue = ae.itemSize, Pe = e.get(ae);
          if (Pe === void 0) continue;
          const Le = Pe.buffer, Ve = Pe.type, He = Pe.bytesPerElement, $ = Ve === r.INT || Ve === r.UNSIGNED_INT || ae.gpuType === 1013;
          if (ae.isInterleavedBufferAttribute) {
            const J = ae.data, me = J.stride, Fe = ae.offset;
            if (J.isInstancedInterleavedBuffer) {
              for (let ve = 0; ve < Y.locationSize; ve++)
                p(Y.location + ve, J.meshPerAttribute);
              E.isInstancedMesh !== !0 && N._maxInstanceCount === void 0 && (N._maxInstanceCount = J.meshPerAttribute * J.count);
            } else
              for (let ve = 0; ve < Y.locationSize; ve++)
                m(Y.location + ve);
            r.bindBuffer(r.ARRAY_BUFFER, Le);
            for (let ve = 0; ve < Y.locationSize; ve++)
              b(
                Y.location + ve,
                ue / Y.locationSize,
                Ve,
                ne,
                me * He,
                (Fe + ue / Y.locationSize * ve) * He,
                $
              );
          } else {
            if (ae.isInstancedBufferAttribute) {
              for (let J = 0; J < Y.locationSize; J++)
                p(Y.location + J, ae.meshPerAttribute);
              E.isInstancedMesh !== !0 && N._maxInstanceCount === void 0 && (N._maxInstanceCount = ae.meshPerAttribute * ae.count);
            } else
              for (let J = 0; J < Y.locationSize; J++)
                m(Y.location + J);
            r.bindBuffer(r.ARRAY_BUFFER, Le);
            for (let J = 0; J < Y.locationSize; J++)
              b(
                Y.location + J,
                ue / Y.locationSize,
                Ve,
                ne,
                ue * He,
                ue / Y.locationSize * J * He,
                $
              );
          }
        } else if (k !== void 0) {
          const ne = k[O];
          if (ne !== void 0)
            switch (ne.length) {
              case 2:
                r.vertexAttrib2fv(Y.location, ne);
                break;
              case 3:
                r.vertexAttrib3fv(Y.location, ne);
                break;
              case 4:
                r.vertexAttrib4fv(Y.location, ne);
                break;
              default:
                r.vertexAttrib1fv(Y.location, ne);
            }
        }
      }
    }
    S();
  }
  function y() {
    C();
    for (const E in n) {
      const P = n[E];
      for (const z in P) {
        const N = P[z];
        for (const W in N)
          u(N[W].object), delete N[W];
        delete P[z];
      }
      delete n[E];
    }
  }
  function R(E) {
    if (n[E.id] === void 0) return;
    const P = n[E.id];
    for (const z in P) {
      const N = P[z];
      for (const W in N)
        u(N[W].object), delete N[W];
      delete P[z];
    }
    delete n[E.id];
  }
  function A(E) {
    for (const P in n) {
      const z = n[P];
      if (z[E.id] === void 0) continue;
      const N = z[E.id];
      for (const W in N)
        u(N[W].object), delete N[W];
      delete z[E.id];
    }
  }
  function C() {
    x(), a = !0, s !== i && (s = i, l(s.object));
  }
  function x() {
    i.geometry = null, i.program = null, i.wireframe = !1;
  }
  return {
    setup: o,
    reset: C,
    resetDefaultState: x,
    dispose: y,
    releaseStatesOfGeometry: R,
    releaseStatesOfProgram: A,
    initAttributes: _,
    enableAttribute: m,
    disableUnusedAttributes: S
  };
}
function bp(r, e, t) {
  let n;
  function i(l) {
    n = l;
  }
  function s(l, u) {
    r.drawArrays(n, l, u), t.update(u, n, 1);
  }
  function a(l, u, h) {
    h !== 0 && (r.drawArraysInstanced(n, l, u, h), t.update(u, n, h));
  }
  function o(l, u, h) {
    if (h === 0) return;
    e.get("WEBGL_multi_draw").multiDrawArraysWEBGL(n, l, 0, u, 0, h);
    let d = 0;
    for (let g = 0; g < h; g++)
      d += u[g];
    t.update(d, n, 1);
  }
  function c(l, u, h, f) {
    if (h === 0) return;
    const d = e.get("WEBGL_multi_draw");
    if (d === null)
      for (let g = 0; g < l.length; g++)
        a(l[g], u[g], f[g]);
    else {
      d.multiDrawArraysInstancedWEBGL(n, l, 0, u, 0, f, 0, h);
      let g = 0;
      for (let _ = 0; _ < h; _++)
        g += u[_] * f[_];
      t.update(g, n, 1);
    }
  }
  this.setMode = i, this.render = s, this.renderInstances = a, this.renderMultiDraw = o, this.renderMultiDrawInstances = c;
}
function Ap(r, e, t, n) {
  let i;
  function s() {
    if (i !== void 0) return i;
    if (e.has("EXT_texture_filter_anisotropic") === !0) {
      const A = e.get("EXT_texture_filter_anisotropic");
      i = r.getParameter(A.MAX_TEXTURE_MAX_ANISOTROPY_EXT);
    } else
      i = 0;
    return i;
  }
  function a(A) {
    return !(A !== 1023 && n.convert(A) !== r.getParameter(r.IMPLEMENTATION_COLOR_READ_FORMAT));
  }
  function o(A) {
    const C = A === 1016 && (e.has("EXT_color_buffer_half_float") || e.has("EXT_color_buffer_float"));
    return !(A !== 1009 && n.convert(A) !== r.getParameter(r.IMPLEMENTATION_COLOR_READ_TYPE) && // Edge and Chrome Mac < 52 (#9513)
    A !== 1015 && !C);
  }
  function c(A) {
    if (A === "highp") {
      if (r.getShaderPrecisionFormat(r.VERTEX_SHADER, r.HIGH_FLOAT).precision > 0 && r.getShaderPrecisionFormat(r.FRAGMENT_SHADER, r.HIGH_FLOAT).precision > 0)
        return "highp";
      A = "mediump";
    }
    return A === "mediump" && r.getShaderPrecisionFormat(r.VERTEX_SHADER, r.MEDIUM_FLOAT).precision > 0 && r.getShaderPrecisionFormat(r.FRAGMENT_SHADER, r.MEDIUM_FLOAT).precision > 0 ? "mediump" : "lowp";
  }
  let l = t.precision !== void 0 ? t.precision : "highp";
  const u = c(l);
  u !== l && (Ce("WebGLRenderer:", l, "not supported, using", u, "instead."), l = u);
  const h = t.logarithmicDepthBuffer === !0, f = t.reversedDepthBuffer === !0 && e.has("EXT_clip_control"), d = r.getParameter(r.MAX_TEXTURE_IMAGE_UNITS), g = r.getParameter(r.MAX_VERTEX_TEXTURE_IMAGE_UNITS), _ = r.getParameter(r.MAX_TEXTURE_SIZE), m = r.getParameter(r.MAX_CUBE_MAP_TEXTURE_SIZE), p = r.getParameter(r.MAX_VERTEX_ATTRIBS), S = r.getParameter(r.MAX_VERTEX_UNIFORM_VECTORS), b = r.getParameter(r.MAX_VARYING_VECTORS), T = r.getParameter(r.MAX_FRAGMENT_UNIFORM_VECTORS), y = r.getParameter(r.MAX_SAMPLES), R = r.getParameter(r.SAMPLES);
  return {
    isWebGL2: !0,
    // keeping this for backwards compatibility
    getMaxAnisotropy: s,
    getMaxPrecision: c,
    textureFormatReadable: a,
    textureTypeReadable: o,
    precision: l,
    logarithmicDepthBuffer: h,
    reversedDepthBuffer: f,
    maxTextures: d,
    maxVertexTextures: g,
    maxTextureSize: _,
    maxCubemapSize: m,
    maxAttributes: p,
    maxVertexUniforms: S,
    maxVaryings: b,
    maxFragmentUniforms: T,
    maxSamples: y,
    samples: R
  };
}
function wp(r) {
  const e = this;
  let t = null, n = 0, i = !1, s = !1;
  const a = new vi(), o = new Ue(), c = { value: null, needsUpdate: !1 };
  this.uniform = c, this.numPlanes = 0, this.numIntersection = 0, this.init = function(h, f) {
    const d = h.length !== 0 || f || // enable state of previous frame - the clipping code has to
    // run another frame in order to reset the state:
    n !== 0 || i;
    return i = f, n = h.length, d;
  }, this.beginShadows = function() {
    s = !0, u(null);
  }, this.endShadows = function() {
    s = !1;
  }, this.setGlobalState = function(h, f) {
    t = u(h, f, 0);
  }, this.setState = function(h, f, d) {
    const g = h.clippingPlanes, _ = h.clipIntersection, m = h.clipShadows, p = r.get(h);
    if (!i || g === null || g.length === 0 || s && !m)
      s ? u(null) : l();
    else {
      const S = s ? 0 : n, b = S * 4;
      let T = p.clippingState || null;
      c.value = T, T = u(g, f, b, d);
      for (let y = 0; y !== b; ++y)
        T[y] = t[y];
      p.clippingState = T, this.numIntersection = _ ? this.numPlanes : 0, this.numPlanes += S;
    }
  };
  function l() {
    c.value !== t && (c.value = t, c.needsUpdate = n > 0), e.numPlanes = n, e.numIntersection = 0;
  }
  function u(h, f, d, g) {
    const _ = h !== null ? h.length : 0;
    let m = null;
    if (_ !== 0) {
      if (m = c.value, g !== !0 || m === null) {
        const p = d + _ * 4, S = f.matrixWorldInverse;
        o.getNormalMatrix(S), (m === null || m.length < p) && (m = new Float32Array(p));
        for (let b = 0, T = d; b !== _; ++b, T += 4)
          a.copy(h[b]).applyMatrix4(S, o), a.normal.toArray(m, T), m[T + 3] = a.constant;
      }
      c.value = m, c.needsUpdate = !0;
    }
    return e.numPlanes = _, e.numIntersection = 0, m;
  }
}
function Rp(r) {
  let e = /* @__PURE__ */ new WeakMap();
  function t(a, o) {
    return o === 303 ? a.mapping = 301 : o === 304 && (a.mapping = 302), a;
  }
  function n(a) {
    if (a && a.isTexture) {
      const o = a.mapping;
      if (o === 303 || o === 304)
        if (e.has(a)) {
          const c = e.get(a).texture;
          return t(c, a.mapping);
        } else {
          const c = a.image;
          if (c && c.height > 0) {
            const l = new dc(c.height);
            return l.fromEquirectangularTexture(r, a), e.set(a, l), a.addEventListener("dispose", i), t(l.texture, a.mapping);
          } else
            return null;
        }
    }
    return a;
  }
  function i(a) {
    const o = a.target;
    o.removeEventListener("dispose", i);
    const c = e.get(o);
    c !== void 0 && (e.delete(o), c.dispose());
  }
  function s() {
    e = /* @__PURE__ */ new WeakMap();
  }
  return {
    get: n,
    dispose: s
  };
}
const Jn = 4, dl = [0.125, 0.215, 0.35, 0.446, 0.526, 0.582], Si = 20, Cp = 256, xr = /* @__PURE__ */ new Mc(), pl = /* @__PURE__ */ new Ge();
let wa = null, Ra = 0, Ca = 0, Pa = !1;
const Pp = /* @__PURE__ */ new I();
class ml {
  /**
   * Constructs a new PMREM generator.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   */
  constructor(e) {
    this._renderer = e, this._pingPongRenderTarget = null, this._lodMax = 0, this._cubeSize = 0, this._sizeLods = [], this._sigmas = [], this._lodMeshes = [], this._backgroundBox = null, this._cubemapMaterial = null, this._equirectMaterial = null, this._blurMaterial = null, this._ggxMaterial = null;
  }
  /**
   * Generates a PMREM from a supplied Scene, which can be faster than using an
   * image if networking bandwidth is low. Optional sigma specifies a blur radius
   * in radians to be applied to the scene before PMREM generation. Optional near
   * and far planes ensure the scene is rendered in its entirety.
   *
   * @param {Scene} scene - The scene to be captured.
   * @param {number} [sigma=0] - The blur radius in radians.
   * @param {number} [near=0.1] - The near plane distance.
   * @param {number} [far=100] - The far plane distance.
   * @param {Object} [options={}] - The configuration options.
   * @param {number} [options.size=256] - The texture size of the PMREM.
   * @param {Vector3} [options.position=origin] - The position of the internal cube camera that renders the scene.
   * @return {WebGLRenderTarget} The resulting PMREM.
   */
  fromScene(e, t = 0, n = 0.1, i = 100, s = {}) {
    const {
      size: a = 256,
      position: o = Pp
    } = s;
    wa = this._renderer.getRenderTarget(), Ra = this._renderer.getActiveCubeFace(), Ca = this._renderer.getActiveMipmapLevel(), Pa = this._renderer.xr.enabled, this._renderer.xr.enabled = !1, this._setSize(a);
    const c = this._allocateTargets();
    return c.depthBuffer = !0, this._sceneToCubeUV(e, n, i, c, o), t > 0 && this._blur(c, 0, 0, t), this._applyPMREM(c), this._cleanup(c), c;
  }
  /**
   * Generates a PMREM from an equirectangular texture, which can be either LDR
   * or HDR. The ideal input image size is 1k (1024 x 512),
   * as this matches best with the 256 x 256 cubemap output.
   *
   * @param {Texture} equirectangular - The equirectangular texture to be converted.
   * @param {?WebGLRenderTarget} [renderTarget=null] - The render target to use.
   * @return {WebGLRenderTarget} The resulting PMREM.
   */
  fromEquirectangular(e, t = null) {
    return this._fromTexture(e, t);
  }
  /**
   * Generates a PMREM from an cubemap texture, which can be either LDR
   * or HDR. The ideal input cube size is 256 x 256,
   * as this matches best with the 256 x 256 cubemap output.
   *
   * @param {Texture} cubemap - The cubemap texture to be converted.
   * @param {?WebGLRenderTarget} [renderTarget=null] - The render target to use.
   * @return {WebGLRenderTarget} The resulting PMREM.
   */
  fromCubemap(e, t = null) {
    return this._fromTexture(e, t);
  }
  /**
   * Pre-compiles the cubemap shader. You can get faster start-up by invoking this method during
   * your texture's network fetch for increased concurrency.
   */
  compileCubemapShader() {
    this._cubemapMaterial === null && (this._cubemapMaterial = vl(), this._compileMaterial(this._cubemapMaterial));
  }
  /**
   * Pre-compiles the equirectangular shader. You can get faster start-up by invoking this method during
   * your texture's network fetch for increased concurrency.
   */
  compileEquirectangularShader() {
    this._equirectMaterial === null && (this._equirectMaterial = gl(), this._compileMaterial(this._equirectMaterial));
  }
  /**
   * Disposes of the PMREMGenerator's internal memory. Note that PMREMGenerator is a static class,
   * so you should not need more than one PMREMGenerator object. If you do, calling dispose() on
   * one of them will cause any others to also become unusable.
   */
  dispose() {
    this._dispose(), this._cubemapMaterial !== null && this._cubemapMaterial.dispose(), this._equirectMaterial !== null && this._equirectMaterial.dispose(), this._backgroundBox !== null && (this._backgroundBox.geometry.dispose(), this._backgroundBox.material.dispose());
  }
  // private interface
  _setSize(e) {
    this._lodMax = Math.floor(Math.log2(e)), this._cubeSize = Math.pow(2, this._lodMax);
  }
  _dispose() {
    this._blurMaterial !== null && this._blurMaterial.dispose(), this._ggxMaterial !== null && this._ggxMaterial.dispose(), this._pingPongRenderTarget !== null && this._pingPongRenderTarget.dispose();
    for (let e = 0; e < this._lodMeshes.length; e++)
      this._lodMeshes[e].geometry.dispose();
  }
  _cleanup(e) {
    this._renderer.setRenderTarget(wa, Ra, Ca), this._renderer.xr.enabled = Pa, e.scissorTest = !1, qi(e, 0, 0, e.width, e.height);
  }
  _fromTexture(e, t) {
    e.mapping === 301 || e.mapping === 302 ? this._setSize(e.image.length === 0 ? 16 : e.image[0].width || e.image[0].image.width) : this._setSize(e.image.width / 4), wa = this._renderer.getRenderTarget(), Ra = this._renderer.getActiveCubeFace(), Ca = this._renderer.getActiveMipmapLevel(), Pa = this._renderer.xr.enabled, this._renderer.xr.enabled = !1;
    const n = t || this._allocateTargets();
    return this._textureToCubeUV(e, n), this._applyPMREM(n), this._cleanup(n), n;
  }
  _allocateTargets() {
    const e = 3 * Math.max(this._cubeSize, 112), t = 4 * this._cubeSize, n = {
      magFilter: 1006,
      minFilter: 1006,
      generateMipmaps: !1,
      type: 1016,
      format: 1023,
      colorSpace: tr,
      depthBuffer: !1
    }, i = _l(e, t, n);
    if (this._pingPongRenderTarget === null || this._pingPongRenderTarget.width !== e || this._pingPongRenderTarget.height !== t) {
      this._pingPongRenderTarget !== null && this._dispose(), this._pingPongRenderTarget = _l(e, t, n);
      const { _lodMax: s } = this;
      ({ lodMeshes: this._lodMeshes, sizeLods: this._sizeLods, sigmas: this._sigmas } = Dp(s)), this._blurMaterial = Fp(s, e, t), this._ggxMaterial = Lp(s, e, t);
    }
    return i;
  }
  _compileMaterial(e) {
    const t = new Lt(new Qt(), e);
    this._renderer.compile(t, xr);
  }
  _sceneToCubeUV(e, t, n, i, s) {
    const c = new qt(90, 1, t, n), l = [1, -1, 1, 1, 1, 1], u = [1, 1, 1, -1, -1, -1], h = this._renderer, f = h.autoClear, d = h.toneMapping;
    h.getClearColor(pl), h.toneMapping = 0, h.autoClear = !1, h.state.buffers.depth.getReversed() && (h.setRenderTarget(i), h.clearDepth(), h.setRenderTarget(null)), this._backgroundBox === null && (this._backgroundBox = new Lt(
      new $r(),
      new Cr({
        name: "PMREM.Background",
        side: 1,
        depthWrite: !1,
        depthTest: !1
      })
    ));
    const _ = this._backgroundBox, m = _.material;
    let p = !1;
    const S = e.background;
    S ? S.isColor && (m.color.copy(S), e.background = null, p = !0) : (m.color.copy(pl), p = !0);
    for (let b = 0; b < 6; b++) {
      const T = b % 3;
      T === 0 ? (c.up.set(0, l[b], 0), c.position.set(s.x, s.y, s.z), c.lookAt(s.x + u[b], s.y, s.z)) : T === 1 ? (c.up.set(0, 0, l[b]), c.position.set(s.x, s.y, s.z), c.lookAt(s.x, s.y + u[b], s.z)) : (c.up.set(0, l[b], 0), c.position.set(s.x, s.y, s.z), c.lookAt(s.x, s.y, s.z + u[b]));
      const y = this._cubeSize;
      qi(i, T * y, b > 2 ? y : 0, y, y), h.setRenderTarget(i), p && h.render(_, c), h.render(e, c);
    }
    h.toneMapping = d, h.autoClear = f, e.background = S;
  }
  _textureToCubeUV(e, t) {
    const n = this._renderer, i = e.mapping === 301 || e.mapping === 302;
    i ? (this._cubemapMaterial === null && (this._cubemapMaterial = vl()), this._cubemapMaterial.uniforms.flipEnvMap.value = e.isRenderTargetTexture === !1 ? -1 : 1) : this._equirectMaterial === null && (this._equirectMaterial = gl());
    const s = i ? this._cubemapMaterial : this._equirectMaterial, a = this._lodMeshes[0];
    a.material = s;
    const o = s.uniforms;
    o.envMap.value = e;
    const c = this._cubeSize;
    qi(t, 0, 0, 3 * c, 2 * c), n.setRenderTarget(t), n.render(a, xr);
  }
  _applyPMREM(e) {
    const t = this._renderer, n = t.autoClear;
    t.autoClear = !1;
    const i = this._lodMeshes.length;
    for (let s = 1; s < i; s++)
      this._applyGGXFilter(e, s - 1, s);
    t.autoClear = n;
  }
  /**
   * Applies GGX VNDF importance sampling filter to generate a prefiltered environment map.
   * Uses Monte Carlo integration with VNDF importance sampling to accurately represent the
   * GGX BRDF for physically-based rendering. Reads from the previous LOD level and
   * applies incremental roughness filtering to avoid over-blurring.
   *
   * @private
   * @param {WebGLRenderTarget} cubeUVRenderTarget
   * @param {number} lodIn - Source LOD level to read from
   * @param {number} lodOut - Target LOD level to write to
   */
  _applyGGXFilter(e, t, n) {
    const i = this._renderer, s = this._pingPongRenderTarget, a = this._ggxMaterial, o = this._lodMeshes[n];
    o.material = a;
    const c = a.uniforms, l = n / (this._lodMeshes.length - 1), u = t / (this._lodMeshes.length - 1), h = Math.sqrt(l * l - u * u), f = 0 + l * 1.25, d = h * f, { _lodMax: g } = this, _ = this._sizeLods[n], m = 3 * _ * (n > g - Jn ? n - g + Jn : 0), p = 4 * (this._cubeSize - _);
    c.envMap.value = e.texture, c.roughness.value = d, c.mipInt.value = g - t, qi(s, m, p, 3 * _, 2 * _), i.setRenderTarget(s), i.render(o, xr), c.envMap.value = s.texture, c.roughness.value = 0, c.mipInt.value = g - n, qi(e, m, p, 3 * _, 2 * _), i.setRenderTarget(e), i.render(o, xr);
  }
  /**
   * This is a two-pass Gaussian blur for a cubemap. Normally this is done
   * vertically and horizontally, but this breaks down on a cube. Here we apply
   * the blur latitudinally (around the poles), and then longitudinally (towards
   * the poles) to approximate the orthogonally-separable blur. It is least
   * accurate at the poles, but still does a decent job.
   *
   * Used for initial scene blur in fromScene() method when sigma > 0.
   *
   * @private
   * @param {WebGLRenderTarget} cubeUVRenderTarget
   * @param {number} lodIn
   * @param {number} lodOut
   * @param {number} sigma
   * @param {Vector3} [poleAxis]
   */
  _blur(e, t, n, i, s) {
    const a = this._pingPongRenderTarget;
    this._halfBlur(
      e,
      a,
      t,
      n,
      i,
      "latitudinal",
      s
    ), this._halfBlur(
      a,
      e,
      n,
      n,
      i,
      "longitudinal",
      s
    );
  }
  _halfBlur(e, t, n, i, s, a, o) {
    const c = this._renderer, l = this._blurMaterial;
    a !== "latitudinal" && a !== "longitudinal" && Xe(
      "blur direction must be either latitudinal or longitudinal!"
    );
    const u = 3, h = this._lodMeshes[i];
    h.material = l;
    const f = l.uniforms, d = this._sizeLods[n] - 1, g = isFinite(s) ? Math.PI / (2 * d) : 2 * Math.PI / (2 * Si - 1), _ = s / g, m = isFinite(s) ? 1 + Math.floor(u * _) : Si;
    m > Si && Ce(`sigmaRadians, ${s}, is too large and will clip, as it requested ${m} samples when the maximum is set to ${Si}`);
    const p = [];
    let S = 0;
    for (let A = 0; A < Si; ++A) {
      const C = A / _, x = Math.exp(-C * C / 2);
      p.push(x), A === 0 ? S += x : A < m && (S += 2 * x);
    }
    for (let A = 0; A < p.length; A++)
      p[A] = p[A] / S;
    f.envMap.value = e.texture, f.samples.value = m, f.weights.value = p, f.latitudinal.value = a === "latitudinal", o && (f.poleAxis.value = o);
    const { _lodMax: b } = this;
    f.dTheta.value = g, f.mipInt.value = b - n;
    const T = this._sizeLods[i], y = 3 * T * (i > b - Jn ? i - b + Jn : 0), R = 4 * (this._cubeSize - T);
    qi(t, y, R, 3 * T, 2 * T), c.setRenderTarget(t), c.render(h, xr);
  }
}
function Dp(r) {
  const e = [], t = [], n = [];
  let i = r;
  const s = r - Jn + 1 + dl.length;
  for (let a = 0; a < s; a++) {
    const o = Math.pow(2, i);
    e.push(o);
    let c = 1 / o;
    a > r - Jn ? c = dl[a - r + Jn - 1] : a === 0 && (c = 0), t.push(c);
    const l = 1 / (o - 2), u = -l, h = 1 + l, f = [u, u, h, u, h, h, u, u, h, h, u, h], d = 6, g = 6, _ = 3, m = 2, p = 1, S = new Float32Array(_ * g * d), b = new Float32Array(m * g * d), T = new Float32Array(p * g * d);
    for (let R = 0; R < d; R++) {
      const A = R % 3 * 2 / 3 - 1, C = R > 2 ? 0 : -1, x = [
        A,
        C,
        0,
        A + 2 / 3,
        C,
        0,
        A + 2 / 3,
        C + 1,
        0,
        A,
        C,
        0,
        A + 2 / 3,
        C + 1,
        0,
        A,
        C + 1,
        0
      ];
      S.set(x, _ * g * R), b.set(f, m * g * R);
      const E = [R, R, R, R, R, R];
      T.set(E, p * g * R);
    }
    const y = new Qt();
    y.setAttribute("position", new Nt(S, _)), y.setAttribute("uv", new Nt(b, m)), y.setAttribute("faceIndex", new Nt(T, p)), n.push(new Lt(y, null)), i > Jn && i--;
  }
  return { lodMeshes: n, sizeLods: e, sigmas: t };
}
function _l(r, e, t) {
  const n = new Cn(r, e, t);
  return n.texture.mapping = 306, n.texture.name = "PMREM.cubeUv", n.scissorTest = !0, n;
}
function qi(r, e, t, n, i) {
  r.viewport.set(e, t, n, i), r.scissor.set(e, t, n, i);
}
function Lp(r, e, t) {
  return new Ht({
    name: "PMREMGGXConvolution",
    defines: {
      GGX_SAMPLES: Cp,
      CUBEUV_TEXEL_WIDTH: 1 / e,
      CUBEUV_TEXEL_HEIGHT: 1 / t,
      CUBEUV_MAX_MIP: `${r}.0`
    },
    uniforms: {
      envMap: { value: null },
      roughness: { value: 0 },
      mipInt: { value: 0 }
    },
    vertexShader: Ws(),
    fragmentShader: (
      /* glsl */
      `

			precision highp float;
			precision highp int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;
			uniform float roughness;
			uniform float mipInt;

			#define ENVMAP_TYPE_CUBE_UV
			#include <cube_uv_reflection_fragment>

			#define PI 3.14159265359

			// Van der Corput radical inverse
			float radicalInverse_VdC(uint bits) {
				bits = (bits << 16u) | (bits >> 16u);
				bits = ((bits & 0x55555555u) << 1u) | ((bits & 0xAAAAAAAAu) >> 1u);
				bits = ((bits & 0x33333333u) << 2u) | ((bits & 0xCCCCCCCCu) >> 2u);
				bits = ((bits & 0x0F0F0F0Fu) << 4u) | ((bits & 0xF0F0F0F0u) >> 4u);
				bits = ((bits & 0x00FF00FFu) << 8u) | ((bits & 0xFF00FF00u) >> 8u);
				return float(bits) * 2.3283064365386963e-10; // / 0x100000000
			}

			// Hammersley sequence
			vec2 hammersley(uint i, uint N) {
				return vec2(float(i) / float(N), radicalInverse_VdC(i));
			}

			// GGX VNDF importance sampling (Eric Heitz 2018)
			// "Sampling the GGX Distribution of Visible Normals"
			// https://jcgt.org/published/0007/04/01/
			vec3 importanceSampleGGX_VNDF(vec2 Xi, vec3 V, float roughness) {
				float alpha = roughness * roughness;

				// Section 3.2: Transform view direction to hemisphere configuration
				vec3 Vh = normalize(vec3(alpha * V.x, alpha * V.y, V.z));

				// Section 4.1: Orthonormal basis
				float lensq = Vh.x * Vh.x + Vh.y * Vh.y;
				vec3 T1 = lensq > 0.0 ? vec3(-Vh.y, Vh.x, 0.0) / sqrt(lensq) : vec3(1.0, 0.0, 0.0);
				vec3 T2 = cross(Vh, T1);

				// Section 4.2: Parameterization of projected area
				float r = sqrt(Xi.x);
				float phi = 2.0 * PI * Xi.y;
				float t1 = r * cos(phi);
				float t2 = r * sin(phi);
				float s = 0.5 * (1.0 + Vh.z);
				t2 = (1.0 - s) * sqrt(1.0 - t1 * t1) + s * t2;

				// Section 4.3: Reprojection onto hemisphere
				vec3 Nh = t1 * T1 + t2 * T2 + sqrt(max(0.0, 1.0 - t1 * t1 - t2 * t2)) * Vh;

				// Section 3.4: Transform back to ellipsoid configuration
				return normalize(vec3(alpha * Nh.x, alpha * Nh.y, max(0.0, Nh.z)));
			}

			void main() {
				vec3 N = normalize(vOutputDirection);
				vec3 V = N; // Assume view direction equals normal for pre-filtering

				vec3 prefilteredColor = vec3(0.0);
				float totalWeight = 0.0;

				// For very low roughness, just sample the environment directly
				if (roughness < 0.001) {
					gl_FragColor = vec4(bilinearCubeUV(envMap, N, mipInt), 1.0);
					return;
				}

				// Tangent space basis for VNDF sampling
				vec3 up = abs(N.z) < 0.999 ? vec3(0.0, 0.0, 1.0) : vec3(1.0, 0.0, 0.0);
				vec3 tangent = normalize(cross(up, N));
				vec3 bitangent = cross(N, tangent);

				for(uint i = 0u; i < uint(GGX_SAMPLES); i++) {
					vec2 Xi = hammersley(i, uint(GGX_SAMPLES));

					// For PMREM, V = N, so in tangent space V is always (0, 0, 1)
					vec3 H_tangent = importanceSampleGGX_VNDF(Xi, vec3(0.0, 0.0, 1.0), roughness);

					// Transform H back to world space
					vec3 H = normalize(tangent * H_tangent.x + bitangent * H_tangent.y + N * H_tangent.z);
					vec3 L = normalize(2.0 * dot(V, H) * H - V);

					float NdotL = max(dot(N, L), 0.0);

					if(NdotL > 0.0) {
						// Sample environment at fixed mip level
						// VNDF importance sampling handles the distribution filtering
						vec3 sampleColor = bilinearCubeUV(envMap, L, mipInt);

						// Weight by NdotL for the split-sum approximation
						// VNDF PDF naturally accounts for the visible microfacet distribution
						prefilteredColor += sampleColor * NdotL;
						totalWeight += NdotL;
					}
				}

				if (totalWeight > 0.0) {
					prefilteredColor = prefilteredColor / totalWeight;
				}

				gl_FragColor = vec4(prefilteredColor, 1.0);
			}
		`
    ),
    blending: 0,
    depthTest: !1,
    depthWrite: !1
  });
}
function Fp(r, e, t) {
  const n = new Float32Array(Si), i = new I(0, 1, 0);
  return new Ht({
    name: "SphericalGaussianBlur",
    defines: {
      n: Si,
      CUBEUV_TEXEL_WIDTH: 1 / e,
      CUBEUV_TEXEL_HEIGHT: 1 / t,
      CUBEUV_MAX_MIP: `${r}.0`
    },
    uniforms: {
      envMap: { value: null },
      samples: { value: 1 },
      weights: { value: n },
      latitudinal: { value: !1 },
      dTheta: { value: 0 },
      mipInt: { value: 0 },
      poleAxis: { value: i }
    },
    vertexShader: Ws(),
    fragmentShader: (
      /* glsl */
      `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;
			uniform int samples;
			uniform float weights[ n ];
			uniform bool latitudinal;
			uniform float dTheta;
			uniform float mipInt;
			uniform vec3 poleAxis;

			#define ENVMAP_TYPE_CUBE_UV
			#include <cube_uv_reflection_fragment>

			vec3 getSample( float theta, vec3 axis ) {

				float cosTheta = cos( theta );
				// Rodrigues' axis-angle rotation
				vec3 sampleDirection = vOutputDirection * cosTheta
					+ cross( axis, vOutputDirection ) * sin( theta )
					+ axis * dot( axis, vOutputDirection ) * ( 1.0 - cosTheta );

				return bilinearCubeUV( envMap, sampleDirection, mipInt );

			}

			void main() {

				vec3 axis = latitudinal ? poleAxis : cross( poleAxis, vOutputDirection );

				if ( all( equal( axis, vec3( 0.0 ) ) ) ) {

					axis = vec3( vOutputDirection.z, 0.0, - vOutputDirection.x );

				}

				axis = normalize( axis );

				gl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );
				gl_FragColor.rgb += weights[ 0 ] * getSample( 0.0, axis );

				for ( int i = 1; i < n; i++ ) {

					if ( i >= samples ) {

						break;

					}

					float theta = dTheta * float( i );
					gl_FragColor.rgb += weights[ i ] * getSample( -1.0 * theta, axis );
					gl_FragColor.rgb += weights[ i ] * getSample( theta, axis );

				}

			}
		`
    ),
    blending: 0,
    depthTest: !1,
    depthWrite: !1
  });
}
function gl() {
  return new Ht({
    name: "EquirectangularToCubeUV",
    uniforms: {
      envMap: { value: null }
    },
    vertexShader: Ws(),
    fragmentShader: (
      /* glsl */
      `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;

			#include <common>

			void main() {

				vec3 outputDirection = normalize( vOutputDirection );
				vec2 uv = equirectUv( outputDirection );

				gl_FragColor = vec4( texture2D ( envMap, uv ).rgb, 1.0 );

			}
		`
    ),
    blending: 0,
    depthTest: !1,
    depthWrite: !1
  });
}
function vl() {
  return new Ht({
    name: "CubemapToCubeUV",
    uniforms: {
      envMap: { value: null },
      flipEnvMap: { value: -1 }
    },
    vertexShader: Ws(),
    fragmentShader: (
      /* glsl */
      `

			precision mediump float;
			precision mediump int;

			uniform float flipEnvMap;

			varying vec3 vOutputDirection;

			uniform samplerCube envMap;

			void main() {

				gl_FragColor = textureCube( envMap, vec3( flipEnvMap * vOutputDirection.x, vOutputDirection.yz ) );

			}
		`
    ),
    blending: 0,
    depthTest: !1,
    depthWrite: !1
  });
}
function Ws() {
  return (
    /* glsl */
    `

		precision mediump float;
		precision mediump int;

		attribute float faceIndex;

		varying vec3 vOutputDirection;

		// RH coordinate system; PMREM face-indexing convention
		vec3 getDirection( vec2 uv, float face ) {

			uv = 2.0 * uv - 1.0;

			vec3 direction = vec3( uv, 1.0 );

			if ( face == 0.0 ) {

				direction = direction.zyx; // ( 1, v, u ) pos x

			} else if ( face == 1.0 ) {

				direction = direction.xzy;
				direction.xz *= -1.0; // ( -u, 1, -v ) pos y

			} else if ( face == 2.0 ) {

				direction.x *= -1.0; // ( -u, v, 1 ) pos z

			} else if ( face == 3.0 ) {

				direction = direction.zyx;
				direction.xz *= -1.0; // ( -1, v, -u ) neg x

			} else if ( face == 4.0 ) {

				direction = direction.xzy;
				direction.xy *= -1.0; // ( -u, -1, v ) neg y

			} else if ( face == 5.0 ) {

				direction.z *= -1.0; // ( u, v, -1 ) neg z

			}

			return direction;

		}

		void main() {

			vOutputDirection = getDirection( uv, faceIndex );
			gl_Position = vec4( position, 1.0 );

		}
	`
  );
}
function Up(r) {
  let e = /* @__PURE__ */ new WeakMap(), t = null;
  function n(o) {
    if (o && o.isTexture) {
      const c = o.mapping, l = c === 303 || c === 304, u = c === 301 || c === 302;
      if (l || u) {
        let h = e.get(o);
        const f = h !== void 0 ? h.texture.pmremVersion : 0;
        if (o.isRenderTargetTexture && o.pmremVersion !== f)
          return t === null && (t = new ml(r)), h = l ? t.fromEquirectangular(o, h) : t.fromCubemap(o, h), h.texture.pmremVersion = o.pmremVersion, e.set(o, h), h.texture;
        if (h !== void 0)
          return h.texture;
        {
          const d = o.image;
          return l && d && d.height > 0 || u && d && i(d) ? (t === null && (t = new ml(r)), h = l ? t.fromEquirectangular(o) : t.fromCubemap(o), h.texture.pmremVersion = o.pmremVersion, e.set(o, h), o.addEventListener("dispose", s), h.texture) : null;
        }
      }
    }
    return o;
  }
  function i(o) {
    let c = 0;
    const l = 6;
    for (let u = 0; u < l; u++)
      o[u] !== void 0 && c++;
    return c === l;
  }
  function s(o) {
    const c = o.target;
    c.removeEventListener("dispose", s);
    const l = e.get(c);
    l !== void 0 && (e.delete(c), l.dispose());
  }
  function a() {
    e = /* @__PURE__ */ new WeakMap(), t !== null && (t.dispose(), t = null);
  }
  return {
    get: n,
    dispose: a
  };
}
function Ip(r) {
  const e = {};
  function t(n) {
    if (e[n] !== void 0)
      return e[n];
    const i = r.getExtension(n);
    return e[n] = i, i;
  }
  return {
    has: function(n) {
      return t(n) !== null;
    },
    init: function() {
      t("EXT_color_buffer_float"), t("WEBGL_clip_cull_distance"), t("OES_texture_float_linear"), t("EXT_color_buffer_half_float"), t("WEBGL_multisampled_render_to_texture"), t("WEBGL_render_shared_exponent");
    },
    get: function(n) {
      const i = t(n);
      return i === null && Ur("WebGLRenderer: " + n + " extension not supported."), i;
    }
  };
}
function Np(r, e, t, n) {
  const i = {}, s = /* @__PURE__ */ new WeakMap();
  function a(h) {
    const f = h.target;
    f.index !== null && e.remove(f.index);
    for (const g in f.attributes)
      e.remove(f.attributes[g]);
    f.removeEventListener("dispose", a), delete i[f.id];
    const d = s.get(f);
    d && (e.remove(d), s.delete(f)), n.releaseStatesOfGeometry(f), f.isInstancedBufferGeometry === !0 && delete f._maxInstanceCount, t.memory.geometries--;
  }
  function o(h, f) {
    return i[f.id] === !0 || (f.addEventListener("dispose", a), i[f.id] = !0, t.memory.geometries++), f;
  }
  function c(h) {
    const f = h.attributes;
    for (const d in f)
      e.update(f[d], r.ARRAY_BUFFER);
  }
  function l(h) {
    const f = [], d = h.index, g = h.attributes.position;
    let _ = 0;
    if (d !== null) {
      const S = d.array;
      _ = d.version;
      for (let b = 0, T = S.length; b < T; b += 3) {
        const y = S[b + 0], R = S[b + 1], A = S[b + 2];
        f.push(y, R, R, A, A, y);
      }
    } else if (g !== void 0) {
      const S = g.array;
      _ = g.version;
      for (let b = 0, T = S.length / 3 - 1; b < T; b += 3) {
        const y = b + 0, R = b + 1, A = b + 2;
        f.push(y, R, R, A, A, y);
      }
    } else
      return;
    const m = new (sc(f) ? uc : cc)(f, 1);
    m.version = _;
    const p = s.get(h);
    p && e.remove(p), s.set(h, m);
  }
  function u(h) {
    const f = s.get(h);
    if (f) {
      const d = h.index;
      d !== null && f.version < d.version && l(h);
    } else
      l(h);
    return s.get(h);
  }
  return {
    get: o,
    update: c,
    getWireframeAttribute: u
  };
}
function Op(r, e, t) {
  let n;
  function i(f) {
    n = f;
  }
  let s, a;
  function o(f) {
    s = f.type, a = f.bytesPerElement;
  }
  function c(f, d) {
    r.drawElements(n, d, s, f * a), t.update(d, n, 1);
  }
  function l(f, d, g) {
    g !== 0 && (r.drawElementsInstanced(n, d, s, f * a, g), t.update(d, n, g));
  }
  function u(f, d, g) {
    if (g === 0) return;
    e.get("WEBGL_multi_draw").multiDrawElementsWEBGL(n, d, 0, s, f, 0, g);
    let m = 0;
    for (let p = 0; p < g; p++)
      m += d[p];
    t.update(m, n, 1);
  }
  function h(f, d, g, _) {
    if (g === 0) return;
    const m = e.get("WEBGL_multi_draw");
    if (m === null)
      for (let p = 0; p < f.length; p++)
        l(f[p] / a, d[p], _[p]);
    else {
      m.multiDrawElementsInstancedWEBGL(n, d, 0, s, f, 0, _, 0, g);
      let p = 0;
      for (let S = 0; S < g; S++)
        p += d[S] * _[S];
      t.update(p, n, 1);
    }
  }
  this.setMode = i, this.setIndex = o, this.render = c, this.renderInstances = l, this.renderMultiDraw = u, this.renderMultiDrawInstances = h;
}
function Bp(r) {
  const e = {
    geometries: 0,
    textures: 0
  }, t = {
    frame: 0,
    calls: 0,
    triangles: 0,
    points: 0,
    lines: 0
  };
  function n(s, a, o) {
    switch (t.calls++, a) {
      case r.TRIANGLES:
        t.triangles += o * (s / 3);
        break;
      case r.LINES:
        t.lines += o * (s / 2);
        break;
      case r.LINE_STRIP:
        t.lines += o * (s - 1);
        break;
      case r.LINE_LOOP:
        t.lines += o * s;
        break;
      case r.POINTS:
        t.points += o * s;
        break;
      default:
        Xe("WebGLInfo: Unknown draw mode:", a);
        break;
    }
  }
  function i() {
    t.calls = 0, t.triangles = 0, t.points = 0, t.lines = 0;
  }
  return {
    memory: e,
    render: t,
    programs: null,
    autoReset: !0,
    reset: i,
    update: n
  };
}
function zp(r, e, t) {
  const n = /* @__PURE__ */ new WeakMap(), i = new xt();
  function s(a, o, c) {
    const l = a.morphTargetInfluences, u = o.morphAttributes.position || o.morphAttributes.normal || o.morphAttributes.color, h = u !== void 0 ? u.length : 0;
    let f = n.get(o);
    if (f === void 0 || f.count !== h) {
      let E = function() {
        C.dispose(), n.delete(o), o.removeEventListener("dispose", E);
      };
      var d = E;
      f !== void 0 && f.texture.dispose();
      const g = o.morphAttributes.position !== void 0, _ = o.morphAttributes.normal !== void 0, m = o.morphAttributes.color !== void 0, p = o.morphAttributes.position || [], S = o.morphAttributes.normal || [], b = o.morphAttributes.color || [];
      let T = 0;
      g === !0 && (T = 1), _ === !0 && (T = 2), m === !0 && (T = 3);
      let y = o.attributes.position.count * T, R = 1;
      y > e.maxTextureSize && (R = Math.ceil(y / e.maxTextureSize), y = e.maxTextureSize);
      const A = new Float32Array(y * R * 4 * h), C = new ac(A, y, R, h);
      C.type = 1015, C.needsUpdate = !0;
      const x = T * 4;
      for (let P = 0; P < h; P++) {
        const z = p[P], N = S[P], W = b[P], H = y * R * 4 * P;
        for (let k = 0; k < z.count; k++) {
          const O = k * x;
          g === !0 && (i.fromBufferAttribute(z, k), A[H + O + 0] = i.x, A[H + O + 1] = i.y, A[H + O + 2] = i.z, A[H + O + 3] = 0), _ === !0 && (i.fromBufferAttribute(N, k), A[H + O + 4] = i.x, A[H + O + 5] = i.y, A[H + O + 6] = i.z, A[H + O + 7] = 0), m === !0 && (i.fromBufferAttribute(W, k), A[H + O + 8] = i.x, A[H + O + 9] = i.y, A[H + O + 10] = i.z, A[H + O + 11] = W.itemSize === 4 ? i.w : 1);
        }
      }
      f = {
        count: h,
        texture: C,
        size: new Ae(y, R)
      }, n.set(o, f), o.addEventListener("dispose", E);
    }
    if (a.isInstancedMesh === !0 && a.morphTexture !== null)
      c.getUniforms().setValue(r, "morphTexture", a.morphTexture, t);
    else {
      let g = 0;
      for (let m = 0; m < l.length; m++)
        g += l[m];
      const _ = o.morphTargetsRelative ? 1 : 1 - g;
      c.getUniforms().setValue(r, "morphTargetBaseInfluence", _), c.getUniforms().setValue(r, "morphTargetInfluences", l);
    }
    c.getUniforms().setValue(r, "morphTargetsTexture", f.texture, t), c.getUniforms().setValue(r, "morphTargetsTextureSize", f.size);
  }
  return {
    update: s
  };
}
function Gp(r, e, t, n) {
  let i = /* @__PURE__ */ new WeakMap();
  function s(c) {
    const l = n.render.frame, u = c.geometry, h = e.get(c, u);
    if (i.get(h) !== l && (e.update(h), i.set(h, l)), c.isInstancedMesh && (c.hasEventListener("dispose", o) === !1 && c.addEventListener("dispose", o), i.get(c) !== l && (t.update(c.instanceMatrix, r.ARRAY_BUFFER), c.instanceColor !== null && t.update(c.instanceColor, r.ARRAY_BUFFER), i.set(c, l))), c.isSkinnedMesh) {
      const f = c.skeleton;
      i.get(f) !== l && (f.update(), i.set(f, l));
    }
    return h;
  }
  function a() {
    i = /* @__PURE__ */ new WeakMap();
  }
  function o(c) {
    const l = c.target;
    l.removeEventListener("dispose", o), t.remove(l.instanceMatrix), l.instanceColor !== null && t.remove(l.instanceColor);
  }
  return {
    update: s,
    dispose: a
  };
}
const kp = {
  1: "LINEAR_TONE_MAPPING",
  2: "REINHARD_TONE_MAPPING",
  3: "CINEON_TONE_MAPPING",
  4: "ACES_FILMIC_TONE_MAPPING",
  6: "AGX_TONE_MAPPING",
  7: "NEUTRAL_TONE_MAPPING",
  5: "CUSTOM_TONE_MAPPING"
};
function Vp(r, e, t, n, i) {
  const s = new Cn(e, t, {
    type: r,
    depthBuffer: n,
    stencilBuffer: i
  }), a = new Cn(e, t, {
    type: 1016,
    depthBuffer: !1,
    stencilBuffer: !1
  }), o = new Qt();
  o.setAttribute("position", new Pn([-1, 3, 0, -1, -1, 0, 3, -1, 0], 3)), o.setAttribute("uv", new Pn([0, 2, 0, 0, 2, 0], 2));
  const c = new Fh({
    uniforms: {
      tDiffuse: { value: null }
    },
    vertexShader: (
      /* glsl */
      `
			precision highp float;

			uniform mat4 modelViewMatrix;
			uniform mat4 projectionMatrix;

			attribute vec3 position;
			attribute vec2 uv;

			varying vec2 vUv;

			void main() {
				vUv = uv;
				gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
			}`
    ),
    fragmentShader: (
      /* glsl */
      `
			precision highp float;

			uniform sampler2D tDiffuse;

			varying vec2 vUv;

			#include <tonemapping_pars_fragment>
			#include <colorspace_pars_fragment>

			void main() {
				gl_FragColor = texture2D( tDiffuse, vUv );

				#ifdef LINEAR_TONE_MAPPING
					gl_FragColor.rgb = LinearToneMapping( gl_FragColor.rgb );
				#elif defined( REINHARD_TONE_MAPPING )
					gl_FragColor.rgb = ReinhardToneMapping( gl_FragColor.rgb );
				#elif defined( CINEON_TONE_MAPPING )
					gl_FragColor.rgb = CineonToneMapping( gl_FragColor.rgb );
				#elif defined( ACES_FILMIC_TONE_MAPPING )
					gl_FragColor.rgb = ACESFilmicToneMapping( gl_FragColor.rgb );
				#elif defined( AGX_TONE_MAPPING )
					gl_FragColor.rgb = AgXToneMapping( gl_FragColor.rgb );
				#elif defined( NEUTRAL_TONE_MAPPING )
					gl_FragColor.rgb = NeutralToneMapping( gl_FragColor.rgb );
				#elif defined( CUSTOM_TONE_MAPPING )
					gl_FragColor.rgb = CustomToneMapping( gl_FragColor.rgb );
				#endif

				#ifdef SRGB_TRANSFER
					gl_FragColor = sRGBTransferOETF( gl_FragColor );
				#endif
			}`
    ),
    depthTest: !1,
    depthWrite: !1
  }), l = new Lt(o, c), u = new Mc(-1, 1, 1, -1, 0, 1);
  let h = null, f = null, d = !1, g, _ = null, m = [], p = !1;
  this.setSize = function(S, b) {
    s.setSize(S, b), a.setSize(S, b);
    for (let T = 0; T < m.length; T++) {
      const y = m[T];
      y.setSize && y.setSize(S, b);
    }
  }, this.setEffects = function(S) {
    m = S, p = m.length > 0 && m[0].isRenderPass === !0;
    const b = s.width, T = s.height;
    for (let y = 0; y < m.length; y++) {
      const R = m[y];
      R.setSize && R.setSize(b, T);
    }
  }, this.begin = function(S, b) {
    if (d || S.toneMapping === 0 && m.length === 0) return !1;
    if (_ = b, b !== null) {
      const T = b.width, y = b.height;
      (s.width !== T || s.height !== y) && this.setSize(T, y);
    }
    return p === !1 && S.setRenderTarget(s), g = S.toneMapping, S.toneMapping = 0, !0;
  }, this.hasRenderPass = function() {
    return p;
  }, this.end = function(S, b) {
    S.toneMapping = g, d = !0;
    let T = s, y = a;
    for (let R = 0; R < m.length; R++) {
      const A = m[R];
      if (A.enabled !== !1 && (A.render(S, y, T, b), A.needsSwap !== !1)) {
        const C = T;
        T = y, y = C;
      }
    }
    if (h !== S.outputColorSpace || f !== S.toneMapping) {
      h = S.outputColorSpace, f = S.toneMapping, c.defines = {}, qe.getTransfer(h) === Qe && (c.defines.SRGB_TRANSFER = "");
      const R = kp[f];
      R && (c.defines[R] = ""), c.needsUpdate = !0;
    }
    c.uniforms.tDiffuse.value = T.texture, S.setRenderTarget(_), S.render(l, u), _ = null, d = !1;
  }, this.isCompositing = function() {
    return d;
  }, this.dispose = function() {
    s.dispose(), a.dispose(), o.dispose(), c.dispose();
  };
}
const Ec = /* @__PURE__ */ new bt(), Ha = /* @__PURE__ */ new Nr(1, 1), Tc = /* @__PURE__ */ new ac(), bc = /* @__PURE__ */ new rh(), Ac = /* @__PURE__ */ new fc(), xl = [], Sl = [], Ml = new Float32Array(16), yl = new Float32Array(9), El = new Float32Array(4);
function cr(r, e, t) {
  const n = r[0];
  if (n <= 0 || n > 0) return r;
  const i = e * t;
  let s = xl[i];
  if (s === void 0 && (s = new Float32Array(i), xl[i] = s), e !== 0) {
    n.toArray(s, 0);
    for (let a = 1, o = 0; a !== e; ++a)
      o += t, r[a].toArray(s, o);
  }
  return s;
}
function At(r, e) {
  if (r.length !== e.length) return !1;
  for (let t = 0, n = r.length; t < n; t++)
    if (r[t] !== e[t]) return !1;
  return !0;
}
function wt(r, e) {
  for (let t = 0, n = e.length; t < n; t++)
    r[t] = e[t];
}
function Xs(r, e) {
  let t = Sl[e];
  t === void 0 && (t = new Int32Array(e), Sl[e] = t);
  for (let n = 0; n !== e; ++n)
    t[n] = r.allocateTextureUnit();
  return t;
}
function Hp(r, e) {
  const t = this.cache;
  t[0] !== e && (r.uniform1f(this.addr, e), t[0] = e);
}
function Wp(r, e) {
  const t = this.cache;
  if (e.x !== void 0)
    (t[0] !== e.x || t[1] !== e.y) && (r.uniform2f(this.addr, e.x, e.y), t[0] = e.x, t[1] = e.y);
  else {
    if (At(t, e)) return;
    r.uniform2fv(this.addr, e), wt(t, e);
  }
}
function Xp(r, e) {
  const t = this.cache;
  if (e.x !== void 0)
    (t[0] !== e.x || t[1] !== e.y || t[2] !== e.z) && (r.uniform3f(this.addr, e.x, e.y, e.z), t[0] = e.x, t[1] = e.y, t[2] = e.z);
  else if (e.r !== void 0)
    (t[0] !== e.r || t[1] !== e.g || t[2] !== e.b) && (r.uniform3f(this.addr, e.r, e.g, e.b), t[0] = e.r, t[1] = e.g, t[2] = e.b);
  else {
    if (At(t, e)) return;
    r.uniform3fv(this.addr, e), wt(t, e);
  }
}
function qp(r, e) {
  const t = this.cache;
  if (e.x !== void 0)
    (t[0] !== e.x || t[1] !== e.y || t[2] !== e.z || t[3] !== e.w) && (r.uniform4f(this.addr, e.x, e.y, e.z, e.w), t[0] = e.x, t[1] = e.y, t[2] = e.z, t[3] = e.w);
  else {
    if (At(t, e)) return;
    r.uniform4fv(this.addr, e), wt(t, e);
  }
}
function Yp(r, e) {
  const t = this.cache, n = e.elements;
  if (n === void 0) {
    if (At(t, e)) return;
    r.uniformMatrix2fv(this.addr, !1, e), wt(t, e);
  } else {
    if (At(t, n)) return;
    El.set(n), r.uniformMatrix2fv(this.addr, !1, El), wt(t, n);
  }
}
function $p(r, e) {
  const t = this.cache, n = e.elements;
  if (n === void 0) {
    if (At(t, e)) return;
    r.uniformMatrix3fv(this.addr, !1, e), wt(t, e);
  } else {
    if (At(t, n)) return;
    yl.set(n), r.uniformMatrix3fv(this.addr, !1, yl), wt(t, n);
  }
}
function Kp(r, e) {
  const t = this.cache, n = e.elements;
  if (n === void 0) {
    if (At(t, e)) return;
    r.uniformMatrix4fv(this.addr, !1, e), wt(t, e);
  } else {
    if (At(t, n)) return;
    Ml.set(n), r.uniformMatrix4fv(this.addr, !1, Ml), wt(t, n);
  }
}
function Zp(r, e) {
  const t = this.cache;
  t[0] !== e && (r.uniform1i(this.addr, e), t[0] = e);
}
function jp(r, e) {
  const t = this.cache;
  if (e.x !== void 0)
    (t[0] !== e.x || t[1] !== e.y) && (r.uniform2i(this.addr, e.x, e.y), t[0] = e.x, t[1] = e.y);
  else {
    if (At(t, e)) return;
    r.uniform2iv(this.addr, e), wt(t, e);
  }
}
function Jp(r, e) {
  const t = this.cache;
  if (e.x !== void 0)
    (t[0] !== e.x || t[1] !== e.y || t[2] !== e.z) && (r.uniform3i(this.addr, e.x, e.y, e.z), t[0] = e.x, t[1] = e.y, t[2] = e.z);
  else {
    if (At(t, e)) return;
    r.uniform3iv(this.addr, e), wt(t, e);
  }
}
function Qp(r, e) {
  const t = this.cache;
  if (e.x !== void 0)
    (t[0] !== e.x || t[1] !== e.y || t[2] !== e.z || t[3] !== e.w) && (r.uniform4i(this.addr, e.x, e.y, e.z, e.w), t[0] = e.x, t[1] = e.y, t[2] = e.z, t[3] = e.w);
  else {
    if (At(t, e)) return;
    r.uniform4iv(this.addr, e), wt(t, e);
  }
}
function em(r, e) {
  const t = this.cache;
  t[0] !== e && (r.uniform1ui(this.addr, e), t[0] = e);
}
function tm(r, e) {
  const t = this.cache;
  if (e.x !== void 0)
    (t[0] !== e.x || t[1] !== e.y) && (r.uniform2ui(this.addr, e.x, e.y), t[0] = e.x, t[1] = e.y);
  else {
    if (At(t, e)) return;
    r.uniform2uiv(this.addr, e), wt(t, e);
  }
}
function nm(r, e) {
  const t = this.cache;
  if (e.x !== void 0)
    (t[0] !== e.x || t[1] !== e.y || t[2] !== e.z) && (r.uniform3ui(this.addr, e.x, e.y, e.z), t[0] = e.x, t[1] = e.y, t[2] = e.z);
  else {
    if (At(t, e)) return;
    r.uniform3uiv(this.addr, e), wt(t, e);
  }
}
function im(r, e) {
  const t = this.cache;
  if (e.x !== void 0)
    (t[0] !== e.x || t[1] !== e.y || t[2] !== e.z || t[3] !== e.w) && (r.uniform4ui(this.addr, e.x, e.y, e.z, e.w), t[0] = e.x, t[1] = e.y, t[2] = e.z, t[3] = e.w);
  else {
    if (At(t, e)) return;
    r.uniform4uiv(this.addr, e), wt(t, e);
  }
}
function rm(r, e, t) {
  const n = this.cache, i = t.allocateTextureUnit();
  n[0] !== i && (r.uniform1i(this.addr, i), n[0] = i);
  let s;
  this.type === r.SAMPLER_2D_SHADOW ? (Ha.compareFunction = t.isReversedDepthBuffer() ? 518 : 515, s = Ha) : s = Ec, t.setTexture2D(e || s, i);
}
function sm(r, e, t) {
  const n = this.cache, i = t.allocateTextureUnit();
  n[0] !== i && (r.uniform1i(this.addr, i), n[0] = i), t.setTexture3D(e || bc, i);
}
function am(r, e, t) {
  const n = this.cache, i = t.allocateTextureUnit();
  n[0] !== i && (r.uniform1i(this.addr, i), n[0] = i), t.setTextureCube(e || Ac, i);
}
function om(r, e, t) {
  const n = this.cache, i = t.allocateTextureUnit();
  n[0] !== i && (r.uniform1i(this.addr, i), n[0] = i), t.setTexture2DArray(e || Tc, i);
}
function lm(r) {
  switch (r) {
    case 5126:
      return Hp;
    // FLOAT
    case 35664:
      return Wp;
    // _VEC2
    case 35665:
      return Xp;
    // _VEC3
    case 35666:
      return qp;
    // _VEC4
    case 35674:
      return Yp;
    // _MAT2
    case 35675:
      return $p;
    // _MAT3
    case 35676:
      return Kp;
    // _MAT4
    case 5124:
    case 35670:
      return Zp;
    // INT, BOOL
    case 35667:
    case 35671:
      return jp;
    // _VEC2
    case 35668:
    case 35672:
      return Jp;
    // _VEC3
    case 35669:
    case 35673:
      return Qp;
    // _VEC4
    case 5125:
      return em;
    // UINT
    case 36294:
      return tm;
    // _VEC2
    case 36295:
      return nm;
    // _VEC3
    case 36296:
      return im;
    // _VEC4
    case 35678:
    // SAMPLER_2D
    case 36198:
    // SAMPLER_EXTERNAL_OES
    case 36298:
    // INT_SAMPLER_2D
    case 36306:
    // UNSIGNED_INT_SAMPLER_2D
    case 35682:
      return rm;
    case 35679:
    // SAMPLER_3D
    case 36299:
    // INT_SAMPLER_3D
    case 36307:
      return sm;
    case 35680:
    // SAMPLER_CUBE
    case 36300:
    // INT_SAMPLER_CUBE
    case 36308:
    // UNSIGNED_INT_SAMPLER_CUBE
    case 36293:
      return am;
    case 36289:
    // SAMPLER_2D_ARRAY
    case 36303:
    // INT_SAMPLER_2D_ARRAY
    case 36311:
    // UNSIGNED_INT_SAMPLER_2D_ARRAY
    case 36292:
      return om;
  }
}
function cm(r, e) {
  r.uniform1fv(this.addr, e);
}
function um(r, e) {
  const t = cr(e, this.size, 2);
  r.uniform2fv(this.addr, t);
}
function hm(r, e) {
  const t = cr(e, this.size, 3);
  r.uniform3fv(this.addr, t);
}
function fm(r, e) {
  const t = cr(e, this.size, 4);
  r.uniform4fv(this.addr, t);
}
function dm(r, e) {
  const t = cr(e, this.size, 4);
  r.uniformMatrix2fv(this.addr, !1, t);
}
function pm(r, e) {
  const t = cr(e, this.size, 9);
  r.uniformMatrix3fv(this.addr, !1, t);
}
function mm(r, e) {
  const t = cr(e, this.size, 16);
  r.uniformMatrix4fv(this.addr, !1, t);
}
function _m(r, e) {
  r.uniform1iv(this.addr, e);
}
function gm(r, e) {
  r.uniform2iv(this.addr, e);
}
function vm(r, e) {
  r.uniform3iv(this.addr, e);
}
function xm(r, e) {
  r.uniform4iv(this.addr, e);
}
function Sm(r, e) {
  r.uniform1uiv(this.addr, e);
}
function Mm(r, e) {
  r.uniform2uiv(this.addr, e);
}
function ym(r, e) {
  r.uniform3uiv(this.addr, e);
}
function Em(r, e) {
  r.uniform4uiv(this.addr, e);
}
function Tm(r, e, t) {
  const n = this.cache, i = e.length, s = Xs(t, i);
  At(n, s) || (r.uniform1iv(this.addr, s), wt(n, s));
  let a;
  this.type === r.SAMPLER_2D_SHADOW ? a = Ha : a = Ec;
  for (let o = 0; o !== i; ++o)
    t.setTexture2D(e[o] || a, s[o]);
}
function bm(r, e, t) {
  const n = this.cache, i = e.length, s = Xs(t, i);
  At(n, s) || (r.uniform1iv(this.addr, s), wt(n, s));
  for (let a = 0; a !== i; ++a)
    t.setTexture3D(e[a] || bc, s[a]);
}
function Am(r, e, t) {
  const n = this.cache, i = e.length, s = Xs(t, i);
  At(n, s) || (r.uniform1iv(this.addr, s), wt(n, s));
  for (let a = 0; a !== i; ++a)
    t.setTextureCube(e[a] || Ac, s[a]);
}
function wm(r, e, t) {
  const n = this.cache, i = e.length, s = Xs(t, i);
  At(n, s) || (r.uniform1iv(this.addr, s), wt(n, s));
  for (let a = 0; a !== i; ++a)
    t.setTexture2DArray(e[a] || Tc, s[a]);
}
function Rm(r) {
  switch (r) {
    case 5126:
      return cm;
    // FLOAT
    case 35664:
      return um;
    // _VEC2
    case 35665:
      return hm;
    // _VEC3
    case 35666:
      return fm;
    // _VEC4
    case 35674:
      return dm;
    // _MAT2
    case 35675:
      return pm;
    // _MAT3
    case 35676:
      return mm;
    // _MAT4
    case 5124:
    case 35670:
      return _m;
    // INT, BOOL
    case 35667:
    case 35671:
      return gm;
    // _VEC2
    case 35668:
    case 35672:
      return vm;
    // _VEC3
    case 35669:
    case 35673:
      return xm;
    // _VEC4
    case 5125:
      return Sm;
    // UINT
    case 36294:
      return Mm;
    // _VEC2
    case 36295:
      return ym;
    // _VEC3
    case 36296:
      return Em;
    // _VEC4
    case 35678:
    // SAMPLER_2D
    case 36198:
    // SAMPLER_EXTERNAL_OES
    case 36298:
    // INT_SAMPLER_2D
    case 36306:
    // UNSIGNED_INT_SAMPLER_2D
    case 35682:
      return Tm;
    case 35679:
    // SAMPLER_3D
    case 36299:
    // INT_SAMPLER_3D
    case 36307:
      return bm;
    case 35680:
    // SAMPLER_CUBE
    case 36300:
    // INT_SAMPLER_CUBE
    case 36308:
    // UNSIGNED_INT_SAMPLER_CUBE
    case 36293:
      return Am;
    case 36289:
    // SAMPLER_2D_ARRAY
    case 36303:
    // INT_SAMPLER_2D_ARRAY
    case 36311:
    // UNSIGNED_INT_SAMPLER_2D_ARRAY
    case 36292:
      return wm;
  }
}
class Cm {
  constructor(e, t, n) {
    this.id = e, this.addr = n, this.cache = [], this.type = t.type, this.setValue = lm(t.type);
  }
}
class Pm {
  constructor(e, t, n) {
    this.id = e, this.addr = n, this.cache = [], this.type = t.type, this.size = t.size, this.setValue = Rm(t.type);
  }
}
class Dm {
  constructor(e) {
    this.id = e, this.seq = [], this.map = {};
  }
  setValue(e, t, n) {
    const i = this.seq;
    for (let s = 0, a = i.length; s !== a; ++s) {
      const o = i[s];
      o.setValue(e, t[o.id], n);
    }
  }
}
const Da = /(\w+)(\])?(\[|\.)?/g;
function Tl(r, e) {
  r.seq.push(e), r.map[e.id] = e;
}
function Lm(r, e, t) {
  const n = r.name, i = n.length;
  for (Da.lastIndex = 0; ; ) {
    const s = Da.exec(n), a = Da.lastIndex;
    let o = s[1];
    const c = s[2] === "]", l = s[3];
    if (c && (o = o | 0), l === void 0 || l === "[" && a + 2 === i) {
      Tl(t, l === void 0 ? new Cm(o, r, e) : new Pm(o, r, e));
      break;
    } else {
      let h = t.map[o];
      h === void 0 && (h = new Dm(o), Tl(t, h)), t = h;
    }
  }
}
class As {
  constructor(e, t) {
    this.seq = [], this.map = {};
    const n = e.getProgramParameter(t, e.ACTIVE_UNIFORMS);
    for (let a = 0; a < n; ++a) {
      const o = e.getActiveUniform(t, a), c = e.getUniformLocation(t, o.name);
      Lm(o, c, this);
    }
    const i = [], s = [];
    for (const a of this.seq)
      a.type === e.SAMPLER_2D_SHADOW || a.type === e.SAMPLER_CUBE_SHADOW || a.type === e.SAMPLER_2D_ARRAY_SHADOW ? i.push(a) : s.push(a);
    i.length > 0 && (this.seq = i.concat(s));
  }
  setValue(e, t, n, i) {
    const s = this.map[t];
    s !== void 0 && s.setValue(e, n, i);
  }
  setOptional(e, t, n) {
    const i = t[n];
    i !== void 0 && this.setValue(e, n, i);
  }
  static upload(e, t, n, i) {
    for (let s = 0, a = t.length; s !== a; ++s) {
      const o = t[s], c = n[o.id];
      c.needsUpdate !== !1 && o.setValue(e, c.value, i);
    }
  }
  static seqWithValue(e, t) {
    const n = [];
    for (let i = 0, s = e.length; i !== s; ++i) {
      const a = e[i];
      a.id in t && n.push(a);
    }
    return n;
  }
}
function bl(r, e, t) {
  const n = r.createShader(e);
  return r.shaderSource(n, t), r.compileShader(n), n;
}
const Fm = 37297;
let Um = 0;
function Im(r, e) {
  const t = r.split(`
`), n = [], i = Math.max(e - 6, 0), s = Math.min(e + 6, t.length);
  for (let a = i; a < s; a++) {
    const o = a + 1;
    n.push(`${o === e ? ">" : " "} ${o}: ${t[a]}`);
  }
  return n.join(`
`);
}
const Al = /* @__PURE__ */ new Ue();
function Nm(r) {
  qe._getMatrix(Al, qe.workingColorSpace, r);
  const e = `mat3( ${Al.elements.map((t) => t.toFixed(4))} )`;
  switch (qe.getTransfer(r)) {
    case Ps:
      return [e, "LinearTransferOETF"];
    case Qe:
      return [e, "sRGBTransferOETF"];
    default:
      return Ce("WebGLProgram: Unsupported color space: ", r), [e, "LinearTransferOETF"];
  }
}
function wl(r, e, t) {
  const n = r.getShaderParameter(e, r.COMPILE_STATUS), s = (r.getShaderInfoLog(e) || "").trim();
  if (n && s === "") return "";
  const a = /ERROR: 0:(\d+)/.exec(s);
  if (a) {
    const o = parseInt(a[1]);
    return t.toUpperCase() + `

` + s + `

` + Im(r.getShaderSource(e), o);
  } else
    return s;
}
function Om(r, e) {
  const t = Nm(e);
  return [
    `vec4 ${r}( vec4 value ) {`,
    `	return ${t[1]}( vec4( value.rgb * ${t[0]}, value.a ) );`,
    "}"
  ].join(`
`);
}
const Bm = {
  1: "Linear",
  2: "Reinhard",
  3: "Cineon",
  4: "ACESFilmic",
  6: "AgX",
  7: "Neutral",
  5: "Custom"
};
function zm(r, e) {
  const t = Bm[e];
  return t === void 0 ? (Ce("WebGLProgram: Unsupported toneMapping:", e), "vec3 " + r + "( vec3 color ) { return LinearToneMapping( color ); }") : "vec3 " + r + "( vec3 color ) { return " + t + "ToneMapping( color ); }";
}
const Es = /* @__PURE__ */ new I();
function Gm() {
  qe.getLuminanceCoefficients(Es);
  const r = Es.x.toFixed(4), e = Es.y.toFixed(4), t = Es.z.toFixed(4);
  return [
    "float luminance( const in vec3 rgb ) {",
    `	const vec3 weights = vec3( ${r}, ${e}, ${t} );`,
    "	return dot( weights, rgb );",
    "}"
  ].join(`
`);
}
function km(r) {
  return [
    r.extensionClipCullDistance ? "#extension GL_ANGLE_clip_cull_distance : require" : "",
    r.extensionMultiDraw ? "#extension GL_ANGLE_multi_draw : require" : ""
  ].filter(Tr).join(`
`);
}
function Vm(r) {
  const e = [];
  for (const t in r) {
    const n = r[t];
    n !== !1 && e.push("#define " + t + " " + n);
  }
  return e.join(`
`);
}
function Hm(r, e) {
  const t = {}, n = r.getProgramParameter(e, r.ACTIVE_ATTRIBUTES);
  for (let i = 0; i < n; i++) {
    const s = r.getActiveAttrib(e, i), a = s.name;
    let o = 1;
    s.type === r.FLOAT_MAT2 && (o = 2), s.type === r.FLOAT_MAT3 && (o = 3), s.type === r.FLOAT_MAT4 && (o = 4), t[a] = {
      type: s.type,
      location: r.getAttribLocation(e, a),
      locationSize: o
    };
  }
  return t;
}
function Tr(r) {
  return r !== "";
}
function Rl(r, e) {
  const t = e.numSpotLightShadows + e.numSpotLightMaps - e.numSpotLightShadowsWithMaps;
  return r.replace(/NUM_DIR_LIGHTS/g, e.numDirLights).replace(/NUM_SPOT_LIGHTS/g, e.numSpotLights).replace(/NUM_SPOT_LIGHT_MAPS/g, e.numSpotLightMaps).replace(/NUM_SPOT_LIGHT_COORDS/g, t).replace(/NUM_RECT_AREA_LIGHTS/g, e.numRectAreaLights).replace(/NUM_POINT_LIGHTS/g, e.numPointLights).replace(/NUM_HEMI_LIGHTS/g, e.numHemiLights).replace(/NUM_DIR_LIGHT_SHADOWS/g, e.numDirLightShadows).replace(/NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS/g, e.numSpotLightShadowsWithMaps).replace(/NUM_SPOT_LIGHT_SHADOWS/g, e.numSpotLightShadows).replace(/NUM_POINT_LIGHT_SHADOWS/g, e.numPointLightShadows);
}
function Cl(r, e) {
  return r.replace(/NUM_CLIPPING_PLANES/g, e.numClippingPlanes).replace(/UNION_CLIPPING_PLANES/g, e.numClippingPlanes - e.numClipIntersection);
}
const Wm = /^[ \t]*#include +<([\w\d./]+)>/gm;
function Wa(r) {
  return r.replace(Wm, qm);
}
const Xm = /* @__PURE__ */ new Map();
function qm(r, e) {
  let t = Ie[e];
  if (t === void 0) {
    const n = Xm.get(e);
    if (n !== void 0)
      t = Ie[n], Ce('WebGLRenderer: Shader chunk "%s" has been deprecated. Use "%s" instead.', e, n);
    else
      throw new Error("Can not resolve #include <" + e + ">");
  }
  return Wa(t);
}
const Ym = /#pragma unroll_loop_start\s+for\s*\(\s*int\s+i\s*=\s*(\d+)\s*;\s*i\s*<\s*(\d+)\s*;\s*i\s*\+\+\s*\)\s*{([\s\S]+?)}\s+#pragma unroll_loop_end/g;
function Pl(r) {
  return r.replace(Ym, $m);
}
function $m(r, e, t, n) {
  let i = "";
  for (let s = parseInt(e); s < parseInt(t); s++)
    i += n.replace(/\[\s*i\s*\]/g, "[ " + s + " ]").replace(/UNROLLED_LOOP_INDEX/g, s);
  return i;
}
function Dl(r) {
  let e = `precision ${r.precision} float;
	precision ${r.precision} int;
	precision ${r.precision} sampler2D;
	precision ${r.precision} samplerCube;
	precision ${r.precision} sampler3D;
	precision ${r.precision} sampler2DArray;
	precision ${r.precision} sampler2DShadow;
	precision ${r.precision} samplerCubeShadow;
	precision ${r.precision} sampler2DArrayShadow;
	precision ${r.precision} isampler2D;
	precision ${r.precision} isampler3D;
	precision ${r.precision} isamplerCube;
	precision ${r.precision} isampler2DArray;
	precision ${r.precision} usampler2D;
	precision ${r.precision} usampler3D;
	precision ${r.precision} usamplerCube;
	precision ${r.precision} usampler2DArray;
	`;
  return r.precision === "highp" ? e += `
#define HIGH_PRECISION` : r.precision === "mediump" ? e += `
#define MEDIUM_PRECISION` : r.precision === "lowp" && (e += `
#define LOW_PRECISION`), e;
}
const Km = {
  1: "SHADOWMAP_TYPE_PCF",
  3: "SHADOWMAP_TYPE_VSM"
};
function Zm(r) {
  return Km[r.shadowMapType] || "SHADOWMAP_TYPE_BASIC";
}
const jm = {
  301: "ENVMAP_TYPE_CUBE",
  302: "ENVMAP_TYPE_CUBE",
  306: "ENVMAP_TYPE_CUBE_UV"
};
function Jm(r) {
  return r.envMap === !1 ? "ENVMAP_TYPE_CUBE" : jm[r.envMapMode] || "ENVMAP_TYPE_CUBE";
}
const Qm = {
  302: "ENVMAP_MODE_REFRACTION"
};
function e_(r) {
  return r.envMap === !1 ? "ENVMAP_MODE_REFLECTION" : Qm[r.envMapMode] || "ENVMAP_MODE_REFLECTION";
}
const t_ = {
  0: "ENVMAP_BLENDING_MULTIPLY",
  1: "ENVMAP_BLENDING_MIX",
  2: "ENVMAP_BLENDING_ADD"
};
function n_(r) {
  return r.envMap === !1 ? "ENVMAP_BLENDING_NONE" : t_[r.combine] || "ENVMAP_BLENDING_NONE";
}
function i_(r) {
  const e = r.envMapCubeUVHeight;
  if (e === null) return null;
  const t = Math.log2(e) - 2, n = 1 / e;
  return { texelWidth: 1 / (3 * Math.max(Math.pow(2, t), 112)), texelHeight: n, maxMip: t };
}
function r_(r, e, t, n) {
  const i = r.getContext(), s = t.defines;
  let a = t.vertexShader, o = t.fragmentShader;
  const c = Zm(t), l = Jm(t), u = e_(t), h = n_(t), f = i_(t), d = km(t), g = Vm(s), _ = i.createProgram();
  let m, p, S = t.glslVersion ? "#version " + t.glslVersion + `
` : "";
  t.isRawShaderMaterial ? (m = [
    "#define SHADER_TYPE " + t.shaderType,
    "#define SHADER_NAME " + t.shaderName,
    g
  ].filter(Tr).join(`
`), m.length > 0 && (m += `
`), p = [
    "#define SHADER_TYPE " + t.shaderType,
    "#define SHADER_NAME " + t.shaderName,
    g
  ].filter(Tr).join(`
`), p.length > 0 && (p += `
`)) : (m = [
    Dl(t),
    "#define SHADER_TYPE " + t.shaderType,
    "#define SHADER_NAME " + t.shaderName,
    g,
    t.extensionClipCullDistance ? "#define USE_CLIP_DISTANCE" : "",
    t.batching ? "#define USE_BATCHING" : "",
    t.batchingColor ? "#define USE_BATCHING_COLOR" : "",
    t.instancing ? "#define USE_INSTANCING" : "",
    t.instancingColor ? "#define USE_INSTANCING_COLOR" : "",
    t.instancingMorph ? "#define USE_INSTANCING_MORPH" : "",
    t.useFog && t.fog ? "#define USE_FOG" : "",
    t.useFog && t.fogExp2 ? "#define FOG_EXP2" : "",
    t.map ? "#define USE_MAP" : "",
    t.envMap ? "#define USE_ENVMAP" : "",
    t.envMap ? "#define " + u : "",
    t.lightMap ? "#define USE_LIGHTMAP" : "",
    t.aoMap ? "#define USE_AOMAP" : "",
    t.bumpMap ? "#define USE_BUMPMAP" : "",
    t.normalMap ? "#define USE_NORMALMAP" : "",
    t.normalMapObjectSpace ? "#define USE_NORMALMAP_OBJECTSPACE" : "",
    t.normalMapTangentSpace ? "#define USE_NORMALMAP_TANGENTSPACE" : "",
    t.displacementMap ? "#define USE_DISPLACEMENTMAP" : "",
    t.emissiveMap ? "#define USE_EMISSIVEMAP" : "",
    t.anisotropy ? "#define USE_ANISOTROPY" : "",
    t.anisotropyMap ? "#define USE_ANISOTROPYMAP" : "",
    t.clearcoatMap ? "#define USE_CLEARCOATMAP" : "",
    t.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "",
    t.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "",
    t.iridescenceMap ? "#define USE_IRIDESCENCEMAP" : "",
    t.iridescenceThicknessMap ? "#define USE_IRIDESCENCE_THICKNESSMAP" : "",
    t.specularMap ? "#define USE_SPECULARMAP" : "",
    t.specularColorMap ? "#define USE_SPECULAR_COLORMAP" : "",
    t.specularIntensityMap ? "#define USE_SPECULAR_INTENSITYMAP" : "",
    t.roughnessMap ? "#define USE_ROUGHNESSMAP" : "",
    t.metalnessMap ? "#define USE_METALNESSMAP" : "",
    t.alphaMap ? "#define USE_ALPHAMAP" : "",
    t.alphaHash ? "#define USE_ALPHAHASH" : "",
    t.transmission ? "#define USE_TRANSMISSION" : "",
    t.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "",
    t.thicknessMap ? "#define USE_THICKNESSMAP" : "",
    t.sheenColorMap ? "#define USE_SHEEN_COLORMAP" : "",
    t.sheenRoughnessMap ? "#define USE_SHEEN_ROUGHNESSMAP" : "",
    //
    t.mapUv ? "#define MAP_UV " + t.mapUv : "",
    t.alphaMapUv ? "#define ALPHAMAP_UV " + t.alphaMapUv : "",
    t.lightMapUv ? "#define LIGHTMAP_UV " + t.lightMapUv : "",
    t.aoMapUv ? "#define AOMAP_UV " + t.aoMapUv : "",
    t.emissiveMapUv ? "#define EMISSIVEMAP_UV " + t.emissiveMapUv : "",
    t.bumpMapUv ? "#define BUMPMAP_UV " + t.bumpMapUv : "",
    t.normalMapUv ? "#define NORMALMAP_UV " + t.normalMapUv : "",
    t.displacementMapUv ? "#define DISPLACEMENTMAP_UV " + t.displacementMapUv : "",
    t.metalnessMapUv ? "#define METALNESSMAP_UV " + t.metalnessMapUv : "",
    t.roughnessMapUv ? "#define ROUGHNESSMAP_UV " + t.roughnessMapUv : "",
    t.anisotropyMapUv ? "#define ANISOTROPYMAP_UV " + t.anisotropyMapUv : "",
    t.clearcoatMapUv ? "#define CLEARCOATMAP_UV " + t.clearcoatMapUv : "",
    t.clearcoatNormalMapUv ? "#define CLEARCOAT_NORMALMAP_UV " + t.clearcoatNormalMapUv : "",
    t.clearcoatRoughnessMapUv ? "#define CLEARCOAT_ROUGHNESSMAP_UV " + t.clearcoatRoughnessMapUv : "",
    t.iridescenceMapUv ? "#define IRIDESCENCEMAP_UV " + t.iridescenceMapUv : "",
    t.iridescenceThicknessMapUv ? "#define IRIDESCENCE_THICKNESSMAP_UV " + t.iridescenceThicknessMapUv : "",
    t.sheenColorMapUv ? "#define SHEEN_COLORMAP_UV " + t.sheenColorMapUv : "",
    t.sheenRoughnessMapUv ? "#define SHEEN_ROUGHNESSMAP_UV " + t.sheenRoughnessMapUv : "",
    t.specularMapUv ? "#define SPECULARMAP_UV " + t.specularMapUv : "",
    t.specularColorMapUv ? "#define SPECULAR_COLORMAP_UV " + t.specularColorMapUv : "",
    t.specularIntensityMapUv ? "#define SPECULAR_INTENSITYMAP_UV " + t.specularIntensityMapUv : "",
    t.transmissionMapUv ? "#define TRANSMISSIONMAP_UV " + t.transmissionMapUv : "",
    t.thicknessMapUv ? "#define THICKNESSMAP_UV " + t.thicknessMapUv : "",
    //
    t.vertexTangents && t.flatShading === !1 ? "#define USE_TANGENT" : "",
    t.vertexColors ? "#define USE_COLOR" : "",
    t.vertexAlphas ? "#define USE_COLOR_ALPHA" : "",
    t.vertexUv1s ? "#define USE_UV1" : "",
    t.vertexUv2s ? "#define USE_UV2" : "",
    t.vertexUv3s ? "#define USE_UV3" : "",
    t.pointsUvs ? "#define USE_POINTS_UV" : "",
    t.flatShading ? "#define FLAT_SHADED" : "",
    t.skinning ? "#define USE_SKINNING" : "",
    t.morphTargets ? "#define USE_MORPHTARGETS" : "",
    t.morphNormals && t.flatShading === !1 ? "#define USE_MORPHNORMALS" : "",
    t.morphColors ? "#define USE_MORPHCOLORS" : "",
    t.morphTargetsCount > 0 ? "#define MORPHTARGETS_TEXTURE_STRIDE " + t.morphTextureStride : "",
    t.morphTargetsCount > 0 ? "#define MORPHTARGETS_COUNT " + t.morphTargetsCount : "",
    t.doubleSided ? "#define DOUBLE_SIDED" : "",
    t.flipSided ? "#define FLIP_SIDED" : "",
    t.shadowMapEnabled ? "#define USE_SHADOWMAP" : "",
    t.shadowMapEnabled ? "#define " + c : "",
    t.sizeAttenuation ? "#define USE_SIZEATTENUATION" : "",
    t.numLightProbes > 0 ? "#define USE_LIGHT_PROBES" : "",
    t.logarithmicDepthBuffer ? "#define USE_LOGARITHMIC_DEPTH_BUFFER" : "",
    t.reversedDepthBuffer ? "#define USE_REVERSED_DEPTH_BUFFER" : "",
    "uniform mat4 modelMatrix;",
    "uniform mat4 modelViewMatrix;",
    "uniform mat4 projectionMatrix;",
    "uniform mat4 viewMatrix;",
    "uniform mat3 normalMatrix;",
    "uniform vec3 cameraPosition;",
    "uniform bool isOrthographic;",
    "#ifdef USE_INSTANCING",
    "	attribute mat4 instanceMatrix;",
    "#endif",
    "#ifdef USE_INSTANCING_COLOR",
    "	attribute vec3 instanceColor;",
    "#endif",
    "#ifdef USE_INSTANCING_MORPH",
    "	uniform sampler2D morphTexture;",
    "#endif",
    "attribute vec3 position;",
    "attribute vec3 normal;",
    "attribute vec2 uv;",
    "#ifdef USE_UV1",
    "	attribute vec2 uv1;",
    "#endif",
    "#ifdef USE_UV2",
    "	attribute vec2 uv2;",
    "#endif",
    "#ifdef USE_UV3",
    "	attribute vec2 uv3;",
    "#endif",
    "#ifdef USE_TANGENT",
    "	attribute vec4 tangent;",
    "#endif",
    "#if defined( USE_COLOR_ALPHA )",
    "	attribute vec4 color;",
    "#elif defined( USE_COLOR )",
    "	attribute vec3 color;",
    "#endif",
    "#ifdef USE_SKINNING",
    "	attribute vec4 skinIndex;",
    "	attribute vec4 skinWeight;",
    "#endif",
    `
`
  ].filter(Tr).join(`
`), p = [
    Dl(t),
    "#define SHADER_TYPE " + t.shaderType,
    "#define SHADER_NAME " + t.shaderName,
    g,
    t.useFog && t.fog ? "#define USE_FOG" : "",
    t.useFog && t.fogExp2 ? "#define FOG_EXP2" : "",
    t.alphaToCoverage ? "#define ALPHA_TO_COVERAGE" : "",
    t.map ? "#define USE_MAP" : "",
    t.matcap ? "#define USE_MATCAP" : "",
    t.envMap ? "#define USE_ENVMAP" : "",
    t.envMap ? "#define " + l : "",
    t.envMap ? "#define " + u : "",
    t.envMap ? "#define " + h : "",
    f ? "#define CUBEUV_TEXEL_WIDTH " + f.texelWidth : "",
    f ? "#define CUBEUV_TEXEL_HEIGHT " + f.texelHeight : "",
    f ? "#define CUBEUV_MAX_MIP " + f.maxMip + ".0" : "",
    t.lightMap ? "#define USE_LIGHTMAP" : "",
    t.aoMap ? "#define USE_AOMAP" : "",
    t.bumpMap ? "#define USE_BUMPMAP" : "",
    t.normalMap ? "#define USE_NORMALMAP" : "",
    t.normalMapObjectSpace ? "#define USE_NORMALMAP_OBJECTSPACE" : "",
    t.normalMapTangentSpace ? "#define USE_NORMALMAP_TANGENTSPACE" : "",
    t.emissiveMap ? "#define USE_EMISSIVEMAP" : "",
    t.anisotropy ? "#define USE_ANISOTROPY" : "",
    t.anisotropyMap ? "#define USE_ANISOTROPYMAP" : "",
    t.clearcoat ? "#define USE_CLEARCOAT" : "",
    t.clearcoatMap ? "#define USE_CLEARCOATMAP" : "",
    t.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "",
    t.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "",
    t.dispersion ? "#define USE_DISPERSION" : "",
    t.iridescence ? "#define USE_IRIDESCENCE" : "",
    t.iridescenceMap ? "#define USE_IRIDESCENCEMAP" : "",
    t.iridescenceThicknessMap ? "#define USE_IRIDESCENCE_THICKNESSMAP" : "",
    t.specularMap ? "#define USE_SPECULARMAP" : "",
    t.specularColorMap ? "#define USE_SPECULAR_COLORMAP" : "",
    t.specularIntensityMap ? "#define USE_SPECULAR_INTENSITYMAP" : "",
    t.roughnessMap ? "#define USE_ROUGHNESSMAP" : "",
    t.metalnessMap ? "#define USE_METALNESSMAP" : "",
    t.alphaMap ? "#define USE_ALPHAMAP" : "",
    t.alphaTest ? "#define USE_ALPHATEST" : "",
    t.alphaHash ? "#define USE_ALPHAHASH" : "",
    t.sheen ? "#define USE_SHEEN" : "",
    t.sheenColorMap ? "#define USE_SHEEN_COLORMAP" : "",
    t.sheenRoughnessMap ? "#define USE_SHEEN_ROUGHNESSMAP" : "",
    t.transmission ? "#define USE_TRANSMISSION" : "",
    t.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "",
    t.thicknessMap ? "#define USE_THICKNESSMAP" : "",
    t.vertexTangents && t.flatShading === !1 ? "#define USE_TANGENT" : "",
    t.vertexColors || t.instancingColor || t.batchingColor ? "#define USE_COLOR" : "",
    t.vertexAlphas ? "#define USE_COLOR_ALPHA" : "",
    t.vertexUv1s ? "#define USE_UV1" : "",
    t.vertexUv2s ? "#define USE_UV2" : "",
    t.vertexUv3s ? "#define USE_UV3" : "",
    t.pointsUvs ? "#define USE_POINTS_UV" : "",
    t.gradientMap ? "#define USE_GRADIENTMAP" : "",
    t.flatShading ? "#define FLAT_SHADED" : "",
    t.doubleSided ? "#define DOUBLE_SIDED" : "",
    t.flipSided ? "#define FLIP_SIDED" : "",
    t.shadowMapEnabled ? "#define USE_SHADOWMAP" : "",
    t.shadowMapEnabled ? "#define " + c : "",
    t.premultipliedAlpha ? "#define PREMULTIPLIED_ALPHA" : "",
    t.numLightProbes > 0 ? "#define USE_LIGHT_PROBES" : "",
    t.decodeVideoTexture ? "#define DECODE_VIDEO_TEXTURE" : "",
    t.decodeVideoTextureEmissive ? "#define DECODE_VIDEO_TEXTURE_EMISSIVE" : "",
    t.logarithmicDepthBuffer ? "#define USE_LOGARITHMIC_DEPTH_BUFFER" : "",
    t.reversedDepthBuffer ? "#define USE_REVERSED_DEPTH_BUFFER" : "",
    "uniform mat4 viewMatrix;",
    "uniform vec3 cameraPosition;",
    "uniform bool isOrthographic;",
    t.toneMapping !== 0 ? "#define TONE_MAPPING" : "",
    t.toneMapping !== 0 ? Ie.tonemapping_pars_fragment : "",
    // this code is required here because it is used by the toneMapping() function defined below
    t.toneMapping !== 0 ? zm("toneMapping", t.toneMapping) : "",
    t.dithering ? "#define DITHERING" : "",
    t.opaque ? "#define OPAQUE" : "",
    Ie.colorspace_pars_fragment,
    // this code is required here because it is used by the various encoding/decoding function defined below
    Om("linearToOutputTexel", t.outputColorSpace),
    Gm(),
    t.useDepthPacking ? "#define DEPTH_PACKING " + t.depthPacking : "",
    `
`
  ].filter(Tr).join(`
`)), a = Wa(a), a = Rl(a, t), a = Cl(a, t), o = Wa(o), o = Rl(o, t), o = Cl(o, t), a = Pl(a), o = Pl(o), t.isRawShaderMaterial !== !0 && (S = `#version 300 es
`, m = [
    d,
    "#define attribute in",
    "#define varying out",
    "#define texture2D texture"
  ].join(`
`) + `
` + m, p = [
    "#define varying in",
    t.glslVersion === Go ? "" : "layout(location = 0) out highp vec4 pc_fragColor;",
    t.glslVersion === Go ? "" : "#define gl_FragColor pc_fragColor",
    "#define gl_FragDepthEXT gl_FragDepth",
    "#define texture2D texture",
    "#define textureCube texture",
    "#define texture2DProj textureProj",
    "#define texture2DLodEXT textureLod",
    "#define texture2DProjLodEXT textureProjLod",
    "#define textureCubeLodEXT textureLod",
    "#define texture2DGradEXT textureGrad",
    "#define texture2DProjGradEXT textureProjGrad",
    "#define textureCubeGradEXT textureGrad"
  ].join(`
`) + `
` + p);
  const b = S + m + a, T = S + p + o, y = bl(i, i.VERTEX_SHADER, b), R = bl(i, i.FRAGMENT_SHADER, T);
  i.attachShader(_, y), i.attachShader(_, R), t.index0AttributeName !== void 0 ? i.bindAttribLocation(_, 0, t.index0AttributeName) : t.morphTargets === !0 && i.bindAttribLocation(_, 0, "position"), i.linkProgram(_);
  function A(P) {
    if (r.debug.checkShaderErrors) {
      const z = i.getProgramInfoLog(_) || "", N = i.getShaderInfoLog(y) || "", W = i.getShaderInfoLog(R) || "", H = z.trim(), k = N.trim(), O = W.trim();
      let Y = !0, ae = !0;
      if (i.getProgramParameter(_, i.LINK_STATUS) === !1)
        if (Y = !1, typeof r.debug.onShaderError == "function")
          r.debug.onShaderError(i, _, y, R);
        else {
          const ne = wl(i, y, "vertex"), ue = wl(i, R, "fragment");
          Xe(
            "THREE.WebGLProgram: Shader Error " + i.getError() + " - VALIDATE_STATUS " + i.getProgramParameter(_, i.VALIDATE_STATUS) + `

Material Name: ` + P.name + `
Material Type: ` + P.type + `

Program Info Log: ` + H + `
` + ne + `
` + ue
          );
        }
      else H !== "" ? Ce("WebGLProgram: Program Info Log:", H) : (k === "" || O === "") && (ae = !1);
      ae && (P.diagnostics = {
        runnable: Y,
        programLog: H,
        vertexShader: {
          log: k,
          prefix: m
        },
        fragmentShader: {
          log: O,
          prefix: p
        }
      });
    }
    i.deleteShader(y), i.deleteShader(R), C = new As(i, _), x = Hm(i, _);
  }
  let C;
  this.getUniforms = function() {
    return C === void 0 && A(this), C;
  };
  let x;
  this.getAttributes = function() {
    return x === void 0 && A(this), x;
  };
  let E = t.rendererExtensionParallelShaderCompile === !1;
  return this.isReady = function() {
    return E === !1 && (E = i.getProgramParameter(_, Fm)), E;
  }, this.destroy = function() {
    n.releaseStatesOfProgram(this), i.deleteProgram(_), this.program = void 0;
  }, this.type = t.shaderType, this.name = t.shaderName, this.id = Um++, this.cacheKey = e, this.usedTimes = 1, this.program = _, this.vertexShader = y, this.fragmentShader = R, this;
}
let s_ = 0;
class a_ {
  constructor() {
    this.shaderCache = /* @__PURE__ */ new Map(), this.materialCache = /* @__PURE__ */ new Map();
  }
  update(e) {
    const t = e.vertexShader, n = e.fragmentShader, i = this._getShaderStage(t), s = this._getShaderStage(n), a = this._getShaderCacheForMaterial(e);
    return a.has(i) === !1 && (a.add(i), i.usedTimes++), a.has(s) === !1 && (a.add(s), s.usedTimes++), this;
  }
  remove(e) {
    const t = this.materialCache.get(e);
    for (const n of t)
      n.usedTimes--, n.usedTimes === 0 && this.shaderCache.delete(n.code);
    return this.materialCache.delete(e), this;
  }
  getVertexShaderID(e) {
    return this._getShaderStage(e.vertexShader).id;
  }
  getFragmentShaderID(e) {
    return this._getShaderStage(e.fragmentShader).id;
  }
  dispose() {
    this.shaderCache.clear(), this.materialCache.clear();
  }
  _getShaderCacheForMaterial(e) {
    const t = this.materialCache;
    let n = t.get(e);
    return n === void 0 && (n = /* @__PURE__ */ new Set(), t.set(e, n)), n;
  }
  _getShaderStage(e) {
    const t = this.shaderCache;
    let n = t.get(e);
    return n === void 0 && (n = new o_(e), t.set(e, n)), n;
  }
}
class o_ {
  constructor(e) {
    this.id = s_++, this.code = e, this.usedTimes = 0;
  }
}
function l_(r, e, t, n, i, s, a) {
  const o = new oc(), c = new a_(), l = /* @__PURE__ */ new Set(), u = [], h = /* @__PURE__ */ new Map(), f = i.logarithmicDepthBuffer;
  let d = i.precision;
  const g = {
    MeshDepthMaterial: "depth",
    MeshDistanceMaterial: "distance",
    MeshNormalMaterial: "normal",
    MeshBasicMaterial: "basic",
    MeshLambertMaterial: "lambert",
    MeshPhongMaterial: "phong",
    MeshToonMaterial: "toon",
    MeshStandardMaterial: "physical",
    MeshPhysicalMaterial: "physical",
    MeshMatcapMaterial: "matcap",
    LineBasicMaterial: "basic",
    LineDashedMaterial: "dashed",
    PointsMaterial: "points",
    ShadowMaterial: "shadow",
    SpriteMaterial: "sprite"
  };
  function _(x) {
    return l.add(x), x === 0 ? "uv" : `uv${x}`;
  }
  function m(x, E, P, z, N) {
    const W = z.fog, H = N.geometry, k = x.isMeshStandardMaterial ? z.environment : null, O = (x.isMeshStandardMaterial ? t : e).get(x.envMap || k), Y = O && O.mapping === 306 ? O.image.height : null, ae = g[x.type];
    x.precision !== null && (d = i.getMaxPrecision(x.precision), d !== x.precision && Ce("WebGLProgram.getParameters:", x.precision, "not supported, using", d, "instead."));
    const ne = H.morphAttributes.position || H.morphAttributes.normal || H.morphAttributes.color, ue = ne !== void 0 ? ne.length : 0;
    let Pe = 0;
    H.morphAttributes.position !== void 0 && (Pe = 1), H.morphAttributes.normal !== void 0 && (Pe = 2), H.morphAttributes.color !== void 0 && (Pe = 3);
    let Le, Ve, He, $;
    if (ae) {
      const je = An[ae];
      Le = je.vertexShader, Ve = je.fragmentShader;
    } else
      Le = x.vertexShader, Ve = x.fragmentShader, c.update(x), He = c.getVertexShaderID(x), $ = c.getFragmentShaderID(x);
    const J = r.getRenderTarget(), me = r.state.buffers.depth.getReversed(), Fe = N.isInstancedMesh === !0, ve = N.isBatchedMesh === !0, Ye = !!x.map, Rt = !!x.matcap, We = !!O, Ze = !!x.aoMap, nt = !!x.lightMap, Ne = !!x.bumpMap, St = !!x.normalMap, D = !!x.displacementMap, Mt = !!x.emissiveMap, Ke = !!x.metalnessMap, at = !!x.roughnessMap, Se = x.anisotropy > 0, w = x.clearcoat > 0, v = x.dispersion > 0, F = x.iridescence > 0, q = x.sheen > 0, j = x.transmission > 0, X = Se && !!x.anisotropyMap, ye = w && !!x.clearcoatMap, re = w && !!x.clearcoatNormalMap, xe = w && !!x.clearcoatRoughnessMap, Re = F && !!x.iridescenceMap, ee = F && !!x.iridescenceThicknessMap, oe = q && !!x.sheenColorMap, ge = q && !!x.sheenRoughnessMap, Me = !!x.specularMap, se = !!x.specularColorMap, Oe = !!x.specularIntensityMap, L = j && !!x.transmissionMap, fe = j && !!x.thicknessMap, te = !!x.gradientMap, de = !!x.alphaMap, Q = x.alphaTest > 0, Z = !!x.alphaHash, ie = !!x.extensions;
    let De = 0;
    x.toneMapped && (J === null || J.isXRRenderTarget === !0) && (De = r.toneMapping);
    const ot = {
      shaderID: ae,
      shaderType: x.type,
      shaderName: x.name,
      vertexShader: Le,
      fragmentShader: Ve,
      defines: x.defines,
      customVertexShaderID: He,
      customFragmentShaderID: $,
      isRawShaderMaterial: x.isRawShaderMaterial === !0,
      glslVersion: x.glslVersion,
      precision: d,
      batching: ve,
      batchingColor: ve && N._colorsTexture !== null,
      instancing: Fe,
      instancingColor: Fe && N.instanceColor !== null,
      instancingMorph: Fe && N.morphTexture !== null,
      outputColorSpace: J === null ? r.outputColorSpace : J.isXRRenderTarget === !0 ? J.texture.colorSpace : tr,
      alphaToCoverage: !!x.alphaToCoverage,
      map: Ye,
      matcap: Rt,
      envMap: We,
      envMapMode: We && O.mapping,
      envMapCubeUVHeight: Y,
      aoMap: Ze,
      lightMap: nt,
      bumpMap: Ne,
      normalMap: St,
      displacementMap: D,
      emissiveMap: Mt,
      normalMapObjectSpace: St && x.normalMapType === 1,
      normalMapTangentSpace: St && x.normalMapType === 0,
      metalnessMap: Ke,
      roughnessMap: at,
      anisotropy: Se,
      anisotropyMap: X,
      clearcoat: w,
      clearcoatMap: ye,
      clearcoatNormalMap: re,
      clearcoatRoughnessMap: xe,
      dispersion: v,
      iridescence: F,
      iridescenceMap: Re,
      iridescenceThicknessMap: ee,
      sheen: q,
      sheenColorMap: oe,
      sheenRoughnessMap: ge,
      specularMap: Me,
      specularColorMap: se,
      specularIntensityMap: Oe,
      transmission: j,
      transmissionMap: L,
      thicknessMap: fe,
      gradientMap: te,
      opaque: x.transparent === !1 && x.blending === 1 && x.alphaToCoverage === !1,
      alphaMap: de,
      alphaTest: Q,
      alphaHash: Z,
      combine: x.combine,
      //
      mapUv: Ye && _(x.map.channel),
      aoMapUv: Ze && _(x.aoMap.channel),
      lightMapUv: nt && _(x.lightMap.channel),
      bumpMapUv: Ne && _(x.bumpMap.channel),
      normalMapUv: St && _(x.normalMap.channel),
      displacementMapUv: D && _(x.displacementMap.channel),
      emissiveMapUv: Mt && _(x.emissiveMap.channel),
      metalnessMapUv: Ke && _(x.metalnessMap.channel),
      roughnessMapUv: at && _(x.roughnessMap.channel),
      anisotropyMapUv: X && _(x.anisotropyMap.channel),
      clearcoatMapUv: ye && _(x.clearcoatMap.channel),
      clearcoatNormalMapUv: re && _(x.clearcoatNormalMap.channel),
      clearcoatRoughnessMapUv: xe && _(x.clearcoatRoughnessMap.channel),
      iridescenceMapUv: Re && _(x.iridescenceMap.channel),
      iridescenceThicknessMapUv: ee && _(x.iridescenceThicknessMap.channel),
      sheenColorMapUv: oe && _(x.sheenColorMap.channel),
      sheenRoughnessMapUv: ge && _(x.sheenRoughnessMap.channel),
      specularMapUv: Me && _(x.specularMap.channel),
      specularColorMapUv: se && _(x.specularColorMap.channel),
      specularIntensityMapUv: Oe && _(x.specularIntensityMap.channel),
      transmissionMapUv: L && _(x.transmissionMap.channel),
      thicknessMapUv: fe && _(x.thicknessMap.channel),
      alphaMapUv: de && _(x.alphaMap.channel),
      //
      vertexTangents: !!H.attributes.tangent && (St || Se),
      vertexColors: x.vertexColors,
      vertexAlphas: x.vertexColors === !0 && !!H.attributes.color && H.attributes.color.itemSize === 4,
      pointsUvs: N.isPoints === !0 && !!H.attributes.uv && (Ye || de),
      fog: !!W,
      useFog: x.fog === !0,
      fogExp2: !!W && W.isFogExp2,
      flatShading: x.flatShading === !0 && x.wireframe === !1,
      sizeAttenuation: x.sizeAttenuation === !0,
      logarithmicDepthBuffer: f,
      reversedDepthBuffer: me,
      skinning: N.isSkinnedMesh === !0,
      morphTargets: H.morphAttributes.position !== void 0,
      morphNormals: H.morphAttributes.normal !== void 0,
      morphColors: H.morphAttributes.color !== void 0,
      morphTargetsCount: ue,
      morphTextureStride: Pe,
      numDirLights: E.directional.length,
      numPointLights: E.point.length,
      numSpotLights: E.spot.length,
      numSpotLightMaps: E.spotLightMap.length,
      numRectAreaLights: E.rectArea.length,
      numHemiLights: E.hemi.length,
      numDirLightShadows: E.directionalShadowMap.length,
      numPointLightShadows: E.pointShadowMap.length,
      numSpotLightShadows: E.spotShadowMap.length,
      numSpotLightShadowsWithMaps: E.numSpotLightShadowsWithMaps,
      numLightProbes: E.numLightProbes,
      numClippingPlanes: a.numPlanes,
      numClipIntersection: a.numIntersection,
      dithering: x.dithering,
      shadowMapEnabled: r.shadowMap.enabled && P.length > 0,
      shadowMapType: r.shadowMap.type,
      toneMapping: De,
      decodeVideoTexture: Ye && x.map.isVideoTexture === !0 && qe.getTransfer(x.map.colorSpace) === Qe,
      decodeVideoTextureEmissive: Mt && x.emissiveMap.isVideoTexture === !0 && qe.getTransfer(x.emissiveMap.colorSpace) === Qe,
      premultipliedAlpha: x.premultipliedAlpha,
      doubleSided: x.side === 2,
      flipSided: x.side === 1,
      useDepthPacking: x.depthPacking >= 0,
      depthPacking: x.depthPacking || 0,
      index0AttributeName: x.index0AttributeName,
      extensionClipCullDistance: ie && x.extensions.clipCullDistance === !0 && n.has("WEBGL_clip_cull_distance"),
      extensionMultiDraw: (ie && x.extensions.multiDraw === !0 || ve) && n.has("WEBGL_multi_draw"),
      rendererExtensionParallelShaderCompile: n.has("KHR_parallel_shader_compile"),
      customProgramCacheKey: x.customProgramCacheKey()
    };
    return ot.vertexUv1s = l.has(1), ot.vertexUv2s = l.has(2), ot.vertexUv3s = l.has(3), l.clear(), ot;
  }
  function p(x) {
    const E = [];
    if (x.shaderID ? E.push(x.shaderID) : (E.push(x.customVertexShaderID), E.push(x.customFragmentShaderID)), x.defines !== void 0)
      for (const P in x.defines)
        E.push(P), E.push(x.defines[P]);
    return x.isRawShaderMaterial === !1 && (S(E, x), b(E, x), E.push(r.outputColorSpace)), E.push(x.customProgramCacheKey), E.join();
  }
  function S(x, E) {
    x.push(E.precision), x.push(E.outputColorSpace), x.push(E.envMapMode), x.push(E.envMapCubeUVHeight), x.push(E.mapUv), x.push(E.alphaMapUv), x.push(E.lightMapUv), x.push(E.aoMapUv), x.push(E.bumpMapUv), x.push(E.normalMapUv), x.push(E.displacementMapUv), x.push(E.emissiveMapUv), x.push(E.metalnessMapUv), x.push(E.roughnessMapUv), x.push(E.anisotropyMapUv), x.push(E.clearcoatMapUv), x.push(E.clearcoatNormalMapUv), x.push(E.clearcoatRoughnessMapUv), x.push(E.iridescenceMapUv), x.push(E.iridescenceThicknessMapUv), x.push(E.sheenColorMapUv), x.push(E.sheenRoughnessMapUv), x.push(E.specularMapUv), x.push(E.specularColorMapUv), x.push(E.specularIntensityMapUv), x.push(E.transmissionMapUv), x.push(E.thicknessMapUv), x.push(E.combine), x.push(E.fogExp2), x.push(E.sizeAttenuation), x.push(E.morphTargetsCount), x.push(E.morphAttributeCount), x.push(E.numDirLights), x.push(E.numPointLights), x.push(E.numSpotLights), x.push(E.numSpotLightMaps), x.push(E.numHemiLights), x.push(E.numRectAreaLights), x.push(E.numDirLightShadows), x.push(E.numPointLightShadows), x.push(E.numSpotLightShadows), x.push(E.numSpotLightShadowsWithMaps), x.push(E.numLightProbes), x.push(E.shadowMapType), x.push(E.toneMapping), x.push(E.numClippingPlanes), x.push(E.numClipIntersection), x.push(E.depthPacking);
  }
  function b(x, E) {
    o.disableAll(), E.instancing && o.enable(0), E.instancingColor && o.enable(1), E.instancingMorph && o.enable(2), E.matcap && o.enable(3), E.envMap && o.enable(4), E.normalMapObjectSpace && o.enable(5), E.normalMapTangentSpace && o.enable(6), E.clearcoat && o.enable(7), E.iridescence && o.enable(8), E.alphaTest && o.enable(9), E.vertexColors && o.enable(10), E.vertexAlphas && o.enable(11), E.vertexUv1s && o.enable(12), E.vertexUv2s && o.enable(13), E.vertexUv3s && o.enable(14), E.vertexTangents && o.enable(15), E.anisotropy && o.enable(16), E.alphaHash && o.enable(17), E.batching && o.enable(18), E.dispersion && o.enable(19), E.batchingColor && o.enable(20), E.gradientMap && o.enable(21), x.push(o.mask), o.disableAll(), E.fog && o.enable(0), E.useFog && o.enable(1), E.flatShading && o.enable(2), E.logarithmicDepthBuffer && o.enable(3), E.reversedDepthBuffer && o.enable(4), E.skinning && o.enable(5), E.morphTargets && o.enable(6), E.morphNormals && o.enable(7), E.morphColors && o.enable(8), E.premultipliedAlpha && o.enable(9), E.shadowMapEnabled && o.enable(10), E.doubleSided && o.enable(11), E.flipSided && o.enable(12), E.useDepthPacking && o.enable(13), E.dithering && o.enable(14), E.transmission && o.enable(15), E.sheen && o.enable(16), E.opaque && o.enable(17), E.pointsUvs && o.enable(18), E.decodeVideoTexture && o.enable(19), E.decodeVideoTextureEmissive && o.enable(20), E.alphaToCoverage && o.enable(21), x.push(o.mask);
  }
  function T(x) {
    const E = g[x.type];
    let P;
    if (E) {
      const z = An[E];
      P = gh.clone(z.uniforms);
    } else
      P = x.uniforms;
    return P;
  }
  function y(x, E) {
    let P = h.get(E);
    return P !== void 0 ? ++P.usedTimes : (P = new r_(r, E, x, s), u.push(P), h.set(E, P)), P;
  }
  function R(x) {
    if (--x.usedTimes === 0) {
      const E = u.indexOf(x);
      u[E] = u[u.length - 1], u.pop(), h.delete(x.cacheKey), x.destroy();
    }
  }
  function A(x) {
    c.remove(x);
  }
  function C() {
    c.dispose();
  }
  return {
    getParameters: m,
    getProgramCacheKey: p,
    getUniforms: T,
    acquireProgram: y,
    releaseProgram: R,
    releaseShaderCache: A,
    // Exposed for resource monitoring & error feedback via renderer.info:
    programs: u,
    dispose: C
  };
}
function c_() {
  let r = /* @__PURE__ */ new WeakMap();
  function e(a) {
    return r.has(a);
  }
  function t(a) {
    let o = r.get(a);
    return o === void 0 && (o = {}, r.set(a, o)), o;
  }
  function n(a) {
    r.delete(a);
  }
  function i(a, o, c) {
    r.get(a)[o] = c;
  }
  function s() {
    r = /* @__PURE__ */ new WeakMap();
  }
  return {
    has: e,
    get: t,
    remove: n,
    update: i,
    dispose: s
  };
}
function u_(r, e) {
  return r.groupOrder !== e.groupOrder ? r.groupOrder - e.groupOrder : r.renderOrder !== e.renderOrder ? r.renderOrder - e.renderOrder : r.material.id !== e.material.id ? r.material.id - e.material.id : r.z !== e.z ? r.z - e.z : r.id - e.id;
}
function Ll(r, e) {
  return r.groupOrder !== e.groupOrder ? r.groupOrder - e.groupOrder : r.renderOrder !== e.renderOrder ? r.renderOrder - e.renderOrder : r.z !== e.z ? e.z - r.z : r.id - e.id;
}
function Fl() {
  const r = [];
  let e = 0;
  const t = [], n = [], i = [];
  function s() {
    e = 0, t.length = 0, n.length = 0, i.length = 0;
  }
  function a(h, f, d, g, _, m) {
    let p = r[e];
    return p === void 0 ? (p = {
      id: h.id,
      object: h,
      geometry: f,
      material: d,
      groupOrder: g,
      renderOrder: h.renderOrder,
      z: _,
      group: m
    }, r[e] = p) : (p.id = h.id, p.object = h, p.geometry = f, p.material = d, p.groupOrder = g, p.renderOrder = h.renderOrder, p.z = _, p.group = m), e++, p;
  }
  function o(h, f, d, g, _, m) {
    const p = a(h, f, d, g, _, m);
    d.transmission > 0 ? n.push(p) : d.transparent === !0 ? i.push(p) : t.push(p);
  }
  function c(h, f, d, g, _, m) {
    const p = a(h, f, d, g, _, m);
    d.transmission > 0 ? n.unshift(p) : d.transparent === !0 ? i.unshift(p) : t.unshift(p);
  }
  function l(h, f) {
    t.length > 1 && t.sort(h || u_), n.length > 1 && n.sort(f || Ll), i.length > 1 && i.sort(f || Ll);
  }
  function u() {
    for (let h = e, f = r.length; h < f; h++) {
      const d = r[h];
      if (d.id === null) break;
      d.id = null, d.object = null, d.geometry = null, d.material = null, d.group = null;
    }
  }
  return {
    opaque: t,
    transmissive: n,
    transparent: i,
    init: s,
    push: o,
    unshift: c,
    finish: u,
    sort: l
  };
}
function h_() {
  let r = /* @__PURE__ */ new WeakMap();
  function e(n, i) {
    const s = r.get(n);
    let a;
    return s === void 0 ? (a = new Fl(), r.set(n, [a])) : i >= s.length ? (a = new Fl(), s.push(a)) : a = s[i], a;
  }
  function t() {
    r = /* @__PURE__ */ new WeakMap();
  }
  return {
    get: e,
    dispose: t
  };
}
function f_() {
  const r = {};
  return {
    get: function(e) {
      if (r[e.id] !== void 0)
        return r[e.id];
      let t;
      switch (e.type) {
        case "DirectionalLight":
          t = {
            direction: new I(),
            color: new Ge()
          };
          break;
        case "SpotLight":
          t = {
            position: new I(),
            direction: new I(),
            color: new Ge(),
            distance: 0,
            coneCos: 0,
            penumbraCos: 0,
            decay: 0
          };
          break;
        case "PointLight":
          t = {
            position: new I(),
            color: new Ge(),
            distance: 0,
            decay: 0
          };
          break;
        case "HemisphereLight":
          t = {
            direction: new I(),
            skyColor: new Ge(),
            groundColor: new Ge()
          };
          break;
        case "RectAreaLight":
          t = {
            color: new Ge(),
            position: new I(),
            halfWidth: new I(),
            halfHeight: new I()
          };
          break;
      }
      return r[e.id] = t, t;
    }
  };
}
function d_() {
  const r = {};
  return {
    get: function(e) {
      if (r[e.id] !== void 0)
        return r[e.id];
      let t;
      switch (e.type) {
        case "DirectionalLight":
          t = {
            shadowIntensity: 1,
            shadowBias: 0,
            shadowNormalBias: 0,
            shadowRadius: 1,
            shadowMapSize: new Ae()
          };
          break;
        case "SpotLight":
          t = {
            shadowIntensity: 1,
            shadowBias: 0,
            shadowNormalBias: 0,
            shadowRadius: 1,
            shadowMapSize: new Ae()
          };
          break;
        case "PointLight":
          t = {
            shadowIntensity: 1,
            shadowBias: 0,
            shadowNormalBias: 0,
            shadowRadius: 1,
            shadowMapSize: new Ae(),
            shadowCameraNear: 1,
            shadowCameraFar: 1e3
          };
          break;
      }
      return r[e.id] = t, t;
    }
  };
}
let p_ = 0;
function m_(r, e) {
  return (e.castShadow ? 2 : 0) - (r.castShadow ? 2 : 0) + (e.map ? 1 : 0) - (r.map ? 1 : 0);
}
function __(r) {
  const e = new f_(), t = d_(), n = {
    version: 0,
    hash: {
      directionalLength: -1,
      pointLength: -1,
      spotLength: -1,
      rectAreaLength: -1,
      hemiLength: -1,
      numDirectionalShadows: -1,
      numPointShadows: -1,
      numSpotShadows: -1,
      numSpotMaps: -1,
      numLightProbes: -1
    },
    ambient: [0, 0, 0],
    probe: [],
    directional: [],
    directionalShadow: [],
    directionalShadowMap: [],
    directionalShadowMatrix: [],
    spot: [],
    spotLightMap: [],
    spotShadow: [],
    spotShadowMap: [],
    spotLightMatrix: [],
    rectArea: [],
    rectAreaLTC1: null,
    rectAreaLTC2: null,
    point: [],
    pointShadow: [],
    pointShadowMap: [],
    pointShadowMatrix: [],
    hemi: [],
    numSpotLightShadowsWithMaps: 0,
    numLightProbes: 0
  };
  for (let l = 0; l < 9; l++) n.probe.push(new I());
  const i = new I(), s = new ht(), a = new ht();
  function o(l) {
    let u = 0, h = 0, f = 0;
    for (let x = 0; x < 9; x++) n.probe[x].set(0, 0, 0);
    let d = 0, g = 0, _ = 0, m = 0, p = 0, S = 0, b = 0, T = 0, y = 0, R = 0, A = 0;
    l.sort(m_);
    for (let x = 0, E = l.length; x < E; x++) {
      const P = l[x], z = P.color, N = P.intensity, W = P.distance;
      let H = null;
      if (P.shadow && P.shadow.map && (P.shadow.map.texture.format === 1030 ? H = P.shadow.map.texture : H = P.shadow.map.depthTexture || P.shadow.map.texture), P.isAmbientLight)
        u += z.r * N, h += z.g * N, f += z.b * N;
      else if (P.isLightProbe) {
        for (let k = 0; k < 9; k++)
          n.probe[k].addScaledVector(P.sh.coefficients[k], N);
        A++;
      } else if (P.isDirectionalLight) {
        const k = e.get(P);
        if (k.color.copy(P.color).multiplyScalar(P.intensity), P.castShadow) {
          const O = P.shadow, Y = t.get(P);
          Y.shadowIntensity = O.intensity, Y.shadowBias = O.bias, Y.shadowNormalBias = O.normalBias, Y.shadowRadius = O.radius, Y.shadowMapSize = O.mapSize, n.directionalShadow[d] = Y, n.directionalShadowMap[d] = H, n.directionalShadowMatrix[d] = P.shadow.matrix, S++;
        }
        n.directional[d] = k, d++;
      } else if (P.isSpotLight) {
        const k = e.get(P);
        k.position.setFromMatrixPosition(P.matrixWorld), k.color.copy(z).multiplyScalar(N), k.distance = W, k.coneCos = Math.cos(P.angle), k.penumbraCos = Math.cos(P.angle * (1 - P.penumbra)), k.decay = P.decay, n.spot[_] = k;
        const O = P.shadow;
        if (P.map && (n.spotLightMap[y] = P.map, y++, O.updateMatrices(P), P.castShadow && R++), n.spotLightMatrix[_] = O.matrix, P.castShadow) {
          const Y = t.get(P);
          Y.shadowIntensity = O.intensity, Y.shadowBias = O.bias, Y.shadowNormalBias = O.normalBias, Y.shadowRadius = O.radius, Y.shadowMapSize = O.mapSize, n.spotShadow[_] = Y, n.spotShadowMap[_] = H, T++;
        }
        _++;
      } else if (P.isRectAreaLight) {
        const k = e.get(P);
        k.color.copy(z).multiplyScalar(N), k.halfWidth.set(P.width * 0.5, 0, 0), k.halfHeight.set(0, P.height * 0.5, 0), n.rectArea[m] = k, m++;
      } else if (P.isPointLight) {
        const k = e.get(P);
        if (k.color.copy(P.color).multiplyScalar(P.intensity), k.distance = P.distance, k.decay = P.decay, P.castShadow) {
          const O = P.shadow, Y = t.get(P);
          Y.shadowIntensity = O.intensity, Y.shadowBias = O.bias, Y.shadowNormalBias = O.normalBias, Y.shadowRadius = O.radius, Y.shadowMapSize = O.mapSize, Y.shadowCameraNear = O.camera.near, Y.shadowCameraFar = O.camera.far, n.pointShadow[g] = Y, n.pointShadowMap[g] = H, n.pointShadowMatrix[g] = P.shadow.matrix, b++;
        }
        n.point[g] = k, g++;
      } else if (P.isHemisphereLight) {
        const k = e.get(P);
        k.skyColor.copy(P.color).multiplyScalar(N), k.groundColor.copy(P.groundColor).multiplyScalar(N), n.hemi[p] = k, p++;
      }
    }
    m > 0 && (r.has("OES_texture_float_linear") === !0 ? (n.rectAreaLTC1 = ce.LTC_FLOAT_1, n.rectAreaLTC2 = ce.LTC_FLOAT_2) : (n.rectAreaLTC1 = ce.LTC_HALF_1, n.rectAreaLTC2 = ce.LTC_HALF_2)), n.ambient[0] = u, n.ambient[1] = h, n.ambient[2] = f;
    const C = n.hash;
    (C.directionalLength !== d || C.pointLength !== g || C.spotLength !== _ || C.rectAreaLength !== m || C.hemiLength !== p || C.numDirectionalShadows !== S || C.numPointShadows !== b || C.numSpotShadows !== T || C.numSpotMaps !== y || C.numLightProbes !== A) && (n.directional.length = d, n.spot.length = _, n.rectArea.length = m, n.point.length = g, n.hemi.length = p, n.directionalShadow.length = S, n.directionalShadowMap.length = S, n.pointShadow.length = b, n.pointShadowMap.length = b, n.spotShadow.length = T, n.spotShadowMap.length = T, n.directionalShadowMatrix.length = S, n.pointShadowMatrix.length = b, n.spotLightMatrix.length = T + y - R, n.spotLightMap.length = y, n.numSpotLightShadowsWithMaps = R, n.numLightProbes = A, C.directionalLength = d, C.pointLength = g, C.spotLength = _, C.rectAreaLength = m, C.hemiLength = p, C.numDirectionalShadows = S, C.numPointShadows = b, C.numSpotShadows = T, C.numSpotMaps = y, C.numLightProbes = A, n.version = p_++);
  }
  function c(l, u) {
    let h = 0, f = 0, d = 0, g = 0, _ = 0;
    const m = u.matrixWorldInverse;
    for (let p = 0, S = l.length; p < S; p++) {
      const b = l[p];
      if (b.isDirectionalLight) {
        const T = n.directional[h];
        T.direction.setFromMatrixPosition(b.matrixWorld), i.setFromMatrixPosition(b.target.matrixWorld), T.direction.sub(i), T.direction.transformDirection(m), h++;
      } else if (b.isSpotLight) {
        const T = n.spot[d];
        T.position.setFromMatrixPosition(b.matrixWorld), T.position.applyMatrix4(m), T.direction.setFromMatrixPosition(b.matrixWorld), i.setFromMatrixPosition(b.target.matrixWorld), T.direction.sub(i), T.direction.transformDirection(m), d++;
      } else if (b.isRectAreaLight) {
        const T = n.rectArea[g];
        T.position.setFromMatrixPosition(b.matrixWorld), T.position.applyMatrix4(m), a.identity(), s.copy(b.matrixWorld), s.premultiply(m), a.extractRotation(s), T.halfWidth.set(b.width * 0.5, 0, 0), T.halfHeight.set(0, b.height * 0.5, 0), T.halfWidth.applyMatrix4(a), T.halfHeight.applyMatrix4(a), g++;
      } else if (b.isPointLight) {
        const T = n.point[f];
        T.position.setFromMatrixPosition(b.matrixWorld), T.position.applyMatrix4(m), f++;
      } else if (b.isHemisphereLight) {
        const T = n.hemi[_];
        T.direction.setFromMatrixPosition(b.matrixWorld), T.direction.transformDirection(m), _++;
      }
    }
  }
  return {
    setup: o,
    setupView: c,
    state: n
  };
}
function Ul(r) {
  const e = new __(r), t = [], n = [];
  function i(u) {
    l.camera = u, t.length = 0, n.length = 0;
  }
  function s(u) {
    t.push(u);
  }
  function a(u) {
    n.push(u);
  }
  function o() {
    e.setup(t);
  }
  function c(u) {
    e.setupView(t, u);
  }
  const l = {
    lightsArray: t,
    shadowsArray: n,
    camera: null,
    lights: e,
    transmissionRenderTarget: {}
  };
  return {
    init: i,
    state: l,
    setupLights: o,
    setupLightsView: c,
    pushLight: s,
    pushShadow: a
  };
}
function g_(r) {
  let e = /* @__PURE__ */ new WeakMap();
  function t(i, s = 0) {
    const a = e.get(i);
    let o;
    return a === void 0 ? (o = new Ul(r), e.set(i, [o])) : s >= a.length ? (o = new Ul(r), a.push(o)) : o = a[s], o;
  }
  function n() {
    e = /* @__PURE__ */ new WeakMap();
  }
  return {
    get: t,
    dispose: n
  };
}
const v_ = `void main() {
	gl_Position = vec4( position, 1.0 );
}`, x_ = `uniform sampler2D shadow_pass;
uniform vec2 resolution;
uniform float radius;
void main() {
	const float samples = float( VSM_SAMPLES );
	float mean = 0.0;
	float squared_mean = 0.0;
	float uvStride = samples <= 1.0 ? 0.0 : 2.0 / ( samples - 1.0 );
	float uvStart = samples <= 1.0 ? 0.0 : - 1.0;
	for ( float i = 0.0; i < samples; i ++ ) {
		float uvOffset = uvStart + i * uvStride;
		#ifdef HORIZONTAL_PASS
			vec2 distribution = texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( uvOffset, 0.0 ) * radius ) / resolution ).rg;
			mean += distribution.x;
			squared_mean += distribution.y * distribution.y + distribution.x * distribution.x;
		#else
			float depth = texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( 0.0, uvOffset ) * radius ) / resolution ).r;
			mean += depth;
			squared_mean += depth * depth;
		#endif
	}
	mean = mean / samples;
	squared_mean = squared_mean / samples;
	float std_dev = sqrt( max( 0.0, squared_mean - mean * mean ) );
	gl_FragColor = vec4( mean, std_dev, 0.0, 1.0 );
}`, S_ = [
  /* @__PURE__ */ new I(1, 0, 0),
  /* @__PURE__ */ new I(-1, 0, 0),
  /* @__PURE__ */ new I(0, 1, 0),
  /* @__PURE__ */ new I(0, -1, 0),
  /* @__PURE__ */ new I(0, 0, 1),
  /* @__PURE__ */ new I(0, 0, -1)
], M_ = [
  /* @__PURE__ */ new I(0, -1, 0),
  /* @__PURE__ */ new I(0, -1, 0),
  /* @__PURE__ */ new I(0, 0, 1),
  /* @__PURE__ */ new I(0, 0, -1),
  /* @__PURE__ */ new I(0, -1, 0),
  /* @__PURE__ */ new I(0, -1, 0)
], Il = /* @__PURE__ */ new ht(), Sr = /* @__PURE__ */ new I(), La = /* @__PURE__ */ new I();
function y_(r, e, t) {
  let n = new _c();
  const i = new Ae(), s = new Ae(), a = new xt(), o = new Uh(), c = new Ih(), l = {}, u = t.maxTextureSize, h = { 0: 1, 1: 0, 2: 2 }, f = new Ht({
    defines: {
      VSM_SAMPLES: 8
    },
    uniforms: {
      shadow_pass: { value: null },
      resolution: { value: new Ae() },
      radius: { value: 4 }
    },
    vertexShader: v_,
    fragmentShader: x_
  }), d = f.clone();
  d.defines.HORIZONTAL_PASS = 1;
  const g = new Qt();
  g.setAttribute(
    "position",
    new Nt(
      new Float32Array([-1, -1, 0.5, 3, -1, 0.5, -1, 3, 0.5]),
      3
    )
  );
  const _ = new Lt(g, f), m = this;
  this.enabled = !1, this.autoUpdate = !0, this.needsUpdate = !1, this.type = 1;
  let p = this.type;
  this.render = function(R, A, C) {
    if (m.enabled === !1 || m.autoUpdate === !1 && m.needsUpdate === !1 || R.length === 0) return;
    R.type === 2 && (Ce("WebGLShadowMap: PCFSoftShadowMap has been deprecated. Using PCFShadowMap instead."), R.type = 1);
    const x = r.getRenderTarget(), E = r.getActiveCubeFace(), P = r.getActiveMipmapLevel(), z = r.state;
    z.setBlending(0), z.buffers.depth.getReversed() === !0 ? z.buffers.color.setClear(0, 0, 0, 0) : z.buffers.color.setClear(1, 1, 1, 1), z.buffers.depth.setTest(!0), z.setScissorTest(!1);
    const N = p !== this.type;
    N && A.traverse(function(W) {
      W.material && (Array.isArray(W.material) ? W.material.forEach((H) => H.needsUpdate = !0) : W.material.needsUpdate = !0);
    });
    for (let W = 0, H = R.length; W < H; W++) {
      const k = R[W], O = k.shadow;
      if (O === void 0) {
        Ce("WebGLShadowMap:", k, "has no shadow.");
        continue;
      }
      if (O.autoUpdate === !1 && O.needsUpdate === !1) continue;
      i.copy(O.mapSize);
      const Y = O.getFrameExtents();
      if (i.multiply(Y), s.copy(O.mapSize), (i.x > u || i.y > u) && (i.x > u && (s.x = Math.floor(u / Y.x), i.x = s.x * Y.x, O.mapSize.x = s.x), i.y > u && (s.y = Math.floor(u / Y.y), i.y = s.y * Y.y, O.mapSize.y = s.y)), O.map === null || N === !0) {
        if (O.map !== null && (O.map.depthTexture !== null && (O.map.depthTexture.dispose(), O.map.depthTexture = null), O.map.dispose()), this.type === 3) {
          if (k.isPointLight) {
            Ce("WebGLShadowMap: VSM shadow maps are not supported for PointLights. Use PCF or BasicShadowMap instead.");
            continue;
          }
          O.map = new Cn(i.x, i.y, {
            format: 1030,
            type: 1016,
            minFilter: 1006,
            magFilter: 1006,
            generateMipmaps: !1
          }), O.map.texture.name = k.name + ".shadowMap", O.map.depthTexture = new Nr(i.x, i.y, 1015), O.map.depthTexture.name = k.name + ".shadowMapDepth", O.map.depthTexture.format = 1026, O.map.depthTexture.compareFunction = null, O.map.depthTexture.minFilter = 1003, O.map.depthTexture.magFilter = 1003;
        } else {
          k.isPointLight ? (O.map = new dc(i.x), O.map.depthTexture = new Ph(i.x, 1014)) : (O.map = new Cn(i.x, i.y), O.map.depthTexture = new Nr(i.x, i.y, 1014)), O.map.depthTexture.name = k.name + ".shadowMap", O.map.depthTexture.format = 1026;
          const ne = r.state.buffers.depth.getReversed();
          this.type === 1 ? (O.map.depthTexture.compareFunction = ne ? 518 : 515, O.map.depthTexture.minFilter = 1006, O.map.depthTexture.magFilter = 1006) : (O.map.depthTexture.compareFunction = null, O.map.depthTexture.minFilter = 1003, O.map.depthTexture.magFilter = 1003);
        }
        O.camera.updateProjectionMatrix();
      }
      const ae = O.map.isWebGLCubeRenderTarget ? 6 : 1;
      for (let ne = 0; ne < ae; ne++) {
        if (O.map.isWebGLCubeRenderTarget)
          r.setRenderTarget(O.map, ne), r.clear();
        else {
          ne === 0 && (r.setRenderTarget(O.map), r.clear());
          const ue = O.getViewport(ne);
          a.set(
            s.x * ue.x,
            s.y * ue.y,
            s.x * ue.z,
            s.y * ue.w
          ), z.viewport(a);
        }
        if (k.isPointLight) {
          const ue = O.camera, Pe = O.matrix, Le = k.distance || ue.far;
          Le !== ue.far && (ue.far = Le, ue.updateProjectionMatrix()), Sr.setFromMatrixPosition(k.matrixWorld), ue.position.copy(Sr), La.copy(ue.position), La.add(S_[ne]), ue.up.copy(M_[ne]), ue.lookAt(La), ue.updateMatrixWorld(), Pe.makeTranslation(-Sr.x, -Sr.y, -Sr.z), Il.multiplyMatrices(ue.projectionMatrix, ue.matrixWorldInverse), O._frustum.setFromProjectionMatrix(Il, ue.coordinateSystem, ue.reversedDepth);
        } else
          O.updateMatrices(k);
        n = O.getFrustum(), T(A, C, O.camera, k, this.type);
      }
      O.isPointLightShadow !== !0 && this.type === 3 && S(O, C), O.needsUpdate = !1;
    }
    p = this.type, m.needsUpdate = !1, r.setRenderTarget(x, E, P);
  };
  function S(R, A) {
    const C = e.update(_);
    f.defines.VSM_SAMPLES !== R.blurSamples && (f.defines.VSM_SAMPLES = R.blurSamples, d.defines.VSM_SAMPLES = R.blurSamples, f.needsUpdate = !0, d.needsUpdate = !0), R.mapPass === null && (R.mapPass = new Cn(i.x, i.y, {
      format: 1030,
      type: 1016
    })), f.uniforms.shadow_pass.value = R.map.depthTexture, f.uniforms.resolution.value = R.mapSize, f.uniforms.radius.value = R.radius, r.setRenderTarget(R.mapPass), r.clear(), r.renderBufferDirect(A, null, C, f, _, null), d.uniforms.shadow_pass.value = R.mapPass.texture, d.uniforms.resolution.value = R.mapSize, d.uniforms.radius.value = R.radius, r.setRenderTarget(R.map), r.clear(), r.renderBufferDirect(A, null, C, d, _, null);
  }
  function b(R, A, C, x) {
    let E = null;
    const P = C.isPointLight === !0 ? R.customDistanceMaterial : R.customDepthMaterial;
    if (P !== void 0)
      E = P;
    else if (E = C.isPointLight === !0 ? c : o, r.localClippingEnabled && A.clipShadows === !0 && Array.isArray(A.clippingPlanes) && A.clippingPlanes.length !== 0 || A.displacementMap && A.displacementScale !== 0 || A.alphaMap && A.alphaTest > 0 || A.map && A.alphaTest > 0 || A.alphaToCoverage === !0) {
      const z = E.uuid, N = A.uuid;
      let W = l[z];
      W === void 0 && (W = {}, l[z] = W);
      let H = W[N];
      H === void 0 && (H = E.clone(), W[N] = H, A.addEventListener("dispose", y)), E = H;
    }
    if (E.visible = A.visible, E.wireframe = A.wireframe, x === 3 ? E.side = A.shadowSide !== null ? A.shadowSide : A.side : E.side = A.shadowSide !== null ? A.shadowSide : h[A.side], E.alphaMap = A.alphaMap, E.alphaTest = A.alphaToCoverage === !0 ? 0.5 : A.alphaTest, E.map = A.map, E.clipShadows = A.clipShadows, E.clippingPlanes = A.clippingPlanes, E.clipIntersection = A.clipIntersection, E.displacementMap = A.displacementMap, E.displacementScale = A.displacementScale, E.displacementBias = A.displacementBias, E.wireframeLinewidth = A.wireframeLinewidth, E.linewidth = A.linewidth, C.isPointLight === !0 && E.isMeshDistanceMaterial === !0) {
      const z = r.properties.get(E);
      z.light = C;
    }
    return E;
  }
  function T(R, A, C, x, E) {
    if (R.visible === !1) return;
    if (R.layers.test(A.layers) && (R.isMesh || R.isLine || R.isPoints) && (R.castShadow || R.receiveShadow && E === 3) && (!R.frustumCulled || n.intersectsObject(R))) {
      R.modelViewMatrix.multiplyMatrices(C.matrixWorldInverse, R.matrixWorld);
      const N = e.update(R), W = R.material;
      if (Array.isArray(W)) {
        const H = N.groups;
        for (let k = 0, O = H.length; k < O; k++) {
          const Y = H[k], ae = W[Y.materialIndex];
          if (ae && ae.visible) {
            const ne = b(R, ae, x, E);
            R.onBeforeShadow(r, R, A, C, N, ne, Y), r.renderBufferDirect(C, null, N, ne, R, Y), R.onAfterShadow(r, R, A, C, N, ne, Y);
          }
        }
      } else if (W.visible) {
        const H = b(R, W, x, E);
        R.onBeforeShadow(r, R, A, C, N, H, null), r.renderBufferDirect(C, null, N, H, R, null), R.onAfterShadow(r, R, A, C, N, H, null);
      }
    }
    const z = R.children;
    for (let N = 0, W = z.length; N < W; N++)
      T(z[N], A, C, x, E);
  }
  function y(R) {
    R.target.removeEventListener("dispose", y);
    for (const C in l) {
      const x = l[C], E = R.target.uuid;
      E in x && (x[E].dispose(), delete x[E]);
    }
  }
}
const E_ = {
  0: 1,
  2: 6,
  4: 7,
  3: 5,
  1: 0,
  6: 2,
  7: 4,
  5: 3
};
function T_(r, e) {
  function t() {
    let L = !1;
    const fe = new xt();
    let te = null;
    const de = new xt(0, 0, 0, 0);
    return {
      setMask: function(Q) {
        te !== Q && !L && (r.colorMask(Q, Q, Q, Q), te = Q);
      },
      setLocked: function(Q) {
        L = Q;
      },
      setClear: function(Q, Z, ie, De, ot) {
        ot === !0 && (Q *= De, Z *= De, ie *= De), fe.set(Q, Z, ie, De), de.equals(fe) === !1 && (r.clearColor(Q, Z, ie, De), de.copy(fe));
      },
      reset: function() {
        L = !1, te = null, de.set(-1, 0, 0, 0);
      }
    };
  }
  function n() {
    let L = !1, fe = !1, te = null, de = null, Q = null;
    return {
      setReversed: function(Z) {
        if (fe !== Z) {
          const ie = e.get("EXT_clip_control");
          Z ? ie.clipControlEXT(ie.LOWER_LEFT_EXT, ie.ZERO_TO_ONE_EXT) : ie.clipControlEXT(ie.LOWER_LEFT_EXT, ie.NEGATIVE_ONE_TO_ONE_EXT), fe = Z;
          const De = Q;
          Q = null, this.setClear(De);
        }
      },
      getReversed: function() {
        return fe;
      },
      setTest: function(Z) {
        Z ? J(r.DEPTH_TEST) : me(r.DEPTH_TEST);
      },
      setMask: function(Z) {
        te !== Z && !L && (r.depthMask(Z), te = Z);
      },
      setFunc: function(Z) {
        if (fe && (Z = E_[Z]), de !== Z) {
          switch (Z) {
            case 0:
              r.depthFunc(r.NEVER);
              break;
            case 1:
              r.depthFunc(r.ALWAYS);
              break;
            case 2:
              r.depthFunc(r.LESS);
              break;
            case 3:
              r.depthFunc(r.LEQUAL);
              break;
            case 4:
              r.depthFunc(r.EQUAL);
              break;
            case 5:
              r.depthFunc(r.GEQUAL);
              break;
            case 6:
              r.depthFunc(r.GREATER);
              break;
            case 7:
              r.depthFunc(r.NOTEQUAL);
              break;
            default:
              r.depthFunc(r.LEQUAL);
          }
          de = Z;
        }
      },
      setLocked: function(Z) {
        L = Z;
      },
      setClear: function(Z) {
        Q !== Z && (fe && (Z = 1 - Z), r.clearDepth(Z), Q = Z);
      },
      reset: function() {
        L = !1, te = null, de = null, Q = null, fe = !1;
      }
    };
  }
  function i() {
    let L = !1, fe = null, te = null, de = null, Q = null, Z = null, ie = null, De = null, ot = null;
    return {
      setTest: function(je) {
        L || (je ? J(r.STENCIL_TEST) : me(r.STENCIL_TEST));
      },
      setMask: function(je) {
        fe !== je && !L && (r.stencilMask(je), fe = je);
      },
      setFunc: function(je, En, Ln) {
        (te !== je || de !== En || Q !== Ln) && (r.stencilFunc(je, En, Ln), te = je, de = En, Q = Ln);
      },
      setOp: function(je, En, Ln) {
        (Z !== je || ie !== En || De !== Ln) && (r.stencilOp(je, En, Ln), Z = je, ie = En, De = Ln);
      },
      setLocked: function(je) {
        L = je;
      },
      setClear: function(je) {
        ot !== je && (r.clearStencil(je), ot = je);
      },
      reset: function() {
        L = !1, fe = null, te = null, de = null, Q = null, Z = null, ie = null, De = null, ot = null;
      }
    };
  }
  const s = new t(), a = new n(), o = new i(), c = /* @__PURE__ */ new WeakMap(), l = /* @__PURE__ */ new WeakMap();
  let u = {}, h = {}, f = /* @__PURE__ */ new WeakMap(), d = [], g = null, _ = !1, m = null, p = null, S = null, b = null, T = null, y = null, R = null, A = new Ge(0, 0, 0), C = 0, x = !1, E = null, P = null, z = null, N = null, W = null;
  const H = r.getParameter(r.MAX_COMBINED_TEXTURE_IMAGE_UNITS);
  let k = !1, O = 0;
  const Y = r.getParameter(r.VERSION);
  Y.indexOf("WebGL") !== -1 ? (O = parseFloat(/^WebGL (\d)/.exec(Y)[1]), k = O >= 1) : Y.indexOf("OpenGL ES") !== -1 && (O = parseFloat(/^OpenGL ES (\d)/.exec(Y)[1]), k = O >= 2);
  let ae = null, ne = {};
  const ue = r.getParameter(r.SCISSOR_BOX), Pe = r.getParameter(r.VIEWPORT), Le = new xt().fromArray(ue), Ve = new xt().fromArray(Pe);
  function He(L, fe, te, de) {
    const Q = new Uint8Array(4), Z = r.createTexture();
    r.bindTexture(L, Z), r.texParameteri(L, r.TEXTURE_MIN_FILTER, r.NEAREST), r.texParameteri(L, r.TEXTURE_MAG_FILTER, r.NEAREST);
    for (let ie = 0; ie < te; ie++)
      L === r.TEXTURE_3D || L === r.TEXTURE_2D_ARRAY ? r.texImage3D(fe, 0, r.RGBA, 1, 1, de, 0, r.RGBA, r.UNSIGNED_BYTE, Q) : r.texImage2D(fe + ie, 0, r.RGBA, 1, 1, 0, r.RGBA, r.UNSIGNED_BYTE, Q);
    return Z;
  }
  const $ = {};
  $[r.TEXTURE_2D] = He(r.TEXTURE_2D, r.TEXTURE_2D, 1), $[r.TEXTURE_CUBE_MAP] = He(r.TEXTURE_CUBE_MAP, r.TEXTURE_CUBE_MAP_POSITIVE_X, 6), $[r.TEXTURE_2D_ARRAY] = He(r.TEXTURE_2D_ARRAY, r.TEXTURE_2D_ARRAY, 1, 1), $[r.TEXTURE_3D] = He(r.TEXTURE_3D, r.TEXTURE_3D, 1, 1), s.setClear(0, 0, 0, 1), a.setClear(1), o.setClear(0), J(r.DEPTH_TEST), a.setFunc(3), Ne(!1), St(1), J(r.CULL_FACE), Ze(0);
  function J(L) {
    u[L] !== !0 && (r.enable(L), u[L] = !0);
  }
  function me(L) {
    u[L] !== !1 && (r.disable(L), u[L] = !1);
  }
  function Fe(L, fe) {
    return h[L] !== fe ? (r.bindFramebuffer(L, fe), h[L] = fe, L === r.DRAW_FRAMEBUFFER && (h[r.FRAMEBUFFER] = fe), L === r.FRAMEBUFFER && (h[r.DRAW_FRAMEBUFFER] = fe), !0) : !1;
  }
  function ve(L, fe) {
    let te = d, de = !1;
    if (L) {
      te = f.get(fe), te === void 0 && (te = [], f.set(fe, te));
      const Q = L.textures;
      if (te.length !== Q.length || te[0] !== r.COLOR_ATTACHMENT0) {
        for (let Z = 0, ie = Q.length; Z < ie; Z++)
          te[Z] = r.COLOR_ATTACHMENT0 + Z;
        te.length = Q.length, de = !0;
      }
    } else
      te[0] !== r.BACK && (te[0] = r.BACK, de = !0);
    de && r.drawBuffers(te);
  }
  function Ye(L) {
    return g !== L ? (r.useProgram(L), g = L, !0) : !1;
  }
  const Rt = {
    100: r.FUNC_ADD,
    101: r.FUNC_SUBTRACT,
    102: r.FUNC_REVERSE_SUBTRACT
  };
  Rt[103] = r.MIN, Rt[104] = r.MAX;
  const We = {
    200: r.ZERO,
    201: r.ONE,
    202: r.SRC_COLOR,
    204: r.SRC_ALPHA,
    210: r.SRC_ALPHA_SATURATE,
    208: r.DST_COLOR,
    206: r.DST_ALPHA,
    203: r.ONE_MINUS_SRC_COLOR,
    205: r.ONE_MINUS_SRC_ALPHA,
    209: r.ONE_MINUS_DST_COLOR,
    207: r.ONE_MINUS_DST_ALPHA,
    211: r.CONSTANT_COLOR,
    212: r.ONE_MINUS_CONSTANT_COLOR,
    213: r.CONSTANT_ALPHA,
    214: r.ONE_MINUS_CONSTANT_ALPHA
  };
  function Ze(L, fe, te, de, Q, Z, ie, De, ot, je) {
    if (L === 0) {
      _ === !0 && (me(r.BLEND), _ = !1);
      return;
    }
    if (_ === !1 && (J(r.BLEND), _ = !0), L !== 5) {
      if (L !== m || je !== x) {
        if ((p !== 100 || T !== 100) && (r.blendEquation(r.FUNC_ADD), p = 100, T = 100), je)
          switch (L) {
            case 1:
              r.blendFuncSeparate(r.ONE, r.ONE_MINUS_SRC_ALPHA, r.ONE, r.ONE_MINUS_SRC_ALPHA);
              break;
            case 2:
              r.blendFunc(r.ONE, r.ONE);
              break;
            case 3:
              r.blendFuncSeparate(r.ZERO, r.ONE_MINUS_SRC_COLOR, r.ZERO, r.ONE);
              break;
            case 4:
              r.blendFuncSeparate(r.DST_COLOR, r.ONE_MINUS_SRC_ALPHA, r.ZERO, r.ONE);
              break;
            default:
              Xe("WebGLState: Invalid blending: ", L);
              break;
          }
        else
          switch (L) {
            case 1:
              r.blendFuncSeparate(r.SRC_ALPHA, r.ONE_MINUS_SRC_ALPHA, r.ONE, r.ONE_MINUS_SRC_ALPHA);
              break;
            case 2:
              r.blendFuncSeparate(r.SRC_ALPHA, r.ONE, r.ONE, r.ONE);
              break;
            case 3:
              Xe("WebGLState: SubtractiveBlending requires material.premultipliedAlpha = true");
              break;
            case 4:
              Xe("WebGLState: MultiplyBlending requires material.premultipliedAlpha = true");
              break;
            default:
              Xe("WebGLState: Invalid blending: ", L);
              break;
          }
        S = null, b = null, y = null, R = null, A.set(0, 0, 0), C = 0, m = L, x = je;
      }
      return;
    }
    Q = Q || fe, Z = Z || te, ie = ie || de, (fe !== p || Q !== T) && (r.blendEquationSeparate(Rt[fe], Rt[Q]), p = fe, T = Q), (te !== S || de !== b || Z !== y || ie !== R) && (r.blendFuncSeparate(We[te], We[de], We[Z], We[ie]), S = te, b = de, y = Z, R = ie), (De.equals(A) === !1 || ot !== C) && (r.blendColor(De.r, De.g, De.b, ot), A.copy(De), C = ot), m = L, x = !1;
  }
  function nt(L, fe) {
    L.side === 2 ? me(r.CULL_FACE) : J(r.CULL_FACE);
    let te = L.side === 1;
    fe && (te = !te), Ne(te), L.blending === 1 && L.transparent === !1 ? Ze(0) : Ze(L.blending, L.blendEquation, L.blendSrc, L.blendDst, L.blendEquationAlpha, L.blendSrcAlpha, L.blendDstAlpha, L.blendColor, L.blendAlpha, L.premultipliedAlpha), a.setFunc(L.depthFunc), a.setTest(L.depthTest), a.setMask(L.depthWrite), s.setMask(L.colorWrite);
    const de = L.stencilWrite;
    o.setTest(de), de && (o.setMask(L.stencilWriteMask), o.setFunc(L.stencilFunc, L.stencilRef, L.stencilFuncMask), o.setOp(L.stencilFail, L.stencilZFail, L.stencilZPass)), Mt(L.polygonOffset, L.polygonOffsetFactor, L.polygonOffsetUnits), L.alphaToCoverage === !0 ? J(r.SAMPLE_ALPHA_TO_COVERAGE) : me(r.SAMPLE_ALPHA_TO_COVERAGE);
  }
  function Ne(L) {
    E !== L && (L ? r.frontFace(r.CW) : r.frontFace(r.CCW), E = L);
  }
  function St(L) {
    L !== 0 ? (J(r.CULL_FACE), L !== P && (L === 1 ? r.cullFace(r.BACK) : L === 2 ? r.cullFace(r.FRONT) : r.cullFace(r.FRONT_AND_BACK))) : me(r.CULL_FACE), P = L;
  }
  function D(L) {
    L !== z && (k && r.lineWidth(L), z = L);
  }
  function Mt(L, fe, te) {
    L ? (J(r.POLYGON_OFFSET_FILL), (N !== fe || W !== te) && (r.polygonOffset(fe, te), N = fe, W = te)) : me(r.POLYGON_OFFSET_FILL);
  }
  function Ke(L) {
    L ? J(r.SCISSOR_TEST) : me(r.SCISSOR_TEST);
  }
  function at(L) {
    L === void 0 && (L = r.TEXTURE0 + H - 1), ae !== L && (r.activeTexture(L), ae = L);
  }
  function Se(L, fe, te) {
    te === void 0 && (ae === null ? te = r.TEXTURE0 + H - 1 : te = ae);
    let de = ne[te];
    de === void 0 && (de = { type: void 0, texture: void 0 }, ne[te] = de), (de.type !== L || de.texture !== fe) && (ae !== te && (r.activeTexture(te), ae = te), r.bindTexture(L, fe || $[L]), de.type = L, de.texture = fe);
  }
  function w() {
    const L = ne[ae];
    L !== void 0 && L.type !== void 0 && (r.bindTexture(L.type, null), L.type = void 0, L.texture = void 0);
  }
  function v() {
    try {
      r.compressedTexImage2D(...arguments);
    } catch (L) {
      Xe("WebGLState:", L);
    }
  }
  function F() {
    try {
      r.compressedTexImage3D(...arguments);
    } catch (L) {
      Xe("WebGLState:", L);
    }
  }
  function q() {
    try {
      r.texSubImage2D(...arguments);
    } catch (L) {
      Xe("WebGLState:", L);
    }
  }
  function j() {
    try {
      r.texSubImage3D(...arguments);
    } catch (L) {
      Xe("WebGLState:", L);
    }
  }
  function X() {
    try {
      r.compressedTexSubImage2D(...arguments);
    } catch (L) {
      Xe("WebGLState:", L);
    }
  }
  function ye() {
    try {
      r.compressedTexSubImage3D(...arguments);
    } catch (L) {
      Xe("WebGLState:", L);
    }
  }
  function re() {
    try {
      r.texStorage2D(...arguments);
    } catch (L) {
      Xe("WebGLState:", L);
    }
  }
  function xe() {
    try {
      r.texStorage3D(...arguments);
    } catch (L) {
      Xe("WebGLState:", L);
    }
  }
  function Re() {
    try {
      r.texImage2D(...arguments);
    } catch (L) {
      Xe("WebGLState:", L);
    }
  }
  function ee() {
    try {
      r.texImage3D(...arguments);
    } catch (L) {
      Xe("WebGLState:", L);
    }
  }
  function oe(L) {
    Le.equals(L) === !1 && (r.scissor(L.x, L.y, L.z, L.w), Le.copy(L));
  }
  function ge(L) {
    Ve.equals(L) === !1 && (r.viewport(L.x, L.y, L.z, L.w), Ve.copy(L));
  }
  function Me(L, fe) {
    let te = l.get(fe);
    te === void 0 && (te = /* @__PURE__ */ new WeakMap(), l.set(fe, te));
    let de = te.get(L);
    de === void 0 && (de = r.getUniformBlockIndex(fe, L.name), te.set(L, de));
  }
  function se(L, fe) {
    const de = l.get(fe).get(L);
    c.get(fe) !== de && (r.uniformBlockBinding(fe, de, L.__bindingPointIndex), c.set(fe, de));
  }
  function Oe() {
    r.disable(r.BLEND), r.disable(r.CULL_FACE), r.disable(r.DEPTH_TEST), r.disable(r.POLYGON_OFFSET_FILL), r.disable(r.SCISSOR_TEST), r.disable(r.STENCIL_TEST), r.disable(r.SAMPLE_ALPHA_TO_COVERAGE), r.blendEquation(r.FUNC_ADD), r.blendFunc(r.ONE, r.ZERO), r.blendFuncSeparate(r.ONE, r.ZERO, r.ONE, r.ZERO), r.blendColor(0, 0, 0, 0), r.colorMask(!0, !0, !0, !0), r.clearColor(0, 0, 0, 0), r.depthMask(!0), r.depthFunc(r.LESS), a.setReversed(!1), r.clearDepth(1), r.stencilMask(4294967295), r.stencilFunc(r.ALWAYS, 0, 4294967295), r.stencilOp(r.KEEP, r.KEEP, r.KEEP), r.clearStencil(0), r.cullFace(r.BACK), r.frontFace(r.CCW), r.polygonOffset(0, 0), r.activeTexture(r.TEXTURE0), r.bindFramebuffer(r.FRAMEBUFFER, null), r.bindFramebuffer(r.DRAW_FRAMEBUFFER, null), r.bindFramebuffer(r.READ_FRAMEBUFFER, null), r.useProgram(null), r.lineWidth(1), r.scissor(0, 0, r.canvas.width, r.canvas.height), r.viewport(0, 0, r.canvas.width, r.canvas.height), u = {}, ae = null, ne = {}, h = {}, f = /* @__PURE__ */ new WeakMap(), d = [], g = null, _ = !1, m = null, p = null, S = null, b = null, T = null, y = null, R = null, A = new Ge(0, 0, 0), C = 0, x = !1, E = null, P = null, z = null, N = null, W = null, Le.set(0, 0, r.canvas.width, r.canvas.height), Ve.set(0, 0, r.canvas.width, r.canvas.height), s.reset(), a.reset(), o.reset();
  }
  return {
    buffers: {
      color: s,
      depth: a,
      stencil: o
    },
    enable: J,
    disable: me,
    bindFramebuffer: Fe,
    drawBuffers: ve,
    useProgram: Ye,
    setBlending: Ze,
    setMaterial: nt,
    setFlipSided: Ne,
    setCullFace: St,
    setLineWidth: D,
    setPolygonOffset: Mt,
    setScissorTest: Ke,
    activeTexture: at,
    bindTexture: Se,
    unbindTexture: w,
    compressedTexImage2D: v,
    compressedTexImage3D: F,
    texImage2D: Re,
    texImage3D: ee,
    updateUBOMapping: Me,
    uniformBlockBinding: se,
    texStorage2D: re,
    texStorage3D: xe,
    texSubImage2D: q,
    texSubImage3D: j,
    compressedTexSubImage2D: X,
    compressedTexSubImage3D: ye,
    scissor: oe,
    viewport: ge,
    reset: Oe
  };
}
function b_(r, e, t, n, i, s, a) {
  const o = e.has("WEBGL_multisampled_render_to_texture") ? e.get("WEBGL_multisampled_render_to_texture") : null, c = typeof navigator > "u" ? !1 : /OculusBrowser/g.test(navigator.userAgent), l = new Ae(), u = /* @__PURE__ */ new WeakMap();
  let h;
  const f = /* @__PURE__ */ new WeakMap();
  let d = !1;
  try {
    d = typeof OffscreenCanvas < "u" && new OffscreenCanvas(1, 1).getContext("2d") !== null;
  } catch {
  }
  function g(w, v) {
    return d ? new OffscreenCanvas(w, v) : Fr("canvas");
  }
  function _(w, v, F) {
    let q = 1;
    const j = Se(w);
    if ((j.width > F || j.height > F) && (q = F / Math.max(j.width, j.height)), q < 1)
      if (typeof HTMLImageElement < "u" && w instanceof HTMLImageElement || typeof HTMLCanvasElement < "u" && w instanceof HTMLCanvasElement || typeof ImageBitmap < "u" && w instanceof ImageBitmap || typeof VideoFrame < "u" && w instanceof VideoFrame) {
        const X = Math.floor(q * j.width), ye = Math.floor(q * j.height);
        h === void 0 && (h = g(X, ye));
        const re = v ? g(X, ye) : h;
        return re.width = X, re.height = ye, re.getContext("2d").drawImage(w, 0, 0, X, ye), Ce("WebGLRenderer: Texture has been resized from (" + j.width + "x" + j.height + ") to (" + X + "x" + ye + ")."), re;
      } else
        return "data" in w && Ce("WebGLRenderer: Image in DataTexture is too big (" + j.width + "x" + j.height + ")."), w;
    return w;
  }
  function m(w) {
    return w.generateMipmaps;
  }
  function p(w) {
    r.generateMipmap(w);
  }
  function S(w) {
    return w.isWebGLCubeRenderTarget ? r.TEXTURE_CUBE_MAP : w.isWebGL3DRenderTarget ? r.TEXTURE_3D : w.isWebGLArrayRenderTarget || w.isCompressedArrayTexture ? r.TEXTURE_2D_ARRAY : r.TEXTURE_2D;
  }
  function b(w, v, F, q, j = !1) {
    if (w !== null) {
      if (r[w] !== void 0) return r[w];
      Ce("WebGLRenderer: Attempt to use non-existing WebGL internal format '" + w + "'");
    }
    let X = v;
    if (v === r.RED && (F === r.FLOAT && (X = r.R32F), F === r.HALF_FLOAT && (X = r.R16F), F === r.UNSIGNED_BYTE && (X = r.R8)), v === r.RED_INTEGER && (F === r.UNSIGNED_BYTE && (X = r.R8UI), F === r.UNSIGNED_SHORT && (X = r.R16UI), F === r.UNSIGNED_INT && (X = r.R32UI), F === r.BYTE && (X = r.R8I), F === r.SHORT && (X = r.R16I), F === r.INT && (X = r.R32I)), v === r.RG && (F === r.FLOAT && (X = r.RG32F), F === r.HALF_FLOAT && (X = r.RG16F), F === r.UNSIGNED_BYTE && (X = r.RG8)), v === r.RG_INTEGER && (F === r.UNSIGNED_BYTE && (X = r.RG8UI), F === r.UNSIGNED_SHORT && (X = r.RG16UI), F === r.UNSIGNED_INT && (X = r.RG32UI), F === r.BYTE && (X = r.RG8I), F === r.SHORT && (X = r.RG16I), F === r.INT && (X = r.RG32I)), v === r.RGB_INTEGER && (F === r.UNSIGNED_BYTE && (X = r.RGB8UI), F === r.UNSIGNED_SHORT && (X = r.RGB16UI), F === r.UNSIGNED_INT && (X = r.RGB32UI), F === r.BYTE && (X = r.RGB8I), F === r.SHORT && (X = r.RGB16I), F === r.INT && (X = r.RGB32I)), v === r.RGBA_INTEGER && (F === r.UNSIGNED_BYTE && (X = r.RGBA8UI), F === r.UNSIGNED_SHORT && (X = r.RGBA16UI), F === r.UNSIGNED_INT && (X = r.RGBA32UI), F === r.BYTE && (X = r.RGBA8I), F === r.SHORT && (X = r.RGBA16I), F === r.INT && (X = r.RGBA32I)), v === r.RGB && (F === r.UNSIGNED_INT_5_9_9_9_REV && (X = r.RGB9_E5), F === r.UNSIGNED_INT_10F_11F_11F_REV && (X = r.R11F_G11F_B10F)), v === r.RGBA) {
      const ye = j ? Ps : qe.getTransfer(q);
      F === r.FLOAT && (X = r.RGBA32F), F === r.HALF_FLOAT && (X = r.RGBA16F), F === r.UNSIGNED_BYTE && (X = ye === Qe ? r.SRGB8_ALPHA8 : r.RGBA8), F === r.UNSIGNED_SHORT_4_4_4_4 && (X = r.RGBA4), F === r.UNSIGNED_SHORT_5_5_5_1 && (X = r.RGB5_A1);
    }
    return (X === r.R16F || X === r.R32F || X === r.RG16F || X === r.RG32F || X === r.RGBA16F || X === r.RGBA32F) && e.get("EXT_color_buffer_float"), X;
  }
  function T(w, v) {
    let F;
    return w ? v === null || v === 1014 || v === 1020 ? F = r.DEPTH24_STENCIL8 : v === 1015 ? F = r.DEPTH32F_STENCIL8 : v === 1012 && (F = r.DEPTH24_STENCIL8, Ce("DepthTexture: 16 bit depth attachment is not supported with stencil. Using 24-bit attachment.")) : v === null || v === 1014 || v === 1020 ? F = r.DEPTH_COMPONENT24 : v === 1015 ? F = r.DEPTH_COMPONENT32F : v === 1012 && (F = r.DEPTH_COMPONENT16), F;
  }
  function y(w, v) {
    return m(w) === !0 || w.isFramebufferTexture && w.minFilter !== 1003 && w.minFilter !== 1006 ? Math.log2(Math.max(v.width, v.height)) + 1 : w.mipmaps !== void 0 && w.mipmaps.length > 0 ? w.mipmaps.length : w.isCompressedTexture && Array.isArray(w.image) ? v.mipmaps.length : 1;
  }
  function R(w) {
    const v = w.target;
    v.removeEventListener("dispose", R), C(v), v.isVideoTexture && u.delete(v);
  }
  function A(w) {
    const v = w.target;
    v.removeEventListener("dispose", A), E(v);
  }
  function C(w) {
    const v = n.get(w);
    if (v.__webglInit === void 0) return;
    const F = w.source, q = f.get(F);
    if (q) {
      const j = q[v.__cacheKey];
      j.usedTimes--, j.usedTimes === 0 && x(w), Object.keys(q).length === 0 && f.delete(F);
    }
    n.remove(w);
  }
  function x(w) {
    const v = n.get(w);
    r.deleteTexture(v.__webglTexture);
    const F = w.source, q = f.get(F);
    delete q[v.__cacheKey], a.memory.textures--;
  }
  function E(w) {
    const v = n.get(w);
    if (w.depthTexture && (w.depthTexture.dispose(), n.remove(w.depthTexture)), w.isWebGLCubeRenderTarget)
      for (let q = 0; q < 6; q++) {
        if (Array.isArray(v.__webglFramebuffer[q]))
          for (let j = 0; j < v.__webglFramebuffer[q].length; j++) r.deleteFramebuffer(v.__webglFramebuffer[q][j]);
        else
          r.deleteFramebuffer(v.__webglFramebuffer[q]);
        v.__webglDepthbuffer && r.deleteRenderbuffer(v.__webglDepthbuffer[q]);
      }
    else {
      if (Array.isArray(v.__webglFramebuffer))
        for (let q = 0; q < v.__webglFramebuffer.length; q++) r.deleteFramebuffer(v.__webglFramebuffer[q]);
      else
        r.deleteFramebuffer(v.__webglFramebuffer);
      if (v.__webglDepthbuffer && r.deleteRenderbuffer(v.__webglDepthbuffer), v.__webglMultisampledFramebuffer && r.deleteFramebuffer(v.__webglMultisampledFramebuffer), v.__webglColorRenderbuffer)
        for (let q = 0; q < v.__webglColorRenderbuffer.length; q++)
          v.__webglColorRenderbuffer[q] && r.deleteRenderbuffer(v.__webglColorRenderbuffer[q]);
      v.__webglDepthRenderbuffer && r.deleteRenderbuffer(v.__webglDepthRenderbuffer);
    }
    const F = w.textures;
    for (let q = 0, j = F.length; q < j; q++) {
      const X = n.get(F[q]);
      X.__webglTexture && (r.deleteTexture(X.__webglTexture), a.memory.textures--), n.remove(F[q]);
    }
    n.remove(w);
  }
  let P = 0;
  function z() {
    P = 0;
  }
  function N() {
    const w = P;
    return w >= i.maxTextures && Ce("WebGLTextures: Trying to use " + w + " texture units while this GPU supports only " + i.maxTextures), P += 1, w;
  }
  function W(w) {
    const v = [];
    return v.push(w.wrapS), v.push(w.wrapT), v.push(w.wrapR || 0), v.push(w.magFilter), v.push(w.minFilter), v.push(w.anisotropy), v.push(w.internalFormat), v.push(w.format), v.push(w.type), v.push(w.generateMipmaps), v.push(w.premultiplyAlpha), v.push(w.flipY), v.push(w.unpackAlignment), v.push(w.colorSpace), v.join();
  }
  function H(w, v) {
    const F = n.get(w);
    if (w.isVideoTexture && Ke(w), w.isRenderTargetTexture === !1 && w.isExternalTexture !== !0 && w.version > 0 && F.__version !== w.version) {
      const q = w.image;
      if (q === null)
        Ce("WebGLRenderer: Texture marked for update but no image data found.");
      else if (q.complete === !1)
        Ce("WebGLRenderer: Texture marked for update but image is incomplete");
      else {
        $(F, w, v);
        return;
      }
    } else w.isExternalTexture && (F.__webglTexture = w.sourceTexture ? w.sourceTexture : null);
    t.bindTexture(r.TEXTURE_2D, F.__webglTexture, r.TEXTURE0 + v);
  }
  function k(w, v) {
    const F = n.get(w);
    if (w.isRenderTargetTexture === !1 && w.version > 0 && F.__version !== w.version) {
      $(F, w, v);
      return;
    } else w.isExternalTexture && (F.__webglTexture = w.sourceTexture ? w.sourceTexture : null);
    t.bindTexture(r.TEXTURE_2D_ARRAY, F.__webglTexture, r.TEXTURE0 + v);
  }
  function O(w, v) {
    const F = n.get(w);
    if (w.isRenderTargetTexture === !1 && w.version > 0 && F.__version !== w.version) {
      $(F, w, v);
      return;
    }
    t.bindTexture(r.TEXTURE_3D, F.__webglTexture, r.TEXTURE0 + v);
  }
  function Y(w, v) {
    const F = n.get(w);
    if (w.isCubeDepthTexture !== !0 && w.version > 0 && F.__version !== w.version) {
      J(F, w, v);
      return;
    }
    t.bindTexture(r.TEXTURE_CUBE_MAP, F.__webglTexture, r.TEXTURE0 + v);
  }
  const ae = {
    1e3: r.REPEAT,
    1001: r.CLAMP_TO_EDGE,
    1002: r.MIRRORED_REPEAT
  }, ne = {
    1003: r.NEAREST,
    1004: r.NEAREST_MIPMAP_NEAREST,
    1005: r.NEAREST_MIPMAP_LINEAR,
    1006: r.LINEAR,
    1007: r.LINEAR_MIPMAP_NEAREST,
    1008: r.LINEAR_MIPMAP_LINEAR
  }, ue = {
    512: r.NEVER,
    519: r.ALWAYS,
    513: r.LESS,
    515: r.LEQUAL,
    514: r.EQUAL,
    518: r.GEQUAL,
    516: r.GREATER,
    517: r.NOTEQUAL
  };
  function Pe(w, v) {
    if (v.type === 1015 && e.has("OES_texture_float_linear") === !1 && (v.magFilter === 1006 || v.magFilter === 1007 || v.magFilter === 1005 || v.magFilter === 1008 || v.minFilter === 1006 || v.minFilter === 1007 || v.minFilter === 1005 || v.minFilter === 1008) && Ce("WebGLRenderer: Unable to use linear filtering with floating point textures. OES_texture_float_linear not supported on this device."), r.texParameteri(w, r.TEXTURE_WRAP_S, ae[v.wrapS]), r.texParameteri(w, r.TEXTURE_WRAP_T, ae[v.wrapT]), (w === r.TEXTURE_3D || w === r.TEXTURE_2D_ARRAY) && r.texParameteri(w, r.TEXTURE_WRAP_R, ae[v.wrapR]), r.texParameteri(w, r.TEXTURE_MAG_FILTER, ne[v.magFilter]), r.texParameteri(w, r.TEXTURE_MIN_FILTER, ne[v.minFilter]), v.compareFunction && (r.texParameteri(w, r.TEXTURE_COMPARE_MODE, r.COMPARE_REF_TO_TEXTURE), r.texParameteri(w, r.TEXTURE_COMPARE_FUNC, ue[v.compareFunction])), e.has("EXT_texture_filter_anisotropic") === !0) {
      if (v.magFilter === 1003 || v.minFilter !== 1005 && v.minFilter !== 1008 || v.type === 1015 && e.has("OES_texture_float_linear") === !1) return;
      if (v.anisotropy > 1 || n.get(v).__currentAnisotropy) {
        const F = e.get("EXT_texture_filter_anisotropic");
        r.texParameterf(w, F.TEXTURE_MAX_ANISOTROPY_EXT, Math.min(v.anisotropy, i.getMaxAnisotropy())), n.get(v).__currentAnisotropy = v.anisotropy;
      }
    }
  }
  function Le(w, v) {
    let F = !1;
    w.__webglInit === void 0 && (w.__webglInit = !0, v.addEventListener("dispose", R));
    const q = v.source;
    let j = f.get(q);
    j === void 0 && (j = {}, f.set(q, j));
    const X = W(v);
    if (X !== w.__cacheKey) {
      j[X] === void 0 && (j[X] = {
        texture: r.createTexture(),
        usedTimes: 0
      }, a.memory.textures++, F = !0), j[X].usedTimes++;
      const ye = j[w.__cacheKey];
      ye !== void 0 && (j[w.__cacheKey].usedTimes--, ye.usedTimes === 0 && x(v)), w.__cacheKey = X, w.__webglTexture = j[X].texture;
    }
    return F;
  }
  function Ve(w, v, F) {
    return Math.floor(Math.floor(w / F) / v);
  }
  function He(w, v, F, q) {
    const X = w.updateRanges;
    if (X.length === 0)
      t.texSubImage2D(r.TEXTURE_2D, 0, 0, 0, v.width, v.height, F, q, v.data);
    else {
      X.sort((ee, oe) => ee.start - oe.start);
      let ye = 0;
      for (let ee = 1; ee < X.length; ee++) {
        const oe = X[ye], ge = X[ee], Me = oe.start + oe.count, se = Ve(ge.start, v.width, 4), Oe = Ve(oe.start, v.width, 4);
        ge.start <= Me + 1 && se === Oe && Ve(ge.start + ge.count - 1, v.width, 4) === se ? oe.count = Math.max(
          oe.count,
          ge.start + ge.count - oe.start
        ) : (++ye, X[ye] = ge);
      }
      X.length = ye + 1;
      const re = r.getParameter(r.UNPACK_ROW_LENGTH), xe = r.getParameter(r.UNPACK_SKIP_PIXELS), Re = r.getParameter(r.UNPACK_SKIP_ROWS);
      r.pixelStorei(r.UNPACK_ROW_LENGTH, v.width);
      for (let ee = 0, oe = X.length; ee < oe; ee++) {
        const ge = X[ee], Me = Math.floor(ge.start / 4), se = Math.ceil(ge.count / 4), Oe = Me % v.width, L = Math.floor(Me / v.width), fe = se, te = 1;
        r.pixelStorei(r.UNPACK_SKIP_PIXELS, Oe), r.pixelStorei(r.UNPACK_SKIP_ROWS, L), t.texSubImage2D(r.TEXTURE_2D, 0, Oe, L, fe, te, F, q, v.data);
      }
      w.clearUpdateRanges(), r.pixelStorei(r.UNPACK_ROW_LENGTH, re), r.pixelStorei(r.UNPACK_SKIP_PIXELS, xe), r.pixelStorei(r.UNPACK_SKIP_ROWS, Re);
    }
  }
  function $(w, v, F) {
    let q = r.TEXTURE_2D;
    (v.isDataArrayTexture || v.isCompressedArrayTexture) && (q = r.TEXTURE_2D_ARRAY), v.isData3DTexture && (q = r.TEXTURE_3D);
    const j = Le(w, v), X = v.source;
    t.bindTexture(q, w.__webglTexture, r.TEXTURE0 + F);
    const ye = n.get(X);
    if (X.version !== ye.__version || j === !0) {
      t.activeTexture(r.TEXTURE0 + F);
      const re = qe.getPrimaries(qe.workingColorSpace), xe = v.colorSpace === "" ? null : qe.getPrimaries(v.colorSpace), Re = v.colorSpace === "" || re === xe ? r.NONE : r.BROWSER_DEFAULT_WEBGL;
      r.pixelStorei(r.UNPACK_FLIP_Y_WEBGL, v.flipY), r.pixelStorei(r.UNPACK_PREMULTIPLY_ALPHA_WEBGL, v.premultiplyAlpha), r.pixelStorei(r.UNPACK_ALIGNMENT, v.unpackAlignment), r.pixelStorei(r.UNPACK_COLORSPACE_CONVERSION_WEBGL, Re);
      let ee = _(v.image, !1, i.maxTextureSize);
      ee = at(v, ee);
      const oe = s.convert(v.format, v.colorSpace), ge = s.convert(v.type);
      let Me = b(v.internalFormat, oe, ge, v.colorSpace, v.isVideoTexture);
      Pe(q, v);
      let se;
      const Oe = v.mipmaps, L = v.isVideoTexture !== !0, fe = ye.__version === void 0 || j === !0, te = X.dataReady, de = y(v, ee);
      if (v.isDepthTexture)
        Me = T(v.format === 1027, v.type), fe && (L ? t.texStorage2D(r.TEXTURE_2D, 1, Me, ee.width, ee.height) : t.texImage2D(r.TEXTURE_2D, 0, Me, ee.width, ee.height, 0, oe, ge, null));
      else if (v.isDataTexture)
        if (Oe.length > 0) {
          L && fe && t.texStorage2D(r.TEXTURE_2D, de, Me, Oe[0].width, Oe[0].height);
          for (let Q = 0, Z = Oe.length; Q < Z; Q++)
            se = Oe[Q], L ? te && t.texSubImage2D(r.TEXTURE_2D, Q, 0, 0, se.width, se.height, oe, ge, se.data) : t.texImage2D(r.TEXTURE_2D, Q, Me, se.width, se.height, 0, oe, ge, se.data);
          v.generateMipmaps = !1;
        } else
          L ? (fe && t.texStorage2D(r.TEXTURE_2D, de, Me, ee.width, ee.height), te && He(v, ee, oe, ge)) : t.texImage2D(r.TEXTURE_2D, 0, Me, ee.width, ee.height, 0, oe, ge, ee.data);
      else if (v.isCompressedTexture)
        if (v.isCompressedArrayTexture) {
          L && fe && t.texStorage3D(r.TEXTURE_2D_ARRAY, de, Me, Oe[0].width, Oe[0].height, ee.depth);
          for (let Q = 0, Z = Oe.length; Q < Z; Q++)
            if (se = Oe[Q], v.format !== 1023)
              if (oe !== null)
                if (L) {
                  if (te)
                    if (v.layerUpdates.size > 0) {
                      const ie = fl(se.width, se.height, v.format, v.type);
                      for (const De of v.layerUpdates) {
                        const ot = se.data.subarray(
                          De * ie / se.data.BYTES_PER_ELEMENT,
                          (De + 1) * ie / se.data.BYTES_PER_ELEMENT
                        );
                        t.compressedTexSubImage3D(r.TEXTURE_2D_ARRAY, Q, 0, 0, De, se.width, se.height, 1, oe, ot);
                      }
                      v.clearLayerUpdates();
                    } else
                      t.compressedTexSubImage3D(r.TEXTURE_2D_ARRAY, Q, 0, 0, 0, se.width, se.height, ee.depth, oe, se.data);
                } else
                  t.compressedTexImage3D(r.TEXTURE_2D_ARRAY, Q, Me, se.width, se.height, ee.depth, 0, se.data, 0, 0);
              else
                Ce("WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()");
            else
              L ? te && t.texSubImage3D(r.TEXTURE_2D_ARRAY, Q, 0, 0, 0, se.width, se.height, ee.depth, oe, ge, se.data) : t.texImage3D(r.TEXTURE_2D_ARRAY, Q, Me, se.width, se.height, ee.depth, 0, oe, ge, se.data);
        } else {
          L && fe && t.texStorage2D(r.TEXTURE_2D, de, Me, Oe[0].width, Oe[0].height);
          for (let Q = 0, Z = Oe.length; Q < Z; Q++)
            se = Oe[Q], v.format !== 1023 ? oe !== null ? L ? te && t.compressedTexSubImage2D(r.TEXTURE_2D, Q, 0, 0, se.width, se.height, oe, se.data) : t.compressedTexImage2D(r.TEXTURE_2D, Q, Me, se.width, se.height, 0, se.data) : Ce("WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()") : L ? te && t.texSubImage2D(r.TEXTURE_2D, Q, 0, 0, se.width, se.height, oe, ge, se.data) : t.texImage2D(r.TEXTURE_2D, Q, Me, se.width, se.height, 0, oe, ge, se.data);
        }
      else if (v.isDataArrayTexture)
        if (L) {
          if (fe && t.texStorage3D(r.TEXTURE_2D_ARRAY, de, Me, ee.width, ee.height, ee.depth), te)
            if (v.layerUpdates.size > 0) {
              const Q = fl(ee.width, ee.height, v.format, v.type);
              for (const Z of v.layerUpdates) {
                const ie = ee.data.subarray(
                  Z * Q / ee.data.BYTES_PER_ELEMENT,
                  (Z + 1) * Q / ee.data.BYTES_PER_ELEMENT
                );
                t.texSubImage3D(r.TEXTURE_2D_ARRAY, 0, 0, 0, Z, ee.width, ee.height, 1, oe, ge, ie);
              }
              v.clearLayerUpdates();
            } else
              t.texSubImage3D(r.TEXTURE_2D_ARRAY, 0, 0, 0, 0, ee.width, ee.height, ee.depth, oe, ge, ee.data);
        } else
          t.texImage3D(r.TEXTURE_2D_ARRAY, 0, Me, ee.width, ee.height, ee.depth, 0, oe, ge, ee.data);
      else if (v.isData3DTexture)
        L ? (fe && t.texStorage3D(r.TEXTURE_3D, de, Me, ee.width, ee.height, ee.depth), te && t.texSubImage3D(r.TEXTURE_3D, 0, 0, 0, 0, ee.width, ee.height, ee.depth, oe, ge, ee.data)) : t.texImage3D(r.TEXTURE_3D, 0, Me, ee.width, ee.height, ee.depth, 0, oe, ge, ee.data);
      else if (v.isFramebufferTexture) {
        if (fe)
          if (L)
            t.texStorage2D(r.TEXTURE_2D, de, Me, ee.width, ee.height);
          else {
            let Q = ee.width, Z = ee.height;
            for (let ie = 0; ie < de; ie++)
              t.texImage2D(r.TEXTURE_2D, ie, Me, Q, Z, 0, oe, ge, null), Q >>= 1, Z >>= 1;
          }
      } else if (Oe.length > 0) {
        if (L && fe) {
          const Q = Se(Oe[0]);
          t.texStorage2D(r.TEXTURE_2D, de, Me, Q.width, Q.height);
        }
        for (let Q = 0, Z = Oe.length; Q < Z; Q++)
          se = Oe[Q], L ? te && t.texSubImage2D(r.TEXTURE_2D, Q, 0, 0, oe, ge, se) : t.texImage2D(r.TEXTURE_2D, Q, Me, oe, ge, se);
        v.generateMipmaps = !1;
      } else if (L) {
        if (fe) {
          const Q = Se(ee);
          t.texStorage2D(r.TEXTURE_2D, de, Me, Q.width, Q.height);
        }
        te && t.texSubImage2D(r.TEXTURE_2D, 0, 0, 0, oe, ge, ee);
      } else
        t.texImage2D(r.TEXTURE_2D, 0, Me, oe, ge, ee);
      m(v) && p(q), ye.__version = X.version, v.onUpdate && v.onUpdate(v);
    }
    w.__version = v.version;
  }
  function J(w, v, F) {
    if (v.image.length !== 6) return;
    const q = Le(w, v), j = v.source;
    t.bindTexture(r.TEXTURE_CUBE_MAP, w.__webglTexture, r.TEXTURE0 + F);
    const X = n.get(j);
    if (j.version !== X.__version || q === !0) {
      t.activeTexture(r.TEXTURE0 + F);
      const ye = qe.getPrimaries(qe.workingColorSpace), re = v.colorSpace === "" ? null : qe.getPrimaries(v.colorSpace), xe = v.colorSpace === "" || ye === re ? r.NONE : r.BROWSER_DEFAULT_WEBGL;
      r.pixelStorei(r.UNPACK_FLIP_Y_WEBGL, v.flipY), r.pixelStorei(r.UNPACK_PREMULTIPLY_ALPHA_WEBGL, v.premultiplyAlpha), r.pixelStorei(r.UNPACK_ALIGNMENT, v.unpackAlignment), r.pixelStorei(r.UNPACK_COLORSPACE_CONVERSION_WEBGL, xe);
      const Re = v.isCompressedTexture || v.image[0].isCompressedTexture, ee = v.image[0] && v.image[0].isDataTexture, oe = [];
      for (let Z = 0; Z < 6; Z++)
        !Re && !ee ? oe[Z] = _(v.image[Z], !0, i.maxCubemapSize) : oe[Z] = ee ? v.image[Z].image : v.image[Z], oe[Z] = at(v, oe[Z]);
      const ge = oe[0], Me = s.convert(v.format, v.colorSpace), se = s.convert(v.type), Oe = b(v.internalFormat, Me, se, v.colorSpace), L = v.isVideoTexture !== !0, fe = X.__version === void 0 || q === !0, te = j.dataReady;
      let de = y(v, ge);
      Pe(r.TEXTURE_CUBE_MAP, v);
      let Q;
      if (Re) {
        L && fe && t.texStorage2D(r.TEXTURE_CUBE_MAP, de, Oe, ge.width, ge.height);
        for (let Z = 0; Z < 6; Z++) {
          Q = oe[Z].mipmaps;
          for (let ie = 0; ie < Q.length; ie++) {
            const De = Q[ie];
            v.format !== 1023 ? Me !== null ? L ? te && t.compressedTexSubImage2D(r.TEXTURE_CUBE_MAP_POSITIVE_X + Z, ie, 0, 0, De.width, De.height, Me, De.data) : t.compressedTexImage2D(r.TEXTURE_CUBE_MAP_POSITIVE_X + Z, ie, Oe, De.width, De.height, 0, De.data) : Ce("WebGLRenderer: Attempt to load unsupported compressed texture format in .setTextureCube()") : L ? te && t.texSubImage2D(r.TEXTURE_CUBE_MAP_POSITIVE_X + Z, ie, 0, 0, De.width, De.height, Me, se, De.data) : t.texImage2D(r.TEXTURE_CUBE_MAP_POSITIVE_X + Z, ie, Oe, De.width, De.height, 0, Me, se, De.data);
          }
        }
      } else {
        if (Q = v.mipmaps, L && fe) {
          Q.length > 0 && de++;
          const Z = Se(oe[0]);
          t.texStorage2D(r.TEXTURE_CUBE_MAP, de, Oe, Z.width, Z.height);
        }
        for (let Z = 0; Z < 6; Z++)
          if (ee) {
            L ? te && t.texSubImage2D(r.TEXTURE_CUBE_MAP_POSITIVE_X + Z, 0, 0, 0, oe[Z].width, oe[Z].height, Me, se, oe[Z].data) : t.texImage2D(r.TEXTURE_CUBE_MAP_POSITIVE_X + Z, 0, Oe, oe[Z].width, oe[Z].height, 0, Me, se, oe[Z].data);
            for (let ie = 0; ie < Q.length; ie++) {
              const ot = Q[ie].image[Z].image;
              L ? te && t.texSubImage2D(r.TEXTURE_CUBE_MAP_POSITIVE_X + Z, ie + 1, 0, 0, ot.width, ot.height, Me, se, ot.data) : t.texImage2D(r.TEXTURE_CUBE_MAP_POSITIVE_X + Z, ie + 1, Oe, ot.width, ot.height, 0, Me, se, ot.data);
            }
          } else {
            L ? te && t.texSubImage2D(r.TEXTURE_CUBE_MAP_POSITIVE_X + Z, 0, 0, 0, Me, se, oe[Z]) : t.texImage2D(r.TEXTURE_CUBE_MAP_POSITIVE_X + Z, 0, Oe, Me, se, oe[Z]);
            for (let ie = 0; ie < Q.length; ie++) {
              const De = Q[ie];
              L ? te && t.texSubImage2D(r.TEXTURE_CUBE_MAP_POSITIVE_X + Z, ie + 1, 0, 0, Me, se, De.image[Z]) : t.texImage2D(r.TEXTURE_CUBE_MAP_POSITIVE_X + Z, ie + 1, Oe, Me, se, De.image[Z]);
            }
          }
      }
      m(v) && p(r.TEXTURE_CUBE_MAP), X.__version = j.version, v.onUpdate && v.onUpdate(v);
    }
    w.__version = v.version;
  }
  function me(w, v, F, q, j, X) {
    const ye = s.convert(F.format, F.colorSpace), re = s.convert(F.type), xe = b(F.internalFormat, ye, re, F.colorSpace), Re = n.get(v), ee = n.get(F);
    if (ee.__renderTarget = v, !Re.__hasExternalTextures) {
      const oe = Math.max(1, v.width >> X), ge = Math.max(1, v.height >> X);
      j === r.TEXTURE_3D || j === r.TEXTURE_2D_ARRAY ? t.texImage3D(j, X, xe, oe, ge, v.depth, 0, ye, re, null) : t.texImage2D(j, X, xe, oe, ge, 0, ye, re, null);
    }
    t.bindFramebuffer(r.FRAMEBUFFER, w), Mt(v) ? o.framebufferTexture2DMultisampleEXT(r.FRAMEBUFFER, q, j, ee.__webglTexture, 0, D(v)) : (j === r.TEXTURE_2D || j >= r.TEXTURE_CUBE_MAP_POSITIVE_X && j <= r.TEXTURE_CUBE_MAP_NEGATIVE_Z) && r.framebufferTexture2D(r.FRAMEBUFFER, q, j, ee.__webglTexture, X), t.bindFramebuffer(r.FRAMEBUFFER, null);
  }
  function Fe(w, v, F) {
    if (r.bindRenderbuffer(r.RENDERBUFFER, w), v.depthBuffer) {
      const q = v.depthTexture, j = q && q.isDepthTexture ? q.type : null, X = T(v.stencilBuffer, j), ye = v.stencilBuffer ? r.DEPTH_STENCIL_ATTACHMENT : r.DEPTH_ATTACHMENT;
      Mt(v) ? o.renderbufferStorageMultisampleEXT(r.RENDERBUFFER, D(v), X, v.width, v.height) : F ? r.renderbufferStorageMultisample(r.RENDERBUFFER, D(v), X, v.width, v.height) : r.renderbufferStorage(r.RENDERBUFFER, X, v.width, v.height), r.framebufferRenderbuffer(r.FRAMEBUFFER, ye, r.RENDERBUFFER, w);
    } else {
      const q = v.textures;
      for (let j = 0; j < q.length; j++) {
        const X = q[j], ye = s.convert(X.format, X.colorSpace), re = s.convert(X.type), xe = b(X.internalFormat, ye, re, X.colorSpace);
        Mt(v) ? o.renderbufferStorageMultisampleEXT(r.RENDERBUFFER, D(v), xe, v.width, v.height) : F ? r.renderbufferStorageMultisample(r.RENDERBUFFER, D(v), xe, v.width, v.height) : r.renderbufferStorage(r.RENDERBUFFER, xe, v.width, v.height);
      }
    }
    r.bindRenderbuffer(r.RENDERBUFFER, null);
  }
  function ve(w, v, F) {
    const q = v.isWebGLCubeRenderTarget === !0;
    if (t.bindFramebuffer(r.FRAMEBUFFER, w), !(v.depthTexture && v.depthTexture.isDepthTexture))
      throw new Error("renderTarget.depthTexture must be an instance of THREE.DepthTexture");
    const j = n.get(v.depthTexture);
    if (j.__renderTarget = v, (!j.__webglTexture || v.depthTexture.image.width !== v.width || v.depthTexture.image.height !== v.height) && (v.depthTexture.image.width = v.width, v.depthTexture.image.height = v.height, v.depthTexture.needsUpdate = !0), q) {
      if (j.__webglInit === void 0 && (j.__webglInit = !0, v.depthTexture.addEventListener("dispose", R)), j.__webglTexture === void 0) {
        j.__webglTexture = r.createTexture(), t.bindTexture(r.TEXTURE_CUBE_MAP, j.__webglTexture), Pe(r.TEXTURE_CUBE_MAP, v.depthTexture);
        const Re = s.convert(v.depthTexture.format), ee = s.convert(v.depthTexture.type);
        let oe;
        v.depthTexture.format === 1026 ? oe = r.DEPTH_COMPONENT24 : v.depthTexture.format === 1027 && (oe = r.DEPTH24_STENCIL8);
        for (let ge = 0; ge < 6; ge++)
          r.texImage2D(r.TEXTURE_CUBE_MAP_POSITIVE_X + ge, 0, oe, v.width, v.height, 0, Re, ee, null);
      }
    } else
      H(v.depthTexture, 0);
    const X = j.__webglTexture, ye = D(v), re = q ? r.TEXTURE_CUBE_MAP_POSITIVE_X + F : r.TEXTURE_2D, xe = v.depthTexture.format === 1027 ? r.DEPTH_STENCIL_ATTACHMENT : r.DEPTH_ATTACHMENT;
    if (v.depthTexture.format === 1026)
      Mt(v) ? o.framebufferTexture2DMultisampleEXT(r.FRAMEBUFFER, xe, re, X, 0, ye) : r.framebufferTexture2D(r.FRAMEBUFFER, xe, re, X, 0);
    else if (v.depthTexture.format === 1027)
      Mt(v) ? o.framebufferTexture2DMultisampleEXT(r.FRAMEBUFFER, xe, re, X, 0, ye) : r.framebufferTexture2D(r.FRAMEBUFFER, xe, re, X, 0);
    else
      throw new Error("Unknown depthTexture format");
  }
  function Ye(w) {
    const v = n.get(w), F = w.isWebGLCubeRenderTarget === !0;
    if (v.__boundDepthTexture !== w.depthTexture) {
      const q = w.depthTexture;
      if (v.__depthDisposeCallback && v.__depthDisposeCallback(), q) {
        const j = () => {
          delete v.__boundDepthTexture, delete v.__depthDisposeCallback, q.removeEventListener("dispose", j);
        };
        q.addEventListener("dispose", j), v.__depthDisposeCallback = j;
      }
      v.__boundDepthTexture = q;
    }
    if (w.depthTexture && !v.__autoAllocateDepthBuffer)
      if (F)
        for (let q = 0; q < 6; q++)
          ve(v.__webglFramebuffer[q], w, q);
      else {
        const q = w.texture.mipmaps;
        q && q.length > 0 ? ve(v.__webglFramebuffer[0], w, 0) : ve(v.__webglFramebuffer, w, 0);
      }
    else if (F) {
      v.__webglDepthbuffer = [];
      for (let q = 0; q < 6; q++)
        if (t.bindFramebuffer(r.FRAMEBUFFER, v.__webglFramebuffer[q]), v.__webglDepthbuffer[q] === void 0)
          v.__webglDepthbuffer[q] = r.createRenderbuffer(), Fe(v.__webglDepthbuffer[q], w, !1);
        else {
          const j = w.stencilBuffer ? r.DEPTH_STENCIL_ATTACHMENT : r.DEPTH_ATTACHMENT, X = v.__webglDepthbuffer[q];
          r.bindRenderbuffer(r.RENDERBUFFER, X), r.framebufferRenderbuffer(r.FRAMEBUFFER, j, r.RENDERBUFFER, X);
        }
    } else {
      const q = w.texture.mipmaps;
      if (q && q.length > 0 ? t.bindFramebuffer(r.FRAMEBUFFER, v.__webglFramebuffer[0]) : t.bindFramebuffer(r.FRAMEBUFFER, v.__webglFramebuffer), v.__webglDepthbuffer === void 0)
        v.__webglDepthbuffer = r.createRenderbuffer(), Fe(v.__webglDepthbuffer, w, !1);
      else {
        const j = w.stencilBuffer ? r.DEPTH_STENCIL_ATTACHMENT : r.DEPTH_ATTACHMENT, X = v.__webglDepthbuffer;
        r.bindRenderbuffer(r.RENDERBUFFER, X), r.framebufferRenderbuffer(r.FRAMEBUFFER, j, r.RENDERBUFFER, X);
      }
    }
    t.bindFramebuffer(r.FRAMEBUFFER, null);
  }
  function Rt(w, v, F) {
    const q = n.get(w);
    v !== void 0 && me(q.__webglFramebuffer, w, w.texture, r.COLOR_ATTACHMENT0, r.TEXTURE_2D, 0), F !== void 0 && Ye(w);
  }
  function We(w) {
    const v = w.texture, F = n.get(w), q = n.get(v);
    w.addEventListener("dispose", A);
    const j = w.textures, X = w.isWebGLCubeRenderTarget === !0, ye = j.length > 1;
    if (ye || (q.__webglTexture === void 0 && (q.__webglTexture = r.createTexture()), q.__version = v.version, a.memory.textures++), X) {
      F.__webglFramebuffer = [];
      for (let re = 0; re < 6; re++)
        if (v.mipmaps && v.mipmaps.length > 0) {
          F.__webglFramebuffer[re] = [];
          for (let xe = 0; xe < v.mipmaps.length; xe++)
            F.__webglFramebuffer[re][xe] = r.createFramebuffer();
        } else
          F.__webglFramebuffer[re] = r.createFramebuffer();
    } else {
      if (v.mipmaps && v.mipmaps.length > 0) {
        F.__webglFramebuffer = [];
        for (let re = 0; re < v.mipmaps.length; re++)
          F.__webglFramebuffer[re] = r.createFramebuffer();
      } else
        F.__webglFramebuffer = r.createFramebuffer();
      if (ye)
        for (let re = 0, xe = j.length; re < xe; re++) {
          const Re = n.get(j[re]);
          Re.__webglTexture === void 0 && (Re.__webglTexture = r.createTexture(), a.memory.textures++);
        }
      if (w.samples > 0 && Mt(w) === !1) {
        F.__webglMultisampledFramebuffer = r.createFramebuffer(), F.__webglColorRenderbuffer = [], t.bindFramebuffer(r.FRAMEBUFFER, F.__webglMultisampledFramebuffer);
        for (let re = 0; re < j.length; re++) {
          const xe = j[re];
          F.__webglColorRenderbuffer[re] = r.createRenderbuffer(), r.bindRenderbuffer(r.RENDERBUFFER, F.__webglColorRenderbuffer[re]);
          const Re = s.convert(xe.format, xe.colorSpace), ee = s.convert(xe.type), oe = b(xe.internalFormat, Re, ee, xe.colorSpace, w.isXRRenderTarget === !0), ge = D(w);
          r.renderbufferStorageMultisample(r.RENDERBUFFER, ge, oe, w.width, w.height), r.framebufferRenderbuffer(r.FRAMEBUFFER, r.COLOR_ATTACHMENT0 + re, r.RENDERBUFFER, F.__webglColorRenderbuffer[re]);
        }
        r.bindRenderbuffer(r.RENDERBUFFER, null), w.depthBuffer && (F.__webglDepthRenderbuffer = r.createRenderbuffer(), Fe(F.__webglDepthRenderbuffer, w, !0)), t.bindFramebuffer(r.FRAMEBUFFER, null);
      }
    }
    if (X) {
      t.bindTexture(r.TEXTURE_CUBE_MAP, q.__webglTexture), Pe(r.TEXTURE_CUBE_MAP, v);
      for (let re = 0; re < 6; re++)
        if (v.mipmaps && v.mipmaps.length > 0)
          for (let xe = 0; xe < v.mipmaps.length; xe++)
            me(F.__webglFramebuffer[re][xe], w, v, r.COLOR_ATTACHMENT0, r.TEXTURE_CUBE_MAP_POSITIVE_X + re, xe);
        else
          me(F.__webglFramebuffer[re], w, v, r.COLOR_ATTACHMENT0, r.TEXTURE_CUBE_MAP_POSITIVE_X + re, 0);
      m(v) && p(r.TEXTURE_CUBE_MAP), t.unbindTexture();
    } else if (ye) {
      for (let re = 0, xe = j.length; re < xe; re++) {
        const Re = j[re], ee = n.get(Re);
        let oe = r.TEXTURE_2D;
        (w.isWebGL3DRenderTarget || w.isWebGLArrayRenderTarget) && (oe = w.isWebGL3DRenderTarget ? r.TEXTURE_3D : r.TEXTURE_2D_ARRAY), t.bindTexture(oe, ee.__webglTexture), Pe(oe, Re), me(F.__webglFramebuffer, w, Re, r.COLOR_ATTACHMENT0 + re, oe, 0), m(Re) && p(oe);
      }
      t.unbindTexture();
    } else {
      let re = r.TEXTURE_2D;
      if ((w.isWebGL3DRenderTarget || w.isWebGLArrayRenderTarget) && (re = w.isWebGL3DRenderTarget ? r.TEXTURE_3D : r.TEXTURE_2D_ARRAY), t.bindTexture(re, q.__webglTexture), Pe(re, v), v.mipmaps && v.mipmaps.length > 0)
        for (let xe = 0; xe < v.mipmaps.length; xe++)
          me(F.__webglFramebuffer[xe], w, v, r.COLOR_ATTACHMENT0, re, xe);
      else
        me(F.__webglFramebuffer, w, v, r.COLOR_ATTACHMENT0, re, 0);
      m(v) && p(re), t.unbindTexture();
    }
    w.depthBuffer && Ye(w);
  }
  function Ze(w) {
    const v = w.textures;
    for (let F = 0, q = v.length; F < q; F++) {
      const j = v[F];
      if (m(j)) {
        const X = S(w), ye = n.get(j).__webglTexture;
        t.bindTexture(X, ye), p(X), t.unbindTexture();
      }
    }
  }
  const nt = [], Ne = [];
  function St(w) {
    if (w.samples > 0) {
      if (Mt(w) === !1) {
        const v = w.textures, F = w.width, q = w.height;
        let j = r.COLOR_BUFFER_BIT;
        const X = w.stencilBuffer ? r.DEPTH_STENCIL_ATTACHMENT : r.DEPTH_ATTACHMENT, ye = n.get(w), re = v.length > 1;
        if (re)
          for (let Re = 0; Re < v.length; Re++)
            t.bindFramebuffer(r.FRAMEBUFFER, ye.__webglMultisampledFramebuffer), r.framebufferRenderbuffer(r.FRAMEBUFFER, r.COLOR_ATTACHMENT0 + Re, r.RENDERBUFFER, null), t.bindFramebuffer(r.FRAMEBUFFER, ye.__webglFramebuffer), r.framebufferTexture2D(r.DRAW_FRAMEBUFFER, r.COLOR_ATTACHMENT0 + Re, r.TEXTURE_2D, null, 0);
        t.bindFramebuffer(r.READ_FRAMEBUFFER, ye.__webglMultisampledFramebuffer);
        const xe = w.texture.mipmaps;
        xe && xe.length > 0 ? t.bindFramebuffer(r.DRAW_FRAMEBUFFER, ye.__webglFramebuffer[0]) : t.bindFramebuffer(r.DRAW_FRAMEBUFFER, ye.__webglFramebuffer);
        for (let Re = 0; Re < v.length; Re++) {
          if (w.resolveDepthBuffer && (w.depthBuffer && (j |= r.DEPTH_BUFFER_BIT), w.stencilBuffer && w.resolveStencilBuffer && (j |= r.STENCIL_BUFFER_BIT)), re) {
            r.framebufferRenderbuffer(r.READ_FRAMEBUFFER, r.COLOR_ATTACHMENT0, r.RENDERBUFFER, ye.__webglColorRenderbuffer[Re]);
            const ee = n.get(v[Re]).__webglTexture;
            r.framebufferTexture2D(r.DRAW_FRAMEBUFFER, r.COLOR_ATTACHMENT0, r.TEXTURE_2D, ee, 0);
          }
          r.blitFramebuffer(0, 0, F, q, 0, 0, F, q, j, r.NEAREST), c === !0 && (nt.length = 0, Ne.length = 0, nt.push(r.COLOR_ATTACHMENT0 + Re), w.depthBuffer && w.resolveDepthBuffer === !1 && (nt.push(X), Ne.push(X), r.invalidateFramebuffer(r.DRAW_FRAMEBUFFER, Ne)), r.invalidateFramebuffer(r.READ_FRAMEBUFFER, nt));
        }
        if (t.bindFramebuffer(r.READ_FRAMEBUFFER, null), t.bindFramebuffer(r.DRAW_FRAMEBUFFER, null), re)
          for (let Re = 0; Re < v.length; Re++) {
            t.bindFramebuffer(r.FRAMEBUFFER, ye.__webglMultisampledFramebuffer), r.framebufferRenderbuffer(r.FRAMEBUFFER, r.COLOR_ATTACHMENT0 + Re, r.RENDERBUFFER, ye.__webglColorRenderbuffer[Re]);
            const ee = n.get(v[Re]).__webglTexture;
            t.bindFramebuffer(r.FRAMEBUFFER, ye.__webglFramebuffer), r.framebufferTexture2D(r.DRAW_FRAMEBUFFER, r.COLOR_ATTACHMENT0 + Re, r.TEXTURE_2D, ee, 0);
          }
        t.bindFramebuffer(r.DRAW_FRAMEBUFFER, ye.__webglMultisampledFramebuffer);
      } else if (w.depthBuffer && w.resolveDepthBuffer === !1 && c) {
        const v = w.stencilBuffer ? r.DEPTH_STENCIL_ATTACHMENT : r.DEPTH_ATTACHMENT;
        r.invalidateFramebuffer(r.DRAW_FRAMEBUFFER, [v]);
      }
    }
  }
  function D(w) {
    return Math.min(i.maxSamples, w.samples);
  }
  function Mt(w) {
    const v = n.get(w);
    return w.samples > 0 && e.has("WEBGL_multisampled_render_to_texture") === !0 && v.__useRenderToTexture !== !1;
  }
  function Ke(w) {
    const v = a.render.frame;
    u.get(w) !== v && (u.set(w, v), w.update());
  }
  function at(w, v) {
    const F = w.colorSpace, q = w.format, j = w.type;
    return w.isCompressedTexture === !0 || w.isVideoTexture === !0 || F !== tr && F !== "" && (qe.getTransfer(F) === Qe ? (q !== 1023 || j !== 1009) && Ce("WebGLTextures: sRGB encoded textures have to use RGBAFormat and UnsignedByteType.") : Xe("WebGLTextures: Unsupported texture color space:", F)), v;
  }
  function Se(w) {
    return typeof HTMLImageElement < "u" && w instanceof HTMLImageElement ? (l.width = w.naturalWidth || w.width, l.height = w.naturalHeight || w.height) : typeof VideoFrame < "u" && w instanceof VideoFrame ? (l.width = w.displayWidth, l.height = w.displayHeight) : (l.width = w.width, l.height = w.height), l;
  }
  this.allocateTextureUnit = N, this.resetTextureUnits = z, this.setTexture2D = H, this.setTexture2DArray = k, this.setTexture3D = O, this.setTextureCube = Y, this.rebindTextures = Rt, this.setupRenderTarget = We, this.updateRenderTargetMipmap = Ze, this.updateMultisampleRenderTarget = St, this.setupDepthRenderbuffer = Ye, this.setupFrameBufferTexture = me, this.useMultisampledRTT = Mt, this.isReversedDepthBuffer = function() {
    return t.buffers.depth.getReversed();
  };
}
function A_(r, e) {
  function t(n, i = "") {
    let s;
    const a = qe.getTransfer(i);
    if (n === 1009) return r.UNSIGNED_BYTE;
    if (n === 1017) return r.UNSIGNED_SHORT_4_4_4_4;
    if (n === 1018) return r.UNSIGNED_SHORT_5_5_5_1;
    if (n === 35902) return r.UNSIGNED_INT_5_9_9_9_REV;
    if (n === 35899) return r.UNSIGNED_INT_10F_11F_11F_REV;
    if (n === 1010) return r.BYTE;
    if (n === 1011) return r.SHORT;
    if (n === 1012) return r.UNSIGNED_SHORT;
    if (n === 1013) return r.INT;
    if (n === 1014) return r.UNSIGNED_INT;
    if (n === 1015) return r.FLOAT;
    if (n === 1016) return r.HALF_FLOAT;
    if (n === 1021) return r.ALPHA;
    if (n === 1022) return r.RGB;
    if (n === 1023) return r.RGBA;
    if (n === 1026) return r.DEPTH_COMPONENT;
    if (n === 1027) return r.DEPTH_STENCIL;
    if (n === 1028) return r.RED;
    if (n === 1029) return r.RED_INTEGER;
    if (n === 1030) return r.RG;
    if (n === 1031) return r.RG_INTEGER;
    if (n === 1033) return r.RGBA_INTEGER;
    if (n === 33776 || n === 33777 || n === 33778 || n === 33779)
      if (a === Qe)
        if (s = e.get("WEBGL_compressed_texture_s3tc_srgb"), s !== null) {
          if (n === 33776) return s.COMPRESSED_SRGB_S3TC_DXT1_EXT;
          if (n === 33777) return s.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT;
          if (n === 33778) return s.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT;
          if (n === 33779) return s.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT;
        } else
          return null;
      else if (s = e.get("WEBGL_compressed_texture_s3tc"), s !== null) {
        if (n === 33776) return s.COMPRESSED_RGB_S3TC_DXT1_EXT;
        if (n === 33777) return s.COMPRESSED_RGBA_S3TC_DXT1_EXT;
        if (n === 33778) return s.COMPRESSED_RGBA_S3TC_DXT3_EXT;
        if (n === 33779) return s.COMPRESSED_RGBA_S3TC_DXT5_EXT;
      } else
        return null;
    if (n === 35840 || n === 35841 || n === 35842 || n === 35843)
      if (s = e.get("WEBGL_compressed_texture_pvrtc"), s !== null) {
        if (n === 35840) return s.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;
        if (n === 35841) return s.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;
        if (n === 35842) return s.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;
        if (n === 35843) return s.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG;
      } else
        return null;
    if (n === 36196 || n === 37492 || n === 37496 || n === 37488 || n === 37489 || n === 37490 || n === 37491)
      if (s = e.get("WEBGL_compressed_texture_etc"), s !== null) {
        if (n === 36196 || n === 37492) return a === Qe ? s.COMPRESSED_SRGB8_ETC2 : s.COMPRESSED_RGB8_ETC2;
        if (n === 37496) return a === Qe ? s.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC : s.COMPRESSED_RGBA8_ETC2_EAC;
        if (n === 37488) return s.COMPRESSED_R11_EAC;
        if (n === 37489) return s.COMPRESSED_SIGNED_R11_EAC;
        if (n === 37490) return s.COMPRESSED_RG11_EAC;
        if (n === 37491) return s.COMPRESSED_SIGNED_RG11_EAC;
      } else
        return null;
    if (n === 37808 || n === 37809 || n === 37810 || n === 37811 || n === 37812 || n === 37813 || n === 37814 || n === 37815 || n === 37816 || n === 37817 || n === 37818 || n === 37819 || n === 37820 || n === 37821)
      if (s = e.get("WEBGL_compressed_texture_astc"), s !== null) {
        if (n === 37808) return a === Qe ? s.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR : s.COMPRESSED_RGBA_ASTC_4x4_KHR;
        if (n === 37809) return a === Qe ? s.COMPRESSED_SRGB8_ALPHA8_ASTC_5x4_KHR : s.COMPRESSED_RGBA_ASTC_5x4_KHR;
        if (n === 37810) return a === Qe ? s.COMPRESSED_SRGB8_ALPHA8_ASTC_5x5_KHR : s.COMPRESSED_RGBA_ASTC_5x5_KHR;
        if (n === 37811) return a === Qe ? s.COMPRESSED_SRGB8_ALPHA8_ASTC_6x5_KHR : s.COMPRESSED_RGBA_ASTC_6x5_KHR;
        if (n === 37812) return a === Qe ? s.COMPRESSED_SRGB8_ALPHA8_ASTC_6x6_KHR : s.COMPRESSED_RGBA_ASTC_6x6_KHR;
        if (n === 37813) return a === Qe ? s.COMPRESSED_SRGB8_ALPHA8_ASTC_8x5_KHR : s.COMPRESSED_RGBA_ASTC_8x5_KHR;
        if (n === 37814) return a === Qe ? s.COMPRESSED_SRGB8_ALPHA8_ASTC_8x6_KHR : s.COMPRESSED_RGBA_ASTC_8x6_KHR;
        if (n === 37815) return a === Qe ? s.COMPRESSED_SRGB8_ALPHA8_ASTC_8x8_KHR : s.COMPRESSED_RGBA_ASTC_8x8_KHR;
        if (n === 37816) return a === Qe ? s.COMPRESSED_SRGB8_ALPHA8_ASTC_10x5_KHR : s.COMPRESSED_RGBA_ASTC_10x5_KHR;
        if (n === 37817) return a === Qe ? s.COMPRESSED_SRGB8_ALPHA8_ASTC_10x6_KHR : s.COMPRESSED_RGBA_ASTC_10x6_KHR;
        if (n === 37818) return a === Qe ? s.COMPRESSED_SRGB8_ALPHA8_ASTC_10x8_KHR : s.COMPRESSED_RGBA_ASTC_10x8_KHR;
        if (n === 37819) return a === Qe ? s.COMPRESSED_SRGB8_ALPHA8_ASTC_10x10_KHR : s.COMPRESSED_RGBA_ASTC_10x10_KHR;
        if (n === 37820) return a === Qe ? s.COMPRESSED_SRGB8_ALPHA8_ASTC_12x10_KHR : s.COMPRESSED_RGBA_ASTC_12x10_KHR;
        if (n === 37821) return a === Qe ? s.COMPRESSED_SRGB8_ALPHA8_ASTC_12x12_KHR : s.COMPRESSED_RGBA_ASTC_12x12_KHR;
      } else
        return null;
    if (n === 36492 || n === 36494 || n === 36495)
      if (s = e.get("EXT_texture_compression_bptc"), s !== null) {
        if (n === 36492) return a === Qe ? s.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT : s.COMPRESSED_RGBA_BPTC_UNORM_EXT;
        if (n === 36494) return s.COMPRESSED_RGB_BPTC_SIGNED_FLOAT_EXT;
        if (n === 36495) return s.COMPRESSED_RGB_BPTC_UNSIGNED_FLOAT_EXT;
      } else
        return null;
    if (n === 36283 || n === 36284 || n === 36285 || n === 36286)
      if (s = e.get("EXT_texture_compression_rgtc"), s !== null) {
        if (n === 36283) return s.COMPRESSED_RED_RGTC1_EXT;
        if (n === 36284) return s.COMPRESSED_SIGNED_RED_RGTC1_EXT;
        if (n === 36285) return s.COMPRESSED_RED_GREEN_RGTC2_EXT;
        if (n === 36286) return s.COMPRESSED_SIGNED_RED_GREEN_RGTC2_EXT;
      } else
        return null;
    return n === 1020 ? r.UNSIGNED_INT_24_8 : r[n] !== void 0 ? r[n] : null;
  }
  return { convert: t };
}
const w_ = `
void main() {

	gl_Position = vec4( position, 1.0 );

}`, R_ = `
uniform sampler2DArray depthColor;
uniform float depthWidth;
uniform float depthHeight;

void main() {

	vec2 coord = vec2( gl_FragCoord.x / depthWidth, gl_FragCoord.y / depthHeight );

	if ( coord.x >= 1.0 ) {

		gl_FragDepth = texture( depthColor, vec3( coord.x - 1.0, coord.y, 1 ) ).r;

	} else {

		gl_FragDepth = texture( depthColor, vec3( coord.x, coord.y, 0 ) ).r;

	}

}`;
class C_ {
  /**
   * Constructs a new depth sensing module.
   */
  constructor() {
    this.texture = null, this.mesh = null, this.depthNear = 0, this.depthFar = 0;
  }
  /**
   * Inits the depth sensing module
   *
   * @param {XRWebGLDepthInformation} depthData - The XR depth data.
   * @param {XRRenderState} renderState - The XR render state.
   */
  init(e, t) {
    if (this.texture === null) {
      const n = new xc(e.texture);
      (e.depthNear !== t.depthNear || e.depthFar !== t.depthFar) && (this.depthNear = e.depthNear, this.depthFar = e.depthFar), this.texture = n;
    }
  }
  /**
   * Returns a plane mesh that visualizes the depth texture.
   *
   * @param {ArrayCamera} cameraXR - The XR camera.
   * @return {?Mesh} The plane mesh.
   */
  getMesh(e) {
    if (this.texture !== null && this.mesh === null) {
      const t = e.cameras[0].viewport, n = new Ht({
        vertexShader: w_,
        fragmentShader: R_,
        uniforms: {
          depthColor: { value: this.texture },
          depthWidth: { value: t.z },
          depthHeight: { value: t.w }
        }
      });
      this.mesh = new Lt(new _n(20, 20), n);
    }
    return this.mesh;
  }
  /**
   * Resets the module
   */
  reset() {
    this.texture = null, this.mesh = null;
  }
  /**
   * Returns a texture representing the depth of the user's environment.
   *
   * @return {?ExternalTexture} The depth texture.
   */
  getDepthTexture() {
    return this.texture;
  }
}
class P_ extends lr {
  /**
   * Constructs a new WebGL renderer.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {WebGL2RenderingContext} gl - The rendering context.
   */
  constructor(e, t) {
    super();
    const n = this;
    let i = null, s = 1, a = null, o = "local-floor", c = 1, l = null, u = null, h = null, f = null, d = null, g = null;
    const _ = typeof XRWebGLBinding < "u", m = new C_(), p = {}, S = t.getContextAttributes();
    let b = null, T = null;
    const y = [], R = [], A = new Ae();
    let C = null;
    const x = new qt();
    x.viewport = new xt();
    const E = new qt();
    E.viewport = new xt();
    const P = [x, E], z = new zh();
    let N = null, W = null;
    this.cameraAutoUpdate = !0, this.enabled = !1, this.isPresenting = !1, this.getController = function($) {
      let J = y[$];
      return J === void 0 && (J = new ya(), y[$] = J), J.getTargetRaySpace();
    }, this.getControllerGrip = function($) {
      let J = y[$];
      return J === void 0 && (J = new ya(), y[$] = J), J.getGripSpace();
    }, this.getHand = function($) {
      let J = y[$];
      return J === void 0 && (J = new ya(), y[$] = J), J.getHandSpace();
    };
    function H($) {
      const J = R.indexOf($.inputSource);
      if (J === -1)
        return;
      const me = y[J];
      me !== void 0 && (me.update($.inputSource, $.frame, l || a), me.dispatchEvent({ type: $.type, data: $.inputSource }));
    }
    function k() {
      i.removeEventListener("select", H), i.removeEventListener("selectstart", H), i.removeEventListener("selectend", H), i.removeEventListener("squeeze", H), i.removeEventListener("squeezestart", H), i.removeEventListener("squeezeend", H), i.removeEventListener("end", k), i.removeEventListener("inputsourceschange", O);
      for (let $ = 0; $ < y.length; $++) {
        const J = R[$];
        J !== null && (R[$] = null, y[$].disconnect(J));
      }
      N = null, W = null, m.reset();
      for (const $ in p)
        delete p[$];
      e.setRenderTarget(b), d = null, f = null, h = null, i = null, T = null, He.stop(), n.isPresenting = !1, e.setPixelRatio(C), e.setSize(A.width, A.height, !1), n.dispatchEvent({ type: "sessionend" });
    }
    this.setFramebufferScaleFactor = function($) {
      s = $, n.isPresenting === !0 && Ce("WebXRManager: Cannot change framebuffer scale while presenting.");
    }, this.setReferenceSpaceType = function($) {
      o = $, n.isPresenting === !0 && Ce("WebXRManager: Cannot change reference space type while presenting.");
    }, this.getReferenceSpace = function() {
      return l || a;
    }, this.setReferenceSpace = function($) {
      l = $;
    }, this.getBaseLayer = function() {
      return f !== null ? f : d;
    }, this.getBinding = function() {
      return h === null && _ && (h = new XRWebGLBinding(i, t)), h;
    }, this.getFrame = function() {
      return g;
    }, this.getSession = function() {
      return i;
    }, this.setSession = async function($) {
      if (i = $, i !== null) {
        if (b = e.getRenderTarget(), i.addEventListener("select", H), i.addEventListener("selectstart", H), i.addEventListener("selectend", H), i.addEventListener("squeeze", H), i.addEventListener("squeezestart", H), i.addEventListener("squeezeend", H), i.addEventListener("end", k), i.addEventListener("inputsourceschange", O), S.xrCompatible !== !0 && await t.makeXRCompatible(), C = e.getPixelRatio(), e.getSize(A), _ && "createProjectionLayer" in XRWebGLBinding.prototype) {
          let me = null, Fe = null, ve = null;
          S.depth && (ve = S.stencil ? t.DEPTH24_STENCIL8 : t.DEPTH_COMPONENT24, me = S.stencil ? 1027 : 1026, Fe = S.stencil ? 1020 : 1014);
          const Ye = {
            colorFormat: t.RGBA8,
            depthFormat: ve,
            scaleFactor: s
          };
          h = this.getBinding(), f = h.createProjectionLayer(Ye), i.updateRenderState({ layers: [f] }), e.setPixelRatio(1), e.setSize(f.textureWidth, f.textureHeight, !1), T = new Cn(
            f.textureWidth,
            f.textureHeight,
            {
              format: 1023,
              type: 1009,
              depthTexture: new Nr(f.textureWidth, f.textureHeight, Fe, void 0, void 0, void 0, void 0, void 0, void 0, me),
              stencilBuffer: S.stencil,
              colorSpace: e.outputColorSpace,
              samples: S.antialias ? 4 : 0,
              resolveDepthBuffer: f.ignoreDepthValues === !1,
              resolveStencilBuffer: f.ignoreDepthValues === !1
            }
          );
        } else {
          const me = {
            antialias: S.antialias,
            alpha: !0,
            depth: S.depth,
            stencil: S.stencil,
            framebufferScaleFactor: s
          };
          d = new XRWebGLLayer(i, t, me), i.updateRenderState({ baseLayer: d }), e.setPixelRatio(1), e.setSize(d.framebufferWidth, d.framebufferHeight, !1), T = new Cn(
            d.framebufferWidth,
            d.framebufferHeight,
            {
              format: 1023,
              type: 1009,
              colorSpace: e.outputColorSpace,
              stencilBuffer: S.stencil,
              resolveDepthBuffer: d.ignoreDepthValues === !1,
              resolveStencilBuffer: d.ignoreDepthValues === !1
            }
          );
        }
        T.isXRRenderTarget = !0, this.setFoveation(c), l = null, a = await i.requestReferenceSpace(o), He.setContext(i), He.start(), n.isPresenting = !0, n.dispatchEvent({ type: "sessionstart" });
      }
    }, this.getEnvironmentBlendMode = function() {
      if (i !== null)
        return i.environmentBlendMode;
    }, this.getDepthTexture = function() {
      return m.getDepthTexture();
    };
    function O($) {
      for (let J = 0; J < $.removed.length; J++) {
        const me = $.removed[J], Fe = R.indexOf(me);
        Fe >= 0 && (R[Fe] = null, y[Fe].disconnect(me));
      }
      for (let J = 0; J < $.added.length; J++) {
        const me = $.added[J];
        let Fe = R.indexOf(me);
        if (Fe === -1) {
          for (let Ye = 0; Ye < y.length; Ye++)
            if (Ye >= R.length) {
              R.push(me), Fe = Ye;
              break;
            } else if (R[Ye] === null) {
              R[Ye] = me, Fe = Ye;
              break;
            }
          if (Fe === -1) break;
        }
        const ve = y[Fe];
        ve && ve.connect(me);
      }
    }
    const Y = new I(), ae = new I();
    function ne($, J, me) {
      Y.setFromMatrixPosition(J.matrixWorld), ae.setFromMatrixPosition(me.matrixWorld);
      const Fe = Y.distanceTo(ae), ve = J.projectionMatrix.elements, Ye = me.projectionMatrix.elements, Rt = ve[14] / (ve[10] - 1), We = ve[14] / (ve[10] + 1), Ze = (ve[9] + 1) / ve[5], nt = (ve[9] - 1) / ve[5], Ne = (ve[8] - 1) / ve[0], St = (Ye[8] + 1) / Ye[0], D = Rt * Ne, Mt = Rt * St, Ke = Fe / (-Ne + St), at = Ke * -Ne;
      if (J.matrixWorld.decompose($.position, $.quaternion, $.scale), $.translateX(at), $.translateZ(Ke), $.matrixWorld.compose($.position, $.quaternion, $.scale), $.matrixWorldInverse.copy($.matrixWorld).invert(), ve[10] === -1)
        $.projectionMatrix.copy(J.projectionMatrix), $.projectionMatrixInverse.copy(J.projectionMatrixInverse);
      else {
        const Se = Rt + Ke, w = We + Ke, v = D - at, F = Mt + (Fe - at), q = Ze * We / w * Se, j = nt * We / w * Se;
        $.projectionMatrix.makePerspective(v, F, q, j, Se, w), $.projectionMatrixInverse.copy($.projectionMatrix).invert();
      }
    }
    function ue($, J) {
      J === null ? $.matrixWorld.copy($.matrix) : $.matrixWorld.multiplyMatrices(J.matrixWorld, $.matrix), $.matrixWorldInverse.copy($.matrixWorld).invert();
    }
    this.updateCamera = function($) {
      if (i === null) return;
      let J = $.near, me = $.far;
      m.texture !== null && (m.depthNear > 0 && (J = m.depthNear), m.depthFar > 0 && (me = m.depthFar)), z.near = E.near = x.near = J, z.far = E.far = x.far = me, (N !== z.near || W !== z.far) && (i.updateRenderState({
        depthNear: z.near,
        depthFar: z.far
      }), N = z.near, W = z.far), z.layers.mask = $.layers.mask | 6, x.layers.mask = z.layers.mask & 3, E.layers.mask = z.layers.mask & 5;
      const Fe = $.parent, ve = z.cameras;
      ue(z, Fe);
      for (let Ye = 0; Ye < ve.length; Ye++)
        ue(ve[Ye], Fe);
      ve.length === 2 ? ne(z, x, E) : z.projectionMatrix.copy(x.projectionMatrix), Pe($, z, Fe);
    };
    function Pe($, J, me) {
      me === null ? $.matrix.copy(J.matrixWorld) : ($.matrix.copy(me.matrixWorld), $.matrix.invert(), $.matrix.multiply(J.matrixWorld)), $.matrix.decompose($.position, $.quaternion, $.scale), $.updateMatrixWorld(!0), $.projectionMatrix.copy(J.projectionMatrix), $.projectionMatrixInverse.copy(J.projectionMatrixInverse), $.isPerspectiveCamera && ($.fov = Ir * 2 * Math.atan(1 / $.projectionMatrix.elements[5]), $.zoom = 1);
    }
    this.getCamera = function() {
      return z;
    }, this.getFoveation = function() {
      if (!(f === null && d === null))
        return c;
    }, this.setFoveation = function($) {
      c = $, f !== null && (f.fixedFoveation = $), d !== null && d.fixedFoveation !== void 0 && (d.fixedFoveation = $);
    }, this.hasDepthSensing = function() {
      return m.texture !== null;
    }, this.getDepthSensingMesh = function() {
      return m.getMesh(z);
    }, this.getCameraTexture = function($) {
      return p[$];
    };
    let Le = null;
    function Ve($, J) {
      if (u = J.getViewerPose(l || a), g = J, u !== null) {
        const me = u.views;
        d !== null && (e.setRenderTargetFramebuffer(T, d.framebuffer), e.setRenderTarget(T));
        let Fe = !1;
        me.length !== z.cameras.length && (z.cameras.length = 0, Fe = !0);
        for (let We = 0; We < me.length; We++) {
          const Ze = me[We];
          let nt = null;
          if (d !== null)
            nt = d.getViewport(Ze);
          else {
            const St = h.getViewSubImage(f, Ze);
            nt = St.viewport, We === 0 && (e.setRenderTargetTextures(
              T,
              St.colorTexture,
              St.depthStencilTexture
            ), e.setRenderTarget(T));
          }
          let Ne = P[We];
          Ne === void 0 && (Ne = new qt(), Ne.layers.enable(We), Ne.viewport = new xt(), P[We] = Ne), Ne.matrix.fromArray(Ze.transform.matrix), Ne.matrix.decompose(Ne.position, Ne.quaternion, Ne.scale), Ne.projectionMatrix.fromArray(Ze.projectionMatrix), Ne.projectionMatrixInverse.copy(Ne.projectionMatrix).invert(), Ne.viewport.set(nt.x, nt.y, nt.width, nt.height), We === 0 && (z.matrix.copy(Ne.matrix), z.matrix.decompose(z.position, z.quaternion, z.scale)), Fe === !0 && z.cameras.push(Ne);
        }
        const ve = i.enabledFeatures;
        if (ve && ve.includes("depth-sensing") && i.depthUsage == "gpu-optimized" && _) {
          h = n.getBinding();
          const We = h.getDepthInformation(me[0]);
          We && We.isValid && We.texture && m.init(We, i.renderState);
        }
        if (ve && ve.includes("camera-access") && _) {
          e.state.unbindTexture(), h = n.getBinding();
          for (let We = 0; We < me.length; We++) {
            const Ze = me[We].camera;
            if (Ze) {
              let nt = p[Ze];
              nt || (nt = new xc(), p[Ze] = nt);
              const Ne = h.getCameraImage(Ze);
              nt.sourceTexture = Ne;
            }
          }
        }
      }
      for (let me = 0; me < y.length; me++) {
        const Fe = R[me], ve = y[me];
        Fe !== null && ve !== void 0 && ve.update(Fe, J, l || a);
      }
      Le && Le($, J), J.detectedPlanes && n.dispatchEvent({ type: "planesdetected", data: J }), g = null;
    }
    const He = new yc();
    He.setAnimationLoop(Ve), this.setAnimationLoop = function($) {
      Le = $;
    }, this.dispose = function() {
    };
  }
}
const mi = /* @__PURE__ */ new Vn(), D_ = /* @__PURE__ */ new ht();
function L_(r, e) {
  function t(m, p) {
    m.matrixAutoUpdate === !0 && m.updateMatrix(), p.value.copy(m.matrix);
  }
  function n(m, p) {
    p.color.getRGB(m.fogColor.value, hc(r)), p.isFog ? (m.fogNear.value = p.near, m.fogFar.value = p.far) : p.isFogExp2 && (m.fogDensity.value = p.density);
  }
  function i(m, p, S, b, T) {
    p.isMeshBasicMaterial || p.isMeshLambertMaterial ? s(m, p) : p.isMeshToonMaterial ? (s(m, p), h(m, p)) : p.isMeshPhongMaterial ? (s(m, p), u(m, p)) : p.isMeshStandardMaterial ? (s(m, p), f(m, p), p.isMeshPhysicalMaterial && d(m, p, T)) : p.isMeshMatcapMaterial ? (s(m, p), g(m, p)) : p.isMeshDepthMaterial ? s(m, p) : p.isMeshDistanceMaterial ? (s(m, p), _(m, p)) : p.isMeshNormalMaterial ? s(m, p) : p.isLineBasicMaterial ? (a(m, p), p.isLineDashedMaterial && o(m, p)) : p.isPointsMaterial ? c(m, p, S, b) : p.isSpriteMaterial ? l(m, p) : p.isShadowMaterial ? (m.color.value.copy(p.color), m.opacity.value = p.opacity) : p.isShaderMaterial && (p.uniformsNeedUpdate = !1);
  }
  function s(m, p) {
    m.opacity.value = p.opacity, p.color && m.diffuse.value.copy(p.color), p.emissive && m.emissive.value.copy(p.emissive).multiplyScalar(p.emissiveIntensity), p.map && (m.map.value = p.map, t(p.map, m.mapTransform)), p.alphaMap && (m.alphaMap.value = p.alphaMap, t(p.alphaMap, m.alphaMapTransform)), p.bumpMap && (m.bumpMap.value = p.bumpMap, t(p.bumpMap, m.bumpMapTransform), m.bumpScale.value = p.bumpScale, p.side === 1 && (m.bumpScale.value *= -1)), p.normalMap && (m.normalMap.value = p.normalMap, t(p.normalMap, m.normalMapTransform), m.normalScale.value.copy(p.normalScale), p.side === 1 && m.normalScale.value.negate()), p.displacementMap && (m.displacementMap.value = p.displacementMap, t(p.displacementMap, m.displacementMapTransform), m.displacementScale.value = p.displacementScale, m.displacementBias.value = p.displacementBias), p.emissiveMap && (m.emissiveMap.value = p.emissiveMap, t(p.emissiveMap, m.emissiveMapTransform)), p.specularMap && (m.specularMap.value = p.specularMap, t(p.specularMap, m.specularMapTransform)), p.alphaTest > 0 && (m.alphaTest.value = p.alphaTest);
    const S = e.get(p), b = S.envMap, T = S.envMapRotation;
    b && (m.envMap.value = b, mi.copy(T), mi.x *= -1, mi.y *= -1, mi.z *= -1, b.isCubeTexture && b.isRenderTargetTexture === !1 && (mi.y *= -1, mi.z *= -1), m.envMapRotation.value.setFromMatrix4(D_.makeRotationFromEuler(mi)), m.flipEnvMap.value = b.isCubeTexture && b.isRenderTargetTexture === !1 ? -1 : 1, m.reflectivity.value = p.reflectivity, m.ior.value = p.ior, m.refractionRatio.value = p.refractionRatio), p.lightMap && (m.lightMap.value = p.lightMap, m.lightMapIntensity.value = p.lightMapIntensity, t(p.lightMap, m.lightMapTransform)), p.aoMap && (m.aoMap.value = p.aoMap, m.aoMapIntensity.value = p.aoMapIntensity, t(p.aoMap, m.aoMapTransform));
  }
  function a(m, p) {
    m.diffuse.value.copy(p.color), m.opacity.value = p.opacity, p.map && (m.map.value = p.map, t(p.map, m.mapTransform));
  }
  function o(m, p) {
    m.dashSize.value = p.dashSize, m.totalSize.value = p.dashSize + p.gapSize, m.scale.value = p.scale;
  }
  function c(m, p, S, b) {
    m.diffuse.value.copy(p.color), m.opacity.value = p.opacity, m.size.value = p.size * S, m.scale.value = b * 0.5, p.map && (m.map.value = p.map, t(p.map, m.uvTransform)), p.alphaMap && (m.alphaMap.value = p.alphaMap, t(p.alphaMap, m.alphaMapTransform)), p.alphaTest > 0 && (m.alphaTest.value = p.alphaTest);
  }
  function l(m, p) {
    m.diffuse.value.copy(p.color), m.opacity.value = p.opacity, m.rotation.value = p.rotation, p.map && (m.map.value = p.map, t(p.map, m.mapTransform)), p.alphaMap && (m.alphaMap.value = p.alphaMap, t(p.alphaMap, m.alphaMapTransform)), p.alphaTest > 0 && (m.alphaTest.value = p.alphaTest);
  }
  function u(m, p) {
    m.specular.value.copy(p.specular), m.shininess.value = Math.max(p.shininess, 1e-4);
  }
  function h(m, p) {
    p.gradientMap && (m.gradientMap.value = p.gradientMap);
  }
  function f(m, p) {
    m.metalness.value = p.metalness, p.metalnessMap && (m.metalnessMap.value = p.metalnessMap, t(p.metalnessMap, m.metalnessMapTransform)), m.roughness.value = p.roughness, p.roughnessMap && (m.roughnessMap.value = p.roughnessMap, t(p.roughnessMap, m.roughnessMapTransform)), p.envMap && (m.envMapIntensity.value = p.envMapIntensity);
  }
  function d(m, p, S) {
    m.ior.value = p.ior, p.sheen > 0 && (m.sheenColor.value.copy(p.sheenColor).multiplyScalar(p.sheen), m.sheenRoughness.value = p.sheenRoughness, p.sheenColorMap && (m.sheenColorMap.value = p.sheenColorMap, t(p.sheenColorMap, m.sheenColorMapTransform)), p.sheenRoughnessMap && (m.sheenRoughnessMap.value = p.sheenRoughnessMap, t(p.sheenRoughnessMap, m.sheenRoughnessMapTransform))), p.clearcoat > 0 && (m.clearcoat.value = p.clearcoat, m.clearcoatRoughness.value = p.clearcoatRoughness, p.clearcoatMap && (m.clearcoatMap.value = p.clearcoatMap, t(p.clearcoatMap, m.clearcoatMapTransform)), p.clearcoatRoughnessMap && (m.clearcoatRoughnessMap.value = p.clearcoatRoughnessMap, t(p.clearcoatRoughnessMap, m.clearcoatRoughnessMapTransform)), p.clearcoatNormalMap && (m.clearcoatNormalMap.value = p.clearcoatNormalMap, t(p.clearcoatNormalMap, m.clearcoatNormalMapTransform), m.clearcoatNormalScale.value.copy(p.clearcoatNormalScale), p.side === 1 && m.clearcoatNormalScale.value.negate())), p.dispersion > 0 && (m.dispersion.value = p.dispersion), p.iridescence > 0 && (m.iridescence.value = p.iridescence, m.iridescenceIOR.value = p.iridescenceIOR, m.iridescenceThicknessMinimum.value = p.iridescenceThicknessRange[0], m.iridescenceThicknessMaximum.value = p.iridescenceThicknessRange[1], p.iridescenceMap && (m.iridescenceMap.value = p.iridescenceMap, t(p.iridescenceMap, m.iridescenceMapTransform)), p.iridescenceThicknessMap && (m.iridescenceThicknessMap.value = p.iridescenceThicknessMap, t(p.iridescenceThicknessMap, m.iridescenceThicknessMapTransform))), p.transmission > 0 && (m.transmission.value = p.transmission, m.transmissionSamplerMap.value = S.texture, m.transmissionSamplerSize.value.set(S.width, S.height), p.transmissionMap && (m.transmissionMap.value = p.transmissionMap, t(p.transmissionMap, m.transmissionMapTransform)), m.thickness.value = p.thickness, p.thicknessMap && (m.thicknessMap.value = p.thicknessMap, t(p.thicknessMap, m.thicknessMapTransform)), m.attenuationDistance.value = p.attenuationDistance, m.attenuationColor.value.copy(p.attenuationColor)), p.anisotropy > 0 && (m.anisotropyVector.value.set(p.anisotropy * Math.cos(p.anisotropyRotation), p.anisotropy * Math.sin(p.anisotropyRotation)), p.anisotropyMap && (m.anisotropyMap.value = p.anisotropyMap, t(p.anisotropyMap, m.anisotropyMapTransform))), m.specularIntensity.value = p.specularIntensity, m.specularColor.value.copy(p.specularColor), p.specularColorMap && (m.specularColorMap.value = p.specularColorMap, t(p.specularColorMap, m.specularColorMapTransform)), p.specularIntensityMap && (m.specularIntensityMap.value = p.specularIntensityMap, t(p.specularIntensityMap, m.specularIntensityMapTransform));
  }
  function g(m, p) {
    p.matcap && (m.matcap.value = p.matcap);
  }
  function _(m, p) {
    const S = e.get(p).light;
    m.referencePosition.value.setFromMatrixPosition(S.matrixWorld), m.nearDistance.value = S.shadow.camera.near, m.farDistance.value = S.shadow.camera.far;
  }
  return {
    refreshFogUniforms: n,
    refreshMaterialUniforms: i
  };
}
function F_(r, e, t, n) {
  let i = {}, s = {}, a = [];
  const o = r.getParameter(r.MAX_UNIFORM_BUFFER_BINDINGS);
  function c(S, b) {
    const T = b.program;
    n.uniformBlockBinding(S, T);
  }
  function l(S, b) {
    let T = i[S.id];
    T === void 0 && (g(S), T = u(S), i[S.id] = T, S.addEventListener("dispose", m));
    const y = b.program;
    n.updateUBOMapping(S, y);
    const R = e.render.frame;
    s[S.id] !== R && (f(S), s[S.id] = R);
  }
  function u(S) {
    const b = h();
    S.__bindingPointIndex = b;
    const T = r.createBuffer(), y = S.__size, R = S.usage;
    return r.bindBuffer(r.UNIFORM_BUFFER, T), r.bufferData(r.UNIFORM_BUFFER, y, R), r.bindBuffer(r.UNIFORM_BUFFER, null), r.bindBufferBase(r.UNIFORM_BUFFER, b, T), T;
  }
  function h() {
    for (let S = 0; S < o; S++)
      if (a.indexOf(S) === -1)
        return a.push(S), S;
    return Xe("WebGLRenderer: Maximum number of simultaneously usable uniforms groups reached."), 0;
  }
  function f(S) {
    const b = i[S.id], T = S.uniforms, y = S.__cache;
    r.bindBuffer(r.UNIFORM_BUFFER, b);
    for (let R = 0, A = T.length; R < A; R++) {
      const C = Array.isArray(T[R]) ? T[R] : [T[R]];
      for (let x = 0, E = C.length; x < E; x++) {
        const P = C[x];
        if (d(P, R, x, y) === !0) {
          const z = P.__offset, N = Array.isArray(P.value) ? P.value : [P.value];
          let W = 0;
          for (let H = 0; H < N.length; H++) {
            const k = N[H], O = _(k);
            typeof k == "number" || typeof k == "boolean" ? (P.__data[0] = k, r.bufferSubData(r.UNIFORM_BUFFER, z + W, P.__data)) : k.isMatrix3 ? (P.__data[0] = k.elements[0], P.__data[1] = k.elements[1], P.__data[2] = k.elements[2], P.__data[3] = 0, P.__data[4] = k.elements[3], P.__data[5] = k.elements[4], P.__data[6] = k.elements[5], P.__data[7] = 0, P.__data[8] = k.elements[6], P.__data[9] = k.elements[7], P.__data[10] = k.elements[8], P.__data[11] = 0) : (k.toArray(P.__data, W), W += O.storage / Float32Array.BYTES_PER_ELEMENT);
          }
          r.bufferSubData(r.UNIFORM_BUFFER, z, P.__data);
        }
      }
    }
    r.bindBuffer(r.UNIFORM_BUFFER, null);
  }
  function d(S, b, T, y) {
    const R = S.value, A = b + "_" + T;
    if (y[A] === void 0)
      return typeof R == "number" || typeof R == "boolean" ? y[A] = R : y[A] = R.clone(), !0;
    {
      const C = y[A];
      if (typeof R == "number" || typeof R == "boolean") {
        if (C !== R)
          return y[A] = R, !0;
      } else if (C.equals(R) === !1)
        return C.copy(R), !0;
    }
    return !1;
  }
  function g(S) {
    const b = S.uniforms;
    let T = 0;
    const y = 16;
    for (let A = 0, C = b.length; A < C; A++) {
      const x = Array.isArray(b[A]) ? b[A] : [b[A]];
      for (let E = 0, P = x.length; E < P; E++) {
        const z = x[E], N = Array.isArray(z.value) ? z.value : [z.value];
        for (let W = 0, H = N.length; W < H; W++) {
          const k = N[W], O = _(k), Y = T % y, ae = Y % O.boundary, ne = Y + ae;
          T += ae, ne !== 0 && y - ne < O.storage && (T += y - ne), z.__data = new Float32Array(O.storage / Float32Array.BYTES_PER_ELEMENT), z.__offset = T, T += O.storage;
        }
      }
    }
    const R = T % y;
    return R > 0 && (T += y - R), S.__size = T, S.__cache = {}, this;
  }
  function _(S) {
    const b = {
      boundary: 0,
      // bytes
      storage: 0
      // bytes
    };
    return typeof S == "number" || typeof S == "boolean" ? (b.boundary = 4, b.storage = 4) : S.isVector2 ? (b.boundary = 8, b.storage = 8) : S.isVector3 || S.isColor ? (b.boundary = 16, b.storage = 12) : S.isVector4 ? (b.boundary = 16, b.storage = 16) : S.isMatrix3 ? (b.boundary = 48, b.storage = 48) : S.isMatrix4 ? (b.boundary = 64, b.storage = 64) : S.isTexture ? Ce("WebGLRenderer: Texture samplers can not be part of an uniforms group.") : Ce("WebGLRenderer: Unsupported uniform value type.", S), b;
  }
  function m(S) {
    const b = S.target;
    b.removeEventListener("dispose", m);
    const T = a.indexOf(b.__bindingPointIndex);
    a.splice(T, 1), r.deleteBuffer(i[b.id]), delete i[b.id], delete s[b.id];
  }
  function p() {
    for (const S in i)
      r.deleteBuffer(i[S]);
    a = [], i = {}, s = {};
  }
  return {
    bind: c,
    update: l,
    dispose: p
  };
}
const U_ = new Uint16Array([
  12469,
  15057,
  12620,
  14925,
  13266,
  14620,
  13807,
  14376,
  14323,
  13990,
  14545,
  13625,
  14713,
  13328,
  14840,
  12882,
  14931,
  12528,
  14996,
  12233,
  15039,
  11829,
  15066,
  11525,
  15080,
  11295,
  15085,
  10976,
  15082,
  10705,
  15073,
  10495,
  13880,
  14564,
  13898,
  14542,
  13977,
  14430,
  14158,
  14124,
  14393,
  13732,
  14556,
  13410,
  14702,
  12996,
  14814,
  12596,
  14891,
  12291,
  14937,
  11834,
  14957,
  11489,
  14958,
  11194,
  14943,
  10803,
  14921,
  10506,
  14893,
  10278,
  14858,
  9960,
  14484,
  14039,
  14487,
  14025,
  14499,
  13941,
  14524,
  13740,
  14574,
  13468,
  14654,
  13106,
  14743,
  12678,
  14818,
  12344,
  14867,
  11893,
  14889,
  11509,
  14893,
  11180,
  14881,
  10751,
  14852,
  10428,
  14812,
  10128,
  14765,
  9754,
  14712,
  9466,
  14764,
  13480,
  14764,
  13475,
  14766,
  13440,
  14766,
  13347,
  14769,
  13070,
  14786,
  12713,
  14816,
  12387,
  14844,
  11957,
  14860,
  11549,
  14868,
  11215,
  14855,
  10751,
  14825,
  10403,
  14782,
  10044,
  14729,
  9651,
  14666,
  9352,
  14599,
  9029,
  14967,
  12835,
  14966,
  12831,
  14963,
  12804,
  14954,
  12723,
  14936,
  12564,
  14917,
  12347,
  14900,
  11958,
  14886,
  11569,
  14878,
  11247,
  14859,
  10765,
  14828,
  10401,
  14784,
  10011,
  14727,
  9600,
  14660,
  9289,
  14586,
  8893,
  14508,
  8533,
  15111,
  12234,
  15110,
  12234,
  15104,
  12216,
  15092,
  12156,
  15067,
  12010,
  15028,
  11776,
  14981,
  11500,
  14942,
  11205,
  14902,
  10752,
  14861,
  10393,
  14812,
  9991,
  14752,
  9570,
  14682,
  9252,
  14603,
  8808,
  14519,
  8445,
  14431,
  8145,
  15209,
  11449,
  15208,
  11451,
  15202,
  11451,
  15190,
  11438,
  15163,
  11384,
  15117,
  11274,
  15055,
  10979,
  14994,
  10648,
  14932,
  10343,
  14871,
  9936,
  14803,
  9532,
  14729,
  9218,
  14645,
  8742,
  14556,
  8381,
  14461,
  8020,
  14365,
  7603,
  15273,
  10603,
  15272,
  10607,
  15267,
  10619,
  15256,
  10631,
  15231,
  10614,
  15182,
  10535,
  15118,
  10389,
  15042,
  10167,
  14963,
  9787,
  14883,
  9447,
  14800,
  9115,
  14710,
  8665,
  14615,
  8318,
  14514,
  7911,
  14411,
  7507,
  14279,
  7198,
  15314,
  9675,
  15313,
  9683,
  15309,
  9712,
  15298,
  9759,
  15277,
  9797,
  15229,
  9773,
  15166,
  9668,
  15084,
  9487,
  14995,
  9274,
  14898,
  8910,
  14800,
  8539,
  14697,
  8234,
  14590,
  7790,
  14479,
  7409,
  14367,
  7067,
  14178,
  6621,
  15337,
  8619,
  15337,
  8631,
  15333,
  8677,
  15325,
  8769,
  15305,
  8871,
  15264,
  8940,
  15202,
  8909,
  15119,
  8775,
  15022,
  8565,
  14916,
  8328,
  14804,
  8009,
  14688,
  7614,
  14569,
  7287,
  14448,
  6888,
  14321,
  6483,
  14088,
  6171,
  15350,
  7402,
  15350,
  7419,
  15347,
  7480,
  15340,
  7613,
  15322,
  7804,
  15287,
  7973,
  15229,
  8057,
  15148,
  8012,
  15046,
  7846,
  14933,
  7611,
  14810,
  7357,
  14682,
  7069,
  14552,
  6656,
  14421,
  6316,
  14251,
  5948,
  14007,
  5528,
  15356,
  5942,
  15356,
  5977,
  15353,
  6119,
  15348,
  6294,
  15332,
  6551,
  15302,
  6824,
  15249,
  7044,
  15171,
  7122,
  15070,
  7050,
  14949,
  6861,
  14818,
  6611,
  14679,
  6349,
  14538,
  6067,
  14398,
  5651,
  14189,
  5311,
  13935,
  4958,
  15359,
  4123,
  15359,
  4153,
  15356,
  4296,
  15353,
  4646,
  15338,
  5160,
  15311,
  5508,
  15263,
  5829,
  15188,
  6042,
  15088,
  6094,
  14966,
  6001,
  14826,
  5796,
  14678,
  5543,
  14527,
  5287,
  14377,
  4985,
  14133,
  4586,
  13869,
  4257,
  15360,
  1563,
  15360,
  1642,
  15358,
  2076,
  15354,
  2636,
  15341,
  3350,
  15317,
  4019,
  15273,
  4429,
  15203,
  4732,
  15105,
  4911,
  14981,
  4932,
  14836,
  4818,
  14679,
  4621,
  14517,
  4386,
  14359,
  4156,
  14083,
  3795,
  13808,
  3437,
  15360,
  122,
  15360,
  137,
  15358,
  285,
  15355,
  636,
  15344,
  1274,
  15322,
  2177,
  15281,
  2765,
  15215,
  3223,
  15120,
  3451,
  14995,
  3569,
  14846,
  3567,
  14681,
  3466,
  14511,
  3305,
  14344,
  3121,
  14037,
  2800,
  13753,
  2467,
  15360,
  0,
  15360,
  1,
  15359,
  21,
  15355,
  89,
  15346,
  253,
  15325,
  479,
  15287,
  796,
  15225,
  1148,
  15133,
  1492,
  15008,
  1749,
  14856,
  1882,
  14685,
  1886,
  14506,
  1783,
  14324,
  1608,
  13996,
  1398,
  13702,
  1183
]);
let Tn = null;
function I_() {
  return Tn === null && (Tn = new mc(U_, 16, 16, 1030, 1016), Tn.name = "DFG_LUT", Tn.minFilter = 1006, Tn.magFilter = 1006, Tn.wrapS = 1001, Tn.wrapT = 1001, Tn.generateMipmaps = !1, Tn.needsUpdate = !0), Tn;
}
class qs {
  /**
   * Constructs a new WebGL renderer.
   *
   * @param {WebGLRenderer~Options} [parameters] - The configuration parameter.
   */
  constructor(e = {}) {
    const {
      canvas: t = Uu(),
      context: n = null,
      depth: i = !0,
      stencil: s = !1,
      alpha: a = !1,
      antialias: o = !1,
      premultipliedAlpha: c = !0,
      preserveDrawingBuffer: l = !1,
      powerPreference: u = "default",
      failIfMajorPerformanceCaveat: h = !1,
      reversedDepthBuffer: f = !1,
      outputBufferType: d = 1009
    } = e;
    this.isWebGLRenderer = !0;
    let g;
    if (n !== null) {
      if (typeof WebGLRenderingContext < "u" && n instanceof WebGLRenderingContext)
        throw new Error("THREE.WebGLRenderer: WebGL 1 is not supported since r163.");
      g = n.getContextAttributes().alpha;
    } else
      g = a;
    const _ = d, m = /* @__PURE__ */ new Set([
      1033,
      1031,
      1029
    ]), p = /* @__PURE__ */ new Set([
      1009,
      1014,
      1012,
      1020,
      1017,
      1018
    ]), S = new Uint32Array(4), b = new Int32Array(4);
    let T = null, y = null;
    const R = [], A = [];
    let C = null;
    this.domElement = t, this.debug = {
      /**
       * Enables error checking and reporting when shader programs are being compiled.
       * @type {boolean}
       */
      checkShaderErrors: !0,
      /**
       * Callback for custom error reporting.
       * @type {?Function}
       */
      onShaderError: null
    }, this.autoClear = !0, this.autoClearColor = !0, this.autoClearDepth = !0, this.autoClearStencil = !0, this.sortObjects = !0, this.clippingPlanes = [], this.localClippingEnabled = !1, this.toneMapping = 0, this.toneMappingExposure = 1, this.transmissionResolutionScale = 1;
    const x = this;
    let E = !1;
    this._outputColorSpace = Tt;
    let P = 0, z = 0, N = null, W = -1, H = null;
    const k = new xt(), O = new xt();
    let Y = null;
    const ae = new Ge(0);
    let ne = 0, ue = t.width, Pe = t.height, Le = 1, Ve = null, He = null;
    const $ = new xt(0, 0, ue, Pe), J = new xt(0, 0, ue, Pe);
    let me = !1;
    const Fe = new _c();
    let ve = !1, Ye = !1;
    const Rt = new ht(), We = new I(), Ze = new xt(), nt = { background: null, fog: null, environment: null, overrideMaterial: null, isScene: !0 };
    let Ne = !1;
    function St() {
      return N === null ? Le : 1;
    }
    let D = n;
    function Mt(M, U) {
      return t.getContext(M, U);
    }
    try {
      const M = {
        alpha: !0,
        depth: i,
        stencil: s,
        antialias: o,
        premultipliedAlpha: c,
        preserveDrawingBuffer: l,
        powerPreference: u,
        failIfMajorPerformanceCaveat: h
      };
      if ("setAttribute" in t && t.setAttribute("data-engine", "three.js r182"), t.addEventListener("webglcontextlost", De, !1), t.addEventListener("webglcontextrestored", ot, !1), t.addEventListener("webglcontextcreationerror", je, !1), D === null) {
        const U = "webgl2";
        if (D = Mt(U, M), D === null)
          throw Mt(U) ? new Error("Error creating WebGL context with your selected attributes.") : new Error("Error creating WebGL context.");
      }
    } catch (M) {
      throw Xe("WebGLRenderer: " + M.message), M;
    }
    let Ke, at, Se, w, v, F, q, j, X, ye, re, xe, Re, ee, oe, ge, Me, se, Oe, L, fe, te, de, Q;
    function Z() {
      Ke = new Ip(D), Ke.init(), te = new A_(D, Ke), at = new Ap(D, Ke, e, te), Se = new T_(D, Ke), at.reversedDepthBuffer && f && Se.buffers.depth.setReversed(!0), w = new Bp(D), v = new c_(), F = new b_(D, Ke, Se, v, at, te, w), q = new Rp(x), j = new Up(x), X = new kh(D), de = new Tp(D, X), ye = new Np(D, X, w, de), re = new Gp(D, ye, X, w), Oe = new zp(D, at, F), ge = new wp(v), xe = new l_(x, q, j, Ke, at, de, ge), Re = new L_(x, v), ee = new h_(), oe = new g_(Ke), se = new Ep(x, q, j, Se, re, g, c), Me = new y_(x, re, at), Q = new F_(D, w, at, Se), L = new bp(D, Ke, w), fe = new Op(D, Ke, w), w.programs = xe.programs, x.capabilities = at, x.extensions = Ke, x.properties = v, x.renderLists = ee, x.shadowMap = Me, x.state = Se, x.info = w;
    }
    Z(), _ !== 1009 && (C = new Vp(_, t.width, t.height, i, s));
    const ie = new P_(x, D);
    this.xr = ie, this.getContext = function() {
      return D;
    }, this.getContextAttributes = function() {
      return D.getContextAttributes();
    }, this.forceContextLoss = function() {
      const M = Ke.get("WEBGL_lose_context");
      M && M.loseContext();
    }, this.forceContextRestore = function() {
      const M = Ke.get("WEBGL_lose_context");
      M && M.restoreContext();
    }, this.getPixelRatio = function() {
      return Le;
    }, this.setPixelRatio = function(M) {
      M !== void 0 && (Le = M, this.setSize(ue, Pe, !1));
    }, this.getSize = function(M) {
      return M.set(ue, Pe);
    }, this.setSize = function(M, U, V = !0) {
      if (ie.isPresenting) {
        Ce("WebGLRenderer: Can't change size while VR device is presenting.");
        return;
      }
      ue = M, Pe = U, t.width = Math.floor(M * Le), t.height = Math.floor(U * Le), V === !0 && (t.style.width = M + "px", t.style.height = U + "px"), C !== null && C.setSize(t.width, t.height), this.setViewport(0, 0, M, U);
    }, this.getDrawingBufferSize = function(M) {
      return M.set(ue * Le, Pe * Le).floor();
    }, this.setDrawingBufferSize = function(M, U, V) {
      ue = M, Pe = U, Le = V, t.width = Math.floor(M * V), t.height = Math.floor(U * V), this.setViewport(0, 0, M, U);
    }, this.setEffects = function(M) {
      if (_ === 1009) {
        console.error("THREE.WebGLRenderer: setEffects() requires outputBufferType set to HalfFloatType or FloatType.");
        return;
      }
      if (M) {
        for (let U = 0; U < M.length; U++)
          if (M[U].isOutputPass === !0) {
            console.warn("THREE.WebGLRenderer: OutputPass is not needed in setEffects(). Tone mapping and color space conversion are applied automatically.");
            break;
          }
      }
      C.setEffects(M || []);
    }, this.getCurrentViewport = function(M) {
      return M.copy(k);
    }, this.getViewport = function(M) {
      return M.copy($);
    }, this.setViewport = function(M, U, V, G) {
      M.isVector4 ? $.set(M.x, M.y, M.z, M.w) : $.set(M, U, V, G), Se.viewport(k.copy($).multiplyScalar(Le).round());
    }, this.getScissor = function(M) {
      return M.copy(J);
    }, this.setScissor = function(M, U, V, G) {
      M.isVector4 ? J.set(M.x, M.y, M.z, M.w) : J.set(M, U, V, G), Se.scissor(O.copy(J).multiplyScalar(Le).round());
    }, this.getScissorTest = function() {
      return me;
    }, this.setScissorTest = function(M) {
      Se.setScissorTest(me = M);
    }, this.setOpaqueSort = function(M) {
      Ve = M;
    }, this.setTransparentSort = function(M) {
      He = M;
    }, this.getClearColor = function(M) {
      return M.copy(se.getClearColor());
    }, this.setClearColor = function() {
      se.setClearColor(...arguments);
    }, this.getClearAlpha = function() {
      return se.getClearAlpha();
    }, this.setClearAlpha = function() {
      se.setClearAlpha(...arguments);
    }, this.clear = function(M = !0, U = !0, V = !0) {
      let G = 0;
      if (M) {
        let B = !1;
        if (N !== null) {
          const le = N.texture.format;
          B = m.has(le);
        }
        if (B) {
          const le = N.texture.type, pe = p.has(le), he = se.getClearColor(), _e = se.getClearAlpha(), Ee = he.r, we = he.g, Te = he.b;
          pe ? (S[0] = Ee, S[1] = we, S[2] = Te, S[3] = _e, D.clearBufferuiv(D.COLOR, 0, S)) : (b[0] = Ee, b[1] = we, b[2] = Te, b[3] = _e, D.clearBufferiv(D.COLOR, 0, b));
        } else
          G |= D.COLOR_BUFFER_BIT;
      }
      U && (G |= D.DEPTH_BUFFER_BIT), V && (G |= D.STENCIL_BUFFER_BIT, this.state.buffers.stencil.setMask(4294967295)), D.clear(G);
    }, this.clearColor = function() {
      this.clear(!0, !1, !1);
    }, this.clearDepth = function() {
      this.clear(!1, !0, !1);
    }, this.clearStencil = function() {
      this.clear(!1, !1, !0);
    }, this.dispose = function() {
      t.removeEventListener("webglcontextlost", De, !1), t.removeEventListener("webglcontextrestored", ot, !1), t.removeEventListener("webglcontextcreationerror", je, !1), se.dispose(), ee.dispose(), oe.dispose(), v.dispose(), q.dispose(), j.dispose(), re.dispose(), de.dispose(), Q.dispose(), xe.dispose(), ie.dispose(), ie.removeEventListener("sessionstart", Fo), ie.removeEventListener("sessionend", Uo), li.stop();
    };
    function De(M) {
      M.preventDefault(), Ds("WebGLRenderer: Context Lost."), E = !0;
    }
    function ot() {
      Ds("WebGLRenderer: Context Restored."), E = !1;
      const M = w.autoReset, U = Me.enabled, V = Me.autoUpdate, G = Me.needsUpdate, B = Me.type;
      Z(), w.autoReset = M, Me.enabled = U, Me.autoUpdate = V, Me.needsUpdate = G, Me.type = B;
    }
    function je(M) {
      Xe("WebGLRenderer: A WebGL context could not be created. Reason: ", M.statusMessage);
    }
    function En(M) {
      const U = M.target;
      U.removeEventListener("dispose", En), Ln(U);
    }
    function Ln(M) {
      Tu(M), v.remove(M);
    }
    function Tu(M) {
      const U = v.get(M).programs;
      U !== void 0 && (U.forEach(function(V) {
        xe.releaseProgram(V);
      }), M.isShaderMaterial && xe.releaseShaderCache(M));
    }
    this.renderBufferDirect = function(M, U, V, G, B, le) {
      U === null && (U = nt);
      const pe = B.isMesh && B.matrixWorld.determinant() < 0, he = Au(M, U, V, G, B);
      Se.setMaterial(G, pe);
      let _e = V.index, Ee = 1;
      if (G.wireframe === !0) {
        if (_e = ye.getWireframeAttribute(V), _e === void 0) return;
        Ee = 2;
      }
      const we = V.drawRange, Te = V.attributes.position;
      let Be = we.start * Ee, tt = (we.start + we.count) * Ee;
      le !== null && (Be = Math.max(Be, le.start * Ee), tt = Math.min(tt, (le.start + le.count) * Ee)), _e !== null ? (Be = Math.max(Be, 0), tt = Math.min(tt, _e.count)) : Te != null && (Be = Math.max(Be, 0), tt = Math.min(tt, Te.count));
      const mt = tt - Be;
      if (mt < 0 || mt === 1 / 0) return;
      de.setup(B, G, he, V, _e);
      let _t, it = L;
      if (_e !== null && (_t = X.get(_e), it = fe, it.setIndex(_t)), B.isMesh)
        G.wireframe === !0 ? (Se.setLineWidth(G.wireframeLinewidth * St()), it.setMode(D.LINES)) : it.setMode(D.TRIANGLES);
      else if (B.isLine) {
        let be = G.linewidth;
        be === void 0 && (be = 1), Se.setLineWidth(be * St()), B.isLineSegments ? it.setMode(D.LINES) : B.isLineLoop ? it.setMode(D.LINE_LOOP) : it.setMode(D.LINE_STRIP);
      } else B.isPoints ? it.setMode(D.POINTS) : B.isSprite && it.setMode(D.TRIANGLES);
      if (B.isBatchedMesh)
        if (B._multiDrawInstances !== null)
          Ur("WebGLRenderer: renderMultiDrawInstances has been deprecated and will be removed in r184. Append to renderMultiDraw arguments and use indirection."), it.renderMultiDrawInstances(B._multiDrawStarts, B._multiDrawCounts, B._multiDrawCount, B._multiDrawInstances);
        else if (Ke.get("WEBGL_multi_draw"))
          it.renderMultiDraw(B._multiDrawStarts, B._multiDrawCounts, B._multiDrawCount);
        else {
          const be = B._multiDrawStarts, Je = B._multiDrawCounts, $e = B._multiDrawCount, en = _e ? X.get(_e).bytesPerElement : 1, Ri = v.get(G).currentProgram.getUniforms();
          for (let tn = 0; tn < $e; tn++)
            Ri.setValue(D, "_gl_DrawID", tn), it.render(be[tn] / en, Je[tn]);
        }
      else if (B.isInstancedMesh)
        it.renderInstances(Be, mt, B.count);
      else if (V.isInstancedBufferGeometry) {
        const be = V._maxInstanceCount !== void 0 ? V._maxInstanceCount : 1 / 0, Je = Math.min(V.instanceCount, be);
        it.renderInstances(Be, mt, Je);
      } else
        it.render(Be, mt);
    };
    function Lo(M, U, V) {
      M.transparent === !0 && M.side === 2 && M.forceSinglePass === !1 ? (M.side = 1, M.needsUpdate = !0, jr(M, U, V), M.side = 0, M.needsUpdate = !0, jr(M, U, V), M.side = 2) : jr(M, U, V);
    }
    this.compile = function(M, U, V = null) {
      V === null && (V = M), y = oe.get(V), y.init(U), A.push(y), V.traverseVisible(function(B) {
        B.isLight && B.layers.test(U.layers) && (y.pushLight(B), B.castShadow && y.pushShadow(B));
      }), M !== V && M.traverseVisible(function(B) {
        B.isLight && B.layers.test(U.layers) && (y.pushLight(B), B.castShadow && y.pushShadow(B));
      }), y.setupLights();
      const G = /* @__PURE__ */ new Set();
      return M.traverse(function(B) {
        if (!(B.isMesh || B.isPoints || B.isLine || B.isSprite))
          return;
        const le = B.material;
        if (le)
          if (Array.isArray(le))
            for (let pe = 0; pe < le.length; pe++) {
              const he = le[pe];
              Lo(he, V, B), G.add(he);
            }
          else
            Lo(le, V, B), G.add(le);
      }), y = A.pop(), G;
    }, this.compileAsync = function(M, U, V = null) {
      const G = this.compile(M, U, V);
      return new Promise((B) => {
        function le() {
          if (G.forEach(function(pe) {
            v.get(pe).currentProgram.isReady() && G.delete(pe);
          }), G.size === 0) {
            B(M);
            return;
          }
          setTimeout(le, 10);
        }
        Ke.get("KHR_parallel_shader_compile") !== null ? le() : setTimeout(le, 10);
      });
    };
    let Qs = null;
    function bu(M) {
      Qs && Qs(M);
    }
    function Fo() {
      li.stop();
    }
    function Uo() {
      li.start();
    }
    const li = new yc();
    li.setAnimationLoop(bu), typeof self < "u" && li.setContext(self), this.setAnimationLoop = function(M) {
      Qs = M, ie.setAnimationLoop(M), M === null ? li.stop() : li.start();
    }, ie.addEventListener("sessionstart", Fo), ie.addEventListener("sessionend", Uo), this.render = function(M, U) {
      if (U !== void 0 && U.isCamera !== !0) {
        Xe("WebGLRenderer.render: camera is not an instance of THREE.Camera.");
        return;
      }
      if (E === !0) return;
      const V = ie.enabled === !0 && ie.isPresenting === !0, G = C !== null && (N === null || V) && C.begin(x, N);
      if (M.matrixWorldAutoUpdate === !0 && M.updateMatrixWorld(), U.parent === null && U.matrixWorldAutoUpdate === !0 && U.updateMatrixWorld(), ie.enabled === !0 && ie.isPresenting === !0 && (C === null || C.isCompositing() === !1) && (ie.cameraAutoUpdate === !0 && ie.updateCamera(U), U = ie.getCamera()), M.isScene === !0 && M.onBeforeRender(x, M, U, N), y = oe.get(M, A.length), y.init(U), A.push(y), Rt.multiplyMatrices(U.projectionMatrix, U.matrixWorldInverse), Fe.setFromProjectionMatrix(Rt, 2e3, U.reversedDepth), Ye = this.localClippingEnabled, ve = ge.init(this.clippingPlanes, Ye), T = ee.get(M, R.length), T.init(), R.push(T), ie.enabled === !0 && ie.isPresenting === !0) {
        const pe = x.xr.getDepthSensingMesh();
        pe !== null && ea(pe, U, -1 / 0, x.sortObjects);
      }
      ea(M, U, 0, x.sortObjects), T.finish(), x.sortObjects === !0 && T.sort(Ve, He), Ne = ie.enabled === !1 || ie.isPresenting === !1 || ie.hasDepthSensing() === !1, Ne && se.addToRenderList(T, M), this.info.render.frame++, ve === !0 && ge.beginShadows();
      const B = y.state.shadowsArray;
      if (Me.render(B, M, U), ve === !0 && ge.endShadows(), this.info.autoReset === !0 && this.info.reset(), (G && C.hasRenderPass()) === !1) {
        const pe = T.opaque, he = T.transmissive;
        if (y.setupLights(), U.isArrayCamera) {
          const _e = U.cameras;
          if (he.length > 0)
            for (let Ee = 0, we = _e.length; Ee < we; Ee++) {
              const Te = _e[Ee];
              No(pe, he, M, Te);
            }
          Ne && se.render(M);
          for (let Ee = 0, we = _e.length; Ee < we; Ee++) {
            const Te = _e[Ee];
            Io(T, M, Te, Te.viewport);
          }
        } else
          he.length > 0 && No(pe, he, M, U), Ne && se.render(M), Io(T, M, U);
      }
      N !== null && z === 0 && (F.updateMultisampleRenderTarget(N), F.updateRenderTargetMipmap(N)), G && C.end(x), M.isScene === !0 && M.onAfterRender(x, M, U), de.resetDefaultState(), W = -1, H = null, A.pop(), A.length > 0 ? (y = A[A.length - 1], ve === !0 && ge.setGlobalState(x.clippingPlanes, y.state.camera)) : y = null, R.pop(), R.length > 0 ? T = R[R.length - 1] : T = null;
    };
    function ea(M, U, V, G) {
      if (M.visible === !1) return;
      if (M.layers.test(U.layers)) {
        if (M.isGroup)
          V = M.renderOrder;
        else if (M.isLOD)
          M.autoUpdate === !0 && M.update(U);
        else if (M.isLight)
          y.pushLight(M), M.castShadow && y.pushShadow(M);
        else if (M.isSprite) {
          if (!M.frustumCulled || Fe.intersectsSprite(M)) {
            G && Ze.setFromMatrixPosition(M.matrixWorld).applyMatrix4(Rt);
            const pe = re.update(M), he = M.material;
            he.visible && T.push(M, pe, he, V, Ze.z, null);
          }
        } else if ((M.isMesh || M.isLine || M.isPoints) && (!M.frustumCulled || Fe.intersectsObject(M))) {
          const pe = re.update(M), he = M.material;
          if (G && (M.boundingSphere !== void 0 ? (M.boundingSphere === null && M.computeBoundingSphere(), Ze.copy(M.boundingSphere.center)) : (pe.boundingSphere === null && pe.computeBoundingSphere(), Ze.copy(pe.boundingSphere.center)), Ze.applyMatrix4(M.matrixWorld).applyMatrix4(Rt)), Array.isArray(he)) {
            const _e = pe.groups;
            for (let Ee = 0, we = _e.length; Ee < we; Ee++) {
              const Te = _e[Ee], Be = he[Te.materialIndex];
              Be && Be.visible && T.push(M, pe, Be, V, Ze.z, Te);
            }
          } else he.visible && T.push(M, pe, he, V, Ze.z, null);
        }
      }
      const le = M.children;
      for (let pe = 0, he = le.length; pe < he; pe++)
        ea(le[pe], U, V, G);
    }
    function Io(M, U, V, G) {
      const { opaque: B, transmissive: le, transparent: pe } = M;
      y.setupLightsView(V), ve === !0 && ge.setGlobalState(x.clippingPlanes, V), G && Se.viewport(k.copy(G)), B.length > 0 && Zr(B, U, V), le.length > 0 && Zr(le, U, V), pe.length > 0 && Zr(pe, U, V), Se.buffers.depth.setTest(!0), Se.buffers.depth.setMask(!0), Se.buffers.color.setMask(!0), Se.setPolygonOffset(!1);
    }
    function No(M, U, V, G) {
      if ((V.isScene === !0 ? V.overrideMaterial : null) !== null)
        return;
      if (y.state.transmissionRenderTarget[G.id] === void 0) {
        const Be = Ke.has("EXT_color_buffer_half_float") || Ke.has("EXT_color_buffer_float");
        y.state.transmissionRenderTarget[G.id] = new Cn(1, 1, {
          generateMipmaps: !0,
          type: Be ? 1016 : 1009,
          minFilter: 1008,
          samples: at.samples,
          stencilBuffer: s,
          resolveDepthBuffer: !1,
          resolveStencilBuffer: !1,
          colorSpace: qe.workingColorSpace
        });
      }
      const le = y.state.transmissionRenderTarget[G.id], pe = G.viewport || k;
      le.setSize(pe.z * x.transmissionResolutionScale, pe.w * x.transmissionResolutionScale);
      const he = x.getRenderTarget(), _e = x.getActiveCubeFace(), Ee = x.getActiveMipmapLevel();
      x.setRenderTarget(le), x.getClearColor(ae), ne = x.getClearAlpha(), ne < 1 && x.setClearColor(16777215, 0.5), x.clear(), Ne && se.render(V);
      const we = x.toneMapping;
      x.toneMapping = 0;
      const Te = G.viewport;
      if (G.viewport !== void 0 && (G.viewport = void 0), y.setupLightsView(G), ve === !0 && ge.setGlobalState(x.clippingPlanes, G), Zr(M, V, G), F.updateMultisampleRenderTarget(le), F.updateRenderTargetMipmap(le), Ke.has("WEBGL_multisampled_render_to_texture") === !1) {
        let Be = !1;
        for (let tt = 0, mt = U.length; tt < mt; tt++) {
          const _t = U[tt], { object: it, geometry: be, material: Je, group: $e } = _t;
          if (Je.side === 2 && it.layers.test(G.layers)) {
            const en = Je.side;
            Je.side = 1, Je.needsUpdate = !0, Oo(it, V, G, be, Je, $e), Je.side = en, Je.needsUpdate = !0, Be = !0;
          }
        }
        Be === !0 && (F.updateMultisampleRenderTarget(le), F.updateRenderTargetMipmap(le));
      }
      x.setRenderTarget(he, _e, Ee), x.setClearColor(ae, ne), Te !== void 0 && (G.viewport = Te), x.toneMapping = we;
    }
    function Zr(M, U, V) {
      const G = U.isScene === !0 ? U.overrideMaterial : null;
      for (let B = 0, le = M.length; B < le; B++) {
        const pe = M[B], { object: he, geometry: _e, group: Ee } = pe;
        let we = pe.material;
        we.allowOverride === !0 && G !== null && (we = G), he.layers.test(V.layers) && Oo(he, U, V, _e, we, Ee);
      }
    }
    function Oo(M, U, V, G, B, le) {
      M.onBeforeRender(x, U, V, G, B, le), M.modelViewMatrix.multiplyMatrices(V.matrixWorldInverse, M.matrixWorld), M.normalMatrix.getNormalMatrix(M.modelViewMatrix), B.onBeforeRender(x, U, V, G, M, le), B.transparent === !0 && B.side === 2 && B.forceSinglePass === !1 ? (B.side = 1, B.needsUpdate = !0, x.renderBufferDirect(V, U, G, B, M, le), B.side = 0, B.needsUpdate = !0, x.renderBufferDirect(V, U, G, B, M, le), B.side = 2) : x.renderBufferDirect(V, U, G, B, M, le), M.onAfterRender(x, U, V, G, B, le);
    }
    function jr(M, U, V) {
      U.isScene !== !0 && (U = nt);
      const G = v.get(M), B = y.state.lights, le = y.state.shadowsArray, pe = B.state.version, he = xe.getParameters(M, B.state, le, U, V), _e = xe.getProgramCacheKey(he);
      let Ee = G.programs;
      G.environment = M.isMeshStandardMaterial ? U.environment : null, G.fog = U.fog, G.envMap = (M.isMeshStandardMaterial ? j : q).get(M.envMap || G.environment), G.envMapRotation = G.environment !== null && M.envMap === null ? U.environmentRotation : M.envMapRotation, Ee === void 0 && (M.addEventListener("dispose", En), Ee = /* @__PURE__ */ new Map(), G.programs = Ee);
      let we = Ee.get(_e);
      if (we !== void 0) {
        if (G.currentProgram === we && G.lightsStateVersion === pe)
          return zo(M, he), we;
      } else
        he.uniforms = xe.getUniforms(M), M.onBeforeCompile(he, x), we = xe.acquireProgram(he, _e), Ee.set(_e, we), G.uniforms = he.uniforms;
      const Te = G.uniforms;
      return (!M.isShaderMaterial && !M.isRawShaderMaterial || M.clipping === !0) && (Te.clippingPlanes = ge.uniform), zo(M, he), G.needsLights = Ru(M), G.lightsStateVersion = pe, G.needsLights && (Te.ambientLightColor.value = B.state.ambient, Te.lightProbe.value = B.state.probe, Te.directionalLights.value = B.state.directional, Te.directionalLightShadows.value = B.state.directionalShadow, Te.spotLights.value = B.state.spot, Te.spotLightShadows.value = B.state.spotShadow, Te.rectAreaLights.value = B.state.rectArea, Te.ltc_1.value = B.state.rectAreaLTC1, Te.ltc_2.value = B.state.rectAreaLTC2, Te.pointLights.value = B.state.point, Te.pointLightShadows.value = B.state.pointShadow, Te.hemisphereLights.value = B.state.hemi, Te.directionalShadowMap.value = B.state.directionalShadowMap, Te.directionalShadowMatrix.value = B.state.directionalShadowMatrix, Te.spotShadowMap.value = B.state.spotShadowMap, Te.spotLightMatrix.value = B.state.spotLightMatrix, Te.spotLightMap.value = B.state.spotLightMap, Te.pointShadowMap.value = B.state.pointShadowMap, Te.pointShadowMatrix.value = B.state.pointShadowMatrix), G.currentProgram = we, G.uniformsList = null, we;
    }
    function Bo(M) {
      if (M.uniformsList === null) {
        const U = M.currentProgram.getUniforms();
        M.uniformsList = As.seqWithValue(U.seq, M.uniforms);
      }
      return M.uniformsList;
    }
    function zo(M, U) {
      const V = v.get(M);
      V.outputColorSpace = U.outputColorSpace, V.batching = U.batching, V.batchingColor = U.batchingColor, V.instancing = U.instancing, V.instancingColor = U.instancingColor, V.instancingMorph = U.instancingMorph, V.skinning = U.skinning, V.morphTargets = U.morphTargets, V.morphNormals = U.morphNormals, V.morphColors = U.morphColors, V.morphTargetsCount = U.morphTargetsCount, V.numClippingPlanes = U.numClippingPlanes, V.numIntersection = U.numClipIntersection, V.vertexAlphas = U.vertexAlphas, V.vertexTangents = U.vertexTangents, V.toneMapping = U.toneMapping;
    }
    function Au(M, U, V, G, B) {
      U.isScene !== !0 && (U = nt), F.resetTextureUnits();
      const le = U.fog, pe = G.isMeshStandardMaterial ? U.environment : null, he = N === null ? x.outputColorSpace : N.isXRRenderTarget === !0 ? N.texture.colorSpace : tr, _e = (G.isMeshStandardMaterial ? j : q).get(G.envMap || pe), Ee = G.vertexColors === !0 && !!V.attributes.color && V.attributes.color.itemSize === 4, we = !!V.attributes.tangent && (!!G.normalMap || G.anisotropy > 0), Te = !!V.morphAttributes.position, Be = !!V.morphAttributes.normal, tt = !!V.morphAttributes.color;
      let mt = 0;
      G.toneMapped && (N === null || N.isXRRenderTarget === !0) && (mt = x.toneMapping);
      const _t = V.morphAttributes.position || V.morphAttributes.normal || V.morphAttributes.color, it = _t !== void 0 ? _t.length : 0, be = v.get(G), Je = y.state.lights;
      if (ve === !0 && (Ye === !0 || M !== H)) {
        const Gt = M === H && G.id === W;
        ge.setState(G, M, Gt);
      }
      let $e = !1;
      G.version === be.__version ? (be.needsLights && be.lightsStateVersion !== Je.state.version || be.outputColorSpace !== he || B.isBatchedMesh && be.batching === !1 || !B.isBatchedMesh && be.batching === !0 || B.isBatchedMesh && be.batchingColor === !0 && B.colorTexture === null || B.isBatchedMesh && be.batchingColor === !1 && B.colorTexture !== null || B.isInstancedMesh && be.instancing === !1 || !B.isInstancedMesh && be.instancing === !0 || B.isSkinnedMesh && be.skinning === !1 || !B.isSkinnedMesh && be.skinning === !0 || B.isInstancedMesh && be.instancingColor === !0 && B.instanceColor === null || B.isInstancedMesh && be.instancingColor === !1 && B.instanceColor !== null || B.isInstancedMesh && be.instancingMorph === !0 && B.morphTexture === null || B.isInstancedMesh && be.instancingMorph === !1 && B.morphTexture !== null || be.envMap !== _e || G.fog === !0 && be.fog !== le || be.numClippingPlanes !== void 0 && (be.numClippingPlanes !== ge.numPlanes || be.numIntersection !== ge.numIntersection) || be.vertexAlphas !== Ee || be.vertexTangents !== we || be.morphTargets !== Te || be.morphNormals !== Be || be.morphColors !== tt || be.toneMapping !== mt || be.morphTargetsCount !== it) && ($e = !0) : ($e = !0, be.__version = G.version);
      let en = be.currentProgram;
      $e === !0 && (en = jr(G, U, B));
      let Ri = !1, tn = !1, ur = !1;
      const lt = en.getUniforms(), Wt = be.uniforms;
      if (Se.useProgram(en.program) && (Ri = !0, tn = !0, ur = !0), G.id !== W && (W = G.id, tn = !0), Ri || H !== M) {
        Se.buffers.depth.getReversed() && M.reversedDepth !== !0 && (M._reversedDepth = !0, M.updateProjectionMatrix()), lt.setValue(D, "projectionMatrix", M.projectionMatrix), lt.setValue(D, "viewMatrix", M.matrixWorldInverse);
        const Xt = lt.map.cameraPosition;
        Xt !== void 0 && Xt.setValue(D, We.setFromMatrixPosition(M.matrixWorld)), at.logarithmicDepthBuffer && lt.setValue(
          D,
          "logDepthBufFC",
          2 / (Math.log(M.far + 1) / Math.LN2)
        ), (G.isMeshPhongMaterial || G.isMeshToonMaterial || G.isMeshLambertMaterial || G.isMeshBasicMaterial || G.isMeshStandardMaterial || G.isShaderMaterial) && lt.setValue(D, "isOrthographic", M.isOrthographicCamera === !0), H !== M && (H = M, tn = !0, ur = !0);
      }
      if (be.needsLights && (Je.state.directionalShadowMap.length > 0 && lt.setValue(D, "directionalShadowMap", Je.state.directionalShadowMap, F), Je.state.spotShadowMap.length > 0 && lt.setValue(D, "spotShadowMap", Je.state.spotShadowMap, F), Je.state.pointShadowMap.length > 0 && lt.setValue(D, "pointShadowMap", Je.state.pointShadowMap, F)), B.isSkinnedMesh) {
        lt.setOptional(D, B, "bindMatrix"), lt.setOptional(D, B, "bindMatrixInverse");
        const Gt = B.skeleton;
        Gt && (Gt.boneTexture === null && Gt.computeBoneTexture(), lt.setValue(D, "boneTexture", Gt.boneTexture, F));
      }
      B.isBatchedMesh && (lt.setOptional(D, B, "batchingTexture"), lt.setValue(D, "batchingTexture", B._matricesTexture, F), lt.setOptional(D, B, "batchingIdTexture"), lt.setValue(D, "batchingIdTexture", B._indirectTexture, F), lt.setOptional(D, B, "batchingColorTexture"), B._colorsTexture !== null && lt.setValue(D, "batchingColorTexture", B._colorsTexture, F));
      const fn = V.morphAttributes;
      if ((fn.position !== void 0 || fn.normal !== void 0 || fn.color !== void 0) && Oe.update(B, V, en), (tn || be.receiveShadow !== B.receiveShadow) && (be.receiveShadow = B.receiveShadow, lt.setValue(D, "receiveShadow", B.receiveShadow)), G.isMeshGouraudMaterial && G.envMap !== null && (Wt.envMap.value = _e, Wt.flipEnvMap.value = _e.isCubeTexture && _e.isRenderTargetTexture === !1 ? -1 : 1), G.isMeshStandardMaterial && G.envMap === null && U.environment !== null && (Wt.envMapIntensity.value = U.environmentIntensity), Wt.dfgLUT !== void 0 && (Wt.dfgLUT.value = I_()), tn && (lt.setValue(D, "toneMappingExposure", x.toneMappingExposure), be.needsLights && wu(Wt, ur), le && G.fog === !0 && Re.refreshFogUniforms(Wt, le), Re.refreshMaterialUniforms(Wt, G, Le, Pe, y.state.transmissionRenderTarget[M.id]), As.upload(D, Bo(be), Wt, F)), G.isShaderMaterial && G.uniformsNeedUpdate === !0 && (As.upload(D, Bo(be), Wt, F), G.uniformsNeedUpdate = !1), G.isSpriteMaterial && lt.setValue(D, "center", B.center), lt.setValue(D, "modelViewMatrix", B.modelViewMatrix), lt.setValue(D, "normalMatrix", B.normalMatrix), lt.setValue(D, "modelMatrix", B.matrixWorld), G.isShaderMaterial || G.isRawShaderMaterial) {
        const Gt = G.uniformsGroups;
        for (let Xt = 0, ta = Gt.length; Xt < ta; Xt++) {
          const ci = Gt[Xt];
          Q.update(ci, en), Q.bind(ci, en);
        }
      }
      return en;
    }
    function wu(M, U) {
      M.ambientLightColor.needsUpdate = U, M.lightProbe.needsUpdate = U, M.directionalLights.needsUpdate = U, M.directionalLightShadows.needsUpdate = U, M.pointLights.needsUpdate = U, M.pointLightShadows.needsUpdate = U, M.spotLights.needsUpdate = U, M.spotLightShadows.needsUpdate = U, M.rectAreaLights.needsUpdate = U, M.hemisphereLights.needsUpdate = U;
    }
    function Ru(M) {
      return M.isMeshLambertMaterial || M.isMeshToonMaterial || M.isMeshPhongMaterial || M.isMeshStandardMaterial || M.isShadowMaterial || M.isShaderMaterial && M.lights === !0;
    }
    this.getActiveCubeFace = function() {
      return P;
    }, this.getActiveMipmapLevel = function() {
      return z;
    }, this.getRenderTarget = function() {
      return N;
    }, this.setRenderTargetTextures = function(M, U, V) {
      const G = v.get(M);
      G.__autoAllocateDepthBuffer = M.resolveDepthBuffer === !1, G.__autoAllocateDepthBuffer === !1 && (G.__useRenderToTexture = !1), v.get(M.texture).__webglTexture = U, v.get(M.depthTexture).__webglTexture = G.__autoAllocateDepthBuffer ? void 0 : V, G.__hasExternalTextures = !0;
    }, this.setRenderTargetFramebuffer = function(M, U) {
      const V = v.get(M);
      V.__webglFramebuffer = U, V.__useDefaultFramebuffer = U === void 0;
    };
    const Cu = D.createFramebuffer();
    this.setRenderTarget = function(M, U = 0, V = 0) {
      N = M, P = U, z = V;
      let G = null, B = !1, le = !1;
      if (M) {
        const he = v.get(M);
        if (he.__useDefaultFramebuffer !== void 0) {
          Se.bindFramebuffer(D.FRAMEBUFFER, he.__webglFramebuffer), k.copy(M.viewport), O.copy(M.scissor), Y = M.scissorTest, Se.viewport(k), Se.scissor(O), Se.setScissorTest(Y), W = -1;
          return;
        } else if (he.__webglFramebuffer === void 0)
          F.setupRenderTarget(M);
        else if (he.__hasExternalTextures)
          F.rebindTextures(M, v.get(M.texture).__webglTexture, v.get(M.depthTexture).__webglTexture);
        else if (M.depthBuffer) {
          const we = M.depthTexture;
          if (he.__boundDepthTexture !== we) {
            if (we !== null && v.has(we) && (M.width !== we.image.width || M.height !== we.image.height))
              throw new Error("WebGLRenderTarget: Attached DepthTexture is initialized to the incorrect size.");
            F.setupDepthRenderbuffer(M);
          }
        }
        const _e = M.texture;
        (_e.isData3DTexture || _e.isDataArrayTexture || _e.isCompressedArrayTexture) && (le = !0);
        const Ee = v.get(M).__webglFramebuffer;
        M.isWebGLCubeRenderTarget ? (Array.isArray(Ee[U]) ? G = Ee[U][V] : G = Ee[U], B = !0) : M.samples > 0 && F.useMultisampledRTT(M) === !1 ? G = v.get(M).__webglMultisampledFramebuffer : Array.isArray(Ee) ? G = Ee[V] : G = Ee, k.copy(M.viewport), O.copy(M.scissor), Y = M.scissorTest;
      } else
        k.copy($).multiplyScalar(Le).floor(), O.copy(J).multiplyScalar(Le).floor(), Y = me;
      if (V !== 0 && (G = Cu), Se.bindFramebuffer(D.FRAMEBUFFER, G) && Se.drawBuffers(M, G), Se.viewport(k), Se.scissor(O), Se.setScissorTest(Y), B) {
        const he = v.get(M.texture);
        D.framebufferTexture2D(D.FRAMEBUFFER, D.COLOR_ATTACHMENT0, D.TEXTURE_CUBE_MAP_POSITIVE_X + U, he.__webglTexture, V);
      } else if (le) {
        const he = U;
        for (let _e = 0; _e < M.textures.length; _e++) {
          const Ee = v.get(M.textures[_e]);
          D.framebufferTextureLayer(D.FRAMEBUFFER, D.COLOR_ATTACHMENT0 + _e, Ee.__webglTexture, V, he);
        }
      } else if (M !== null && V !== 0) {
        const he = v.get(M.texture);
        D.framebufferTexture2D(D.FRAMEBUFFER, D.COLOR_ATTACHMENT0, D.TEXTURE_2D, he.__webglTexture, V);
      }
      W = -1;
    }, this.readRenderTargetPixels = function(M, U, V, G, B, le, pe, he = 0) {
      if (!(M && M.isWebGLRenderTarget)) {
        Xe("WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.");
        return;
      }
      let _e = v.get(M).__webglFramebuffer;
      if (M.isWebGLCubeRenderTarget && pe !== void 0 && (_e = _e[pe]), _e) {
        Se.bindFramebuffer(D.FRAMEBUFFER, _e);
        try {
          const Ee = M.textures[he], we = Ee.format, Te = Ee.type;
          if (!at.textureFormatReadable(we)) {
            Xe("WebGLRenderer.readRenderTargetPixels: renderTarget is not in RGBA or implementation defined format.");
            return;
          }
          if (!at.textureTypeReadable(Te)) {
            Xe("WebGLRenderer.readRenderTargetPixels: renderTarget is not in UnsignedByteType or implementation defined type.");
            return;
          }
          U >= 0 && U <= M.width - G && V >= 0 && V <= M.height - B && (M.textures.length > 1 && D.readBuffer(D.COLOR_ATTACHMENT0 + he), D.readPixels(U, V, G, B, te.convert(we), te.convert(Te), le));
        } finally {
          const Ee = N !== null ? v.get(N).__webglFramebuffer : null;
          Se.bindFramebuffer(D.FRAMEBUFFER, Ee);
        }
      }
    }, this.readRenderTargetPixelsAsync = async function(M, U, V, G, B, le, pe, he = 0) {
      if (!(M && M.isWebGLRenderTarget))
        throw new Error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.");
      let _e = v.get(M).__webglFramebuffer;
      if (M.isWebGLCubeRenderTarget && pe !== void 0 && (_e = _e[pe]), _e)
        if (U >= 0 && U <= M.width - G && V >= 0 && V <= M.height - B) {
          Se.bindFramebuffer(D.FRAMEBUFFER, _e);
          const Ee = M.textures[he], we = Ee.format, Te = Ee.type;
          if (!at.textureFormatReadable(we))
            throw new Error("THREE.WebGLRenderer.readRenderTargetPixelsAsync: renderTarget is not in RGBA or implementation defined format.");
          if (!at.textureTypeReadable(Te))
            throw new Error("THREE.WebGLRenderer.readRenderTargetPixelsAsync: renderTarget is not in UnsignedByteType or implementation defined type.");
          const Be = D.createBuffer();
          D.bindBuffer(D.PIXEL_PACK_BUFFER, Be), D.bufferData(D.PIXEL_PACK_BUFFER, le.byteLength, D.STREAM_READ), M.textures.length > 1 && D.readBuffer(D.COLOR_ATTACHMENT0 + he), D.readPixels(U, V, G, B, te.convert(we), te.convert(Te), 0);
          const tt = N !== null ? v.get(N).__webglFramebuffer : null;
          Se.bindFramebuffer(D.FRAMEBUFFER, tt);
          const mt = D.fenceSync(D.SYNC_GPU_COMMANDS_COMPLETE, 0);
          return D.flush(), await Iu(D, mt, 4), D.bindBuffer(D.PIXEL_PACK_BUFFER, Be), D.getBufferSubData(D.PIXEL_PACK_BUFFER, 0, le), D.deleteBuffer(Be), D.deleteSync(mt), le;
        } else
          throw new Error("THREE.WebGLRenderer.readRenderTargetPixelsAsync: requested read bounds are out of range.");
    }, this.copyFramebufferToTexture = function(M, U = null, V = 0) {
      const G = Math.pow(2, -V), B = Math.floor(M.image.width * G), le = Math.floor(M.image.height * G), pe = U !== null ? U.x : 0, he = U !== null ? U.y : 0;
      F.setTexture2D(M, 0), D.copyTexSubImage2D(D.TEXTURE_2D, V, 0, 0, pe, he, B, le), Se.unbindTexture();
    };
    const Pu = D.createFramebuffer(), Du = D.createFramebuffer();
    this.copyTextureToTexture = function(M, U, V = null, G = null, B = 0, le = null) {
      le === null && (B !== 0 ? (Ur("WebGLRenderer: copyTextureToTexture function signature has changed to support src and dst mipmap levels."), le = B, B = 0) : le = 0);
      let pe, he, _e, Ee, we, Te, Be, tt, mt;
      const _t = M.isCompressedTexture ? M.mipmaps[le] : M.image;
      if (V !== null)
        pe = V.max.x - V.min.x, he = V.max.y - V.min.y, _e = V.isBox3 ? V.max.z - V.min.z : 1, Ee = V.min.x, we = V.min.y, Te = V.isBox3 ? V.min.z : 0;
      else {
        const fn = Math.pow(2, -B);
        pe = Math.floor(_t.width * fn), he = Math.floor(_t.height * fn), M.isDataArrayTexture ? _e = _t.depth : M.isData3DTexture ? _e = Math.floor(_t.depth * fn) : _e = 1, Ee = 0, we = 0, Te = 0;
      }
      G !== null ? (Be = G.x, tt = G.y, mt = G.z) : (Be = 0, tt = 0, mt = 0);
      const it = te.convert(U.format), be = te.convert(U.type);
      let Je;
      U.isData3DTexture ? (F.setTexture3D(U, 0), Je = D.TEXTURE_3D) : U.isDataArrayTexture || U.isCompressedArrayTexture ? (F.setTexture2DArray(U, 0), Je = D.TEXTURE_2D_ARRAY) : (F.setTexture2D(U, 0), Je = D.TEXTURE_2D), D.pixelStorei(D.UNPACK_FLIP_Y_WEBGL, U.flipY), D.pixelStorei(D.UNPACK_PREMULTIPLY_ALPHA_WEBGL, U.premultiplyAlpha), D.pixelStorei(D.UNPACK_ALIGNMENT, U.unpackAlignment);
      const $e = D.getParameter(D.UNPACK_ROW_LENGTH), en = D.getParameter(D.UNPACK_IMAGE_HEIGHT), Ri = D.getParameter(D.UNPACK_SKIP_PIXELS), tn = D.getParameter(D.UNPACK_SKIP_ROWS), ur = D.getParameter(D.UNPACK_SKIP_IMAGES);
      D.pixelStorei(D.UNPACK_ROW_LENGTH, _t.width), D.pixelStorei(D.UNPACK_IMAGE_HEIGHT, _t.height), D.pixelStorei(D.UNPACK_SKIP_PIXELS, Ee), D.pixelStorei(D.UNPACK_SKIP_ROWS, we), D.pixelStorei(D.UNPACK_SKIP_IMAGES, Te);
      const lt = M.isDataArrayTexture || M.isData3DTexture, Wt = U.isDataArrayTexture || U.isData3DTexture;
      if (M.isDepthTexture) {
        const fn = v.get(M), Gt = v.get(U), Xt = v.get(fn.__renderTarget), ta = v.get(Gt.__renderTarget);
        Se.bindFramebuffer(D.READ_FRAMEBUFFER, Xt.__webglFramebuffer), Se.bindFramebuffer(D.DRAW_FRAMEBUFFER, ta.__webglFramebuffer);
        for (let ci = 0; ci < _e; ci++)
          lt && (D.framebufferTextureLayer(D.READ_FRAMEBUFFER, D.COLOR_ATTACHMENT0, v.get(M).__webglTexture, B, Te + ci), D.framebufferTextureLayer(D.DRAW_FRAMEBUFFER, D.COLOR_ATTACHMENT0, v.get(U).__webglTexture, le, mt + ci)), D.blitFramebuffer(Ee, we, pe, he, Be, tt, pe, he, D.DEPTH_BUFFER_BIT, D.NEAREST);
        Se.bindFramebuffer(D.READ_FRAMEBUFFER, null), Se.bindFramebuffer(D.DRAW_FRAMEBUFFER, null);
      } else if (B !== 0 || M.isRenderTargetTexture || v.has(M)) {
        const fn = v.get(M), Gt = v.get(U);
        Se.bindFramebuffer(D.READ_FRAMEBUFFER, Pu), Se.bindFramebuffer(D.DRAW_FRAMEBUFFER, Du);
        for (let Xt = 0; Xt < _e; Xt++)
          lt ? D.framebufferTextureLayer(D.READ_FRAMEBUFFER, D.COLOR_ATTACHMENT0, fn.__webglTexture, B, Te + Xt) : D.framebufferTexture2D(D.READ_FRAMEBUFFER, D.COLOR_ATTACHMENT0, D.TEXTURE_2D, fn.__webglTexture, B), Wt ? D.framebufferTextureLayer(D.DRAW_FRAMEBUFFER, D.COLOR_ATTACHMENT0, Gt.__webglTexture, le, mt + Xt) : D.framebufferTexture2D(D.DRAW_FRAMEBUFFER, D.COLOR_ATTACHMENT0, D.TEXTURE_2D, Gt.__webglTexture, le), B !== 0 ? D.blitFramebuffer(Ee, we, pe, he, Be, tt, pe, he, D.COLOR_BUFFER_BIT, D.NEAREST) : Wt ? D.copyTexSubImage3D(Je, le, Be, tt, mt + Xt, Ee, we, pe, he) : D.copyTexSubImage2D(Je, le, Be, tt, Ee, we, pe, he);
        Se.bindFramebuffer(D.READ_FRAMEBUFFER, null), Se.bindFramebuffer(D.DRAW_FRAMEBUFFER, null);
      } else
        Wt ? M.isDataTexture || M.isData3DTexture ? D.texSubImage3D(Je, le, Be, tt, mt, pe, he, _e, it, be, _t.data) : U.isCompressedArrayTexture ? D.compressedTexSubImage3D(Je, le, Be, tt, mt, pe, he, _e, it, _t.data) : D.texSubImage3D(Je, le, Be, tt, mt, pe, he, _e, it, be, _t) : M.isDataTexture ? D.texSubImage2D(D.TEXTURE_2D, le, Be, tt, pe, he, it, be, _t.data) : M.isCompressedTexture ? D.compressedTexSubImage2D(D.TEXTURE_2D, le, Be, tt, _t.width, _t.height, it, _t.data) : D.texSubImage2D(D.TEXTURE_2D, le, Be, tt, pe, he, it, be, _t);
      D.pixelStorei(D.UNPACK_ROW_LENGTH, $e), D.pixelStorei(D.UNPACK_IMAGE_HEIGHT, en), D.pixelStorei(D.UNPACK_SKIP_PIXELS, Ri), D.pixelStorei(D.UNPACK_SKIP_ROWS, tn), D.pixelStorei(D.UNPACK_SKIP_IMAGES, ur), le === 0 && U.generateMipmaps && D.generateMipmap(Je), Se.unbindTexture();
    }, this.initRenderTarget = function(M) {
      v.get(M).__webglFramebuffer === void 0 && F.setupRenderTarget(M);
    }, this.initTexture = function(M) {
      M.isCubeTexture ? F.setTextureCube(M, 0) : M.isData3DTexture ? F.setTexture3D(M, 0) : M.isDataArrayTexture || M.isCompressedArrayTexture ? F.setTexture2DArray(M, 0) : F.setTexture2D(M, 0), Se.unbindTexture();
    }, this.resetState = function() {
      P = 0, z = 0, N = null, Se.reset(), de.reset();
    }, typeof __THREE_DEVTOOLS__ < "u" && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", { detail: this }));
  }
  /**
   * Defines the coordinate system of the renderer.
   *
   * In `WebGLRenderer`, the value is always `WebGLCoordinateSystem`.
   *
   * @type {WebGLCoordinateSystem|WebGPUCoordinateSystem}
   * @default WebGLCoordinateSystem
   * @readonly
   */
  get coordinateSystem() {
    return 2e3;
  }
  /**
   * Defines the output color space of the renderer.
   *
   * @type {SRGBColorSpace|LinearSRGBColorSpace}
   * @default SRGBColorSpace
   */
  get outputColorSpace() {
    return this._outputColorSpace;
  }
  set outputColorSpace(e) {
    this._outputColorSpace = e;
    const t = this.getContext();
    t.drawingBufferColorSpace = qe._getDrawingBufferColorSpace(e), t.unpackColorSpace = qe._getUnpackColorSpace();
  }
}
function Bn(r) {
  if (r === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return r;
}
function wc(r, e) {
  r.prototype = Object.create(e.prototype), r.prototype.constructor = r, r.__proto__ = e;
}
var cn = {
  autoSleep: 120,
  force3D: "auto",
  nullTargetWarn: 1,
  units: {
    lineHeight: ""
  }
}, Or = {
  duration: 0.5,
  overwrite: !1,
  delay: 0
}, ho, Ft, ut, gn = 1e8, st = 1 / gn, Xa = Math.PI * 2, N_ = Xa / 4, O_ = 0, Rc = Math.sqrt, B_ = Math.cos, z_ = Math.sin, Dt = function(e) {
  return typeof e == "string";
}, gt = function(e) {
  return typeof e == "function";
}, Hn = function(e) {
  return typeof e == "number";
}, fo = function(e) {
  return typeof e > "u";
}, Dn = function(e) {
  return typeof e == "object";
}, $t = function(e) {
  return e !== !1;
}, po = function() {
  return typeof window < "u";
}, Ts = function(e) {
  return gt(e) || Dt(e);
}, Cc = typeof ArrayBuffer == "function" && ArrayBuffer.isView || function() {
}, zt = Array.isArray, G_ = /random\([^)]+\)/g, k_ = /,\s*/g, Nl = /(?:-?\.?\d|\.)+/gi, Pc = /[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/g, Ki = /[-+=.]*\d+[.e-]*\d*[a-z%]*/g, Fa = /[-+=.]*\d+\.?\d*(?:e-|e\+)?\d*/gi, Dc = /[+-]=-?[.\d]+/, V_ = /[^,'"\[\]\s]+/gi, H_ = /^[+\-=e\s\d]*\d+[.\d]*([a-z]*|%)\s*$/i, dt, bn, qa, mo, un = {}, Is = {}, Lc, Fc = function(e) {
  return (Is = ir(e, un)) && Jt;
}, _o = function(e, t) {
  return console.warn("Invalid property", e, "set to", t, "Missing plugin? gsap.registerPlugin()");
}, Br = function(e, t) {
  return !t && console.warn(e);
}, Uc = function(e, t) {
  return e && (un[e] = t) && Is && (Is[e] = t) || un;
}, zr = function() {
  return 0;
}, W_ = {
  suppressEvents: !0,
  isStart: !0,
  kill: !1
}, ws = {
  suppressEvents: !0,
  kill: !1
}, X_ = {
  suppressEvents: !0
}, go = {}, ni = [], Ya = {}, Ic, sn = {}, Ua = {}, Ol = 30, Rs = [], vo = "", xo = function(e) {
  var t = e[0], n, i;
  if (Dn(t) || gt(t) || (e = [e]), !(n = (t._gsap || {}).harness)) {
    for (i = Rs.length; i-- && !Rs[i].targetTest(t); )
      ;
    n = Rs[i];
  }
  for (i = e.length; i--; )
    e[i] && (e[i]._gsap || (e[i]._gsap = new iu(e[i], n))) || e.splice(i, 1);
  return e;
}, yi = function(e) {
  return e._gsap || xo(vn(e))[0]._gsap;
}, Nc = function(e, t, n) {
  return (n = e[t]) && gt(n) ? e[t]() : fo(n) && e.getAttribute && e.getAttribute(t) || n;
}, Kt = function(e, t) {
  return (e = e.split(",")).forEach(t) || e;
}, vt = function(e) {
  return Math.round(e * 1e5) / 1e5 || 0;
}, ft = function(e) {
  return Math.round(e * 1e7) / 1e7 || 0;
}, Ji = function(e, t) {
  var n = t.charAt(0), i = parseFloat(t.substr(2));
  return e = parseFloat(e), n === "+" ? e + i : n === "-" ? e - i : n === "*" ? e * i : e / i;
}, q_ = function(e, t) {
  for (var n = t.length, i = 0; e.indexOf(t[i]) < 0 && ++i < n; )
    ;
  return i < n;
}, Ns = function() {
  var e = ni.length, t = ni.slice(0), n, i;
  for (Ya = {}, ni.length = 0, n = 0; n < e; n++)
    i = t[n], i && i._lazy && (i.render(i._lazy[0], i._lazy[1], !0)._lazy = 0);
}, So = function(e) {
  return !!(e._initted || e._startAt || e.add);
}, Oc = function(e, t, n, i) {
  ni.length && !Ft && Ns(), e.render(t, n, !!(Ft && t < 0 && So(e))), ni.length && !Ft && Ns();
}, Bc = function(e) {
  var t = parseFloat(e);
  return (t || t === 0) && (e + "").match(V_).length < 2 ? t : Dt(e) ? e.trim() : e;
}, zc = function(e) {
  return e;
}, hn = function(e, t) {
  for (var n in t)
    n in e || (e[n] = t[n]);
  return e;
}, Y_ = function(e) {
  return function(t, n) {
    for (var i in n)
      i in t || i === "duration" && e || i === "ease" || (t[i] = n[i]);
  };
}, ir = function(e, t) {
  for (var n in t)
    e[n] = t[n];
  return e;
}, Bl = function r(e, t) {
  for (var n in t)
    n !== "__proto__" && n !== "constructor" && n !== "prototype" && (e[n] = Dn(t[n]) ? r(e[n] || (e[n] = {}), t[n]) : t[n]);
  return e;
}, Os = function(e, t) {
  var n = {}, i;
  for (i in e)
    i in t || (n[i] = e[i]);
  return n;
}, Pr = function(e) {
  var t = e.parent || dt, n = e.keyframes ? Y_(zt(e.keyframes)) : hn;
  if ($t(e.inherit))
    for (; t; )
      n(e, t.vars.defaults), t = t.parent || t._dp;
  return e;
}, $_ = function(e, t) {
  for (var n = e.length, i = n === t.length; i && n-- && e[n] === t[n]; )
    ;
  return n < 0;
}, Gc = function(e, t, n, i, s) {
  var a = e[i], o;
  if (s)
    for (o = t[s]; a && a[s] > o; )
      a = a._prev;
  return a ? (t._next = a._next, a._next = t) : (t._next = e[n], e[n] = t), t._next ? t._next._prev = t : e[i] = t, t._prev = a, t.parent = t._dp = e, t;
}, Ys = function(e, t, n, i) {
  n === void 0 && (n = "_first"), i === void 0 && (i = "_last");
  var s = t._prev, a = t._next;
  s ? s._next = a : e[n] === t && (e[n] = a), a ? a._prev = s : e[i] === t && (e[i] = s), t._next = t._prev = t.parent = null;
}, ri = function(e, t) {
  e.parent && (!t || e.parent.autoRemoveChildren) && e.parent.remove && e.parent.remove(e), e._act = 0;
}, Ei = function(e, t) {
  if (e && (!t || t._end > e._dur || t._start < 0))
    for (var n = e; n; )
      n._dirty = 1, n = n.parent;
  return e;
}, K_ = function(e) {
  for (var t = e.parent; t && t.parent; )
    t._dirty = 1, t.totalDuration(), t = t.parent;
  return e;
}, $a = function(e, t, n, i) {
  return e._startAt && (Ft ? e._startAt.revert(ws) : e.vars.immediateRender && !e.vars.autoRevert || e._startAt.render(t, !0, i));
}, Z_ = function r(e) {
  return !e || e._ts && r(e.parent);
}, zl = function(e) {
  return e._repeat ? rr(e._tTime, e = e.duration() + e._rDelay) * e : 0;
}, rr = function(e, t) {
  var n = Math.floor(e = ft(e / t));
  return e && n === e ? n - 1 : n;
}, Bs = function(e, t) {
  return (e - t._start) * t._ts + (t._ts >= 0 ? 0 : t._dirty ? t.totalDuration() : t._tDur);
}, $s = function(e) {
  return e._end = ft(e._start + (e._tDur / Math.abs(e._ts || e._rts || st) || 0));
}, Ks = function(e, t) {
  var n = e._dp;
  return n && n.smoothChildTiming && e._ts && (e._start = ft(n._time - (e._ts > 0 ? t / e._ts : ((e._dirty ? e.totalDuration() : e._tDur) - t) / -e._ts)), $s(e), n._dirty || Ei(n, e)), e;
}, kc = function(e, t) {
  var n;
  if ((t._time || !t._dur && t._initted || t._start < e._time && (t._dur || !t.add)) && (n = Bs(e.rawTime(), t), (!t._dur || Kr(0, t.totalDuration(), n) - t._tTime > st) && t.render(n, !0)), Ei(e, t)._dp && e._initted && e._time >= e._dur && e._ts) {
    if (e._dur < e.duration())
      for (n = e; n._dp; )
        n.rawTime() >= 0 && n.totalTime(n._tTime), n = n._dp;
    e._zTime = -st;
  }
}, wn = function(e, t, n, i) {
  return t.parent && ri(t), t._start = ft((Hn(n) ? n : n || e !== dt ? pn(e, n, t) : e._time) + t._delay), t._end = ft(t._start + (t.totalDuration() / Math.abs(t.timeScale()) || 0)), Gc(e, t, "_first", "_last", e._sort ? "_start" : 0), Ka(t) || (e._recent = t), i || kc(e, t), e._ts < 0 && Ks(e, e._tTime), e;
}, Vc = function(e, t) {
  return (un.ScrollTrigger || _o("scrollTrigger", t)) && un.ScrollTrigger.create(t, e);
}, Hc = function(e, t, n, i, s) {
  if (yo(e, t, s), !e._initted)
    return 1;
  if (!n && e._pt && !Ft && (e._dur && e.vars.lazy !== !1 || !e._dur && e.vars.lazy) && Ic !== an.frame)
    return ni.push(e), e._lazy = [s, i], 1;
}, j_ = function r(e) {
  var t = e.parent;
  return t && t._ts && t._initted && !t._lock && (t.rawTime() < 0 || r(t));
}, Ka = function(e) {
  var t = e.data;
  return t === "isFromStart" || t === "isStart";
}, J_ = function(e, t, n, i) {
  var s = e.ratio, a = t < 0 || !t && (!e._start && j_(e) && !(!e._initted && Ka(e)) || (e._ts < 0 || e._dp._ts < 0) && !Ka(e)) ? 0 : 1, o = e._rDelay, c = 0, l, u, h;
  if (o && e._repeat && (c = Kr(0, e._tDur, t), u = rr(c, o), e._yoyo && u & 1 && (a = 1 - a), u !== rr(e._tTime, o) && (s = 1 - a, e.vars.repeatRefresh && e._initted && e.invalidate())), a !== s || Ft || i || e._zTime === st || !t && e._zTime) {
    if (!e._initted && Hc(e, t, i, n, c))
      return;
    for (h = e._zTime, e._zTime = t || (n ? st : 0), n || (n = t && !h), e.ratio = a, e._from && (a = 1 - a), e._time = 0, e._tTime = c, l = e._pt; l; )
      l.r(a, l.d), l = l._next;
    t < 0 && $a(e, t, n, !0), e._onUpdate && !n && on(e, "onUpdate"), c && e._repeat && !n && e.parent && on(e, "onRepeat"), (t >= e._tDur || t < 0) && e.ratio === a && (a && ri(e, 1), !n && !Ft && (on(e, a ? "onComplete" : "onReverseComplete", !0), e._prom && e._prom()));
  } else e._zTime || (e._zTime = t);
}, Q_ = function(e, t, n) {
  var i;
  if (n > t)
    for (i = e._first; i && i._start <= n; ) {
      if (i.data === "isPause" && i._start > t)
        return i;
      i = i._next;
    }
  else
    for (i = e._last; i && i._start >= n; ) {
      if (i.data === "isPause" && i._start < t)
        return i;
      i = i._prev;
    }
}, sr = function(e, t, n, i) {
  var s = e._repeat, a = ft(t) || 0, o = e._tTime / e._tDur;
  return o && !i && (e._time *= a / e._dur), e._dur = a, e._tDur = s ? s < 0 ? 1e10 : ft(a * (s + 1) + e._rDelay * s) : a, o > 0 && !i && Ks(e, e._tTime = e._tDur * o), e.parent && $s(e), n || Ei(e.parent, e), e;
}, Gl = function(e) {
  return e instanceof Yt ? Ei(e) : sr(e, e._dur);
}, eg = {
  _start: 0,
  endTime: zr,
  totalDuration: zr
}, pn = function r(e, t, n) {
  var i = e.labels, s = e._recent || eg, a = e.duration() >= gn ? s.endTime(!1) : e._dur, o, c, l;
  return Dt(t) && (isNaN(t) || t in i) ? (c = t.charAt(0), l = t.substr(-1) === "%", o = t.indexOf("="), c === "<" || c === ">" ? (o >= 0 && (t = t.replace(/=/, "")), (c === "<" ? s._start : s.endTime(s._repeat >= 0)) + (parseFloat(t.substr(1)) || 0) * (l ? (o < 0 ? s : n).totalDuration() / 100 : 1)) : o < 0 ? (t in i || (i[t] = a), i[t]) : (c = parseFloat(t.charAt(o - 1) + t.substr(o + 1)), l && n && (c = c / 100 * (zt(n) ? n[0] : n).totalDuration()), o > 1 ? r(e, t.substr(0, o - 1), n) + c : a + c)) : t == null ? a : +t;
}, Dr = function(e, t, n) {
  var i = Hn(t[1]), s = (i ? 2 : 1) + (e < 2 ? 0 : 1), a = t[s], o, c;
  if (i && (a.duration = t[1]), a.parent = n, e) {
    for (o = a, c = n; c && !("immediateRender" in o); )
      o = c.vars.defaults || {}, c = $t(c.vars.inherit) && c.parent;
    a.immediateRender = $t(o.immediateRender), e < 2 ? a.runBackwards = 1 : a.startAt = t[s - 1];
  }
  return new Et(t[0], a, t[s + 1]);
}, oi = function(e, t) {
  return e || e === 0 ? t(e) : t;
}, Kr = function(e, t, n) {
  return n < e ? e : n > t ? t : n;
}, Ot = function(e, t) {
  return !Dt(e) || !(t = H_.exec(e)) ? "" : t[1];
}, tg = function(e, t, n) {
  return oi(n, function(i) {
    return Kr(e, t, i);
  });
}, Za = [].slice, Wc = function(e, t) {
  return e && Dn(e) && "length" in e && (!t && !e.length || e.length - 1 in e && Dn(e[0])) && !e.nodeType && e !== bn;
}, ng = function(e, t, n) {
  return n === void 0 && (n = []), e.forEach(function(i) {
    var s;
    return Dt(i) && !t || Wc(i, 1) ? (s = n).push.apply(s, vn(i)) : n.push(i);
  }) || n;
}, vn = function(e, t, n) {
  return ut && !t && ut.selector ? ut.selector(e) : Dt(e) && !n && (qa || !ar()) ? Za.call((t || mo).querySelectorAll(e), 0) : zt(e) ? ng(e, n) : Wc(e) ? Za.call(e, 0) : e ? [e] : [];
}, ja = function(e) {
  return e = vn(e)[0] || Br("Invalid scope") || {}, function(t) {
    var n = e.current || e.nativeElement || e;
    return vn(t, n.querySelectorAll ? n : n === e ? Br("Invalid scope") || mo.createElement("div") : e);
  };
}, Xc = function(e) {
  return e.sort(function() {
    return 0.5 - Math.random();
  });
}, qc = function(e) {
  if (gt(e))
    return e;
  var t = Dn(e) ? e : {
    each: e
  }, n = Ti(t.ease), i = t.from || 0, s = parseFloat(t.base) || 0, a = {}, o = i > 0 && i < 1, c = isNaN(i) || o, l = t.axis, u = i, h = i;
  return Dt(i) ? u = h = {
    center: 0.5,
    edges: 0.5,
    end: 1
  }[i] || 0 : !o && c && (u = i[0], h = i[1]), function(f, d, g) {
    var _ = (g || t).length, m = a[_], p, S, b, T, y, R, A, C, x;
    if (!m) {
      if (x = t.grid === "auto" ? 0 : (t.grid || [1, gn])[1], !x) {
        for (A = -gn; A < (A = g[x++].getBoundingClientRect().left) && x < _; )
          ;
        x < _ && x--;
      }
      for (m = a[_] = [], p = c ? Math.min(x, _) * u - 0.5 : i % x, S = x === gn ? 0 : c ? _ * h / x - 0.5 : i / x | 0, A = 0, C = gn, R = 0; R < _; R++)
        b = R % x - p, T = S - (R / x | 0), m[R] = y = l ? Math.abs(l === "y" ? T : b) : Rc(b * b + T * T), y > A && (A = y), y < C && (C = y);
      i === "random" && Xc(m), m.max = A - C, m.min = C, m.v = _ = (parseFloat(t.amount) || parseFloat(t.each) * (x > _ ? _ - 1 : l ? l === "y" ? _ / x : x : Math.max(x, _ / x)) || 0) * (i === "edges" ? -1 : 1), m.b = _ < 0 ? s - _ : s, m.u = Ot(t.amount || t.each) || 0, n = n && _ < 0 ? mg(n) : n;
    }
    return _ = (m[f] - m.min) / m.max || 0, ft(m.b + (n ? n(_) : _) * m.v) + m.u;
  };
}, Ja = function(e) {
  var t = Math.pow(10, ((e + "").split(".")[1] || "").length);
  return function(n) {
    var i = ft(Math.round(parseFloat(n) / e) * e * t);
    return (i - i % 1) / t + (Hn(n) ? 0 : Ot(n));
  };
}, Yc = function(e, t) {
  var n = zt(e), i, s;
  return !n && Dn(e) && (i = n = e.radius || gn, e.values ? (e = vn(e.values), (s = !Hn(e[0])) && (i *= i)) : e = Ja(e.increment)), oi(t, n ? gt(e) ? function(a) {
    return s = e(a), Math.abs(s - a) <= i ? s : a;
  } : function(a) {
    for (var o = parseFloat(s ? a.x : a), c = parseFloat(s ? a.y : 0), l = gn, u = 0, h = e.length, f, d; h--; )
      s ? (f = e[h].x - o, d = e[h].y - c, f = f * f + d * d) : f = Math.abs(e[h] - o), f < l && (l = f, u = h);
    return u = !i || l <= i ? e[u] : a, s || u === a || Hn(a) ? u : u + Ot(a);
  } : Ja(e));
}, $c = function(e, t, n, i) {
  return oi(zt(e) ? !t : n === !0 ? !!(n = 0) : !i, function() {
    return zt(e) ? e[~~(Math.random() * e.length)] : (n = n || 1e-5) && (i = n < 1 ? Math.pow(10, (n + "").length - 2) : 1) && Math.floor(Math.round((e - n / 2 + Math.random() * (t - e + n * 0.99)) / n) * n * i) / i;
  });
}, ig = function() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return function(i) {
    return t.reduce(function(s, a) {
      return a(s);
    }, i);
  };
}, rg = function(e, t) {
  return function(n) {
    return e(parseFloat(n)) + (t || Ot(n));
  };
}, sg = function(e, t, n) {
  return Zc(e, t, 0, 1, n);
}, Kc = function(e, t, n) {
  return oi(n, function(i) {
    return e[~~t(i)];
  });
}, ag = function r(e, t, n) {
  var i = t - e;
  return zt(e) ? Kc(e, r(0, e.length), t) : oi(n, function(s) {
    return (i + (s - e) % i) % i + e;
  });
}, og = function r(e, t, n) {
  var i = t - e, s = i * 2;
  return zt(e) ? Kc(e, r(0, e.length - 1), t) : oi(n, function(a) {
    return a = (s + (a - e) % s) % s || 0, e + (a > i ? s - a : a);
  });
}, Gr = function(e) {
  return e.replace(G_, function(t) {
    var n = t.indexOf("[") + 1, i = t.substring(n || 7, n ? t.indexOf("]") : t.length - 1).split(k_);
    return $c(n ? i : +i[0], n ? 0 : +i[1], +i[2] || 1e-5);
  });
}, Zc = function(e, t, n, i, s) {
  var a = t - e, o = i - n;
  return oi(s, function(c) {
    return n + ((c - e) / a * o || 0);
  });
}, lg = function r(e, t, n, i) {
  var s = isNaN(e + t) ? 0 : function(d) {
    return (1 - d) * e + d * t;
  };
  if (!s) {
    var a = Dt(e), o = {}, c, l, u, h, f;
    if (n === !0 && (i = 1) && (n = null), a)
      e = {
        p: e
      }, t = {
        p: t
      };
    else if (zt(e) && !zt(t)) {
      for (u = [], h = e.length, f = h - 2, l = 1; l < h; l++)
        u.push(r(e[l - 1], e[l]));
      h--, s = function(g) {
        g *= h;
        var _ = Math.min(f, ~~g);
        return u[_](g - _);
      }, n = t;
    } else i || (e = ir(zt(e) ? [] : {}, e));
    if (!u) {
      for (c in t)
        Mo.call(o, e, c, "get", t[c]);
      s = function(g) {
        return bo(g, o) || (a ? e.p : e);
      };
    }
  }
  return oi(n, s);
}, kl = function(e, t, n) {
  var i = e.labels, s = gn, a, o, c;
  for (a in i)
    o = i[a] - t, o < 0 == !!n && o && s > (o = Math.abs(o)) && (c = a, s = o);
  return c;
}, on = function(e, t, n) {
  var i = e.vars, s = i[t], a = ut, o = e._ctx, c, l, u;
  if (s)
    return c = i[t + "Params"], l = i.callbackScope || e, n && ni.length && Ns(), o && (ut = o), u = c ? s.apply(l, c) : s.call(l), ut = a, u;
}, br = function(e) {
  return ri(e), e.scrollTrigger && e.scrollTrigger.kill(!!Ft), e.progress() < 1 && on(e, "onInterrupt"), e;
}, Zi, jc = [], Jc = function(e) {
  if (e)
    if (e = !e.name && e.default || e, po() || e.headless) {
      var t = e.name, n = gt(e), i = t && !n && e.init ? function() {
        this._props = [];
      } : e, s = {
        init: zr,
        render: bo,
        add: Mo,
        kill: bg,
        modifier: Tg,
        rawVars: 0
      }, a = {
        targetTest: 0,
        get: 0,
        getSetter: To,
        aliases: {},
        register: 0
      };
      if (ar(), e !== i) {
        if (sn[t])
          return;
        hn(i, hn(Os(e, s), a)), ir(i.prototype, ir(s, Os(e, a))), sn[i.prop = t] = i, e.targetTest && (Rs.push(i), go[t] = 1), t = (t === "css" ? "CSS" : t.charAt(0).toUpperCase() + t.substr(1)) + "Plugin";
      }
      Uc(t, i), e.register && e.register(Jt, i, Zt);
    } else
      jc.push(e);
}, rt = 255, Ar = {
  aqua: [0, rt, rt],
  lime: [0, rt, 0],
  silver: [192, 192, 192],
  black: [0, 0, 0],
  maroon: [128, 0, 0],
  teal: [0, 128, 128],
  blue: [0, 0, rt],
  navy: [0, 0, 128],
  white: [rt, rt, rt],
  olive: [128, 128, 0],
  yellow: [rt, rt, 0],
  orange: [rt, 165, 0],
  gray: [128, 128, 128],
  purple: [128, 0, 128],
  green: [0, 128, 0],
  red: [rt, 0, 0],
  pink: [rt, 192, 203],
  cyan: [0, rt, rt],
  transparent: [rt, rt, rt, 0]
}, Ia = function(e, t, n) {
  return e += e < 0 ? 1 : e > 1 ? -1 : 0, (e * 6 < 1 ? t + (n - t) * e * 6 : e < 0.5 ? n : e * 3 < 2 ? t + (n - t) * (2 / 3 - e) * 6 : t) * rt + 0.5 | 0;
}, Qc = function(e, t, n) {
  var i = e ? Hn(e) ? [e >> 16, e >> 8 & rt, e & rt] : 0 : Ar.black, s, a, o, c, l, u, h, f, d, g;
  if (!i) {
    if (e.substr(-1) === "," && (e = e.substr(0, e.length - 1)), Ar[e])
      i = Ar[e];
    else if (e.charAt(0) === "#") {
      if (e.length < 6 && (s = e.charAt(1), a = e.charAt(2), o = e.charAt(3), e = "#" + s + s + a + a + o + o + (e.length === 5 ? e.charAt(4) + e.charAt(4) : "")), e.length === 9)
        return i = parseInt(e.substr(1, 6), 16), [i >> 16, i >> 8 & rt, i & rt, parseInt(e.substr(7), 16) / 255];
      e = parseInt(e.substr(1), 16), i = [e >> 16, e >> 8 & rt, e & rt];
    } else if (e.substr(0, 3) === "hsl") {
      if (i = g = e.match(Nl), !t)
        c = +i[0] % 360 / 360, l = +i[1] / 100, u = +i[2] / 100, a = u <= 0.5 ? u * (l + 1) : u + l - u * l, s = u * 2 - a, i.length > 3 && (i[3] *= 1), i[0] = Ia(c + 1 / 3, s, a), i[1] = Ia(c, s, a), i[2] = Ia(c - 1 / 3, s, a);
      else if (~e.indexOf("="))
        return i = e.match(Pc), n && i.length < 4 && (i[3] = 1), i;
    } else
      i = e.match(Nl) || Ar.transparent;
    i = i.map(Number);
  }
  return t && !g && (s = i[0] / rt, a = i[1] / rt, o = i[2] / rt, h = Math.max(s, a, o), f = Math.min(s, a, o), u = (h + f) / 2, h === f ? c = l = 0 : (d = h - f, l = u > 0.5 ? d / (2 - h - f) : d / (h + f), c = h === s ? (a - o) / d + (a < o ? 6 : 0) : h === a ? (o - s) / d + 2 : (s - a) / d + 4, c *= 60), i[0] = ~~(c + 0.5), i[1] = ~~(l * 100 + 0.5), i[2] = ~~(u * 100 + 0.5)), n && i.length < 4 && (i[3] = 1), i;
}, eu = function(e) {
  var t = [], n = [], i = -1;
  return e.split(ii).forEach(function(s) {
    var a = s.match(Ki) || [];
    t.push.apply(t, a), n.push(i += a.length + 1);
  }), t.c = n, t;
}, Vl = function(e, t, n) {
  var i = "", s = (e + i).match(ii), a = t ? "hsla(" : "rgba(", o = 0, c, l, u, h;
  if (!s)
    return e;
  if (s = s.map(function(f) {
    return (f = Qc(f, t, 1)) && a + (t ? f[0] + "," + f[1] + "%," + f[2] + "%," + f[3] : f.join(",")) + ")";
  }), n && (u = eu(e), c = n.c, c.join(i) !== u.c.join(i)))
    for (l = e.replace(ii, "1").split(Ki), h = l.length - 1; o < h; o++)
      i += l[o] + (~c.indexOf(o) ? s.shift() || a + "0,0,0,0)" : (u.length ? u : s.length ? s : n).shift());
  if (!l)
    for (l = e.split(ii), h = l.length - 1; o < h; o++)
      i += l[o] + s[o];
  return i + l[h];
}, ii = (function() {
  var r = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3,4}){1,2}\\b", e;
  for (e in Ar)
    r += "|" + e + "\\b";
  return new RegExp(r + ")", "gi");
})(), cg = /hsl[a]?\(/, tu = function(e) {
  var t = e.join(" "), n;
  if (ii.lastIndex = 0, ii.test(t))
    return n = cg.test(t), e[1] = Vl(e[1], n), e[0] = Vl(e[0], n, eu(e[1])), !0;
}, kr, an = (function() {
  var r = Date.now, e = 500, t = 33, n = r(), i = n, s = 1e3 / 240, a = s, o = [], c, l, u, h, f, d, g = function _(m) {
    var p = r() - i, S = m === !0, b, T, y, R;
    if ((p > e || p < 0) && (n += p - t), i += p, y = i - n, b = y - a, (b > 0 || S) && (R = ++h.frame, f = y - h.time * 1e3, h.time = y = y / 1e3, a += b + (b >= s ? 4 : s - b), T = 1), S || (c = l(_)), T)
      for (d = 0; d < o.length; d++)
        o[d](y, f, R, m);
  };
  return h = {
    time: 0,
    frame: 0,
    tick: function() {
      g(!0);
    },
    deltaRatio: function(m) {
      return f / (1e3 / (m || 60));
    },
    wake: function() {
      Lc && (!qa && po() && (bn = qa = window, mo = bn.document || {}, un.gsap = Jt, (bn.gsapVersions || (bn.gsapVersions = [])).push(Jt.version), Fc(Is || bn.GreenSockGlobals || !bn.gsap && bn || {}), jc.forEach(Jc)), u = typeof requestAnimationFrame < "u" && requestAnimationFrame, c && h.sleep(), l = u || function(m) {
        return setTimeout(m, a - h.time * 1e3 + 1 | 0);
      }, kr = 1, g(2));
    },
    sleep: function() {
      (u ? cancelAnimationFrame : clearTimeout)(c), kr = 0, l = zr;
    },
    lagSmoothing: function(m, p) {
      e = m || 1 / 0, t = Math.min(p || 33, e);
    },
    fps: function(m) {
      s = 1e3 / (m || 240), a = h.time * 1e3 + s;
    },
    add: function(m, p, S) {
      var b = p ? function(T, y, R, A) {
        m(T, y, R, A), h.remove(b);
      } : m;
      return h.remove(m), o[S ? "unshift" : "push"](b), ar(), b;
    },
    remove: function(m, p) {
      ~(p = o.indexOf(m)) && o.splice(p, 1) && d >= p && d--;
    },
    _listeners: o
  }, h;
})(), ar = function() {
  return !kr && an.wake();
}, ke = {}, ug = /^[\d.\-M][\d.\-,\s]/, hg = /["']/g, fg = function(e) {
  for (var t = {}, n = e.substr(1, e.length - 3).split(":"), i = n[0], s = 1, a = n.length, o, c, l; s < a; s++)
    c = n[s], o = s !== a - 1 ? c.lastIndexOf(",") : c.length, l = c.substr(0, o), t[i] = isNaN(l) ? l.replace(hg, "").trim() : +l, i = c.substr(o + 1).trim();
  return t;
}, dg = function(e) {
  var t = e.indexOf("(") + 1, n = e.indexOf(")"), i = e.indexOf("(", t);
  return e.substring(t, ~i && i < n ? e.indexOf(")", n + 1) : n);
}, pg = function(e) {
  var t = (e + "").split("("), n = ke[t[0]];
  return n && t.length > 1 && n.config ? n.config.apply(null, ~e.indexOf("{") ? [fg(t[1])] : dg(e).split(",").map(Bc)) : ke._CE && ug.test(e) ? ke._CE("", e) : n;
}, mg = function(e) {
  return function(t) {
    return 1 - e(1 - t);
  };
}, Ti = function(e, t) {
  return e && (gt(e) ? e : ke[e] || pg(e)) || t;
}, wi = function(e, t, n, i) {
  n === void 0 && (n = function(c) {
    return 1 - t(1 - c);
  }), i === void 0 && (i = function(c) {
    return c < 0.5 ? t(c * 2) / 2 : 1 - t((1 - c) * 2) / 2;
  });
  var s = {
    easeIn: t,
    easeOut: n,
    easeInOut: i
  }, a;
  return Kt(e, function(o) {
    ke[o] = un[o] = s, ke[a = o.toLowerCase()] = n;
    for (var c in s)
      ke[a + (c === "easeIn" ? ".in" : c === "easeOut" ? ".out" : ".inOut")] = ke[o + "." + c] = s[c];
  }), s;
}, nu = function(e) {
  return function(t) {
    return t < 0.5 ? (1 - e(1 - t * 2)) / 2 : 0.5 + e((t - 0.5) * 2) / 2;
  };
}, Na = function r(e, t, n) {
  var i = t >= 1 ? t : 1, s = (n || (e ? 0.3 : 0.45)) / (t < 1 ? t : 1), a = s / Xa * (Math.asin(1 / i) || 0), o = function(u) {
    return u === 1 ? 1 : i * Math.pow(2, -10 * u) * z_((u - a) * s) + 1;
  }, c = e === "out" ? o : e === "in" ? function(l) {
    return 1 - o(1 - l);
  } : nu(o);
  return s = Xa / s, c.config = function(l, u) {
    return r(e, l, u);
  }, c;
}, Oa = function r(e, t) {
  t === void 0 && (t = 1.70158);
  var n = function(a) {
    return a ? --a * a * ((t + 1) * a + t) + 1 : 0;
  }, i = e === "out" ? n : e === "in" ? function(s) {
    return 1 - n(1 - s);
  } : nu(n);
  return i.config = function(s) {
    return r(e, s);
  }, i;
};
Kt("Linear,Quad,Cubic,Quart,Quint,Strong", function(r, e) {
  var t = e < 5 ? e + 1 : e;
  wi(r + ",Power" + (t - 1), e ? function(n) {
    return Math.pow(n, t);
  } : function(n) {
    return n;
  }, function(n) {
    return 1 - Math.pow(1 - n, t);
  }, function(n) {
    return n < 0.5 ? Math.pow(n * 2, t) / 2 : 1 - Math.pow((1 - n) * 2, t) / 2;
  });
});
ke.Linear.easeNone = ke.none = ke.Linear.easeIn;
wi("Elastic", Na("in"), Na("out"), Na());
(function(r, e) {
  var t = 1 / e, n = 2 * t, i = 2.5 * t, s = function(o) {
    return o < t ? r * o * o : o < n ? r * Math.pow(o - 1.5 / e, 2) + 0.75 : o < i ? r * (o -= 2.25 / e) * o + 0.9375 : r * Math.pow(o - 2.625 / e, 2) + 0.984375;
  };
  wi("Bounce", function(a) {
    return 1 - s(1 - a);
  }, s);
})(7.5625, 2.75);
wi("Expo", function(r) {
  return Math.pow(2, 10 * (r - 1)) * r + r * r * r * r * r * r * (1 - r);
});
wi("Circ", function(r) {
  return -(Rc(1 - r * r) - 1);
});
wi("Sine", function(r) {
  return r === 1 ? 1 : -B_(r * N_) + 1;
});
wi("Back", Oa("in"), Oa("out"), Oa());
ke.SteppedEase = ke.steps = un.SteppedEase = {
  config: function(e, t) {
    e === void 0 && (e = 1);
    var n = 1 / e, i = e + (t ? 0 : 1), s = t ? 1 : 0, a = 1 - st;
    return function(o) {
      return ((i * Kr(0, a, o) | 0) + s) * n;
    };
  }
};
Or.ease = ke["quad.out"];
Kt("onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt", function(r) {
  return vo += r + "," + r + "Params,";
});
var iu = function(e, t) {
  this.id = O_++, e._gsap = this, this.target = e, this.harness = t, this.get = t ? t.get : Nc, this.set = t ? t.getSetter : To;
}, Vr = /* @__PURE__ */ (function() {
  function r(t) {
    this.vars = t, this._delay = +t.delay || 0, (this._repeat = t.repeat === 1 / 0 ? -2 : t.repeat || 0) && (this._rDelay = t.repeatDelay || 0, this._yoyo = !!t.yoyo || !!t.yoyoEase), this._ts = 1, sr(this, +t.duration, 1, 1), this.data = t.data, ut && (this._ctx = ut, ut.data.push(this)), kr || an.wake();
  }
  var e = r.prototype;
  return e.delay = function(n) {
    return n || n === 0 ? (this.parent && this.parent.smoothChildTiming && this.startTime(this._start + n - this._delay), this._delay = n, this) : this._delay;
  }, e.duration = function(n) {
    return arguments.length ? this.totalDuration(this._repeat > 0 ? n + (n + this._rDelay) * this._repeat : n) : this.totalDuration() && this._dur;
  }, e.totalDuration = function(n) {
    return arguments.length ? (this._dirty = 0, sr(this, this._repeat < 0 ? n : (n - this._repeat * this._rDelay) / (this._repeat + 1))) : this._tDur;
  }, e.totalTime = function(n, i) {
    if (ar(), !arguments.length)
      return this._tTime;
    var s = this._dp;
    if (s && s.smoothChildTiming && this._ts) {
      for (Ks(this, n), !s._dp || s.parent || kc(s, this); s && s.parent; )
        s.parent._time !== s._start + (s._ts >= 0 ? s._tTime / s._ts : (s.totalDuration() - s._tTime) / -s._ts) && s.totalTime(s._tTime, !0), s = s.parent;
      !this.parent && this._dp.autoRemoveChildren && (this._ts > 0 && n < this._tDur || this._ts < 0 && n > 0 || !this._tDur && !n) && wn(this._dp, this, this._start - this._delay);
    }
    return (this._tTime !== n || !this._dur && !i || this._initted && Math.abs(this._zTime) === st || !this._initted && this._dur && n || !n && !this._initted && (this.add || this._ptLookup)) && (this._ts || (this._pTime = n), Oc(this, n, i)), this;
  }, e.time = function(n, i) {
    return arguments.length ? this.totalTime(Math.min(this.totalDuration(), n + zl(this)) % (this._dur + this._rDelay) || (n ? this._dur : 0), i) : this._time;
  }, e.totalProgress = function(n, i) {
    return arguments.length ? this.totalTime(this.totalDuration() * n, i) : this.totalDuration() ? Math.min(1, this._tTime / this._tDur) : this.rawTime() >= 0 && this._initted ? 1 : 0;
  }, e.progress = function(n, i) {
    return arguments.length ? this.totalTime(this.duration() * (this._yoyo && !(this.iteration() & 1) ? 1 - n : n) + zl(this), i) : this.duration() ? Math.min(1, this._time / this._dur) : this.rawTime() > 0 ? 1 : 0;
  }, e.iteration = function(n, i) {
    var s = this.duration() + this._rDelay;
    return arguments.length ? this.totalTime(this._time + (n - 1) * s, i) : this._repeat ? rr(this._tTime, s) + 1 : 1;
  }, e.timeScale = function(n, i) {
    if (!arguments.length)
      return this._rts === -st ? 0 : this._rts;
    if (this._rts === n)
      return this;
    var s = this.parent && this._ts ? Bs(this.parent._time, this) : this._tTime;
    return this._rts = +n || 0, this._ts = this._ps || n === -st ? 0 : this._rts, this.totalTime(Kr(-Math.abs(this._delay), this.totalDuration(), s), i !== !1), $s(this), K_(this);
  }, e.paused = function(n) {
    return arguments.length ? (this._ps !== n && (this._ps = n, n ? (this._pTime = this._tTime || Math.max(-this._delay, this.rawTime()), this._ts = this._act = 0) : (ar(), this._ts = this._rts, this.totalTime(this.parent && !this.parent.smoothChildTiming ? this.rawTime() : this._tTime || this._pTime, this.progress() === 1 && Math.abs(this._zTime) !== st && (this._tTime -= st)))), this) : this._ps;
  }, e.startTime = function(n) {
    if (arguments.length) {
      this._start = ft(n);
      var i = this.parent || this._dp;
      return i && (i._sort || !this.parent) && wn(i, this, this._start - this._delay), this;
    }
    return this._start;
  }, e.endTime = function(n) {
    return this._start + ($t(n) ? this.totalDuration() : this.duration()) / Math.abs(this._ts || 1);
  }, e.rawTime = function(n) {
    var i = this.parent || this._dp;
    return i ? n && (!this._ts || this._repeat && this._time && this.totalProgress() < 1) ? this._tTime % (this._dur + this._rDelay) : this._ts ? Bs(i.rawTime(n), this) : this._tTime : this._tTime;
  }, e.revert = function(n) {
    n === void 0 && (n = X_);
    var i = Ft;
    return Ft = n, So(this) && (this.timeline && this.timeline.revert(n), this.totalTime(-0.01, n.suppressEvents)), this.data !== "nested" && n.kill !== !1 && this.kill(), Ft = i, this;
  }, e.globalTime = function(n) {
    for (var i = this, s = arguments.length ? n : i.rawTime(); i; )
      s = i._start + s / (Math.abs(i._ts) || 1), i = i._dp;
    return !this.parent && this._sat ? this._sat.globalTime(n) : s;
  }, e.repeat = function(n) {
    return arguments.length ? (this._repeat = n === 1 / 0 ? -2 : n, Gl(this)) : this._repeat === -2 ? 1 / 0 : this._repeat;
  }, e.repeatDelay = function(n) {
    if (arguments.length) {
      var i = this._time;
      return this._rDelay = n, Gl(this), i ? this.time(i) : this;
    }
    return this._rDelay;
  }, e.yoyo = function(n) {
    return arguments.length ? (this._yoyo = n, this) : this._yoyo;
  }, e.seek = function(n, i) {
    return this.totalTime(pn(this, n), $t(i));
  }, e.restart = function(n, i) {
    return this.play().totalTime(n ? -this._delay : 0, $t(i)), this._dur || (this._zTime = -st), this;
  }, e.play = function(n, i) {
    return n != null && this.seek(n, i), this.reversed(!1).paused(!1);
  }, e.reverse = function(n, i) {
    return n != null && this.seek(n || this.totalDuration(), i), this.reversed(!0).paused(!1);
  }, e.pause = function(n, i) {
    return n != null && this.seek(n, i), this.paused(!0);
  }, e.resume = function() {
    return this.paused(!1);
  }, e.reversed = function(n) {
    return arguments.length ? (!!n !== this.reversed() && this.timeScale(-this._rts || (n ? -st : 0)), this) : this._rts < 0;
  }, e.invalidate = function() {
    return this._initted = this._act = 0, this._zTime = -st, this;
  }, e.isActive = function() {
    var n = this.parent || this._dp, i = this._start, s;
    return !!(!n || this._ts && this._initted && n.isActive() && (s = n.rawTime(!0)) >= i && s < this.endTime(!0) - st);
  }, e.eventCallback = function(n, i, s) {
    var a = this.vars;
    return arguments.length > 1 ? (i ? (a[n] = i, s && (a[n + "Params"] = s), n === "onUpdate" && (this._onUpdate = i)) : delete a[n], this) : a[n];
  }, e.then = function(n) {
    var i = this, s = i._prom;
    return new Promise(function(a) {
      var o = gt(n) ? n : zc, c = function() {
        var u = i.then;
        i.then = null, s && s(), gt(o) && (o = o(i)) && (o.then || o === i) && (i.then = u), a(o), i.then = u;
      };
      i._initted && i.totalProgress() === 1 && i._ts >= 0 || !i._tTime && i._ts < 0 ? c() : i._prom = c;
    });
  }, e.kill = function() {
    br(this);
  }, r;
})();
hn(Vr.prototype, {
  _time: 0,
  _start: 0,
  _end: 0,
  _tTime: 0,
  _tDur: 0,
  _dirty: 0,
  _repeat: 0,
  _yoyo: !1,
  parent: null,
  _initted: !1,
  _rDelay: 0,
  _ts: 1,
  _dp: 0,
  ratio: 0,
  _zTime: -st,
  _prom: 0,
  _ps: !1,
  _rts: 1
});
var Yt = /* @__PURE__ */ (function(r) {
  wc(e, r);
  function e(n, i) {
    var s;
    return n === void 0 && (n = {}), s = r.call(this, n) || this, s.labels = {}, s.smoothChildTiming = !!n.smoothChildTiming, s.autoRemoveChildren = !!n.autoRemoveChildren, s._sort = $t(n.sortChildren), dt && wn(n.parent || dt, Bn(s), i), n.reversed && s.reverse(), n.paused && s.paused(!0), n.scrollTrigger && Vc(Bn(s), n.scrollTrigger), s;
  }
  var t = e.prototype;
  return t.to = function(i, s, a) {
    return Dr(0, arguments, this), this;
  }, t.from = function(i, s, a) {
    return Dr(1, arguments, this), this;
  }, t.fromTo = function(i, s, a, o) {
    return Dr(2, arguments, this), this;
  }, t.set = function(i, s, a) {
    return s.duration = 0, s.parent = this, Pr(s).repeatDelay || (s.repeat = 0), s.immediateRender = !!s.immediateRender, new Et(i, s, pn(this, a), 1), this;
  }, t.call = function(i, s, a) {
    return wn(this, Et.delayedCall(0, i, s), a);
  }, t.staggerTo = function(i, s, a, o, c, l, u) {
    return a.duration = s, a.stagger = a.stagger || o, a.onComplete = l, a.onCompleteParams = u, a.parent = this, new Et(i, a, pn(this, c)), this;
  }, t.staggerFrom = function(i, s, a, o, c, l, u) {
    return a.runBackwards = 1, Pr(a).immediateRender = $t(a.immediateRender), this.staggerTo(i, s, a, o, c, l, u);
  }, t.staggerFromTo = function(i, s, a, o, c, l, u, h) {
    return o.startAt = a, Pr(o).immediateRender = $t(o.immediateRender), this.staggerTo(i, s, o, c, l, u, h);
  }, t.render = function(i, s, a) {
    var o = this._time, c = this._dirty ? this.totalDuration() : this._tDur, l = this._dur, u = i <= 0 ? 0 : ft(i), h = this._zTime < 0 != i < 0 && (this._initted || !l), f, d, g, _, m, p, S, b, T, y, R, A;
    if (this !== dt && u > c && i >= 0 && (u = c), u !== this._tTime || a || h) {
      if (o !== this._time && l && (u += this._time - o, i += this._time - o), f = u, T = this._start, b = this._ts, p = !b, h && (l || (o = this._zTime), (i || !s) && (this._zTime = i)), this._repeat) {
        if (R = this._yoyo, m = l + this._rDelay, this._repeat < -1 && i < 0)
          return this.totalTime(m * 100 + i, s, a);
        if (f = ft(u % m), u === c ? (_ = this._repeat, f = l) : (y = ft(u / m), _ = ~~y, _ && _ === y && (f = l, _--), f > l && (f = l)), y = rr(this._tTime, m), !o && this._tTime && y !== _ && this._tTime - y * m - this._dur <= 0 && (y = _), R && _ & 1 && (f = l - f, A = 1), _ !== y && !this._lock) {
          var C = R && y & 1, x = C === (R && _ & 1);
          if (_ < y && (C = !C), o = C ? 0 : u % l ? l : u, this._lock = 1, this.render(o || (A ? 0 : ft(_ * m)), s, !l)._lock = 0, this._tTime = u, !s && this.parent && on(this, "onRepeat"), this.vars.repeatRefresh && !A && (this.invalidate()._lock = 1, y = _), o && o !== this._time || p !== !this._ts || this.vars.onRepeat && !this.parent && !this._act)
            return this;
          if (l = this._dur, c = this._tDur, x && (this._lock = 2, o = C ? l : -1e-4, this.render(o, !0), this.vars.repeatRefresh && !A && this.invalidate()), this._lock = 0, !this._ts && !p)
            return this;
        }
      }
      if (this._hasPause && !this._forcing && this._lock < 2 && (S = Q_(this, ft(o), ft(f)), S && (u -= f - (f = S._start))), this._tTime = u, this._time = f, this._act = !!b, this._initted || (this._onUpdate = this.vars.onUpdate, this._initted = 1, this._zTime = i, o = 0), !o && u && l && !s && !y && (on(this, "onStart"), this._tTime !== u))
        return this;
      if (f >= o && i >= 0)
        for (d = this._first; d; ) {
          if (g = d._next, (d._act || f >= d._start) && d._ts && S !== d) {
            if (d.parent !== this)
              return this.render(i, s, a);
            if (d.render(d._ts > 0 ? (f - d._start) * d._ts : (d._dirty ? d.totalDuration() : d._tDur) + (f - d._start) * d._ts, s, a), f !== this._time || !this._ts && !p) {
              S = 0, g && (u += this._zTime = -st);
              break;
            }
          }
          d = g;
        }
      else {
        d = this._last;
        for (var E = i < 0 ? i : f; d; ) {
          if (g = d._prev, (d._act || E <= d._end) && d._ts && S !== d) {
            if (d.parent !== this)
              return this.render(i, s, a);
            if (d.render(d._ts > 0 ? (E - d._start) * d._ts : (d._dirty ? d.totalDuration() : d._tDur) + (E - d._start) * d._ts, s, a || Ft && So(d)), f !== this._time || !this._ts && !p) {
              S = 0, g && (u += this._zTime = E ? -st : st);
              break;
            }
          }
          d = g;
        }
      }
      if (S && !s && (this.pause(), S.render(f >= o ? 0 : -st)._zTime = f >= o ? 1 : -1, this._ts))
        return this._start = T, $s(this), this.render(i, s, a);
      this._onUpdate && !s && on(this, "onUpdate", !0), (u === c && this._tTime >= this.totalDuration() || !u && o) && (T === this._start || Math.abs(b) !== Math.abs(this._ts)) && (this._lock || ((i || !l) && (u === c && this._ts > 0 || !u && this._ts < 0) && ri(this, 1), !s && !(i < 0 && !o) && (u || o || !c) && (on(this, u === c && i >= 0 ? "onComplete" : "onReverseComplete", !0), this._prom && !(u < c && this.timeScale() > 0) && this._prom())));
    }
    return this;
  }, t.add = function(i, s) {
    var a = this;
    if (Hn(s) || (s = pn(this, s, i)), !(i instanceof Vr)) {
      if (zt(i))
        return i.forEach(function(o) {
          return a.add(o, s);
        }), this;
      if (Dt(i))
        return this.addLabel(i, s);
      if (gt(i))
        i = Et.delayedCall(0, i);
      else
        return this;
    }
    return this !== i ? wn(this, i, s) : this;
  }, t.getChildren = function(i, s, a, o) {
    i === void 0 && (i = !0), s === void 0 && (s = !0), a === void 0 && (a = !0), o === void 0 && (o = -gn);
    for (var c = [], l = this._first; l; )
      l._start >= o && (l instanceof Et ? s && c.push(l) : (a && c.push(l), i && c.push.apply(c, l.getChildren(!0, s, a)))), l = l._next;
    return c;
  }, t.getById = function(i) {
    for (var s = this.getChildren(1, 1, 1), a = s.length; a--; )
      if (s[a].vars.id === i)
        return s[a];
  }, t.remove = function(i) {
    return Dt(i) ? this.removeLabel(i) : gt(i) ? this.killTweensOf(i) : (i.parent === this && Ys(this, i), i === this._recent && (this._recent = this._last), Ei(this));
  }, t.totalTime = function(i, s) {
    return arguments.length ? (this._forcing = 1, !this._dp && this._ts && (this._start = ft(an.time - (this._ts > 0 ? i / this._ts : (this.totalDuration() - i) / -this._ts))), r.prototype.totalTime.call(this, i, s), this._forcing = 0, this) : this._tTime;
  }, t.addLabel = function(i, s) {
    return this.labels[i] = pn(this, s), this;
  }, t.removeLabel = function(i) {
    return delete this.labels[i], this;
  }, t.addPause = function(i, s, a) {
    var o = Et.delayedCall(0, s || zr, a);
    return o.data = "isPause", this._hasPause = 1, wn(this, o, pn(this, i));
  }, t.removePause = function(i) {
    var s = this._first;
    for (i = pn(this, i); s; )
      s._start === i && s.data === "isPause" && ri(s), s = s._next;
  }, t.killTweensOf = function(i, s, a) {
    for (var o = this.getTweensOf(i, a), c = o.length; c--; )
      Qn !== o[c] && o[c].kill(i, s);
    return this;
  }, t.getTweensOf = function(i, s) {
    for (var a = [], o = vn(i), c = this._first, l = Hn(s), u; c; )
      c instanceof Et ? q_(c._targets, o) && (l ? (!Qn || c._initted && c._ts) && c.globalTime(0) <= s && c.globalTime(c.totalDuration()) > s : !s || c.isActive()) && a.push(c) : (u = c.getTweensOf(o, s)).length && a.push.apply(a, u), c = c._next;
    return a;
  }, t.tweenTo = function(i, s) {
    s = s || {};
    var a = this, o = pn(a, i), c = s, l = c.startAt, u = c.onStart, h = c.onStartParams, f = c.immediateRender, d, g = Et.to(a, hn({
      ease: s.ease || "none",
      lazy: !1,
      immediateRender: !1,
      time: o,
      overwrite: "auto",
      duration: s.duration || Math.abs((o - (l && "time" in l ? l.time : a._time)) / a.timeScale()) || st,
      onStart: function() {
        if (a.pause(), !d) {
          var m = s.duration || Math.abs((o - (l && "time" in l ? l.time : a._time)) / a.timeScale());
          g._dur !== m && sr(g, m, 0, 1).render(g._time, !0, !0), d = 1;
        }
        u && u.apply(g, h || []);
      }
    }, s));
    return f ? g.render(0) : g;
  }, t.tweenFromTo = function(i, s, a) {
    return this.tweenTo(s, hn({
      startAt: {
        time: pn(this, i)
      }
    }, a));
  }, t.recent = function() {
    return this._recent;
  }, t.nextLabel = function(i) {
    return i === void 0 && (i = this._time), kl(this, pn(this, i));
  }, t.previousLabel = function(i) {
    return i === void 0 && (i = this._time), kl(this, pn(this, i), 1);
  }, t.currentLabel = function(i) {
    return arguments.length ? this.seek(i, !0) : this.previousLabel(this._time + st);
  }, t.shiftChildren = function(i, s, a) {
    a === void 0 && (a = 0);
    var o = this._first, c = this.labels, l;
    for (i = ft(i); o; )
      o._start >= a && (o._start += i, o._end += i), o = o._next;
    if (s)
      for (l in c)
        c[l] >= a && (c[l] += i);
    return Ei(this);
  }, t.invalidate = function(i) {
    var s = this._first;
    for (this._lock = 0; s; )
      s.invalidate(i), s = s._next;
    return r.prototype.invalidate.call(this, i);
  }, t.clear = function(i) {
    i === void 0 && (i = !0);
    for (var s = this._first, a; s; )
      a = s._next, this.remove(s), s = a;
    return this._dp && (this._time = this._tTime = this._pTime = 0), i && (this.labels = {}), Ei(this);
  }, t.totalDuration = function(i) {
    var s = 0, a = this, o = a._last, c = gn, l, u, h;
    if (arguments.length)
      return a.timeScale((a._repeat < 0 ? a.duration() : a.totalDuration()) / (a.reversed() ? -i : i));
    if (a._dirty) {
      for (h = a.parent; o; )
        l = o._prev, o._dirty && o.totalDuration(), u = o._start, u > c && a._sort && o._ts && !a._lock ? (a._lock = 1, wn(a, o, u - o._delay, 1)._lock = 0) : c = u, u < 0 && o._ts && (s -= u, (!h && !a._dp || h && h.smoothChildTiming) && (a._start += ft(u / a._ts), a._time -= u, a._tTime -= u), a.shiftChildren(-u, !1, -1 / 0), c = 0), o._end > s && o._ts && (s = o._end), o = l;
      sr(a, a === dt && a._time > s ? a._time : s, 1, 1), a._dirty = 0;
    }
    return a._tDur;
  }, e.updateRoot = function(i) {
    if (dt._ts && (Oc(dt, Bs(i, dt)), Ic = an.frame), an.frame >= Ol) {
      Ol += cn.autoSleep || 120;
      var s = dt._first;
      if ((!s || !s._ts) && cn.autoSleep && an._listeners.length < 2) {
        for (; s && !s._ts; )
          s = s._next;
        s || an.sleep();
      }
    }
  }, e;
})(Vr);
hn(Yt.prototype, {
  _lock: 0,
  _hasPause: 0,
  _forcing: 0
});
var _g = function(e, t, n, i, s, a, o) {
  var c = new Zt(this._pt, e, t, 0, 1, cu, null, s), l = 0, u = 0, h, f, d, g, _, m, p, S;
  for (c.b = n, c.e = i, n += "", i += "", (p = ~i.indexOf("random(")) && (i = Gr(i)), a && (S = [n, i], a(S, e, t), n = S[0], i = S[1]), f = n.match(Fa) || []; h = Fa.exec(i); )
    g = h[0], _ = i.substring(l, h.index), d ? d = (d + 1) % 5 : _.substr(-5) === "rgba(" && (d = 1), g !== f[u++] && (m = parseFloat(f[u - 1]) || 0, c._pt = {
      _next: c._pt,
      p: _ || u === 1 ? _ : ",",
      //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
      s: m,
      c: g.charAt(1) === "=" ? Ji(m, g) - m : parseFloat(g) - m,
      m: d && d < 4 ? Math.round : 0
    }, l = Fa.lastIndex);
  return c.c = l < i.length ? i.substring(l, i.length) : "", c.fp = o, (Dc.test(i) || p) && (c.e = 0), this._pt = c, c;
}, Mo = function(e, t, n, i, s, a, o, c, l, u) {
  gt(i) && (i = i(s || 0, e, a));
  var h = e[t], f = n !== "get" ? n : gt(h) ? l ? e[t.indexOf("set") || !gt(e["get" + t.substr(3)]) ? t : "get" + t.substr(3)](l) : e[t]() : h, d = gt(h) ? l ? Mg : ou : Eo, g;
  if (Dt(i) && (~i.indexOf("random(") && (i = Gr(i)), i.charAt(1) === "=" && (g = Ji(f, i) + (Ot(f) || 0), (g || g === 0) && (i = g))), !u || f !== i || Qa)
    return !isNaN(f * i) && i !== "" ? (g = new Zt(this._pt, e, t, +f || 0, i - (f || 0), typeof h == "boolean" ? Eg : lu, 0, d), l && (g.fp = l), o && g.modifier(o, this, e), this._pt = g) : (!h && !(t in e) && _o(t, i), _g.call(this, e, t, f, i, d, c || cn.stringFilter, l));
}, gg = function(e, t, n, i, s) {
  if (gt(e) && (e = Lr(e, s, t, n, i)), !Dn(e) || e.style && e.nodeType || zt(e) || Cc(e))
    return Dt(e) ? Lr(e, s, t, n, i) : e;
  var a = {}, o;
  for (o in e)
    a[o] = Lr(e[o], s, t, n, i);
  return a;
}, ru = function(e, t, n, i, s, a) {
  var o, c, l, u;
  if (sn[e] && (o = new sn[e]()).init(s, o.rawVars ? t[e] : gg(t[e], i, s, a, n), n, i, a) !== !1 && (n._pt = c = new Zt(n._pt, s, e, 0, 1, o.render, o, 0, o.priority), n !== Zi))
    for (l = n._ptLookup[n._targets.indexOf(s)], u = o._props.length; u--; )
      l[o._props[u]] = c;
  return o;
}, Qn, Qa, yo = function r(e, t, n) {
  var i = e.vars, s = i.ease, a = i.startAt, o = i.immediateRender, c = i.lazy, l = i.onUpdate, u = i.runBackwards, h = i.yoyoEase, f = i.keyframes, d = i.autoRevert, g = e._dur, _ = e._startAt, m = e._targets, p = e.parent, S = p && p.data === "nested" ? p.vars.targets : m, b = e._overwrite === "auto" && !ho, T = e.timeline, y = i.easeReverse || h, R, A, C, x, E, P, z, N, W, H, k, O, Y;
  if (T && (!f || !s) && (s = "none"), e._ease = Ti(s, Or.ease), e._rEase = y && (Ti(y) || e._ease), e._from = !T && !!i.runBackwards, e._from && (e.ratio = 1), !T || f && !i.stagger) {
    if (N = m[0] ? yi(m[0]).harness : 0, O = N && i[N.prop], R = Os(i, go), _ && (_._zTime < 0 && _.progress(1), t < 0 && u && o && !d ? _.render(-1, !0) : _.revert(u && g ? ws : W_), _._lazy = 0), a) {
      if (ri(e._startAt = Et.set(m, hn({
        data: "isStart",
        overwrite: !1,
        parent: p,
        immediateRender: !0,
        lazy: !_ && $t(c),
        startAt: null,
        delay: 0,
        onUpdate: l && function() {
          return on(e, "onUpdate");
        },
        stagger: 0
      }, a))), e._startAt._dp = 0, e._startAt._sat = e, t < 0 && (Ft || !o && !d) && e._startAt.revert(ws), o && g && t <= 0 && n <= 0) {
        t && (e._zTime = t);
        return;
      }
    } else if (u && g && !_) {
      if (t && (o = !1), C = hn({
        overwrite: !1,
        data: "isFromStart",
        //we tag the tween with as "isFromStart" so that if [inside a plugin] we need to only do something at the very END of a tween, we have a way of identifying this tween as merely the one that's setting the beginning values for a "from()" tween. For example, clearProps in CSSPlugin should only get applied at the very END of a tween and without this tag, from(...{height:100, clearProps:"height", delay:1}) would wipe the height at the beginning of the tween and after 1 second, it'd kick back in.
        lazy: o && !_ && $t(c),
        immediateRender: o,
        //zero-duration tweens render immediately by default, but if we're not specifically instructed to render this tween immediately, we should skip this and merely _init() to record the starting values (rendering them immediately would push them to completion which is wasteful in that case - we'd have to render(-1) immediately after)
        stagger: 0,
        parent: p
        //ensures that nested tweens that had a stagger are handled properly, like gsap.from(".class", {y: gsap.utils.wrap([-100,100]), stagger: 0.5})
      }, R), O && (C[N.prop] = O), ri(e._startAt = Et.set(m, C)), e._startAt._dp = 0, e._startAt._sat = e, t < 0 && (Ft ? e._startAt.revert(ws) : e._startAt.render(-1, !0)), e._zTime = t, !o)
        r(e._startAt, st, st);
      else if (!t)
        return;
    }
    for (e._pt = e._ptCache = 0, c = g && $t(c) || c && !g, A = 0; A < m.length; A++) {
      if (E = m[A], z = E._gsap || xo(m)[A]._gsap, e._ptLookup[A] = H = {}, Ya[z.id] && ni.length && Ns(), k = S === m ? A : S.indexOf(E), N && (W = new N()).init(E, O || R, e, k, S) !== !1 && (e._pt = x = new Zt(e._pt, E, W.name, 0, 1, W.render, W, 0, W.priority), W._props.forEach(function(ae) {
        H[ae] = x;
      }), W.priority && (P = 1)), !N || O)
        for (C in R)
          sn[C] && (W = ru(C, R, e, k, E, S)) ? W.priority && (P = 1) : H[C] = x = Mo.call(e, E, C, "get", R[C], k, S, 0, i.stringFilter);
      e._op && e._op[A] && e.kill(E, e._op[A]), b && e._pt && (Qn = e, dt.killTweensOf(E, H, e.globalTime(t)), Y = !e.parent, Qn = 0), e._pt && c && (Ya[z.id] = 1);
    }
    P && uu(e), e._onInit && e._onInit(e);
  }
  e._onUpdate = l, e._initted = (!e._op || e._pt) && !Y, f && t <= 0 && T.render(gn, !0, !0);
}, vg = function(e, t, n, i, s, a, o, c) {
  var l = (e._pt && e._ptCache || (e._ptCache = {}))[t], u, h, f, d;
  if (!l)
    for (l = e._ptCache[t] = [], f = e._ptLookup, d = e._targets.length; d--; ) {
      if (u = f[d][t], u && u.d && u.d._pt)
        for (u = u.d._pt; u && u.p !== t && u.fp !== t; )
          u = u._next;
      if (!u)
        return Qa = 1, e.vars[t] = "+=0", yo(e, o), Qa = 0, c ? Br(t + " not eligible for reset. Try splitting into individual properties") : 1;
      l.push(u);
    }
  for (d = l.length; d--; )
    h = l[d], u = h._pt || h, u.s = (i || i === 0) && !s ? i : u.s + (i || 0) + a * u.c, u.c = n - u.s, h.e && (h.e = vt(n) + Ot(h.e)), h.b && (h.b = u.s + Ot(h.b));
}, xg = function(e, t) {
  var n = e[0] ? yi(e[0]).harness : 0, i = n && n.aliases, s, a, o, c;
  if (!i)
    return t;
  s = ir({}, t);
  for (a in i)
    if (a in s)
      for (c = i[a].split(","), o = c.length; o--; )
        s[c[o]] = s[a];
  return s;
}, Sg = function(e, t, n, i) {
  var s = t.ease || i || "power1.inOut", a, o;
  if (zt(t))
    o = n[e] || (n[e] = []), t.forEach(function(c, l) {
      return o.push({
        t: l / (t.length - 1) * 100,
        v: c,
        e: s
      });
    });
  else
    for (a in t)
      o = n[a] || (n[a] = []), a === "ease" || o.push({
        t: parseFloat(e),
        v: t[a],
        e: s
      });
}, Lr = function(e, t, n, i, s) {
  return gt(e) ? e.call(t, n, i, s) : Dt(e) && ~e.indexOf("random(") ? Gr(e) : e;
}, su = vo + "repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase,easeReverse,autoRevert", au = {};
Kt(su + ",id,stagger,delay,duration,paused,scrollTrigger", function(r) {
  return au[r] = 1;
});
var Et = /* @__PURE__ */ (function(r) {
  wc(e, r);
  function e(n, i, s, a) {
    var o;
    typeof i == "number" && (s.duration = i, i = s, s = null), o = r.call(this, a ? i : Pr(i)) || this;
    var c = o.vars, l = c.duration, u = c.delay, h = c.immediateRender, f = c.stagger, d = c.overwrite, g = c.keyframes, _ = c.defaults, m = c.scrollTrigger, p = i.parent || dt, S = (zt(n) || Cc(n) ? Hn(n[0]) : "length" in i) ? [n] : vn(n), b, T, y, R, A, C, x, E;
    if (o._targets = S.length ? xo(S) : Br("GSAP target " + n + " not found. https://gsap.com", !cn.nullTargetWarn) || [], o._ptLookup = [], o._overwrite = d, g || f || Ts(l) || Ts(u)) {
      i = o.vars;
      var P = i.easeReverse || i.yoyoEase;
      if (b = o.timeline = new Yt({
        data: "nested",
        defaults: _ || {},
        targets: p && p.data === "nested" ? p.vars.targets : S
      }), b.kill(), b.parent = b._dp = Bn(o), b._start = 0, f || Ts(l) || Ts(u)) {
        if (R = S.length, x = f && qc(f), Dn(f))
          for (A in f)
            ~su.indexOf(A) && (E || (E = {}), E[A] = f[A]);
        for (T = 0; T < R; T++)
          y = Os(i, au), y.stagger = 0, P && (y.easeReverse = P), E && ir(y, E), C = S[T], y.duration = +Lr(l, Bn(o), T, C, S), y.delay = (+Lr(u, Bn(o), T, C, S) || 0) - o._delay, !f && R === 1 && y.delay && (o._delay = u = y.delay, o._start += u, y.delay = 0), b.to(C, y, x ? x(T, C, S) : 0), b._ease = ke.none;
        b.duration() ? l = u = 0 : o.timeline = 0;
      } else if (g) {
        Pr(hn(b.vars.defaults, {
          ease: "none"
        })), b._ease = Ti(g.ease || i.ease || "none");
        var z = 0, N, W, H;
        if (zt(g))
          g.forEach(function(k) {
            return b.to(S, k, ">");
          }), b.duration();
        else {
          y = {};
          for (A in g)
            A === "ease" || A === "easeEach" || Sg(A, g[A], y, g.easeEach);
          for (A in y)
            for (N = y[A].sort(function(k, O) {
              return k.t - O.t;
            }), z = 0, T = 0; T < N.length; T++)
              W = N[T], H = {
                ease: W.e,
                duration: (W.t - (T ? N[T - 1].t : 0)) / 100 * l
              }, H[A] = W.v, b.to(S, H, z), z += H.duration;
          b.duration() < l && b.to({}, {
            duration: l - b.duration()
          });
        }
      }
      l || o.duration(l = b.duration());
    } else
      o.timeline = 0;
    return d === !0 && !ho && (Qn = Bn(o), dt.killTweensOf(S), Qn = 0), wn(p, Bn(o), s), i.reversed && o.reverse(), i.paused && o.paused(!0), (h || !l && !g && o._start === ft(p._time) && $t(h) && Z_(Bn(o)) && p.data !== "nested") && (o._tTime = -st, o.render(Math.max(0, -u) || 0)), m && Vc(Bn(o), m), o;
  }
  var t = e.prototype;
  return t.render = function(i, s, a) {
    var o = this._time, c = this._tDur, l = this._dur, u = i < 0, h = i > c - st && !u ? c : i < st ? 0 : i, f, d, g, _, m, p, S, b;
    if (!l)
      J_(this, i, s, a);
    else if (h !== this._tTime || !i || a || !this._initted && this._tTime || this._startAt && this._zTime < 0 !== u || this._lazy) {
      if (f = h, b = this.timeline, this._repeat) {
        if (_ = l + this._rDelay, this._repeat < -1 && u)
          return this.totalTime(_ * 100 + i, s, a);
        if (f = ft(h % _), h === c ? (g = this._repeat, f = l) : (m = ft(h / _), g = ~~m, g && g === m ? (f = l, g--) : f > l && (f = l)), p = this._yoyo && g & 1, p && (f = l - f), m = rr(this._tTime, _), f === o && !a && this._initted && g === m)
          return this._tTime = h, this;
        g !== m && this.vars.repeatRefresh && !p && !this._lock && f !== _ && this._initted && (this._lock = a = 1, this.render(ft(_ * g), !0).invalidate()._lock = 0);
      }
      if (!this._initted) {
        if (Hc(this, u ? i : f, a, s, h))
          return this._tTime = 0, this;
        if (o !== this._time && !(a && this.vars.repeatRefresh && g !== m))
          return this;
        if (l !== this._dur)
          return this.render(i, s, a);
      }
      if (this._rEase) {
        var T = f < o;
        if (T !== this._inv) {
          var y = T ? o : l - o;
          this._inv = T, this._from && (this.ratio = 1 - this.ratio), this._invRatio = this.ratio, this._invTime = o, this._invRecip = y ? (T ? -1 : 1) / y : 0, this._invScale = T ? -this.ratio : 1 - this.ratio, this._invEase = T ? this._rEase : this._ease;
        }
        this.ratio = S = this._invRatio + this._invScale * this._invEase((f - this._invTime) * this._invRecip);
      } else
        this.ratio = S = this._ease(f / l);
      if (this._from && (this.ratio = S = 1 - S), this._tTime = h, this._time = f, !this._act && this._ts && (this._act = 1, this._lazy = 0), !o && h && !s && !m && (on(this, "onStart"), this._tTime !== h))
        return this;
      for (d = this._pt; d; )
        d.r(S, d.d), d = d._next;
      b && b.render(i < 0 ? i : b._dur * b._ease(f / this._dur), s, a) || this._startAt && (this._zTime = i), this._onUpdate && !s && (u && $a(this, i, s, a), on(this, "onUpdate")), this._repeat && g !== m && this.vars.onRepeat && !s && this.parent && on(this, "onRepeat"), (h === this._tDur || !h) && this._tTime === h && (u && !this._onUpdate && $a(this, i, !0, !0), (i || !l) && (h === this._tDur && this._ts > 0 || !h && this._ts < 0) && ri(this, 1), !s && !(u && !o) && (h || o || p) && (on(this, h === c ? "onComplete" : "onReverseComplete", !0), this._prom && !(h < c && this.timeScale() > 0) && this._prom()));
    }
    return this;
  }, t.targets = function() {
    return this._targets;
  }, t.invalidate = function(i) {
    return (!i || !this.vars.runBackwards) && (this._startAt = 0), this._pt = this._op = this._onUpdate = this._lazy = this.ratio = 0, this._ptLookup = [], this.timeline && this.timeline.invalidate(i), r.prototype.invalidate.call(this, i);
  }, t.resetTo = function(i, s, a, o, c) {
    kr || an.wake(), this._ts || this.play();
    var l = Math.min(this._dur, (this._dp._time - this._start) * this._ts), u;
    return this._initted || yo(this, l), u = this._ease(l / this._dur), vg(this, i, s, a, o, u, l, c) ? this.resetTo(i, s, a, o, 1) : (Ks(this, 0), this.parent || Gc(this._dp, this, "_first", "_last", this._dp._sort ? "_start" : 0), this.render(0));
  }, t.kill = function(i, s) {
    if (s === void 0 && (s = "all"), !i && (!s || s === "all"))
      return this._lazy = this._pt = 0, this.parent ? br(this) : this.scrollTrigger && this.scrollTrigger.kill(!!Ft), this;
    if (this.timeline) {
      var a = this.timeline.totalDuration();
      return this.timeline.killTweensOf(i, s, Qn && Qn.vars.overwrite !== !0)._first || br(this), this.parent && a !== this.timeline.totalDuration() && sr(this, this._dur * this.timeline._tDur / a, 0, 1), this;
    }
    var o = this._targets, c = i ? vn(i) : o, l = this._ptLookup, u = this._pt, h, f, d, g, _, m, p;
    if ((!s || s === "all") && $_(o, c))
      return s === "all" && (this._pt = 0), br(this);
    for (h = this._op = this._op || [], s !== "all" && (Dt(s) && (_ = {}, Kt(s, function(S) {
      return _[S] = 1;
    }), s = _), s = xg(o, s)), p = o.length; p--; )
      if (~c.indexOf(o[p])) {
        f = l[p], s === "all" ? (h[p] = s, g = f, d = {}) : (d = h[p] = h[p] || {}, g = s);
        for (_ in g)
          m = f && f[_], m && ((!("kill" in m.d) || m.d.kill(_) === !0) && Ys(this, m, "_pt"), delete f[_]), d !== "all" && (d[_] = 1);
      }
    return this._initted && !this._pt && u && br(this), this;
  }, e.to = function(i, s) {
    return new e(i, s, arguments[2]);
  }, e.from = function(i, s) {
    return Dr(1, arguments);
  }, e.delayedCall = function(i, s, a, o) {
    return new e(s, 0, {
      immediateRender: !1,
      lazy: !1,
      overwrite: !1,
      delay: i,
      onComplete: s,
      onReverseComplete: s,
      onCompleteParams: a,
      onReverseCompleteParams: a,
      callbackScope: o
    });
  }, e.fromTo = function(i, s, a) {
    return Dr(2, arguments);
  }, e.set = function(i, s) {
    return s.duration = 0, s.repeatDelay || (s.repeat = 0), new e(i, s);
  }, e.killTweensOf = function(i, s, a) {
    return dt.killTweensOf(i, s, a);
  }, e;
})(Vr);
hn(Et.prototype, {
  _targets: [],
  _lazy: 0,
  _startAt: 0,
  _op: 0,
  _onInit: 0
});
Kt("staggerTo,staggerFrom,staggerFromTo", function(r) {
  Et[r] = function() {
    var e = new Yt(), t = Za.call(arguments, 0);
    return t.splice(r === "staggerFromTo" ? 5 : 4, 0, 0), e[r].apply(e, t);
  };
});
var Eo = function(e, t, n) {
  return e[t] = n;
}, ou = function(e, t, n) {
  return e[t](n);
}, Mg = function(e, t, n, i) {
  return e[t](i.fp, n);
}, yg = function(e, t, n) {
  return e.setAttribute(t, n);
}, To = function(e, t) {
  return gt(e[t]) ? ou : fo(e[t]) && e.setAttribute ? yg : Eo;
}, lu = function(e, t) {
  return t.set(t.t, t.p, Math.round((t.s + t.c * e) * 1e6) / 1e6, t);
}, Eg = function(e, t) {
  return t.set(t.t, t.p, !!(t.s + t.c * e), t);
}, cu = function(e, t) {
  var n = t._pt, i = "";
  if (!e && t.b)
    i = t.b;
  else if (e === 1 && t.e)
    i = t.e;
  else {
    for (; n; )
      i = n.p + (n.m ? n.m(n.s + n.c * e) : Math.round((n.s + n.c * e) * 1e4) / 1e4) + i, n = n._next;
    i += t.c;
  }
  t.set(t.t, t.p, i, t);
}, bo = function(e, t) {
  for (var n = t._pt; n; )
    n.r(e, n.d), n = n._next;
}, Tg = function(e, t, n, i) {
  for (var s = this._pt, a; s; )
    a = s._next, s.p === i && s.modifier(e, t, n), s = a;
}, bg = function(e) {
  for (var t = this._pt, n, i; t; )
    i = t._next, t.p === e && !t.op || t.op === e ? Ys(this, t, "_pt") : t.dep || (n = 1), t = i;
  return !n;
}, Ag = function(e, t, n, i) {
  i.mSet(e, t, i.m.call(i.tween, n, i.mt), i);
}, uu = function(e) {
  for (var t = e._pt, n, i, s, a; t; ) {
    for (n = t._next, i = s; i && i.pr > t.pr; )
      i = i._next;
    (t._prev = i ? i._prev : a) ? t._prev._next = t : s = t, (t._next = i) ? i._prev = t : a = t, t = n;
  }
  e._pt = s;
}, Zt = /* @__PURE__ */ (function() {
  function r(t, n, i, s, a, o, c, l, u) {
    this.t = n, this.s = s, this.c = a, this.p = i, this.r = o || lu, this.d = c || this, this.set = l || Eo, this.pr = u || 0, this._next = t, t && (t._prev = this);
  }
  var e = r.prototype;
  return e.modifier = function(n, i, s) {
    this.mSet = this.mSet || this.set, this.set = Ag, this.m = n, this.mt = s, this.tween = i;
  }, r;
})();
Kt(vo + "parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger,easeReverse", function(r) {
  return go[r] = 1;
});
un.TweenMax = un.TweenLite = Et;
un.TimelineLite = un.TimelineMax = Yt;
dt = new Yt({
  sortChildren: !1,
  defaults: Or,
  autoRemoveChildren: !0,
  id: "root",
  smoothChildTiming: !0
});
cn.stringFilter = tu;
var bi = [], Cs = {}, wg = [], Hl = 0, Rg = 0, Ba = function(e) {
  return (Cs[e] || wg).map(function(t) {
    return t();
  });
}, eo = function() {
  var e = Date.now(), t = [];
  e - Hl > 2 && (Ba("matchMediaInit"), bi.forEach(function(n) {
    var i = n.queries, s = n.conditions, a, o, c, l;
    for (o in i)
      a = bn.matchMedia(i[o]).matches, a && (c = 1), a !== s[o] && (s[o] = a, l = 1);
    l && (n.revert(), c && t.push(n));
  }), Ba("matchMediaRevert"), t.forEach(function(n) {
    return n.onMatch(n, function(i) {
      return n.add(null, i);
    });
  }), Hl = e, Ba("matchMedia"));
}, hu = /* @__PURE__ */ (function() {
  function r(t, n) {
    this.selector = n && ja(n), this.data = [], this._r = [], this.isReverted = !1, this.id = Rg++, t && this.add(t);
  }
  var e = r.prototype;
  return e.add = function(n, i, s) {
    gt(n) && (s = i, i = n, n = gt);
    var a = this, o = function() {
      var l = ut, u = a.selector, h;
      return l && l !== a && l.data.push(a), s && (a.selector = ja(s)), ut = a, h = i.apply(a, arguments), gt(h) && a._r.push(h), ut = l, a.selector = u, a.isReverted = !1, h;
    };
    return a.last = o, n === gt ? o(a, function(c) {
      return a.add(null, c);
    }) : n ? a[n] = o : o;
  }, e.ignore = function(n) {
    var i = ut;
    ut = null, n(this), ut = i;
  }, e.getTweens = function() {
    var n = [];
    return this.data.forEach(function(i) {
      return i instanceof r ? n.push.apply(n, i.getTweens()) : i instanceof Et && !(i.parent && i.parent.data === "nested") && n.push(i);
    }), n;
  }, e.clear = function() {
    this._r.length = this.data.length = 0;
  }, e.kill = function(n, i) {
    var s = this;
    if (n ? (function() {
      for (var o = s.getTweens(), c = s.data.length, l; c--; )
        l = s.data[c], l.data === "isFlip" && (l.revert(), l.getChildren(!0, !0, !1).forEach(function(u) {
          return o.splice(o.indexOf(u), 1);
        }));
      for (o.map(function(u) {
        return {
          g: u._dur || u._delay || u._sat && !u._sat.vars.immediateRender ? u.globalTime(0) : -1 / 0,
          t: u
        };
      }).sort(function(u, h) {
        return h.g - u.g || -1 / 0;
      }).forEach(function(u) {
        return u.t.revert(n);
      }), c = s.data.length; c--; )
        l = s.data[c], l instanceof Yt ? l.data !== "nested" && (l.scrollTrigger && l.scrollTrigger.revert(), l.kill()) : !(l instanceof Et) && l.revert && l.revert(n);
      s._r.forEach(function(u) {
        return u(n, s);
      }), s.isReverted = !0;
    })() : this.data.forEach(function(o) {
      return o.kill && o.kill();
    }), this.clear(), i)
      for (var a = bi.length; a--; )
        bi[a].id === this.id && bi.splice(a, 1);
  }, e.revert = function(n) {
    this.kill(n || {});
  }, r;
})(), Cg = /* @__PURE__ */ (function() {
  function r(t) {
    this.contexts = [], this.scope = t, ut && ut.data.push(this);
  }
  var e = r.prototype;
  return e.add = function(n, i, s) {
    Dn(n) || (n = {
      matches: n
    });
    var a = new hu(0, s || this.scope), o = a.conditions = {}, c, l, u;
    ut && !a.selector && (a.selector = ut.selector), this.contexts.push(a), i = a.add("onMatch", i), a.queries = n;
    for (l in n)
      l === "all" ? u = 1 : (c = bn.matchMedia(n[l]), c && (bi.indexOf(a) < 0 && bi.push(a), (o[l] = c.matches) && (u = 1), c.addListener ? c.addListener(eo) : c.addEventListener("change", eo)));
    return u && i(a, function(h) {
      return a.add(null, h);
    }), this;
  }, e.revert = function(n) {
    this.kill(n || {});
  }, e.kill = function(n) {
    this.contexts.forEach(function(i) {
      return i.kill(n, !0);
    });
  }, r;
})(), zs = {
  registerPlugin: function() {
    for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
      t[n] = arguments[n];
    t.forEach(function(i) {
      return Jc(i);
    });
  },
  timeline: function(e) {
    return new Yt(e);
  },
  getTweensOf: function(e, t) {
    return dt.getTweensOf(e, t);
  },
  getProperty: function(e, t, n, i) {
    Dt(e) && (e = vn(e)[0]);
    var s = yi(e || {}).get, a = n ? zc : Bc;
    return n === "native" && (n = ""), e && (t ? a((sn[t] && sn[t].get || s)(e, t, n, i)) : function(o, c, l) {
      return a((sn[o] && sn[o].get || s)(e, o, c, l));
    });
  },
  quickSetter: function(e, t, n) {
    if (e = vn(e), e.length > 1) {
      var i = e.map(function(u) {
        return Jt.quickSetter(u, t, n);
      }), s = i.length;
      return function(u) {
        for (var h = s; h--; )
          i[h](u);
      };
    }
    e = e[0] || {};
    var a = sn[t], o = yi(e), c = o.harness && (o.harness.aliases || {})[t] || t, l = a ? function(u) {
      var h = new a();
      Zi._pt = 0, h.init(e, n ? u + n : u, Zi, 0, [e]), h.render(1, h), Zi._pt && bo(1, Zi);
    } : o.set(e, c);
    return a ? l : function(u) {
      return l(e, c, n ? u + n : u, o, 1);
    };
  },
  quickTo: function(e, t, n) {
    var i, s = Jt.to(e, hn((i = {}, i[t] = "+=0.1", i.paused = !0, i.stagger = 0, i), n || {})), a = function(c, l, u) {
      return s.resetTo(t, c, l, u);
    };
    return a.tween = s, a;
  },
  isTweening: function(e) {
    return dt.getTweensOf(e, !0).length > 0;
  },
  defaults: function(e) {
    return e && e.ease && (e.ease = Ti(e.ease, Or.ease)), Bl(Or, e || {});
  },
  config: function(e) {
    return Bl(cn, e || {});
  },
  registerEffect: function(e) {
    var t = e.name, n = e.effect, i = e.plugins, s = e.defaults, a = e.extendTimeline;
    (i || "").split(",").forEach(function(o) {
      return o && !sn[o] && !un[o] && Br(t + " effect requires " + o + " plugin.");
    }), Ua[t] = function(o, c, l) {
      return n(vn(o), hn(c || {}, s), l);
    }, a && (Yt.prototype[t] = function(o, c, l) {
      return this.add(Ua[t](o, Dn(c) ? c : (l = c) && {}, this), l);
    });
  },
  registerEase: function(e, t) {
    ke[e] = Ti(t);
  },
  parseEase: function(e, t) {
    return arguments.length ? Ti(e, t) : ke;
  },
  getById: function(e) {
    return dt.getById(e);
  },
  exportRoot: function(e, t) {
    e === void 0 && (e = {});
    var n = new Yt(e), i, s;
    for (n.smoothChildTiming = $t(e.smoothChildTiming), dt.remove(n), n._dp = 0, n._time = n._tTime = dt._time, i = dt._first; i; )
      s = i._next, (t || !(!i._dur && i instanceof Et && i.vars.onComplete === i._targets[0])) && wn(n, i, i._start - i._delay), i = s;
    return wn(dt, n, 0), n;
  },
  context: function(e, t) {
    return e ? new hu(e, t) : ut;
  },
  matchMedia: function(e) {
    return new Cg(e);
  },
  matchMediaRefresh: function() {
    return bi.forEach(function(e) {
      var t = e.conditions, n, i;
      for (i in t)
        t[i] && (t[i] = !1, n = 1);
      n && e.revert();
    }) || eo();
  },
  addEventListener: function(e, t) {
    var n = Cs[e] || (Cs[e] = []);
    ~n.indexOf(t) || n.push(t);
  },
  removeEventListener: function(e, t) {
    var n = Cs[e], i = n && n.indexOf(t);
    i >= 0 && n.splice(i, 1);
  },
  utils: {
    wrap: ag,
    wrapYoyo: og,
    distribute: qc,
    random: $c,
    snap: Yc,
    normalize: sg,
    getUnit: Ot,
    clamp: tg,
    splitColor: Qc,
    toArray: vn,
    selector: ja,
    mapRange: Zc,
    pipe: ig,
    unitize: rg,
    interpolate: lg,
    shuffle: Xc
  },
  install: Fc,
  effects: Ua,
  ticker: an,
  updateRoot: Yt.updateRoot,
  plugins: sn,
  globalTimeline: dt,
  core: {
    PropTween: Zt,
    globals: Uc,
    Tween: Et,
    Timeline: Yt,
    Animation: Vr,
    getCache: yi,
    _removeLinkedListItem: Ys,
    reverting: function() {
      return Ft;
    },
    context: function(e) {
      return e && ut && (ut.data.push(e), e._ctx = ut), ut;
    },
    suppressOverwrites: function(e) {
      return ho = e;
    }
  }
};
Kt("to,from,fromTo,delayedCall,set,killTweensOf", function(r) {
  return zs[r] = Et[r];
});
an.add(Yt.updateRoot);
Zi = zs.to({}, {
  duration: 0
});
var Pg = function(e, t) {
  for (var n = e._pt; n && n.p !== t && n.op !== t && n.fp !== t; )
    n = n._next;
  return n;
}, Dg = function(e, t) {
  var n = e._targets, i, s, a;
  for (i in t)
    for (s = n.length; s--; )
      a = e._ptLookup[s][i], a && (a = a.d) && (a._pt && (a = Pg(a, i)), a && a.modifier && a.modifier(t[i], e, n[s], i));
}, za = function(e, t) {
  return {
    name: e,
    headless: 1,
    rawVars: 1,
    //don't pre-process function-based values or "random()" strings.
    init: function(i, s, a) {
      a._onInit = function(o) {
        var c, l;
        if (Dt(s) && (c = {}, Kt(s, function(u) {
          return c[u] = 1;
        }), s = c), t) {
          c = {};
          for (l in s)
            c[l] = t(s[l]);
          s = c;
        }
        Dg(o, s);
      };
    }
  };
}, Jt = zs.registerPlugin({
  name: "attr",
  init: function(e, t, n, i, s) {
    var a, o, c;
    this.tween = n;
    for (a in t)
      c = e.getAttribute(a) || "", o = this.add(e, "setAttribute", (c || 0) + "", t[a], i, s, 0, 0, a), o.op = a, o.b = c, this._props.push(a);
  },
  render: function(e, t) {
    for (var n = t._pt; n; )
      Ft ? n.set(n.t, n.p, n.b, n) : n.r(e, n.d), n = n._next;
  }
}, {
  name: "endArray",
  headless: 1,
  init: function(e, t) {
    for (var n = t.length; n--; )
      this.add(e, n, e[n] || 0, t[n], 0, 0, 0, 0, 0, 1);
  }
}, za("roundProps", Ja), za("modifiers"), za("snap", Yc)) || zs;
Et.version = Yt.version = Jt.version = "3.15.0";
Lc = 1;
po() && ar();
ke.Power0;
ke.Power1;
ke.Power2;
ke.Power3;
ke.Power4;
ke.Linear;
ke.Quad;
ke.Cubic;
ke.Quart;
ke.Quint;
ke.Strong;
ke.Elastic;
ke.Back;
ke.SteppedEase;
ke.Bounce;
ke.Sine;
ke.Expo;
ke.Circ;
var Wl, ei, Qi, Ao, Mi, Xl, wo, Lg = function() {
  return typeof window < "u";
}, Wn = {}, xi = 180 / Math.PI, er = Math.PI / 180, Yi = Math.atan2, ql = 1e8, Ro = /([A-Z])/g, Fg = /(left|right|width|margin|padding|x)/i, Ug = /[\s,\(]\S/, Rn = {
  autoAlpha: "opacity,visibility",
  scale: "scaleX,scaleY",
  alpha: "opacity"
}, to = function(e, t) {
  return t.set(t.t, t.p, Math.round((t.s + t.c * e) * 1e4) / 1e4 + t.u, t);
}, Ig = function(e, t) {
  return t.set(t.t, t.p, e === 1 ? t.e : Math.round((t.s + t.c * e) * 1e4) / 1e4 + t.u, t);
}, Ng = function(e, t) {
  return t.set(t.t, t.p, e ? Math.round((t.s + t.c * e) * 1e4) / 1e4 + t.u : t.b, t);
}, Og = function(e, t) {
  return t.set(t.t, t.p, e === 1 ? t.e : e ? Math.round((t.s + t.c * e) * 1e4) / 1e4 + t.u : t.b, t);
}, Bg = function(e, t) {
  var n = t.s + t.c * e;
  t.set(t.t, t.p, ~~(n + (n < 0 ? -0.5 : 0.5)) + t.u, t);
}, fu = function(e, t) {
  return t.set(t.t, t.p, e ? t.e : t.b, t);
}, du = function(e, t) {
  return t.set(t.t, t.p, e !== 1 ? t.b : t.e, t);
}, zg = function(e, t, n) {
  return e.style[t] = n;
}, Gg = function(e, t, n) {
  return e.style.setProperty(t, n);
}, kg = function(e, t, n) {
  return e._gsap[t] = n;
}, Vg = function(e, t, n) {
  return e._gsap.scaleX = e._gsap.scaleY = n;
}, Hg = function(e, t, n, i, s) {
  var a = e._gsap;
  a.scaleX = a.scaleY = n, a.renderTransform(s, a);
}, Wg = function(e, t, n, i, s) {
  var a = e._gsap;
  a[t] = n, a.renderTransform(s, a);
}, pt = "transform", jt = pt + "Origin", Xg = function r(e, t) {
  var n = this, i = this.target, s = i.style, a = i._gsap;
  if (e in Wn && s) {
    if (this.tfm = this.tfm || {}, e !== "transform")
      e = Rn[e] || e, ~e.indexOf(",") ? e.split(",").forEach(function(o) {
        return n.tfm[o] = zn(i, o);
      }) : this.tfm[e] = a.x ? a[e] : zn(i, e), e === jt && (this.tfm.zOrigin = a.zOrigin);
    else
      return Rn.transform.split(",").forEach(function(o) {
        return r.call(n, o, t);
      });
    if (this.props.indexOf(pt) >= 0)
      return;
    a.svg && (this.svgo = i.getAttribute("data-svg-origin"), this.props.push(jt, t, "")), e = pt;
  }
  (s || t) && this.props.push(e, t, s[e]);
}, pu = function(e) {
  e.translate && (e.removeProperty("translate"), e.removeProperty("scale"), e.removeProperty("rotate"));
}, qg = function() {
  var e = this.props, t = this.target, n = t.style, i = t._gsap, s, a;
  for (s = 0; s < e.length; s += 3)
    e[s + 1] ? e[s + 1] === 2 ? t[e[s]](e[s + 2]) : t[e[s]] = e[s + 2] : e[s + 2] ? n[e[s]] = e[s + 2] : n.removeProperty(e[s].substr(0, 2) === "--" ? e[s] : e[s].replace(Ro, "-$1").toLowerCase());
  if (this.tfm) {
    for (a in this.tfm)
      i[a] = this.tfm[a];
    i.svg && (i.renderTransform(), t.setAttribute("data-svg-origin", this.svgo || "")), s = wo(), (!s || !s.isStart) && !n[pt] && (pu(n), i.zOrigin && n[jt] && (n[jt] += " " + i.zOrigin + "px", i.zOrigin = 0, i.renderTransform()), i.uncache = 1);
  }
}, mu = function(e, t) {
  var n = {
    target: e,
    props: [],
    revert: qg,
    save: Xg
  };
  return e._gsap || Jt.core.getCache(e), t && e.style && e.nodeType && t.split(",").forEach(function(i) {
    return n.save(i);
  }), n;
}, _u, no = function(e, t) {
  var n = ei.createElementNS ? ei.createElementNS((t || "http://www.w3.org/1999/xhtml").replace(/^https/, "http"), e) : ei.createElement(e);
  return n && n.style ? n : ei.createElement(e);
}, ln = function r(e, t, n) {
  var i = getComputedStyle(e);
  return i[t] || i.getPropertyValue(t.replace(Ro, "-$1").toLowerCase()) || i.getPropertyValue(t) || !n && r(e, or(t) || t, 1) || "";
}, Yl = "O,Moz,ms,Ms,Webkit".split(","), or = function(e, t, n) {
  var i = t || Mi, s = i.style, a = 5;
  if (e in s && !n)
    return e;
  for (e = e.charAt(0).toUpperCase() + e.substr(1); a-- && !(Yl[a] + e in s); )
    ;
  return a < 0 ? null : (a === 3 ? "ms" : a >= 0 ? Yl[a] : "") + e;
}, io = function() {
  Lg() && window.document && (Wl = window, ei = Wl.document, Qi = ei.documentElement, Mi = no("div") || {
    style: {}
  }, no("div"), pt = or(pt), jt = pt + "Origin", Mi.style.cssText = "border-width:0;line-height:0;position:absolute;padding:0", _u = !!or("perspective"), wo = Jt.core.reverting, Ao = 1);
}, $l = function(e) {
  var t = e.ownerSVGElement, n = no("svg", t && t.getAttribute("xmlns") || "http://www.w3.org/2000/svg"), i = e.cloneNode(!0), s;
  i.style.display = "block", n.appendChild(i), Qi.appendChild(n);
  try {
    s = i.getBBox();
  } catch {
  }
  return n.removeChild(i), Qi.removeChild(n), s;
}, Kl = function(e, t) {
  for (var n = t.length; n--; )
    if (e.hasAttribute(t[n]))
      return e.getAttribute(t[n]);
}, gu = function(e) {
  var t, n;
  try {
    t = e.getBBox();
  } catch {
    t = $l(e), n = 1;
  }
  return t && (t.width || t.height) || n || (t = $l(e)), t && !t.width && !t.x && !t.y ? {
    x: +Kl(e, ["x", "cx", "x1"]) || 0,
    y: +Kl(e, ["y", "cy", "y1"]) || 0,
    width: 0,
    height: 0
  } : t;
}, vu = function(e) {
  return !!(e.getCTM && (!e.parentNode || e.ownerSVGElement) && gu(e));
}, si = function(e, t) {
  if (t) {
    var n = e.style, i;
    t in Wn && t !== jt && (t = pt), n.removeProperty ? (i = t.substr(0, 2), (i === "ms" || t.substr(0, 6) === "webkit") && (t = "-" + t), n.removeProperty(i === "--" ? t : t.replace(Ro, "-$1").toLowerCase())) : n.removeAttribute(t);
  }
}, ti = function(e, t, n, i, s, a) {
  var o = new Zt(e._pt, t, n, 0, 1, a ? du : fu);
  return e._pt = o, o.b = i, o.e = s, e._props.push(n), o;
}, Zl = {
  deg: 1,
  rad: 1,
  turn: 1
}, Yg = {
  grid: 1,
  flex: 1
}, ai = function r(e, t, n, i) {
  var s = parseFloat(n) || 0, a = (n + "").trim().substr((s + "").length) || "px", o = Mi.style, c = Fg.test(t), l = e.tagName.toLowerCase() === "svg", u = (l ? "client" : "offset") + (c ? "Width" : "Height"), h = 100, f = i === "px", d = i === "%", g, _, m, p;
  if (i === a || !s || Zl[i] || Zl[a])
    return s;
  if (a !== "px" && !f && (s = r(e, t, n, "px")), p = e.getCTM && vu(e), (d || a === "%") && (Wn[t] || ~t.indexOf("adius")))
    return g = p ? e.getBBox()[c ? "width" : "height"] : e[u], vt(d ? s / g * h : s / 100 * g);
  if (o[c ? "width" : "height"] = h + (f ? a : i), _ = i !== "rem" && ~t.indexOf("adius") || i === "em" && e.appendChild && !l ? e : e.parentNode, p && (_ = (e.ownerSVGElement || {}).parentNode), (!_ || _ === ei || !_.appendChild) && (_ = ei.body), m = _._gsap, m && d && m.width && c && m.time === an.time && !m.uncache)
    return vt(s / m.width * h);
  if (d && (t === "height" || t === "width")) {
    var S = e.style[t];
    e.style[t] = h + i, g = e[u], S ? e.style[t] = S : si(e, t);
  } else
    (d || a === "%") && !Yg[ln(_, "display")] && (o.position = ln(e, "position")), _ === e && (o.position = "static"), _.appendChild(Mi), g = Mi[u], _.removeChild(Mi), o.position = "absolute";
  return c && d && (m = yi(_), m.time = an.time, m.width = _[u]), vt(f ? g * s / h : g && s ? h / g * s : 0);
}, zn = function(e, t, n, i) {
  var s;
  return Ao || io(), t in Rn && t !== "transform" && (t = Rn[t], ~t.indexOf(",") && (t = t.split(",")[0])), Wn[t] && t !== "transform" ? (s = Wr(e, i), s = t !== "transformOrigin" ? s[t] : s.svg ? s.origin : ks(ln(e, jt)) + " " + s.zOrigin + "px") : (s = e.style[t], (!s || s === "auto" || i || ~(s + "").indexOf("calc(")) && (s = Gs[t] && Gs[t](e, t, n) || ln(e, t) || Nc(e, t) || (t === "opacity" ? 1 : 0))), n && !~(s + "").trim().indexOf(" ") ? ai(e, t, s, n) + n : s;
}, $g = function(e, t, n, i) {
  if (!n || n === "none") {
    var s = or(t, e, 1), a = s && ln(e, s, 1);
    a && a !== n ? (t = s, n = a) : t === "borderColor" && (n = ln(e, "borderTopColor"));
  }
  var o = new Zt(this._pt, e.style, t, 0, 1, cu), c = 0, l = 0, u, h, f, d, g, _, m, p, S, b, T, y;
  if (o.b = n, o.e = i, n += "", i += "", i.substring(0, 6) === "var(--" && (i = ln(e, i.substring(4, i.indexOf(")")))), i === "auto" && (_ = e.style[t], e.style[t] = i, i = ln(e, t) || i, _ ? e.style[t] = _ : si(e, t)), u = [n, i], tu(u), n = u[0], i = u[1], f = n.match(Ki) || [], y = i.match(Ki) || [], y.length) {
    for (; h = Ki.exec(i); )
      m = h[0], S = i.substring(c, h.index), g ? g = (g + 1) % 5 : (S.substr(-5) === "rgba(" || S.substr(-5) === "hsla(") && (g = 1), m !== (_ = f[l++] || "") && (d = parseFloat(_) || 0, T = _.substr((d + "").length), m.charAt(1) === "=" && (m = Ji(d, m) + T), p = parseFloat(m), b = m.substr((p + "").length), c = Ki.lastIndex - b.length, b || (b = b || cn.units[t] || T, c === i.length && (i += b, o.e += b)), T !== b && (d = ai(e, t, _, b) || 0), o._pt = {
        _next: o._pt,
        p: S || l === 1 ? S : ",",
        //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
        s: d,
        c: p - d,
        m: g && g < 4 || t === "zIndex" ? Math.round : 0
      });
    o.c = c < i.length ? i.substring(c, i.length) : "";
  } else
    o.r = t === "display" && i === "none" ? du : fu;
  return Dc.test(i) && (o.e = 0), this._pt = o, o;
}, jl = {
  top: "0%",
  bottom: "100%",
  left: "0%",
  right: "100%",
  center: "50%"
}, Kg = function(e) {
  var t = e.split(" "), n = t[0], i = t[1] || "50%";
  return (n === "top" || n === "bottom" || i === "left" || i === "right") && (e = n, n = i, i = e), t[0] = jl[n] || n, t[1] = jl[i] || i, t.join(" ");
}, Zg = function(e, t) {
  if (t.tween && t.tween._time === t.tween._dur) {
    var n = t.t, i = n.style, s = t.u, a = n._gsap, o, c, l;
    if (s === "all" || s === !0)
      i.cssText = "", c = 1;
    else
      for (s = s.split(","), l = s.length; --l > -1; )
        o = s[l], Wn[o] && (c = 1, o = o === "transformOrigin" ? jt : pt), si(n, o);
    c && (si(n, pt), a && (a.svg && n.removeAttribute("transform"), i.scale = i.rotate = i.translate = "none", Wr(n, 1), a.uncache = 1, pu(i)));
  }
}, Gs = {
  clearProps: function(e, t, n, i, s) {
    if (s.data !== "isFromStart") {
      var a = e._pt = new Zt(e._pt, t, n, 0, 0, Zg);
      return a.u = i, a.pr = -10, a.tween = s, e._props.push(n), 1;
    }
  }
  /* className feature (about 0.4kb gzipped).
  , className(plugin, target, property, endValue, tween) {
  	let _renderClassName = (ratio, data) => {
  			data.css.render(ratio, data.css);
  			if (!ratio || ratio === 1) {
  				let inline = data.rmv,
  					target = data.t,
  					p;
  				target.setAttribute("class", ratio ? data.e : data.b);
  				for (p in inline) {
  					_removeProperty(target, p);
  				}
  			}
  		},
  		_getAllStyles = (target) => {
  			let styles = {},
  				computed = getComputedStyle(target),
  				p;
  			for (p in computed) {
  				if (isNaN(p) && p !== "cssText" && p !== "length") {
  					styles[p] = computed[p];
  				}
  			}
  			_setDefaults(styles, _parseTransform(target, 1));
  			return styles;
  		},
  		startClassList = target.getAttribute("class"),
  		style = target.style,
  		cssText = style.cssText,
  		cache = target._gsap,
  		classPT = cache.classPT,
  		inlineToRemoveAtEnd = {},
  		data = {t:target, plugin:plugin, rmv:inlineToRemoveAtEnd, b:startClassList, e:(endValue.charAt(1) !== "=") ? endValue : startClassList.replace(new RegExp("(?:\\s|^)" + endValue.substr(2) + "(?![\\w-])"), "") + ((endValue.charAt(0) === "+") ? " " + endValue.substr(2) : "")},
  		changingVars = {},
  		startVars = _getAllStyles(target),
  		transformRelated = /(transform|perspective)/i,
  		endVars, p;
  	if (classPT) {
  		classPT.r(1, classPT.d);
  		_removeLinkedListItem(classPT.d.plugin, classPT, "_pt");
  	}
  	target.setAttribute("class", data.e);
  	endVars = _getAllStyles(target, true);
  	target.setAttribute("class", startClassList);
  	for (p in endVars) {
  		if (endVars[p] !== startVars[p] && !transformRelated.test(p)) {
  			changingVars[p] = endVars[p];
  			if (!style[p] && style[p] !== "0") {
  				inlineToRemoveAtEnd[p] = 1;
  			}
  		}
  	}
  	cache.classPT = plugin._pt = new PropTween(plugin._pt, target, "className", 0, 0, _renderClassName, data, 0, -11);
  	if (style.cssText !== cssText) { //only apply if things change. Otherwise, in cases like a background-image that's pulled dynamically, it could cause a refresh. See https://gsap.com/forums/topic/20368-possible-gsap-bug-switching-classnames-in-chrome/.
  		style.cssText = cssText; //we recorded cssText before we swapped classes and ran _getAllStyles() because in cases when a className tween is overwritten, we remove all the related tweening properties from that class change (otherwise class-specific stuff can't override properties we've directly set on the target's style object due to specificity).
  	}
  	_parseTransform(target, true); //to clear the caching of transforms
  	data.css = new gsap.plugins.css();
  	data.css.init(target, changingVars, tween);
  	plugin._props.push(...data.css._props);
  	return 1;
  }
  */
}, Hr = [1, 0, 0, 1, 0, 0], xu = {}, Su = function(e) {
  return e === "matrix(1, 0, 0, 1, 0, 0)" || e === "none" || !e;
}, Jl = function(e) {
  var t = ln(e, pt);
  return Su(t) ? Hr : t.substr(7).match(Pc).map(vt);
}, Co = function(e, t) {
  var n = e._gsap || yi(e), i = e.style, s = Jl(e), a, o, c, l;
  return n.svg && e.getAttribute("transform") ? (c = e.transform.baseVal.consolidate().matrix, s = [c.a, c.b, c.c, c.d, c.e, c.f], s.join(",") === "1,0,0,1,0,0" ? Hr : s) : (s === Hr && !e.offsetParent && e !== Qi && !n.svg && (c = i.display, i.display = "block", a = e.parentNode, (!a || !e.offsetParent && !e.getBoundingClientRect().width) && (l = 1, o = e.nextElementSibling, Qi.appendChild(e)), s = Jl(e), c ? i.display = c : si(e, "display"), l && (o ? a.insertBefore(e, o) : a ? a.appendChild(e) : Qi.removeChild(e))), t && s.length > 6 ? [s[0], s[1], s[4], s[5], s[12], s[13]] : s);
}, ro = function(e, t, n, i, s, a) {
  var o = e._gsap, c = s || Co(e, !0), l = o.xOrigin || 0, u = o.yOrigin || 0, h = o.xOffset || 0, f = o.yOffset || 0, d = c[0], g = c[1], _ = c[2], m = c[3], p = c[4], S = c[5], b = t.split(" "), T = parseFloat(b[0]) || 0, y = parseFloat(b[1]) || 0, R, A, C, x;
  n ? c !== Hr && (A = d * m - g * _) && (C = T * (m / A) + y * (-_ / A) + (_ * S - m * p) / A, x = T * (-g / A) + y * (d / A) - (d * S - g * p) / A, T = C, y = x) : (R = gu(e), T = R.x + (~b[0].indexOf("%") ? T / 100 * R.width : T), y = R.y + (~(b[1] || b[0]).indexOf("%") ? y / 100 * R.height : y)), i || i !== !1 && o.smooth ? (p = T - l, S = y - u, o.xOffset = h + (p * d + S * _) - p, o.yOffset = f + (p * g + S * m) - S) : o.xOffset = o.yOffset = 0, o.xOrigin = T, o.yOrigin = y, o.smooth = !!i, o.origin = t, o.originIsAbsolute = !!n, e.style[jt] = "0px 0px", a && (ti(a, o, "xOrigin", l, T), ti(a, o, "yOrigin", u, y), ti(a, o, "xOffset", h, o.xOffset), ti(a, o, "yOffset", f, o.yOffset)), e.setAttribute("data-svg-origin", T + " " + y);
}, Wr = function(e, t) {
  var n = e._gsap || new iu(e);
  if ("x" in n && !t && !n.uncache)
    return n;
  var i = e.style, s = n.scaleX < 0, a = "px", o = "deg", c = getComputedStyle(e), l = ln(e, jt) || "0", u, h, f, d, g, _, m, p, S, b, T, y, R, A, C, x, E, P, z, N, W, H, k, O, Y, ae, ne, ue, Pe, Le, Ve, He;
  return u = h = f = _ = m = p = S = b = T = 0, d = g = 1, n.svg = !!(e.getCTM && vu(e)), c.translate && ((c.translate !== "none" || c.scale !== "none" || c.rotate !== "none") && (i[pt] = (c.translate !== "none" ? "translate3d(" + (c.translate + " 0 0").split(" ").slice(0, 3).join(", ") + ") " : "") + (c.rotate !== "none" ? "rotate(" + c.rotate + ") " : "") + (c.scale !== "none" ? "scale(" + c.scale.split(" ").join(",") + ") " : "") + (c[pt] !== "none" ? c[pt] : "")), i.scale = i.rotate = i.translate = "none"), A = Co(e, n.svg), n.svg && (n.uncache ? (Y = e.getBBox(), l = n.xOrigin - Y.x + "px " + (n.yOrigin - Y.y) + "px", O = "") : O = !t && e.getAttribute("data-svg-origin"), ro(e, O || l, !!O || n.originIsAbsolute, n.smooth !== !1, A)), y = n.xOrigin || 0, R = n.yOrigin || 0, A !== Hr && (P = A[0], z = A[1], N = A[2], W = A[3], u = H = A[4], h = k = A[5], A.length === 6 ? (d = Math.sqrt(P * P + z * z), g = Math.sqrt(W * W + N * N), _ = P || z ? Yi(z, P) * xi : 0, S = N || W ? Yi(N, W) * xi + _ : 0, S && (g *= Math.abs(Math.cos(S * er))), n.svg && (u -= y - (y * P + R * N), h -= R - (y * z + R * W))) : (He = A[6], Le = A[7], ne = A[8], ue = A[9], Pe = A[10], Ve = A[11], u = A[12], h = A[13], f = A[14], C = Yi(He, Pe), m = C * xi, C && (x = Math.cos(-C), E = Math.sin(-C), O = H * x + ne * E, Y = k * x + ue * E, ae = He * x + Pe * E, ne = H * -E + ne * x, ue = k * -E + ue * x, Pe = He * -E + Pe * x, Ve = Le * -E + Ve * x, H = O, k = Y, He = ae), C = Yi(-N, Pe), p = C * xi, C && (x = Math.cos(-C), E = Math.sin(-C), O = P * x - ne * E, Y = z * x - ue * E, ae = N * x - Pe * E, Ve = W * E + Ve * x, P = O, z = Y, N = ae), C = Yi(z, P), _ = C * xi, C && (x = Math.cos(C), E = Math.sin(C), O = P * x + z * E, Y = H * x + k * E, z = z * x - P * E, k = k * x - H * E, P = O, H = Y), m && Math.abs(m) + Math.abs(_) > 359.9 && (m = _ = 0, p = 180 - p), d = vt(Math.sqrt(P * P + z * z + N * N)), g = vt(Math.sqrt(k * k + He * He)), C = Yi(H, k), S = Math.abs(C) > 2e-4 ? C * xi : 0, T = Ve ? 1 / (Ve < 0 ? -Ve : Ve) : 0), n.svg && (O = e.getAttribute("transform"), n.forceCSS = e.setAttribute("transform", "") || !Su(ln(e, pt)), O && e.setAttribute("transform", O))), Math.abs(S) > 90 && Math.abs(S) < 270 && (s ? (d *= -1, S += _ <= 0 ? 180 : -180, _ += _ <= 0 ? 180 : -180) : (g *= -1, S += S <= 0 ? 180 : -180)), t = t || n.uncache, n.x = u - ((n.xPercent = u && (!t && n.xPercent || (Math.round(e.offsetWidth / 2) === Math.round(-u) ? -50 : 0))) ? e.offsetWidth * n.xPercent / 100 : 0) + a, n.y = h - ((n.yPercent = h && (!t && n.yPercent || (Math.round(e.offsetHeight / 2) === Math.round(-h) ? -50 : 0))) ? e.offsetHeight * n.yPercent / 100 : 0) + a, n.z = f + a, n.scaleX = vt(d), n.scaleY = vt(g), n.rotation = vt(_) + o, n.rotationX = vt(m) + o, n.rotationY = vt(p) + o, n.skewX = S + o, n.skewY = b + o, n.transformPerspective = T + a, (n.zOrigin = parseFloat(l.split(" ")[2]) || !t && n.zOrigin || 0) && (i[jt] = ks(l)), n.xOffset = n.yOffset = 0, n.force3D = cn.force3D, n.renderTransform = n.svg ? Jg : _u ? Mu : jg, n.uncache = 0, n;
}, ks = function(e) {
  return (e = e.split(" "))[0] + " " + e[1];
}, Ga = function(e, t, n) {
  var i = Ot(t);
  return vt(parseFloat(t) + parseFloat(ai(e, "x", n + "px", i))) + i;
}, jg = function(e, t) {
  t.z = "0px", t.rotationY = t.rotationX = "0deg", t.force3D = 0, Mu(e, t);
}, _i = "0deg", Mr = "0px", gi = ") ", Mu = function(e, t) {
  var n = t || this, i = n.xPercent, s = n.yPercent, a = n.x, o = n.y, c = n.z, l = n.rotation, u = n.rotationY, h = n.rotationX, f = n.skewX, d = n.skewY, g = n.scaleX, _ = n.scaleY, m = n.transformPerspective, p = n.force3D, S = n.target, b = n.zOrigin, T = "", y = p === "auto" && e && e !== 1 || p === !0;
  if (b && (h !== _i || u !== _i)) {
    var R = parseFloat(u) * er, A = Math.sin(R), C = Math.cos(R), x;
    R = parseFloat(h) * er, x = Math.cos(R), a = Ga(S, a, A * x * -b), o = Ga(S, o, -Math.sin(R) * -b), c = Ga(S, c, C * x * -b + b);
  }
  m !== Mr && (T += "perspective(" + m + gi), (i || s) && (T += "translate(" + i + "%, " + s + "%) "), (y || a !== Mr || o !== Mr || c !== Mr) && (T += c !== Mr || y ? "translate3d(" + a + ", " + o + ", " + c + ") " : "translate(" + a + ", " + o + gi), l !== _i && (T += "rotate(" + l + gi), u !== _i && (T += "rotateY(" + u + gi), h !== _i && (T += "rotateX(" + h + gi), (f !== _i || d !== _i) && (T += "skew(" + f + ", " + d + gi), (g !== 1 || _ !== 1) && (T += "scale(" + g + ", " + _ + gi), S.style[pt] = T || "translate(0, 0)";
}, Jg = function(e, t) {
  var n = t || this, i = n.xPercent, s = n.yPercent, a = n.x, o = n.y, c = n.rotation, l = n.skewX, u = n.skewY, h = n.scaleX, f = n.scaleY, d = n.target, g = n.xOrigin, _ = n.yOrigin, m = n.xOffset, p = n.yOffset, S = n.forceCSS, b = parseFloat(a), T = parseFloat(o), y, R, A, C, x;
  c = parseFloat(c), l = parseFloat(l), u = parseFloat(u), u && (u = parseFloat(u), l += u, c += u), c || l ? (c *= er, l *= er, y = Math.cos(c) * h, R = Math.sin(c) * h, A = Math.sin(c - l) * -f, C = Math.cos(c - l) * f, l && (u *= er, x = Math.tan(l - u), x = Math.sqrt(1 + x * x), A *= x, C *= x, u && (x = Math.tan(u), x = Math.sqrt(1 + x * x), y *= x, R *= x)), y = vt(y), R = vt(R), A = vt(A), C = vt(C)) : (y = h, C = f, R = A = 0), (b && !~(a + "").indexOf("px") || T && !~(o + "").indexOf("px")) && (b = ai(d, "x", a, "px"), T = ai(d, "y", o, "px")), (g || _ || m || p) && (b = vt(b + g - (g * y + _ * A) + m), T = vt(T + _ - (g * R + _ * C) + p)), (i || s) && (x = d.getBBox(), b = vt(b + i / 100 * x.width), T = vt(T + s / 100 * x.height)), x = "matrix(" + y + "," + R + "," + A + "," + C + "," + b + "," + T + ")", d.setAttribute("transform", x), S && (d.style[pt] = x);
}, Qg = function(e, t, n, i, s) {
  var a = 360, o = Dt(s), c = parseFloat(s) * (o && ~s.indexOf("rad") ? xi : 1), l = c - i, u = i + l + "deg", h, f;
  return o && (h = s.split("_")[1], h === "short" && (l %= a, l !== l % (a / 2) && (l += l < 0 ? a : -a)), h === "cw" && l < 0 ? l = (l + a * ql) % a - ~~(l / a) * a : h === "ccw" && l > 0 && (l = (l - a * ql) % a - ~~(l / a) * a)), e._pt = f = new Zt(e._pt, t, n, i, l, Ig), f.e = u, f.u = "deg", e._props.push(n), f;
}, Ql = function(e, t) {
  for (var n in t)
    e[n] = t[n];
  return e;
}, e0 = function(e, t, n) {
  var i = Ql({}, n._gsap), s = "perspective,force3D,transformOrigin,svgOrigin", a = n.style, o, c, l, u, h, f, d, g;
  i.svg ? (l = n.getAttribute("transform"), n.setAttribute("transform", ""), a[pt] = t, o = Wr(n, 1), si(n, pt), n.setAttribute("transform", l)) : (l = getComputedStyle(n)[pt], a[pt] = t, o = Wr(n, 1), a[pt] = l);
  for (c in Wn)
    l = i[c], u = o[c], l !== u && s.indexOf(c) < 0 && (d = Ot(l), g = Ot(u), h = d !== g ? ai(n, c, l, g) : parseFloat(l), f = parseFloat(u), e._pt = new Zt(e._pt, o, c, h, f - h, to), e._pt.u = g || 0, e._props.push(c));
  Ql(o, i);
};
Kt("padding,margin,Width,Radius", function(r, e) {
  var t = "Top", n = "Right", i = "Bottom", s = "Left", a = (e < 3 ? [t, n, i, s] : [t + s, t + n, i + n, i + s]).map(function(o) {
    return e < 2 ? r + o : "border" + o + r;
  });
  Gs[e > 1 ? "border" + r : r] = function(o, c, l, u, h) {
    var f, d;
    if (arguments.length < 4)
      return f = a.map(function(g) {
        return zn(o, g, l);
      }), d = f.join(" "), d.split(f[0]).length === 5 ? f[0] : d;
    f = (u + "").split(" "), d = {}, a.forEach(function(g, _) {
      return d[g] = f[_] = f[_] || f[(_ - 1) / 2 | 0];
    }), o.init(c, d, h);
  };
});
var yu = {
  name: "css",
  register: io,
  targetTest: function(e) {
    return e.style && e.nodeType;
  },
  init: function(e, t, n, i, s) {
    var a = this._props, o = e.style, c = n.vars.startAt, l, u, h, f, d, g, _, m, p, S, b, T, y, R, A, C, x;
    Ao || io(), this.styles = this.styles || mu(e), C = this.styles.props, this.tween = n;
    for (_ in t)
      if (_ !== "autoRound" && (u = t[_], !(sn[_] && ru(_, t, n, i, e, s)))) {
        if (d = typeof u, g = Gs[_], d === "function" && (u = u.call(n, i, e, s), d = typeof u), d === "string" && ~u.indexOf("random(") && (u = Gr(u)), g)
          g(this, e, _, u, n) && (A = 1);
        else if (_.substr(0, 2) === "--")
          l = (getComputedStyle(e).getPropertyValue(_) + "").trim(), u += "", ii.lastIndex = 0, ii.test(l) || (m = Ot(l), p = Ot(u), p ? m !== p && (l = ai(e, _, l, p) + p) : m && (u += m)), this.add(o, "setProperty", l, u, i, s, 0, 0, _), a.push(_), C.push(_, 0, o[_]);
        else if (d !== "undefined") {
          if (c && _ in c ? (l = typeof c[_] == "function" ? c[_].call(n, i, e, s) : c[_], Dt(l) && ~l.indexOf("random(") && (l = Gr(l)), Ot(l + "") || l === "auto" || (l += cn.units[_] || Ot(zn(e, _)) || ""), (l + "").charAt(1) === "=" && (l = zn(e, _))) : l = zn(e, _), f = parseFloat(l), S = d === "string" && u.charAt(1) === "=" && u.substr(0, 2), S && (u = u.substr(2)), h = parseFloat(u), _ in Rn && (_ === "autoAlpha" && (f === 1 && zn(e, "visibility") === "hidden" && h && (f = 0), C.push("visibility", 0, o.visibility), ti(this, o, "visibility", f ? "inherit" : "hidden", h ? "inherit" : "hidden", !h)), _ !== "scale" && _ !== "transform" && (_ = Rn[_], ~_.indexOf(",") && (_ = _.split(",")[0]))), b = _ in Wn, b) {
            if (this.styles.save(_), x = u, d === "string" && u.substring(0, 6) === "var(--") {
              if (u = ln(e, u.substring(4, u.indexOf(")"))), u.substring(0, 5) === "calc(") {
                var E = e.style.perspective;
                e.style.perspective = u, u = ln(e, "perspective"), E ? e.style.perspective = E : si(e, "perspective");
              }
              h = parseFloat(u);
            }
            if (T || (y = e._gsap, y.renderTransform && !t.parseTransform || Wr(e, t.parseTransform), R = t.smoothOrigin !== !1 && y.smooth, T = this._pt = new Zt(this._pt, o, pt, 0, 1, y.renderTransform, y, 0, -1), T.dep = 1), _ === "scale")
              this._pt = new Zt(this._pt, y, "scaleY", y.scaleY, (S ? Ji(y.scaleY, S + h) : h) - y.scaleY || 0, to), this._pt.u = 0, a.push("scaleY", _), _ += "X";
            else if (_ === "transformOrigin") {
              C.push(jt, 0, o[jt]), u = Kg(u), y.svg ? ro(e, u, 0, R, 0, this) : (p = parseFloat(u.split(" ")[2]) || 0, p !== y.zOrigin && ti(this, y, "zOrigin", y.zOrigin, p), ti(this, o, _, ks(l), ks(u)));
              continue;
            } else if (_ === "svgOrigin") {
              ro(e, u, 1, R, 0, this);
              continue;
            } else if (_ in xu) {
              Qg(this, y, _, f, S ? Ji(f, S + u) : u);
              continue;
            } else if (_ === "smoothOrigin") {
              ti(this, y, "smooth", y.smooth, u);
              continue;
            } else if (_ === "force3D") {
              y[_] = u;
              continue;
            } else if (_ === "transform") {
              e0(this, u, e);
              continue;
            }
          } else _ in o || (_ = or(_) || _);
          if (b || (h || h === 0) && (f || f === 0) && !Ug.test(u) && _ in o)
            m = (l + "").substr((f + "").length), h || (h = 0), p = Ot(u) || (_ in cn.units ? cn.units[_] : m), m !== p && (f = ai(e, _, l, p)), this._pt = new Zt(this._pt, b ? y : o, _, f, (S ? Ji(f, S + h) : h) - f, !b && (p === "px" || _ === "zIndex") && t.autoRound !== !1 ? Bg : to), this._pt.u = p || 0, b && x !== u ? (this._pt.b = l, this._pt.e = x, this._pt.r = Og) : m !== p && p !== "%" && (this._pt.b = l, this._pt.r = Ng);
          else if (_ in o)
            $g.call(this, e, _, l, S ? S + u : u);
          else if (_ in e)
            this.add(e, _, l || e[_], S ? S + u : u, i, s);
          else if (_ !== "parseTransform") {
            _o(_, u);
            continue;
          }
          b || (_ in o ? C.push(_, 0, o[_]) : typeof e[_] == "function" ? C.push(_, 2, e[_]()) : C.push(_, 1, l || e[_])), a.push(_);
        }
      }
    A && uu(this);
  },
  render: function(e, t) {
    if (t.tween._time || !wo())
      for (var n = t._pt; n; )
        n.r(e, n.d), n = n._next;
    else
      t.styles.revert();
  },
  get: zn,
  aliases: Rn,
  getSetter: function(e, t, n) {
    var i = Rn[t];
    return i && i.indexOf(",") < 0 && (t = i), t in Wn && t !== jt && (e._gsap.x || zn(e, "x")) ? n && Xl === n ? t === "scale" ? Vg : kg : (Xl = n || {}) && (t === "scale" ? Hg : Wg) : e.style && !fo(e.style[t]) ? zg : ~t.indexOf("-") ? Gg : To(e, t);
  },
  core: {
    _removeProperty: si,
    _getMatrix: Co
  }
};
Jt.utils.checkPrefix = or;
Jt.core.getStyleSaver = mu;
(function(r, e, t, n) {
  var i = Kt(r + "," + e + "," + t, function(s) {
    Wn[s] = 1;
  });
  Kt(e, function(s) {
    cn.units[s] = "deg", xu[s] = 1;
  }), Rn[i[13]] = r + "," + e, Kt(n, function(s) {
    var a = s.split(":");
    Rn[a[1]] = i[a[0]];
  });
})("x,y,z,scale,scaleX,scaleY,xPercent,yPercent", "rotation,rotationX,rotationY,skewX,skewY", "transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective", "0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,8:rotateZ,9:rotateX,10:rotateY");
Kt("x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective", function(r) {
  cn.units[r] = "px";
});
Jt.registerPlugin(yu);
var ct = Jt.registerPlugin(yu) || Jt;
ct.core.Tween;
const t0 = (
  /* glsl */
  `
  uniform float uTime;
  uniform float uBend;
  uniform float uOpening;
  varying vec2 vUv;
  void main() {
    vUv = uv;
    vec3 p = position;
    float edge = sin(uv.x * 3.14159265);
    p.z += edge * uBend * sin(uTime * .72 + uv.y * 2.8);
    p.x += sin(uv.y * 4.2 + uTime * .35) * uBend * .08;
    p.z += uOpening * length(position.xy) * .08;
    gl_Position = projectionMatrix * modelViewMatrix * vec4(p, 1.0);
  }
`
), n0 = (
  /* glsl */
  `
  uniform sampler2D uTexture;
  uniform float uOpacity;
  uniform float uOpening;
  uniform float uTime;
  uniform float uSheen;
  uniform vec2 uScale;
  varying vec2 vUv;
  float roundedBox(vec2 p, vec2 b, float r) {
    vec2 q = abs(p) - b + r;
    return min(max(q.x, q.y), 0.0) + length(max(q, 0.0)) - r;
  }
  void main() {
    vec2 uv = (vUv - .5) * uScale + .5;
    float ripple = sin((uv.y + uOpening * .7) * 22.0) * .004 * uOpening;
    uv.x += ripple;
    vec4 tex = texture2D(uTexture, uv);
    tex.rgb = clamp((tex.rgb - .5) * 1.12 + .5, 0.0, 1.0);
    float distanceToEdge = roundedBox(vUv - .5, vec2(.49), .055);
    float shape = 1.0 - smoothstep(-.004, .012, distanceToEdge);
    float inner = 1.0 - smoothstep(-.03, -.016, distanceToEdge);
    float sweep = pow(max(0.0, sin((vUv.x + vUv.y) * 2.6 + uTime * .55 + uSheen)), 10.0);
    vec3 lacquer = vec3(.30, .035, .05) + sweep * vec3(.62, .22, .20);
    float vignette = 1.0 - smoothstep(.28, .77, distance(vUv, vec2(.5))) * .22;
    vec3 framed = mix(lacquer, tex.rgb * vignette, inner);
    gl_FragColor = vec4(framed, tex.a * shape * uOpacity);
  }
`
), i0 = (
  /* glsl */
  `
  attribute vec3 aColor;
  attribute float aSeed;
  attribute float aSize;
  attribute float aDelay;
  uniform float uTime;
  uniform float uSpawn;
  uniform float uBurst;
  uniform float uPixelRatio;
  uniform float uFluidStrength;
  uniform sampler2D uFluid;
  varying vec3 vColor;
  varying float vTwinkle;
  varying float vAlpha;
  varying float vStar;
  void main() {
    float spawn = smoothstep(aDelay, aDelay + .45, uSpawn);
    vec3 base = position;
    base.x += sin(uTime * .21 + aSeed * 6.283) * .12;
    base.y += cos(uTime * .17 + aSeed * 4.1) * .1;
    base.z += sin(uTime * .13 + aSeed * 2.7) * .08;
    vec3 seed = vec3(0.0, 0.0, -1.0);
    vec3 p = mix(seed + (base - seed) * .06, base, spawn);
    vec2 dir = normalize(base.xy + vec2(.001, .001));
    p.xy += dir * uBurst * uBurst * 5.5;
    p.z += uBurst * 6.5;
    vec4 clip = projectionMatrix * modelViewMatrix * vec4(p, 1.0);
    vec2 screen = clip.xy / max(clip.w, .001) * .5 + .5;
    vec2 vel = texture2D(uFluid, clamp(screen, 0.0, 1.0)).xy * 2.0 - 1.0;
    p.xy += vel * uFluidStrength * (1.0 + (p.z + 3.0) * .12);
    vec4 mv = modelViewMatrix * vec4(p, 1.0);
    gl_Position = projectionMatrix * mv;
    float tw = sin(uTime * (1.6 + aSeed * 2.4) + aSeed * 40.0);
    vTwinkle = pow(max(tw, 0.0), 6.0);
    float speed = min(length(vel), 1.0);
    gl_PointSize = aSize * uPixelRatio * (1.0 + vTwinkle * 1.2 + speed * 2.5 + uBurst * 2.0) * (7.0 / max(-mv.z, .5));
    vColor = aColor;
    vAlpha = spawn * (1.0 - smoothstep(.55, 1.0, uBurst)) * (.35 + .65 * vTwinkle + speed * .8);
    vStar = step(.82, aSeed);
  }
`
), r0 = (
  /* glsl */
  `
  uniform float uLift;
  uniform float uAlphaCap;
  varying vec3 vColor;
  varying float vTwinkle;
  varying float vAlpha;
  varying float vStar;
  void main() {
    vec2 uv = gl_PointCoord * 2.0 - 1.0;
    float d = length(uv);
    float disc = 1.0 - smoothstep(.25, 1.0, d);
    float star = (pow(max(0.0, 1.0 - abs(uv.x)), 8.0) + pow(max(0.0, 1.0 - abs(uv.y)), 8.0)) * vStar * vTwinkle;
    float a = min(clamp(disc + star, 0.0, 1.0) * vAlpha, uAlphaCap);
    vec3 col = max(vColor + vec3(uLift) * vTwinkle, 0.0);
    gl_FragColor = vec4(col * a, a);
  }
`
), Eu = [
  [0.62, 0.93, 0.91, 0.87],
  [0.2, 0.91, 0.72, 0.47],
  [0.14, 0.86, 0.2, 0.17],
  [0.04, 0.45, 0.05, 0.07]
], yr = 32, Er = 18, ec = [
  [-3.45, 1.95, 0.55, 1.12, 1.52, -0.11],
  [-1.55, 2.65, -0.1, 0.82, 1.08, 0.07],
  [1.05, 2.7, 0.2, 1.25, 0.78, -0.055],
  [3.42, 1.78, 0.45, 1, 1.33, 0.1],
  [-4.05, -0.45, 0.15, 1.35, 0.86, 0.055],
  [-2.15, -2.1, 0.6, 1, 1.28, -0.08],
  [0.35, -2.62, 0.1, 1.35, 0.84, 0.05],
  [2.63, -1.72, 0.7, 0.9, 1.22, -0.09],
  [4.17, -0.2, -0.1, 1.08, 0.72, 0.07],
  [-0.05, 1.4, -0.6, 0.72, 0.92, -0.04],
  [-3.2, -2.8, -0.3, 0.72, 0.9, 0.035],
  [3.55, -2.72, -0.25, 0.74, 0.96, -0.045]
], s0 = [
  [-1.12, 2.72, 0.55, 0.78, 1.18, -0.085],
  [1.14, 2.63, 0.1, 0.9, 0.72, 0.055],
  [-1.22, -2.56, 0.25, 0.82, 0.98, -0.04],
  [1.22, -2.45, 0.55, 0.82, 0.9, 0.07],
  [-1.42, 0.9, -0.2, 0.66, 0.55, 0.04],
  [1.45, 0.72, -0.1, 0.62, 0.78, -0.065],
  [-0.93, -3.55, -0.25, 0.62, 0.58, 0.035],
  [0.92, -3.5, -0.3, 0.62, 0.62, -0.03]
], tc = 0.12, Pt = (r, e) => r + Math.random() * (e - r), a0 = [
  [0.45, 0.86, 0.2, 0.17],
  [0.15, 0.45, 0.05, 0.07],
  [0.25, 0.79, 0.54, 0.23],
  [0.15, 0.04, 0.035, 0.035]
];
class Zs {
  constructor() {
    K(this, "texture");
    K(this, "vel", new Float32Array(yr * Er * 2));
    K(this, "scratch", new Float32Array(yr * Er * 2));
    K(this, "data", new Uint8Array(yr * Er * 4));
    K(this, "prev", new Ae());
    K(this, "stationaryPrimed", !1);
    K(this, "hasReceivedImpulse", !1);
    this.data.fill(128);
    for (let e = 3; e < this.data.length; e += 4) this.data[e] = 255;
    this.texture = new mc(this.data, yr, Er, 1023, 1009), this.texture.minFilter = this.texture.magFilter = 1006, this.texture.wrapS = this.texture.wrapT = 1001, this.texture.needsUpdate = !0;
  }
  step(e, t = 1 / 0) {
    const n = this.vel, i = this.scratch, s = yr, a = Er, o = e.x - this.prev.x, c = e.y - this.prev.y;
    this.prev.copy(e);
    const l = Math.hypot(o, c);
    if (this.stationaryPrimed && !this.hasReceivedImpulse && !(l > 5e-4 && l < t)) return;
    if (l > 5e-4 && l < t) {
      this.hasReceivedImpulse = !0;
      const h = (e.x * 0.5 + 0.5) * (s - 1), f = (e.y * 0.5 + 0.5) * (a - 1), d = 2.6;
      for (let g = Math.max(0, Math.floor(f - d)); g <= Math.min(a - 1, Math.ceil(f + d)); g += 1)
        for (let _ = Math.max(0, Math.floor(h - d)); _ <= Math.min(s - 1, Math.ceil(h + d)); _ += 1) {
          const m = (_ - h) * (_ - h) + (g - f) * (g - f), p = Math.exp(-m / (d * d * 0.5)) * 6, S = (g * s + _) * 2;
          n[S] += o * p, n[S + 1] += c * p;
        }
    }
    for (let h = 0; h < a; h += 1)
      for (let f = 0; f < s; f += 1) {
        const d = (h * s + f) * 2, g = (h * s + Math.max(0, f - 1)) * 2, _ = (h * s + Math.min(s - 1, f + 1)) * 2, m = (Math.max(0, h - 1) * s + f) * 2, p = (Math.min(a - 1, h + 1) * s + f) * 2;
        i[d] = (n[d] * 0.6 + (n[g] + n[_] + n[m] + n[p]) * 0.1) * 0.93, i[d + 1] = (n[d + 1] * 0.6 + (n[g + 1] + n[_ + 1] + n[m + 1] + n[p + 1]) * 0.1) * 0.93;
      }
    this.vel = i, this.scratch = n;
    const u = this.data;
    for (let h = 0, f = 0; h < s * a; h += 1, f += 2)
      u[h * 4] = Math.max(0, Math.min(255, (i[f] * 0.5 + 0.5) * 255)), u[h * 4 + 1] = Math.max(0, Math.min(255, (i[f + 1] * 0.5 + 0.5) * 255));
    this.texture.needsUpdate = !0, this.stationaryPrimed = !0;
  }
  dispose() {
    this.texture.dispose();
  }
}
function Po(r, e) {
  const t = {
    uTime: { value: 0 },
    uSpawn: { value: 0 },
    uBurst: { value: 0 },
    uPixelRatio: { value: 1 },
    uFluidStrength: { value: 0.9 },
    uLift: { value: r.lift },
    uAlphaCap: { value: r.alphaCap },
    uFluid: { value: e.texture }
  }, n = new jn(), i = (s, a, o, c, l, u) => {
    const h = new Float32Array(s * 3), f = new Float32Array(s * 3), d = new Float32Array(s), g = new Float32Array(s), _ = new Float32Array(s), m = r.mobile ? 3.4 : 7.2, p = r.mobile ? 5.6 : 4.4;
    for (let y = 0; y < s; y += 1) {
      const R = Math.random() * Math.PI * 2, A = Math.sqrt(Math.random()) * 1.05;
      h[y * 3] = Math.cos(R) * A * m, h[y * 3 + 1] = Math.sin(R) * A * p, h[y * 3 + 2] = Pt(a, o);
      let C = Math.random(), x = r.palette[0];
      for (const E of r.palette) {
        if (C < E[0]) {
          x = E;
          break;
        }
        C -= E[0];
      }
      f[y * 3] = x[1], f[y * 3 + 1] = x[2], f[y * 3 + 2] = x[3], d[y] = Math.random(), g[y] = Pt(c, l) * r.sizeScale, _[y] = Math.random() * 0.55;
    }
    const S = new Qt();
    S.setAttribute("position", new Nt(h, 3)), S.setAttribute("aColor", new Nt(f, 3)), S.setAttribute("aSeed", new Nt(d, 1)), S.setAttribute("aSize", new Nt(g, 1)), S.setAttribute("aDelay", new Nt(_, 1));
    const b = new Ht({
      uniforms: t,
      vertexShader: i0,
      fragmentShader: r0,
      transparent: !0,
      depthWrite: !1,
      depthTest: !1,
      blending: r.additive ? 2 : 1,
      premultipliedAlpha: !r.additive
    }), T = new Ch(S, b);
    return T.renderOrder = u, T.frustumCulled = !1, T;
  };
  return n.add(i(Math.round(r.total * 0.72), -3.6, -0.3, 1.3, 3.4, -1)), n.add(i(Math.round(r.total * 0.28), 0.7, 2.3, 0.9, 2.2, 2)), { group: n, uniforms: t };
}
let webGLProbeSucceeded = !1;
const js = () => {
  if (webGLProbeSucceeded) return !0;
  try {
    const r = document.createElement("canvas"), e = r.getContext("webgl2") || r.getContext("webgl");
    return e ? (e.getExtension("WEBGL_lose_context")?.loseContext(), webGLProbeSucceeded = !0) : !1;
  } catch {
    return !1;
  }
}, Js = (r) => {
  r.traverse((e) => {
    const t = e;
    "geometry" in t && t.geometry && t.geometry.dispose(), "material" in t && t.material && (Array.isArray(t.material) ? t.material : [t.material]).forEach((i) => {
      const s = i;
      s.uniforms && Object.values(s.uniforms).forEach((a) => {
        a.value instanceof bt && a.value.dispose();
      }), ["map", "alphaMap", "emissiveMap", "bumpMap", "normalMap"].forEach((a) => {
        const o = i[a];
        o instanceof bt && o.dispose();
      }), i.dispose();
    });
  });
}, Do = (r, e, t, n) => {
  const i = typeof navigator < "u" && navigator.hardwareConcurrency ? navigator.hardwareConcurrency : 8;
  return r ? n : i < 6 || window.devicePixelRatio > 2 ? t : e;
};
class o0 extends HTMLElement {
  constructor() {
    super(...arguments);
    K(this, "renderer");
    K(this, "scene", new Vs());
    K(this, "camera", new qt(38, 1, 0.1, 100));
    K(this, "artifacts", []);
    K(this, "shards", []);
    K(this, "orbit", new jn());
    K(this, "frame", 0);
    K(this, "clock", new Hs());
    K(this, "pointer", new Ae());
    K(this, "smoothPointer", new Ae());
    K(this, "opening", !1);
    K(this, "words", []);
    K(this, "extras", []);
    K(this, "glints", new jn());
    K(this, "glintUniforms");
    K(this, "fluid", new Zs());
    K(this, "torn", !1);
    K(this, "resizeObserver");
    K(this, "pointerHandler", (t) => {
      this.pointer.x = t.clientX / window.innerWidth * 2 - 1, this.pointer.y = -(t.clientY / window.innerHeight * 2 - 1);
    });
    K(this, "render", () => {
      if (this.torn) return;
      if (this.threshold?.classList.contains("is-gone")) {
        this.teardown();
        return;
      }
      const t = this.clock.getElapsedTime();
      this.smoothPointer.lerp(this.pointer, 0.045), this.opening || (this.orbit.rotation.z = t * 0.018, this.orbit.rotation.x = this.smoothPointer.y * 0.045, this.orbit.rotation.y = this.smoothPointer.x * 0.05, this.artifacts.forEach((n, i) => {
        n.mesh.position.x = n.base.x + this.smoothPointer.x * (n.base.z + 1.1) * 0.17, n.mesh.position.y = n.base.y + Math.sin(t * n.speed + n.phase) * n.drift + this.smoothPointer.y * (n.base.z + 1.1) * 0.12, n.mesh.rotation.z = n.rotation + Math.sin(t * 0.25 + i) * 0.012;
      })), this.glintUniforms && (this.fluid.step(this.pointer), this.glintUniforms.uTime.value = t, this.glints.rotation.y = this.smoothPointer.x * 0.06, this.glints.rotation.x = this.smoothPointer.y * 0.04), this.artifacts.forEach((n) => {
        n.mesh.material.uniforms.uTime.value = t;
      }), this.shards.forEach((n) => {
        n.mesh.material.uniforms.uTime.value = t;
      }), this.renderer && this.renderer.render(this.scene, this.camera), this.frame = requestAnimationFrame(this.render);
    });
  }
  get threshold() {
    return this.closest("[data-threshold], .threshold-entry");
  }
  // PERSSE_UX_COPY_PRESENTED_START — keep an already completed native CSS entrance visible.
  fallbackCopyWasPresented() {
    const owner = this.threshold;
    if (!owner || document.visibilityState !== "visible" || owner.classList.contains("is-opening") || owner.classList.contains("motion-ready")) return !1;
    const title = owner.querySelector(".threshold__content h1, .threshold-entry__content h1");
    if (!title || !title.children.length) return !1;
    const rect = title.getBoundingClientRect(), titleStyle = getComputedStyle(title), ownerStyle = getComputedStyle(owner);
    if (rect.width <= 0 || rect.height <= 0 || rect.bottom <= 0 || rect.top >= window.innerHeight || rect.right <= 0 || rect.left >= window.innerWidth || titleStyle.visibility !== "visible" || ownerStyle.visibility !== "visible" || Number(titleStyle.opacity) < .99 || Number(ownerStyle.opacity) < .99) return !1;
    return [...title.children].every((line) => {
      const style = getComputedStyle(line);
      if (style.visibility !== "visible" || Number(style.opacity) < .99 || typeof line.getAnimations !== "function") return !1;
      return line.getAnimations().some((animation) => (animation.animationName === "threshold-word-in" || animation.animationName === "threshold-accent-in") && animation.playState === "finished");
    });
  }
  // PERSSE_UX_COPY_PRESENTED_END
  connectedCallback() {
    if (this.torn || !this.isConnected || this.threshold?.classList.contains("is-gone")) {
      this.teardown();
      return;
    }
    if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      if (!js()) {
        this.setAttribute("data-failed", "true");
        return;
      }
      this.copyWasPresented = this.fallbackCopyWasPresented();
      this.pendingOwner = this.threshold;
      if (!this.copyWasPresented) this.pendingOwner?.setAttribute("data-motion-pending", "true");
      this.initialize().catch(() => {
        if (this.torn || this.opening || !this.isConnected || this.threshold?.classList.contains("is-gone") || this.threshold?.classList.contains("is-opening")) this.teardown();
        this.setAttribute("data-failed", "true"), this.pendingOwner?.removeAttribute("data-motion-pending");
      });
    }
  }
  disconnectedCallback() {
    this.teardown();
  }
  // Al terminar la entrada el umbral queda display:none: se apaga el bucle y se libera el contexto.
  teardown() {
    this.torn || (this.torn = !0, this.pendingOwner?.removeAttribute("data-motion-pending"), this.pendingOwner = void 0, cancelAnimationFrame(this.frame), this.resizeObserver?.disconnect(), this.threshold?.removeEventListener("pointermove", this.pointerHandler), Js(this.scene), this.fluid.dispose(), this.renderer && (this.renderer.dispose(), this.renderer.forceContextLoss(), this.renderer.domElement.remove(), this.renderer = void 0));
  }
  makeMaterial(t, n) {
    return new Ht({
      uniforms: {
        uTexture: { value: t },
        uOpacity: { value: 1 },
        uTime: { value: 0 },
        uBend: { value: n },
        uOpening: { value: 0 },
        uSheen: { value: Pt(0, 6.28) },
        uScale: { value: { x: 1, y: 1 } }
      },
      vertexShader: t0,
      fragmentShader: n0,
      transparent: !0,
      depthWrite: !1,
      side: 2
    });
  }
  async initialize() {
    const entryOwner = this.pendingOwner || this.threshold;
    const cancelled = () => this.torn || this.opening || !this.isConnected || this.threshold !== entryOwner || entryOwner?.classList.contains("is-gone") || entryOwner?.classList.contains("is-opening");
    if (cancelled()) {
      this.teardown();
      return;
    }
    const t = [...this.querySelectorAll("[data-motion-source]")];
    if (!t.length) throw new Error("Motion assets missing");
    this.renderer = new qs({ antialias: !0, alpha: !0, premultipliedAlpha: !0, powerPreference: "high-performance" }), this.renderer.setPixelRatio(Math.min(window.devicePixelRatio, 1.6)), this.renderer.setClearColor(0, 0), this.renderer.outputColorSpace = Tt, this.renderer.domElement.setAttribute("aria-hidden", "true"), this.prepend(this.renderer.domElement), this.camera.position.set(0, 0, 9.4), this.scene.fog = new co(328451, 0.03), [[14167849, 0.24], [15657439, 0.07], [9377048, 0.13]].forEach(([l, u], h) => {
      const d = new Lh(0, 0, 3.1 + h * 0.72, 1.85 + h * 0.45, 0, Math.PI * 2, !1, h * 0.4).getPoints(180).map((_) => new I(_.x, _.y, 0)), g = new wh(
        new Qt().setFromPoints(d),
        new gc({ color: l, transparent: !0, opacity: u })
      );
      g.rotation.z = h % 2 ? 0.34 : -0.18, g.position.z = -1.15 - h * 0.14, this.orbit.add(g);
    }), this.scene.add(this.orbit);
    // Reuse the eight parser-loaded, anonymous-CORS images; never request them again.
    const s = await Promise.all(t.map(async (l) => {
      await new Promise((resolve, reject) => {
        const clear = () => {
          l.removeEventListener("load", loaded);
          l.removeEventListener("error", failed);
        };
        const failed = () => {
          clear();
          reject(new Error("Motion image unavailable"));
        };
        const loaded = () => {
          clear();
          l.naturalWidth > 0 ? resolve() : reject(new Error("Motion image unavailable"));
        };
        if (l.complete) {
          loaded();
          return;
        }
        l.addEventListener("load", loaded, { once: true });
        l.addEventListener("error", failed, { once: true });
        if (l.complete) loaded();
      });
      if (typeof l.decode === "function") await l.decode();
      const texture = new bt(l);
      texture.needsUpdate = !0;
      return texture;
    }));
    if (cancelled()) {
      s.forEach((l) => l.dispose());
      this.teardown();
      return;
    }
    s.forEach((l) => {
      l.colorSpace = "", l.minFilter = 1008, l.magFilter = 1006;
    });
    const a = window.innerWidth < 720, o = Math.min(a ? 8 : ec.length, s.length);
    for (let l = 0; l < o; l += 1) {
      const u = a ? s0[l] : ec[l], h = new Lt(new _n(1, 1, 20, 20), this.makeMaterial(s[l], 0.07 + l % 3 * 0.018));
      (() => { const im = s[l].image, pa = u[3] / u[4], ia = im && im.width && im.height ? im.width / im.height : pa; h.material.uniforms.uScale.value = pa > ia ? { x: 1, y: ia / pa } : { x: pa / ia, y: 1 }; })(), h.position.set(u[0], u[1], u[2]), h.scale.set(u[3] * (a ? 1 : 1.27), u[4] * (a ? 1 : 1.27), 1), h.rotation.z = u[5], this.scene.add(h), this.artifacts.push({
        mesh: h,
        base: h.position.clone(),
        rotation: u[5],
        speed: 0.32 + l * 0.028,
        phase: l * 0.71,
        drift: 0.045 + l % 4 * 0.012,
        shard: !1
      });
    }
    const c = a ? 8 : 14;
    for (let l = 0; l < c; l += 1) {
      const u = s[(l * 3 + 1) % s.length].clone(), h = Pt(0.7, 1.45), f = a ? Pt(0.22, 0.42) : Pt(0.28, 0.58);
      u.wrapS = u.wrapT = 1001, u.repeat.set(Pt(0.3, 0.55), Pt(0.3, 0.55)), u.offset.set(Pt(0, 0.45), Pt(0, 0.45)), u.needsUpdate = !0;
      const d = new Lt(new _n(1, 1, 6, 6), this.makeMaterial(u, 0.04));
      d.material.uniforms.uOpacity.value = 0;
      const g = l / c * Math.PI * 2 + 0.35, _ = a ? Pt(0.9, 1.8) : Pt(1.4, 3.2);
      d.position.set(Math.cos(g) * _, Math.sin(g) * _ * 0.72, Pt(-1.4, -0.4)), d.scale.set(f * h, f, 1), d.rotation.z = Pt(-0.3, 0.3), d.visible = !1, this.scene.add(d), this.shards.push({ mesh: d, base: d.position.clone(), rotation: d.rotation.z, speed: 0, phase: 0, drift: 0, shard: !0 });
    }
    try {
      this.buildGlints(a);
    } catch {
      this.glints.clear();
    }
    // Prime the unchanged first zero-pointer fluid step before its one GPU upload.
    this.fluid.step(this.pointer);
    const uploadTextures = [...s, this.fluid.texture];
    for (let l = 0; l < uploadTextures.length; l += 1) {
      if (cancelled()) {
        this.teardown();
        return;
      }
      this.renderer.initTexture(uploadTextures[l]);
      if (l + 1 < uploadTextures.length) {
        await new Promise((resolve) => setTimeout(resolve, 0));
        if (cancelled()) {
          this.teardown();
          return;
        }
      }
    }
    this.resizeObserver = new ResizeObserver(() => this.resize()), this.resizeObserver.observe(this), this.threshold?.addEventListener("pointermove", this.pointerHandler, { passive: !0 }), this.resize(), this.animateIn(), this.glintUniforms && ct.to(this.glintUniforms.uSpawn, { value: 1, duration: 1.9, ease: "power2.out", delay: 0.05 }), this.render(), this.setAttribute("data-ready", "true"), this.threshold?.classList.add("motion-ready"), this.birthHeadline(), this.dispatchEvent(new CustomEvent("casa:motion-ready", { bubbles: !0 }));
  }
  buildGlints(t) {
    const { group: n, uniforms: i } = Po({
      mobile: t,
      total: Do(t, 2200, 1400, 700),
      palette: Eu,
      additive: !0,
      lift: 0.25,
      alphaCap: 1,
      sizeScale: 1
    }, this.fluid);
    this.glints = n, this.glintUniforms = i, this.scene.add(this.glints);
  }
  animateIn() {
    this.artifacts.forEach((t, n) => {
      const i = t.mesh.scale.clone();
      t.mesh.scale.multiplyScalar(0.4), t.mesh.material.uniforms.uOpacity.value = 0, ct.to(t.mesh.material.uniforms.uOpacity, { value: 1, duration: 0.6, delay: 0.45 + n * 0.06 }), ct.to(t.mesh.scale, { x: i.x, y: i.y, duration: 1.3, delay: 0.45 + n * 0.06, ease: "expo.out" });
    });
  }
  collectCopy() {
    const t = this.threshold?.querySelector(".threshold__content, .threshold-entry__content"), n = t?.querySelector("h1"), i = { words: [], marks: [], extras: [] };
    if (!t || !n) return i;
    let s = 0;
    [...n.children].forEach((l) => {
      if (l.querySelector("[data-word]")) return;
      const u = l.textContent ?? "";
      l.textContent = "", u.split(/(\s+)/).forEach((h) => {
        if (!h) return;
        if (/^\s+$/.test(h)) {
          l.append(document.createTextNode(h));
          return;
        }
        const f = document.createElement("i");
        f.className = "threshold__word", f.setAttribute("data-word", "");
        const d = document.createElement("b");
        d.className = `threshold__mark${s % 3 === 2 ? " threshold__mark--round" : ""}`, d.setAttribute("data-mark", ""), d.setAttribute("aria-hidden", "true");
        const g = document.createElement("span");
        g.className = "threshold__glyph", g.setAttribute("data-glyph", ""), g.textContent = h, f.append(d, g), l.append(f), s += 1;
      });
    });
    const a = [...n.querySelectorAll("[data-glyph]")], o = [...n.querySelectorAll("[data-mark]")], c = [
      t.querySelector(":scope > p"),
      t.querySelector(":scope > button")
    ].filter((l) => !!l);
    return { words: a, marks: o, extras: c };
  }
  birthHeadline() {
    const t = this.threshold, { words: n, marks: i, extras: s } = this.collectCopy();
    if (this.words = n, this.extras = s, !n.length) {
      t?.removeAttribute("data-motion-pending");
      return;
    }
    if (this.copyWasPresented) {
      // Match the final native birth state, including the rotation origin consumed by unchanged open().
      ct.set(n, { autoAlpha: 1, scale: 1, x: 0, y: 0, transformOrigin: "50% 62%" });
      ct.set(i, { scale: 0, transformOrigin: "50% 50%" });
      ct.set(s, { y: 0, opacity: 1 });
      t?.removeAttribute("data-motion-pending");
      this.dispatchEvent(new CustomEvent("casa:motion-birth", { bubbles: !0 }));
      return;
    }
    ct.set(n, { autoAlpha: 0, scale: 0.35, x: 0, y: 0, transformOrigin: "50% 62%" }), ct.set(i, { scale: 0, transformOrigin: "50% 50%" }), ct.set(s, { y: 12, opacity: 0 }), t?.removeAttribute("data-motion-pending");
    const a = ct.timeline();
    n.forEach((c, l) => {
      const u = i[l], h = l * tc, f = (l % 2 ? 1 : -1) * 0.08;
      a.set(u, { scale: 1 }, h), a.set(u, { scale: 1.5 }, h + 0.15), a.set(u, { scale: 2 }, h + 0.3), a.set(c, { autoAlpha: 1, scale: 0.35 }, h + 0.3), a.set(c, { scale: 0.65 }, h + 0.45), a.set(u, { scale: 0 }, h + 0.55), a.set(c, { scale: 1, x: `${f}em` }, h + 0.55), a.to(c, { x: 0, duration: 0.25, ease: "power2.out" }, h + 0.55);
    });
    const o = (n.length - 1) * tc + 0.8;
    a.to(s, { y: 0, opacity: 1, duration: 0.7, ease: "power3.out", stagger: 0.08 }, o - 0.2), this.dispatchEvent(new CustomEvent("casa:motion-birth", { bubbles: !0 }));
  }
  open() {
    return this.opening ? Promise.resolve() : (this.opening = !0, this.setAttribute("data-opening", "true"), new Promise((t) => {
      const n = ct.timeline({ defaults: { ease: "power3.inOut" } });
      this.words.length && n.to(this.words, {
        y: "24vh",
        rotate: (s) => s % 2 ? 9 : -7,
        opacity: 0,
        duration: 0.62,
        ease: "power3.in",
        stagger: { each: 0.045, from: "center" }
      }, 0), this.extras.length && n.to(this.extras, { y: 10, opacity: 0, duration: 0.35, ease: "power2.in" }, 0);
      const i = (s, a, o, c) => {
        const l = s.mesh, u = Math.atan2(s.base.y || 1e-3, s.base.x || 1e-3), h = s.shard ? Pt(3.8, 6.2) : Pt(2.4, 3.6);
        n.to(l.position, {
          x: s.base.x + Math.cos(u) * h,
          y: s.base.y + Math.sin(u) * h * 0.8,
          z: Pt(4.5, 6.5),
          duration: c,
          ease: "power2.in"
        }, o), n.to(l.rotation, { z: s.rotation + (a % 2 ? 1 : -1) * Pt(0.35, 0.9), duration: c, ease: "power1.in" }, o), n.to(l.material.uniforms.uOpening, { value: 1, duration: c * 0.7 }, o), n.to(l.material.uniforms.uOpacity, { value: 0, duration: 0.22, ease: "power1.in" }, o + c - 0.2);
      };
      this.artifacts.forEach((s, a) => i(s, a, 0.08 + a * 0.04, 1.05)), this.shards.forEach((s, a) => {
        const o = 0.16 + a * 0.028;
        n.add(() => {
          s.mesh.visible = !0;
        }, o), n.to(s.mesh.material.uniforms.uOpacity, { value: 1, duration: 0.12 }, o), i(s, a, o, 0.85);
      }), n.to(this.orbit.scale, { x: 1.9, y: 1.9, duration: 1, ease: "power3.in" }, 0.1), this.orbit.children.forEach((s) => {
        const a = s.material;
        n.to(a, { opacity: 0, duration: 0.55 }, 0.4);
      }), n.to(this.camera.position, { z: 8.2, duration: 1.2, ease: "power2.in" }, 0.1), this.glintUniforms && n.to(this.glintUniforms.uBurst, { value: 1, duration: 1.05, ease: "power2.in" }, 0.05), n.add(() => {
        this.dispatchEvent(new CustomEvent("casa:motion-handoff", { bubbles: !0 })), t();
      }, 0.85), n.to({}, { duration: 0.5 });
    }));
  }
  resize() {
    if (!this.renderer) return;
    const t = this.clientWidth || window.innerWidth, n = this.clientHeight || window.innerHeight;
    const i = this.renderer.getSize(new Ae()), s = this.renderer.getPixelRatio(), a = this.renderer.domElement;
    this.camera.aspect = t / n, this.camera.updateProjectionMatrix(), (i.x !== t || i.y !== n || a.width !== Math.floor(t * s) || a.height !== Math.floor(n * s)) && this.renderer.setSize(t, n, !1), this.glintUniforms && (this.glintUniforms.uPixelRatio.value = this.renderer.getPixelRatio());
  }
}
customElements.get("casa-motion-entry") || customElements.define("casa-motion-entry", o0);
class l0 extends HTMLElement {
  constructor() {
    super(...arguments);
    K(this, "renderer");
    K(this, "scene", new Vs());
    K(this, "camera", new qt(38, 1, 0.1, 100));
    K(this, "fluid");
    K(this, "uniforms");
    K(this, "group");
    K(this, "clock", new Hs());
    K(this, "pointer", new Ae());
    K(this, "rawPointer", new Ae());
    K(this, "pointerDirty", !1);
    K(this, "smoothPointer", new Ae());
    K(this, "frame", 0);
    K(this, "tick", 0);
    K(this, "running", !1);
    K(this, "faded", !1);
    K(this, "intersecting", !1);
    K(this, "spawned", !1);
    K(this, "pendingArrive", null);
    K(this, "resizeObserver");
    K(this, "visibility");
    K(this, "pointerHandler", (t) => {
      this.running && (this.rawPointer.set(t.clientX, t.clientY), this.pointerDirty = !0);
    });
    K(this, "arrivalHandler", () => this.arrive(0.75));
    K(this, "readyHandler", () => {
      document.body.classList.contains("is-threshold") || this.arrive(0.15);
    });
    K(this, "contextLost", () => this.stop());
    K(this, "contextRestored", () => {
      this.resize(), this.maybeStart();
    });
    K(this, "render", () => {
      if (!this.running || !this.renderer || !this.uniforms || !this.group || !this.fluid || (this.frame = requestAnimationFrame(this.render), this.tick += 1, this.tick % 6 === 0 && (this.faded = getComputedStyle(this).opacity === "0"), this.faded)) return;
      if (!this.spawned && !document.body.classList.contains("is-threshold") && this.arrive(0.1), this.pointerDirty) {
        const n = this.getBoundingClientRect();
        n.width && n.height && this.pointer.set((this.rawPointer.x - n.left) / n.width * 2 - 1, -((this.rawPointer.y - n.top) / n.height * 2 - 1)), this.pointerDirty = !1;
      }
      const t = this.clock.getElapsedTime();
      this.smoothPointer.lerp(this.pointer, 0.045), this.fluid.step(this.pointer, 0.6), this.uniforms.uTime.value = t, this.group.rotation.y = this.smoothPointer.x * 0.06, this.group.rotation.x = this.smoothPointer.y * 0.04, this.renderer.render(this.scene, this.camera);
    });
  }
  connectedCallback() {
    if (this.setAttribute("aria-hidden", "true"), this.setAttribute("role", "presentation"), !this.visibility && !window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      if (!js()) {
        this.setAttribute("data-failed", "true");
        return;
      }
      this.visibility = new IntersectionObserver((t) => {
        if (this.intersecting = t.some((n) => n.isIntersecting), this.intersecting) {
          if (!this.renderer)
            try {
              this.initialize();
            } catch {
              this.setAttribute("data-failed", "true"), this.visibility?.disconnect();
              return;
            }
          this.maybeStart();
        } else
          this.stop();
      }, { threshold: 0 }), this.visibility.observe(this), document.addEventListener("casa:threshold-opened", this.arrivalHandler, { once: !0 }), document.readyState === "complete" ? this.readyHandler() : document.addEventListener("DOMContentLoaded", this.readyHandler, { once: !0 });
    }
  }
  disconnectedCallback() {
    this.stop(), this.visibility?.disconnect(), this.visibility = void 0, this.resizeObserver?.disconnect(), this.resizeObserver = void 0, window.removeEventListener("pointermove", this.pointerHandler), document.removeEventListener("casa:threshold-opened", this.arrivalHandler), document.removeEventListener("DOMContentLoaded", this.readyHandler), this.group && (Js(this.group), this.scene.remove(this.group)), this.fluid?.dispose(), this.renderer && (this.renderer.domElement.removeEventListener("webglcontextlost", this.contextLost), this.renderer.domElement.removeEventListener("webglcontextrestored", this.contextRestored), this.renderer.dispose(), this.renderer.forceContextLoss(), this.renderer.domElement.remove()), this.renderer = void 0, this.group = void 0, this.uniforms = void 0, this.fluid = void 0, this.spawned = !1, this.pendingArrive = null, this.intersecting = !1, this.removeAttribute("data-ready");
  }
  initialize() {
    const t = window.innerWidth < 720;
    this.renderer = new qs({ antialias: !1, alpha: !0, premultipliedAlpha: !0, powerPreference: "low-power" }), this.renderer.setPixelRatio(Math.min(window.devicePixelRatio, 1.6)), this.renderer.setClearColor(0, 0), this.renderer.outputColorSpace = Tt, this.renderer.domElement.setAttribute("aria-hidden", "true"), this.renderer.domElement.addEventListener("webglcontextlost", this.contextLost), this.renderer.domElement.addEventListener("webglcontextrestored", this.contextRestored), this.append(this.renderer.domElement), this.camera.position.set(0, 0, 9.4), this.fluid = new Zs();
    const { group: n, uniforms: i } = Po({
      mobile: t,
      total: Do(t, 1500, 1e3, 550),
      palette: a0,
      additive: !1,
      lift: -0.12,
      alphaCap: 0.75,
      sizeScale: 1
    }, this.fluid);
    if (this.group = n, this.uniforms = i, this.scene.add(n), this.resizeObserver = new ResizeObserver(() => this.resize()), this.resizeObserver.observe(this), this.resize(), window.addEventListener("pointermove", this.pointerHandler, { passive: !0 }), this.setAttribute("data-ready", "true"), this.pendingArrive !== null) {
      const s = this.pendingArrive;
      this.pendingArrive = null, this.arrive(s);
    }
  }
  arrive(t = 0) {
    if (!this.spawned) {
      if (!this.uniforms) {
        this.pendingArrive = t;
        return;
      }
      this.spawned = !0, ct.to(this.uniforms.uSpawn, { value: 1, duration: 1.9, ease: "power2.out", delay: t }), this.maybeStart();
    }
  }
  // Solo se pinta cuando hay algo que ver: hero en pantalla y brillos ya nacidos (o por nacer).
  maybeStart() {
    this.intersecting && this.spawned && this.start();
  }
  start() {
    this.running || !this.renderer || (this.running = !0, this.clock.start(), this.frame = requestAnimationFrame(this.render));
  }
  stop() {
    this.running = !1, cancelAnimationFrame(this.frame);
  }
  resize() {
    if (!this.renderer) return;
    const t = this.clientWidth, n = this.clientHeight;
    !t || !n || (this.camera.aspect = t / n, this.camera.updateProjectionMatrix(), this.renderer.setSize(t, n, !1), this.uniforms && (this.uniforms.uPixelRatio.value = this.renderer.getPixelRatio()));
  }
}
customElements.get("perse-glints") || customElements.define("perse-glints", l0);
const c0 = (
  /* glsl */
  `
  varying vec2 vUv;
  void main() {
    vUv = uv;
    gl_Position = vec4(position.xy, 0.0, 1.0);
  }
`
), u0 = (
  /* glsl */
  `
  varying vec2 vUv;
  uniform float uTime;
  uniform float uProgress;
  uniform float uReveal;
  uniform vec2 uAspect;
  uniform sampler2D uFluid;

  float hash(vec2 p) {
    p = fract(p * vec2(123.34, 456.21));
    p += dot(p, p + 45.32);
    return fract(p.x * p.y);
  }
  float noise(vec2 p) {
    vec2 i = floor(p);
    vec2 f = fract(p);
    f = f * f * (3.0 - 2.0 * f);
    return mix(mix(hash(i), hash(i + vec2(1.0, 0.0)), f.x), mix(hash(i + vec2(0.0, 1.0)), hash(i + vec2(1.0, 1.0)), f.x), f.y);
  }
  float fbm(vec2 p) {
    float v = 0.0;
    float a = 0.5;
    mat2 m = mat2(1.6, 1.2, -1.2, 1.6);
    for (int i = 0; i < 5; i++) {
      v += a * noise(p);
      p = m * p;
      a *= 0.5;
    }
    return v;
  }

  void main() {
    vec2 uv = vUv;
    vec2 vel = texture2D(uFluid, uv).rg * 2.0 - 1.0;
    vec2 p = (uv - 0.5) * uAspect * 2.4;
    p += vel * 1.7;
    float t = uTime * 0.05;
    vec2 q = vec2(fbm(p + vec2(t, -t * 0.6)), fbm(p + vec2(3.1, 1.7) - t * 0.5));
    vec2 r = vec2(fbm(p + 1.9 * q + vec2(1.7, 9.2) + t * 0.3), fbm(p + 1.9 * q + vec2(8.3, 2.8) - t * 0.2));
    float f = fbm(p + 2.1 * r);
    float ink = smoothstep(0.34, 0.68, f) * (0.6 + 0.4 * uProgress);
    float deep = smoothstep(0.6, 0.88, f);
    float center = smoothstep(0.1, 0.6, length((uv - 0.5) * uAspect));
    ink *= mix(0.22, 1.0, center);
    vec3 ruby = vec3(0.86, 0.2, 0.17);
    vec3 deepRuby = vec3(0.45, 0.05, 0.07);
    vec3 amber = vec3(0.82, 0.58, 0.3);
    vec3 col = mix(amber, ruby, smoothstep(0.2, 0.65, q.x));
    col = mix(col, deepRuby, deep * 0.85);
    float alpha = ink * 0.92 * uReveal;
    gl_FragColor = vec4(col * alpha, alpha);
  }
`
);
class h0 extends HTMLElement {
  constructor() {
    super(...arguments);
    K(this, "renderer");
    K(this, "scene", new Vs());
    K(this, "camera", new lo());
    K(this, "mesh");
    K(this, "fluid");
    K(this, "uniforms");
    K(this, "clock", new Hs());
    K(this, "pointer", new Ae());
    K(this, "rawPointer", new Ae());
    K(this, "pointerDirty", !1);
    K(this, "frame", 0);
    K(this, "running", !1);
    K(this, "revealed", !1);
    K(this, "intersecting", !1);
    K(this, "progressValue", 0);
    K(this, "resizeObserver");
    K(this, "visibility");
    K(this, "pointerHandler", (t) => {
      this.running && (this.rawPointer.set(t.clientX, t.clientY), this.pointerDirty = !0);
    });
    K(this, "contextLost", () => this.stop());
    K(this, "contextRestored", () => {
      this.resize(), this.intersecting && this.start();
    });
    K(this, "render", () => {
      if (!(!this.running || !this.renderer || !this.uniforms || !this.fluid)) {
        if (this.frame = requestAnimationFrame(this.render), this.pointerDirty) {
          const t = this.getBoundingClientRect();
          t.width && t.height && this.pointer.set((this.rawPointer.x - t.left) / t.width * 2 - 1, -((this.rawPointer.y - t.top) / t.height * 2 - 1)), this.pointerDirty = !1;
        }
        this.fluid.step(this.pointer, 0.6), this.uniforms.uTime.value = this.clock.getElapsedTime(), this.renderer.render(this.scene, this.camera);
      }
    });
  }
  get progress() {
    return this.progressValue;
  }
  set progress(t) {
    this.progressValue = Math.min(1, Math.max(0, t)), this.uniforms && (this.uniforms.uProgress.value = this.progressValue);
  }
  connectedCallback() {
    if (this.setAttribute("aria-hidden", "true"), this.setAttribute("role", "presentation"), !this.visibility && !window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      if (!js()) {
        this.setAttribute("data-failed", "true");
        return;
      }
      this.visibility = new IntersectionObserver((t) => {
        if (this.intersecting = t.some((n) => n.isIntersecting), this.intersecting) {
          if (!this.renderer)
            try {
              this.initialize();
            } catch {
              this.setAttribute("data-failed", "true"), this.visibility?.disconnect();
              return;
            }
          this.start();
        } else
          this.stop();
      }, { threshold: 0, rootMargin: "20% 0px 20% 0px" }), this.visibility.observe(this);
    }
  }
  disconnectedCallback() {
    this.stop(), this.visibility?.disconnect(), this.visibility = void 0, this.resizeObserver?.disconnect(), this.resizeObserver = void 0, window.removeEventListener("pointermove", this.pointerHandler), this.mesh && (Js(this.mesh), this.scene.remove(this.mesh)), this.fluid?.dispose(), this.renderer && (this.renderer.domElement.removeEventListener("webglcontextlost", this.contextLost), this.renderer.domElement.removeEventListener("webglcontextrestored", this.contextRestored), this.renderer.dispose(), this.renderer.forceContextLoss(), this.renderer.domElement.remove()), this.renderer = void 0, this.mesh = void 0, this.uniforms = void 0, this.fluid = void 0, this.revealed = !1, this.intersecting = !1, this.removeAttribute("data-ready");
  }
  initialize() {
    this.renderer = new qs({ antialias: !1, alpha: !0, premultipliedAlpha: !0, powerPreference: "low-power" }), this.renderer.setPixelRatio(Math.min(window.devicePixelRatio, 1.25)), this.renderer.setClearColor(0, 0), this.renderer.outputColorSpace = Tt, this.renderer.domElement.setAttribute("aria-hidden", "true"), this.renderer.domElement.addEventListener("webglcontextlost", this.contextLost), this.renderer.domElement.addEventListener("webglcontextrestored", this.contextRestored), this.append(this.renderer.domElement), this.fluid = new Zs(), this.uniforms = {
      uTime: { value: 0 },
      uProgress: { value: this.progressValue },
      uReveal: { value: 0 },
      uAspect: { value: new Ae(1, 1) },
      uFluid: { value: this.fluid.texture }
    };
    const t = new Ht({
      uniforms: this.uniforms,
      vertexShader: c0,
      fragmentShader: u0,
      transparent: !0,
      depthTest: !1,
      depthWrite: !1,
      premultipliedAlpha: !0
    });
    this.mesh = new Lt(new _n(2, 2), t), this.mesh.frustumCulled = !1, this.scene.add(this.mesh), this.resizeObserver = new ResizeObserver(() => this.resize()), this.resizeObserver.observe(this), this.resize(), window.addEventListener("pointermove", this.pointerHandler, { passive: !0 }), this.setAttribute("data-ready", "true");
  }
  start() {
    this.running || !this.renderer || !this.uniforms || (this.running = !0, this.clock.start(), this.revealed || (this.revealed = !0, ct.to(this.uniforms.uReveal, { value: 1, duration: 1.8, ease: "power2.out" })), this.frame = requestAnimationFrame(this.render));
  }
  stop() {
    this.running = !1, cancelAnimationFrame(this.frame);
  }
  resize() {
    if (!this.renderer || !this.uniforms) return;
    const t = this.clientWidth, n = this.clientHeight;
    !t || !n || (this.renderer.setSize(t, n, !1), this.uniforms.uAspect.value.set(t / n, 1));
  }
}
customElements.get("perse-ink") || customElements.define("perse-ink", h0);
const f0 = (
  /* glsl */
  `
  varying vec2 vUv;
  void main() {
    vUv = uv;
    gl_Position = vec4(position.xy, 0.9999, 1.0);
  }
`
), d0 = (
  /* glsl */
  `
  varying vec2 vUv;
  uniform float uDark;
  uniform vec2 uAspect;
  void main() {
    vec3 bone = vec3(0.933, 0.914, 0.875);
    vec3 ink = vec3(0.039, 0.035, 0.035);
    float d = length((vUv - 0.5) * uAspect);
    float vignette = smoothstep(0.25, 1.15, d);
    vec3 col = mix(bone, ink, uDark);
    col = mix(col, bone * 0.93, vignette * (1.0 - uDark) * 0.55);
    col = mix(col, vec3(0.02), vignette * uDark * 0.7);
    gl_FragColor = vec4(col, 1.0);
  }
`
), p0 = (
  /* glsl */
  `
  varying vec2 vUv;
  void main() {
    vUv = uv;
    gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
  }
`
), m0 = (
  /* glsl */
  `
  varying vec2 vUv;
  uniform sampler2D uMap;
  uniform vec2 uCrop;
  uniform float uOpacity;
  void main() {
    vec4 c = texture2D(uMap, vec2(uCrop.x + vUv.x * uCrop.y, vUv.y));
    float fade = 1.0 - vUv.y;
    gl_FragColor = vec4(c.rgb * uOpacity * fade * fade, uOpacity * fade * fade);
  }
`
), bs = (r, e, t) => {
  const n = Math.min(1, Math.max(0, (t - r) / (e - r)));
  return n * n * (3 - 2 * n);
}, $i = (r, e, t) => r + (e - r) * t;
function nc(r = 256) {
  const e = document.createElement("canvas");
  e.width = e.height = r;
  const t = e.getContext("2d");
  if (t) {
    const i = t.createRadialGradient(r / 2, r / 2, 0, r / 2, r / 2, r / 2);
    i.addColorStop(0, "rgba(255,255,255,1)"), i.addColorStop(0.3, "rgba(255,255,255,.55)"), i.addColorStop(0.65, "rgba(255,255,255,.14)"), i.addColorStop(1, "rgba(255,255,255,0)"), t.fillStyle = i, t.fillRect(0, 0, r, r);
  }
  const n = new vc(e);
  return n.colorSpace = Tt, n;
}
function ic(r, e) {
  const t = document.createElement("canvas");
  t.width = 2048, t.height = 640;
  const n = t.getContext("2d");
  n && (n.clearRect(0, 0, t.width, t.height), n.fillStyle = "#ffffff", n.textAlign = "center", n.textBaseline = "alphabetic", n.font = '500 430px "DM Sans", "Helvetica Neue", sans-serif', n.fillText(r.toUpperCase(), 1024, 420), n.font = 'italic 400 200px "Instrument Serif", Georgia, serif', n.fillText(e, 1024, 612));
  const i = new vc(t);
  return i.colorSpace = Tt, i.minFilter = 1006, i;
}
class _0 extends HTMLElement {
  constructor() {
    super(...arguments);
    K(this, "renderer");
    K(this, "scene", new Vs());
    K(this, "camera", new qt(32, 1, 0.1, 60));
    K(this, "fluid");
    K(this, "glintUniforms");
    K(this, "glintGroup");
    K(this, "backdropUniforms");
    K(this, "object");
    K(this, "reflectionUniforms");
    K(this, "shadow");
    K(this, "word");
    K(this, "wordMaterial");
    K(this, "blooms", []);
    K(this, "inkColor", new Ge("#0a0909"));
    K(this, "boneColor", new Ge("#eee9df"));
    K(this, "clock", new Hs());
    K(this, "pointer", new Ae());
    K(this, "rawPointer", new Ae());
    K(this, "smoothPointer", new Ae());
    K(this, "pointerDirty", !1);
    K(this, "progressValue", 0);
    K(this, "smoothProgress", 0);
    K(this, "frame", 0);
    K(this, "running", !1);
    K(this, "intersecting", !1);
    K(this, "spawned", !1);
    K(this, "mobile", !1);
    K(this, "visibleWidth", 4);
    K(this, "visibleHeight", 4);
    K(this, "resizeObserver");
    K(this, "visibility");
    K(this, "pointerHandler", (t) => {
      this.running && (this.rawPointer.set(t.clientX, t.clientY), this.pointerDirty = !0);
    });
    K(this, "contextLost", () => this.stop());
    K(this, "contextRestored", () => {
      this.resize(), this.intersecting && this.start();
    });
    K(this, "render", () => {
      if (!this.running || !this.renderer) return;
      this.frame = requestAnimationFrame(this.render);
      const t = this.clock.getElapsedTime();
      if (this.pointerDirty) {
        const a = this.getBoundingClientRect();
        a.width && a.height && this.pointer.set((this.rawPointer.x - a.left) / a.width * 2 - 1, -((this.rawPointer.y - a.top) / a.height * 2 - 1)), this.pointerDirty = !1;
      }
      this.smoothPointer.lerp(this.pointer, 0.05), this.smoothProgress += (this.progressValue - this.smoothProgress) * 0.12;
      const n = this.smoothProgress, i = bs(0.1, 0.21, n);
      if (this.backdropUniforms && (this.backdropUniforms.uDark.value = i), this.fluid?.step(this.pointer, 0.6), this.object) {
        const a = bs(0.02, 0.58, n), o = 1 - Math.pow(1 - a, 3), c = bs(0.6, 1, n), l = $i(0.5, 1, o) * this.objectScale(), u = this.mobile ? 0.26 : 0.06;
        this.object.position.set(this.smoothPointer.x * 0.12, $i(-this.visibleHeight * 0.66, u, o) + c * (this.mobile ? 0.04 : 0.06) + Math.sin(t * 0.8) * 0.02 * o, $i(-0.9, 0.2, o) + c * 0.38), this.object.scale.setScalar(l), this.object.rotation.set($i(-0.64, 0, o) - this.smoothPointer.y * 0.08 * o, this.smoothPointer.x * 0.16 * o, $i(0.08, 0, o)), this.reflectionUniforms && (this.reflectionUniforms.uOpacity.value = 0.32 * o * (0.35 + 0.65 * i)), this.shadow && (this.shadow.material.opacity = 0.5 * o);
      }
      const s = bs(0.26, 0.88, n);
      this.blooms.forEach((a) => {
        a.sprite.position.y = $i(a.y0, a.y1, s) + Math.sin(t * 0.35 + a.phase) * 0.14, a.sprite.position.x = a.x + this.smoothPointer.x * 0.4 * a.depth + Math.cos(t * 0.27 + a.phase) * 0.12, a.sprite.material.opacity = Math.min(1, a.base * 1.35) * i * (0.25 + 0.75 * s);
      }), this.word && this.wordMaterial && (this.wordMaterial.color.copy(this.inkColor).lerp(this.boneColor, i), this.wordMaterial.opacity = 0.15 + 0.07 * i, this.word.position.y = 0.3 - n * 0.5, this.word.position.x = this.smoothPointer.x * 0.08), !this.spawned && n > 0.42 && this.glintUniforms && (this.spawned = !0, ct.to(this.glintUniforms.uSpawn, { value: 1, duration: 1.8, ease: "power2.out" })), this.glintUniforms && (this.glintUniforms.uTime.value = t), this.glintGroup && (this.glintGroup.rotation.y = this.smoothPointer.x * 0.06, this.glintGroup.rotation.x = this.smoothPointer.y * 0.04), this.renderer.render(this.scene, this.camera);
    });
  }
  get progress() {
    return this.progressValue;
  }
  set progress(t) {
    this.progressValue = Math.min(1, Math.max(0, t));
  }
  connectedCallback() {
    if (this.setAttribute("aria-hidden", "true"), this.setAttribute("role", "presentation"), !this.visibility) {
      if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
        this.setAttribute("data-failed", "true");
        return;
      }
      if (!js()) {
        this.setAttribute("data-failed", "true");
        return;
      }
      this.visibility = new IntersectionObserver((t) => {
        if (this.intersecting = t.some((n) => n.isIntersecting), this.intersecting) {
          if (!this.renderer)
            try {
              this.initialize();
            } catch {
              this.setAttribute("data-failed", "true"), this.visibility?.disconnect();
              return;
            }
          this.start();
        } else
          this.stop();
      }, { threshold: 0, rootMargin: "30% 0px 30% 0px" }), this.visibility.observe(this);
    }
  }
  disconnectedCallback() {
    this.stop(), this.visibility?.disconnect(), this.visibility = void 0, this.resizeObserver?.disconnect(), this.resizeObserver = void 0, window.removeEventListener("pointermove", this.pointerHandler), [...this.scene.children].forEach((t) => {
      Js(t), this.scene.remove(t);
    }), this.fluid?.dispose(), this.renderer && (this.renderer.domElement.removeEventListener("webglcontextlost", this.contextLost), this.renderer.domElement.removeEventListener("webglcontextrestored", this.contextRestored), this.renderer.dispose(), this.renderer.forceContextLoss(), this.renderer.domElement.remove()), this.renderer = void 0, this.object = void 0, this.word = void 0, this.wordMaterial = void 0, this.glintGroup = void 0, this.glintUniforms = void 0, this.fluid = void 0, this.blooms = [], this.spawned = !1, this.intersecting = !1, this.removeAttribute("data-ready");
  }
  initialize() {
    this.mobile = window.innerWidth < 720, this.renderer = new qs({ antialias: !0, alpha: !1, powerPreference: "high-performance" }), this.renderer.setPixelRatio(Math.min(window.devicePixelRatio, this.mobile ? 1.5 : 1.6)), this.renderer.setClearColor(15657439, 1), this.renderer.outputColorSpace = Tt, this.renderer.domElement.setAttribute("aria-hidden", "true"), this.renderer.domElement.addEventListener("webglcontextlost", this.contextLost), this.renderer.domElement.addEventListener("webglcontextrestored", this.contextRestored), this.append(this.renderer.domElement), this.camera.position.set(0, 0, 7), this.backdropUniforms = { uDark: { value: 0 }, uAspect: { value: new Ae(1, 1) } };
    const t = new Lt(new _n(2, 2), new Ht({ uniforms: this.backdropUniforms, vertexShader: f0, fragmentShader: d0, depthTest: !1, depthWrite: !1 }));
    t.frustumCulled = !1, t.renderOrder = -10, this.scene.add(t);
    const n = nc();
    [
      [-1.9, -3.4, -0.3, -2.6, 3.6, "#dc332c", 0.5, 0.6, 0],
      [1.8, -3.8, 0.3, -3, 4.2, "#8e1218", 0.75, 0.8, 1.3],
      [0.2, -3.2, 1.3, -3.4, 4.8, "#d29a52", 0.3, 1, 2.1],
      [-0.7, -2.5, -1.3, -2.2, 2.4, "#eee9df", 0.2, 0.5, 3.4],
      [2.7, -3, 1.7, -3.8, 3, "#dc332c", 0.32, 0.9, 4.2],
      [-2.6, -2.2, 1.9, -3.6, 2.6, "#f0b487", 0.22, 0.95, 5]
    ].forEach(([o, c, l, u, h, f, d, g, _]) => {
      const m = new ka({ map: n, color: new Ge(f), transparent: !0, opacity: 0, blending: 2, depthWrite: !1, depthTest: !1 }), p = new ol(m), S = this.mobile ? 0.68 : 1;
      p.position.set(o * (this.mobile ? 0.55 : 1), c, u), p.scale.set(h * S, h * S, 1), p.renderOrder = -5, this.scene.add(p), this.blooms.push({ sprite: p, x: o * (this.mobile ? 0.55 : 1), y0: c, y1: l, base: d, phase: _, depth: g });
    });
    const s = this.dataset.word || "Objeto", a = this.dataset.sub || "";
    this.wordMaterial = new Cr({ map: ic(s, a), transparent: !0, opacity: 0.16, depthWrite: !1, color: this.inkColor.clone() }), this.word = new Lt(new _n(1, 640 / 2048), this.wordMaterial), this.word.position.set(0, 0.2, -1.6), this.word.renderOrder = -2, this.scene.add(this.word), document.fonts?.ready && document.fonts.ready.then(() => {
      this.wordMaterial && (this.wordMaterial.map?.dispose(), this.wordMaterial.map = ic(s, a), this.wordMaterial.needsUpdate = !0);
    }), this.fluid = new Zs();
    try {
      const { group: o, uniforms: c } = Po({ mobile: this.mobile, total: Do(this.mobile, 800, 500, 300), palette: Eu, additive: !0, lift: 0.18, alphaCap: 0.85, sizeScale: 0.85 }, this.fluid);
      o.position.z = 0.6, o.renderOrder = 5, this.glintGroup = o, this.glintUniforms = c, this.scene.add(o);
    } catch {
      this.glintGroup = void 0;
    }
    this.resizeObserver = new ResizeObserver(() => this.resize()), this.resizeObserver.observe(this), this.resize(), window.addEventListener("pointermove", this.pointerHandler, { passive: !0 }), this.setAttribute("data-ready", "true"), this.loadObject();
  }
  async loadObject() {
    const t = this.dataset.src;
    if (!t) return;
    const n = new Sc();
    let i;
    try {
      i = await n.loadAsync(t);
    } catch {
      this.setAttribute("data-failed", "true");
      return;
    }
    if (!this.renderer) return;
    i.colorSpace = Tt, i.minFilter = 1008, i.magFilter = 1006, i.wrapS = i.wrapT = 1001;
    const s = Number(this.dataset.crops || 4), a = Number(this.dataset.crop || 1) - 1, o = 1 / s;
    i.repeat.set(o, 1), i.offset.set(a * o, 0);
    const l = 1 / Number(this.dataset.aspect || 0.625), u = new jn(), h = new Lt(new _n(1, l), new Cr({ map: i, toneMapped: !1 }));
    h.renderOrder = 2, u.add(h);
    const f = new Lt(new _n(1.06, l + 0.06), new Cr({ color: new Ge("#f4f0e8"), toneMapped: !1 }));
    f.position.z = -4e-3, f.renderOrder = 1, u.add(f), this.reflectionUniforms = { uMap: { value: i }, uCrop: { value: new Ae(a * o, o) }, uOpacity: { value: 0 } };
    const d = new Lt(new _n(1, l), new Ht({ uniforms: this.reflectionUniforms, vertexShader: p0, fragmentShader: m0, transparent: !0, depthWrite: !1, premultipliedAlpha: !0 }));
    d.scale.y = -1, d.position.set(0, -l - 0.05, -0.01), d.renderOrder = 0, u.add(d);
    const g = new ka({ map: nc(128), color: new Ge("#000000"), transparent: !0, opacity: 0, depthWrite: !1 });
    this.shadow = new ol(g), this.shadow.position.set(0, -l / 2 - 0.12, 0.05), this.shadow.scale.set(1.9, 0.55, 1), this.shadow.renderOrder = 0, u.add(this.shadow), this.object = u, this.scene.add(u);
  }
  objectScale() {
    const t = 1 / Number(this.dataset.aspect || 0.625);
    return this.mobile ? Math.min(this.visibleWidth * 0.66, this.visibleHeight * 0.42 / t) : Math.min(this.visibleWidth * 0.36, this.visibleHeight * 0.64 / t);
  }
  start() {
    this.running || !this.renderer || (this.running = !0, this.clock.start(), this.frame = requestAnimationFrame(this.render));
  }
  stop() {
    this.running = !1, cancelAnimationFrame(this.frame);
  }
  resize() {
    if (!this.renderer) return;
    const t = this.clientWidth, n = this.clientHeight;
    if (!(!t || !n) && (this.camera.aspect = t / n, this.camera.updateProjectionMatrix(), this.renderer.setSize(t, n, !1), this.visibleHeight = 2 * Math.tan(Ju.degToRad(this.camera.fov / 2)) * this.camera.position.z, this.visibleWidth = this.visibleHeight * this.camera.aspect, this.backdropUniforms && this.backdropUniforms.uAspect.value.set(this.camera.aspect, 1), this.glintUniforms && (this.glintUniforms.uPixelRatio.value = this.renderer.getPixelRatio()), this.word)) {
      const i = (this.camera.position.z + 1.6) / this.camera.position.z, s = this.visibleWidth * i * (this.mobile ? 1.35 : 1.05);
      this.word.scale.set(s, s, 1);
    }
  }
}
customElements.get("perse-focus") || customElements.define("perse-focus", _0);
window.perseMotion = { gsap: ct };
class g0 extends HTMLElement {
  constructor() {
    super(...arguments);
    K(this, "active", !1);
    K(this, "timeline");
    K(this, "reducedMotion", window.matchMedia("(prefers-reduced-motion: reduce)").matches);
    K(this, "clickHandler", (t) => this.handleProductLink(t));
    // BFCache can restore an outgoing curtain before its fallback timer fires.
    K(this, "pageShowHandler", (t) => {
      t.persisted && this.reset();
    });
    K(this, "pageHideHandler", () => this.reset());
  }
  connectedCallback() {
    this.childElementCount || this.render(), this.setAttribute("aria-hidden", "true"), document.addEventListener("click", this.clickHandler), window.addEventListener("pageshow", this.pageShowHandler), window.addEventListener("pagehide", this.pageHideHandler), window.perseProductTransition = this;
    let t = !1;
    try {
      t = window.sessionStorage.getItem("perse:product-arrival") === "true", t && window.sessionStorage.removeItem("perse:product-arrival");
    } catch {
      t = !1;
    }
    t && this.playArrival();
  }
  disconnectedCallback() {
    document.removeEventListener("click", this.clickHandler), window.removeEventListener("pageshow", this.pageShowHandler), window.removeEventListener("pagehide", this.pageHideHandler), this.reset(), window.perseProductTransition === this && delete window.perseProductTransition;
  }
  play(t, n = {}) {
    if (this.active) return Promise.resolve();
    if (this.reducedMotion)
      return t(), Promise.resolve();
    const i = [...this.querySelectorAll("[data-perse-letter]")], s = [...this.querySelectorAll("[data-perse-shutter]")], a = this.querySelector("[data-perse-line]"), o = this.querySelector("[data-perse-object]"), c = n.returnToPage !== !1;
    this.active = !0, document.body.classList.add("is-perse-transitioning"), this.dataset.state = "outgoing", this.style.display = "block", o && (o.textContent = n.label ? `ENTRANDO A · ${n.label}` : "ENTRANDO AL OBJETO");
    const l = [-128, -154, -119, -168, -137, -146], u = [-9, 6, -4, 8, -7, 5], h = [0.16, 0.24, 0.19, 0.28, 0.22, 0.18];
    return ct.set(s, { yPercent: 106 }), ct.set(a, { scaleX: 0, opacity: 0 }), ct.set(o, { y: 10, opacity: 0 }), i.forEach((f, d) => {
      ct.set(f, {
        y: `${l[d]}vh`,
        x: d % 2 ? "1.5vw" : "-1.5vw",
        rotate: u[d],
        force3D: !1,
        scaleX: 0.94,
        scaleY: 1.08,
        opacity: 1,
        transformOrigin: "50% 100%"
      });
    }), new Promise((f) => {
      let d = !1;
      const g = this.timeline = ct.timeline({
        defaults: { overwrite: "auto" },
        onComplete: () => {
          c && this.reset(), f();
        }
      });
      g.to(s, {
        yPercent: 0,
        duration: 0.25,
        stagger: { amount: 0.06, from: "center" },
        ease: "power4.inOut"
      }, 0), i.forEach((_, m) => {
        const p = h[m] * 0.43, S = 0.28 + m % 3 * 0.02;
        g.to(_, {
          y: "0vh",
          x: "0vw",
          rotate: 0,
          scaleX: 1,
          scaleY: 1,
          duration: S,
          ease: "power4.in"
        }, p), g.to(_, {
          y: ".025em",
          scaleX: 1.055,
          scaleY: 0.82,
          duration: 0.04,
          ease: "power2.out"
        }, p + S), g.to(_, {
          y: 0,
          scaleX: 1,
          scaleY: 1,
          duration: 0.11,
          ease: "elastic.out(1, .52)"
        }, p + S + 0.04);
      }), g.to(a, { scaleX: 1, opacity: 1, duration: 0.13, ease: "power3.out" }, 0.32), g.to(o, { y: 0, opacity: 1, duration: 0.1, ease: "power3.out" }, 0.34), g.add(() => {
        d || !this.active || (d = !0, t());
      }, 0.66), g.to(o, { y: -8, opacity: 0, duration: 0.08, ease: "power2.in" }, 0.68), g.to(a, { scaleX: 0, opacity: 0, duration: 0.09, ease: "power2.in" }, 0.69), i.forEach((_, m) => {
        g.to(_, {
          y: `${125 + m * 9}vh`,
          x: m % 2 ? `${2 + m}vw` : `${-2 - m}vw`,
          rotate: m % 2 ? 7 + m : -7 - m,
          duration: 0.26 + m * 0.014,
          ease: "power3.in"
        }, 0.72 + [0, 0.025, 0.01, 0.04, 0.016, 0.03][m]);
      }), c && g.to(s, {
        yPercent: (_) => _ % 2 ? -106 : 106,
        duration: 0.36,
        stagger: { amount: 0.08, from: "edges" },
        ease: "power4.inOut"
      }, 0.94);
    });
  }
  playArrival() {
    if (this.reducedMotion) return;
    const t = [...this.querySelectorAll("[data-perse-letter]")], n = [...this.querySelectorAll("[data-perse-shutter]")], i = this.querySelector("[data-perse-line]"), s = this.querySelector("[data-perse-object]");
    this.active = !0, document.body.classList.add("is-perse-transitioning"), this.dataset.state = "arrival", this.style.display = "block", ct.set(n, { yPercent: 0 }), ct.set(t, { y: 0, rotate: 0, opacity: 1, force3D: !1 }), ct.set(i, { scaleX: 1, opacity: 0.8 }), ct.set(s, { opacity: 0 });
    const a = this.timeline = ct.timeline({ onComplete: () => this.reset() });
    t.forEach((o, c) => {
      a.to(o, {
        y: `${130 + c * 8}vh`,
        rotate: c % 2 ? 8 + c : -8 - c,
        duration: 0.26 + c * 0.014,
        ease: "power3.in"
      }, 0.015 + [0, 0.022, 8e-3, 0.034, 0.015, 0.026][c]);
    }), a.to(i, { scaleX: 0, opacity: 0, duration: 0.12 }, 0.05), a.to(n, {
      yPercent: (o) => o % 2 ? -106 : 106,
      duration: 0.3,
      stagger: { amount: 0.06, from: "edges" },
      ease: "power4.inOut"
    }, 0.12);
  }
  rememberCatalogPosition() {
    if (window.location.pathname.startsWith("/products/")) return;
    const t = [...document.querySelectorAll("[data-horizontal-rail]")].map((n) => ({ key: n.dataset.horizontalRail || "", scrollLeft: n.scrollLeft }));
    try {
      window.sessionStorage.setItem("perse:return-state", JSON.stringify({
        href: window.location.href,
        scrollX: window.scrollX,
        scrollY: window.scrollY,
        rails: t
      }));
    } catch {
    }
  }
  handleProductLink(t) {
    if (t.defaultPrevented || t.button !== 0 || t.metaKey || t.ctrlKey || t.shiftKey || t.altKey) return;
    const n = t.target?.closest('a[data-perse-product], a[href*="/products/"]');
    if (!n || n.hasAttribute("download") || n.target === "_blank") return;
    const i = new URL(n.href, window.location.href);
    if (i.origin !== window.location.origin || i.pathname === window.location.pathname) return;
    this.rememberCatalogPosition(), t.preventDefault(), t.stopImmediatePropagation();
    const s = n.dataset.productTitle || n.textContent?.trim() || "Producto";
    if (this.active) {
      if (this.dataset.state === "arrival") {
        try {
          window.sessionStorage.setItem("perse:product-arrival", "true");
        } catch {
        }
        window.location.assign(i.href);
      }
      return;
    }
    this.navigateToProduct(i.href, s);
  }
  navigateToProduct(t, n) {
    this.play(() => {
      try {
        window.sessionStorage.setItem("perse:product-arrival", "true");
      } catch {
      }
      window.location.assign(t), window.setTimeout(() => this.reset(), 5e3);
    }, { label: n, returnToPage: !1 });
  }
  reset() {
    this.timeline?.kill(), this.timeline = void 0, this.active = !1, this.removeAttribute("data-state"), this.style.display = "none", document.body.classList.remove("is-perse-transitioning"), ct.killTweensOf(this.querySelectorAll("[data-perse-letter], [data-perse-shutter], [data-perse-line], [data-perse-object]")), ct.set(this.querySelectorAll("[data-perse-letter], [data-perse-shutter], [data-perse-line], [data-perse-object]"), { clearProps: "all" });
  }
  render() {
    const t = [..."PERSSE"].map(
      (n, i) => `<span class="perse-transition__letter" data-perse-letter data-letter="${n}"><b>${n}</b><i>0${i + 1}</i></span>`
    ).join("");
    this.innerHTML = `
      <div class="perse-transition__stage">
        <div class="perse-transition__shutters">${"<span data-perse-shutter></span>".repeat(5)}</div>
        <div class="perse-transition__coordinates"><span>PERSSE · OBJETOS CON CRITERIO</span><span>06 LETRAS · UNA ENTRADA</span></div>
        <div class="perse-transition__word">${t}</div>
        <div class="perse-transition__line" data-perse-line></div>
        <p class="perse-transition__object" data-perse-object>ENTRANDO AL OBJETO</p>
        <div class="perse-transition__grain"></div>
      </div>`;
  }
}
customElements.get("perse-product-transition") || customElements.define("perse-product-transition", g0);
const rc = () => {
  !document.body || document.querySelector("perse-product-transition") || document.body.append(document.createElement("perse-product-transition"));
};
document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", rc, { once: !0 }) : rc();
